/* eslint-disable */
import { SdkgenError, SdkgenErrorWithData, SdkgenHttpClient } from "@sdkgen/browser-runtime";

export type AddressFromCepTipo = "localidade" | "logradouro" | "unidadeOperacional" | "grandeUsuario";

export type BackofficeStorageTransferType = "input" | "transferOut" | "transferIn" | "lost" | "productionLost" | "sell" | "refund" | "manual" | "productionOut" | "productionIn" | "invoice" | "inventory" | "cardExchange";

export type BackofficeSupplierRegisterType = "Customer" | "Supplier" | "CustomerAndSupplier" | "Employee";

export type BackofficeBillPaymentMethod = "App" | "Money" | "Check" | "Boleto" | "CreditCard" | "BankTransfer" | "Promissory" | "DebitCard" | "AutomaticDebit";

export type BankAccountReceiverTypeDto = "conta_corrente" | "conta_salario" | "conta_poupanca" | "conta_pagamento";

export type PixKeyTypeDto = "email" | "evp" | "phone" | "cpf" | "cnpj";

export type BankAccountDocumentTypeDto = "cpf" | "cnpj";

export type CategoryKind = "product" | "menu";

export type EventOperationExpenseCategory = "fieldTeam" | "logisticsExpense" | "cardsAndBracelets" | "othersExpenses" | "equipmentBreakdown" | "replacedEquipments" | "usedEquipments" | "otherUsedEquipments" | "posCreditAdvance";

export type EventOperationExpenseType = "listEquipment" | "typeBreakdowns" | "typeBreakages" | "typeRepairs" | "exchangeForProduct" | "notReturned" | "head" | "supervisor" | "technician" | "providedByCustomer" | "notProvided" | "uber" | "app99" | "loggi" | "carrier" | "carRental" | "airfare" | "others";

export type EventOperationExpenseResponsible = "client" | "zig" | "rateio";

export type EventOperationStatus = "opened" | "operationalApproval" | "financialApproval" | "financialRevision" | "finalApproval" | "finished";

export type EquipmentType = "Terminal" | "TotemFicha" | "TotemCashless" | "MiniTotem";

export type EquipmentBillingPeriodicity = "Daily" | "Monthly";

export type ChargeType = "OneTime" | "Recurring";

export type ChargeStatus = "Calculated" | "FullyBonified" | "Error" | "ReportedOnly" | "NotInContract";

export type ChargeErrorKind = "UnknownPeriodicity" | "ContractsApiUnavailable" | "MissingContractValue" | "InternationalNotSupported";

export type DashboardNotificationClassificationEnum = "warning" | "soon" | "release" | "alert" | "other" | "xmlZipSuccess" | "xmlZipError";

export type DashboardNotificationTagsEnum = "organization" | "place" | "event" | "pdv" | "app";

export type EmployeeMenuVisualizationType = "SmallGrid" | "Grid" | "NoPicture";

export type EmployeeType = "system" | "hawker" | "admin" | "dashboard" | "hawkerCashier" | "miniTotemFicha" | "miniTotemCashless" | "beerTap" | "beerTapCashless" | "kds";

export type AdjustCategory = "pos" | "posTax" | "operatorFee" | "systemSetup" | "wifiSetup" | "equipmentsPurchase" | "equipmentsRental" | "zigDevicePurchase" | "equipmentsMaintenance" | "wifiAssistance" | "zigFee" | "totemFee" | "cardActivations" | "genericOperationsFee" | "genericServices" | "bonifications" | "expiredRecharges" | "notUsedRecharges" | "generalZigMachineTPV" | "generalZigMachineTax" | "paymentsTax" | "anticipationFee" | "payments" | "withdraw" | "externalResourceContribution" | "reimbursements" | "balanceAdjustment" | "renegotiation" | "advance" | "advanceFee" | "balanceRetention" | "balanceTransfer" | "residueRemain" | "missingCards" | "billingInvoice" | "guaranteedMinimumSupplement" | "commandFiscalPurchase" | "accountsReceivableLegal" | "cardDiscount" | "discountGeneralOperatingExpenses" | "discountOperatorDailyRate" | "generalDiscount" | "dailyCoordinatorRate" | "dailyHeadsRate" | "setupDailyCoordinatorRate" | "setupDailyHeadsRate" | "setupDailySupervisorsRate" | "setupDailyTechnicalRate" | "setupDailyTraineeRate" | "dailySupervisorRate" | "dailyTechnicianRate" | "dailyTraineeRate" | "damagedEquipment" | "integratedAPPBilling" | "apartCreditBilling" | "integratedCreditBilling" | "apartDebitBilling" | "integratedDebitBilling" | "apartBillingPIX" | "integratedPIXBilling" | "integratedAdvancedRechargeBilling" | "interestandPenalties" | "softwareLicense" | "replacedMachines" | "minimumGuaranteedpermachine" | "otherEquipment" | "rebate" | "setupAdvancedRecharge" | "setupRefundSite" | "acquirementfeeforIntegratedZIGApplication" | "acquiringfeeonapartCredit" | "acquiringfeeforIntegratedCredit" | "acquiringfeeforapartDebit" | "acquiringfeeonIntegratedDebit" | "acquiringfeeforapartPIX" | "acquiringfeeforIntegratedPIX" | "acquiringfeeforAdvancedRecharge" | "refundfee" | "relatedpartyretentionfee" | "rappiFee" | "SMSFee" | "residualFee" | "cardtoCashExchange" | "cardtoProductExchange" | "travelFood" | "shipping" | "accommodation" | "transport" | "pixRefundFee" | "softwareLicenseMachine" | "softwareLicenseTotem" | "integratedAdvanceDebitBilling" | "integratedAdvanceCreditBilling" | "integratedAdvancePixBilling" | "integratedAdvanceDebitFee" | "integratedAdvanceCreditFee" | "integratedAdvancePixFee" | "zeDeliveryDiscount" | "ticketPrinting" | "validatorRental" | "zeDeliveryRetention" | "valueAddedTax" | "moneyTPV" | "acquiringFeeForIntegratedInstallmentCredit" | "loanBracelet" | "lendingCards" | "issuedCharge" | "anticipationValue" | "anticipatedValue" | "softwareLicenseGiftback" | "integratedOnlineDeliveryIncome" | "generalZigMachineCreditIn2Installments" | "generalZigMachineCreditIn3Installments" | "generalZigMachineCreditIn4Installments" | "generalZigMachineCreditIn5Installments" | "generalZigMachineCreditIn6Installments" | "generalZigMachineCreditIn7Installments" | "generalZigMachineCreditIn8Installments" | "generalZigMachineCreditIn9Installments" | "generalZigMachineCreditIn10Installments" | "generalZigMachineCreditIn11Installments" | "generalZigMachineCreditIn12Installments" | "generalZigMachineCreditIn2InstallmentsFEE" | "generalZigMachineCreditIn3InstallmentsFEE" | "generalZigMachineCreditIn4InstallmentsFEE" | "generalZigMachineCreditIn5InstallmentsFEE" | "generalZigMachineCreditIn6InstallmentsFEE" | "generalZigMachineCreditIn7InstallmentsFEE" | "generalZigMachineCreditIn8InstallmentsFEE" | "generalZigMachineCreditIn9InstallmentsFEE" | "generalZigMachineCreditIn10InstallmentsFEE" | "generalZigMachineCreditIn11InstallmentsFEE" | "generalZigMachineCreditIn12InstallmentsFEE" | "totalTpvBarIncome" | "totalTpvEntranceIncome" | "totalTpvEntranceIncomeConsumption" | "totalTpvBarMinimumConsumption" | "totalTpvBonus" | "bankRefund" | "acquirerRefund" | "advanceRenegotiation" | "zigTicketsRetention" | "onlineDeliveryAcquisitionFee" | "pixPreventiveBlock" | "pixAuthorizedUnblock" | "pixRefundByChargeback" | "totenRental" | "RelatedStakeholderRetentionReprocessing" | "electrical" | "hydraulics" | "cleaning" | "other" | "supply";

export type WithdrawStatus = "Pending" | "Paid" | "Refused" | "Processing" | "Pix_Processing" | "Bankslip_Processing" | "PendingManagerApproval" | "Cancelled" | "PendingPlaceConfirmation" | "CanceledPlaceConfirmation" | "ProcessingCancellation" | "PendingAnticipation" | "PendingTreasuryAction";

export type WithdrawType = "Anticipation" | "Withdraw" | "WithdrawAndAnticipation" | "Bankslip";

export type ConsolidatedExtractSectionValuesTotalValueUnit = "unit" | "money";

export type DebitNoteStatus = "CREATED" | "GENERATED" | "CANCELLED";

export type DebitNoteGeneratedAs = "AUTOMATIC" | "MANUALLY";

export type RentNoteStatus = "CREATED" | "GENERATED" | "CANCELLED";

export type RentNoteGeneratedAs = "AUTOMATIC" | "MANUALLY";

export type BaseFinancialChargeConfigRecurrence = "daily" | "event" | "weekly" | "monthly";

export type AutomaticWithdrawStatus = "success" | "partial" | "error";

export type FinancialExtractBlockType = "automatic" | "manual" | "contractEffect";

export type FinancialExtractBlockReceivableType = "credit" | "debit";

export type InvoiceMoment = "recharge" | "rechargeAndActivation" | "consumption" | "consumptionAndActivation";

export type InvoiceStatus = "issued" | "issuing" | "failed" | "canceled";

export type PrechargeOperationBonusType = "money";

export type PrechargeOperationPaymentMethod = "PIX" | "CREDIT_CARD";

export type PrechargeStatus = "refused" | "success" | "pending_review" | "refunded";

export type SellableThing = "Product" | "Combo";

export type PlaceProductFiscalDataStatus = "no" | "notTested" | "tested" | "error";

export type OperationType = "table" | "zigTag" | "ficha";

export type ProductMasterKind = "Outros" | "Bilheteria" | "Bebidas" | "Alimentos";

export type ProductStatus = "active" | "inactive";

export type WeekDay = "sun" | "mon" | "tue" | "wed" | "thu" | "fri" | "sat";

export type BirthdayPerson = "day" | "week" | "month";

export type PromotionFrequencyOfEarning = "everytime" | "eachEvent" | "oncePerWeek" | "oncePerMonth";

export type PromotionDiscountType = "bonus" | "discount";

export type NewPromotionConditionsGender = "Male" | "Female" | "Other";

export type PostPaymentEventPostPaymentType = "App" | "Place";

export type BasicStorageUnit = "milliliter" | "liter" | "kilogram" | "gram" | "unit";

export type NewMountableSectionPricing = "sum" | "average" | "higher";

export type MountableSectionV2Pricing = "sum" | "average" | "higher";

export type PrinterType = "EPSON" | "BEMATECH";

export type PaymentPrePaidType = "MinimumConsumption" | "Bonus" | "FromEvent" | "FromOtherEvent" | "FromApp" | "FakeRecharge";

export type TransactionSource = "ficha" | "balcony" | "delivery" | "grabngo" | "onlineBill" | "cashless" | "dash" | "zigQrcode" | "hce" | "onlineFicha" | "table";

export type UserDocumentType = "unknown" | "cpf" | "phone" | "uid" | "table" | "email";

export type RechargePaymentMethod = "Rappi" | "Ifood" | "Uber" | "Ame" | "DeliveryOnline" | "CreditCard" | "DebitCard" | "Cash" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "Voucher" | "Dashboard" | "Anticipated" | "Pix" | "IntegratedFoodVoucher" | "Online" | "MBWay";

export type Gender = "Male" | "Female" | "Other";

export type RechargePaymentMethodWithCashless = "Rappi" | "Ifood" | "Uber" | "Ame" | "DeliveryOnline" | "CreditCard" | "DebitCard" | "Cash" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "Voucher" | "Dashboard" | "Anticipated" | "Pix" | "IntegratedFoodVoucher" | "Online" | "MBWay" | "Cashless";

export type AllPaymentMethods = "Rappi" | "Ifood" | "Uber" | "Ame" | "DeliveryOnline" | "CreditCard" | "DebitCard" | "Cash" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "Voucher" | "Dashboard" | "Anticipated" | "Pix" | "IntegratedFoodVoucher" | "Online" | "MBWay" | "PostEvent" | "Bonus" | "Cashless" | "Unknown" | "DigitalCashless";

export type OperationalType = "ficha" | "prePaid" | "postPaid" | "mesa" | "balcony";

export type VendorFinancialAdjustCategory = "electrical" | "hydraulics" | "cleaning" | "other" | "supply";

export type VendorClosingValueRelative = "closingBilled" | "adjust" | "revenue" | "dailyRent" | "weeklyRent" | "monthlyRent" | "commissionPayment" | "floorComplement";

export type VendorFeatureEnum = "seeExtract" | "seeClosings" | "chargeOpenedBillsFromVendor" | "seeBarReports" | "canCreateAndDeleteProducts" | "cashRetention" | "blockWithdraw";

export type VendorDocumentType = "CPF" | "CNPJ" | "INTERNATIONAL";

export type VendorWithdrawRequestType = "Withdraw" | "Anticipation";

export type VendorWithdrawRequestStatus = "Processing" | "Paid" | "Refused" | "Pending";

export type MetabaseQuestionEnum = "audits_enterprise" | "relay_gl" | "gift_card";

export type MetabaseIntegrationEmbeddingParamsConfig = "enabled" | "locked" | "disabled";

export type MetabaseResourceType = "card" | "dashboard";

export type OrganizationMetabaseContextLevel = "organization" | "place" | "event";

export type ConsentSource = "delivery" | "queue" | "reservation" | "pdv" | "app" | "precharge";

export type Channel = "sms" | "whatsapp";

export type MenuType = "normal" | "delivery" | "dineIn" | "pickUp" | "deliveryByMarketplace" | "hawker" | "grabAndGo" | "onlineFicha" | "onlineTab" | "viewMenu" | "deliveryIntegrated";

export type Vendor = "rappi" | "coala" | "ifood" | "ubereats" | "menu" | "food99" | "keeta" | "manualOrder";

export type OrderStatus = "placed" | "confirmed" | "concluded" | "cancelled" | "pendingPayment" | "ready" | "dispatched" | "pickupAreaAssigned";

export type DeliveryType = "dineIn" | "pickUp" | "deliveryByPartner" | "deliveryByRestaurant" | "deliveryByMarketplace" | "viewMenu" | "onlineTab" | "onlineFicha";

export type DeliverySource = "coala" | "ifood" | "ubereats" | "rappi" | "food99" | "keeta" | "other";

export type TipReceiver = "MERCHANT" | "LOGISTIC_SERVICES" | "MARKETPLACE";

export type CashierAdjustmentType = "bleeding" | "pettyCash";

export type CloseMethodEnum = "cash" | "debit" | "credit" | "voucher";

export type AllMethods = "cash" | "debit" | "credit" | "voucher" | "zigDebit" | "zigCredit" | "zigCreditInInstallments" | "postEvent" | "dashboard" | "anticipated" | "deliveryOnline" | "ame" | "rappi" | "uber" | "ifood" | "bonus" | "pix" | "integratedFoodVoucher" | "MBWay" | "online";

export type PaymentMethodWithCashless = "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "CreditCard" | "DebitCard" | "Cash" | "App" | "Voucher" | "Anticipated" | "Pix" | "Cashless" | "DigitalCashless" | "IntegratedFoodVoucher" | "MBWay";

export type PaymentMethodWithCashlessAndBonus = "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "CreditCard" | "DebitCard" | "Cash" | "App" | "Voucher" | "Anticipated" | "Pix" | "Cashless" | "DigitalCashless" | "IntegratedFoodVoucher" | "MBWay" | "Bonus" | "MinimumConsumption" | "Ifood" | "Online";

export type PixChargePaidResponseStatus = "paid" | "notPaid" | "expired" | "error";

export type EventResumeSectionValuesValuesUnit = "money" | "un" | "percentage";

export type RechargeTypeEnum = "minimumConsumption" | "normal" | "bonus";

export type RechargeType = "Bonus" | "Refund" | "CreditViaApp" | "CreditViaPlace" | "RefundForPPU";

export type CheckinMethod = "biometry" | "pdv" | "app" | "automatic" | "menu";

export type PlaceContractManagerContact = "Zendesk" | "Comercial";

export type QuestionType = "music" | "product" | "service" | "price" | "cleaness" | "mixes" | "nps" | "paymentExperience";

export type Origin = "direct_link" | "qr_code" | "sms";

export type MenuConfigsTaxType = "unique" | "baseRateWithVariableKm" | "ratePerRadius";

export type MenuConfigsAdditionalFieldType = "numberChair" | "numberTable" | "numberRoom" | "referencePoint";

export type PlaceMenus = "delivery" | "dineIn" | "onlineTab" | "onlinePostPayment" | "viewMenu";

export type FichaFontSize = "Small" | "Medium" | "Large";

export type FichaImageSize = "NoImage" | "Small" | "Medium" | "Large";

export type FichaQRCodeSize = "NoQRCode" | "Small" | "Medium" | "Large";

export type PairInfoType = "vendor" | "place";

export type FutureFinancialEntryGroupBy = "MONTH" | "DAY" | "TYPE" | "CATEGORY";

export type WithdrawV2Status = "Paid" | "Pending" | "Refused" | "Processing" | "Pix_Processing" | "Bankslip_Processing" | "PendingManagerApproval" | "Cancelled" | "PendingPlaceConfirmation" | "CanceledPlaceConfirmation" | "ProcessingCancellation" | "PendingAnticipation" | "PendingTreasuryAction";

export type WithdrawV2Type = "Withdraw" | "Anticipation";

export type DateFilterType = "referenceDate" | "originalPayDate" | "effectivePayDate";

export type GroupByOption = "DAY" | "MONTH" | "TYPE" | "CATEGORY";

export type ReceivableUnitType = "credit" | "debit" | "anticipation" | "contractEffect";

export type ReceivableUnitConsolidatedCardType = "credit" | "debit";

export type ExternalStoreIntegrationStatus = "synced" | "pendingSyncing" | "pendingImporting" | "noItemsToImport";

export type ExternalStoreIntegrationType = "iFood" | "rappi" | "keeta";

export type DashboardAlertType = "ExtractPriority" | "Normal";

export type BackofficeBaseBillStatus = "Paid" | "Pending";

export type BackofficeReferenceField = "addition" | "discount";

export type BackofficeDateInterval = "weekly" | "monthly" | "yearly" | "semiannual" | "quarterly" | "bimonthly";

export type BackofficeBillStatusFilter = "Any" | "ToPay" | "ToReceive";

export type BackofficeBillDateFilter = "ByDue" | "ByPerform" | "ByPay";

export type BackofficeExportBillArgsStatus = "Paid" | "Pending" | "Any";

export type BackofficeBillsToDREAnalyticsStatus = "Paid" | "Pending";

export type BackofficeCashFlowBillDateWithStatusStatus = "Paid" | "Overdue" | "Pending";

export type BackofficeNeoCashFlowArgsViewMode = "Weekly" | "Daily" | "Monthly";

export type BackofficeExportDreArgDateFilter = "PerformDate" | "PayDate";

export type BackofficeInventoryStatus = "Opened" | "Closed" | "Canceled";

export type BackofficeImportedInvoiceDetailsField = "insuranceValue" | "discountValue" | "otherExpensesValue" | "shippingValue" | "icmsstValue" | "ipiValue";

export type SimpleInvoiceInfoStatus = "authorized" | "notAllowed" | "xmlUnavailable" | "imported";

export type ManualBackofficeInvoiceDuplcatesInterval = "Week" | "Month";

export type BackofficeInvoiceXLSXArgsStatus = "Processed" | "Pending" | "Any";

export type BackofficeInvoiceXLSXArgsOrigin = "ByXML" | "Manual" | "Focus" | "Any";

export type BackofficeManifestType = "ciencia" | "confirmacao" | "desconhecimento" | "naoRealizada";

export type BackofficeReceivedInvoiceStatus = "ciencia" | "confirmacao" | "desconhecimento" | "naoRealizada" | "respostaPendente" | "baixada";

export type BackofficeResumeBillsDueToTodayStatus = "Paid" | "Pending";

export type BackofficeProductStorageHistoryFilterBy = "interval" | "events";

export type BackofficeNewProductRuleType = "minimunQuantity" | "criticalQuantity";

export type BackofficeEditProductRuleType = "minimunQuantity" | "criticalQuantity";

export type ProductsSoldOrderByColumn = "count" | "subtotal" | "discount" | "totalValue" | "productName";

export type ProductsSoldOrderByOrder = "desc" | "asc";

export type CateringProductSubType = "Product" | "Combo" | "Mountable";

export type CateringProductsOrderBy = "name" | "category";

export type CateringProductsOrderDirection = "asc" | "desc";

export type CateringMountableSectionPricing = "sum" | "average" | "higher";

export type CmvReportType = "All" | "From_Place" | "From_Vendor";

export type ComodatoContractStatus = "pendingSignature" | "signatureExpired" | "contractExpired" | "active" | "closed";

export type ComodatoContractRequestType = "permanent" | "temporary";

export type ComodatoContractRequestModel = "addition" | "exchange";

export type ComodatoContractSortBy = "createdAt" | "signedAt" | "expiresAt" | "status";

export type SortOrder = "asc" | "desc";

export type DiscountCategoryType = "percentage" | "value";

export type EditMultipleEmployeesBarsOperation = "add" | "remove";

export type BankAccountType = "Savings" | "Checking";

export type AuthKeyType = "email" | "phone";

export type AuthKeyStatus = "active" | "blocked" | "inactive";

export type DebtorStatus = "notCharged" | "created" | "expired" | "partiallyCreated";

export type RechargeConsumptionMethod = "Ame" | "Anticipated" | "Cash" | "Credit" | "CreditCard" | "Dashboard" | "DebitCard" | "DeliveryOnline" | "Ifood" | "Pix" | "Rappi" | "Uber" | "Voucher" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "MBWay" | "IntegratedFoodVoucher";

export type PaymentMethod = "CreditCard" | "DebitCard" | "Cash" | "PostEvent" | "ZigPosCredit" | "ZigPosDebit" | "Voucher" | "Bonus" | "App" | "Pix" | "IntegratedFoodVoucher" | "ZigPosCreditInInstallments" | "Anticipated" | "Ame" | "MBWay" | "DeliveryOnline" | "Ifood";

export type OpenedBillPaymentMethod = "CreditCard" | "DebitCard" | "Cash" | "PostEvent" | "ZigPosCredit" | "ZigPosDebit" | "Voucher" | "Bonus" | "MBWay";

export type ReportAfterEventClosingOrigin = "OfflineAction" | "HistoryMachine" | "HistoryMachineAfterClosing";

export type AppTransactionDetailsAppPaymentType = "creditCard" | "balance";

export type AppTransactionDetailsTransactionType = "ppu" | "pre" | "post";

export type TransactionType = "Couvert" | "Entrance" | "Normal" | "Tip" | "ZigCard" | "MinimumConsumption";

export type BuyerPaymentType = "Post" | "Ppu" | "MinimumConsumption" | "Bonus" | "FromEvent" | "FromOtherEvent" | "FromApp";

export type OriginalType = "pre" | "post" | "ppu";

export type SalesDetailsOrderByColumn = "date" | "isRefunded";

export type SalesDetailsOrderByOrder = "desc" | "asc";

export type RegimeTributario = "SimplesNacional" | "SimplesNacionalExcesso" | "RegimeNormal";

export type RegimeTributarioEspecial = "MicroempresaMunicipal" | "Estimativa" | "SociedadeDeProfissionais" | "Cooperativa" | "MEISimplesNacional" | "MEEPPSimplesNacional";

export type FiscalMode = "nfce" | "sat" | "ivaVendus" | "ivaFactura";

export type InvoiceMode = "sat" | "nfe" | "nfse" | "nfsen" | "nfce" | "ivaVendus" | "ivaFactura";

export type RecipientExtraInfoIndicadorInscricaoEstadual = "ContribuinteICMS" | "ContribuinteIsento" | "NaoContribuinte";

export type FiscalDraftActorType = "adminZig" | "employee";

export type FiscalProfileIvaVendusCountry = "PT" | "ES";

export type FiscalProfileIvaFacturaExpirationOpt = "lastMonthDay" | "daysAfterTransaction";

export type FiscalProductGroupType = "invoice" | "service" | "serviceNational" | "vat" | "vatFactura" | "vatSpain";

export type FiscalProductGroupVatVendusDetailsCode = "INT" | "RED" | "NOR" | "ISE" | "RED2" | "OUT" | "OUT2";

export type FiscalProductGroupVatVendusDetailsProductType = "P" | "S" | "O" | "I" | "E";

export type FiscalProductGroupVatVendusDetailsTaxExemption = "M01" | "M02" | "M03" | "M04" | "M05" | "M06" | "M07" | "M08" | "M09" | "M10" | "M11" | "M12" | "M13" | "M14" | "M15" | "M16" | "M99";

export type FiscalProductGroupVatVendusDetailsRegion = "ptContinental" | "ptAcores" | "ptMadeira";

export type InvoiceV2Mode = "sat" | "nfse" | "nfsen" | "nfce" | "ivaVendus" | "ivaFactura";

export type InvoiceTypeEnum = "FT" | "NC";

export type InvoicesV2FilterEmissionItemType = "Product" | "Recharge";

export type NationalFiscalInvoiceDataMode = "sat" | "nfse" | "nfsen" | "nfce" | "nfe";

export type ManualRequestPaymentMethod = "Cash" | "CreditCard" | "DebitCard" | "Voucher" | "PostEvent" | "Anticipated";

export type NotEmittedProductOrComboType = "combo" | "product";

export type LogInvoiceErrorResponseStatus = "pending" | "resolved";

export type PendingInvoicesFilterInvoiceType = "FT" | "NC";

export type PendingInvoicesFilterInvoiceEmissionType = "Recharge" | "Products";

export type EmittedValueByPaymentTypeEnum = "cashless" | "zigApp" | "card" | "cash" | "bonus" | "pix" | "mbWay" | "mealTicket" | "voucher" | "noPaymentAttached";

export type GenericValueForReportUnit = "unit" | "money";

export type NotEmittedProductType = "product" | "combo";

export type InvoiceFiscalProductGroupType = "invoice" | "service" | "serviceNational" | "vat" | "vatFactura" | "vatSpain";

export type InvoiceUserInformationType = "CPF" | "CNPJ" | "NIF";

export type InsightReaction = "good" | "bad";

export type InventoryStatus = "Opened" | "Closed" | "Canceled";

export type BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout = "sms" | "wpp";

export type LoyaltyProgramExtractType = "couponRedeem" | "productBuy" | "placeAttend" | "spentValue" | "gender" | "appPayment";

export type GiftCardCampaignStatus = "active" | "canceled" | "expired";

export type OpenSaleMethod = "pix" | "credit" | "debit" | "integratedFoodVoucher" | "mbway" | "creditInInstallments";

export type PaymentOrigin = "zig" | "place";

export type PaymentLinkStatus = "PENDING" | "PAID" | "EXPIRED" | "CANCELED";

export type PaymentLinkDateField = "createdAt" | "paidAt";

export type PlaceSize = "XS" | "S" | "M" | "L" | "XL";

export type PlaceType = "default" | "delivery" | "transfers" | "advance" | "billing";

export type PlaceSellVisualizationFormat = "Grid" | "List";

export type PlaceStatus = "active" | "inactive" | "blocked" | "paused";

export type NewPlaceSellVisualizationFormat = "Grid" | "List";

export type PlaceContractDetailsRechargesRechargesAction = "ChargeBack" | "PlaceOnly" | "Normal";

export type UsersWithAverageTicketGender = "Male" | "Female" | "Other";

export type AverageTicketFilterGender = "Male" | "Female" | "Other";

export type SellVisualizationFormat = "Grid" | "List";

export type LinkHighlightType = "instagram" | "facebook" | "twitter" | "ticketLink" | "site";

export type LocationCategory = "show" | "event" | "festival" | "restaurant" | "barAndRestaurant" | "pub" | "nightclub" | "bar";

export type NewLocationCategory = "show" | "event" | "festival" | "restaurant" | "barAndRestaurant" | "pub" | "nightclub" | "bar" | "arena" | "bistro" | "beachClub";

export type DayOfWeek = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun" | "hol";

export type LocalType = "place" | "event";

export type FeeType = "single" | "segmented";

export type PosTransactionMethodMethod = "Credit" | "Debit";

export type KitchenPrinterTypes = "lan" | "smartpos" | "kds";

export type ProportionalValueUnit = "gramas" | "ml" | "un";

export type NewMountableSectionWithStatusPricing = "sum" | "average" | "higher";

export type ProductType = "MinimumConsumption" | "ZigCard" | "Couvert" | "Product" | "Entrance" | "Tip" | "Supply" | "Combo" | "Catering";

export type DeleteMultipleProductsStatus = "completed" | "queued";

export type PatchProductErrorName = "invalidTaxData" | "ncm" | "cest" | "duplicatedFiscalCode" | "productNotFound" | "categoryWithSubcategory" | "supercategoryNotFound" | "invalidSystemProduct";

export type BaseProductSectionResponsePricing = "sum" | "average" | "higher";

export type ProductFeatureTemplateFieldType = "text" | "number" | "bool" | "enum";

export type PlacePromoterStatus = "active" | "inactive" | "pending";

export type RefundReasonsTypes = "refund" | "cancel";

export type ImportRelationErrorTypes = "limitByPromoterCannotGreaterThanLimitPerList" | "relationNameAlreadyExists" | "invalidInput";

export type MultipleRelationUserErrorsType = "userAlreadyExists" | "relationReachesLimit" | "userWithoutDocument";

export type FinanceBiMethod = "Credit" | "Debit" | "Cash" | "PostEvent" | "ZigCredit" | "ZigDebit" | "Voucher" | "Anticipated" | "Dashboard" | "App" | "Other";

export type ReportExportFormat = "Csv" | "Xlsx";

export type ProductsSoldReportV2OperationType = "Table" | "ZigTag";

export type ProductsSoldReportV2TransactionSource = "ficha" | "balcony" | "delivery" | "grabngo" | "onlineBill" | "cashless" | "dash" | "zigQrcode" | "hce" | "onlineFicha" | "table";

export type ProductsSoldReportV2ProductStatus = "active" | "inactive" | "unavailable";

export type DetailedTransactionsReportOrderByColumn = "date" | "isRefunded";

export type DetailedTransactionsReportOrderByOrder = "desc" | "asc";

export type KdsOrderFinalStatus = "ON_TIME" | "DELAYED";

export type KdsOrdersSortColumn = "date" | "totalTimeMin";

export type KdsOrdersSortDirection = "asc" | "desc";

export type NewProductAlertType = "minimunQuantity" | "criticalQuantity";

export type EditProductAlertType = "minimunQuantity" | "criticalQuantity";

export type ProductStorageRuleType = "minimunQuantity" | "criticalQuantity";

export type StorageTransferType = "input" | "transferOut" | "transferIn" | "lost" | "productionLost" | "sell" | "refund" | "manual" | "productionOut" | "productionIn" | "invoice" | "inventory" | "cardExchange";

export type TableMapStatus = "Available" | "InService" | "InPayment" | "Paid" | "Blocked";

export type ProductSoldV2OperationType = "table" | "card";

export type UserFilterType = "cpf" | "phone" | "zigcode" | "id";

export type UserRechargeMethod = "CreditCard" | "DebitCard" | "Cash" | "App" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "Voucher" | "Dashboard" | "Anticipated" | "DeliveryOnline" | "Ame" | "Rappi" | "Ifood" | "Uber" | "Pix" | "IntegratedFoodVoucher" | "Online" | "MBWay";

export type NewUserRechargeGender = "Male" | "Female" | "Other";

export type UserEventHistoryType = "productTransaction" | "entranceTransaction" | "sharedTransaction" | "attach" | "consumeRecharge" | "detachAndRefundActivation" | "postPayment" | "appPrePayment" | "recharge" | "bonus" | "minimumConsumption" | "refundRecharge" | "refundTransaction" | "discount" | "tipRemoval" | "promotion" | "changePostLimit" | "attachToReserve" | "consumptionObligation" | "zigDeviceSyncForce" | "transferProductTransaction" | "zigCardPixRefund" | "transferConsumptionObligation" | "transferTransaction" | "refundPostPayment" | "singleProductReturn";

export type UserTransactionTipReceiver = "MERCHANT" | "LOGISTIC_SERVICES" | "MARKETPLACE";

export type VendorWithdrawRequestMethod = "accountBalance" | "other";

export type ZigDeviceWithGroupAndBalanceStatus = "inactive" | "used" | "inUse" | "blocked";

export type MessageStatus = "scheduled" | "sent" | "canceled";

export type GlossaryVariables = "date" | "client" | "productName" | "productOriginalPrice" | "productPromotionalPrice" | "discount" | "observation";

export type ActionTypes = "action" | "text" | "media" | "location" | "quick" | "list" | "card";

export type MessageClientGender = "Male" | "Female" | "Other";

export type SentMessageClientStatus = "optout" | "sending" | "sent" | "delivered" | "error";

export type MessageTemplateStatus = "approved" | "rejected" | "pending" | "received";

export type ButtonType = "QUICK_REPLY" | "URL" | "PHONE_NUMBER";

export type MessageSentOrigin = "coalaIntegration" | "npsForm" | "campaignMessage" | "kitchen" | "reservation_confirmation" | "giftback" | "minimumStorageAlert" | "givePromotion" | "reservation_late" | "reservation_day_of" | "reservation_reminder" | "reservation_cancellation";

export type BackOfficeOperationChartAccount = "credit" | "debit";

export type BackOfficeTypeChartAccount = "analytic" | "synthetic";

export type BackofficePurposeTypes = "Advance" | "CardIssuer" | "InternalCash" | "Tip" | "CreditCard" | "eWallet" | "InvestmentAccount" | "CheckingAccount" | "PaymentAccount" | "ReceivingAccount" | "LoanAccount" | "SecuredAccount" | "SavingsAccount";

export type BackofficeTypeAccountBills = "payable" | "receivable";

export type BackofficePaymentMethod = "App" | "Money" | "Check" | "CreditCard" | "BankTransfer" | "Promissory" | "DebitCard" | "AutomaticDebit" | "Boleto" | "Pix";

export type BackofficeTypeAccountBillsChartAccount = "Account" | "Interest" | "Fine" | "Discount" | "FinancialFees" | "InvoiceProducts";

export type TypeInterval = "Day" | "Week" | "Month" | "Year";

export type BackofficeRecurringStatus = "active" | "paused" | "completed" | "cancelled";

export type BackofficeGetParamsAccountsBillsOrderBy = "dueDate";

export type BackofficeGetParamsAccountsBillsOrder = "asc" | "desc";

export type BackofficeAccountBillsStatus = "due" | "overdue" | "paid" | "conciliated" | "dueToday";

export type TypeClosingAccount = "credit" | "debit";

export type BackofficeAccountBillHistoryEventType = "created" | "updated" | "deleted" | "paymentAdded" | "reconciled" | "chartAccountAssigned" | "chartAccountValueChanged" | "unknown";

export type BackofficeStorageInventoryProductTransferType = "manual" | "lost";

export type BackofficeStorageInventoryStatus = "open" | "reopened" | "in_review" | "approved";

export type GetBackofficeStorageInventoryAndStorageComparisonFiltersFilterType = "onlyZero" | "negativeDifference" | "positiveDifference" | "withoutDifference";

export type HawkerSaleType = "transacted" | "devolved" | "released" | "canceled" | "remained" | "all";

export type PaymentType = "CreditCard" | "DebitCard" | "Pix" | "Cash";

export type TableFilterStatusEnum = "all" | "open" | "closed";

export type ZendeskTicketStatus = "closed" | "solved" | "hold" | "pending" | "open" | "new";

export type ZigTicketStatus = "closed" | "ongoing" | "open";

export type IfoodEventCode = "POS" | "PLC" | "CFM" | "SPS" | "SPE" | "RTP" | "DSP" | "CON" | "CAN" | "CAR" | "CARF" | "HSD" | "HSS" | "PAA" | "RDR" | "RDS" | "RDF" | "DCRA" | "DCRR" | "CLT" | "ADR" | "GTO" | "AAO" | "DDD" | "AAD" | "DRGO" | "DRDO" | "DCR" | "DDCR" | "DDCS" | "DRCR" | "DPCR" | "DPCS" | "DAR" | "DAU" | "DAA" | "DAD" | "DGA" | "DGD" | "DGAC" | "DGDC" | "DGU" | "RTS" | "OPA" | "RPS" | "PRS" | "CPR" | "CPT" | "BOA" | "RFI" | "GTD" | "DRH" | "KEEPALIVE";

export type IfoodEventFullCode = "PLACED" | "CONFIRMED" | "SEPARATION_STARTED" | "SEPARATION_ENDED" | "READY_TO_PICKUP" | "DISPATCHED" | "CONCLUDED" | "CANCELLED" | "CANCELLATION_REQUESTED" | "CANCELLATION_REQUEST_FAILED" | "HANDSHAKE_DISPUTE" | "HANDSHAKE_SETTLEMENT" | "PICKUP_AREA_ASSIGNED" | "ASSIGN_DRIVER" | "GOING_TO_ORIGIN" | "ARRIVED_AT_ORIGIN" | "DELIVERY_DRIVER_DEALLOCATED" | "COLLECTED" | "ARRIVED_AT_DESTINATION" | "DELIVERY_RETURNING_TO_ORIGIN" | "DELIVERY_RETURNED_TO_ORIGIN" | "DELIVERY_CANCELLATION_REQUESTED" | "DELIVERY_DROP_CODE_REQUESTED" | "DELIVERY_DROP_CODE_VALIDATION_SUCCESS" | "DELIVERY_RETURN_CODE_REQUESTED" | "DELIVERY_PICKUP_CODE_REQUESTED" | "DELIVERY_PICKUP_CODE_VALIDATION_SUCCESS" | "DELIVERY_ADDRESS_CHANGE_REQUESTED" | "DELIVERY_ADDRESS_CHANGE_USER_CONFIRMED" | "DELIVERY_ADDRESS_CHANGE_ACCEPTED" | "DELIVERY_ADDRESS_CHANGE_DENIED" | "DELIVERY_GROUP_ASSIGNED" | "DELIVERY_GROUP_DISMISSED" | "DELIVERY_GROUP_ASSOCIATED" | "DELIVERY_GROUP_DISSOCIATED" | "DELIVERY_GROUP_UPDATED" | "RETURN_TO_STORE" | "ORDER_PATCHED" | "RECOMMENDED_PREPARATION_START" | "PREPARATION_STARTED" | "CONSUMER_PREPARATION_TIME_REQUESTED" | "CHANGE_PREPARATION_TIME" | "BOX_ASSIGNED" | "READY_FOR_INVOICE" | "REQUEST_DRIVER" | "REQUEST_DRIVER_SUCCESS" | "REQUEST_DRIVER_FAILED" | "DELIVERY_CANCELLATION_REQUEST_ACCEPTED" | "DELIVERY_CANCELLATION_REQUEST_REJECTED" | "GOING_TO_DESTINATION" | "DELIVERY_RETURNING_HANDSHAKE" | "KEEPALIVE";

export type DeliveryChannel = "phone" | "whatsapp" | "marketplace" | "whitelabel";

export type DeliveryOrderEventStatus = "pendingPayment" | "placed" | "integrated" | "scheduled" | "confirmed" | "ready" | "dispatched" | "concluded" | "cancelled" | "pickupAreaAssigned";

export type DeliveryOrderPaymentMethod = "Rappi" | "Ifood" | "Uber" | "Ame" | "DeliveryOnline" | "CreditCard" | "DebitCard" | "Cash" | "ZigPosCredit" | "ZigPosCreditInInstallments" | "ZigPosDebit" | "Voucher" | "Dashboard" | "Anticipated" | "Pix" | "IntegratedFoodVoucher" | "Online" | "MBWay";

export type ManagerDeliveryOrderCustomerDocumentType = "cpf" | "phone" | "unknown";

export type ManagerDeliveryOrderItemsSubItemsPricing = "sum" | "average" | "higher";

export type DeliveryIfoodCancellationReason = "SYSTEM_ERROR" | "DUPLICATE_ORDER" | "ITEM_UNAVAILABLE" | "NO_DELIVERY_PERSON" | "OUTDATED_MENU" | "OUTSIDE_DELIVERY_AREA" | "FRAUDULENT_CUSTOMER" | "OUTSIDE_DELIVERY_HOURS" | "INTERNAL_DIFFICULTIES" | "RISK_AREA" | "RESTAURANT_OPENING_LATER" | "RESTAURANT_CLOSED_EARLIER";

export type ZigCancelReason = "itemUnavailable" | "storeClosed" | "storeOverloaded" | "infrastructureOutage" | "customerIssue" | "outdatedMenu" | "fraudSuspected" | "feesOrPromoDoubt" | "noCourier" | "orderOutOfArea" | "unsafeArea" | "other";

export type CreateManualOrderCustomerDocumentType = "cpf" | "phone" | "unknown";

export type CreateManualOrderPayloadDeliveryType = "deliveryByRestaurant" | "pickUp";

export type UpsertDeliveryFeeConfigPayloadTaxType = "unique" | "baseRateWithVariableKm" | "ratePerRadius";

export type MarketplaceProvider = "keeta" | "food99";

export type PendingTransactionStatus = "pending" | "conciliated" | "processed" | "cancelled";

export type AcquirerPaymentMethod = "Credit" | "Debit" | "Pix";

export type PlaceWizardStep = "basicInformation" | "barsAndSectors" | "productsAndMenus" | "rolesAndEmployees";

export type OFXTypeTransaction = "CREDIT" | "DEBIT" | "INT" | "DIV" | "FEE" | "SRVCHG" | "DEP" | "ATM" | "POS" | "XFER" | "CHECK" | "PAYMENT" | "CASH" | "DIRECTDEP" | "DIRECTDEBIT" | "REPEATPMT" | "OTHER" | "OUT" | "IN";

export type OFXFileHeaderResponseStatus = "created" | "notCreated" | "validated";

export type BackofficeBankConciliationStatus = "opened" | "conciliated";

export type BackofficeBankConciliationTransactionsType = "opened" | "conciliated" | "refused";

export type BackofficeSaveBankConciliationType = "conciliation" | "undoConciliation" | "ignore" | "undoIgnore";

export type CashbackConfigDataStatusKey = "active" | "deactivated" | "expired";

export type RfmClassification = "champions" | "loyal" | "highPotential" | "recent" | "promising" | "attention" | "closeToHibernation" | "risk" | "canNotLose" | "hibernating" | "lost" | "others";

export type CdpSortDirection = "asc" | "desc";

export type CdpUserSortField = "name" | "totalPaidValue" | "averageTicket" | "presences" | "lastInteraction";

export type InteractionType = "Event" | "TicketOrder" | "NpsSurveyAnswer" | "Communication" | "SegmentAlteration";

export type ProductPurchaseType = "Product" | "Entrance";

export type CdpInteractionProvider = "Zigpay" | "ZigTickets" | "Netpdv";

export type CdpInteractionChannel = "App" | "Marketplace" | "Phisical" | "Promoter";

export type CdpInteractionCommunicationChannel = "Whatsapp" | "Email" | "Sms" | "Push";

export type CdpInteractionCommunicationSubject = "Giftback" | "Promotion" | "NpsSurvey" | "Generic";

export type CdpSegmentRulesBirthday = "thismonth" | "nextmonth" | "thisweek" | "nextweek";

export type DashboardTimeGrouping = "dayOfWeek" | "week" | "month";

export type MixMode = "organization" | "place";

export type DemographicGender = "Male" | "Female" | "Other" | "NotInformed";

export type ValueMatrixPointQuadrant = "highFrequencyHighTicket" | "highFrequencyLowTicket" | "lowFrequencyHighTicket" | "lowFrequencyLowTicket";

export type DashboardInsightType = "ticketVariation" | "paretoRule" | "weekdayPattern" | "lostValuableClients" | "growthTrend" | "retentionAlert";

export type DashboardInsightSeverity = "info" | "warning" | "critical" | "success";

export type ExportFormat = "csv" | "excel";

export type CdpReportType = "clients" | "rfmDistribution" | "segmentDistribution" | "interactions" | "productPurchases" | "demographicDistribution" | "periodComparison" | "topRfmMetrics" | "valueMatrix";

export type TransactionReportLinkStatus = "PROCESSING" | "SUCCESS" | "ERROR";

export type HawkerCashierAdjustmentType = "changeFund" | "bleeding";

export type HawkerCashierHawkerClosingType = "session" | "cycle";

export type HawkerTransactionType = "sessionOpening" | "sessionClosure" | "cycleOpening" | "cycleClosure" | "productRelease" | "sale" | "cancellation" | "bleeding" | "changeFund" | "devolution" | "cashierOpening" | "cashierClosure";

export type KdsType = "Main" | "Basic";

export type KdsScreenType = "PRIMARY" | "SECONDARY";

export type EditMenuItemAction = "add" | "remove";

export type ProductMountableSectionPricing = "sum" | "average" | "higher";

export type EmployeeCardsStatuses = "active" | "inactive" | "blocked";

export type PendingOnlineRechargeResumeGender = "Male" | "Female" | "Other";

export type RechargeManagementType = "Bonus" | "CreditViaApp" | "CreditViaPlace" | "Refund";

export type RechargeManagementBonusType = "MinimumConsumption";

export type RechargeManagementStatus = "refunded" | "expired" | "active";

export type RechargeManagementRechargeType = "MinimumConsumption" | "Bonus" | "Recharge";

export type RechargeStatusEnum = "refunded" | "expired" | "active";

export type OrderEnum = "asc" | "desc";

export type StatusType = "scheduled" | "active" | "finished";

export type CampaignType = "salesTotal" | "attendance" | "soldProducts";

export type CampaignsPaymentType = "bonus" | "money" | "pix" | "employeeOfTheMonth" | "dayOff";

export type ListWinnersStatus = "pending" | "done";

export type PlaceVendorPaymentMethodType = "cash" | "voucher" | "credit" | "debit";

export type VendorConsolidatedExtractSectionValuesTotalValueUnit = "unit" | "money";

export type BankslipAvailableTypes = "BOLETO" | "UTILITY" | "TAX";

export type CombinedOrderReportSubItemDtoPricing = "sum" | "average" | "higher";

export type DeliveryTypeOrder = "dineIn" | "pickUp" | "delivery" | "deliveryByPartner" | "deliveryByRestaurant" | "deliveryByMarketplace" | "onlineFicha" | "onlineTab" | "viewMenu";

export type PaymentMethodOrder = "creditCardInPlace" | "debitCardOnline" | "debitCardInPlace" | "cash" | "creditCardOnline" | "voucherInPlace" | "ame" | "pix";

export type GetCombinedOrdersReportOrderBy = "reference" | "date" | "status" | "value";

export type GetCombinedOrdersReportOrderDirection = "asc" | "desc";

export type AdvanceStatus = "pendingApproval" | "open" | "closed" | "cancelled" | "pdd";

export type AdvanceChargeType = "foodAndBeverage" | "ticket" | "both";

export type AdvancePaymentMode = "manual" | "asAvailable";

export type AdvanceInterestType = "simple" | "compound" | "manual" | "mixed";

export type AdvanceChargeStatus = "pending" | "paid" | "cancelled";

export type AdvanceChargePaymentType = "automatic" | "manual" | "ticket";

export type AdvanceDocumentType = "contract" | "addendum" | "renegotiation" | "other" | "feasibility" | "payment" | "partnerDocuments" | "foodAndBeverageContract" | "ticketContract";

export type AdvancePlaceBindingType = "manual" | "automatic";

export type AdvanceRequestStatus = "pending" | "analyzing" | "approved" | "rejected";

export type AdvanceRequestVenueType = "event" | "venue";

export type AdvanceRequestDocumentType = "borderos" | "socialContract" | "feasibilityStudies" | "contracts" | "partnerDocuments" | "other";

export type EventState = "Created" | "Finished" | "Running" | "Canceled";

export type ClosingEventConferenceStatus = "pending" | "sent";

export type TransferReason = "PPUTransaction" | "PostTransactionOnline" | "PostTransactionInPlace" | "RechargeInPlace" | "RechargeInApp" | "PreTransaction" | "PreTransactionWithPlaceCredit" | "PreTransactionWithPlaceCreditFromOtherEvent" | "BonusTransaction" | "RefundedTransaction" | "PaidPostPaidTransactionsInPlace";

export type ReportType = "Waiter" | "Stock" | "GeneralEmployee" | "Cashier" | "Bar";

export type CpfOrPhoneType = "cpf" | "phone";

export type TimelineEventType = "Recharge" | "Transaction" | "PostPayment";

export type GuinnessLogType = "checkin" | "checkout";

export type ApplySuggestedImageForProductType = "product" | "combo";

export type GetBackofficeCashFlowV2GroupBy = "day" | "month";

export type GetInvoicesBySearchValueCountry = "mx" | "pt" | "es";

export type GetPlaceProductsByTypeOrderBy = "name" | "fiscalCode" | "category";

export type GetPlaceProductsByTypeOrder = "asc" | "desc";

export type ExportPlaceProductsByTypeOrderBy = "name" | "fiscalCode" | "category";

export type ExportPlaceProductsByTypeOrder = "asc" | "desc";

export type VerifyPatchProductsType = "create" | "edit";

export type GetBackofficeProductStorageHistoryXlsFilterBy = "interval" | "events";

export type GetBackofficeProductionHistoryForProductsOrderBy = "createdAt" | "storage" | "outputCount" | "name";

export type GetBackofficeProductionHistoryForProductsOrder = "asc" | "desc";

export type ExportBackofficeProductionHistoryForProductsOrderBy = "createdAt" | "storage" | "outputCount" | "name";

export type ExportBackofficeProductionHistoryForProductsOrder = "asc" | "desc";

export type GetBackofficeTransfersBetweenStoragesOrderBy = "date" | "fromStorage" | "toStorage";

export type GetBackofficeTransfersBetweenStoragesOrder = "asc" | "desc";

export type ExportBackofficeTransfersBetweenStoragesOrderBy = "date" | "fromStorage" | "toStorage";

export type ExportBackofficeTransfersBetweenStoragesOrder = "asc" | "desc";

export type GetBackofficeStorageInventoriesOrderBy = "storage" | "name" | "status" | "createdAt";

export type GetBackofficeStorageInventoriesOrder = "asc" | "desc";

export type GetBackofficeStorageInventoryAndStorageComparisonOrder = "asc" | "desc";

export type GetBackofficeStorageInventoryAndStorageComparisonOrderBy = "name" | "category" | "fiscalCode" | "basicStorageUnit" | "storageInventoryCount" | "storageCount" | "averageUnitCostValue" | "difference";

export type ExportBackofficeStorageInventoryAndStorageComparisonOrder = "asc" | "desc";

export type ExportBackofficeStorageInventoryAndStorageComparisonOrderBy = "name" | "category" | "fiscalCode" | "basicStorageUnit" | "storageInventoryCount" | "storageCount" | "averageUnitCostValue" | "difference";

export type ExportBackofficeStorageInventoryAndStorageComparisonPdfOrder = "asc" | "desc";

export type ExportBackofficeStorageInventoryAndStorageComparisonPdfOrderBy = "name" | "category" | "fiscalCode" | "basicStorageUnit" | "storageInventoryCount" | "storageCount" | "averageUnitCostValue" | "difference";

export type GetBackofficeStorageInventoryTopInconsistenciesType = "unitCost" | "quantity";

export type GetCdpDashboardKpisTimeSeriesGroupBy = "week" | "month";

export type GetCdpAudienceMetricsTimeSeriesGroupBy = "week" | "month";

export type GetCdpRfmDistributionTimeSeriesGroupBy = "week" | "month";

export type GetAutomaticWithdrawHistoryDataType = "vendor" | "place";

export interface ProductEmissionTestDataProducts {
    productId: string
    error: string
}

export interface ProductEmissionTestData {
    products: ProductEmissionTestDataProducts[]
}

export interface AddressFromCep {
    tipo: AddressFromCepTipo | null
    cep: string
    logradouro: string
    bairro: string | null
    estado: string
    cidade: string
    uf: string
    codigoMunicipio: string | null
    pais: string | null
}

export interface Address {
    numero: string
    complemento: string | null
    tipo: AddressFromCepTipo | null
    cep: string
    logradouro: string
    bairro: string | null
    estado: string
    cidade: string
    uf: string
    codigoMunicipio: string | null
    pais: string | null
}

export interface AdyenCard {
    encryptedCardNumber: string | null
    encryptedExpiryMonth: string | null
    encryptedExpiryYear: string | null
    encryptedSecurityCode: string | null
    brand: string | null
    type: string | null
    holderName: string | null
    checkoutAttemptId: string | null
    storedPaymentMethodId: string | null
    googlePayToken: string | null
    applePayToken: string | null
}

export interface AdyenCardPayment {
    card: AdyenCard
    address: Address | null
    shopperReference: string | null
}

export interface AdyenSession {
    id: string
    data: string
    paymentMethods: string | null
}

export interface AdyenPaymentSessionRequest {
    amountValue: number | null
    amountCurrency: string | null
}

export interface BackofficeNewStorage {
    name: string
}

export interface BackofficeStorage {
    isCentral: boolean
    placeId: string | null
    id: string
    name: string
}

export interface BackofficeStorageWithResumeBar {
    id: string
    name: string
    internalIps: string[]
}

export interface BackofficeStorageWithResume {
    isCentral: boolean
    placeId: string | null
    id: string
    name: string
    productsCount: number
    totalCost: string
    createdAt: Date
    attachedBars: BackofficeStorageWithResumeBar[]
}

export interface BackofficeStorageProduct {
    id: string
    count: number
}

export interface BackofficeInput {
    productId: string
    storageId: string
    unitCostValue: number | null
    obs: string | null
    count: number
    date: Date
}

export interface BackofficeInputV2 {
    productId: string
    storageId: string
    unitCostValue: string | null
    obs: string | null
    count: number
    date: Date
}

export interface BackofficeInputsResultV2Error {
    input: BackofficeInputV2
    reason: string
}

export interface BackofficeInputsResultV2 {
    success: BackofficeInputV2[]
    error: BackofficeInputsResultV2Error[]
}

export interface BackofficeInputsResultError {
    input: BackofficeInput
    reason: string
}

export interface BackofficeInputsResult {
    success: BackofficeInput[]
    error: BackofficeInputsResultError[]
}

export interface BackofficeDeleteProductsResultError {
    productId: string
    reason: string
}

export interface BackofficeDeleteProductsResult {
    success: string[]
    error: BackofficeDeleteProductsResultError[]
}

export interface BackofficeStorageHistoryV3TransfersTargetProductionProduct {
    id: string
    name: string
}

export interface BackofficeStorageHistoryV3Transfers {
    date: Date
    type: BackofficeStorageTransferType
    count: number
    remainingCount: number | null
    employeeId: string | null
    employeeName: string | null
    employeeUsername: string | null
    unitCostValue: string | null
    referenceCode: string | null
    obs: string | null
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    remainingCountByProportionOfUnit: ConvertedProportionOfUnit | null
    targetProductionProduct: BackofficeStorageHistoryV3TransfersTargetProductionProduct | null
}

export interface BackofficeStorageHistoryV3 {
    currentPage: number | null
    initial: number
    totalTransfersItems: number
    transfers: BackofficeStorageHistoryV3Transfers[]
}

export interface BackofficeStorageProductsHistoryV3 {
    productName: string | null
    fiscalCode: string | null
    hasProductionRule: boolean | null
    basicStorageUnit: BasicStorageUnit
    proportionOfUnit: ProportionOfUnit | null
    productId: string
    history: BackofficeStorageHistoryV3
}

export interface BackofficeImportedInvoiceRestriction {
    supplierDocument: string
}

export interface BackofficeImportedInvoiceProductInvoiceEntry {
    index: number
    code: string
    description: string
    commercialUnit: string
    commercialQuantity: number
    unitValue: number
    EAN: string | null
    totalValue: number
    icmsStValue: number | null
    icmsStAliquot: number | null
    icmsStBase: number | null
    icmsFcpStValue: number | null
    ipiValue: number | null
    ipiAliquot: number | null
    ipiBase: number | null
    shippingValue: number | null
    otherExpensesValue: number | null
    discountValue: number | null
    insuranceValue: number | null
}

export interface BackofficeInvoiceDuplicate {
    id: string | null
    code: string | null
    dueDate: Date | null
    performDate: Date
    value: number
}

export interface BackofficeImportedInvoiceProduct {
    entryId: string
    pending: boolean
    skipped: boolean
    associatedProduct: Product | null
    chartAccountId: string | null
    unitValue: string
    unitMultiplier: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    commercialQuantity: number
    hasChangedCommercialQuantity: boolean
    invoiceEntry: BackofficeImportedInvoiceProductInvoiceEntry
}

export interface BackofficeAddress {
    street: string
    number: string
    complemento: string | null
    cep: string
    state: string
    city: string
    neighborhood: string
}

export interface BackofficeBankAccount {
    bank: string
    account: string
    agency: string
    cpfOrCnpj: string
    ownerName: string
}

export interface BackofficeBaseSupplier {
    name: string
    legalName: string | null
    inscricaoEstadual: string | null
    cpfOrCnpj: string | null
    address: BackofficeAddress | null
    bankAccount: BackofficeBankAccount | null
    billPlanCategoryId: string | null
    registerType: BackofficeSupplierRegisterType | null
    chartAccountId: string | null
    organizationId: string | null
    pixKeyType: PixKeyTypeDto | null
    pixKey: string | null
}

export interface BackofficeInvoiceSupplier {
    name: string
    legalName: string | null
    inscricaoEstadual: string | null
    cpfOrCnpj: string | null
    address: BackofficeAddress | null
    bankAccount: BackofficeBankAccount | null
    billPlanCategoryId: string | null
    registerType: BackofficeSupplierRegisterType | null
    chartAccountId: string | null
    organizationId: string | null
    pixKeyType: PixKeyTypeDto | null
    pixKey: string | null
    id: string
}

export interface BackofficeImportedProductsFromInvoicesProduct {
    entryId: string
    associatedProduct: Product | null
    chartAccountId: string | null
    unitValue: string
    unitMultiplier: number
    invoiceEntry: BackofficeImportedInvoiceProductInvoiceEntry
    skipped: boolean
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    commercialQuantity: number
    hasChangedCommercialQuantity: boolean
}

export interface BackofficeImportedProductsFromInvoices {
    invoiceId: string
    num: number
    serie: number
    supplierName: string
    supplierCpfOrCnpj: string
    processedAt: Date | null
    createdAt: Date
    storageId: string | null
    date: Date
    inputDate: Date | null
    product: BackofficeImportedProductsFromInvoicesProduct
}

export interface BackofficeImportedInvoiceBill {
    accountId: string | null
    createBill: boolean
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
}

export interface BackofficeImportedInvoiceDetailsSupplier {
    name: string
    cpfOrCnpj: string
}

export interface BackofficeImportedInvoiceDetailsTaxs {
    icmsBase: number
    icmsValue: number
    icmsstBase: number
    icmsstValue: number
    ipiValue: number
}

export interface BackofficeImportedInvoiceDetails {
    num: number
    serie: number
    operationType: string | null
    accessKey: string | null
    date: Date
    supplier: BackofficeImportedInvoiceDetailsSupplier
    totalValue: number
    totalProductsValue: number
    taxs: BackofficeImportedInvoiceDetailsTaxs
    insuranceValue: number
    discountValue: number
    otherExpensesValue: number
    shippingValue: number
    cfop: number | null
}

export interface BackofficeImportedInvoiceSupplierInvoiceEntry {
    cpfOrCnpj: string
    name: string
    legalName: string | null
    inscricaoEstadual: string | null
    address: BackofficeAddress | null
}

export interface BackofficeImportedInvoiceSupplier {
    pending: boolean
    skipped: boolean
    associatedSupplier: BackofficeInvoiceSupplier | null
    invoiceEntry: BackofficeImportedInvoiceSupplierInvoiceEntry | null
}

export interface BackofficeImportedInvoice {
    id: string
    createdAt: Date
    xml: string | null
    completed: boolean
    storageId: string | null
    bill: BackofficeImportedInvoiceBill
    details: BackofficeImportedInvoiceDetails
    supplier: BackofficeImportedInvoiceSupplier
    products: BackofficeImportedInvoiceProduct[]
    duplicates: BackofficeInvoiceDuplicate[]
    processedAt: Date | null
    inputDate: Date | null
}

export interface BackofficeProductCmvInputs {
    productId: string
    count: number
    unitCostValue: string | null
    realUnitCostValue: string | null
    isCompound: boolean
}

export interface BackofficeProductCmv {
    productId: string
    unitCostValue: string | null
    realUnitCostValue: string | null
    absolutePopularity: number | null
    relativePopularity: number | null
    soldCount: number
    inputs: BackofficeProductCmvInputs[]
}

export interface BackofficeProductCmvWithQuantity {
    productId: string
    unitCostValue: string | null
    realUnitCostValue: string | null
    absolutePopularity: number | null
    relativePopularity: number | null
    soldCount: number
    inputs: BackofficeProductCmvInputs[]
    quantity: number
}

export interface BackofficeProductSimpleCmv {
    productId: string
    unitCostValue: string | null
    realUnitCostValue: string | null
    absolutePopularity: number | null
    relativePopularity: number | null
}

export interface PixKeyDto {
    value: string
    type: PixKeyTypeDto
}

export interface BankAccountReceiverDto {
    bank: string
    account: string
    agency: string
    name: string
    documentNumber: string
    accountType: BankAccountReceiverTypeDto
    documentType: BankAccountDocumentTypeDto
}

export interface BankAccountDto {
    holder: string
    name: string
    pixKey: PixKeyDto | null
    receiver: BankAccountReceiverDto | null
    isDefault: boolean
}

export interface BankAccountResponse {
    id: string
    createdAt: Date
    updatedAt: Date
    holder: string
    name: string
    pixKey: PixKeyDto | null
    receiver: BankAccountReceiverDto | null
    isDefault: boolean
}

export interface BankAccountRequestPixKey {
    value: string
    type: PixKeyTypeDto | null
}

export interface BankAccountRequestReceiver {
    bank: string
    account: string
    agency: string
    name: string
    documentNumber: string
    accountType: BankAccountReceiverTypeDto
}

export interface BankAccountRequest {
    holder: string
    name: string
    pixKey: BankAccountRequestPixKey | null
    receiver: BankAccountRequestReceiver | null
    isDefault: boolean
}

export interface Attachment {
    name: string
    bytes: ArrayBuffer
}

export interface BankCodeResponse {
    ispb: string
    name: string
    code: number | null
    fullName: string
}

export interface CostOfGoodsSoldSupplies {
    id: string
    name: string
    quantity: number
    unitCost: string | null
    realCost: string | null
    isCompound: boolean
}

export interface CostOfGoodsSold {
    id: string
    name: string
    supplies: CostOfGoodsSoldSupplies[]
    resellingPrice: number
    productUnitCost: string | null
    productRealCost: string | null
    relativePopularity: number | null
    absolutePopularity: number | null
}

export interface CmvReportProduct {
    id: string
    productName: string
    productCategory: string
    fiscalCode: string
    ncm: string | null
    count: number
    totalValue: string
    totalDiscount: string
    productUnitCost: string | null
}

export interface CmvReportMountables {
    id: string
    name: string
    count: number
    section: string
    productUnitCost: string | null
}

export interface CmvReport {
    id: string
    productName: string
    productCategory: string
    fiscalCode: string
    ncm: string | null
    count: number
    totalValue: string
    totalDiscount: string
    productUnitCost: string | null
    mountables: CmvReportMountables[]
}

export interface EventOperationExpenseCategoryTypeCategory {
    name: EventOperationExpenseCategory
    types: EventOperationExpenseType[] | null
}

export interface EventOperationExpenseCategoryType {
    category: EventOperationExpenseCategoryTypeCategory
}

export interface EventOperationExpense {
    eventOperationId: string
    category: EventOperationExpenseCategory
    role: string | null
    setupDays: number | null
    operationDays: number | null
    operatorsCount: number | null
    hours: number | null
    minutes: number | null
    responsible: string | null
    categoryExpense: string | null
    defaultValueLogisticExpense: boolean | null
    value: number | null
    cardsAndBraceletsTypes: string | null
    initialQty: number | null
    qtyExchangeByProduct: number | null
    finalQty: number | null
    categoryOthersExpense: string | null
    qtyExpense: number | null
    equipment: string | null
    breakdown: string | null
    breakage: string | null
    qtyEquipments: number | null
    othersUsedEquipmentsType: string | null
    description: string | null
    pointOfSales: string | null
    pointOfSalesType: string | null
    equipmentUse: string | null
    advanceFee: number | null
}

export interface EventOperationExpenseTranslatedField {
    id: string
    name: string
}

export interface EventOperationExpenseRequest {
    eventOperationId: string
    category: EventOperationExpenseCategory
    role: string | null
    setupDays: number | null
    operationDays: number | null
    operatorsCount: number | null
    hours: number | null
    minutes: number | null
    responsible: string | null
    categoryExpense: string | null
    defaultValueLogisticExpense: boolean | null
    value: number | null
    cardsAndBraceletsTypes: string | null
    initialQty: number | null
    qtyExchangeByProduct: number | null
    finalQty: number | null
    categoryOthersExpense: string | null
    qtyExpense: number | null
    equipment: string | null
    breakdown: string | null
    breakage: string | null
    qtyEquipments: number | null
    othersUsedEquipmentsType: string | null
    description: string | null
    pointOfSales: string | null
    pointOfSalesType: string | null
    equipmentUse: string | null
    advanceFee: number | null
    attachments: Attachment[] | null
}

export interface EventOperationExpenseResponse {
    id: string
    eventOperationId: string
    category: EventOperationExpenseCategory
    role: EventOperationExpenseTranslatedField | null
    setupDays: number | null
    operationDays: number | null
    operatorsCount: number | null
    hours: number | null
    minutes: number | null
    responsible: EventOperationExpenseTranslatedField | null
    categoryExpense: EventOperationExpenseTranslatedField | null
    defaultValueLogisticExpense: boolean | null
    value: number | null
    cardsAndBraceletsTypes: EventOperationExpenseTranslatedField | null
    initialQty: number | null
    qtyExchangeByProduct: number | null
    finalQty: number | null
    categoryOthersExpense: EventOperationExpenseTranslatedField | null
    qtyExpense: number | null
    equipment: string | null
    breakdown: EventOperationExpenseTranslatedField | null
    breakage: EventOperationExpenseTranslatedField | null
    qtyEquipments: number | null
    othersUsedEquipmentsType: EventOperationExpenseTranslatedField | null
    description: string | null
    attachments: AttachmentResponse[] | null
    createdBy: string | null
    pointOfSales: string | null
    pointOfSalesType: EventOperationExpenseTranslatedField | null
    equipmentUse: EventOperationExpenseTranslatedField | null
    advanceFee: number | null
}

export interface FieldsExpenseCategories {
    id: string
    name: string | null
    type: string
    index: number
    options: ExpenseCategoriesFieldOption[] | null
}

export interface ExpenseCategoriesFieldOption {
    id: string
    name: string | null
}

export interface EventOperationExpenseFormFieldsResponse {
    id: EventOperationExpenseCategory
    name: string | null
    index: number
    fields: FieldsExpenseCategories[] | null
}

export interface EventOperation {
    name: string
    placeId: string
    operationId: string | null
    beginAt: Date
    endAt: Date
}

export interface EventOperationRequest {
    name: string
    placeId: string
    operationId: string | null
    beginAt: Date
    endAt: Date
}

export interface EventOperationResponse {
    name: string
    placeId: string
    events: EventOperationEvent[]
    id: string
    status: EventOperationStatus
    beginAt: Date
    endAt: Date
    reproved: boolean
    operationId: string | null
}

export interface EventOperationCompleteResponse {
    name: string
    placeId: string
    events: EventOperationEvent[]
    id: string
    status: EventOperationStatus
    beginAt: Date
    endAt: Date
    reproved: boolean
    operationId: string | null
    placeName: string
    locationName: string
    organizationName: string
    organizationId: string
    isKeyAccount: boolean
    createdBy: string
    createdAt: Date
    contractNumber: number | null
    customerName: string | null
    customerDocument: string | null
    hasExpenses: boolean
    isHouse: boolean
    executiveName: string | null
}

export interface EventOperationExpensesByCategory {
    category: EventOperationExpenseCategory
    expenses: EventOperationExpenseResponse[]
}

export interface EventOperationFilter {
    key: string
    values: string[]
}

export interface EventOperationEventSize {
    id: string
    name: string
}

export interface EventOperationEventSizeType {
    id: string
    name: string
    defaultFreightValue: number | null
    index: number
}

export interface UpdateEventOperationEventSizeRequest {
    eventOperationId: string
    eventOperationEventSizeId: string
}

export interface EventOperationEventsResponse {
    placeId: string
    events: EventOperationEvent[]
}

export interface EventOperationEvent {
    id: string
    name: string
    beginAt: Date
}

export interface ApproveEventOperationRequest {
    eventOperationId: string
}

export interface RejectEventOperationRequest {
    eventOperationId: string
    description: string
}

export interface EventOperationHistory {
    date: Date
    status: string
    observation: string | null
    createdBy: string
    financialAnalysisDocumentUrl: string | null
    financialClosingResponse: RequestClosingOfEventOperationResponse | null
}

export interface EventOperationFinancialDocumentUploaded {
    eventOperationId: string
    url: string
    fileKey: string
}

export interface EventOperationOperation {
    id: string
    dealName: string
    dealId: string
}

export interface RequestClosingOfEventOperationResponseSummary {
    totalIntegratedAcquirer: number
    totalNonIntegratedAcquirer: number
    totalZigInvoice: number
    totalWithdrawals: number
    finalBalance: number
}

export interface RequestClosingOfEventOperationResponse {
    placeName: string
    eventOperationBeginAt: Date
    eventOperationEndAt: Date
    contractNumber: number
    platform: string
    locationOffice: string
    locationCountry: string
    placeId: string
    organizationId: string
    organizationName: string
    currency: string | null
    clientCorporateName: string | null
    clientDocument: string | null
    zigDocument: string
    zigName: string
    zigAddress: string
    eventType: string
    finderName: string
    eventBillingType: string
    eventModel: string
    automaticRepayment: boolean
    contractStartDate: Date
    contractEndDate: Date
    ownerId: number | null
    clientCode: number | null
    eventsStartAt: Date | null
    eventsEndAt: Date | null
    isHouse: boolean | null
    zigFee: number | null
    totalProcessedValue: number
    futureFinancialEntries: RequestClosingOfEventOperationFutureFinancialEntry[] | null
    zigInvoice: EventOperationClosingGroup[]
    zigInvoiceSummary: EventOperationClosingGroupSummary[]
    adjustsWithUnitValue: RequestClosingOfEventOperationAdjustsWithUnitValue[] | null
    summary: RequestClosingOfEventOperationResponseSummary
}

export interface RequestClosingOfEventOperationAdjustsWithUnitValue {
    category: string
    obs: string
    value: number
    unitValue: number | null
    skipped: boolean | null
}

export interface RequestClosingOfEventOperationFutureFinancialEntry {
    groupId: string | null
    groupName: string | null
    typeId: string
    typeName: string
    categoryId: string | null
    categoryName: string | null
    referenceDate: Date | null
    originalPayDate: Date | null
    value: number | null
    obs: string | null
}

export interface EventOperationClosingGroup {
    id: string
    name: string
    total: number
    types: EventOperationClosingGroupEntry[]
    parentGroupId: string | null
    sortOrder: number
    groups: EventOperationClosingGroup[]
}

export interface EventOperationClosingGroupSummary {
    id: string
    name: string
    total: number
}

export interface EventOperationClosingGroupEntry {
    id: string
    name: string
    value: number
    obs: string | null
}

export interface EventOperationUsedEquipmentRequest {
    eventOperationId: string
    eventId: string | null
    eventDate: Date | null
    qtyEquipments: number
    attachment: Attachment | null
    equipmentType: EquipmentType | null
}

export interface EventOperationUsedEquipmentResponse {
    id: string | null
    eventOperationId: string
    eventId: string | null
    eventDate: Date | null
    eventName: string | null
    qtyEquipments: number | null
    attachment: AttachmentResponse | null
    equipmentType: EquipmentType | null
    unitValue: number | null
    bonusQty: number | null
    netQty: number | null
    periodicity: EquipmentBillingPeriodicity | null
    total: number | null
    createdBy: string | null
    createdAt: Date | null
    updatedAt: Date | null
}

export interface EventOperationUsedEquipmentBatch {
    eventOperationId: string
    equipments: EventOperationUsedEquipmentItem[]
}

export interface EventOperationUsedEquipmentItem {
    eventId: string | null
    eventDate: Date | null
    qtyEquipments: number
    attachment: Attachment | null
    equipmentType: EquipmentType | null
}

export interface EventOperationUsedEquipmentListResponse {
    eventOperationId: string
    equipments: EventOperationUsedEquipmentResponse[]
}

export interface ChargeError {
    kind: ChargeErrorKind
    rawValue: string | null
    message: string
}

export interface OperationChargePreview {
    section: number
    subcategory: string | null
    description: string | null
    sourceRowId: string | null
    financialCategory: string
    type: ChargeType
    periodicity: EquipmentBillingPeriodicity | null
    equipmentType: EquipmentType | null
    unitValue: number | null
    grossQuantity: number | null
    bonifiedQuantity: number | null
    netQuantity: number | null
    total: number | null
    status: ChargeStatus
    error: ChargeError | null
}

export interface OperationChargesPreviewResponse {
    eventOperationId: string
    isHouse: boolean
    charges: OperationChargePreview[]
    grandTotal: number
    hasBlockingErrors: boolean
    calculatedAt: Date
    contractLastUpdatedAt: Date | null
}

export interface BaseEmployeeBars {
    id: string
    isMainBar: boolean
    shouldPrint: boolean
}

export interface BaseEmployee {
    name: string
    zigReadPermissionKey: string | null
    permissions: Permission[]
    role: Role | null
    places: string[]
    bars: BaseEmployeeBars[]
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
    password: string | null
    isPDV: boolean | null
}

export interface NewEmployee {
    name: string
    zigReadPermissionKey: string | null
    permissions: Permission[]
    role: Role | null
    places: string[]
    bars: BaseEmployeeBars[]
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
    password: string | null
    isPDV: boolean | null
    username: string
}

export interface EditEmployee {
    name: string
    zigReadPermissionKey: string | null
    permissions: Permission[]
    role: Role | null
    places: string[]
    bars: BaseEmployeeBars[]
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
    password: string | null
    isPDV: boolean | null
}

export interface MultipleEmployeesBars {
    id: string
    isMainBar: boolean
    shouldPrint: boolean
}

export interface MultipleEmployees {
    username: string
    name: string
    barId: string | null
    bars: MultipleEmployeesBars[]
    placeIds: string[]
    since: number | null
    until: number | null
    permissions: Permission[]
    role: Role | null
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
}

export interface AddMultipleEmployees {
    success: string[]
    errors: string[]
}

export interface MinimalEmployee {
    id: string
    name: string
    username: string | null
    avatar: ImageUrl | null
}

export interface AdjustRequest {
    value: number
    obs: string | null
    payDate: Date
    costCenter: string | null
    billType: string | null
    date: Date
    category: AdjustCategory | null
}

export interface AdjustResponse {
    id: string
    isWithdrawn: boolean
    value: number
    obs: string | null
    payDate: Date
    costCenter: string | null
    billType: string | null
    date: Date
    category: AdjustCategory | null
}

export interface ExtractAdjustPaymentLink {
    id: string
    url: string
    status: string
}

export interface InsertExtractAdjustResult {
    id: string
    isWithdrawn: boolean
    value: number
    obs: string | null
    payDate: Date
    costCenter: string | null
    billType: string | null
    date: Date
    category: AdjustCategory | null
    paymentLink: ExtractAdjustPaymentLink | null
}

export interface DayResume {
    date: Date
    withdrew: number
    in: number
    out: number
}

export interface ExtractResume {
    available: number
    availableInTwoDays: number
    toBeReleased: number
    availableInMoreThanOneMonth: number
    retainedValues: RetainedValues
    netValueAvailableToWithdraw: number
    grossValueAvailabletoAnticipate: number
    netValueAvailableToAnticipate: number
    totalRetainedWithdrawValue: number
}

export interface Fee {
    zigMachineCredit: number
    zigMachineDebit: number
    inHouse: number
    app: number
    rechargeRemainings: number
    bonus: number
    minimumConsumption: number
}

export interface RechargeAvailable {
    id: string
    user: string
    totalValue: number
    usedValue: number
    createdAt: Date
    expiredAt: Date
    fee: number
    availableValue: number
    withdrew: number
}

export interface RechargeExpireResume {
    toBeAvailable: number
    rechargesAvailable: number
}

export interface ExtractDayResumeSectionValues {
    modality: string
    totalValue: number
    tax: number | null
    payValue: number
}

export interface ExtractDayResumeSection {
    title: string
    description: string | null
    tooltip: string | null
    date: Date | null
    values: ExtractDayResumeSectionValues[]
}

export interface RechargeExpireDayResume {
    expired: number
    date: Date
    toExpire: number
}

export interface BankPaymentSlipInfo {
    beneficiary: string | null
    barCode: string | null
    dueDate: Date | null
}

export interface WithdrawBankAccount {
    id: string
    name: string
}

export interface WithdrawEmployee {
    id: string
    name: string
    username: string
}

export interface WithdrawVendor {
    id: string
    name: string
    username: string
}

export interface Withdraw {
    id: string
    type: WithdrawType
    date: Date
    status: WithdrawStatus
    anticipationFee: number | null
    paymentMethod: string | null
    clientObservation: string | null
    obs: string | null
    proRataFee: number | null
    withdrawValue: number
    anticipationValue: number
    attachments: string[] | null
    bankPaymentSlipInfo: BankPaymentSlipInfo | null
    bankAccount: WithdrawBankAccount | null
    employee: WithdrawEmployee | null
    vendor: WithdrawVendor | null
}

export interface ConsolidatedExtract {
    sections: ConsolidatedExtractSection[]
    availableValue: number
    withdrewValue: number
    anticipatedValue: number
}

export interface ConsolidatedExtractSectionValues {
    title: string
    hideIfZero: boolean
    totalValueUnit: ConsolidatedExtractSectionValuesTotalValueUnit
    totalValue: number | null
    maxFee: number | null
    minFee: number | null
    payValue: number
    highlighted: boolean
}

export interface ConsolidatedExtractSection {
    title: string
    description: string
    values: ConsolidatedExtractSectionValues[]
}

export interface ExtractFlowRow {
    id: string
    date: Date
    title: string
    value: number
    balance: number
    competency: Date
}

export interface DebitNote {
    id: string
    placeId: string
    status: DebitNoteStatus
    value: number
    since: Date
    until: Date
    generatedAs: DebitNoteGeneratedAs
    pdf: string | null
    serialNumber: number
}

export interface DebitNoteWithPlace {
    id: string
    placeId: string
    status: DebitNoteStatus
    value: number
    since: Date
    until: Date
    generatedAs: DebitNoteGeneratedAs
    pdf: string | null
    serialNumber: number
    placeName: string
    isPlaceRegistered: boolean
}

export interface RentNote {
    id: string
    placeId: string
    status: RentNoteStatus
    value: number
    since: Date
    until: Date
    generatedAs: RentNoteGeneratedAs
    pdf: string | null
    serialNumber: number
}

export interface RentNoteWithPlace {
    id: string
    placeId: string
    status: RentNoteStatus
    value: number
    since: Date
    until: Date
    generatedAs: RentNoteGeneratedAs
    pdf: string | null
    serialNumber: number
    placeName: string
    isPlaceRegistered: boolean
}

export interface RetainedValuesVendor {
    withdraw: number
    anticipation: number
    pendingWithdraw: number
    pendingAnticipation: number
}

export interface RetainedValues {
    vendor: RetainedValuesVendor
    twentyPercent: number
}

export interface BaseFinancialChargeConfig {
    placeId: string
    value: number
    category: AdjustCategory
    name: string
    productCount: number
    recurrence: BaseFinancialChargeConfigRecurrence
    validSince: Date
    validUntil: Date | null
}

export interface FinancialChargeConfig {
    id: string
    placeId: string
    value: number
    category: AdjustCategory
    name: string
    productCount: number
    recurrence: BaseFinancialChargeConfigRecurrence
    validSince: Date
    validUntil: Date | null
}

export interface FinancialExtractBlockPlace {
    id: string
    name: string
}

export interface FinancialExtractBlockCreatedByAdmin {
    id: string
    name: string
}

export interface FinancialExtractBlockReleaseAdmin {
    id: string
    name: string
}

export interface FinancialExtractBlock {
    id: string
    place: FinancialExtractBlockPlace
    createdByAdmin: FinancialExtractBlockCreatedByAdmin | null
    type: FinancialExtractBlockType
    date: Date
    value: number
    reason: string
    isReleased: boolean
    releaseDate: Date | null
    releaseAdmin: FinancialExtractBlockReleaseAdmin | null
    blockType: string | null
    blockCategory: string | null
    blockObservation: string | null
    canBeReleased: boolean | null
    receivableCompetenceDate: Date | null
    receivableLiquidationDate: Date | null
    receivableType: FinancialExtractBlockReceivableType | null
}

export interface IssueResult {
    issuedInvoices: Invoice[]
    errors: string[]
    failedInvoiceCount: number
}

export interface InvoiceJsonOrgAddress {
    logradouro: string
    numero: string
    cep: string
    bairro: string
    municipio: string
}

export interface InvoiceJsonOrg {
    cnpj: string
    razaoSocial: string
    inscricaoEstadual: string
    address: InvoiceJsonOrgAddress
}

export interface InvoiceJsonDest {
    name: string | null
    cpf: string | null
    cnpj: string | null
}

export interface InvoiceJsonProducts {
    codigo: string
    name: string
    value: number
    discountValue: number
    count: number
    ncm: string | null
    cfop: string | null
    code: string | null
    origem: string | null
    cst: string | null
    csosn: string | null
    aliquota: string | null
}

export interface InvoiceJsonPayments {
    value: number
    type: string
}

export interface InvoiceJson {
    title: string
    accessKey: string
    number: string
    serial: string
    qrcodeUrl: string
    date: Date
    org: InvoiceJsonOrg
    dest: InvoiceJsonDest | null
    products: InvoiceJsonProducts[]
    tributeInfo: string | null
    payments: InvoiceJsonPayments[]
}

export interface Permission {
    name: string
    slug: string
    type: string | null
    isManagerial: boolean | null
    isPaymentMethod: boolean | null
}

export interface ChildPermission {
    name: string
    slug: string
    type: string | null
    isManagerial: boolean | null
    isPaymentMethod: boolean | null
    parent: string | null
}

export interface Role {
    permissions: ChildPermission[]
    name: string
    slug: string
    isBase: boolean
}

export interface SimplifiedRolePermissions {
    name: string
    slug: string
}

export interface SimplifiedRole {
    permissions: SimplifiedRolePermissions[]
    name: string
    slug: string
}

export interface BasePrechargeOperationRechargesPeriod {
    since: Date
    until: Date
}

export interface BasePrechargeOperationMainPageInfo {
    title: string
    subTitle: string
}

export interface BasePrechargeOperationRechargesLimit {
    minimumValue: number
    maximumValuePerUser: number
}

export interface BasePrechargeOperation {
    placeId: string
    name: string
    email: string
    slug: string
    endsAt: Date
    rechargesPeriod: BasePrechargeOperationRechargesPeriod
    primaryColor: string
    mainPageInfo: BasePrechargeOperationMainPageInfo
    rechargesLimit: BasePrechargeOperationRechargesLimit
    preSetedValues: number[]
    bonus: PrechargeOperationBonus[]
    paymentMethods: PrechargeOperationPaymentMethod[]
    tips: PrechargeOperationTip[]
}

export interface PrechargeOperationBonus {
    value: number
    bonusValue: number
    type: PrechargeOperationBonusType
}

export interface PrechargeOperationTip {
    title: string
    description: string
}

export interface PrechargeOperation {
    placeId: string
    name: string
    email: string
    slug: string
    endsAt: Date
    rechargesPeriod: BasePrechargeOperationRechargesPeriod
    primaryColor: string
    mainPageInfo: BasePrechargeOperationMainPageInfo
    rechargesLimit: BasePrechargeOperationRechargesLimit
    preSetedValues: number[]
    bonus: PrechargeOperationBonus[]
    paymentMethods: PrechargeOperationPaymentMethod[]
    tips: PrechargeOperationTip[]
    id: string
    logoUrl: string | null
    mainImageUrl: string | null
}

export interface PrechargesFilters {
    placeIds: string[]
    period: PeriodTime | null
    document: string | null
    paymentId: string | null
    isUsed: boolean | null
    status: PrechargeStatus[]
    email: string | null
    acquirerTransactionId: string | null
    name: string | null
    paymentMethod: PrechargeOperationPaymentMethod | null
}

export interface Precharge {
    pendingOnlineRechargeId: string
    name: string
    document: string
    date: Date
    placeName: string
    value: number
    liability: boolean
    score: number | null
    paymentMethod: string
    bonusValue: number
    cardSummary: string | null
    status: PrechargeStatus
    isUsed: boolean
    cardBrand: string | null
    email: string | null
    acquirerTransactionId: string | null
}

export interface ProportionOfUnit {
    quantity: number
    basicStorageUnit: BasicStorageUnit
}

export interface ConvertedProportionOfUnit {
    unitQuantity: number
    originalUnitQuantity: number
    proportionOfUnit: ProportionOfUnit
}

export interface ProductSoldMountableProducts {
    id: string
    name: string
    count: number
    section: string
    storageCount: number
}

export interface ProductSold {
    id: string
    name: string
    category: string
    image: ImageUrl | null
    count: number
    type: SellableThing
    totalValue: number
    totalDiscount: number
    fiscalCode: string
    mountableProducts: ProductSoldMountableProducts[]
    isMountable: boolean | null
    productUnitCost: string | null
    proportionalValue: ProportionalValue | null
    estimatedTax: number | null
    isReturnable: boolean | null
}

export interface ProductBarReportProducts {
    transactionId: string
    id: string
    name: string
    image: ImageUrl | null
    proportionalValue: ProportionalValue | null
    count: number
    totalValue: number
    totalDiscount: number
    estimatedTax: number | null
    category: string
}

export interface ProductBarReport {
    id: string
    name: string
    products: ProductBarReportProducts[]
}

export interface NewPlaceProductFiscalData {
    ncm: string | null
    cest: string | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
}

export interface PlaceProductFiscalData {
    ncm: string | null
    cest: string | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
    status: PlaceProductFiscalDataStatus
}

export interface TranslatedPlaceProductFiscalData {
    ncm: string | null
    cest: string | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
    status: string
}

export interface ProductKind {
    id: string
    masterKind: string
    name: string
    kindKey: string | null
}

export interface SuggestedImages {
    tags: string[]
    id: string
    url: string
    weight: number
}

export interface ProductImageSearch {
    name: string
    category: string
}

export interface ProductImageReferenceTag {
    ptBr: string | null
    esMx: string | null
    enUs: string | null
}

export interface ProductImageReference {
    imageId: string
    url: string
    tags: ProductImageReferenceTag
}

export interface ProductRuleInputs {
    id: string
    count: number
    loss: number
    basicStorageUnit: string
}

export interface ProductRuleOutputs {
    id: string
    count: number
    basicStorageUnit: string
    value: number | null
}

export interface ProductRule {
    id: string
    inputs: ProductRuleInputs[]
    outputs: ProductRuleOutputs[]
}

export interface ProductRuleWithResumeInputs {
    id: string
    name: string
    count: number
    loss: number
    basicStorageUnit: string
    value: string | null
    unitCostValue: string | null
    totalCost: string | null
    yieldPercentage: number | null
    unitCostWithYield: string | null
}

export interface ProductRuleWithResumeOutputs {
    id: string
    name: string
    count: number
    basicStorageUnit: string
    value: string | null
    unitCostValue: string | null
}

export interface ProductRuleWithResume {
    id: string
    unitCostValue: string | null
    value: string | null
    cmvPercentage: number | null
    inputs: ProductRuleWithResumeInputs[]
    outputs: ProductRuleWithResumeOutputs[]
}

export interface RefundedProductRefundedBy {
    name: string
    username: string | null
}

export interface RefundedProductSoldBy {
    name: string
    username: string | null
}

export interface RefundedProduct {
    id: string
    refundedAt: Date
    name: string
    category: string
    unitValue: number
    count: number
    refundedBy: RefundedProductRefundedBy
    refundObs: string
    buyers: string[]
    isCanceled: boolean
    soldBy: RefundedProductSoldBy | null
    operationType: OperationType
}

export interface ResultSupplyProductionRuleInputs {
    id: string
    name: string
    sku: string | null
    image: ImageUrl | null
    basicStorageUnit: BasicStorageUnit
    count: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    loss: number
    lossByProportionOfUnit: ConvertedProportionOfUnit | null
    yieldPercentage: number | null
    unitCostValue: string | null
    totalCost: string | null
}

export interface ResultSupplyProductionRuleOutput {
    count: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
}

export interface ResultSupplyProductionRule {
    id: string
    inputs: ResultSupplyProductionRuleInputs[]
    output: ResultSupplyProductionRuleOutput
}

export interface SupplyWithProductionRuleAttachedTo {
    id: string
    name: string
}

export interface SupplyWithProductionRule {
    id: string
    name: string
    sku: string | null
    image: ImageUrl | null
    createdAt: Date
    basicStorageUnit: BasicStorageUnit
    yieldPercentage: number | null
    productionRule: ResultSupplyProductionRule
    unitCostValue: string | null
    attachedTo: SupplyWithProductionRuleAttachedTo[]
    proportionOfUnit: ProportionOfUnit | null
}

export interface BaseSystemProduct {
    id: string
    productSk: string
    name: string
}

export interface SystemProduct {
    id: string
    productSk: string
    name: string
    imageUrl: string | null
}

export interface NewPromotionDiscountBonus {
    bonusValue: number
}

export interface NewPromotionDiscountDiscount {
    cashDiscount: number | null
    percentageDiscount: number | null
    discountLimit: number | null
    productsIds: string[]
}

export interface NewPromotionDiscount {
    bonus: NewPromotionDiscountBonus | null
    discount: NewPromotionDiscountDiscount | null
}

export interface NewPromotionConditionsGuestList {
    id: string
    cpf: string
    name: string
}

export interface NewPromotionConditions {
    guestList: NewPromotionConditionsGuestList[] | null
    everybody: boolean | null
    checkinTime: number | null
    birthdayPerson: BirthdayPerson | null
    gender: NewPromotionConditionsGender | null
    minimumValueConsumed: number | null
    maximumValueConsumed: number | null
    productsConsumed: string[] | null
    productsConsumedQuantity: number | null
    minimumPlaceFrequency: number | null
    maximumPlaceFrequency: number | null
    ppuUsage: boolean | null
    minimumRechargeValue: number | null
}

export interface NewPromotion {
    isActive: boolean
    name: string
    description: string
    placeIds: string[]
    maxUses: number | null
    secondsToExpire: number | null
    eventOnly: boolean | null
    weekDays: WeekDay[] | null
    beginTime: number | null
    endTime: number | null
    frequencyOfEarning: PromotionFrequencyOfEarning
    typeOfDiscount: PromotionDiscountType
    discount: NewPromotionDiscount
    conditions: NewPromotionConditions
    automaticMessages: boolean | null
    whatsUp: boolean | null
}

export interface Promotion {
    id: string
    offlineId: string | null
    isActive: boolean
    name: string
    description: string
    placeIds: string[]
    maxUses: number | null
    secondsToExpire: number | null
    eventOnly: boolean | null
    weekDays: WeekDay[] | null
    beginTime: number | null
    endTime: number | null
    frequencyOfEarning: PromotionFrequencyOfEarning
    typeOfDiscount: PromotionDiscountType
    discount: NewPromotionDiscount
    conditions: NewPromotionConditions
    automaticMessages: boolean | null
    whatsUp: boolean | null
}

export interface PromotionUser {
    id: string
    name: string
    cpf: string
    phone: string
    promotionId: string
}

export interface BaseResponse {
    id: string
    isDeleted: boolean
    createdAt: Date
    createdBy: string
}

export interface BaseWithoutDeletedResponse {
    id: string
    createdAt: Date
    createdBy: string
}

export interface BasePaginationResponse {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface PostPaymentEventEmployee {
    name: string
    username: string
}

export interface PostPaymentEventPayments {
    method: string
    value: number
}

export interface PostPaymentEventPayers {
    cpf: string
    name: string
    email: string | null
    phone: string
}

export interface PostPaymentEvent {
    acquirerTransactions: AcquirerTransaction[]
    createdAt: Date
    createdBy: string | null
    id: string
    eventId: string | null
    event: string | null
    beginAt: Date | null
    endAt: Date | null
    place: string | null
    employee: PostPaymentEventEmployee | null
    isDeleted: boolean
    payments: PostPaymentEventPayments[]
    payers: PostPaymentEventPayers[]
    postPaymentType: PostPaymentEventPostPaymentType
}

export interface AcquirerTransaction {
    transactionId: string | null
    acquirer: string | null
    transactionUrl: string | null
    cardBrand: string | null
    cardHolderName: string | null
    cardHolderNumber: string | null
    authorizatedAmount: number | null
    capturedAmount: number | null
    isExpiredCreditCard: boolean | null
    expirationDate: string | null
    paidAmount: number | null
    transactionType: string | null
    transactionStatus: string | null
    type: number | null
    amount: number | null
}

export interface NewMountableSectionItems {
    productId: string
    storageCount: number
    name: string | null
    price: number
    maxCount: number | null
    selectedCount: number | null
    hasAlcohol: boolean | null
}

export interface NewMountableSection {
    title: string
    min: number
    max: number
    pricing: NewMountableSectionPricing
    items: NewMountableSectionItems[]
}

export interface MountableSection {
    title: string
    min: number
    max: number
    pricing: NewMountableSectionPricing
    items: NewMountableSectionItems[]
    id: string
    order: number
}

export interface MountableSectionV2Items {
    isActive: boolean
    productId: string
    storageCount: number
    name: string | null
    price: number
    maxCount: number | null
    selectedCount: number | null
    basicStorageUnit: BasicStorageUnit | null
    hasAlcohol: boolean | null
    isModification: boolean | null
}

export interface MountableSectionV2 {
    id: string
    order: number
    title: string
    min: number
    max: number
    pricing: MountableSectionV2Pricing
    fiscalWeight: number | null
    items: MountableSectionV2Items[]
}

export interface UserAddressCep {
    postalCode: string
    street: string
    neighborhood: string | null
    state: string
    city: string
    stateAbbr: string
    municipalityCode: string | null
    country: string | null
    addressName: string
    number: string
    complement: string | null
    nickname: string | null
    createdBy: string
    mainAddress: boolean
}

export interface NewMountableDescription {
    sections: NewMountableSection[]
}

export interface MountableDescription {
    sections: MountableSection[]
}

export interface MountableDescriptionV2 {
    sections: MountableSectionV2[]
}

export interface FiscalPrinter {
    type: PrinterType | null
    ip: string
    name: string
}

export interface EditProductImage {
    sha256: string | null
    imageId: string | null
    data: ArrayBuffer | null
}

export interface Pagination {
    currentPage: number
    perPage: number
}

export interface PaginationResponse {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface AttachmentResponse {
    name: string
    url: string
}

export interface PeriodTime {
    since: Date
    until: Date
}

export interface VendorFinancialAdjustDto {
    title: string
    category: string | null
    vendorId: string
    eventId: string | null
    placeId: string
    value: number
    obs: string
    date: Date
    originalPayDate: Date
}

export interface VendorFinancialAdjustResponse {
    id: string
    isDeleted: boolean
    createdAt: Date
    createdBy: string
    title: string
    category: string | null
    vendorId: string
    eventId: string | null
    placeId: string
    value: number
    obs: string
    date: Date
    originalPayDate: Date
    vendorClosingValueId: string
    vendorName: string
}

export interface VendorFeature {
    id: string
    name: string
    isActive: boolean
    description: string | null
}

export interface VendorPaymentMethodFees {
    credit: number | null
    debit: number | null
    pix: number | null
}

export interface VendorFees {
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
}

export interface VendorSettings {
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
}

export interface VendorPlaceRequest {
    id: string
    barIds: string[]
}

export interface VendorPlaceResponseBars {
    id: string
    name: string
}

export interface VendorPlaceResponse {
    id: string
    name: string
    bars: VendorPlaceResponseBars[]
}

export interface VendorProductRequest {
    productId: string
    fee: number
}

export interface VendorDocumentAddress {
    postalCode: string | null
    streetName: string | null
    addressNumber: string | null
    city: string | null
    state: string | null
    province: string | null
    complement: string | null
}

export interface VendorDocument {
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
}

export interface BaseVendorOrg {
    name: string
    login: string
    organizationId: string
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
}

export interface VendorRequest {
    name: string
    login: string
    organizationId: string
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
    places: VendorPlaceRequest[]
    productFees: VendorProductRequest[] | null
}

export interface VendorOrg {
    name: string
    login: string
    organizationId: string
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
    places: VendorPlaceResponse[]
    productFees: VendorProductRequest[] | null
    vendorEmployees: VendorEmployeeResponse[] | null
    id: string
}

export interface VendorEmployee {
    name: string
    email: string
    password: string
    permissions: string[]
}

export interface VendorEmployeeResponse {
    id: string
    createdBy: string
    vendorId: string
    name: string
    email: string
    password: string
    permissions: string[]
}

export interface MetabaseIntegrationEmbeddingParams {
    key: string
    config: MetabaseIntegrationEmbeddingParamsConfig
}

export interface MetabaseIntegrationLastEditInfo {
    id: number
    email: string
    firstName: string
    lastName: string
    updatedAt: Date
}

export interface MetabaseIntegrationResource {
    id: number
    name: string
    archived: boolean
    createdAt: Date
    embeddingParams: MetabaseIntegrationEmbeddingParams[] | null
    lastEditInfo: MetabaseIntegrationLastEditInfo
}

export interface ParameterNameConfiguration {
    originalParameter: string
    renamedParameter: string
}

export interface MetabaseResponse {
    id: string
    code: number
    name: string
    type: MetabaseResourceType
    isGeneric: boolean
    parameterNameConfiguration: ParameterNameConfiguration[] | null
    isDeleted: boolean
    createdBy: string
}

export interface OrganizationMetabaseResponse {
    id: string
    metabaseId: string
    name: string | null
    organizationId: string
    placeIds: string[] | null
    isDeleted: boolean
    createdAt: Date
    createdBy: string
    updatedAt: Date
    metabase: MetabaseResponse
    contextLevel: OrganizationMetabaseContextLevel[]
}

export interface UserConsentResponse {
    id: string
    cpf: string
    hasAcceptedToShareData: boolean
    date: Date
    src: ConsentSource
}

export interface CampaignClientInfoPlace {
    id: string
    name: string
}

export interface CampaignClientInfo {
    phone: string
    place: CampaignClientInfoPlace
    optout: boolean
}

export interface UserPlaceInfo {
    placeId: string
    phone: string
    userId: string
}

export interface ConfirmOptOutParams {
    phone: string
    placeId: string
    channel: Channel
    isCampaign: boolean
    createdBy: string
    optOutFromZig: boolean
    userId: string | null
    reason: string | null
}

export interface DBOptOut {
    date: Date
    userId: string | null
    phone: string | null
    placeId: string | null
    reason: string | null
    optOutFromZig: boolean
    isCampaign: boolean
    channel: Channel
}

export interface DeliveryBaseAddress {
    streetName: string
    city: string
    country: string
    state: string
    neighborhood: string
    postalCode: string
    complement: string | null
}

export interface DeliveryAddress {
    streetName: string
    city: string
    country: string
    state: string
    neighborhood: string
    postalCode: string
    complement: string | null
    formattedAddress: string
    streetNumber: string
}

export interface Customer {
    name: string
    email: string
    phone: string
    isWhatsapp: boolean | null
    documentNumber: string | null
    documentType: UserDocumentType | null
    address: Address | null
    userId: string | null
}

export interface OrderFee {
    name: string
    description: string | null
    value: number
    issueInvoice: boolean
    receivedBy: TipReceiver | null
}

export interface SimplifiedOrderIfoodScheduleSchedule {
    deliveryDateTimeStart: Date
    deliveryDateTimeEnd: Date
}

export interface SimplifiedOrderIfoodSchedule {
    schedule: SimplifiedOrderIfoodScheduleSchedule | null
    preparationStartDateTime: Date | null
}

export interface SimplifiedOrder {
    id: string
    date: Date
    reference: number
    status: OrderStatus
    vendor: Vendor
    value: number
    deliveryFee: number
    discountValueDeliveryFee: number | null
    tip: number
    deliveryType: DeliveryType
    customer: Customer
    externalReference: string | null
    cancellationReason: string | null
    cancellationObs: string | null
    ifoodSchedule: SimplifiedOrderIfoodSchedule | null
    isPostPaid: boolean
    discountValue: number
    transactionId: string | null
    deliverySource: DeliverySource | null
    orderFees: OrderFee[] | null
}

export interface OrderFilter {
    status: OrderStatus[]
    since: Date
    until: Date
}

export interface DeliveryOrderStatus {
    date: Date
    status: OrderStatus
}

export interface MountableSectionItem {
    id: string | null
    name: string
    count: number
    order: number
    title: string
    storageCount: number
    maxCount: number | null
    price: number
    isActive: boolean
    basicStorageUnit: string
}

export interface SectionItems {
    id: string | null
    name: string | null
    count: number
    eventId: string
    value: number
    discountValue: number
    transactionType: string
    transactionId: string
    promotionId: string | null
    onlineFichaId: string | null
    exportedAt: Date | null
    sections: MountableSectionItem[] | null
}

export interface GetOrdersResponsePayment {
    method: PaymentMethod
    adyenCard: AdyenCardPayment | null
    isPayOnDelivery: boolean | null
}

export interface GetOrdersResponse {
    items: SectionItems[] | null
    statusHistory: DeliveryOrderStatus[]
    tip: number
    value: number
    transactionId: string
    payment: GetOrdersResponsePayment | null
    id: string
    onlineFichaId: string
    exportedAt: Date | null
}

export interface PlaceActivePromoters {
    promoterId: string
    name: string
    email: string
}

export interface CashierAdjustmentAuthor {
    id: string
    name: string
    username: string | null
}

export interface CashierAdjustmentCashier {
    id: string
    name: string
    username: string | null
}

export interface CashierAdjustment {
    id: string
    author: CashierAdjustmentAuthor
    cashier: CashierAdjustmentCashier
    value: number
    type: CashierAdjustmentType
    timestamp: Date
    obs: string | null
}

export interface CloseMethod {
    method: CloseMethodEnum
    brand: string | null
}

export interface MoneyReceived {
    method: AllMethods
    value: number
}

export interface CloseValue {
    method: CloseMethodEnum
    brand: string | null
    value: number
}

export interface CashierBleedings {
    id: string
    author: string
    date: Date
    value: number
}

export interface CashierClosed {
    author: string
    authorUsername: string | null
    date: Date
}

export interface Cashier {
    id: string
    name: string
    username: string | null
    rechargeMoneyReceived: MoneyReceived[]
    postPaidMoneyReceived: MoneyReceived[]
    cashZigTagDevolutions: number
    rechargeDevolutions: number
    singleProductReturns: number
    bleedings: CashierBleedings[]
    closedValues: CloseValue[]
    closed: CashierClosed | null
    type: EmployeeType | null
}

export interface ZigDeviceGroup {
    id: string
    name: string
    placeId: string
}

export interface PixCharge {
    id: string
    value: number
    emv: string
}

export interface PixChargePaidResponse {
    status: PixChargePaidResponseStatus
    message: string | null
}

export interface EntranceDetail {
    id: string
    count: number
    name: string
    userPaidValue: number
    totalDiscountValue: number
}

export interface ProductReturn {
    id: string
    isShared: boolean
    name: string
    value: number
    count: number
    discountValue: number
}

export interface ProductRefunds {
    id: string
    name: string
    count: number
}

export interface ConsumptionObligation {
    id: string
    value: number
    paidValue: number
    eventId: string
}

export interface OpenBillChargeEventData {
    id: string
    name: string
    date: Date
    status: string
}

export interface OpenBillEventInfo {
    eventData: OpenBillChargeEventData
    products: ProductReturn[]
    value: number
    paidValue: number
    tip: number
    paidTip: number
}

export interface OpenBillChargeDetails {
    userName: string | null
    placeData: PlaceDetails
    openBillChargeData: OpenBillChargeData
    eventsInfo: OpenBillEventInfo[]
}

export interface PlaceDetails {
    id: string
    placeName: string
    tipPercentage: number
}

export interface OpenBillChargeData {
    openBillTotalValue: number
    openBillTotalValuePaid: number
    openBillChargedTipValue: number
    consumedProducts: ProductReturn[]
}

export interface ByPaymentMethodSummary {
    App: number
    Cash: number
    DebitCard: number
    CreditCard: number
    Voucher: number
    ZigPosDebit: number
    ZigPosCredit: number
    PostEvent: number
    Dashboard: number
    Anticipated: number
    DeliveryOnline: number
    Consumption: number
    Ame: number
    Rappi: number
    Uber: number
    Ifood: number
    Bonus: number
    Pix: number
    Opened: number
    Other: number
    ZigPosCreditInInstallments: number
    IntegratedFoodVoucher: number
    MBWay: number
    Cashless: number
}

export interface BarReport {
    id: string
    name: string
    quantity: number
    totalValue: number
    totalTaxAmount: number | null
    totalDiscount: number
}

export interface BarOrEmployeeFinance {
    id: string | null
    name: string | null
    username: string | null
    finance: ByPaymentMethodSummary
}

export interface SellerReport {
    id: string
    name: string
    username: string | null
    isDeleted: boolean | null
    soldValue: number
    tip: number
    countSold: number | null
}

export interface EventResumeSectionValuesValues {
    value: number | null
    unit: EventResumeSectionValuesValuesUnit
}

export interface EventResumeSectionValues {
    name: string
    tooltip: string | null
    values: EventResumeSectionValuesValues[]
    highlighted: boolean
    hideIfZero: boolean
}

export interface EventResumeSection {
    title: string
    description: string | null
    columns: string[]
    values: EventResumeSectionValues[]
}

export interface GetReportByScopeEvent {
    id: string
}

export interface GetReportByScopePlace {
    id: string
    period: PeriodTime
}

export interface GetReportByScope {
    event: GetReportByScopeEvent | null
    place: GetReportByScopePlace | null
}

export interface RechargeByZigDevice {
    value: number
    rechargeType: RechargeTypeEnum
}

export interface RechargeByZigCode {
    zigCode: string
    reason: string
    value: number
}

export interface RechargeResultsError {
    recharge: RechargeByZigCode
    reason: string
}

export interface RechargeResults {
    success: RechargeByZigCode[]
    error: RechargeResultsError[]
}

export interface PlaceContractEquipments {
    type: string
    quantity: number
    unitValue: number
}

export interface PublicDetail {
    consumption: number
    new: number
    old: number
    zero: number
    consumptionPercetage: number
    inside: number
    total: number
}

export interface NewPublic {
    totalConsumption: number | null
    totalPublic: number | null
    publicCapacity: number | null
    male: PublicDetail
    female: PublicDetail
    other: PublicDetail
}

export interface NpsAnswer {
    value: number
    questionId: QuestionType
    comment: string | null
}

export interface BaseMenuConfig {
    name: string | null
    primaryColor: string
    secondaryColor: string
    contrastColor: string
    isOpenStatusVisible: boolean
    isWaitingTimeVisible: boolean
    taxType: MenuConfigsTaxType | null
    baseRateValue: number | null
    ratePerKm: number | null
    waitingTime: number | null
    additionalFieldType: MenuConfigsAdditionalFieldType | null
    postalCode: string | null
    state: string | null
    city: string | null
    neighborhood: string | null
    address: string | null
    number: string | null
    complement: string | null
}

export interface GetMenuConfigResponse {
    name: string | null
    primaryColor: string
    secondaryColor: string
    contrastColor: string
    isOpenStatusVisible: boolean
    isWaitingTimeVisible: boolean
    taxType: MenuConfigsTaxType | null
    baseRateValue: number | null
    ratePerKm: number | null
    waitingTime: number | null
    additionalFieldType: MenuConfigsAdditionalFieldType | null
    postalCode: string | null
    state: string | null
    city: string | null
    neighborhood: string | null
    address: string | null
    number: string | null
    complement: string | null
    id: string
    slug: string | null
    logoImage: string | null
    bannerImage: string | null
}

export interface FichaSettings {
    fontSize: FichaFontSize | null
    imageSize: FichaImageSize | null
    qrCodeSize: FichaQRCodeSize | null
}

export interface WalletSummary {
    availableForWithdraw: number
    generalBlockedBalance: number
    withdrawBlockedBalance: number
    futureEntries: number
    totalBalance: number
    balance: number
    totalBlockedBalance: number
    futureFinancialEntriesForNext31Days: number
    availableForAnticipation: number
    futureFinancialEntriesAfter31Days: number
    notLiquidatedPairEntries: number
}

export interface PairInfoRelatedVendor {
    id: string
    name: string
}

export interface PairInfo {
    id: string
    name: string
    type: PairInfoType
    document: string | null
    relatedVendor: PairInfoRelatedVendor | null
}

export interface FutureFinancialEntry {
    typeId: string
    type: string
    categoryId: string | null
    category: string | null
    observation: string | null
    competenceDate: Date
    liquidationDate: Date
    value: number
    originDestination: PairInfo | null
}

export interface FutureFinancialEntryByMonth {
    year: number
    month: number
    entries: FutureFinancialEntry[]
}

export interface FutureFinancialEntryGrouped {
    entries: FutureFinancialEntry[]
    year: number | null
    month: number | null
    date: string | null
    typeId: string | null
    typeName: string | null
    categoryId: string | null
    categoryName: string | null
}

export interface WithdrawV2ItemRequestedBy {
    id: string
    name: string
}

export interface WithdrawV2ItemProRataFee {
    value: number
    percentage: number
}

export interface WithdrawV2ItemBankAccountReceiver {
    bank: string
    agency: string
    account: string
    name: string
    documentNumber: string
    accountType: string
    documentType: string
}

export interface WithdrawV2ItemBankAccount {
    id: string
    name: string
    holder: string
    receiver: WithdrawV2ItemBankAccountReceiver | null
    isDefault: boolean
}

export interface WithdrawV2Item {
    id: string
    requestDate: Date
    paymentDate: Date | null
    status: WithdrawV2Status
    statusText: string
    type: WithdrawV2Type
    typeText: string
    value: number
    requestedBy: WithdrawV2ItemRequestedBy | null
    proRataFee: WithdrawV2ItemProRataFee | null
    pixKey: string | null
    reason: string | null
    managerObs: string | null
    attachments: string[] | null
    bankAccount: WithdrawV2ItemBankAccount | null
    originWithdrawRequestId: string | null
    originationAnticipationWithdrawRequestId: string | null
    wasDeclinedByInsufficientBalance: boolean | null
}

export interface WithdrawV2Response {
    items: WithdrawV2Item[]
    total: number
}

export interface ConsolidatedExtractV2GroupTypes {
    id: string
    name: string
    typeId: string | null
    categoryId: string | null
    value: number
    grossValue: number | null
    minFee: number | null
    maxFee: number | null
    obs: string | null
    originDestination: PairInfo | null
}

export interface ConsolidatedExtractV2Group {
    id: string
    name: string
    total: number
    types: ConsolidatedExtractV2GroupTypes[]
}

export interface ConsolidatedExtractV2Balance {
    initial: number
    period: number
    final: number
}

export interface ConsolidatedExtractV2 {
    groups: ConsolidatedExtractV2Group[]
    balance: ConsolidatedExtractV2Balance
    total: number
}

export interface ConsolidatedExtractCashFlowFutureEntries {
    value: number
    groups: ConsolidatedExtractV2Group[]
}

export interface ConsolidatedExtractCashFlow {
    groups: ConsolidatedExtractV2Group[]
    balance: ConsolidatedExtractV2Balance
    total: number
    futureEntries: ConsolidatedExtractCashFlowFutureEntries | null
}

export interface AnticipatedEntryInfo {
    id: string
    createdAt: Date
    liquidationDate: Date
    referenceDate: Date
    type: string
    typeId: string
    category: string | null
    observation: string | null
    value: number
    originDestination: PairInfo | null
}

export interface DetailedEntry {
    id: string
    createdAt: Date
    liquidationDate: Date
    referenceDate: Date
    type: string
    typeId: string
    category: string | null
    categoryId: string | null
    groupId: string | null
    groupName: string | null
    observation: string | null
    value: number
    originDestination: PairInfo | null
}

export interface ExtractFlowItemV2 {
    id: string
    createdAt: Date
    liquidationDate: Date
    referenceDate: Date
    type: string
    typeId: string
    category: string | null
    categoryId: string | null
    groupId: string | null
    groupName: string | null
    observation: string | null
    value: number
    originDestination: PairInfo | null
    balance: number
    anticipated: boolean | null
    anticipatedEntries: AnticipatedEntryInfo[] | null
    detailedEntries: DetailedEntry[] | null
}

export interface ExtractFlowResponseV2 {
    items: ExtractFlowItemV2[]
    total: number
    grandTotal: number | null
}

export interface GroupedExtractFlowItem {
    groupKey: string
    totalValue: number
    items: ExtractFlowItemV2[] | null
    initialBalance: number | null
    totalIn: number
    totalOut: number
}

export interface GroupedExtractFlowResponse {
    groups: GroupedExtractFlowItem[]
    totalCount: number
    grandTotal: number
}

export interface ClientProviderDocument {
    id: string
    externalReference: string | null
    documentNumber: string | null
    documentType: string | null
    clientType: string | null
    provider: string | null
    status: string | null
    corporateName: string | null
    fantasyName: string | null
    contactName: string | null
    email: string | null
    cellPhone: string | null
    telephone: string | null
    postalCode: string | null
    address: string | null
    addressNumber: string | null
    complement: string | null
    neighborhood: string | null
    city: string | null
    state: string | null
    operationType: string | null
    mccCode: string | null
    accreditationDate: Date | null
    liquidationBlocking: boolean | null
    createdAt: Date | null
    updatedAt: Date | null
    statusChangedAt: Date | null
    errType: string | null
    err: string | null
}

export interface ReceivableUnit {
    id: string
    placeId: string | null
    referenceDate: Date
    payDate: Date
    type: ReceivableUnitType
    cardBrand: string
    grossValue: number
    taxValue: number
    netValue: number
    blockedValue: number
    anticipatedValue: number
    effectiveContractValue: number
    provider: string
    status: string
    errType: string | null
    err: string | null
    updatedAt: Date | null
    createdAt: Date
    createdBy: string
    paymentAccountId: string | null
    parentContractEffectPaymentAccountId: string | null
    parentAnticipationConsolidatedId: string | null
    isDeleted: boolean
}

export interface ReceivableUnitConsolidated {
    id: string
    provider: string
    providerReference: string
    holderDocumentNumber: string | null
    clientProviderDocumentId: string
    cardBrand: string
    cardType: ReceivableUnitConsolidatedCardType
    payDate: Date
    creditorDocumentNumber: string | null
    lastOperationType: string | null
    status: string
    errType: string | null
    err: string | null
    updatedAt: Date
    grossAmount: number | null
    liquidAmount: number | null
    onlineRiskAmount: number | null
    physicalRiskAmount: number | null
    anticipatedAmount: number | null
    effectiveContractAmount: number | null
    blockedAmount: number | null
    taxAmount: number | null
    lastProviderFileDispatchHistoryId: string | null
    parentReceivableUnitConsolidatedId: string | null
    isDeleted: boolean
    createdAt: Date
    createdBy: string
}

export interface CentralLiquidationOperation {
    id: string
    createdBy: string
    createdAt: Date
    isDeleted: boolean
    updatedAt: Date
    placeId: string
    anticipationId: string | null
    requestDate: Date
    liquidationDate: Date
    method: string
    provider: string
    status: string
    isZig: boolean
    paymentAccountId: string | null
}

export interface CentralLiquidationOperationReceivableUnit {
    centralLiquidationOperationId: string
    receivableUnitId: string
    nuLiquid: string | null
    updatedAt: Date
    err: string | null
    externalId: string
    status: string
    lastStatus: string
    value: number
}

export interface CentralLiquidationOperationReceivableUnitRelated {
    centralLiquidationOperationId: string
    receivableUnitId: string
    nuLiquid: string | null
    updatedAt: Date
    err: string | null
    externalId: string
    status: string
    lastStatus: string
    value: number
    receivableUnit: ReceivableUnit
}

export interface CentralLiquidationOperationWithRelatedValues {
    id: string
    createdBy: string
    createdAt: Date
    isDeleted: boolean
    updatedAt: Date
    placeId: string
    anticipationId: string | null
    requestDate: Date
    liquidationDate: Date
    method: string
    provider: string
    status: string
    isZig: boolean
    paymentAccountId: string | null
    clorus: CentralLiquidationOperationReceivableUnitRelated[]
}

export interface ReceivableUnitByPlaceIdAndFiltersParams {
    placeId: string
    id: string | null
    paymentAccountId: string | null
    status: string | null
}

export interface CoalaTempToken {
    storeId: string
    expiresAt: Date
    token: string
    barId: string
}

export interface CoalaAddress {
    streetName: string
    city: string
    country: string
    state: string
    neighborhood: string
    postalCode: string
    complement: string
    formattedAddress: string
    streetNumber: string
}

export interface ExternalStoreIntegration {
    externalStoreId: string
    name: string
    status: ExternalStoreIntegrationStatus
    createdAt: Date
    isActive: boolean
}

export interface GetStoreExternalIntegrationResponse {
    type: ExternalStoreIntegrationType
    status: ExternalStoreIntegrationStatus
    stores: ExternalStoreIntegration[]
    menuId: string | null
}

export interface GetPlaceStoreResponse {
    id: string
    integrations: GetStoreExternalIntegrationResponse[]
}

export interface UpdateManyStoreIntegrationsRequest {
    externalIds: string[]
    type: ExternalStoreIntegrationType
}

export interface GetExternalStoreResponse {
    externalStoreId: string
    name: string
}

export interface ExternalStoreIntegrationProductDto {
    externalId: string | null
    externalStoreId: string
    name: string
    description: string | null
    price: number
    sku: string | null
    isActive: boolean
    imageUrl: string | null
}

export interface ExternalStoreIntegrationSectionProductDto {
    externalId: string | null
    externalStoreId: string
    name: string
    description: string | null
    index: number
    price: number
    sku: string | null
    isActive: boolean
}

export interface ExternalStoreIntegrationSectionDto {
    externalId: string
    name: string
    index: number
    isActive: boolean
    min: number
    max: number
    products: ExternalStoreIntegrationSectionProductDto[]
}

export interface ExternalStoreIntegrationCategoryDto {
    externalId: string
    externalStoreId: string
    name: string
    sku: string | null
    products: ExternalStoreIntegrationProductWithSectionsDto[]
}

export interface ExternalStoreIntegrationProductWithSectionsDto {
    externalId: string | null
    externalStoreId: string
    name: string
    description: string | null
    price: number
    sku: string | null
    isActive: boolean
    imageUrl: string | null
    sections: ExternalStoreIntegrationSectionDto[]
}

export interface GetManyExternalStoreIntegrationCategoriesResponseDto {
    categories: ExternalStoreIntegrationCategoryDto[]
    totalOfProducts: number
}

export interface DashboardAlert {
    id: string
    date: Date
    title: string
    description: string
    image: ImageUrl
    hasRead: boolean
    type: DashboardAlertType
}

export interface AuditWithRelations {
    id: string
    employeeName: string | null
    date: Date
    functionName: string
    type: string
    params: any
    obs: string
    createdAt: Date
}

export interface AuditResponse {
    data: AuditWithRelations[]
    pagination: PaginationResponse
}

export interface AuditFilters {
    employeeName: string | null
    functionName: string | null
    type: string | null
}

export interface AuditParams {
    period: PeriodTime
    pagination: Pagination
    placeId: string
    filters: AuditFilters
}

export interface BackofficeNewAccount {
    name: string
    bankAccount: BackofficeBankAccount | null
    initialBalance: number
    initialBalanceDate: Date
    currentBalance: number
    isValidated: boolean
}

export interface BackofficeBaseAccount {
    name: string
    bankAccount: BackofficeBankAccount | null
}

export interface BackofficeAccount {
    id: string
    name: string
    bankAccount: BackofficeBankAccount | null
    initialBalance: number
    initialBalanceDate: Date
    currentBalance: number
    isValidated: boolean
}

export interface BackofficeBillPlanCategoryBase {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildrenChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildrenChildren[]
}

export interface BackofficeBillPlanCategoryChildren {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildrenChildren[]
}

export interface BackofficeBillPlanCategory {
    id: string
    name: string
    path: string
    parentId: string | null
    hasBills: boolean
    position: number
    children: BackofficeBillPlanCategoryChildren[]
}

export interface BackofficeAttachment {
    fileName: string
    data: ArrayBuffer
}

export interface BackofficeBaseBill {
    description: string | null
    performDate: Date
    payDate: Date | null
    dueDate: Date
    supplierId: string | null
    accountId: string
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
    metadata: string | null
    value: number
    interest: number
    fine: number
    discount: number
    reconciled: boolean
    status: BackofficeBaseBillStatus
    duplicateId: string | null
    issueDate: Date
    numBill: string | null
    addition: number
}

export interface BackofficeBillBillPlanCategory {
    id: string
    value: number
    referenceField: BackofficeReferenceField | null
}

export interface BackofficeSplittedBillData {
    dueDate: Date | null
    performDate: Date
    value: number
}

export interface BackofficeSplittedBillDataWithId {
    dueDate: Date | null
    performDate: Date
    value: number
    id: string
}

export interface BackofficeNewBill {
    description: string | null
    performDate: Date
    payDate: Date | null
    dueDate: Date
    supplierId: string | null
    accountId: string
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
    metadata: string | null
    value: number
    interest: number
    fine: number
    discount: number
    reconciled: boolean
    status: BackofficeBaseBillStatus
    duplicateId: string | null
    issueDate: Date
    numBill: string | null
    addition: number
    billType: BackofficePartialBillType | null
    costCenter: string | null
    billPlanCategories: BackofficeBillBillPlanCategory[]
}

export interface BackofficeNewBillWithRecurrence {
    description: string | null
    performDate: Date
    payDate: Date | null
    dueDate: Date
    supplierId: string | null
    accountId: string
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
    metadata: string | null
    value: number
    interest: number
    fine: number
    discount: number
    reconciled: boolean
    status: BackofficeBaseBillStatus
    duplicateId: string | null
    issueDate: Date
    numBill: string | null
    addition: number
    billType: BackofficePartialBillType | null
    costCenter: string | null
    billPlanCategories: BackofficeBillBillPlanCategory[]
    recurrence: BackofficeSplittedBillData[]
}

export interface BackofficeNewBillWithInstallments {
    description: string | null
    performDate: Date
    payDate: Date | null
    dueDate: Date
    supplierId: string | null
    accountId: string
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
    metadata: string | null
    value: number
    interest: number
    fine: number
    discount: number
    reconciled: boolean
    status: BackofficeBaseBillStatus
    duplicateId: string | null
    issueDate: Date
    numBill: string | null
    addition: number
    billType: BackofficePartialBillType | null
    costCenter: string | null
    billPlanCategories: BackofficeBillBillPlanCategory[]
    installments: BackofficeSplittedBillData[]
}

export interface BackofficeBillAccount {
    name: string
    bankAccount: BackofficeBankAccount | null
    id: string
}

export interface BackofficeBillBillPlanCategories {
    id: string
    name: string
    referenceField: BackofficeReferenceField | null
    value: number
}

export interface BackofficeBill {
    description: string | null
    performDate: Date
    payDate: Date | null
    dueDate: Date
    supplierId: string | null
    accountId: string
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
    metadata: string | null
    value: number
    interest: number
    fine: number
    discount: number
    reconciled: boolean
    status: BackofficeBaseBillStatus
    duplicateId: string | null
    issueDate: Date
    numBill: string | null
    addition: number
    id: string
    supplier: BackofficeSupplier | null
    account: BackofficeBillAccount | null
    billType: BackofficeBillType | null
    costCenter: BackofficeCostCenter | null
    originId: string | null
    attachment: string | null
    billPlanCategories: BackofficeBillBillPlanCategories[]
    createdBySystem: boolean
}

export interface BackofficeBaseDate {
    since: Date | null
    until: Date | null
}

export interface BackofficeRequiredBaseDate {
    since: Date
    until: Date
}

export interface BackofficeExportBillArgsTotalValue {
    min: number
    max: number
}

export interface BackofficeExportBillArgs {
    performDate: BackofficeRequiredBaseDate | null
    dueDate: BackofficeRequiredBaseDate | null
    issueDate: BackofficeRequiredBaseDate | null
    payDate: BackofficeRequiredBaseDate | null
    type: BackofficeBillStatusFilter
    status: BackofficeExportBillArgsStatus
    bankAccountIds: string[]
    supplierIds: string[]
    costCenterIds: string[]
    billPlanCategoryIds: string[]
    numBill: string | null
    description: string | null
    observation: string | null
    totalValue: BackofficeExportBillArgsTotalValue | null
}

export interface BackofficeBillsToDREAnalyticsSupplier {
    name: string
    id: string
}

export interface BackofficeBillsToDREAnalyticsBillPlanCategory {
    name: string
    id: string
    value: number
    referenceField: BackofficeReferenceField | null
}

export interface BackofficeBillsToDREAnalytics {
    id: string
    addition: number
    discount: number
    dueDate: Date
    performDate: Date
    payDate: Date | null
    description: string | null
    numBill: string | null
    value: number
    supplier: BackofficeBillsToDREAnalyticsSupplier | null
    billPlanCategory: BackofficeBillsToDREAnalyticsBillPlanCategory
    createdBySystem: boolean
    status: BackofficeBillsToDREAnalyticsStatus
    accountId: string
}

export interface BackofficeEditBillDREAnalyticsBillPlanCategory {
    value: number
    oldBillPlanCategoryId: string
    newBillPlanCategoryId: string | null
}

export interface BackofficeEditBillDREAnalyticsArgBillInfo {
    id: string
    performDate: Date
    dueDate: Date | null
    description: string
    supplierId: string
}

export interface BackofficeEditBillDREAnalyticsArg {
    employeeId: string
    billInfo: BackofficeEditBillDREAnalyticsArgBillInfo
    billPlanCategoryInfo: BackofficeEditBillDREAnalyticsBillPlanCategory | null
    additionInfo: BackofficeEditBillDREAnalyticsBillPlanCategory | null
    discountInfo: BackofficeEditBillDREAnalyticsBillPlanCategory | null
}

export interface BackofficeNewBillType {
    name: string
    categoryId: string
}

export interface BackofficeBillType {
    id: string
    category: BackofficeCategory
    name: string
    categoryId: string
}

export interface BackofficePartialBillType {
    idOrName: string
    category: string | null
}

export interface BackofficeBillDataBillPlanCategories {
    id: string
    value: number
    referenceField: BackofficeReferenceField | null
    name: string
}

export interface BackofficeCashFlowBillDateWithStatus {
    date: Date
    description: string
    categoryName: string
    billPlanCategories: BackofficeBillDataBillPlanCategories[]
    account: BackofficeBillAccount | null
    value: number
    balance: number
    payDate: Date | null
    performDate: Date
    dueDate: Date
    status: BackofficeCashFlowBillDateWithStatusStatus
}

export interface BackofficeCashFlowBillDate {
    date: Date
    description: string
    categoryName: string
    billPlanCategories: BackofficeBillDataBillPlanCategories[]
    account: BackofficeBillAccount | null
    value: number
    balance: number
    payDate: Date | null
    performDate: Date
    dueDate: Date
}

export interface BackofficeBaseCashFlow {
    previousBalance: number
    finalBalance: number
    periodBalance: number
    totalReceipts: number
    totalExpenses: number
    since: Date
    until: Date
}

export interface BackofficeCashFlow {
    previousBalance: number
    finalBalance: number
    periodBalance: number
    totalReceipts: number
    totalExpenses: number
    since: Date
    until: Date
    receipts: BackofficeCashFlowBillDate[]
    expenses: BackofficeCashFlowBillDate[]
}

export interface BackofficeFullCashFlow {
    previousBalance: number
    finalBalance: number
    periodBalance: number
    totalReceipts: number
    totalExpenses: number
    since: Date
    until: Date
    receipts: BackofficeCashFlowBillDateWithStatus[]
    expenses: BackofficeCashFlowBillDateWithStatus[]
}

export interface BackofficeNeoCashFlowArgs {
    since: Date
    until: Date
    accountId: string
    billPlanContextId: string
    billPlanLevel: number
    viewMode: BackofficeNeoCashFlowArgsViewMode
}

export interface BackofficeNeoCashFlowBill {
    date: string
    expectedTotalValue: number
    fulfilledTotalValue: number
}

export interface BackofficeNeoCashFlow {
    id: string
    name: string
    path: string
    parentId: string | null
    level: number
    bills: BackofficeNeoCashFlowBill[]
}

export interface BackofficeNewCategory {
    name: string
}

export interface BackofficeCategory {
    id: string
    name: string
}

export interface BackofficeNewCostCenter {
    name: string
}

export interface BackofficeCostCenter {
    id: string
    name: string
}

export interface BackofficeNewDre {
    name: string
    isCostCenterOriented: boolean
}

export interface BackofficeDre {
    name: string
    isCostCenterOriented: boolean
    id: string
}

export interface BackofficeNewDreLineRule {
    costCenterId: string | null
    billPlanId: string | null
}

export interface BackofficeNewDreLine {
    name: string
    parentId: string | null
    previousLineId: string | null
    rules: BackofficeNewDreLineRule[]
}

export interface BackofficeDreLine {
    name: string
    parentId: string | null
    previousLineId: string | null
    rules: BackofficeNewDreLineRule[]
    id: string
}

export interface BackofficeDreLineResult {
    id: string
    name: string
    parentId: string
    previousLineId: string
    value: number
}

export interface BackofficeDreBillBase {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategoriesBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBillBillPlanCategories {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategoriesBillPlanCategories[]
}

export interface BackofficeDreBill {
    costCenterId: string | null
    bankAccountId: string | null
    dueDate: Date | null
    peformDate: Date | null
    payDate: Date | null
    value: number
    billId: string | null
    billPlanCategoryId: string
    billPlanCategoryName: string
    billPlanCategoryPath: string
    billPlanCategories: BackofficeDreBillBillPlanCategories[]
}

export interface BackofficeDreReportLine {
    dreLineId: string
    dreLineName: string
    dreParentLine: string | null
    drePreviousLine: string | null
    dreLineLegendType: string
    billPlanCategories: BackofficeDreBill[]
}

export interface BackofficeDreFullReport {
    dreId: string
    dreName: string
    dreReportLines: BackofficeDreReportLine[]
}

export interface BackofficeDreReport {
    name: string
    isCostCenterOriented: boolean
    id: string
    lines: BackofficeDreLineResult[]
    notCategorizedBills: number
    result: number
}

export interface BackofficeSimplyBillPlan {
    id: string
    name: string
}

export interface BackofficeExportDreArg {
    dreId: string
    billPlanContextId: string
    since: Date
    until: Date
    costCenterIds: string[]
    bankAccountIds: string[]
    dateFilter: BackofficeExportDreArgDateFilter
    billPlanLevel: number
}

export interface BackofficeFocusCompany {
    id: string
    cnpj: string
    token: string
    lastInvoiceVersion: number | null
}

export interface BackofficeFocusInvoice {
    id: string
    focusCompanyId: string
    supplierName: string
    supplierDocument: string
    accessKey: string
    totalValue: number
    issueDate: Date
    situation: string
    completed: boolean
    type: number
    version: number
    digestValue: string | null
    targetManifestion: BackofficeManifestType | null
}

export interface BackofficeBaseInventory {
    date: Date
    isTotal: boolean
    createdBy: string
}

export interface BackofficeNewInventory {
    date: Date
    isTotal: boolean
    createdBy: string
    storageIds: string[]
}

export interface BackofficeInventoryStorages {
    id: string
    name: string
}

export interface BackofficeInventory {
    date: Date
    isTotal: boolean
    createdBy: string
    id: string
    status: BackofficeInventoryStatus
    storages: BackofficeInventoryStorages[]
}

export interface BackofficeInventoryProduct {
    productId: string
    storageId: string
    inventoryCount: number | null
    inventoryUnitValue: number | null
    realCount: number | null
    realUnitValue: number | null
}

export interface BackofficeNewManualInvoiceBill {
    accountId: string | null
    createBill: boolean
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
}

export interface BackofficeNewManualInvoiceDetailsTaxs {
    icmsBase: number
    icmsValue: number
    icmsstBase: number
    icmsstValue: number
    ipiValue: number
}

export interface BackofficeNewManualInvoiceDetails {
    num: number
    serie: number
    operationType: string | null
    date: Date
    taxs: BackofficeNewManualInvoiceDetailsTaxs
    insuranceValue: number
    discountValue: number
    otherExpensesValue: number
    shippingValue: number
    cfop: number | null
}

export interface BackofficeNewManualInvoice {
    storageId: string | null
    bill: BackofficeNewManualInvoiceBill
    details: BackofficeNewManualInvoiceDetails
    supplierId: string | null
    products: BackofficeManualInvoiceProduct[]
    duplicates: BackofficeInvoiceDuplicate[]
}

export interface BackofficeManualInvoiceProduct {
    associatedProductId: string
    count: number
    unitValue: number
    entryTotalValue: number
    entryUnitValue: number
    chartAccountId: string | null
}

export interface BackofficeUpsertManualProduct {
    associatedProductId: string
    count: number
    unitValue: number
    entryTotalValue: number
    entryUnitValue: number
    chartAccountId: string | null
    id: string | null
    code: string
}

export interface BackofficeImportedInvoiceDetailsObjBillPlanCategory {
    billPlanCategoryId: string
    value: number
}

export interface BackofficeImportedInvoiceDetailsBillPlanCategory {
    invoiceId: string
    billPlanCategoryId: string
    value: number
    invoiceDetailsField: BackofficeImportedInvoiceDetailsField
}

export interface BackofficeProductLastInvoiceDetails {
    entryId: string
    pending: boolean
    skipped: boolean
    associatedProduct: Product | null
    chartAccountId: string | null
    unitValue: string
    unitMultiplier: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    commercialQuantity: number
    hasChangedCommercialQuantity: boolean
    invoiceEntry: BackofficeImportedInvoiceProductInvoiceEntry
    isImported: boolean
    totalProductValue: number
    invoiceDate: Date
}

export interface BackofficeBaseInvoiceProduct {
    id: string
    amount: number
    unitValue: number
    totalValue: number
}

export interface BackofficeLatestInvoiceProduct {
    invoiceId: string
    products: BackofficeBaseInvoiceProduct[]
}

export interface BackofficeLastInvoiceProducArg {
    id: string
    amount: number
}

export interface BackofficeMultipleImportedInvoice {
    success: BackofficeImportedInvoice[]
    errors: string[]
}

export interface BackofficeXmlInput {
    xml: ArrayBuffer
    fileName: string
}

export interface BackofficeEditInvoiceBillArg {
    invoiceId: string
    createBill: boolean
    accountId: string | null
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
}

export interface BackofficeUpsertInvoiceDuplicateArg {
    employeeId: string
    invoiceId: string
    accountId: string
    duplicates: BackofficeInvoiceDuplicate[]
    paymentMethod: BackofficeBillPaymentMethod | null
    observation: string | null
}

export interface SimpleInvoiceInfoIssuer {
    name: string
    cpfOrCnpj: string
}

export interface SimpleInvoiceInfo {
    key: string
    issuer: SimpleInvoiceInfoIssuer
    totalValue: number
    issueDate: Date
    status: SimpleInvoiceInfoStatus
    importedId: string | null
    cannotImportReason: string | null
}

export interface NewBackofficeManualInvoiceProduct {
    associatedProductId: string
    chartAccountId: string | null
    quantity: number
    unitCostValue: string
    discountValue: number
    ipiValue: number | null
    unitMultiplier: number
}

export interface NewManualBackofficeInvoiceV2DetailsTaxs {
    icmsBase: number | null
    icmsValue: number | null
    icmsstBase: number | null
    icmsstValue: number | null
    ipiValue: number | null
}

export interface NewManualBackofficeInvoiceV2Details {
    num: number
    serie: number
    operationType: string | null
    accessKey: string | null
    date: Date
    totalValue: number
    taxs: NewManualBackofficeInvoiceV2DetailsTaxs
    insuranceValue: number
    discountValue: number
    otherExpensesValue: number
    shippingValue: number | null
    cfop: number | null
}

export interface NewManualBackofficeInvoiceV2Duplicates {
    amount: number
    firstDueDate: Date
    intervalType: ManualBackofficeInvoiceDuplcatesInterval
}

export interface NewManualBackofficeInvoiceV2 {
    supplierId: string
    fisicalInputDate: Date | null
    details: NewManualBackofficeInvoiceV2Details
    products: NewBackofficeManualInvoiceProduct[]
    duplicates: NewManualBackofficeInvoiceV2Duplicates
}

export interface FiscalInvoiceBackup {
    fiscalProfileId: string
    fiscalProfile: string
    month: number
    year: number
    danfes: string | null
    xmls: string
}

export interface BackofficeImportedInvoiceUpdate {
    storageId: string | null
    inputDate: Date | null
}

export interface BackofficeInvoiceXLSXArgsIssueDate {
    since: Date
    until: Date
}

export interface BackofficeInvoiceXLSXArgsDueDate {
    since: Date
    until: Date
}

export interface BackofficeInvoiceXLSXArgsPerformDate {
    since: Date
    until: Date
}

export interface BackofficeInvoiceXLSXArgs {
    status: BackofficeInvoiceXLSXArgsStatus
    origin: BackofficeInvoiceXLSXArgsOrigin
    supplierIds: string[]
    issueDate: BackofficeInvoiceXLSXArgsIssueDate | null
    dueDate: BackofficeInvoiceXLSXArgsDueDate | null
    performDate: BackofficeInvoiceXLSXArgsPerformDate | null
}

export interface BackofficeBillInvoiceDuplicate {
    id: string | null
    code: string | null
    dueDate: Date | null
    performDate: Date
    value: number
    accountId: string | null
}

export interface BackofficeReceivedInvoiceHeader {
    id: string
    supplierName: string
    supplierDocument: string
    accessKey: string
    totalValue: number
    issueDate: Date
    state: string
    targetManifestion: string | null
    completeNfe: boolean
    kindNfe: string
    version: number
    digestValue: string | null
    numCorrection: string | null
    cancelDate: Date | null
    cancelJustification: string | null
    isImported: boolean
    hasPendingManifestion: boolean
    downloadCounter: number
}

export interface BackofficeResponseInvoiceManifest {
    statusSefaz: string
    messageSefaz: string
    status: string
    protocol: string
    typeManifest: string
    reason: string | null
}

export interface BackofficeGetReceivedInvoicesArgsIssueDate {
    since: Date
    until: Date
}

export interface BackofficeGetReceivedInvoicesArgs {
    focusCompanyId: string
    isComplete: boolean | null
    supplierDocument: string | null
    supplierName: string | null
    status: BackofficeReceivedInvoiceStatus[]
    issueDate: BackofficeGetReceivedInvoicesArgsIssueDate | null
    limit: number
}

export interface BackofficeIncomeStatement {
    grossRevenue: number
    grossProfit: number
    netTotal: number
    taxTotal: number
    categories: BackofficeCategoryTotal[]
    since: Date
    until: Date
}

export interface BackofficeCategoryTotal {
    name: string
    categoryId: string | null
    parcialProfit: number
    total: number
}

export interface BackofficeBillHistory {
    historicByDay: BackofficeBillHistoryByDay[]
    since: Date
    until: Date
}

export interface BackofficeBillHistoryByDay {
    billDataHistory: BackofficeBillDataHistory[]
    date: Date
}

export interface BackofficeBillDataHistory {
    billId: string
    value: number
}

export interface BackofficeCategoryHistory {
    historicByDay: BackofficeCategoryHistoryByDay[]
    since: Date
    until: Date
}

export interface BackofficeCategoryHistoryByDay {
    categoryDataHistory: BackofficeCategoryDataHistory[]
    date: Date
}

export interface BackofficeCategoryDataHistory {
    categoryName: string
    value: number
}

export interface BackofficeExtract {
    previousBalance: number
    finalBalance: number
    periodBalance: number
    totalReceipts: number
    totalExpenses: number
    billExtractData: BackofficeBillData[]
    since: Date
    until: Date
}

export interface BackofficeBillData {
    date: Date
    description: string
    categoryName: string
    billPlanCategories: BackofficeBillDataBillPlanCategories[]
    account: BackofficeBillAccount | null
    value: number
    balance: number
}

export interface BackofficeDescriptionReport {
    bills: BackofficeBillDescriptionData[]
    total: number
    since: Date
    until: Date
}

export interface BackofficeBillDescriptionData {
    description: string
    value: number
}

export interface BackofficeDayReport {
    bills: BackofficeBillDayData[]
    total: number
    since: Date
    until: Date
}

export interface BackofficeBillDayData {
    date: Date
    value: number
}

export interface BackofficeIncomeByCategory {
    categoryName: string
    value: number
}

export interface BackofficeCostCenterReport {
    costCenterBills: BackofficeCostCenterBills[]
    total: number
    since: Date
    until: Date
}

export interface BackofficeCostCenterBills {
    name: string
    value: number
}

export interface BackofficeBillSupplierTrackerReport {
    billSupplierTrackerData: BackofficeBillSupplierTrackerData[]
    since: Date
    until: Date
}

export interface BackofficeBillSupplierTrackerData {
    supplierId: string | null
    supplierName: string
    billDescription: string
    value: number
}

export interface BackofficeResumeBillsDueToTodayAccount {
    id: string
    name: string
}

export interface BackofficeResumeBillsDueToToday {
    id: string
    value: number
    status: BackofficeResumeBillsDueToTodayStatus
    description: string
    account: BackofficeResumeBillsDueToTodayAccount
}

export interface BackofficeResumeAccountBalances {
    id: string
    name: string
    balanceValue: number
}

export interface BackofficeResume {
    billsDueToToday: BackofficeResumeBillsDueToToday[]
    accountBalances: BackofficeResumeAccountBalances[]
}

export interface BackofficePeriodResumeToReceive {
    paid: number
    pending: number
    total: number
}

export interface BackofficePeriodResumeToPay {
    paid: number
    pending: number
    total: number
}

export interface BackofficePeriodResume {
    toReceive: BackofficePeriodResumeToReceive
    toPay: BackofficePeriodResumeToPay
    balance: number
    growth: number | null
}

export interface BackofficeBillPlanCategoriesReportBills {
    description: string
    performDate: Date
    dueDate: Date
    payDate: Date | null
    value: number
    account: string | null
    supplier: string | null
}

export interface BackofficeBillPlanCategoriesReport {
    id: string
    name: string
    total: number
    bills: BackofficeBillPlanCategoriesReportBills[]
}

export interface StoragePositionReportProduct {
    productId: string
    productName: string
    fiscalCode: string | null
    categoryId: string
    categoryName: string
    currentCount: number
    currentCountByProportionOfUnit: ConvertedProportionOfUnit | null
    count: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    unitCostValue: string | null
    totalCost: string | null
    basicStorageUnit: BasicStorageUnit
}

export interface StoragePositionReport {
    products: StoragePositionReportProduct[]
    totalCost: string
}

export interface BackofficeStoragesWithResume {
    storages: BackofficeStorageWithResume[]
    totalCost: string
    productsCount: number
}

export interface BackofficeStorageProductUnitCost {
    avgUnitCost: string | null
    id: string
    count: number
}

export interface BackofficeMultipleStorageProduct {
    storageId: string
    listProducts: BackofficeStorageProduct[]
}

export interface BackofficeStorageProductTransfersResumeTransfers {
    type: BackofficeStorageTransferType
    count: number
}

export interface BackofficeStorageProductTransfersResume {
    id: string
    initial: number
    transfers: BackofficeStorageProductTransfersResumeTransfers[]
}

export interface BackofficePaginationStorageProductTransfersResume {
    page: number | null
    itemsPerPage: number | null
    totalItems: number | null
    products: BackofficeStorageProductTransfersResume[]
}

export interface BackofficeMultipleStorageTransferProduct {
    productId: string
    count: number
}

export interface BackofficeMultipleStorageTransferProductV2 {
    productId: string
    count: number
    basicStorageUnit: BasicStorageUnit
}

export interface BackofficeInputV3 {
    productId: string
    storageId: string
    unitCostValue: string | null
    obs: string | null
    count: number
    basicStorageUnit: BasicStorageUnit
    date: Date
}

export interface BackofficeNewProductionRuleOutputs {
    productId: string
    count: number
}

export interface BackofficeNewProductionRule {
    inputs: BackofficeProductionRuleInput[]
    outputs: BackofficeNewProductionRuleOutputs[]
}

export interface BackofficeProductionRuleInput {
    productId: string
    count: number
    loss: number
}

export interface BackofficeProductionOutput {
    productId: string
    count: number
}

export interface BackofficeProductionRuleInputs {
    productId: string
    count: number
    loss: number
}

export interface BackofficeProductionRuleOutputs {
    productId: string
    count: number
}

export interface BackofficeProductionRule {
    id: string
    inputs: BackofficeProductionRuleInputs[]
    outputs: BackofficeProductionRuleOutputs[]
}

export interface BackofficeProductStatusAtStorage {
    productId: string
    storageId: string
    count: number
    unitCostValue: number | null
}

export interface BackofficeProductAlert {
    productId: string
    type: BackofficeNewProductRuleType
    ruleQuantity: number
    actualCount: number
}

export interface BackofficeProductRule {
    id: string
    productId: string
    type: BackofficeNewProductRuleType
    ruleQuantity: number
}

export interface BackofficeNewProductRule {
    productId: string
    type: BackofficeNewProductRuleType
    ruleQuantity: number
}

export interface BackofficeEditProductRule {
    id: string
    type: BackofficeEditProductRuleType | null
    ruleQuantity: number | null
}

export interface BackofficeResultCreateProductRuleError {
    rule: BackofficeNewProductRule
    reason: string
}

export interface BackofficeResultCreateProductRule {
    error: BackofficeResultCreateProductRuleError[]
    success: BackofficeProductRule[]
}

export interface BackofficeResultEditProductRuleError {
    rule: BackofficeEditProductRule
    reason: string
}

export interface BackofficeResultEditProductRule {
    error: BackofficeResultEditProductRuleError[]
    success: BackofficeProductRule[]
}

export interface BackofficeCurrentReportStorageStoragesProducts {
    id: string
    count: number
    price: number | null
}

export interface BackofficeCurrentReportStorageStorages {
    id: string
    products: BackofficeCurrentReportStorageStoragesProducts[]
}

export interface BackofficeCurrentReportStorage {
    value: number
    storages: BackofficeCurrentReportStorageStorages[]
}

export interface BackofficeStorageHistoryV4 {
    currentPage: number | null
    initial: number
    totalTransfersItems: number
    transfers: BackofficeStorageHistoryV3Transfers[]
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit
    proportionOfUnit: ProportionOfUnit | null
}

export interface BackofficeNewSupplier {
    name: string
    legalName: string | null
    inscricaoEstadual: string | null
    cpfOrCnpj: string | null
    address: BackofficeAddress | null
    bankAccount: BackofficeBankAccount | null
    billPlanCategoryId: string | null
    registerType: BackofficeSupplierRegisterType | null
    chartAccountId: string | null
    organizationId: string | null
    pixKeyType: PixKeyTypeDto | null
    pixKey: string | null
    email: string | null
    cellPhone: string | null
    phone: string | null
    contact: string | null
}

export interface BackofficeSupplier {
    id: string
    isZigSupplier: boolean
    name: string
    legalName: string | null
    inscricaoEstadual: string | null
    cpfOrCnpj: string | null
    address: BackofficeAddress | null
    bankAccount: BackofficeBankAccount | null
    billPlanCategoryId: string | null
    registerType: BackofficeSupplierRegisterType | null
    chartAccountId: string | null
    organizationId: string | null
    pixKeyType: PixKeyTypeDto | null
    pixKey: string | null
    email: string | null
    cellPhone: string | null
    phone: string | null
    contact: string | null
}

export interface BackofficeGetSuppliersParams {
    textSearch: string | null
    registerType: BackofficeSupplierRegisterType | null
    pagination: Pagination | null
}

export interface BackofficeGetSuppliersResponse {
    data: BackofficeSupplier[]
    pagination: PaginationResponse
}

export interface BackofficeNewTransfer {
    date: Date
    description: string
    value: number
    paid: boolean
    sourceAccountId: string
    destinationAccountId: string
}

export interface BackofficeTransfer {
    id: string
    date: Date
    description: string
    value: number
    paid: boolean
    sourceAccount: BackofficeBillAccount
    destinationAccount: BackofficeBillAccount
    sourceBill: BackofficeBill
    destinationBill: BackofficeBill
}

export interface BackofficeProductImporting {
    id: string
    unitCostValue: string | null
    count: number
    obs: string | null
}

export interface BackofficeProductImportingResultError {
    input: BackofficeProductImporting
    reason: string
}

export interface BackofficeProductImportingResult {
    success: BackofficeProductImporting[]
    error: BackofficeProductImportingResultError[]
}

export interface SupplierAbcCurveBase {
    name: string
    total: number
    cumulativeTotal: number
    percentage: number
    cumulativePercentage: number
    tier: string
}

export interface SupplierAbcCurve {
    total: number
    valueCurveA: number
    valueCurveB: number
    valueCurveC: number
    curve: SupplierAbcCurveBase[]
    pagination: PaginationResponse
}

export interface ProductAbcCurveBase {
    name: string
    fiscalCode: string | null
    count: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    unitMeasurement: string
    avgUnitCost: number
    total: number
    cumulativeTotal: number
    percentage: number
    cumulativePercentage: number
    tier: string
}

export interface ProductAbcCurve {
    total: number
    valueCurveA: number
    valueCurveB: number
    valueCurveC: number
    curve: ProductAbcCurveBase[]
}

export interface BackofficeUpdateStorageUnitCostProduct {
    productId: string
    storageId: string
    unitCostValue: string
}

export interface PlaceBankAccountResponse {
    id: string
    createdAt: Date
    updatedAt: Date
    isDefault: boolean
    holder: string
    name: string
    pixKey: PixKeyDto | null
    receiver: BankAccountReceiverDto | null
}

export interface PlaceBankAccountPaginationResponse {
    data: PlaceBankAccountResponse[]
    pagination: BasePaginationResponse
}

export interface BaseBar {
    id: string | null
    name: string
    image: ImageUrl | null
    storageId: string
    storageName: string | null
    internalIp: string | null
    internalIps: string[] | null
    fichaLogoSha256: string | null
}

export interface BarRequest {
    id: string | null
    name: string
    image: ImageUrl | null
    storageId: string
    storageName: string | null
    internalIp: string | null
    internalIps: string[] | null
    fichaLogoSha256: string | null
    fichaLogo: ArrayBuffer | null
    menuIds: string[]
}

export interface Bar {
    id: string | null
    name: string
    image: ImageUrl | null
    storageId: string
    storageName: string | null
    internalIp: string | null
    internalIps: string[] | null
    fichaLogoSha256: string | null
    fichaLogoUrl: string | null
    isDeleted: boolean | null
}

export interface BarWithMenus {
    id: string | null
    name: string
    image: ImageUrl | null
    storageId: string
    storageName: string | null
    internalIp: string | null
    internalIps: string[] | null
    fichaLogoSha256: string | null
    fichaLogoUrl: string | null
    isDeleted: boolean | null
    menus: MenuInfo[]
    kds: KdsInfo | null
    pagseguroEcActivationCode: string | null
    pagseguroEcCnpj: string | null
    getnetEcCnpj: string | null
    productsCount: number | null
}

export interface MenuInfo {
    id: string
    name: string
    isActive: boolean
    isDefault: boolean
}

export interface KdsInfo {
    id: string
    name: string
}

export interface BarsDevices {
    id: string | null
    name: string
    deviceQuantity: number
}

export interface EditableBarFields {
    name: string
    storageId: string
    internalIps: string[]
    fichaLogoImageId: string | null
    pagseguroEcActivationCode: string | null
    pagseguroEcCnpj: string | null
    getnetEcCnpj: string | null
}

export interface PlacesProductsWereSoldBodyProportionalValue {
    value: number
    quantity: number
    unit: string
}

export interface PlacesProductsWereSoldBody {
    placeName: string
    placeId: string
    count: number
    proportionalValue: PlacesProductsWereSoldBodyProportionalValue | null
    totalValue: number
}

export interface ProductsByBarsAtPlace {
    barId: string | null
    barName: string | null
    products: ProductsSoldReportResponse[]
}

export interface SellerTransactionClients {
    id: string
    cpf: string
    name: string
    zigCode: string | null
}

export interface SellerTransactionProducts {
    name: string
    count: number
    isIssued: boolean
}

export interface SellerTransactionInvoiceInfo {
    id: string
    pdfUrl: string | null
    imgUrl: string | null
}

export interface SellerTransaction {
    id: string
    date: Date
    clients: SellerTransactionClients[]
    value: number
    tip: number
    refunded: boolean
    products: SellerTransactionProducts[]
    invoiceInfo: SellerTransactionInvoiceInfo | null
    serialNumber: string | null
}

export interface ProductSoldMountables {
    id: string
    name: string
    count: number
    section: string
}

export interface ProductsSoldReportResponse {
    productId: string
    fiscalCode: string
    productName: string
    categoryId: string
    categoryName: string
    image: ImageUrl | null
    productValues: ProductValuesHistory[] | null
    mountableProducts: ProductSoldMountables[] | null
    count: number
    unitValue: number[]
    subtotal: number
    discount: number
    totalValue: number
    proportionalValue: ProportionalValue[] | null
}

export interface ProductsSoldOrderBy {
    column: ProductsSoldOrderByColumn
    order: ProductsSoldOrderByOrder
}

export interface ProductSoldFilters {
    categoryIds: string[] | null
    productIds: string[] | null
    sources: TransactionSource[] | null
    sectorIds: string[] | null
}

export interface ProductsSoldOverviewResponse {
    count: number
    subtotal: number
    discount: number
    totalValue: number
}

export interface ProductByBarFilters {
    barIds: string[] | null
    productIds: string[] | null
    sources: TransactionSource[] | null
    sectorIds: string[] | null
}

export interface ProductValuesHistory {
    count: number
    unitValue: number
    subtotal: number
    discount: number
    totalValue: number
    proportionalValue: ProportionalValue | null
}

export interface BaseProduct {
    id: string
    name: string
    count: number
    fiscalCode: string
}

export interface SimplifiedSeller {
    role: string | null
    roleId: string | null
    username: string | null
    name: string
    id: string
}

export interface BurnedPaperTicket {
    productId: string
    productName: string
    count: number
}

export interface ProductBurnedTicketSold {
    id: string
    name: string
    category: string
    image: ImageUrl | null
    count: number
    type: SellableThing
    totalValue: number
    totalDiscount: number
    fiscalCode: string
    mountableProducts: ProductSoldMountableProducts[]
    isMountable: boolean | null
    productUnitCost: string | null
    proportionalValue: ProportionalValue | null
    estimatedTax: number | null
    isReturnable: boolean | null
    employee: string
    employeeUsername: string | null
    transactionSource: TransactionSource
}

export interface RechargeDetails {
    id: string
    totalValue: number
    usedValue: number
    isRefunded: boolean
    date: Date
    user: string
    method: string
    zigCode: string | null
    serialNumber: string | null
}

export interface Payment {
    method: string
    value: number
}

export interface PostDetails {
    id: string
    payments: Payment[]
    payers: string[]
    date: Date
    zigCode: string | null
    serialNumber: string | null
    isRefunded: boolean | null
}

export interface CashierClosingObs {
    author: string
    authorUsername: string | null
    obs: string
    cashierId: string
    date: Date
}

export interface CateringProductComboChild {
    productId: string
    name: string
    count: number
    value: number
    image: ImageUrl | null
}

export interface CateringProductMountableSectionItem {
    productId: string
    name: string
    price: number
    maxCount: number | null
    image: ImageUrl | null
}

export interface CateringProductMountableSection {
    id: string
    title: string
    min: number
    max: number
    pricing: CateringMountableSectionPricing
    items: CateringProductMountableSectionItem[]
}

export interface CateringProductListItem {
    id: string
    name: string
    category: string
    categoryId: string
    type: CateringProductSubType
    value: number
    image: ImageUrl | null
    comboProducts: CateringProductComboChild[] | null
    mountableSections: CateringProductMountableSection[] | null
}

export interface CateringProductCounters {
    total: number
    product: number
    combo: number
    mountable: number
}

export interface CateringProductListResponse {
    data: CateringProductListItem[]
    pagination: PaginationResponse
    counters: CateringProductCounters
}

export interface NewCateringComboPayloadProducts {
    productId: string
    count: number
}

export interface NewCateringComboPayload {
    products: NewCateringComboPayloadProducts[]
    description: string | null
}

export interface NewCateringProduct {
    name: string
    categoryId: string
    value: number
    type: CateringProductSubType
    mountableDescription: NewMountableDescriptionWithStatus | null
    combo: NewCateringComboPayload | null
}

export interface DeleteCateringProductsFailure {
    productId: string
    reason: string
}

export interface DeleteCateringProductsResponse {
    deleted: string[]
    failed: DeleteCateringProductsFailure[]
}

export interface NewCateringProductBulkItem {
    name: string
    categoryId: string
    value: number
    image: EditProductImage | null
}

export interface BulkImportCateringProductsCreated {
    index: number
    productId: string
    name: string
}

export interface BulkImportCateringProductsFailure {
    index: number
    name: string
    reason: string
}

export interface BulkImportCateringProductsResponse {
    created: BulkImportCateringProductsCreated[]
    failed: BulkImportCateringProductsFailure[]
}

export interface BaseCategory {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
}

export interface CategorySubCategoriesSubCategories {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
}

export interface CategorySubCategories {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
    subCategories: CategorySubCategoriesSubCategories[]
}

export interface Category {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
    subCategories: CategorySubCategories[]
    chartAccount: BackOfficeChartAccountResponse | null
}

export interface NewCategory {
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    parentId: string | null
    chartAccountId: string | null
}

export interface SellableListProducts {
    id: string
    name: string
    category: string
    type: string
    image: ImageUrl | null
    hasAlcohol: boolean | null
    fiscalCode: string | null
    systemProductId: string | null
}

export interface SellableListCombos {
    id: string
    name: string
    description: string
    category: string
    image: ImageUrl | null
}

export interface SellableList {
    products: SellableListProducts[]
    combos: SellableListCombos[]
}

export interface CategoryWithTotalProducts {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
    totalProducts: number
    chartAccount: BackOfficeChartAccountResponse | null
    subCategories: CategoryWithTotalProducts[]
}

export interface SummarizedCategory {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
    totalProducts: number
    subCategories: SummarizedCategory[]
}

export interface CmvReportOverrite {
    productUnitCost: string | null
}

export interface NewCmvReport {
    id: string
    productName: string
    productCategory: string
    fiscalCode: string
    ncm: string | null
    count: number
    totalValue: string
    totalDiscount: string
    productUnitCost: string | null
    mountables: CmvReportMountables[]
    totalCost: string
    totalProfit: string
    profitMargin: number
    countByProportionOfUnit: ConvertedProportionOfUnit | null
    cmv: number
    value: string
    lostCount: number
    lostCountByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    basicStorageUnit: BasicStorageUnit | null
}

export interface CmvReportResult {
    items: NewCmvReport[]
    totalCount: number
    totalValue: string
    totalCost: string
    totalProfit: string
    profitMargin: number
}

export interface ProductStoragePosition {
    id: string
    fiscalCode: string | null
    category: string
    name: string
    count: number
    averageUnitValue: string | null
}

export interface CmvMonthlyClosing {
    productsSold: number
    productsDiscount: number
    cmv: string | null
    cmvProductionLost: string | null
    cmvLost: string | null
}

export interface ProductLostReport {
    id: string
    fiscalCode: string | null
    category: string
    name: string
    lost: number
    lostByProportionOfUnit: ConvertedProportionOfUnit | null
    inventory: number
    inventoryByProportionOfUnit: ConvertedProportionOfUnit | null
    refund: number
    refundByProportionOfUnit: ConvertedProportionOfUnit | null
    productionLost: number
    productionLostByProportionOfUnit: ConvertedProportionOfUnit | null
    totalLost: number
    totalLostByProportionOfUnit: ConvertedProportionOfUnit | null
    averageUnitValue: string | null
    totalCost: string | null
    basicStorageUnit: BasicStorageUnit | null
    proportionOfUnit: ProportionOfUnit | null
}

export interface BackofficeLostReportPagination {
    page: number
    itemsPerPage: number | null
}

export interface BackofficeLostReportTotals {
    cost: string
}

export interface BackofficeLostReport {
    items: ProductLostReport[]
    totals: BackofficeLostReportTotals
    page: number
    itemsPerPage: number
    totalItems: number
}

export interface NewPlaceComboProducts {
    id: string
    count: number
}

export interface NewPlaceCombo {
    name: string
    value: number
    description: string | null
    category: string
    active: boolean
    fiscalData: ProductFiscalData | null
    products: NewPlaceComboProducts[]
    printComboProductsIndividually: boolean | null
}

export interface PlaceComboProducts {
    id: string
    count: number
    name: string
    image: ImageUrl | null
    category: string
}

export interface PlaceCombo {
    id: string
    name: string
    value: number
    description: string | null
    category: string
    active: boolean
    fiscalData: ProductFiscalData | null
    products: PlaceComboProducts[]
    image: ImageUrl | null
    printComboProductsIndividually: boolean | null
}

export interface DataCombo {
    id: string
    updatedAt: Date
    value: number
    placeId: string
    isActive: boolean
    name: string
    categoryId: string
    organizationId: string
    imageId: string | null
    description: string | null
    fiscalCode: string | null
    fiscalNcm: string | null
    fiscalCest: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
    fiscalProductGroupId: string | null
    fiscalProfileId: string | null
    isActiveForGrabAndGo: boolean
    isDeleted: boolean
}

export interface ComodatoContractListItem {
    id: string
    contractNumber: string
    requestType: ComodatoContractRequestType
    requestModel: ComodatoContractRequestModel
    signatoryName: string
    requestedAt: Date
    signedAt: Date | null
    expiresAt: Date
    status: ComodatoContractStatus
    canResendSignature: boolean
}

export interface ComodatoContractListFilters {
    status: ComodatoContractStatus[] | null
    contractNumber: string | null
    dateFrom: Date | null
    dateTo: Date | null
}

export interface ComodatoContractListPagination {
    page: number | null
    limit: number | null
    sortBy: ComodatoContractSortBy | null
    sortOrder: SortOrder | null
}

export interface ComodatoContractListResponsePagination {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface ComodatoContractListResponse {
    data: ComodatoContractListItem[]
    pagination: ComodatoContractListResponsePagination
}

export interface ComodatoContractListRequest {
    placeId: string
    filters: ComodatoContractListFilters | null
    pagination: ComodatoContractListPagination | null
}

export interface ExportComodatoContractsRequest {
    placeId: string
    filters: ComodatoContractListFilters | null
}

export interface ResendComodatoContractSignatureRequest {
    contractId: string
}

export interface UpsertProductsWebRequest {
    slug: string | null
    bar: string | null
}

export interface UpsertProductsWebResponse {
    slug: string | null
    bar: string | null
}

export interface DeliveryFeeFiscalProductGroupDeliveryFee {
    id: string
    name: string
    description: string | null
    issueInvoice: boolean
}

export interface DeliveryFeeFiscalProductGroupBinding {
    deliveryFee: DeliveryFeeFiscalProductGroupDeliveryFee
    fiscalProductGroupId: string | null
}

export interface Device {
    code: string
    id: string
}

export interface DeviceEventStatusCleanedDataEmployee {
    name: string
    username: string
}

export interface DeviceEventStatusCleanedData {
    employee: DeviceEventStatusCleanedDataEmployee
    date: Date
}

export interface DeviceEventStatusDeviceConfig {
    wifi: boolean | null
    bluetooth: boolean | null
    offlineMode: boolean | null
    nfc: boolean | null
    isMobileDataEnabled: boolean | null
    mobileDataCarrier: string | null
    mobileDataType: string | null
    airplaneMode: boolean | null
    mposConnected: boolean | null
    mposConnectedMac: string | null
    remainingBattery: number | null
}

export interface DeviceEventStatusDevicePreferences {
    isSearchByCodeEnabled: boolean | null
    dettachOnCheckout: boolean | null
    hideDettachOption: boolean | null
    hidePaymentModeVoucher: boolean | null
    isNormalSellEnabled: boolean | null
    isGroupedSellEnabled: boolean | null
    isSellWithoutCardEnabled: boolean | null
    printTwoTickets: boolean | null
    isStorageTransferPrinterLanActive: boolean | null
    printViaBtForWaiter: boolean | null
    isNumericKeyboardInObsEnabled: boolean | null
    registerWithoutCard: boolean | null
    removeCreditDebitPaymentOption: boolean | null
    isKeyboardOpenEnabled: boolean | null
    isStockTransfEnabled: boolean | null
}

export interface DeviceEventStatusDevicePlatformScreen {
    width: number | null
    height: number | null
}

export interface DeviceEventStatusDevicePlatform {
    brand: string | null
    model: string | null
    screen: DeviceEventStatusDevicePlatformScreen | null
    version: string | null
    sdkVersion: number | null
}

export interface DeviceEventStatus {
    id: string
    fingerprint: string
    employeeId: string | null
    employeeName: string | null
    employeeUsername: string | null
    shouldEmployeeConnectToMpos: boolean | null
    firstActivity: Date
    lastOfflineSync: Date
    pdvVersion: string
    hasFinishedActivity: boolean | null
    hasCleanedData: boolean
    deviceType: string | null
    cleanedData: DeviceEventStatusCleanedData[]
    deviceConfig: DeviceEventStatusDeviceConfig
    devicePreferences: DeviceEventStatusDevicePreferences
    devicePlatform: DeviceEventStatusDevicePlatform | null
}

export interface DeviceConfig {
    id: string
    fingerprint: string
    employeeId: string | null
    employeeName: string | null
    updatedAt: Date | null
    createdAt: Date | null
    version: string | null
    status: string | null
}

export interface DiscountPercentageRange {
    minDiscountPercentage: number
    maxDiscountPercentage: number
}

export interface DiscountValueRange {
    minValue: number
    maxValue: number
}

export interface BaseDiscountCategory {
    name: string
    discountPercentageRange: DiscountPercentageRange | null
    discountValueRange: DiscountValueRange | null
    type: DiscountCategoryType
    hasObservation: boolean | null
}

export interface CreateDiscountCategoryRequest {
    name: string
    discountPercentageRange: DiscountPercentageRange | null
    discountValueRange: DiscountValueRange | null
    type: DiscountCategoryType
    hasObservation: boolean | null
}

export interface UpdateDiscountCategoryRequest {
    name: string
    discountPercentageRange: DiscountPercentageRange | null
    discountValueRange: DiscountValueRange | null
    type: DiscountCategoryType
    hasObservation: boolean | null
}

export interface DiscountCategoryResponse {
    name: string
    discountPercentageRange: DiscountPercentageRange | null
    discountValueRange: DiscountValueRange | null
    type: DiscountCategoryType
    hasObservation: boolean | null
    id: string
    createdAt: Date
    updatedAt: Date
    isDeleted: boolean
}

export interface DiscountCategoryResponseWithPlaces {
    name: string
    discountPercentageRange: DiscountPercentageRange | null
    discountValueRange: DiscountValueRange | null
    type: DiscountCategoryType
    hasObservation: boolean | null
    id: string
    createdAt: Date
    updatedAt: Date
    isDeleted: boolean
    isActive: boolean
}

export interface DiscountCategoriesResponse {
    data: DiscountCategoryResponseWithPlaces[]
    pagination: PaginationResponse
}

export interface EmployeesByDiscountCategory {
    id: string | null
    name: string
    username: string
    br: string | null
}

export interface DiscountCategoryFilters {
    isActive: boolean | null
    name: string | null
}

export interface OperationResult {
    message: string
    employeeId: string
}

export interface MultipleEmployeeResult {
    error: OperationResult[]
    success: OperationResult[]
}

export interface Employee {
    id: string
    name: string
    username: string
    zigReadPermissionKey: string | null
    avatar: ImageUrl | null
    permissions: Permission[]
    role: Role | null
    organization: Organization
    places: Place[]
    zigTag: string | null
    deviceIds: string[] | null
    blockedBarIds: string[] | null
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    type: EmployeeType | null
    isDeleted: boolean | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    bars: string[] | null
    email: string | null
}

export interface EmployeeV2Places {
    id: string
    name: string
}

export interface EmployeeV2Bars {
    id: string | null
    name: string
    image: ImageUrl | null
    storageId: string
    storageName: string | null
    internalIp: string | null
    internalIps: string[] | null
    fichaLogoSha256: string | null
    fichaLogoUrl: string | null
    isDeleted: boolean | null
    isMainBar: boolean
    shouldPrint: boolean
}

export interface EmployeeV2 {
    id: string
    name: string
    username: string
    avatar: ImageUrl | null
    permissions: Permission[]
    role: Role | null
    places: EmployeeV2Places[]
    bars: EmployeeV2Bars[]
    zigTag: string | null
    deviceIds: string[] | null
    blockedBarIds: string[] | null
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
}

export interface GetEmployeesV2Filters {
    placeIds: string[] | null
}

export interface EditMultipleEmployeesBars {
    id: string
    isMainBar: boolean
    shouldPrint: boolean
    operation: EditMultipleEmployeesBarsOperation
}

export interface EditMultipleEmployees {
    username: string | null
    initialUsernameNumber: number | null
    name: string | null
    initialNameNumber: number | null
    permissions: Permission[] | null
    role: Role | null
    bars: EditMultipleEmployeesBars[] | null
    placeIds: string[] | null
    blockedBarIds: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
}

export interface AddMultipleEmployeesV2Employee {
    name: string
    zigReadPermissionKey: string | null
    permissions: Permission[]
    role: Role | null
    places: string[]
    bars: BaseEmployeeBars[]
    blacklistEntrances: string[] | null
    fichasAmount: number | null
    menuVisualizationType: EmployeeMenuVisualizationType | null
    shouldBeBoundToAllPlaces: boolean | null
    type: EmployeeType | null
    assignableRoleIds: string[] | null
    assignableBarIds: string[] | null
    sectors: string[] | null
    vendors: string[] | null
    email: string | null
    password: string | null
    isPDV: boolean | null
    username: string
    barId: string | null
    since: number | null
    until: number | null
    image: ArrayBuffer | null
}

export interface EmployeeDeviceConfigsUpdatePreferences {
    isSearchByCodeEnabled: boolean
    dettachOnCheckout: boolean
    hideDettachOption: boolean
    hidePaymentModeVoucher: boolean
    isNormalSellEnabled: boolean
    isGroupedSellEnabled: boolean
    isSellWithoutCardEnabled: boolean
    printTwoTickets: boolean
    isStorageTransferPrinterLanActive: boolean
    printViaBtForWaiter: boolean
    isNumericKeyboardInObsEnabled: boolean
    registerWithoutCard: boolean
    removeCreditDebitPaymentOption: boolean
    isKeyboardOpenEnabled: boolean
    isStockTransfEnabled: boolean
}

export interface EmployeeDeviceConfigsUpdate {
    version: string | null
    wifi: boolean | null
    bluetooth: boolean | null
    offlineMode: boolean | null
    connectToMpos: boolean | null
    preferences: EmployeeDeviceConfigsUpdatePreferences | null
}

export interface Entrance {
    id: string | null
    name: string
    category: string
    value: number
    image: ImageUrl | null
    minimumConsumptionValue: number
    active: boolean
    consumptionObligation: number
    fiscalData: PlaceProductFiscalData | null
    fiscalCode: string | null
    menuCategoryId: string | null
    proportionalValue: ProportionalValue | null
    bonus: number | null
}

export interface EntranceSold {
    id: string
    name: string
    image: ImageUrl | null
    count: number
    totalValue: number
    discountValue: number
    unitValue: number
    proportionalValue: ProportionalValue | null
}

export interface RelationTicket {
    names: string | null
    count: number
}

export interface TicketSold {
    id: string
    name: string
    averageValue: number
    perRelation: RelationTicket[]
}

export interface Bilheteiro {
    id: string
    name: string
    tickets: TicketSold[]
}

export interface EntranceUser {
    id: string
    name: string
    cpf: string
    date: Date
    productName: string
    category: string
    count: number
    unitValue: number
    employeeName: string
    totalValue: number
    totalDiscountValue: number
}

export interface UsersEntrancesConsumedEntrances {
    id: string
    name: string
}

export interface UsersEntrancesConsumed {
    id: string
    name: string | null
    document: string
    phone: string
    birthDate: Date | null
    entrances: UsersEntrancesConsumedEntrances[]
    entranceValue: number
    consumption: number
    total: number
    checkinTime: Date
    checkoutTime: Date | null
}

export interface UsersEntrancesConsumedReportResponse {
    data: UsersEntrancesConsumed[]
    pagination: PaginationResponse
}

export interface UsersEntrancesConsumedReportFilters {
    entranceIds: string[] | null
    period: PeriodTime | null
}

export interface UsersEntrancesConsumedOverview {
    totalUsers: number
    entranceTotal: number
    consumptionTotal: number
    total: number
}

export interface SummaryEvent {
    id: string
    name: string
    status: EventState
    begin: Date
    end: Date | null
    image: ImageUrl | null
    tags: string[]
    unfinishedPdvs: number | null
    hasOpenedTables: boolean | null
    lastSyncAfterClosed: Date | null
    income: number | null
    totalPublic: number | null
    averageTicket: number | null
    sales: EventsSummarySales | null
    closingConferenceStatus: ClosingEventConferenceStatus | null
    openedBy: string | null
    openedAt: Date | null
    checkedAt: Date | null
    checkedBy: CheckedBy | null
}

export interface EventsSummarySales {
    productsSold: number | null
    entrance: number | null
    service: number | null
    remainingConsumptionObligation: number | null
    manualInvoices: number | null
}

export interface EventListIncomeSummary {
    cash: number
    credit: number
    debit: number
    app: number
    pix: number
    rappi: number
    uber: number
    ifood: number
    ame: number
    deliveryOnline: number
    voucher: number
    mbway: number
    anticipated: number
    dashboard: number
    online: number
    postEvent: number
    singleProductReturns: number
    rechargesReturned: number
    consummationGiven: number
    totalRefundedPostPayments: number | null
}

export interface EventList {
    totalClients: number
    averageTicket: number
    totalIncome: number
    futureEvents: number
    totalSales: EventsSummarySales
    incomeSummary: EventListIncomeSummary | null
    events: SummaryEvent[]
}

export interface EventBaseInfo {
    sales: number
    public: number
    id: string
    placeId: string
}

export interface BankslipInfo {
    exists: boolean
    value: number | null
    expirationDate: Date | null
    attachments: string[] | null
}

export interface MaximumPossibleAnticipationValuesResult {
    anticipationLiquidValue: number
    anticipationBruteValue: number
    proRataFee: number
}

export interface WithdrawRequestIdsWithDate {
    id: string
    createdAt: Date
    attachments: string[] | null
}

export interface AuthKeyValueData {
    keyType: AuthKeyType
    keyValue: string
}

export interface CreateWithdrawAuthKeyRequest {
    placeId: string | null
    vendorId: string | null
    values: AuthKeyValueData[]
}

export interface GetWithdrawAuthKeysRequest {
    placeId: string | null
    vendorId: string | null
}

export interface WithdrawAuthKeyResponse {
    id: string
    keyType: AuthKeyType
    keyValue: string
    status: AuthKeyStatus
    attempts: number
    lastSentAt: Date | null
    createdAt: Date
}

export interface CreateWithdrawAuthKeysResponse {
    success: WithdrawAuthKeyResponse[]
    errors: CreateWithdrawAuthKeyError[]
}

export interface CreateWithdrawAuthKeyError {
    keyValue: string
    error: string
}

export interface UnlockWithdrawAuthKeyRequest {
    authKeyId: string
}

export interface DeleteWithdrawAuthKeyRequest {
    authKeyIds: string[]
}

export interface DeleteWithdrawAuthKeyResponse {
    success: string[]
    errors: DeleteWithdrawAuthKeyError[]
}

export interface DeleteWithdrawAuthKeyError {
    authKeyId: string
    error: string
}

export interface RequestAuthKeyCodeRequest {
    authKeyId: string
}

export interface RequestAuthKeyCodeResponse {
    expiresAt: Date
}

export interface ValidateAuthKeyCodeRequest {
    authKeyId: string
    code: string
}

export interface ValidateAuthKeyCodeResponse {
    valid: boolean
}

export interface BillPayment {
    method: PaymentMethod
    value: number
}

export interface MultipleUserIdsResultError {
    userId: string
    reason: string
}

export interface MultipleUserIdsResult {
    success: string[]
    error: MultipleUserIdsResultError[]
}

export interface ZigMachineResume {
    debit: number
    credit: number
}

export interface IncomeResume {
    products: number
    entrances: number
}

export interface Client {
    id: string
    cpf: string
    birthDate: Date | null
    hasApp: boolean
    name: string
    phone: string
    zigCode: string | null
    appTransactionsValue: number
    housePostPaidTransactionsValue: number
    housePrePaidTransactionsValue: number
    bonusTransactionsValue: number
    remaningValueOnPlace: number
}

export interface ClientAtPlace {
    id: string
    cpf: string
    birthDate: Date | null
    hasApp: boolean
    name: string
    phone: string
    zigCode: string | null
    appTransactionsValue: number
    housePostPaidTransactionsValue: number
    housePrePaidTransactionsValue: number
    bonusTransactionsValue: number
    remaningValueOnPlace: number
    hasBiometry: boolean | null
    avatarUrl: string | null
}

export interface OptionsClientsEvent {
    invoicesNotIssued: boolean | null
    includeTable: boolean | null
}

export interface MountableSectionProduct {
    id: string
    name: string
    count: number
    title: string
    storageCount: number
    maxCount: number | null
    price: number
    isActive: boolean
    basicStorageUnit: string
}

export interface UserTransactionProduct {
    id: string
    type: SellableThing
    name: string
    count: number
    value: number | null
    discountValue: number | null
    sections: MountableSectionProduct[] | null
}

export interface Payments {
    bonus: number
    prePaid: number
    ppu: number
    postPaid: number
}

export interface TransactionBuyers {
    id: string
    name: string
}

export interface UserTransaction {
    id: string
    products: UserTransactionProduct[]
    seller: Seller
    buyers: TransactionBuyers[]
    date: Date
    refunded: boolean
    tip: number
}

export interface Debtor {
    userId: string
    userName: string
    userDocument: string
    value: number
    tipValue: number
    paidValue: number
    paidTipValue: number
    phone: string
    email: string | null
    status: DebtorStatus
    openBillChargeId: string | null
}

export interface DebtorsFilters {
    status: DebtorStatus | null
    userName: string | null
    userDocument: string | null
}

export interface OpenedBillsOverview {
    value: number
    tipValue: number
    paidValue: number
    paidTipValue: number
    valueExemptFromTip: number
    paidInOtherEvents: number
    openBillsTotal: number
}

export interface PaginatedDebtorsResponse {
    data: Debtor[]
    pagination: PaginationResponse
    totalizers: OpenedBillsOverview
}

export interface DebtorsXlsInput {
    scope: GetReportByScope
    filters: DebtorsFilters
}

export interface UserBonusReportGivenBy {
    name: string
    username: string | null
}

export interface UserBonusReport {
    id: string
    name: string
    receivedValue: number
    spentValue: number
    givenBy: UserBonusReportGivenBy
    reason: string | null
    date: Date | null
    spentInOtherEvent: number
    bonusCategoryId: string | null
    bonusCategoryName: string | null
}

export interface BonusReportFilters {
    bonusCategoryIds: string[] | null
    employeesIds: string[] | null
}

export interface BonusReportInput {
    eventId: string
    filters: BonusReportFilters
    pagination: Pagination
}

export interface BonusReportForPlaceInputFilters {
    bonusCategoryIds: string[] | null
    employeesIds: string[] | null
    since: Date
    until: Date
}

export interface BonusReportForPlaceInput {
    placeId: string
    filters: BonusReportForPlaceInputFilters
    pagination: Pagination
}

export interface BonusReportResponse {
    data: UserBonusReport[]
    pagination: PaginationResponse
}

export interface BonusReportXlsInput {
    scope: GetReportByScope
    filters: BonusReportFilters
}

export interface BonusReportSummary {
    receivedValue: number
    spentValue: number
    tipValue: number
    spentTipValueInOtherEvent: number
    spentInOtherEvent: number
    unusedValue: number
}

export interface BonusReportOverview {
    receivedValue: number
    spentValue: number
    spentInOtherEvent: number
}

export interface BonusReportForPlaceOverviewInputFilters {
    bonusCategoryIds: string[] | null
    employeesIds: string[] | null
    since: Date
    until: Date
}

export interface BonusReportForPlaceOverviewInput {
    placeId: string
    filters: BonusReportForPlaceOverviewInputFilters
}

export interface BonusReportOverviewInput {
    eventId: string
    filters: BonusReportFilters
}

export interface UsedBonusReportUser {
    id: string
    name: string
}

export interface UsedBonusReportGivenBy {
    name: string
    username: string
}

export interface UsedBonusReport {
    id: string
    user: UsedBonusReportUser
    spentValue: number
    givenAt: Date | null
    givenBy: UsedBonusReportGivenBy | null
    reason: string | null
    consumedAt: Date | null
}

export interface ClientDetails {
    id: string
    name: string
    email: string | null
    hasApp: boolean
    hasBiometry: boolean | null
    zigCode: string | null
    phone: string
    cpf: string
    avatar: ImageUrl | null
}

export interface OpenedProduct {
    openedValue: number
    estimatedCount: number
    name: string
    id: string
    category: string
}

export interface RechargeConsumption {
    value: number
    user: string
    method: RechargeConsumptionMethod
    author: string
}

export interface RefundedRechargeAuthor {
    name: string
    username: string | null
}

export interface RefundedRechargeRefundedBy {
    name: string
    username: string | null
}

export interface RefundedRecharge {
    id: string
    totalValue: number
    usedValue: number
    date: Date
    userName: string | null
    author: RefundedRechargeAuthor
    refundedBy: RefundedRechargeRefundedBy
}

export interface ActivationReturnReportProducts {
    id: string
    count: number
    name: string
}

export interface ActivationReturnReport {
    cashValue: number
    cashQuantity: number
    products: ActivationReturnReportProducts[]
}

export interface UsedPromotion {
    promotionId: string
    promotionName: string
    productId: string
    productName: string
    productCategory: string
    totalDiscount: number
    uses: number
}

export interface UserUsedPromotion {
    userId: string
    userName: string
    userDocument: string
    promotion: UsedPromotion
}

export interface TableUsedPromotion {
    tableId: string
    tableName: string
    openedAt: Date
    closedAt: Date | null
    promotionId: string
    promotionName: string
    productName: string
    productCategory: string
    uses: number
    discountValue: number
}

export interface TotalsTablePromotion {
    totalCount: number
    totalDiscount: number
}

export interface TotalTablePromotionReport {
    totals: TotalsTablePromotion
    promotions: TableUsedPromotion[]
    pagination: PaginationResponse
}

export interface TablePromotionsUsedFilters {
    tableNumbers: string[] | null
    promotionId: string[] | null
}

export interface UsedPromotionsInScope {
    promotionId: string
    promotionName: string
}

export interface SoldEntranceWithEmployee {
    employeeId: string
    employeeName: string
    employeeUsername: string | null
    entranceId: string
    entranceName: string
    totalValue: number
    count: number
}

export interface TipRemovedListRemovals {
    id: string
    name: string
    value: number
    reason: string
    date: Date
}

export interface TipRemovedList {
    employee: MinimalEmployee
    totalRemoved: number
    removals: TipRemovedListRemovals[]
}

export interface CardReturnEmployeeCashReturn {
    count: number
    value: number
}

export interface CardReturnEmployeeProductReturn {
    id: string
    count: number
    name: string
}

export interface CardReturnEmployeePixReturn {
    count: number
    value: number
}

export interface CardReturnEmployee {
    id: string
    name: string
    username: string | null
    cashReturn: CardReturnEmployeeCashReturn
    productReturn: CardReturnEmployeeProductReturn[]
    pixReturn: CardReturnEmployeePixReturn
}

export interface DiscountEmployeeDiscountsUsers {
    id: string
    name: string
}

export interface DiscountEmployeeDiscountsDiscountCategory {
    id: string
    name: string
}

export interface DiscountEmployeeDiscounts {
    date: Date
    value: number
    users: DiscountEmployeeDiscountsUsers[]
    products: string[]
    reason: string | null
    percentual: number | null
    discountCategory: DiscountEmployeeDiscountsDiscountCategory | null
}

export interface DiscountEmployee {
    id: string
    name: string
    username: string | null
    discounts: DiscountEmployeeDiscounts[]
}

export interface ManualInvoice {
    eventId: string
    invoiceId: string
    value: number
    paymentMethod: string
}

export interface PostLimitChange {
    userName: string | null
    employeeId: string
    employeeName: string
    employeeUsername: string | null
    date: Date
    limit: number
}

export interface OpenedBillPaymentUser {
    id: string
    name: string
}

export interface OpenedBillPaymentEmployee {
    id: string
    name: string
}

export interface OpenedBillPayment {
    user: OpenedBillPaymentUser
    employee: OpenedBillPaymentEmployee
    openedEventsDates: Date[]
    paymentId: string
    method: OpenedBillPaymentMethod
    value: number
}

export interface OpenedBillPaymentV2User {
    id: string
    name: string | null
    document: string
}

export interface OpenedBillPaymentV2Employee {
    id: string
    name: string
    username: string | null
}

export interface OpenedBillPaymentV2 {
    user: OpenedBillPaymentV2User
    employee: OpenedBillPaymentV2Employee
    value: number
    tipValue: number | null
    methods: PaymentMethod[]
    openedEventId: string
    openedEventDate: Date
    date: Date
    reason: string | null
}

export interface OpenedBillPaymentsFilters {
    userName: string | null
    userDocument: string | null
}

export interface OpenedBillPaymentsOverview {
    value: number
    tipValue: number
    openBillsTotal: number
}

export interface PaginatedOpenedBillPaymentsResponse {
    data: OpenedBillPaymentV2[]
    pagination: PaginationResponse
    totalizers: OpenedBillPaymentsOverview
}

export interface OpenedBillReportOverview {
    openBillsTotal: number
    linksGenerated: number
    paidValueTotal: number
}

export interface OpenedBillPaymentsXlsInput {
    scope: GetReportByScope
    filters: OpenedBillPaymentsFilters
}

export interface RappiDiscountEmployee {
    name: string
    username: string | null
}

export interface RappiDiscount {
    id: string
    products: string[]
    value: number
    date: Date
    employee: RappiDiscountEmployee
}

export interface ConsumptionObligationReportUser {
    id: string
    name: string
}

export interface ConsumptionObligationReportEmployee {
    id: string
    name: string
    username: string | null
}

export interface ConsumptionObligationReport {
    user: ConsumptionObligationReportUser
    employee: ConsumptionObligationReportEmployee
    value: number
    paidValue: number
    userProductsValueAtEvent: number
    date: Date
    id: string
}

export interface MoneyOperation {
    id: string
    value: number
    date: Date
    client: string
    author: string
    method: string
}

export interface MinimumConsumptionReportGivenBy {
    name: string
    username: string | null
}

export interface MinimumConsumptionReport {
    id: string
    name: string
    receivedValue: number
    spentValue: number
    givenBy: MinimumConsumptionReportGivenBy
    reason: string | null
    date: Date
}

export interface ReportAfterEventClosingEmployee {
    id: string
    name: string
    username: string | null
}

export interface ReportAfterEventClosingUser {
    cpf: string | null
    name: string | null
}

export interface ReportAfterEventClosingTransactionType {
    id: string
    name: string
}

export interface ReportAfterEventClosing {
    id: string
    createdAt: Date
    employee: ReportAfterEventClosingEmployee
    user: ReportAfterEventClosingUser[]
    value: number
    transactionType: ReportAfterEventClosingTransactionType | null
    origin: ReportAfterEventClosingOrigin
}

export interface FilterReportAfterEventClosing {
    key: string
    values: string[]
}

export interface ZigDeviceSyncForceAtEventEmployee {
    id: string
    name: string
    username: string | null
}

export interface ZigDeviceSyncForceAtEventUser {
    id: string
    name: string
}

export interface ZigDeviceSyncForceAtEvent {
    id: string
    balance: number
    reason: string
    date: Date
    employee: ZigDeviceSyncForceAtEventEmployee
    user: ZigDeviceSyncForceAtEventUser
}

export interface RechargeConsumptionData {
    Ame: number
    Anticipated: number
    Cash: number
    CreditCard: number
    Dashboard: number
    DebitCard: number
    DeliveryOnline: number
    Ifood: number
    Pix: number
    Rappi: number
    Uber: number
    Voucher: number
    ZigPosCredit: number
    ZigPosDebit: number
    IntegratedFoodVoucher: number
    MBWay: number
    ZigPosCreditInInstallments: number
}

export interface RechargeConsumptionByAuthorAuthor {
    id: string
    name: string
}

export interface RechargeConsumptionByAuthor {
    author: RechargeConsumptionByAuthorAuthor
    consumptions: RechargeConsumptionData
}

export interface RechargeConsumptionByAuthorPaginated {
    pagination: PaginationResponse | null
    data: RechargeConsumptionByAuthor[]
}

export interface RechargeConsumptionFromAuthorUser {
    id: string
    name: string
}

export interface RechargeConsumptionFromAuthor {
    user: RechargeConsumptionFromAuthorUser
    paymentMethod: RechargePaymentMethod
    value: number
}

export interface TotemTransactionResponse {
    data: TotemTransaction[]
    pagination: PaginationResponse
}

export interface TotemTransaction {
    date: Date | null
    name: string | null
    employeeName: string | null
    employeeUsername: string | null
    isRefunded: boolean | null
    methods: PaymentMethod[] | null
    products: ProductDetails[] | null
    transactionId: string
    paymentValue: number
    paymentTipValue: number
    acquirerTransactionsId: string | null
}

export interface TotemTransactionFilters {
    idOrCpf: string | null
    paymentMethod: PaymentMethod | null
    employee: string | null
}

export interface TotemTransactionTotalizerResponse {
    totalCustomers: number | null
    averageTicket: number | null
    salesTotal: number | null
}

export interface AppTransactionDetails {
    transactionId: string
    name: string | null
    cpf: string
    userId: string
    appPaymentType: AppTransactionDetailsAppPaymentType
    employee: MinimalEmployee
    isRefunded: boolean
    createdAt: Date
    appPaymentValue: number
    appPaymentTipValue: number
    products: ProductDetails[]
    acquirerTransactionId: string | null
    transactionType: AppTransactionDetailsTransactionType
    isSellingByZigTag: boolean
}

export interface AppTransactionDetailsPaginationResponse {
    data: AppTransactionDetails[]
    pagination: PaginationResponse
}

export interface ProductDetails {
    name: string
    id: string
    count: number
    value: number
    discount: number
}

export interface AppTransactionsTotalizer {
    clientCount: number
    totalSold: number
    totalByBalance: number
    totalByCreditCard: number
    totalRefunded: number
}

export interface AppTransactionsFilters {
    appPaymentType: AppTransactionDetailsAppPaymentType | null
    customerName: string | null
}

export interface OpenBillCharge {
    id: string
    expiredAt: Date | null
    openBillChargeDetails: OpenBillChargeDetails
}

export interface TransactionTransfer {
    id: string
    transactionTransferId: string
    transactionId: string
    originId: string
    receiverId: string
    date: Date
    tipValue: number
    newTransactionId: string | null
    employeeName: string
    employeeUserName: string
    originDocument: string
    originName: string
    receiverDocument: string
    receiverName: string
    productName: string
    productId: string
    productDiscountValue: number
    productValue: number
    count: number
}

export interface AllSalesPaginationResponse {
    data: SalesDetails[]
    pagination: PaginationResponse
}

export interface AllSalesSummaryResponse {
    totalInSales: number
    discount: number
    productSales: number
    productsSold: number
}

export interface SalesDetailsOrderBy {
    column: SalesDetailsOrderByColumn
    order: SalesDetailsOrderByOrder
}

export interface SalesFilters {
    customerName: string | null
    employeeIds: string[] | null
    paymentMethods: PaymentMethod[] | null
    sectorIds: string[] | null
    barIds: string[] | null
}

export interface SalesDetailsFilters {
    customerName: string | null
    employeeIds: string[] | null
    paymentMethods: PaymentMethod[] | null
    sectorIds: string[] | null
    barIds: string[] | null
    orderBy: SalesDetailsOrderBy[] | null
}

export interface SalesDetailsProducts {
    name: string
    fiscalCode: string | null
    category: string | null
    count: number
    value: number
    discount: number
    total: number
}

export interface SalesDetails {
    date: Date | null
    transactionId: string | null
    userId: string | null
    name: string | null
    document: string | null
    sellerId: string | null
    sellerName: string | null
    value: number | null
    discount: number | null
    paymentMethods: PaymentMethod[] | null
    isRefunded: boolean | null
    products: SalesDetailsProducts[] | null
}

export interface PlaceReportResumeRevenue {
    totalIncome: number
    anticipated: number
    app: number
    cash: number
    dashboard: number
    credit: number
    debit: number
    postEvent: number
    rappi: number
    voucher: number
    zigCredit: number
    zigDebit: number
    pix: number
    rechargeDevolutions: number
    barTip: number
    entranceTip: number
    consumptionFromBar: number
}

export interface PlaceReportResumePublic {
    averageTicket: number
    totalPublic: number
    malePublic: number
    femalePublic: number
    otherPublic: number
}

export interface PlaceReportResume {
    date: Date
    revenue: PlaceReportResumeRevenue
    public: PlaceReportResumePublic
}

export interface PlaceReport {
    id: string
    name: string
    resume: PlaceReportResume[]
}

export interface FinancialClosingReportMapItem {
    id: string
    division: string
    name: string
    fee: string | null
    payDate: string
    type: string
    isActive: boolean
}

export interface CreateFinancialClosingReportMapInput {
    division: string
    name: string
    fee: string | null
    payDate: string
    type: string
    isActive: boolean | null
}

export interface UpdateFinancialClosingReportMapInput {
    division: string | null
    name: string | null
    fee: string | null
    payDate: string | null
    type: string | null
    isActive: boolean | null
}

export interface CouvertFiscalDataForPlaceFiscalProfile {
    id: string
    name: string
}

export interface CouvertFiscalDataForPlaceFiscalProductGroup {
    id: string
    name: string
}

export interface CouvertFiscalDataForPlace {
    placeId: string
    placeName: string
    codigo: string | null
    ncm: string | null
    cest: string | null
    fiscalProfile: CouvertFiscalDataForPlaceFiscalProfile | null
    fiscalProductGroup: CouvertFiscalDataForPlaceFiscalProductGroup | null
}

export interface FiscalProductNcms {
    name: string
    ncm: string
}

export interface FiscalProduct {
    id: string
    image: string | null
    name: string
    ncm: string
    ncms: FiscalProductNcms[]
    slug: string
}

export interface ProductFiscalDataWithPlaceInfo {
    placeId: string
    placeName: string
    codigo: string | null
    ncm: string | null
    cest: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
}

export interface ProductFiscalData {
    codigo: string | null
    ncm: string | null
    cest: string | null
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
}

export interface Invoice {
    id: string
    mode: InvoiceMode
    issuedAt: Date
    canBeCanceled: boolean | null
    isCanceled: boolean
    isIssued: boolean
    isIssuing: boolean
    error: string | null
    users: User[]
    pdfUrl: string | null
    imgUrl: string | null
}

export interface InvoiceWithEvent {
    id: string
    mode: InvoiceMode
    issuedAt: Date
    canBeCanceled: boolean | null
    isCanceled: boolean
    isIssued: boolean
    isIssuing: boolean
    error: string | null
    users: User[]
    pdfUrl: string | null
    imgUrl: string | null
    event: MinimalEvent
}

export interface MinimalInvoiceWithEventEvent {
    id: string
    name: string
    date: Date
}

export interface MinimalInvoiceWithEvent {
    id: string
    invoiceNumber: string | null
    parentInvoice: string | null
    createdAt: Date | null
    pdfUrl: string | null
    userActionUrl: string | null
    expirationDate: Date | null
    event: MinimalInvoiceWithEventEvent
}

export interface SimpleIssueResult {
    errors: string[]
    failedInvoiceCount: number
    success: number
}

export interface ObligationPaymentsForInvoice {
    userId: string
    value: number
}

export interface RecipientExtraInfoAddress {
    logradouro: string
    numero: string
    complemento: string | null
    bairro: string
    cep: string
    municipio: string
    uf: string
}

export interface RecipientExtraInfo {
    address: RecipientExtraInfoAddress | null
    inscricaoEstadual: string | null
    indicadorInscricaoEstadual: RecipientExtraInfoIndicadorInscricaoEstadual | null
    razaoSocial: string | null
}

export interface FiscalDraftActor {
    id: string
    name: string
    type: FiscalDraftActorType
}

export interface FiscalDraftWorkflow {
    draftId: string
    parentId: string | null
    createdAt: Date
    createdBy: FiscalDraftActor
    approvedAt: Date | null
    approvedBy: FiscalDraftActor | null
    rejectedAt: Date | null
    rejectedBy: FiscalDraftActor | null
}

export interface FiscalProfileOrg {
    cnpj: string
    razaoSocial: string
    nomeFantasia: string
    regimeTributario: RegimeTributario
    regimeTributarioEspecial: RegimeTributarioEspecial | null
    inscricaoEstadual: string
    inscricaoMunicipal: string | null
    codigoMunicipio: string | null
    hasCadastroNacionalContribuinte: boolean
}

export interface FiscalProfileContact {
    email: string
    telefone: string
}

export interface FiscalProfileAddress {
    logradouro: string
    numero: string
    complemento: string | null
    bairro: string
    cep: string
    municipio: string
    uf: string
}

export interface FiscalProfileNfce {
    cscNfceProducao: string
    idNfceProducao: string
    cscNfceHomologacao: string | null
    idNfceHomologacao: string | null
    certificado: ArrayBuffer | null
    senhaCertificado: string
    certificadoValidoAte: Date | null
}

export interface FiscalProfileSat {
    numeroSerieSat: string
}

export interface FiscalProfileIvaVendusPaymentIds {
    cash: number
    credit: number
    debit: number
    mbWay: number
    other: number
}

export interface FiscalProfileIvaVendus {
    apiKey: string
    registerIds: string[]
    paymentIds: FiscalProfileIvaVendusPaymentIds
    country: FiscalProfileIvaVendusCountry
}

export interface FiscalProfileIvaFactura {
    apiKey: string
    secretKey: string
    fiscalProductGroupId: string
    autoInvoicingURL: string
    issuerDocument: string
    expirationDays: number | null
    expirationOpt: FiscalProfileIvaFacturaExpirationOpt
}

export interface FiscalProfile {
    id: string
    name: string
    hasPendingDraft: boolean | null
    validatedAt: Date | null
    org: FiscalProfileOrg | null
    contact: FiscalProfileContact
    address: FiscalProfileAddress | null
    nfce: FiscalProfileNfce | null
    sat: FiscalProfileSat | null
    ivaVendus: FiscalProfileIvaVendus | null
    ivaFactura: FiscalProfileIvaFactura | null
    fiscalMode: FiscalMode | null
    tipFiscalData: TipFiscalData | null
    enableFocusManifestation: boolean | null
    enableNationalService: boolean | null
}

export interface TipFiscalData {
    name: string | null
    cest: string | null
    code: string | null
    ncm: string | null
    fiscalProductGroupId: string | null
    cnae: string | null
}

export interface FiscalProductGroupIcms {
    origem: string | null
    csosn: string | null
    cst: string | null
    aliquota: number | null
    baseCalculo: string | null
    reducaoBaseCalculo: number | null
    benefCode: string | null
    creditoPresumidoCode: string | null
    creditoPresumidoAliquota: number | null
    pFCP: number | null
}

export interface FiscalProductGroupPis {
    cst: string | null
    baseCalculo: string | null
    aliquotaPerc: number | null
    quantidadeVendida: number | null
    aliquotaReais: number | null
}

export interface FiscalProductGroupCofins {
    cst: string | null
    baseCalculo: string | null
    aliquotaPerc: number | null
    quantidadeVendida: number | null
    aliquotaReais: number | null
}

export interface FiscalProductGroupIvaDual {
    codigoSituacaoTributaria: string | null
    codigoClassificacaoTributaria: string | null
    aliquotaEstadualIBS: number | null
    aliquotaMunicipalIBS: number | null
    aliquotaCBS: number | null
    pRedAliqCBS: number | null
    pRedAliqIBSUf: number | null
    pRedAliqIBSMun: number | null
}

export interface FiscalProductGroupService {
    aliquota: number | null
    tipoServico: string | null
    codigoTributacaoMunicipio: string | null
    codigoNbs: string | null
    codigoIndicadorOperacao: string | null
}

export interface FiscalProductGroupServiceNational {
    codigoTributacaoNacionalIss: string | null
    codigoTributacaoMunicipalIss: string | null
    codigoNbs: string | null
    aliquota: number | null
    percentualTotalTributosSN: number | null
    percentualTotalTributosFederais: number | null
    percentualTotalTributosEstaduais: number | null
    percentualTotalTributosMunicipais: number | null
}

export interface FiscalProductGroupVatVendusDetails {
    code: FiscalProductGroupVatVendusDetailsCode
    productType: FiscalProductGroupVatVendusDetailsProductType
    taxExemption: FiscalProductGroupVatVendusDetailsTaxExemption | null
    region: FiscalProductGroupVatVendusDetailsRegion | null
}

export interface FiscalProductGroup {
    id: string
    name: string
    hasPendingDraft: boolean | null
    validatedAt: Date | null
    cfop: string | null
    cfopInterestadual: string | null
    icms: FiscalProductGroupIcms | null
    pis: FiscalProductGroupPis | null
    cofins: FiscalProductGroupCofins | null
    ivaDual: FiscalProductGroupIvaDual | null
    service: FiscalProductGroupService | null
    serviceNational: FiscalProductGroupServiceNational | null
    type: FiscalProductGroupType
    vatVendusDetails: FiscalProductGroupVatVendusDetails | null
    vat: number | null
}

export interface FiscalProfileDraft {
    id: string
    name: string
    hasPendingDraft: boolean | null
    validatedAt: Date | null
    org: FiscalProfileOrg | null
    contact: FiscalProfileContact
    address: FiscalProfileAddress | null
    nfce: FiscalProfileNfce | null
    sat: FiscalProfileSat | null
    ivaVendus: FiscalProfileIvaVendus | null
    ivaFactura: FiscalProfileIvaFactura | null
    fiscalMode: FiscalMode | null
    tipFiscalData: TipFiscalData | null
    enableFocusManifestation: boolean | null
    enableNationalService: boolean | null
    parentId: string | null
    createdAt: Date
    createdBy: FiscalDraftActor
    approvedAt: Date | null
    approvedBy: FiscalDraftActor | null
    rejectedAt: Date | null
    rejectedBy: FiscalDraftActor | null
}

export interface FiscalProductGroupDraft {
    id: string
    name: string
    hasPendingDraft: boolean | null
    validatedAt: Date | null
    cfop: string | null
    cfopInterestadual: string | null
    icms: FiscalProductGroupIcms | null
    pis: FiscalProductGroupPis | null
    cofins: FiscalProductGroupCofins | null
    ivaDual: FiscalProductGroupIvaDual | null
    service: FiscalProductGroupService | null
    serviceNational: FiscalProductGroupServiceNational | null
    type: FiscalProductGroupType
    vatVendusDetails: FiscalProductGroupVatVendusDetails | null
    vat: number | null
    parentId: string | null
    createdAt: Date
    createdBy: FiscalDraftActor
    approvedAt: Date | null
    approvedBy: FiscalDraftActor | null
    rejectedAt: Date | null
    rejectedBy: FiscalDraftActor | null
}

export interface FiscalProfileWithPendingDraft {
    principal: FiscalProfile
    pendingDraft: FiscalProfileDraft | null
}

export interface FiscalProductGroupWithPendingDraft {
    principal: FiscalProductGroup
    pendingDraft: FiscalProductGroupDraft | null
}

export interface InvoiceV2 {
    id: string
    mode: InvoiceV2Mode
    issuedAt: Date
    isCanceled: boolean
    pdfUrl: string | null
    imgUrl: string | null
    type: string | null
    num: string | null
    serie: string | null
    rawSource: string | null
    canceledRawSource: string | null
    fiscalProfile: string
    value: number | null
    eventDate: Date
    creditInvoices: InvoiceV2[] | null
    createdBy: string
    transactionId: string | null
    rechargeId: string | null
    transactionDate: Date | null
    rechargeDate: Date | null
}

export interface InvoicesV2PaginationResponse {
    data: InvoiceV2[]
    pagination: PaginationResponse
}

export interface InvoicesV2Filter {
    employeeIds: string[] | null
    createdBySystem: boolean | null
    fiscalProfileIds: string[] | null
    invoiceType: InvoiceTypeEnum | null
    emissionItemType: InvoicesV2FilterEmissionItemType | null
}

export interface NationalFiscalInvoiceFilter {
    since: Date
    until: Date
    invoiceNumber: string | null
    fiscalProfile: string | null
    isCanceled: boolean | null
}

export interface NationalFiscalInvoiceResponse {
    data: NationalFiscalInvoiceData[]
    pagination: PaginationResponse
}

export interface NationalFiscalInvoiceData {
    id: string
    mode: NationalFiscalInvoiceDataMode
    issuedAt: Date
    canBeCanceled: boolean | null
    isCanceled: boolean
    pdfUrl: string | null
    imgUrl: string | null
    num: string | null
    serie: string | null
    rawSource: string | null
    canceledRawSource: string | null
    fiscalProfile: string
    value: number | null
    eventDate: Date
    createdBy: string | null
    status: InvoiceStatus
}

export interface NotEmmitedTransactionProducts {
    id: string
    name: string
    unitValue: number
    count: number
    discountValue: number
    transactionProductId: string | null
}

export interface NotEmmitedTransaction {
    id: string
    products: NotEmmitedTransactionProducts[]
    date: Date
}

export interface ManualRequestPayments {
    paymentMethod: ManualRequestPaymentMethod
    value: number
}

export interface ManualRequestProducts {
    ncm: string
    cest: string | null
    fiscalProductGroupId: string
    value: number
    fiscalIcmsBaseCalculoRetSt: number | null
    fiscalIcmsAliquotaFinal: number | null
    fiscalIcmsValorSubistituto: number | null
}

export interface ManualRequestConsumptionObligationPayments {
    userCpf: string
    value: number
}

export interface ManualRequest {
    fiscalProfileId: string
    payments: ManualRequestPayments[]
    products: ManualRequestProducts[]
    consumptionObligationPayments: ManualRequestConsumptionObligationPayments[] | null
    tipValue: number
    recipientExtraInfo: RecipientExtraInfo | null
}

export interface NotEmittedProductOrCombo {
    id: string
    name: string
    type: NotEmittedProductOrComboType
    count: number
}

export interface InvoicePrintData {
    printData: ArrayBuffer[] | null
    epsonPrintData: ArrayBuffer[] | null
    printMarkup: string
}

export interface MonthInvoices {
    emitted: number
    totalReceipt: number
    countEmitted: number
    countTotalReceipt: number
}

export interface FiscalSumupEmissible {
    totalReceipt: number
    totalConsumption: number
    bonus: number
    preConsumptionFromOtherEvents: number
    openedBillsPayments: number
    rechargeBalance: number
    paidNotSyncTransactions: number
    otherEventsConsumption: number
    openedBills: number
    rappiDiscounts: number
    activationFee: number
    refundedPostPaidTransactions: number
    otherValues: number
}

export interface FiscalSumupFiscal {
    emitted: number
    laterMonthInvoices: number
    notEmitted: number
    previousMonthInvoices: number
}

export interface FiscalSumup {
    emissible: FiscalSumupEmissible
    fiscal: FiscalSumupFiscal
}

export interface LogInvoiceErrorResponseBuyers {
    id: string | null
    name: string | null
    cpf: string
}

export interface LogInvoiceErrorResponseProducts {
    id: string | null
    name: string | null
}

export interface LogInvoiceErrorResponse {
    id: string
    invoiceId: string
    error: string
    errorMessage: string
    errorType: string
    errorCorrection: string | null
    date: Date
    buyers: LogInvoiceErrorResponseBuyers[]
    products: LogInvoiceErrorResponseProducts[]
    count: number
    status: LogInvoiceErrorResponseStatus
    mode: InvoiceMode
    eventId: string
    placeId: string
    fiscalProfileName: string | null
    updatedAt: Date
}

export interface NotIssuedWithErrorResponse {
    data: LogInvoiceErrorResponse[]
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface InvoiceIssuedByPerfilFiscal {
    name: string
    count: number
    value: number
}

export interface InvoiceByMode {
    emitted: number
    notEmitted: number
    totalReceipt: number
}

export interface InvoiceIssuedByModeInvoices {
    date: Date
    mode: string
    emitted: number
}

export interface InvoiceIssuedByMode {
    invoices: InvoiceIssuedByModeInvoices[]
    nfce: number
    nfse: number
}

export interface ReportFiscal {
    eventId: string
    eventName: string
    date: Date
    lastInvoiceIssued: Date | null
    totalReceipt: number
    emitted: number
    notEmitted: number
    emittedNfce: number
    emittedNfse: number
}

export interface UnusedInvoice {
    id: string
    date: Date
    xml: string
    serie: string
    number: string
}

export interface PendingInvoices {
    id: string
    date: Date
    eventDate: Date
    fiscalProfileId: string | null
    employee: string
    invoiceType: string
    value: number
    fiscalMode: string
    error: string | null
    rechargeId: string | null
    transactionId: string | null
    expirationDate: Date | null
}

export interface PendingInvoicesFilter {
    employeeIds: string[] | null
    createdBySystem: boolean | null
    fiscalProfileIds: string[] | null
    invoiceType: PendingInvoicesFilterInvoiceType | null
    invoiceEmissionType: PendingInvoicesFilterInvoiceEmissionType | null
}

export interface PendingInvoicesPaginatedResponse {
    data: PendingInvoices[]
    pagination: PaginationResponse
}

export interface TransactionProductWithInvoiceEvent {
    id: string
    name: string
    date: Date
}

export interface TransactionProductWithInvoiceInvoice {
    id: string
    number: string
    serie: string
    date: Date
    issuerDocument: string
    recipientDocument: string | null
    value: string
    netValue: string | null
}

export interface TransactionProductWithInvoice {
    transactionProductId: string
    transactionId: string
    isCombo: boolean
    value: number
    totalNetValue: number | null
    count: number
    discountValue: number
    date: Date
    productName: string
    tipValue: number
    event: TransactionProductWithInvoiceEvent
    invoice: TransactionProductWithInvoiceInvoice | null
}

export interface RechargeWithInvoiceEvent {
    id: string
    name: string
    date: Date
}

export interface RechargeWithInvoiceInvoice {
    id: string
    number: string
    serie: string
    date: Date
    issuerDocument: string
    recipientDocument: string | null
    value: string
    netValue: string
}

export interface RechargeWithInvoice {
    id: string
    totalValue: number
    usedValue: number
    date: Date
    event: RechargeWithInvoiceEvent
    invoice: RechargeWithInvoiceInvoice | null
}

export interface RechargeWithInvoicePaginatedResponse {
    data: RechargeWithInvoice[]
    pagination: PaginationResponse
}

export interface RechargeWithInvoiceFilter {
    isIssued: boolean | null
}

export interface BarEmittedValue {
    id: string
    name: string
    grossValue: number
    netValue: number
}

export interface FiscalProfileEmittedValue {
    id: string
    name: string
    value: number
    netValue: number | null
}

export interface EmittedValueByPaymentType {
    netValue: number
    grossValue: number
    paymentMethod: EmittedValueByPaymentTypeEnum
}

export interface EmployeeEmittedValueEmployee {
    id: string
    name: string
}

export interface EmployeeEmittedValue {
    employee: EmployeeEmittedValueEmployee
    grossValue: number
    netValue: number
}

export interface GenericValueForReport {
    title: string
    description: string | null
    motherReportPath: string | null
    value: number
    emittedNetValue: number | null
    unit: GenericValueForReportUnit
    highlighted: boolean
    hideIfZero: boolean
}

export interface SearchInvoice {
    id: string
    emitted: Date
    rawSource: string
    canceledRawSource: string | null
    pdfUrl: string | null
    isCanceled: boolean
    everestUploadTime: Date | null
    type: string | null
}

export interface NotEmittedProduct {
    id: string
    type: NotEmittedProductType
    name: string
    count: number
    lastNotEmittedSellDate: Date
    firstNotEmittedSellDate: Date
}

export interface LastEmissionAttempt {
    id: string
    invoiceId: string
    errorMessage: string
    error: string
    errorType: string
    date: Date
    updatedAt: Date
    eventId: string
    userId: string
    userName: string
    transactionId: string
}

export interface NotEmittedProductByError {
    productId: string
    productName: string
    count: number
}

export interface LastEmissionDetails {
    attempts: LastEmissionAttempt[]
    products: NotEmittedProductByError[]
}

export interface InvoiceFiscalProductGroupIcms {
    origem: string | null
    csosn: string | null
    cst: string | null
    aliquota: number | null
    baseCalculo: string | null
    reducaoBaseCalculo: string | null
    benefCode: string | null
}

export interface InvoiceFiscalProductGroupPis {
    cst: string | null
    baseCalculo: string | null
    aliquotaPerc: number | null
    quantidadeVendida: string | null
    aliquotaReais: number | null
}

export interface InvoiceFiscalProductGroupCofins {
    cst: string | null
    baseCalculo: string | null
    aliquotaPerc: number | null
    quantidadeVendida: string | null
    aliquotaReais: number | null
}

export interface InvoiceFiscalProductGroupService {
    aliquota: number
    tipoServico: string | null
    codigoTributacaoMunicipio: string | null
    codigoNbs: string | null
    codigoIndicadorOperacao: string | null
}

export interface InvoiceFiscalProductGroupServiceNational {
    codigoTributacaoNacionalIss: string
    codigoTributacaoMunicipalIss: string | null
    codigoNbs: string | null
    aliquota: number | null
    percentualTotalTributosSN: number | null
    percentualTotalTributosFederais: number | null
    percentualTotalTributosEstaduais: number | null
    percentualTotalTributosMunicipais: number | null
}

export interface InvoiceFiscalProductGroup {
    value: number
    netValue: number | null
    name: string
    cfop: string | null
    icms: InvoiceFiscalProductGroupIcms | null
    pis: InvoiceFiscalProductGroupPis | null
    cofins: InvoiceFiscalProductGroupCofins | null
    service: InvoiceFiscalProductGroupService | null
    serviceNational: InvoiceFiscalProductGroupServiceNational | null
    type: InvoiceFiscalProductGroupType
}

export interface NCM {
    code: string
}

export interface CEST {
    code: string
    name: string
    description: string
    productNcmId: string
}

export interface ListCEST {
    listCEST: CEST[]
}

export interface ResumeImportCest {
    imported: number
    errors: number
}

export interface ImportCESTNCMConfig {
    startLine: number
    cestCodeColumn: string
    ncmCodeColumn: string
    cestNameColumn: string
    cestDescColumn: string
}

export interface NifData {
    nif: string
    name: string | null
    address: string | null
    postalcode: string | null
    city: string | null
    country: string | null
}

export interface ConsumptionObligationConfig {
    fiscalProductGroupId: string | null
    fiscalProfileId: string | null
    fiscalNcm: string | null
}

export interface PlaceConsumptionObligationConfig {
    placeId: string
    placeName: string
    fiscalProductGroupId: string | null
    fiscalProfileId: string | null
    fiscalNcm: string | null
}

export interface RechargeFiscalConfigPayload {
    fiscalProductGroupId: string | null
    fiscalProfileId: string | null
    fiscalNcm: string | null
}

export interface PlaceRechargeFiscalConfig {
    placeId: string
    placeName: string
    fiscalType: string | null
    fiscalProductGroupId: string | null
    fiscalProfileId: string | null
    fiscalNcm: string | null
}

export interface EmployeeWithIssuedInvoices {
    id: string
    name: string
}

export interface SelectableInvoiceUserInformation {
    document: string
    type: InvoiceUserInformationType
}

export interface SelectableInvoiceRequestSelectedProducts {
    id: string
    value: number
    discountValue: number
    quantity: number
    transactionId: string
    transactionProductId: string
}

export interface SelectableInvoiceRequest {
    obligations: ObligationPaymentsForInvoice[]
    userInformation: SelectableInvoiceUserInformation | null
    userId: string
    withTipValue: boolean | null
    selectedProducts: SelectableInvoiceRequestSelectedProducts[]
    tipValue: number | null
    recipientExtraInfo: RecipientExtraInfo | null
}

export interface InsightText {
    type: string
    text: string
}

export interface InsightCategory {
    id: string
    name: string
}

export interface Insight {
    id: string
    placeId: string
    category: InsightCategory
    expirationDate: Date
    updatedAt: Date
    texts: InsightText[]
    reaction: InsightReaction | null
    priority: number | null
}

export interface NewInventory {
    date: Date
    isTotal: boolean
    createdBy: string
}

export interface InventoryStorages {
    id: string
    name: string
}

export interface Inventory {
    id: string
    status: InventoryStatus
    storages: InventoryStorages[]
    date: Date
    isTotal: boolean
    createdBy: string
}

export interface NewInventoryProduct {
    productId: string
    storageId: string
    inventoryCount: number | null
    inventoryUnitValue: number | null
    realCount: number | null
    realUnitValue: number | null
}

export interface InventoryProduct {
    productId: string
    storageId: string
    inventoryCount: number | null
    inventoryUnitValue: number | null
    realCount: number | null
    realUnitValue: number | null
    productName: string
    productCategory: string
    productCategoryId: string
}

export interface TopSelling {
    name: string
    count: number
}

export interface TopSellingClient {
    name: string
    count: number
    id: string
}

export interface TopSellingCashier {
    id: string
    name: string
    rechargeMoneyReceived: number
    postPaidMoneyReceived: number
}

export interface Public {
    womenInside: number
    menInside: number
    otherInside: number
    menOutside: number
    womenOutside: number
    otherOutside: number
    ticketZero: number
}

export interface TopSellingProducts {
    top5SellingProductsByQuantity: TopSelling[]
    top5SellingProductsByPrice: TopSelling[]
}

export interface TotalReceipt {
    bar: Receipt
    entrances: Receipt
    rechargeConsumptions: number
    entranceConsumptions: number
    barConsumptions: number
    averageTicket: number
    totalRefundedPostPayments: number | null
}

export interface Receipt {
    cash: number
    credit: number
    debit: number
    postEvent: number
    voucher: number
    app: number
    pix: number
    opened: number
    dashboard: number
    anticipated: number
    rappi: number
    uber: number
    ifood: number
    ame: number
    deliveryOnline: number
    integratedFoodVoucher: number
    mbway: number
    online: number
}

export interface ConsumptionTimeline {
    start: Date
    intervalInMinutes: number
    value: number
}

export interface OpenTableTimeline {
    start: Date
    intervalInMinutes: number
    openTables: number
}

export interface ClientsInTagTimeline {
    start: Date
    intervalInMinutes: number
    clientsInTag: number
}

export interface ConsumptionResume {
    minimumConsumption: number
    bonus: number
    normal: number
    openedBils: number
    creditFromPreviousEvents: number
    paidInFutureEvents: number
    app: number
    productsSold: number
}

export interface SelledProduct {
    name: string
    count: number
    totalValue: number
}

export interface DeliveryReceiptItem {
    source: DeliverySource
    value: number
}

export interface DeliveryReceipt {
    total: number
    items: DeliveryReceiptItem[]
}

export interface VendorResume {
    id: string
    name: string
    totalSold: number
}

export interface AdminResponsePermissions {
    id: string
    name: string
}

export interface AdminResponse {
    id: string
    email: string
    name: string
    permissions: AdminResponsePermissions[]
    role: string | null
}

export interface RegisterEmployeeEmailInput {
    username: string
    password: string
    organizationUsername: string
    email: string
}

export interface BaseLoyaltyProgramPlaces {
    id: string
    name: string
}

export interface BaseLoyaltyProgramPointRulesPlaceAttendPointRules {
    placeId: string
    placeName: string
    points: number
}

export interface BaseLoyaltyProgramPointRulesSpentValuePointRule {
    spentValue: number
    points: number
}

export interface BaseLoyaltyProgramPointRulesProductPointRules {
    productId: string | null
    productName: string | null
    categoryId: string | null
    categoryName: string | null
    points: number
}

export interface BaseLoyaltyProgramPointRulesNpsPointRule {
    points: number
}

export interface BaseLoyaltyProgramPointRulesAppPaymentPointRule {
    points: number
}

export interface BaseLoyaltyProgramPointRulesGenderPointRules {
    gender: Gender
    points: number
}

export interface BaseLoyaltyProgramPointRules {
    placeAttendPointRules: BaseLoyaltyProgramPointRulesPlaceAttendPointRules[]
    spentValuePointRule: BaseLoyaltyProgramPointRulesSpentValuePointRule | null
    productPointRules: BaseLoyaltyProgramPointRulesProductPointRules[]
    npsPointRule: BaseLoyaltyProgramPointRulesNpsPointRule | null
    appPaymentPointRule: BaseLoyaltyProgramPointRulesAppPaymentPointRule | null
    genderPointRules: BaseLoyaltyProgramPointRulesGenderPointRules[] | null
}

export interface BaseLoyaltyProgramPrizeRulesProductPrizeRules {
    productId: string | null
    productName: string | null
    categoryId: string | null
    categoryName: string | null
    pointsRequired: number
    discount: number
}

export interface BaseLoyaltyProgramPrizeRulesBonusPrizeRules {
    pointsRequired: number
    bonus: number
}

export interface BaseLoyaltyProgramPrizeRules {
    productPrizeRules: BaseLoyaltyProgramPrizeRulesProductPrizeRules[]
    bonusPrizeRules: BaseLoyaltyProgramPrizeRulesBonusPrizeRules[]
}

export interface BaseLoyaltyProgram {
    name: string
    description: string
    pointsExpiresInDays: number | null
    sendMessagesAboutProgramAfterCheckout: BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout[]
    smsSentAt: Date | null
    isActive: boolean
    places: BaseLoyaltyProgramPlaces[]
    pointRules: BaseLoyaltyProgramPointRules
    prizeRules: BaseLoyaltyProgramPrizeRules
}

export interface LoyaltyProgram {
    name: string
    description: string
    pointsExpiresInDays: number | null
    sendMessagesAboutProgramAfterCheckout: BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout[]
    smsSentAt: Date | null
    isActive: boolean
    places: BaseLoyaltyProgramPlaces[]
    pointRules: BaseLoyaltyProgramPointRules
    prizeRules: BaseLoyaltyProgramPrizeRules
    id: string
}

export interface LoyaltySummarizedReport {
    totalActive: number
    totalGeneratedPoints: number
    totalUsedPoints: number
    totalRedeemedVouchers: number
}

export interface LoyaltyProgramReport {
    id: string
    name: string
    totalGeneratedPoints: number
    totalUsedPoints: number
    totalRedeemedVouchers: number
    isActive: boolean
}

export interface LoyaltyCompleteReport {
    summarizedReport: LoyaltySummarizedReport
    loyaltyProgramsReport: LoyaltyProgramReport[]
}

export interface LoyaltyProgramExtract {
    id: string
    date: Date
    placeName: string | null
    type: LoyaltyProgramExtractType
    productName: string | null
    points: number
    usedPoints: number | null
    expiresAt: Date | null
    isExpired: boolean
}

export interface ProgramParticipantReport {
    name: string
    pointsToExpire: number
    expiredPoints: number
    totalPaidAmount: number | null
    totalEarnedPoints: number
    totalUsedPoints: number
    remainingTotalPoints: number
    frequencyAfterJoiningAProgram: number
    lastCheckIn: Date | null
    pointsToExpireDate: Date | null
    expiredPointsDate: Date | null
    lastPointsAcquiredDate: Date | null
    lastRedeemedCouponDate: Date | null
}

export interface LoyaltyProgramFilters {
    placeId: string | null
    programName: string | null
    since: Date | null
    until: Date | null
}

export interface PaginationAndFilters {
    pagination: Pagination
    filters: LoyaltyProgramFilters | null
}

export interface SmsCostInfo {
    smsCost: number
    usersReached: number
}

export interface ProgramParticipantReportResponse {
    data: ProgramParticipantReport[]
    pagination: PaginationResponse
}

export interface BaseCoupon {
    placeIds: string[]
    expiresAt: Date | null
    discount: number | null
    bonus: number | null
    categoryId: string | null
    productId: string | null
}

export interface Coupon {
    placeIds: string[]
    expiresAt: Date | null
    discount: number | null
    bonus: number | null
    categoryId: string | null
    productId: string | null
    code: string
    campaignId: string
    isUsed: boolean
}

export interface GiftCardCampaign {
    id: string
    name: string
    coupons: Coupon[]
    createdAt: Date
    expiresAt: Date
    status: GiftCardCampaignStatus
    createdBy: string
    isCanceled: boolean
    organizationId: string
}

export interface NpsFormPlace {
    id: string
    name: string
}

export interface NpsForm {
    id: string
    place: NpsFormPlace
    isActive: boolean
    enabledQuestions: QuestionType[]
    dailySmsLimit: number | null
}

export interface SimpleNpsForm {
    placeId: string
    isActive: boolean
    enabledQuestions: QuestionType[]
    shouldSendSmsOnCheckout: boolean
    dailySmsLimit: number | null
}

export interface NpsPlace {
    questionId: QuestionType
    score: string
}

export interface QuestionsScore {
    npsScore: string
    questionsScore: NpsPlace[]
}

export interface NpsResultCustomer {
    name: string
    userId: string
    document: string
    phone: string | null
    birthDate: Date | null
}

export interface NpsResult {
    customer: NpsResultCustomer
    npsFormId: string
    date: Date
    answers: NpsAnswer[]
    eventId: string
    averageTicket: number
    origin: Origin | null
}

export interface NpsPlaceInfoPlace {
    id: string
    name: string
}

export interface NpsPlaceInfoConfig {
    questionId: QuestionType
    name: string
    description: string | null
    isActive: boolean
}

export interface NpsPlaceInfo {
    place: NpsPlaceInfoPlace
    config: NpsPlaceInfoConfig[]
    shouldSendSmsOnCheckout: boolean
    dailySmsLimit: number | null
}

export interface PageArgs {
    page: number
    limitPerPage: number
}

export interface CustomerResult {
    totalItems: number
    data: NpsResult[]
}

export interface NpsSmsSents {
    checkins: number
    smsSents: number
    npsFormAnswers: number
}

export interface NpsSmsSentDates {
    date: Date
    smsSentCount: number
    npsAnswersCount: number
    conversion: number
}

export interface NpsSmsSent {
    totalSmsSentCount: number
    totalNpsAnswerCount: number
    totalConversion: number
    dates: NpsSmsSentDates[] | null
}

export interface NpsCustomerInfo {
    userId: string
    name: string
    cpf: string
    phone: string
    birthDate: Date | null
}

export interface AnswerDetailsEvent {
    id: string
    name: string
}

export interface AnswerDetailsAnswers {
    questionId: QuestionType
    value: number
    comment: string | null
    options: string[] | null
}

export interface AnswerDetailsMostConsumedProducts {
    name: string
    productId: string
    eventId: string
    date: Date
}

export interface AnswerDetails {
    event: AnswerDetailsEvent
    customer: NpsCustomerInfo | null
    answers: AnswerDetailsAnswers[]
    mostConsumedProducts: AnswerDetailsMostConsumedProducts[]
    npsFormId: string
    date: Date
}

export interface NpsQuestionDetailsAnswers {
    answer: number
    count: number
}

export interface NpsQuestionDetailsOptions {
    questionId: QuestionType
    option: string
    count: number
}

export interface NpsQuestionDetails {
    questionId: string
    totalAnswers: number
    answers: NpsQuestionDetailsAnswers[]
    options: NpsQuestionDetailsOptions[]
}

export interface OpenSaleData {
    value: number
    method: OpenSaleMethod
}

export interface OpenSaleEmployeeEmployee {
    id: string
    name: string
    username: string | null
}

export interface OpenSaleEmployee {
    employee: OpenSaleEmployeeEmployee
}

export interface OpenSaleReport {
    employee: OpenSaleEmployeeEmployee
    sales: OpenSaleData[]
}

export interface OpenSaleRefundedBy {
    name: string
    username: string
}

export interface OpenSale {
    id: string
    date: Date
    isRefunded: boolean
    refundedBy: OpenSaleRefundedBy | null
    refundedAt: Date | null
    employee: OpenSaleEmployeeEmployee
    value: number
    method: OpenSaleMethod
}

export interface Organization {
    id: string
    name: string
    description: string | null
    username: string
    icon: ImageUrl | null
    reportMails: string[]
    currency: string | null
    currencySymbol: string | null
    isTest: boolean | null
    features: string[]
}

export interface OrganizationFeatures {
    id: string
    name: string
    description: string
    isEditableByOrganization: boolean
}

export interface OrganizationWithFeatures {
    id: string
    name: string
    description: string | null
    username: string
    icon: ImageUrl | null
    reportMails: string[]
    currency: string | null
    currencySymbol: string | null
    countryISO3: string | null
    isKeyAccount: boolean
    isTest: boolean
    features: OrganizationFeatures[]
}

export interface PaymentLink {
    id: string
    url: string
    status: PaymentLinkStatus
    amount: number
    installments: number
    paymentOrigin: PaymentOrigin
    description: string | null
    createdAt: Date
    paidAt: Date | null
}

export interface CreatePaymentLinkResult {
    id: string
    url: string
    status: PaymentLinkStatus
}

export interface PaymentLinkPage {
    rows: PaymentLink[]
    total: number
}

export interface PaymentLinkFilter {
    search: string | null
    statuses: PaymentLinkStatus[] | null
    startDate: Date | null
    endDate: Date | null
    dateField: PaymentLinkDateField | null
}

export interface BankAccountContractDetails {
    holder: string | null
    name: string | null
    pixKey: string | null
    pixKeyType: string | null
    accountType: string | null
    account: string | null
    digit: string | null
    agency: string | null
    bank: string | null
    documentNumber: string | null
    documentType: string | null
    bankAccountType: string | null
}

export interface BankAccount {
    bank: string
    accountName: string
    cnpj: string
    type: string
    agency: string
    account: string
}

export interface Couvert {
    value: number
    name: string
    category: string
}

export interface Place {
    id: string
    name: string
    isApproved: boolean
    image: ImageUrl | null
    postPaidLimit: number | null
    maleCouvert: Couvert | null
    femaleCouvert: Couvert | null
    mesasCouvert: Couvert | null
    bars: Bar[]
    tip: number
    zigTagProduct: PlaceProduct | null
    sellVisualizationFormat: PlaceSellVisualizationFormat
    fiscalPrinters: FiscalPrinter[]
    localServerIp: string | null
    rechargeNotIntegratedLimit: number | null
    reportMails: string[] | null
    currency: string | null
    currencySymbol: string | null
    isBlocked: boolean | null
    status: PlaceStatus
    withdrawRequestConfirmationContactEmail: string | null
    documentType: UserDocumentType | null
    countryISO3: string | null
    peopleCapacity: number | null
    defaultReportSinceDate: Date | null
    defaultReportUntilDate: Date | null
    isExpired: boolean | null
}

export interface NewPlace {
    id: string | null
    name: string
    postPaidLimit: number | null
    maleCouvert: Couvert | null
    femaleCouvert: Couvert | null
    mesasCouvert: Couvert | null
    bars: Bar[]
    tip: number
    zigTagProductId: string | null
    sellVisualizationFormat: NewPlaceSellVisualizationFormat
    localServerIp: string | null
    rechargeNotIntegratedLimit: number | null
    reportMails: string[] | null
}

export interface PlaceData {
    place: Place
    products: PlaceProduct[]
    combos: PlaceCombo[]
}

export interface PlaceContractDetailsGeneral {
    contractNumber: number | null
    managerZig: string | null
    managers: string[]
    profile: string | null
    status: string
    majorVersion: string
    minVersion: string | null
    locationName: string
    size: PlaceSize | null
    monthlyZigFeeFloor: number | null
    monthlyZigFeeCap: number | null
    contactPhones: string[] | null
    isOnline: boolean
    isHouse: boolean
    zigFeeShouldBeChargedInDebit: boolean
    hasCustomizedCard: boolean
    rechargeNotIntegratedLimit: number | null
    nonIntegratedPaymentLimit: number | null
    parentPlaceName: string | null
    type: PlaceType | null
    ppuAuthorizationValue: number
}

export interface PlaceContractDetailsRecharges {
    rechargesAction: PlaceContractDetailsRechargesRechargesAction | null
    rechargeExpiresIn: string | null
}

export interface PlaceContractDetailsCommunicationSms {
    cost: number
}

export interface PlaceContractDetailsCommunicationWhatsapp {
    phoneNumber: string | null
    serviceId: string | null
    cost: number | null
}

export interface PlaceContractDetailsCommunication {
    sms: PlaceContractDetailsCommunicationSms
    whatsapp: PlaceContractDetailsCommunicationWhatsapp
}

export interface PlaceContractDetailsTaxes {
    feeType: FeeType | null
    barIncomeComission: number
    inHouseComission: number
    entranceIncomeComission: number
    rechargeRemainingsComission: number
    bonusComission: number
    fixedFee: number | null
    appComission: number
    onlinePaymentComission: number | null
    fixedFeeDay: number | null
    anticipationFee: number | null
    thirdPartyPaymentsFee: number | null
    bankslipServiceFee: number | null
    zigMachineDebitComission: number
    zigMachineCreditComission: number
    pixComission: number | null
    integratedFoodVoucherComission: number | null
    zigMachineCreditForNotDefaultBrandsComission: number | null
    zigMachineDebitForNotDefaultBrandsComission: number | null
    replicateTaxesAllBrands: boolean
    clientIntegratedMachineComission: number | null
    barMinimumConsumptionComission: number
    entranceMinimumConsumptionComission: number
    creditDays: number
    debitDays: number
    zigMachineCreditInInstallmentsComission: number
    maxInstallments: number | null
}

export interface PlaceContractDetailsIfood {
    days: number | null
    comission: number | null
}

export interface PlaceContractDetailsDelivery {
    onlineComission: number | null
    reservationComission: number | null
}

export interface PlaceContractDetailsPlaceCurrencyToken {
    proportion: number
    name: string
    symbol: string
}

export interface PlaceContractDetails {
    general: PlaceContractDetailsGeneral
    recharges: PlaceContractDetailsRecharges
    communication: PlaceContractDetailsCommunication
    taxes: PlaceContractDetailsTaxes | null
    ifood: PlaceContractDetailsIfood
    delivery: PlaceContractDetailsDelivery
    charges: FinancialChargeConfig[] | null
    placeCurrencyToken: PlaceContractDetailsPlaceCurrencyToken | null
    bankAccount: BankAccountContractDetails | null
}

export interface PlaceFeature {
    id: string
    name: string
    isEditableByPlace: boolean
    isActive: boolean
    description: string
}

export interface EverestConfig {
    host: string
    user: string
    password: string
    cnpj: string
}

export interface PlaceWithFeatures {
    id: string
    name: string
    placeFeaturesActive: string[] | null
}

export interface SimplifiedPlace {
    id: string
    name: string
    isApproved: boolean
    postPaidLimit: number
    hasOpenedEvent: boolean
    lastEventBeginDate: Date | null
    timezone: string | null
    timezoneGmt: number | null
    currency: string | null
    currencySymbol: string | null
    thirdPartyPaymentsFee: number | null
    bankslipServiceFee: number | null
    lastEventDateWithTransaction: Date | null
    placeFeatures: string[] | null
    size: PlaceSize | null
    isHouse: boolean | null
    defaultReportSinceDate: Date | null
    defaultReportUntilDate: Date | null
    isExpired: boolean
}

export interface BaseBeerTap {
    name: string
    ip: string
    num: number
    productId: string
    isActive: boolean
}

export interface BeerTap {
    id: string
    name: string
    ip: string
    num: number
    productId: string
    isActive: boolean
}

export interface PlacesResume {
    totalAmount: number | null
    uniqueUsersCount: number
    usersCount: number
}

export interface UsersWithAverageTicket {
    name: string
    cpf: string
    phone: string
    gender: UsersWithAverageTicketGender
    userId: string
    averageTicket: number
    presences: number
}

export interface AverageTicketFilterTicketRange {
    min: number
    max: number
}

export interface AverageTicketFilter {
    cpf: string | null
    ticketRange: AverageTicketFilterTicketRange | null
    gender: AverageTicketFilterGender | null
}

export interface FichaExtraConfig {
    fichaLogo: string | null
    fichaText: string | null
}

export interface ZigLocation {
    id: string
    name: string
}

export interface SimplifiedPlaceWhatsapp {
    id: string
    name: string
    whatsappNumber: string | null
}

export interface PlaceConfigAddress {
    postalCode: string
    state: string | null
    city: string
    province: string
    address: string
    addressNumber: string | null
    complement: string | null
}

export interface PlaceSettingsGeneralSectionRequest {
    image: ArrayBuffer | null
    name: string
    reportMails: string[] | null
    postPaidLimit: number | null
    tipPercentage: number
    tipOptions: number[] | null
    nonIntegratedRechargeLimit: number | null
    zigTagProductId: string | null
    nonIntegratedPaymentLimit: number | null
    peopleCapacity: number | null
    invoiceMoment: InvoiceMoment | null
    defaultReportSinceDate: Date | null
    defaultReportUntilDate: Date | null
    passTemplateId: string | null
    address: PlaceConfigAddress | null
    slug: string | null
}

export interface PlaceSettingsGeneralSectionResponseZigTagProduct {
    id: string
    name: string
}

export interface PlaceSettingsGeneralSectionResponse {
    image: ImageUrl | null
    name: string
    reportMails: string[] | null
    postPaidLimit: number | null
    tipPercentage: number
    tipOptions: number[] | null
    nonIntegratedRechargeLimit: number | null
    zigTagProduct: PlaceSettingsGeneralSectionResponseZigTagProduct | null
    nonIntegratedPaymentLimit: number | null
    peopleCapacity: number | null
    invoiceMoment: InvoiceMoment | null
    defaultReportSinceDate: Date | null
    defaultReportUntilDate: Date | null
    passTemplateId: string | null
    address: PlaceConfigAddress | null
    slug: string | null
}

export interface ProductToZigTag {
    id: string
    name: string
}

export interface CouvertRequest {
    name: string
    value: number
    category: string
}

export interface CouvertResponse {
    name: string
    value: number
    category: string
    id: string
    isActive: boolean
}

export interface PlaceSettingsCouvertSectionRequest {
    male: Couvert | null
    female: Couvert | null
    mesas: Couvert | null
}

export interface PlaceSettingsCouvertSectionResponse {
    male: CouvertResponse | null
    female: CouvertResponse | null
    mesas: CouvertResponse | null
}

export interface PlaceSettingsPlaceFeatureSectionRequest {
    placeFeatures: string[]
}

export interface PlaceSettingsPlaceFeatureSectionResponse {
    placeFeatures: PlaceFeature[]
}

export interface PlaceSettingsFichaSectionRequest {
    logo: ArrayBuffer | null
    text: string | null
    hasRemovedImage: boolean | null
    fontSize: FichaFontSize | null
    imageSize: FichaImageSize | null
    qrCodeSize: FichaQRCodeSize | null
}

export interface PlaceSettingsFichaSectionResponse {
    logo: ImageUrl | null
    text: string | null
    fontSize: FichaFontSize | null
    imageSize: FichaImageSize | null
    qrCodeSize: FichaQRCodeSize | null
}

export interface TotemPlaceConfigImage {
    url: string
    sha256: string
}

export interface PlaceSettingsPdvSectionRequest {
    generalPassword: string | null
    sellVisualizationFormat: SellVisualizationFormat
    devicesToAdd: string[] | null
    totemConfigs: TotemConfigsRequest
    kdsServerIp: string | null
}

export interface PlaceSettingsPdvSectionResponse {
    sellVisualizationFormat: SellVisualizationFormat
    devicesCount: number
    totemConfigs: TotemPlaceConfigResponse
    kdsServerIp: string | null
}

export interface PlaceSettingsPdvSectionReturnError {
    deviceIds: string[]
    message: string
}

export interface PlaceSettingsPdvSectionReturn {
    success: string[]
    error: PlaceSettingsPdvSectionReturnError
}

export interface MainImageRequest {
    bytes: ArrayBuffer | null
    shouldUpdate: boolean
}

export interface TotemPlaceConfigResponse {
    mainImage: TotemPlaceConfigImage | null
    primaryColor: string | null
    secondaryColor: string | null
    typeLogo: string | null
}

export interface TotemConfigsRequest {
    mainImage: MainImageRequest
    primaryColor: string | null
    secondaryColor: string | null
    typeLogo: string | null
}

export interface FiscalPrintersResultError {
    fiscalPrinter: FiscalPrinter
    reason: string
}

export interface FiscalPrintersResult {
    success: FiscalPrinter[]
    error: FiscalPrintersResultError[]
}

export interface PlaceDetailAddress {
    city: string
    complement: string | null
    country: string
    formattedAddress: string
    neighborhood: string | null
    postalCode: string | null
    state: string
    streetName: string | null
    streetNumber: string | null
}

export interface WorkingPeriod {
    dayOfWeek: DayOfWeek
    startTime: string
    endTime: string
}

export interface EventDay {
    date: Date
    startTime: string
}

export interface DashPlaceBaseDetail {
    id: string
    address: PlaceDetailAddress | null
    instagram: string | null
    facebook: string | null
    twitter: string | null
    description: string | null
    ticketLink: string | null
    phone: string | null
    email: string | null
    obs: string | null
    linkHighlightType: LinkHighlightType | null
    site: string | null
    locationCategory: NewLocationCategory | null
}

export interface PlaceBaseDetail {
    id: string
    address: PlaceDetailAddress | null
    instagram: string | null
    facebook: string | null
    twitter: string | null
    description: string | null
    ticketLink: string | null
    phone: string | null
    email: string | null
    obs: string | null
    linkHighlightType: LinkHighlightType | null
    site: string | null
    locationCategory: LocationCategory | null
}

export interface BaseTag {
    id: string
    tag: string
}

export interface BaseMusicTag {
    id: string
    musicTag: string
}

export interface PlaceDetailZigLocation {
    id: string
    name: string
}

export interface PlaceDetail {
    appearsInApp: boolean
    zigLocation: PlaceDetailZigLocation
    placeName: string
    images: PlaceDetailImage[]
    localType: LocalType
    isPlaceActive: boolean
    id: string
    address: PlaceDetailAddress | null
    instagram: string | null
    facebook: string | null
    twitter: string | null
    description: string | null
    ticketLink: string | null
    phone: string | null
    email: string | null
    obs: string | null
    linkHighlightType: LinkHighlightType | null
    site: string | null
    locationCategory: NewLocationCategory | null
}

export interface EditPlaceDetail {
    images: ImageUrl[]
    name: string
    id: string
    address: PlaceDetailAddress | null
    instagram: string | null
    facebook: string | null
    twitter: string | null
    description: string | null
    ticketLink: string | null
    phone: string | null
    email: string | null
    obs: string | null
    linkHighlightType: LinkHighlightType | null
    site: string | null
    locationCategory: NewLocationCategory | null
}

export interface PlaceDetailImage {
    url: string
    sha256: string
    height: number
    width: number
}

export interface PlaceDetailTag {
    id: string
    tag: string
    isChecked: boolean
}

export interface WorkingDays {
    workingPeriods: WorkingPeriod[]
    eventDays: EventDay[]
}

export interface PlaceDetailMusicTag {
    id: string
    musicTag: string
    isChecked: boolean
}

export interface PosTransaction {
    brand: string | null
    value: number
    lastDigits: string | null
    date: Date
    acquirerUid: string
    method: PosTransactionMethodMethod
}

export interface PaginationPosTransaction {
    currentPage: number
    itemsPerPage: number
    totalItems: number
    data: PosTransaction[]
}

export interface PosMachineDayResume {
    soldValue: number
    date: Date
    method: PosTransactionMethodMethod
    brand: string | null
}

export interface PosTransactionMethod {
    method: PosTransactionMethodMethod
}

export interface PrechargeAccumulatedValueByGender {
    accumulatedValue: number
    peopleTotalizer: number
    gender: Gender
}

export interface PrechargeAccumulatedValueByPaymentMethod {
    accumulatedValue: number
    rescuedValue: number
    paymentMethod: PrechargeOperationPaymentMethod
}

export interface PrechargeOperationCards {
    peopleTotalizer: number
    averageTicket: number
    accumulatedValue: number
    redeemedValue: number
    bonusValue: number
    valueByGender: PrechargeAccumulatedValueByGender[]
    valueByPaymentMethod: PrechargeAccumulatedValueByPaymentMethod[]
}

export interface PrechargeOperationGraph {
    createdAt: Date
    totalValue: number
    bonusValue: number
}

export interface PrechargeOperationReport {
    cards: PrechargeOperationCards
    graph: PrechargeOperationGraph[]
}

export interface PrechargeResponse {
    data: Precharge[]
    pagination: PaginationResponse
}

export interface CreatePrinter {
    ip: string
    type: KitchenPrinterTypes
    barId: string
    offline: boolean
    pagesToPrint: number | null
}

export interface Printer {
    id: string
    ip: string
    type: KitchenPrinterTypes
    barId: string
    offline: boolean
    pagesToPrint: number | null
}

export interface ListPrinters {
    barId: string
    printers: Printer[]
}

export interface PrintersResultError {
    printer: CreatePrinter
    reason: string
}

export interface PrintersResult {
    success: Printer[]
    error: PrintersResultError[]
}

export interface ProductBarEntry {
    id: string
    name: string
}

export interface PlaceProductMenuCategory {
    id: string
    name: string
}

export interface PlaceProduct {
    id: string | null
    name: string
    description: string | null
    category: string
    categoryId: string
    value: number
    image: ImageUrl | null
    bars: ProductBarEntry[]
    menuCategory: PlaceProductMenuCategory | null
    active: boolean
    hasAlcohol: boolean | null
    fiscalData: TranslatedPlaceProductFiscalData
    type: string
    minimumConsumptionValue: number | null
    hasProductionRule: boolean
    proportionalValue: ProportionalValue | null
    mountableDescription: MountableDescriptionV2 | null
    mountableFiscalSplit: boolean | null
    fiscalCode: string | null
    kind: ProductKind
    basicStorageUnit: BasicStorageUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    proportionOfUnit: ProportionOfUnit | null
    preparationTime: number | null
    systemProduct: BaseSystemProduct | null
    printComboProductsIndividually: boolean | null
}

export interface PlaceProductByTypeProductLinks {
    products: SupplyWithProductionRuleAttachedTo[]
    count: number
}

export interface PlaceProductByTypeStorageLinksStorages {
    id: string
    name: string
}

export interface PlaceProductByTypeStorageLinks {
    storages: PlaceProductByTypeStorageLinksStorages[]
    count: number
}

export interface PlaceProductByType {
    id: string | null
    name: string
    description: string | null
    category: string
    categoryId: string
    value: number
    image: ImageUrl | null
    bars: ProductBarEntry[]
    menuCategory: PlaceProductMenuCategory | null
    active: boolean
    hasAlcohol: boolean | null
    fiscalData: TranslatedPlaceProductFiscalData
    type: string
    minimumConsumptionValue: number | null
    hasProductionRule: boolean
    proportionalValue: ProportionalValue | null
    mountableDescription: MountableDescriptionV2 | null
    mountableFiscalSplit: boolean | null
    fiscalCode: string | null
    kind: ProductKind
    basicStorageUnit: BasicStorageUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    proportionOfUnit: ProportionOfUnit | null
    preparationTime: number | null
    systemProduct: BaseSystemProduct | null
    printComboProductsIndividually: boolean | null
    productLinks: PlaceProductByTypeProductLinks
    storageLinks: PlaceProductByTypeStorageLinks
}

export interface Product {
    id: string | null
    name: string
    category: string
    value: number | null
    image: ImageUrl | null
    hasAlcohol: boolean | null
    type: string
    fiscalCode: string | null
    kind: ProductKind
    fiscalNcm: string | null
    basicStorageUnit: BasicStorageUnit | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
}

export interface NewProduct {
    name: string
    description: string | null
    category: string
    hasAlcohol: boolean
    fiscalCode: string | null
    kindId: string | null
    fiscalNcm: string | null
    basicStorageUnit: BasicStorageUnit | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    value: number | null
    releaseValue: number | null
    proportionOfUnit: ProportionOfUnit | null
    preparationTime: number | null
    systemProductId: string | null
}

export interface EditedProductThroughImport {
    name: string
    description: string | null
    category: string
    hasAlcohol: boolean
    fiscalCode: string | null
    kindId: string | null
    fiscalNcm: string | null
    basicStorageUnit: BasicStorageUnit | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    value: number | null
    releaseValue: number | null
    proportionOfUnit: ProportionOfUnit | null
    preparationTime: number | null
    systemProductId: string | null
    id: string
}

export interface EditedProduct {
    id: string
    name: string
    categoryId: string
    hasAlcohol: boolean
    fiscalCode: string | null
    kindId: string | null
    description: string | null
    value: number | null
    ncm: string | null
    systemProductId: string | null
}

export interface EditedResultsError {
    product: EditedProduct
    reason: string
}

export interface EditedResults {
    success: EditedProduct[]
    error: EditedResultsError[]
}

export interface CreatedResultsError {
    product: NewProduct
    reason: string
}

export interface CreatedResults {
    success: PlaceProduct[]
    error: CreatedResultsError[]
}

export interface ProportionalValue {
    quantity: number
    value: number
    unit: ProportionalValueUnit
}

export interface NewMountableSectionWithStatusItems {
    isActive: boolean
    productId: string
    storageCount: number
    name: string | null
    price: number
    maxCount: number | null
    selectedCount: number | null
}

export interface NewMountableSectionWithStatus {
    title: string
    min: number
    max: number
    pricing: NewMountableSectionWithStatusPricing
    fiscalWeight: number | null
    items: NewMountableSectionWithStatusItems[]
}

export interface NewMountableDescriptionWithStatus {
    sections: NewMountableSectionWithStatus[]
}

export interface NewPlaceProduct {
    name: string
    category: string
    hasAlcohol: boolean
    description: string | null
    fiscalData: NewPlaceProductFiscalData | null
    value: number | null
    proportionalValue: ProportionalValue | null
    mountableDescription: NewMountableDescriptionWithStatus | null
    fiscalCode: string | null
    kindId: string | null
    menuCategory: string | null
    basicStorageUnit: BasicStorageUnit | null
    proportionOfUnit: ProportionOfUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    preparationTime: number | null
    systemProductId: string | null
}

export interface MountableDescriptionWithDetailsSectionsItems {
    isActive: boolean
    productId: string
    storageCount: number
    name: string | null
    price: number
    maxCount: number | null
    selectedCount: number | null
    isModification: boolean | null
}

export interface MountableDescriptionWithDetailsSections {
    title: string
    min: number
    max: number
    pricing: NewMountableSectionWithStatusPricing
    fiscalWeight: number | null
    items: MountableDescriptionWithDetailsSectionsItems[]
}

export interface MountableDescriptionWithDetails {
    sections: MountableDescriptionWithDetailsSections[]
}

export interface NewPlaceProductWithMountableDetails {
    name: string
    category: string
    hasAlcohol: boolean
    description: string | null
    fiscalData: NewPlaceProductFiscalData | null
    value: number | null
    proportionalValue: ProportionalValue | null
    mountableDescription: MountableDescriptionWithDetails | null
    fiscalCode: string | null
    kindId: string | null
    menuCategory: string | null
    basicStorageUnit: BasicStorageUnit | null
    proportionOfUnit: ProportionOfUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    preparationTime: number | null
    systemProductId: string | null
    mountableFiscalSplit: boolean | null
}

export interface BeerProduct {
    beerBrand: string | null
    beerStyle: string | null
    beerAbv: number | null
    beerIbu: number | null
}

export interface DeleteProductResultErrorPlace {
    id: string
    name: string
}

export interface DeleteProductResultErrorProducts {
    id: string
    name: string
}

export interface DeleteProductResultError {
    place: DeleteProductResultErrorPlace
    products: DeleteProductResultErrorProducts[]
}

export interface DeleteProductResult {
    success: boolean
    error: DeleteProductResultError[]
}

export interface DeleteMultipleProductsResult {
    status: DeleteMultipleProductsStatus
    jobId: string | null
}

export interface CreateSupply {
    name: string
    placeId: string
    image: ArrayBuffer | null
    basicStorageUnit: BasicStorageUnit
    fiscalCode: string | null
    yieldPercentage: number | null
    proportionOfUnit: ProportionOfUnit | null
}

export interface CreateSupplyResponseErrors {
    name: string[]
    error: string
}

export interface CreateSupplyResponse {
    resolved: string[]
    errors: CreateSupplyResponseErrors[]
}

export interface BarProductMenuCategory {
    id: string
    name: string
}

export interface BarProductMenus {
    id: string
    name: string
    productValue: number
}

export interface BarProduct {
    id: string | null
    name: string
    category: string
    categoryId: string
    image: ImageUrl | null
    isActiveAtBar: boolean
    menuCategory: BarProductMenuCategory | null
    menus: BarProductMenus[]
    active: boolean
    type: string
    hasProductionRule: boolean
    fiscalCode: string | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
}

export interface SupplyProductionRuleOutput {
    count: number
}

export interface SupplyProductionRule {
    inputs: BackofficeProductionRuleInput[]
    output: SupplyProductionRuleOutput
}

export interface OrganizationProductPlaces {
    id: string
    name: string
}

export interface OrganizationProduct {
    id: string
    places: OrganizationProductPlaces[]
    name: string
    category: string
    categoryId: string
    hasAlcohol: boolean | null
    description: string | null
    type: string
    image: ImageUrl | null
    fiscalCode: string | null
    kind: ProductKind | null
    fiscalNcm: string | null
    systemProductId: string | null
    isPendingDeletion: boolean | null
    deletionFailedReason: string | null
}

export interface OrganizationProductToPlaceProduct {
    id: string
    places: OrganizationProductPlaces[]
    name: string
    category: string
    categoryId: string
    hasAlcohol: boolean | null
    description: string | null
    type: string
    image: ImageUrl | null
    fiscalCode: string | null
    kind: ProductKind | null
    fiscalNcm: string | null
    systemProductId: string | null
    isPendingDeletion: boolean | null
    deletionFailedReason: string | null
    value: number
}

export interface GroupedByCategoryOrganizationProductCategory {
    id: string
    name: string
}

export interface GroupedByCategoryOrganizationProduct {
    category: GroupedByCategoryOrganizationProductCategory
    products: OrganizationProduct[]
}

export interface InputProduct {
    productId: string
    storageId: string
    unitCostValue: number | null
    obs: string | null
    count: number
    date: Date
}

export interface PlaceProductsByTypeResponse {
    data: PlaceProductByType[]
    pagination: PaginationResponse
}

export interface GrabAndGoProduct {
    id: string
    name: string
    imageUrl: string | null
    category: string
    isActiveForGrabAndGo: boolean
}

export interface PatchProduct {
    name: string
    category: string
    hasAlcohol: boolean
    description: string | null
    fiscalData: NewPlaceProductFiscalData | null
    value: number | null
    proportionalValue: ProportionalValue | null
    mountableDescription: NewMountableDescriptionWithStatus | null
    fiscalCode: string | null
    kindId: string | null
    menuCategory: string | null
    basicStorageUnit: BasicStorageUnit | null
    proportionOfUnit: ProportionOfUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    preparationTime: number | null
    systemProductId: string | null
    id: string | null
    bars: string[]
    image: EditProductImage | null
}

export interface PatchProductError {
    name: PatchProductErrorName
    message: string
    product: PatchProduct
}

export interface VerifyPatchProductsResult {
    success: PatchProduct[]
    errors: PatchProductError[]
}

export interface GetProductsWithSectionsRequest {
    keywords: string | null
    name: string | null
    sku: string | null
    menuId: string | null
    categoryId: string | null
}

export interface BaseProductSectionResponseProducts {
    id: string
    name: string
    description: string | null
    fiscalCode: string
    value: number
    order: number
    isActive: boolean
    syncedProduct: ProductWithSectionResponse | null
}

export interface BaseProductSectionResponse {
    id: string
    title: string
    min: number
    max: number
    pricing: BaseProductSectionResponsePricing
    order: number
    products: BaseProductSectionResponseProducts[]
}

export interface ProductWithSectionResponse {
    id: string
    name: string
    description: string | null
    type: string
    fiscalCode: string
    categoryId: string
    categoryName: string
    imageUrl: string | null
    value: number
    isActive: boolean
    sections: BaseProductSectionResponse[]
}

export interface GetProductsWithSectionsWithProductsResponse {
    items: ProductWithSectionResponse[]
    pagination: PaginationResponse
}

export interface ExternalStoreIntegrationSectionProduct {
    externalId: string | null
    externalStoreId: string
    name: string
    description: string | null
    index: number
    price: number
    sku: string | null
    isActive: boolean
    isSynced: boolean
    syncedProduct: ProductWithSectionResponse | null
}

export interface ExternalStoreIntegrationSection {
    externalId: string
    name: string
    index: number
    isActive: boolean
    min: number
    max: number
    products: ExternalStoreIntegrationSectionProduct[]
    isSynced: boolean
}

export interface ExternalStoreIntegrationProductWithSections {
    externalId: string | null
    externalStoreId: string
    name: string
    description: string | null
    price: number
    sku: string | null
    isActive: boolean
    imageUrl: string | null
    syncedProduct: ProductWithSectionResponse | null
    sections: ExternalStoreIntegrationSection[]
    isSectionProductsSynced: boolean
    allSyncedProducts: ProductWithSectionResponse[]
}

export interface ExternalStoreIntegrationCategory {
    externalId: string
    externalStoreId: string
    name: string
    sku: string | null
    products: ExternalStoreIntegrationProductWithSections[]
    isSynced: boolean
}

export interface GetManyExternalStoreIntegrationCategoriesResponse {
    categories: ExternalStoreIntegrationCategory[]
    totalOfProducts: number
}

export interface TinyProduct {
    id: string
    name: string
    category: string
    categoryId: string
}

export interface CategoryProduct {
    id: string | null
    name: string
    description: string | null
    category: string
    categoryId: string
    value: number
    image: ImageUrl | null
    bars: ProductBarEntry[]
    menuCategory: PlaceProductMenuCategory | null
    active: boolean
    hasAlcohol: boolean | null
    fiscalData: TranslatedPlaceProductFiscalData
    type: string
    minimumConsumptionValue: number | null
    hasProductionRule: boolean
    proportionalValue: ProportionalValue | null
    mountableDescription: MountableDescriptionV2 | null
    mountableFiscalSplit: boolean | null
    fiscalCode: string | null
    kind: ProductKind
    basicStorageUnit: BasicStorageUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    proportionOfUnit: ProportionOfUnit | null
    preparationTime: number | null
    systemProduct: BaseSystemProduct | null
    printComboProductsIndividually: boolean | null
    isPartOfMountableDescription: boolean
    isMountable: boolean | null
}

export interface ProductFeatureProperty {
    name: string
    value: any | null
}

export interface BaseProductFeature {
    productId: string
    productFeatureTemplateId: string
    properties: ProductFeatureProperty[]
    isActive: boolean
    type: string | null
}

export interface ProductFeature {
    productId: string
    productFeatureTemplateId: string
    properties: ProductFeatureProperty[]
    isActive: boolean
    type: string | null
    id: string
}

export interface ProductFeatureTemplateField {
    values: string[]
    name: string
    type: ProductFeatureTemplateFieldType
    isRequired: boolean
}

export interface BaseProductFeatureTemplate {
    organizationId: string | null
    observation: string | null
    fields: ProductFeatureTemplateField[]
    name: string
    isActive: boolean
    type: string | null
}

export interface ProductFeatureTemplate {
    organizationId: string | null
    observation: string | null
    fields: ProductFeatureTemplateField[]
    name: string
    isActive: boolean
    type: string | null
    id: string
}

export interface PlacePromoter {
    id: string
    name: string | null
    email: string
    phone: string | null
    status: PlacePromoterStatus
    roleName: string | null
    roleId: string | null
}

export interface PromoterRoles {
    id: string
    name: string
}

export interface EditPromoterPlace {
    status: boolean
    promoterRoleId: string
}

export interface MultipleUserPromotionResultError {
    cpfOrPhone: string
    reason: string
}

export interface MultipleUserPromotionResult {
    success: string[]
    error: MultipleUserPromotionResultError[]
}

export interface CreateRefundReason {
    reason: string
    type: string[]
    shouldAllowOpenText: boolean
}

export interface EditRefundReason {
    id: string
    reason: string
    type: string[]
    isActive: boolean
    shouldAllowOpenText: boolean
}

export interface RefundReason {
    id: string
    placeId: string
    isActive: boolean
    shouldAllowOpenText: boolean
    reason: string
    type: string[]
}

export interface RefundReasonResultError {
    message: string
}

export interface RefundReasonResult {
    success: RefundReason[]
    error: RefundReasonResultError[]
}

export interface NewRelation {
    placeId: string
    eventId: string | null
    name: string
    description: string
    couvertPercentage: number | null
    entranceIds: string[]
    color: string | null
    expiresAt: Date | null
    promoterIds: string[] | null
    canBeInvitedByLink: boolean | null
    guestsLimitByPromoter: number | null
    guestsLimit: number | null
    hasAutomaticEntranceCharge: boolean | null
    isDocumentRequired: boolean | null
    addGuestTimeLimit: Date | null
}

export interface RelationEntrances {
    id: string
    name: string
}

export interface Relation {
    placeId: string
    eventId: string | null
    name: string
    description: string
    couvertPercentage: number | null
    entranceIds: string[]
    color: string | null
    expiresAt: Date | null
    promoterIds: string[] | null
    canBeInvitedByLink: boolean | null
    guestsLimitByPromoter: number | null
    guestsLimit: number | null
    hasAutomaticEntranceCharge: boolean | null
    isDocumentRequired: boolean | null
    addGuestTimeLimit: Date | null
    id: string
    entrances: RelationEntrances[]
    createdAt: Date
    isExpired: boolean
    isActive: boolean
    userCount: number
}

export interface ImportRelationResponse {
    success: Relation[] | null
    errors: ImportRelationError[] | null
}

export interface ImportRelationErrorRelation {
    id: string
    name: string
}

export interface ImportRelationError {
    type: ImportRelationErrorTypes
    message: string
    relation: ImportRelationErrorRelation
}

export interface NewRelationUser {
    cpf: string | null
    name: string
    phone: string | null
    promoter: string | null
    promoterId: string | null
}

export interface RelationUserUser {
    id: string
    name: string
    phone: string | null
    cpf: string | null
}

export interface RelationUser {
    cpf: string | null
    name: string
    phone: string | null
    promoter: string | null
    promoterId: string | null
    id: string
    user: RelationUserUser | null
}

export interface MultipleRelationUserErrorsUser {
    document: string | null
    name: string | null
}

export interface MultipleRelationUserErrors {
    type: MultipleRelationUserErrorsType
    message: string
    user: MultipleRelationUserErrorsUser
}

export interface MultipleRelationUser {
    success: RelationUser[]
    errors: MultipleRelationUserErrors[]
}

export interface GuestReportRelation {
    id: string
    name: string
}

export interface GuestReportUser {
    id: string | null
    cpf: string | null
    phone: string | null
    name: string
    birthDate: Date | null
}

export interface GuestReportEntrances {
    id: string
    name: string
    value: number
}

export interface GuestReport {
    id: string
    relation: GuestReportRelation
    user: GuestReportUser
    promoter: string | null
    consumption: number | null
    checkinDetails: Date | null
    checkinEmployee: string | null
    entrances: GuestReportEntrances[]
}

export interface RelationDataOverview {
    numberOfGuests: number
    numberOfActiveGuests: number
    entranceTotal: number
    consumptionTotal: number
    relationLists: number
    promoters: number
}

export interface RelationPromotersRelations {
    numberOfGuests: number
    numberOfActiveGuests: number
    entranceTotal: number
    consumptionTotal: number
    relationLists: number
    promoters: number
    id: string
    name: string
}

export interface RelationPromoters {
    numberOfGuests: number
    numberOfActiveGuests: number
    entranceTotal: number
    consumptionTotal: number
    relationLists: number
    promoters: number
    promoter: string
    relationCount: number
    relations: RelationPromotersRelations[]
}

export interface RelationReport {
    numberOfGuests: number
    numberOfActiveGuests: number
    entranceTotal: number
    consumptionTotal: number
    relationLists: number
    promoters: number
    relationId: string
    eventId: string | null
    name: string
    promotersName: string[]
}

export interface GuestReportResponse {
    data: GuestReport[]
    pagination: PaginationResponse
}

export interface EmployeeReportItem {
    count: number
}

export interface EmployeeReportItemWithTotal {
    count: number
    total: number
}

export interface EmployeeReportTotals {
    sells: number
    financialOperations: number
    tip: number
    refunds: number
    checkIns: number
}

export interface EmployeeReportEmployees {
    id: string
    name: string
    username: string | null
    eventNames: string[]
    role: string | null
    eventRoles: string[]
    avatar: ImageUrl | null
    sells: EmployeeReportItemWithTotal
    financialOperations: EmployeeReportItemWithTotal
    financialOperationsClosedValue: number
    tipValue: number
    refunds: EmployeeReportItemWithTotal
    sellRefunds: EmployeeReportItemWithTotal
    checkIns: number
}

export interface EmployeeReport {
    totals: EmployeeReportTotals
    employees: EmployeeReportEmployees[]
}

export interface FinanceBiReportEventsIncomes {
    value: number
    method: FinanceBiMethod
}

export interface FinanceBiReportEvents {
    id: string
    date: Date
    incomes: FinanceBiReportEventsIncomes[]
    bonus: number
    ticketZero: number
    female: number
    male: number
    other: number
}

export interface FinanceBiReport {
    events: FinanceBiReportEvents[]
}

export interface BiConsumptionTimeline {
    hourMinute: string
    avgValue: number
    day: number | null
}

export interface OrgConsumptionTimeline {
    hourMinute: string
    avgValue: number
    day: number | null
    placeId: string
}

export interface ClientByReportEvents {
    id: string
    date: Date
    male: number
    female: number
    other: number
}

export interface ClientByReportTopIncomeClients {
    id: string
    name: string
    phone: string
    cpf: string
    income: number
}

export interface ClientByReport {
    events: ClientByReportEvents[]
    topIncomeClients: ClientByReportTopIncomeClients[]
}

export interface ProductBiReport {
    id: string
    name: string
    categoryId: string
    categoryName: string
    image: ImageUrl | null
    sellCount: number
    profit: number
    consumption: number
}

export interface ReportPdvZigCardErrorCustomer {
    id: string
    document: string
    name: string | null
}

export interface ReportPdvZigCardError {
    id: string
    customer: ReportPdvZigCardErrorCustomer | null
    employee: MinimalEmployee
    date: Date
    deviceFingerprint: string | null
    zigDeviceUid: string | null
    additionalInfo: string | null
}

export interface ReportPdvZigCardReport {
    data: ReportPdvZigCardError[]
    pagination: PaginationResponse
}

export interface ReportPdvZigCardFilters {
    employeeIds: string[] | null
    deviceFingerprint: string | null
}

export interface ProductsSoldReportV2PriceVariationProportionalValue {
    value: number
    quantity: number
    unit: string
}

export interface ProductsSoldReportV2PriceVariation {
    count: number
    unitValue: number
    subtotal: number
    discount: number
    totalValue: number
    proportionalValue: ProductsSoldReportV2PriceVariationProportionalValue | null
}

export interface ProductsSoldReportV2MountableComponent {
    id: string
    name: string
    count: number
    section: string
}

export interface ProductsSoldReportV2RowImage {
    sha256: string
    url: string
}

export interface ProductsSoldReportV2Row {
    productId: string
    fiscalCode: string | null
    productName: string
    categoryId: string | null
    categoryName: string | null
    image: ProductsSoldReportV2RowImage | null
    count: number
    subtotal: number
    discount: number
    totalValue: number
    priceVariations: ProductsSoldReportV2PriceVariation[]
    mountableComponents: ProductsSoldReportV2MountableComponent[] | null
    barId: string | null
    barName: string | null
    sectorId: string | null
    sectorName: string | null
    source: ProductsSoldReportV2TransactionSource
    productStatus: ProductsSoldReportV2ProductStatus
    masterKind: string | null
    isReturnable: boolean
}

export interface ProductsSoldReportV2Filters {
    placeId: string
    since: Date | null
    until: Date | null
    eventIds: string[] | null
    categoryIds: string[] | null
    productIds: string[] | null
    barIds: string[] | null
    sectorIds: string[] | null
    sources: string[] | null
    statuses: string[] | null
    masterKinds: string[] | null
    operationTypes: ProductsSoldReportV2OperationType[] | null
}

export interface KdsProductsReportRow {
    productId: string
    productName: string
    productImageUrl: string | null
    categoryName: string | null
    source: string
    quantity: number
    expectedTime: number | null
    actualTime: number
    variation: number | null
}

export interface KdsProductsReportFilters {
    placeId: string
    since: Date
    until: Date
    kdsIds: string[] | null
    screenIds: string[] | null
    sources: string[] | null
    categoryIds: string[] | null
    productIds: string[] | null
}

export interface DetailedTransactionsReportOrderBy {
    column: DetailedTransactionsReportOrderByColumn
    order: DetailedTransactionsReportOrderByOrder
}

export interface DetailedTransactionsReportProduct {
    name: string
    fiscalCode: string | null
    category: string | null
    count: number
    value: number
    discount: number
    total: number
}

export interface DetailedTransactionsReportRow {
    date: Date | null
    transactionId: string
    userId: string | null
    name: string | null
    document: string | null
    sellerId: string | null
    sellerName: string | null
    value: number
    grossValue: number
    discount: number
    paymentMethods: PaymentMethod[] | null
    isRefunded: boolean
    products: DetailedTransactionsReportProduct[]
}

export interface DetailedTransactionsReportFilters {
    placeId: string
    since: Date | null
    until: Date | null
    eventIds: string[] | null
    customerName: string | null
    employeeIds: string[] | null
    paymentMethods: PaymentMethod[] | null
    sectorIds: string[] | null
    orderBy: DetailedTransactionsReportOrderBy[] | null
}

export interface DetailedTransactionsReportResponse {
    data: DetailedTransactionsReportRow[]
    pagination: PaginationResponse
}

export interface DetailedTransactionsReportTotals {
    totalTransactions: number
    refundedCount: number
    uniqueCustomers: number
    grossValue: number
    discount: number
    value: number
}

export interface KdsOrdersReportRow {
    orderId: string
    orderPassword: string
    date: Date
    source: string
    kdsName: string | null
    totalTimeMin: number
    finalStatus: KdsOrderFinalStatus
}

export interface KdsOrdersReportResponse {
    data: KdsOrdersReportRow[]
    pagination: PaginationResponse
}

export interface KdsOrdersReportFilters {
    placeId: string
    since: Date
    until: Date
    kdsIds: string[] | null
    screenIds: string[] | null
    sources: string[] | null
    orderPassword: string | null
    finalStatus: KdsOrderFinalStatus | null
    sortBy: KdsOrdersSortColumn | null
    sortDir: KdsOrdersSortDirection | null
}

export interface ReserveCommon {
    name: string
    estimatedPeopleCount: number
    reserveValue: number | null
    minimumConsumptionValue: number
}

export interface NewReserve {
    name: string
    estimatedPeopleCount: number
    reserveValue: number | null
    minimumConsumptionValue: number
    obs: string
    reserveTemplateId: string | null
    date: Date
    expiresAt: Date | null
    promotionIds: string[]
}

export interface ReservePromotions {
    id: string
    name: string
    description: string | null
    discount: number
}

export interface Reserve {
    id: string
    realPeopleCount: number
    obs: string
    date: Date
    reserveTemplateId: string | null
    expiresAt: Date | null
    name: string
    estimatedPeopleCount: number
    reserveValue: number | null
    minimumConsumptionValue: number
    promotions: ReservePromotions[]
}

export interface ReserveDiscountDetail {
    fiscalProductGroupId: string | null
    fiscalProductGroup: string | null
    value: number
    ncm: string | null
    cest: string | null
}

export interface ReserveDetailUsers {
    id: string
    name: string
    addedAt: Date
    isInside: boolean
}

export interface ReserveDetailInvoices {
    id: string
    mode: InvoiceMode
    date: Date
    isCanceled: boolean
    isIssued: boolean
    isIssuing: boolean
    error: string | null
    pdfUrl: string | null
    imgUrl: string | null
}

export interface ReserveDetail {
    discounts: ReserveDiscountDetail[]
    users: ReserveDetailUsers[]
    invoices: ReserveDetailInvoices[]
}

export interface ReserveReportRowReserves {
    id: string
    name: string
    date: Date
    products: number
    invitedPeople: number
    confirmedPeople: number
    value: number
    revenue: number
    issued: number
}

export interface ReserveReportRow {
    date: Date
    reserves: ReserveReportRowReserves[]
}

export interface ReserveReportDetailsIssuedInvoices {
    id: string
    value: number
    tipValue: number
}

export interface ReserveReportDetailsProductsByPromotion {
    productId: string
    productName: string
    promotionId: string | null
    promotionName: string | null
    selledCount: number
    originalPrice: number
    totalPaidValue: number
    totalDiscount: number
}

export interface ReserveReportDetails {
    id: string
    name: string
    date: Date
    confirmedPeople: number
    issuedInvoices: ReserveReportDetailsIssuedInvoices[]
    reserveValue: number | null
    tipValueOutsideInvoices: number
    totalProductsValue: number
    productsByPromotion: ReserveReportDetailsProductsByPromotion[]
}

export interface NewReserveTemplate {
    name: string
    estimatedPeopleCount: number
    reserveValue: number | null
    minimumConsumptionValue: number
    placeId: string
    promotionIds: string[]
}

export interface ReserveTemplatePromotions {
    id: string
    name: string
    description: string | null
    discount: number
}

export interface ReserveTemplate {
    id: string
    name: string
    estimatedPeopleCount: number
    reserveValue: number | null
    minimumConsumptionValue: number
    promotions: ReserveTemplatePromotions[]
}

export interface StorageProduct {
    id: string
    name: string
    fiscalCode: string | null
    quantity: number
    category: string
    categoryId: string
    image: ImageUrl | null
    basicStorageUnit: BasicStorageUnit | null | null
    avgUnitCost: string | null
    lastUnitCost: string | null
    hasProductionRule: boolean
    isStockable: boolean
    countConvertedProportionOfUnit: ConvertedProportionOfUnit | null
    totalAvgCost: string | null
}

export interface IrregularStorageProduct {
    id: string
    name: string
    fiscalCode: string | null
    count: number
    basicStorageUnit: BasicStorageUnit | null
    proportionOfUnit: ProportionOfUnit | null
    lastUnitCostValue: string | null
    image: ImageUrl | null
}

export interface StorageWithIrregularProducts {
    id: string
    name: string
    isCentral: boolean
    products: IrregularStorageProduct[]
}

export interface StorageProductOutput {
    id: string
    name: string
    count: number
    basicStorageUnit: BasicStorageUnit | null
}

export interface StorageWithProductsWithoutUnitCost {
    id: string
    name: string
    isCentral: boolean
    products: IrregularStorageProduct[]
}

export interface StorageWithProductsWithZeroQuantity {
    id: string
    name: string
    isCentral: boolean
    products: IrregularStorageProduct[]
}

export interface BackofficeStorageInsights {
    lowTurnoverProducts: StorageProductOutput[]
    highTurnoverProducts: StorageProductOutput[]
    zeroQuantityProducts: StorageWithProductsWithZeroQuantity[]
    productsWithoutUnitCostValue: StorageWithProductsWithoutUnitCost[]
}

export interface BackofficeSingleStorageInsights {
    lowTurnoverProducts: StorageProductOutput[]
    highTurnoverProducts: StorageProductOutput[]
    zeroQuantityProducts: IrregularStorageProduct[]
    productsWithoutUnitCostValue: IrregularStorageProduct[]
}

export interface StorageTransferResult {
    productId: string
    count: number
}

export interface BackofficeMultipleStorageTransferProductResult {
    success: StorageTransferResult[]
    error: StorageTransferResult[]
}

export interface StorageTransferResultV2 {
    productId: string
    count: number
    basicStorageUnit: BasicStorageUnit
}

export interface BackofficeMultipleStorageTransferProductResultV2 {
    transferedProducts: StorageTransferResultV2[]
    notActiveOnPlace: StorageTransferResultV2[]
}

export interface GetProductsAtStorageFilters {
    onlyStockableProducts: boolean | null
}

export interface NewProductAlert {
    productId: string
    type: NewProductAlertType
    ruleQuantity: number
}

export interface EditProductAlert {
    id: string
    type: EditProductAlertType | null
    ruleQuantity: number | null
}

export interface ResultEditProductRuleError {
    rule: EditProductAlert
    reason: string
}

export interface ResultEditProductRule {
    error: ResultEditProductRuleError[]
    success: ProductAlert[]
}

export interface ResultCreateProductRuleError {
    rule: NewProductAlert
    reason: string
}

export interface ResultCreateProductRule {
    error: ResultCreateProductRuleError[]
    success: ProductAlert[]
}

export interface ProductStorageRule {
    id: string
    placeId: string
    productId: string
    type: ProductStorageRuleType
    ruleQuantity: number
}

export interface ProductAlert {
    productId: string
    name: string
    minimumAlert: StorageAlert | null
    criticalAlert: StorageAlert | null
    storageQuantity: number
    storageQuantityByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    basicStorageUnit: BasicStorageUnit | null
}

export interface StorageAlert {
    id: string
    value: number
    valueByProportionOfUnit: ConvertedProportionOfUnit | null
}

export interface UserAlert {
    name: string
    email: string
    phone: string | null
}

export interface ProductWithoutCostAtStorageStorage {
    id: string
    name: string
}

export interface ProductWithoutCostAtStorage {
    productId: string
    storage: ProductWithoutCostAtStorageStorage
    lastUnitCostValue: number | null
}

export interface UpdatedProductWithoutCostAtStorage {
    productId: string
    storageId: string
    unitCostValue: string | null
}

export interface BaseProductionHistoryProduct {
    productId: string
    name: string
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit | null | null
    unitCostValue: number | null
}

export interface BackofficeProductionHistoryItemStorage {
    id: string
    name: string
}

export interface BackofficeProductionHistoryItemAuthor {
    id: string
    name: string
}

export interface BackofficeProductionHistoryItemInputs {
    productId: string
    name: string
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit | null | null
    unitCostValue: number | null
    count: number
    lost: number
}

export interface BackofficeProductionHistoryItemOutput {
    productId: string
    name: string
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit | null | null
    unitCostValue: number | null
    count: number
}

export interface BackofficeProductionHistoryItem {
    id: string
    productionRuleId: string
    storage: BackofficeProductionHistoryItemStorage | null
    author: BackofficeProductionHistoryItemAuthor | null
    createdAt: Date
    inputs: BackofficeProductionHistoryItemInputs[]
    output: BackofficeProductionHistoryItemOutput
}

export interface BackofficeProductionHistoryResult {
    items: BackofficeProductionHistoryItem[]
    page: number
    itemsPerPage: number
    totalItems: number
}

export interface Production {
    id: string
    productionRuleId: string
    storage: BackofficeProductionHistoryItemStorage | null
    author: BackofficeProductionHistoryItemAuthor | null
    createdAt: Date
    inputs: BackofficeProductionHistoryItemInputs[]
    output: BackofficeProductionHistoryItemOutput
    recipe: SupplyWithProductionRule
}

export interface ProfitMarginReportItem {
    id: string
    key: string
    name: string
    fiscalCode: string | null
    category: string | null
    quantity: number
    quantityByProportionOfUnit: ConvertedProportionOfUnit | null
    proportionOfUnit: ProportionOfUnit | null
    basicStorageUnit: BasicStorageUnit | null
    value: string
    soldAmount: string
    invoicing: number
    averageSellingPrice: string | null
    totalCost: string
    costPercentage: number | null
    profitMarginValue: string
    profitMarginPercentage: number | null
}

export interface ProfitMarginReportResultInsights {
    highProfitMarginProducts: ProfitMarginReportItem[]
    topHighTurnoverProduct: ProfitMarginReportItem | null
    lowProfitMarginProducts: ProfitMarginReportItem[]
    topLowTurnoverProduct: ProfitMarginReportItem | null
}

export interface ProfitMarginReportResult {
    items: ProfitMarginReportItem[]
    totalValue: string
    totalCost: string
    totalProfit: string
    profitMargin: number
    insights: ProfitMarginReportResultInsights
}

export interface TransferTypeFromStorage {
    id: string
    name: string
}

export interface TransferTypeToStorage {
    id: string | null
    name: string | null
}

export interface TransferTypeEmployee {
    id: string
    name: string | null
}

export interface TransferTypeProduct {
    id: string
    name: string | null
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit | null
    count: number
    unitCostValue: string | null
}

export interface TransferType {
    id: string
    contextId: string
    type: StorageTransferType
    date: Date
    obs: string | null
    fromStorage: TransferTypeFromStorage
    toStorage: TransferTypeToStorage
    employee: TransferTypeEmployee
    product: TransferTypeProduct
}

export interface StorageTransferHistoryResult {
    pagination: PaginationResponse
    transfers: TransferType[]
}

export interface BaseGetStoragesTransfersHistoryByContextFilters {
    productName: string | null
    storageName: string | null
    employeeName: string | null
    types: string[] | null
    since: Date
    until: Date
}

export interface GetStoragesTransfersHistoryByContextFilters {
    productName: string | null
    storageName: string | null
    employeeName: string | null
    types: string[] | null
    since: Date
    until: Date
    pagination: Pagination | null
}

export interface BackofficeTransferBetweenStoragesFromStorage {
    id: string
    name: string
}

export interface BackofficeTransferBetweenStoragesToStorage {
    id: string | null
    name: string | null
}

export interface BackofficeTransferBetweenStoragesEmployee {
    id: string
    name: string
}

export interface BackofficeTransferBetweenStoragesProducts {
    id: string
    name: string
    fiscalCode: string | null
    basicStorageUnit: BasicStorageUnit | null
    count: number
    unitCostValue: string | null
    countByProportionOfUnit: ConvertedProportionOfUnit | null
}

export interface BackofficeTransferBetweenStorages {
    id: string
    contextId: string
    date: Date
    fromStorage: BackofficeTransferBetweenStoragesFromStorage
    toStorage: BackofficeTransferBetweenStoragesToStorage
    employee: BackofficeTransferBetweenStoragesEmployee | null
    products: BackofficeTransferBetweenStoragesProducts[]
}

export interface BackofficeTransfersBetweenStoragesResult {
    pagination: PaginationResponse
    transfers: BackofficeTransferBetweenStorages[]
}

export interface BaseGetBackofficeTransfersBetweenStoragesFilters {
    employeeNameSearch: string | null
    sourceStorageIds: string[] | null
    since: Date | null
    until: Date | null
}

export interface GetBackofficeTransfersBetweenStoragesFilters {
    employeeNameSearch: string | null
    sourceStorageIds: string[] | null
    since: Date | null
    until: Date | null
    pagination: Pagination
}

export interface BaseTableBarRangeWithBarNamesBars {
    id: string
    name: string
}

export interface BaseTableBarRangeWithBarNames {
    fromTable: number
    toTable: number
    environmentName: string | null
    bars: BaseTableBarRangeWithBarNamesBars[]
}

export interface BaseTableBarRange {
    fromTable: number
    toTable: number
    environmentName: string | null
    bars: string[]
}

export interface TableBarRangeResponse {
    id: string
    fromTable: number
    toTable: number
    environmentName: string | null
    bars: BaseTableBarRangeWithBarNamesBars[]
}

export interface TableColor {
    backgroundColor: string
    detailColor: string
    textColor: string
}

export interface TableMapFilters {
    environmentIds: string[] | null
    status: TableMapStatus[] | null
}

export interface TableMapItem {
    id: string
    number: string[]
    name: string
    status: TableMapStatus
    statusTranslated: string
    color: TableColor
    numberOfSeats: number | null
    openedAt: Date | null
    closedAt: Date | null
    totalValue: number
    paidValue: number
    employeeName: string | null
    employeeUsername: string | null
    lastInteractionAt: Date | null
}

export interface GetTablesByEnvironmentAndStatusResponse {
    tables: TableMapItem[]
    pagination: PaginationResponse
}

export interface TableMapOverview {
    tablesInService: number
    tablesNeedingAttention: number
    availableTables: number
    hasActiveEvent: boolean
}

export interface ProductSoldV2MountableProducts {
    id: string
    name: string
    count: number
    section: string
    storageCount: number
}

export interface ProductSoldV2 {
    id: string
    name: string
    category: string
    categoryId: string
    image: ImageUrl | null
    count: number
    type: SellableThing
    unitValue: number
    totalValue: number
    totalDiscount: number
    fiscalCode: string
    mountableProducts: ProductSoldV2MountableProducts[]
    isMountable: boolean | null
    productUnitCost: string | null
    proportionalValue: ProportionalValue | null
    estimatedTax: number | null
    isReturnable: boolean | null
    operationType: ProductSoldV2OperationType
    kind: ProductKind
}

export interface User {
    id: string
    cpf: string
    name: string
    avatar: ImageUrl | null
}

export interface UserFilter {
    type: UserFilterType
    filter: string
}

export interface MinimalEvent {
    id: string
    name: string
}

export interface MinimalEventDetails {
    id: string
    name: string
    beginAt: Date | null
    endAt: Date | null
}

export interface PostPaymentWithPastBill {
    acquirerTransactions: AcquirerTransaction[]
    createdAt: Date
    createdBy: string | null
    id: string
    eventId: string | null
    event: string | null
    beginAt: Date | null
    endAt: Date | null
    place: string | null
    employee: PostPaymentEventEmployee | null
    isDeleted: boolean
    payments: PostPaymentEventPayments[]
    payers: PostPaymentEventPayers[]
    postPaymentType: PostPaymentEventPostPaymentType
    paidPastBill: number
}

export interface UserDetailsTransactionsRefundedBy {
    name: string
    username: string
}

export interface UserDetailsTransactionsProducts {
    name: string
    count: number
    value: number
    discountValue: number
}

export interface UserDetailsTransactions {
    id: string
    userValue: number
    date: Date
    isShared: boolean
    isRefunded: boolean
    refundedBy: UserDetailsTransactionsRefundedBy | null
    sellerName: string
    sellerUsername: string | null
    event: MinimalEventDetails
    tipValue: number
    consumptionWithCreditFromOtherEvents: number
    paidByApp: boolean
    products: UserDetailsTransactionsProducts[]
    paidAfterEvent: number
}

export interface UserDetails {
    recharges: UserRechargeWithEvent[]
    transactions: UserDetailsTransactions[]
    postPayments: PostPaymentWithPastBill[]
    cpf: string
    phone: string
    email: string | null
    birthDate: Date | null
    checkInTime: Date | null
    checkOutTime: Date | null
    checkinMethod: CheckinMethod | null
    checkoutMethod: CheckinMethod | null
    clientsAtTag: number
}

export interface EditUser {
    name: string
    phone: string
    email: string | null
    birthDate: Date | null
}

export interface UserRecharge {
    totalValue: number
    usedValue: number
    authorName: string
    authorUsername: string | null
    date: Date
    isBonus: boolean
    method: UserRechargeMethod | null
    refunded: boolean
    expired: boolean
}

export interface UserRechargeWithEvent {
    totalValue: number
    usedValue: number
    authorName: string
    authorUsername: string | null
    date: Date
    isBonus: boolean
    method: UserRechargeMethod | null
    refunded: boolean
    expired: boolean
    event: MinimalEventDetails
}

export interface NewUserRecharge {
    type: RechargeTypeEnum
    reason: string | null
    value: number
    cpf: string
    name: string | null
    email: string | null
    phone: string | null
    isForeign: boolean | null
    gender: NewUserRechargeGender
    paymentMethod: RechargePaymentMethod | null
}

export interface GiveRechargeError {
    cpf: string
    err: string
}

export interface InternationalUserRecharge {
    type: RechargeTypeEnum
    value: number
    cpf: string
    name: string | null
    email: string | null
    paymentMethod: RechargePaymentMethod | null
}

export interface EventUser {
    id: string
    hasApp: boolean
    checkInTime: Date
    name: string
    email: string | null
    gender: string | null
    phone: string
    cpf: string
    zigCode: string | null
    checkOutTime: Date | null
}

export interface SearchFiltersProductConsumption {
    id: string
    amount: number
}

export interface SearchFiltersBirthdateSince {
    day: number
    month: number
}

export interface SearchFiltersBirthdateUntil {
    day: number
    month: number
}

export interface SearchFiltersBirthdate {
    since: SearchFiltersBirthdateSince | null
    until: SearchFiltersBirthdateUntil | null
    years: number[] | null
}

export interface SearchFilters {
    placeId: string
    gender: string[]
    consumptionVolume: number
    presences: number | null
    firstTimeAtPlace: boolean | null
    presenceDays: number[]
    productConsumption: SearchFiltersProductConsumption[]
    notUsedRecharges: number | null
    since: Date
    until: Date
    name: string | null
    birthdate: SearchFiltersBirthdate | null
}

export interface SearchResult {
    id: string
    name: string
    email: string | null
    birthdate: string | null
    cpf: string
    phone: string
    hasApp: boolean
    consumption: number
    presences: number
    remaningValueOnPlace: number
    firstTimeAtPlace: Date | null
    lastTimeAtPlace: Date | null
}

export interface ClientsAtPlaceResponse {
    data: SearchResult[] | null
    pagination: PaginationResponse | null
    averageTicket: number | null
}

export interface UserDetailsByEventsTransactionsRefundedBy {
    name: string
    username: string
}

export interface UserDetailsByEventsTransactionsProducts {
    name: string
    count: number
    value: number
    discountValue: number
}

export interface UserDetailsByEventsTransactions {
    id: string
    userValue: number
    date: Date
    isShared: boolean
    isRefunded: boolean
    refundedBy: UserDetailsByEventsTransactionsRefundedBy | null
    sellerName: string
    sellerUsername: string | null
    tipValue: number
    consumptionWithCreditFromOtherEvents: number
    paidByApp: boolean
    products: UserDetailsByEventsTransactionsProducts[]
    event: MinimalEventDetails
    paidAfterEvent: number
}

export interface UserDetailsByEvents {
    event: MinimalEventDetails
    recharges: UserRechargeWithEvent[]
    transactions: UserDetailsByEventsTransactions[]
    postPayments: PostPaymentWithPastBill[]
    cpf: string
    phone: string
    email: string | null
    checkInTime: Date | null
    checkOutTime: Date | null
}

export interface ClientSearchFilters {
    since: Date
    until: Date
}

export interface ClientSearchResult {
    id: string
    name: string
    email: string | null
    cpf: string
    phone: string
    averageTicket: number
}

export interface ConsolidatedHistoryEventData {
    id: string
    name: string
    date: Date
    status: string
}

export interface ConsolidatedHistoryConsumptionRechargesInEvent {
    method: string | null
    value: number
}

export interface ConsolidatedHistoryConsumptionEntrances {
    id: string
    name: string
    count: number
    userPaidValue: number
    totalDiscountValue: number
}

export interface ConsolidatedHistoryConsumptionProductsSections {
    id: string
    name: string
    count: number
    title: string
    storageCount: number
    maxCount: number | null
    price: number
    isActive: boolean
    basicStorageUnit: string
}

export interface ConsolidatedHistoryConsumptionProducts {
    id: string
    name: string
    count: number
    userPaidValue: number
    isShared: boolean
    totalDiscountValue: number
    sections: ConsolidatedHistoryConsumptionProductsSections[] | null
}

export interface ConsolidatedHistoryConsumptionPaymentsInEvent {
    method: string
    totalValue: number
}

export interface ConsolidatedHistoryConsumptionRefundedPaymentsInEvent {
    method: string
    totalValue: number
}

export interface ConsolidatedHistoryConsumptionConsumptionObligations {
    id: string
    value: number
    paidValue: number
}

export interface ConsolidatedHistoryConsumption {
    rechargesFromOtherEvents: number
    notSyncRecharges: number
    rechargesInEvent: ConsolidatedHistoryConsumptionRechargesInEvent[]
    bonusReceived: number
    minimumConsumptionUsed: number
    notUsedMinimumConsumption: number
    entrances: ConsolidatedHistoryConsumptionEntrances[]
    products: ConsolidatedHistoryConsumptionProducts[]
    tip: number
    paymentsInEvent: ConsolidatedHistoryConsumptionPaymentsInEvent[]
    refundedPaymentsInEvent: ConsolidatedHistoryConsumptionRefundedPaymentsInEvent[]
    bonusPayments: number | null
    openedBillPayments: number
    paymentsInOtherEvents: number
    consumptionObligations: ConsolidatedHistoryConsumptionConsumptionObligations[]
    openedBill: number
    notUsedRecharges: number
    rechargeDevolutions: number
    rechargeDevolutionsFromOtherEvents: number
    marketPlaceDiscount: number
}

export interface ConsolidatedHistoryGeneralActionsProductRefunds {
    id: string
    name: string
    count: number
}

export interface ConsolidatedHistoryGeneralActionsPackages {
    id: string
    name: string
}

export interface ConsolidatedHistoryGeneralActionsPromotionsUsed {
    id: string
    name: string
}

export interface ConsolidatedHistoryGeneralActionsSingleProductReturns {
    id: string
    returnedCount: number
    eventId: string
    productId: string
    name: string
    unitValue: number
}

export interface ConsolidatedHistoryGeneralActions {
    productRefunds: ConsolidatedHistoryGeneralActionsProductRefunds[]
    packages: ConsolidatedHistoryGeneralActionsPackages[]
    promotionsUsed: ConsolidatedHistoryGeneralActionsPromotionsUsed[]
    removedTip: number
    postPaidLimitChanged: number | null
    attachCount: number
    singleProductReturns: ConsolidatedHistoryGeneralActionsSingleProductReturns[] | null
}

export interface ConsolidatedHistory {
    eventData: ConsolidatedHistoryEventData
    checkInTime: Date
    checkOutTime: Date | null
    consumption: ConsolidatedHistoryConsumption
    generalActions: ConsolidatedHistoryGeneralActions
}

export interface HistoryActionDoneBy {
    name: string
    username: string | null
}

export interface HistoryAction {
    id: string
    type: UserEventHistoryType
    title: string
    subTitle: string | null
    doneBy: HistoryActionDoneBy | null
    value: number | null
    tip: number | null
    obs: string | null
    date: Date | null
    eventId: string
    zigCode: string | null
    syncTime: Date | null
    bonusCategoryName: string | null
    isRefunded: boolean | null
}

export interface UserEventHistoryEventData {
    id: string
    name: string
    date: Date
}

export interface UserEventHistoryFirstInteractionBy {
    name: string
    username: string | null
}

export interface UserEventHistoryCheckoutBy {
    name: string | null
    username: string | null
}

export interface UserEventHistory {
    eventData: UserEventHistoryEventData
    checkInTime: Date
    firstInteractionBy: UserEventHistoryFirstInteractionBy | null
    checkOutTime: Date | null
    checkoutBy: UserEventHistoryCheckoutBy | null
    oldEventsPaid: number
    oldEventsRecharges: number
    history: HistoryAction[]
}

export interface UserTransactionOrderFee {
    name: string
    description: string | null
    value: number
    issueInvoice: boolean
    deliverySource: string | null
    receivedBy: UserTransactionTipReceiver | null
}

export interface UserTransactionResponse {
    id: string
    products: UserTransactionProduct[]
    seller: Seller
    buyers: TransactionBuyers[]
    date: Date
    refunded: boolean
    tip: number
    marketPlaceDiscount: number
    orderFees: UserTransactionOrderFee[]
    total: number | null
}

export interface UserRefundTransactionProducts {
    id: string
    name: string
    count: number
}

export interface UserRefundTransaction {
    id: string
    sellerName: string
    refundedBy: string
    products: UserRefundTransactionProducts[]
}

export interface ClientOpenedBill {
    date: Date
    eventId: string
    eventName: string
    value: number
    tipValue: number
    paidValue: number
    paidInOtherEvents: number
    paidTipValue: number
}

export interface ClientBonus {
    date: Date
    eventId: string
    eventName: string
    eventDate: Date
    totalValue: number
    usedValue: number
    reason: string | null
    givenBy: string
}

export interface ClientDiscount {
    date: Date
    eventId: string
    eventName: string
    eventDate: Date
    value: number
    percentual: number | null
    reason: string | null
    givenBy: string
}

export interface ClientTransferTransactionDetailsUserRef {
    id: string
    name: string
    hasReceivedTransaction: boolean
}

export interface ClientTransferTransactionDetails {
    id: string
    type: SellableThing
    name: string
    count: number
    value: number | null
    discountValue: number | null
    sections: MountableSectionProduct[] | null
    userRef: ClientTransferTransactionDetailsUserRef
}

export interface ClientOnlineFichaHistory {
    name: string
    productId: string
    fichasBought: number
    fichasBurnt: number
    fichasRefunded: number
}

export interface AllOfflineActionTypes {
    id: string
    name: string
}

export interface VendorProductFee {
    productId: string
    productName: string
    percentageFee: number
}

export interface VendorClosing {
    eventId: string
    vendorId: string
    vendorName: string
    totalSoldValue: number
    fixedFee: number
    generalPercentageFee: number
    payDate: Date
    eventDate: Date
    generalFeeValue: number
    otherProductsFeeValue: number
    vendorValueToReceive: number
    tipPercentageFee: number
    tipFeeValue: number
}

export interface VendorRevenueAdjustValuesByCategory {
    electrical: number
    hydraulics: number
    cleaning: number
    supply: number
    other: number
}

export interface VendorRevenue {
    id: string
    name: string
    totalSoldValue: number
    totalSoldValueInCredit: number
    totalSoldValueInCreditFeeValue: number
    totalSoldValueInDebit: number
    totalSoldValueInDebitFeeValue: number
    totalSoldValueInPix: number
    totalSoldValueInPixFeeValue: number
    totalSoldValueInOtherPaymentMethods: number
    totalTipValue: number
    fixedDailyFee: number
    totalDailyFee: number | null
    percentageFee: number
    tipPercentageFee: number | null
    valueFromFee: number
    tipFeeValue: number | null
    totalReceipt: number
    totalBilling: number
    adjustTotalValue: number
    adjustValues: VendorRevenueAdjustValuesByCategory
    cashRetention: number
    cashPayment: number | null
    voucherPayment: number | null
    creditPayment: number | null
    debitPayment: number | null
    creditFee: number | null
    debitFee: number | null
    pixFee: number | null
    voucherRetention: number
    singleProductReturns: number | null
    otherProductsFeeValue: number | null
    tipsInCredit: number | null
    tipsInDebit: number | null
    tipsInPix: number | null
    tipsInOthers: number | null
    floorComplement: number | null
    rechargeLeftovers: number | null
    rechargeLeftoversFeeValue: number | null
}

export interface VendorWithdrawalRequestResponseProRataFee {
    percentage: number
    value: number
}

export interface VendorWithdrawalRequestResponse {
    withdrawId: string
    withdrawValue: number
    availableValue: number
    vendorName: string
    createdBy: string
    requestDate: Date
    anticipationValue: number
    proRataFee: VendorWithdrawalRequestResponseProRataFee | null
    type: VendorWithdrawRequestType
}

export interface VendorWithdrawRequestHistoryResponseHistoryProRataFee {
    percentage: number
    value: number
}

export interface VendorWithdrawRequestHistoryResponseHistory {
    withdrawId: string
    vendorId: string
    requestDate: Date
    vendorName: string
    status: string
    paymentMethod: string | null
    withdrawValue: number
    attachments: string[] | null
    anticipationValue: number
    proRataFee: VendorWithdrawRequestHistoryResponseHistoryProRataFee | null
    type: VendorWithdrawRequestType
    typeText: string
}

export interface VendorWithdrawRequestHistoryResponse {
    month: string
    total: number
    history: VendorWithdrawRequestHistoryResponseHistory[]
}

export interface VendorDebtor {
    userId: string
    userName: string
    value: number
    paidValue: number
    phone: string
    email: string | null
    userDocument: string
}

export interface ZigTagBlockConfirmRecharges {
    id: string
    value: number
    date: Date
    expirationDate: Date | null
    paymentPrePaidType: PaymentPrePaidType | null
}

export interface ZigTagBlockConfirm {
    id: string
    employee: MinimalEmployee
    event: MinimalEvent
    date: Date
    user: User
    zigTagCode: string
    recharges: ZigTagBlockConfirmRecharges[]
}

export interface ZigTagSyncForce {
    id: string
    employee: MinimalEmployee
    event: MinimalEvent
    date: Date
    user: User
    reason: string
    balance: number
    zigTagCode: string
}

export interface ZigTagUser {
    id: string
    name: string | null
    cpf: string
}

export interface ZigTag {
    id: string
    zigCode: string
    user: ZigTagUser | null
    isBlocked: boolean
}

export interface ZigDeviceGroupInfo {
    id: string
    name: string
}

export interface ZigDeviceWithGroupAndBalance {
    uid: string
    zigCode: string
    serialNumber: number | null
    status: ZigDeviceWithGroupAndBalanceStatus
    zigDeviceGroup: ZigDeviceGroupInfo | null
    isAnonymous: boolean
    userId: string | null
    username: string | null
    placeId: string
    totalValue: number
}

export interface MessagePlace {
    id: string
    name: string
}

export interface Message {
    id: string
    message: string
    place: MessagePlace
    date: Date
    status: MessageStatus
    clientsCount: number
    totalSent: number
    createdAt: Date
    value: number | null
    templateId: string | null
    channel: Channel
    campaign: MessageCampaign | null
    totalLines: number | null
    variables: any | null
}

export interface MessageClient {
    phone: string
    name: string | null
    userId: string | null
    cpf: string | null
    gender: MessageClientGender | null
    totalLines: number | null
    observation: string | null
}

export interface MessageClientInsertResponse {
    phone: string
    id: string
}

export interface MessageClientDataForPlace {
    frequency: number | null
    avgTicket: number | null
}

export interface NewMessage {
    placeId: string
    clients: MessageClient[]
    sendAt: Date | null
    message: string | null
    channel: Channel
    campaignId: string | null
    templateId: string | null
    variables: any | null
}

export interface SentMessageClient {
    phone: string
    name: string | null
    userId: string | null
    cpf: string | null
    gender: MessageClientGender | null
    totalLines: number | null
    observation: string | null
    status: SentMessageClientStatus
    errorReason: string | null
}

export interface EditMessage {
    placeId: string | null
    message: string | null
    date: Date | null
    templateId: string | null
    channel: Channel
    campaignId: string | null
    variables: any | null
}

export interface SentResume {
    messageId: string
    mappedStatus: string[]
    placeId: string
}

export interface MessageSentResume {
    messageId: string
    optout: number
    sending: number
    sent: number
    delivered: number
    error: number
    totalMessages: number
    totalCost: number
    totalCostError: number
    totalCostDelivered: number
    totalCostOptout: number
}

export interface MessageCampaign {
    id: string | null
    name: string | null
}

export interface ButtonsTemplate {
    type: ButtonType
    title: string
    index: number | null
    phoneNumber: string | null
    url: string | null
}

export interface MessageTemplate {
    title: string
    variables: GlossaryVariables[] | null
    message: string
    status: MessageTemplateStatus
    buttons: ButtonsTemplate[] | null
    actionType: ActionTypes | null
    image: ArrayBuffer | null
    rejectedReason: string | null
    placeId: string
}

export interface MessageTemplateResponse {
    title: string
    variables: GlossaryVariables[] | null
    message: string
    status: MessageTemplateStatus
    buttons: ButtonsTemplate[] | null
    image: string | null
    id: string
    placeId: string
    isUsed: boolean
}

export interface CampaignsInvestment {
    smsCampaignId: string
    message: string
    date: Date
    sentMessages: number
    campaignCost: number
    spentByClients: number
    investmentMetric: number
    placeName: string
    checkinsAfterMessage: number
}

export interface CampaignsInvestmentResult {
    total: number
    campaigns: CampaignsInvestment[]
}

export interface MessagesSentAnalyticsFilters {
    placeIds: string[] | null
    eventIds: string[] | null
    origins: MessageSentOrigin[] | null
    since: Date
    until: Date
}

export interface MessagesSentByOrigin {
    origin: string
    count: number
    percentage: number
}

export interface MessagesSentByPlace {
    placeId: string
    placeName: string
    count: number
}

export interface MessagesSentByEvent {
    eventId: string
    eventName: string
    count: number
}

export interface MessagesSentDailyVolume {
    date: Date
    count: number
}

export interface MessagesSentAnalytics {
    totalSent: number
    deliveredCount: number
    failedCount: number
    successRate: number
    activePlaces: number
    placesWithMessages: number
    eventsWithMessages: number
    distinctOrigins: number
    byOrigin: MessagesSentByOrigin[]
    byPlace: MessagesSentByPlace[]
    byEvent: MessagesSentByEvent[]
    dailyVolume: MessagesSentDailyVolume[]
}

export interface MessagesSentListItem {
    placeName: string
    eventName: string | null
    date: Date
    origin: string
    smsCount: number
    deliveredCount: number
    failedCount: number
    successRate: number
}

export interface MessagesSentListResult {
    data: MessagesSentListItem[]
    pagination: PaginationResponse
}

export interface BackofficeBaseChartAccount {
    name: string
    description: string | null
    operationChartAccount: BackOfficeOperationChartAccount | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    isCashflow: boolean
    isDRE: boolean
}

export interface BackOfficeChartAccountCreate {
    name: string
    description: string | null
    operationChartAccount: BackOfficeOperationChartAccount | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    isCashflow: boolean
    isDRE: boolean
    chartAccountParentId: string | null
}

export interface BackOfficeChartAccountUpdate {
    name: string
    description: string | null
    operationChartAccount: BackOfficeOperationChartAccount | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    isCashflow: boolean
    isDRE: boolean
}

export interface BackOfficeChartAccountResponseMetadata {
    canCreateChildren: boolean
    canUpdate: boolean
    canDelete: boolean
    isFixed: boolean
}

export interface BackOfficeChartAccountResponse {
    id: string
    code: string
    name: string
    description: string | null
    level: number
    operationChartAccount: BackOfficeOperationChartAccount | null
    chartAccountParentId: string | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    metadata: BackOfficeChartAccountResponseMetadata | null
    isCashflow: boolean
    isDRE: boolean
}

export interface BackOfficeChartAccountResponseTree {
    id: string
    code: string
    name: string
    description: string | null
    level: number
    operationChartAccount: BackOfficeOperationChartAccount | null
    chartAccountParentId: string | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    metadata: BackOfficeChartAccountResponseMetadata | null
    isCashflow: boolean
    isDRE: boolean
    children: BackOfficeChartAccountResponseTree[]
}

export interface BackOfficeImportChartAccountPayload {
    startRow: number
    code: string
    name: string
    level: string
    operation: string
    type: string
    file: ArrayBuffer
}

export interface BackOfficeChartAccountTreeMetadata {
    canCreateChildren: boolean
    canUpdate: boolean
    canDelete: boolean
    isFixed: boolean
}

export interface BackOfficeChartAccountTree {
    id: string
    code: string
    name: string
    description: string | null
    level: number
    operationChartAccount: BackOfficeOperationChartAccount | null
    chartAccountParentId: string | null
    typeChartAccount: BackOfficeTypeChartAccount | null
    metadata: BackOfficeChartAccountTreeMetadata | null
    isCashflow: boolean
    isDRE: boolean
    children: BackOfficeChartAccountTree[]
}

export interface BackofficeBaseAccountV2BankAccount {
    holder: string
    documentNumber: string
    purpose: BackofficePurposeTypes | null
    agency: string
    account: string
    bank: string
}

export interface BackofficeBaseAccountV2 {
    accountName: string
    purpose: BackofficePurposeTypes | null
    bankAccount: BackofficeBaseAccountV2BankAccount | null
    isMainAccount: boolean
    initialBalance: number
    initialBalanceDate: Date
    currentBalance: number
    isValidated: boolean
}

export interface BackofficeAccountV2 {
    accountId: string
    isDeleted: boolean | null
    needsBalanceUpdate: boolean | null
    accountName: string
    purpose: BackofficePurposeTypes | null
    bankAccount: BackofficeBaseAccountV2BankAccount | null
    isMainAccount: boolean
    initialBalance: number
    initialBalanceDate: Date
    currentBalance: number
    isValidated: boolean
}

export interface BackofficeParamDates {
    initial: Date
    final: Date
}

export interface BackofficeAccountBillsReportChildrenPeriods {
    value: number
    date: string
}

export interface BackofficeAccountBillsReportChildren {
    id: string
    code: string
    name: string
    children: BackofficeAccountBillsReportChildren[]
    total: number | null
    chartAccountParentId: string | null
    periods: BackofficeAccountBillsReportChildrenPeriods[]
    level: number
}

export interface BackofficeAccountBillsReportSummaryPeriods {
    value: number
    date: string
}

export interface BackofficeAccountBillsReportSummary {
    periods: BackofficeAccountBillsReportSummaryPeriods[]
    total: number
}

export interface BackofficeAccountBillsReportField {
    dre: BackofficeAccountBillsReportChildren[]
    summary: BackofficeAccountBillsReportSummary
}

export interface BackofficeAccountBillsReportResponse {
    incomeList: BackofficeAccountBillsReportField
    costsList: BackofficeAccountBillsReportField
    expensesList: BackofficeAccountBillsReportField
    summary: BackofficeAccountBillsReportSummary
}

export interface GetBackofficeAccountBillsReportParams {
    contextId: string
    organizationId: string
    interval: BackofficeParamDates
}

export interface FinancialClosingReportMapFields {
    name: string
    fee: string | null
    payDate: string
    type: string
    isActive: boolean
}

export interface FinancialClosingReportMap {
    division: string
    name: string
    fee: string | null
    payDate: string
    type: string
}

export interface FinancialClosingReportMapResponse {
    integratedIncome: FinancialClosingReportMapFields[]
    notIntegratedIncome: FinancialClosingReportMapFields[]
    zigFees: FinancialClosingReportMapFields[]
    securityDeposit: FinancialClosingReportMapFields[]
    otherCharges: FinancialClosingReportMapFields[]
    rechargeRefund: FinancialClosingReportMapFields[]
}

export interface BackofficeAccountBillsChartAccount {
    chartAccountId: string
    type: BackofficeTypeAccountBillsChartAccount
    name: string | null
    code: string | null
    deletedAt: Date | null
    updatedAt: Date | null
    updatedBy: string | null
    isDeleted: boolean | null
    value: number | null
}

export interface BackofficeAccountBillsChartAccountResponse {
    id: string | null
    chartAccountId: string
    type: BackofficeTypeAccountBillsChartAccount
    name: string | null
    code: string | null
    deletedAt: Date | null
    updatedAt: Date | null
    updatedBy: string | null
    isDeleted: boolean | null
    value: number | null
}

export interface BackofficeRecurringPayment {
    typeInterval: TypeInterval
    interval: number
    times: number
}

export interface BackofficeRecurringGroupSummary {
    totalCount: number
    generatedCount: number
    paidCount: number
    pendingCount: number
    overdueCount: number
    paidAmount: number
    pendingAmount: number
    overdueAmount: number
    firstDueDate: Date
    lastDueDate: Date
    nextDueDate: Date | null
}

export interface BackofficeRecurringInfo {
    recurringGroupId: string
    recurringSequence: number | null
    recurringTotalCount: number | null
    recurringStatus: BackofficeRecurringStatus | null
    isFirstInGroup: boolean | null
    isLastInGroup: boolean | null
    groupSummary: BackofficeRecurringGroupSummary | null
}

export interface BackofficeBaseAccountBills {
    supplierId: string | null
    docNumber: string | null
    dueDate: Date
    paymentDate: Date | null
    invoiceDate: Date | null
    description: string | null
    value: number | null
    paymentMethod: BackofficePaymentMethod | null
    accountId: string | null
    costCenterId: string | null
    interest: number | null
    fine: number | null
    discount: number | null
    paidValue: number | null
    isPaid: boolean
    isReconciled: boolean
    type: BackofficeTypeAccountBills
    placeId: string | null
    updatedBy: string | null
    isDeleted: boolean | null
    createdBy: string | null
    chartAccounts: BackofficeAccountBillsChartAccountResponse[]
    observation: string | null
    recurringPayment: BackofficeRecurringPayment | null
    financialFees: number | null
    attachments: BackofficeAttachment[] | null
    eventId: string | null
    recurringGroupId: string | null
    recurringSequence: number | null
    recurringTotalCount: number | null
    recurringStatus: BackofficeRecurringStatus | null
}

export interface BackofficeAccountBills {
    id: string
    supplierId: string | null
    docNumber: string | null
    dueDate: Date
    paymentDate: Date | null
    invoiceDate: Date | null
    description: string | null
    value: number | null
    paymentMethod: BackofficePaymentMethod | null
    accountId: string | null
    costCenterId: string | null
    interest: number | null
    fine: number | null
    discount: number | null
    paidValue: number | null
    isPaid: boolean
    isReconciled: boolean
    type: BackofficeTypeAccountBills
    placeId: string | null
    updatedBy: string | null
    isDeleted: boolean | null
    createdBy: string | null
    chartAccounts: BackofficeAccountBillsChartAccountResponse[]
    observation: string | null
    recurringPayment: BackofficeRecurringPayment | null
    financialFees: number | null
    attachments: BackofficeAttachment[] | null
    eventId: string | null
    recurringGroupId: string | null
    recurringSequence: number | null
    recurringTotalCount: number | null
    recurringStatus: BackofficeRecurringStatus | null
}

export interface BackofficeGetParamsAccountsBills {
    docNumber: string | null
    dueDate: BackofficeParamDates | null
    invoiceDate: BackofficeParamDates | null
    placeId: string
    paymentDate: BackofficeParamDates | null
    organizationId: string
    type: BackofficeTypeAccountBills
    isPaid: boolean | null
    supplierName: string | null
    value: number | null
    status: BackofficeAccountBillsStatus | null
    chartAccountId: string | null
    pagination: Pagination | null
    recurringGroupId: string | null
    installmentGroupId: string | null
    orderBy: BackofficeGetParamsAccountsBillsOrderBy | null
    order: BackofficeGetParamsAccountsBillsOrder | null
}

export interface BackofficeChartAccount {
    id: string
    chartAccountId: string
    accountBillsId: string
    code: string
    name: string
    level: number
    type: string
}

export interface BackofficeAccountBillsAttachmentResponse {
    id: string
    url: string
    fileName: string
}

export interface BackofficeGetAccountBillsResponse {
    id: string
    supplier: BackofficeSupplier | null
    costCenter: BackofficeCostCenter | null
    account: BackofficeAccountV2 | null
    docNumber: string | null
    interest: number | null
    fine: number | null
    discount: number | null
    paidValue: number | null
    isPaid: boolean
    isReconciled: boolean
    type: BackofficeTypeAccountBills
    placeId: string
    deletedAt: Date | null
    updatedAt: Date | null
    updatedBy: string | null
    createdAt: Date | null
    createdBy: string | null
    isDeleted: boolean
    chartAccounts: BackofficeAccountBillsChartAccountResponse[]
    description: string | null
    invoiceDate: Date | null
    dueDate: Date
    paymentDate: Date | null
    value: number | null
    paymentMethod: BackofficePaymentMethod | null
    observation: string | null
    attachments: BackofficeAccountBillsAttachmentResponse[] | null
    recurringPayment: BackofficeRecurringPayment | null
    financialFees: number | null
    status: BackofficeAccountBillsStatus
    recurringGroupId: string | null
    recurringInfo: BackofficeRecurringInfo | null
}

export interface BackofficeGetResumeAccountBillsResponse {
    overdue: number
    maturing: number
    due: number
    paid: number
    total: number
}

export interface BackofficeGetDREParams {
    placeId: string
    interval: BackofficeParamDates
}

export interface BackofficeFinancialFeeType {
    app: number | null
    inHouse: number | null
    expiredRecharge: number | null
    card: number | null
    rechargeRemainings: number | null
    zigMachineCredit: number | null
    zigMachineDebit: number | null
    debitAcquirer: number | null
    creditAcquirer: number | null
    bonus: number | null
    smsCost: number | null
    cpfConsultCost: number | null
    hasCustomizedCard: boolean | null
    barIncome: number | null
    entranceIncome: number | null
    barMinimumConsumption: number | null
    entranceMinimumConsumption: number | null
    debitDays: number | null
    creditDays: number | null
    rappi: number | null
    ame: number | null
    deliveryOnline: number | null
    ifood: number | null
    uber: number | null
    pix: number | null
    reserveOnline: number | null
    clientfloategratedMachine: number | null
    creditOpenSale: number | null
    debitOpenSale: number | null
    pixOpenSale: number | null
    relatedStakeholderRetention: number | null
    terminalRentValue: number | null
    integratedFoodVoucher: number | null
    zigMachineCreditInInstallments: number | null
}

export interface BackofficeFinancialPayDatesType {
    debit: Date | null
    credit: Date | null
    expiredRecharge: Date | null
    fee: Date | null
    rappiDate: Date | null
    ameDate: Date | null
    ifoodDate: Date | null
    uberDate: Date | null
}

export interface BackofficeFinancialClosing {
    date: Date
    fee: BackofficeFinancialFeeType
    payDates: BackofficeFinancialPayDatesType
    appTransactions: number | null
    appCreditTransactions: number | null
    inHouseTransactions: number | null
    inHouseFromOtherEvents: number | null
    bonusTransactions: number | null
    minimumConsumptionTransactions: number | null
    generalZigMachineCredit: number | null
    generalZigMachineDebit: number | null
    notUsedRecharges: number | null
    consumedRecharges: number | null
    totalRecharges: number | null
    expiredRecharge: number | null
    smsCharges: number | null
    cpfConsultCharges: number | null
    eventId: string
    placeId: string
    organizationId: string
    cardActivationsValue: number | null
    barIncomeCash: number | null
    barIncomeCredit: number | null
    barIncomeDebit: number | null
    barIncomeZigCredit: number | null
    barIncomeZigDebit: number | null
    barIncomeVoucher: number | null
    barIncomeDashboard: number | null
    barIncomeAnticipated: number | null
    barIncomeApp: number | null
    entranceIncomeApp: number | null
    entranceIncomeCash: number | null
    entranceIncomeCredit: number | null
    entranceIncomeDebit: number | null
    entranceIncomeZigCredit: number | null
    entranceIncomeZigDebit: number | null
    entranceIncomeVoucher: number | null
    entranceIncomeDashboard: number | null
    entranceIncomeAnticipated: number | null
    barIncomePostEvent: number | null
    entranceIncomePostEvent: number | null
    barMinimumConsumption: number | null
    entranceMinimumConsumption: number | null
    barIncome: number | null
    entranceIncome: number | null
    cardActivationCashDevolutions: number | null
    cardActivationProductDevolutions: number | null
    barIncomeRappi: number | null
    entranceIncomeRappi: number | null
    barTip: number | null
    entranceTip: number | null
    barIncomeAme: number | null
    entranceIncomeAme: number | null
    barIncomeDeliveryOnline: number | null
    barIncomeIfood: number | null
    entranceIncomeIfood: number | null
    barIncomeUber: number | null
    entranceIncomeUber: number | null
    barIncomePix: number | null
    entranceIncomePix: number | null
    paidConsumptionObligation: number | null
    givenAndUsedBonus: number | null
    entranceIncomeReserveOnline: number | null
    grossProductSold: number | null
    discountProductSold: number | null
    grossEntranceSold: number | null
    discountEntranceSold: number | null
    grossZigCardSold: number | null
    discountZigCardSold: number | null
    grossCouvertSold: number | null
    discountCouvertSold: number | null
    manualInvoiceProductsValue: number | null
    manualInvoiceTipsValue: number | null
    eventEntranceConsumptionUsed: number | null
    paidNotSyncTransactions: number | null
    rechargeBalance: number | null
    remainingConsumptionObligation: number | null
    openSaleCredit: number | null
    openSaleDebit: number | null
    openSalePix: number | null
    generalClientIntegratedMachineCredit: number | null
    generalClientIntegratedMachineDebit: number | null
    openSaleCreditClientIntegrated: number | null
    openSaleDebitClientIntegrated: number | null
    terminals: number | null
    whatsappCharges: number | null
    barIncomeIntegratedFoodVoucher: number | null
    entranceIncomeIntegratedFoodVoucher: number | null
    generalZigMachineFoodVoucher: number | null
    generalClientIntegratedMachineFoodVoucher: number | null
    openSaleFoodVoucher: number | null
    openSaleFoodVoucherClientIntegrated: number | null
    barIncomeZigCreditInInstallments: number | null
    entranceIncomeZigCreditInInstallments: number | null
    generalZigMachineCreditIn2Installments: number | null
    generalZigMachineCreditIn3Installments: number | null
    generalZigMachineCreditIn4Installments: number | null
    generalZigMachineCreditIn5Installments: number | null
    generalZigMachineCreditIn6Installments: number | null
    generalZigMachineCreditIn7Installments: number | null
    generalZigMachineCreditIn8Installments: number | null
    generalZigMachineCreditIn9Installments: number | null
    generalZigMachineCreditIn10Installments: number | null
    generalZigMachineCreditIn11Installments: number | null
    generalZigMachineCreditIn12Installments: number | null
    openSaleCreditIn2Installments: number | null
    openSaleCreditIn3Installments: number | null
    openSaleCreditIn4Installments: number | null
    openSaleCreditIn5Installments: number | null
    openSaleCreditIn6Installments: number | null
    openSaleCreditIn7Installments: number | null
    openSaleCreditIn8Installments: number | null
    openSaleCreditIn9Installments: number | null
    openSaleCreditIn10Installments: number | null
    openSaleCreditIn11Installments: number | null
    openSaleCreditIn12Installments: number | null
    notCharged: number | null
    openedBillPayments: number | null
    barIncomeTax: number | null
    entranceIncomeTax: number | null
}

export interface FinancialEventClosingConferenceFee {
    name: string
    value: number
    translate: string | null
}

export interface FinancialEventClosingConferenceAccount {
    name: string
    value: number
    payDate: Date
    type: TypeClosingAccount
    translate: string | null
    invoiceDate: Date
}

export interface FinancialConferenceParams {
    name: string
    account: FinancialEventClosingConferenceAccount
    fee: FinancialEventClosingConferenceFee | null
    total: number
}

export interface FinancialConferenceResponse {
    account: FinancialEventClosingConferenceAccount
    fee: FinancialEventClosingConferenceFee | null
    total: number
}

export interface FinancialEventClosingConference {
    resumed: FinancialConferenceResponse[]
    integratedIncome: FinancialConferenceResponse[] | null
    notIntegratedIncome: FinancialConferenceResponse[] | null
    zigFees: FinancialConferenceResponse[] | null
    securityDeposit: FinancialConferenceResponse[] | null
    otherCharges: FinancialConferenceResponse[] | null
    rechargeRefund: FinancialConferenceResponse[] | null
}

export interface BackofficeGetAccountBillsResponseWithPagination {
    data: BackofficeGetAccountBillsResponse[]
    pagination: PaginationResponse
}

export interface BackofficeInstallmentPreviewResponse {
    installmentNumber: number
    dueDate: Date
    valueInCents: number
    description: string
}

export interface BackofficePreviewInstallmentsRequest {
    totalAmountInCents: number
    installmentCount: number
    firstDueDate: Date
    intervalType: TypeInterval
    intervalValue: number
}

export interface BackofficeUpdatePreviewInstallmentsRequest {
    originalRequest: BackofficePreviewInstallmentsRequest
    modifiedInstallment: BackofficeInstallmentPreviewResponse
}

export interface BackofficeCreateInstallmentResponse {
    installmentGroupId: string
    totalInstallments: number
    createdAccountBills: string[]
}

export interface BackofficeAccountBillDetailValue {
    value: number
    chartAccountId: string
}

export interface BackofficeAccountBillValues {
    interest: BackofficeAccountBillDetailValue | null
    fine: BackofficeAccountBillDetailValue | null
    discount: BackofficeAccountBillDetailValue | null
    financialFees: BackofficeAccountBillDetailValue | null
}

export interface MissingAccountBillsOnEventClosingParams {
    closingType: string
    closingTypeTax: string | null
    paymentDate: string
    chartAccountId: string
    typeAccountBills: BackofficeTypeAccountBills
}

export interface MissingAccountBillsOnEventClosingQuery {
    eventId: string
    closingConferenceStatus: string
    placeId: string
    organizationId: string
    date: Date
    closingType: number
    closingTypeTax: number | null
    paymentDate: Date
}

export interface BackofficeMissingAccountBillsOnEventClosing {
    eventId: string
    closingConferenceStatus: string
    placeId: string
    organizationId: string
    date: Date
    closingType: number
    closingTypeTax: number | null
    paymentDate: Date
    chartAccountId: string
    typeAccountBills: BackofficeTypeAccountBills
}

export interface BackofficeAccountBillHistoryUserRef {
    id: string
    name: string | null
}

export interface BackofficeAccountBillHistoryFieldChange {
    field: string
    fromValue: string | null
    toValue: string
}

export interface BackofficeAccountBillHistoryEntry {
    id: string
    eventType: BackofficeAccountBillHistoryEventType
    performedAt: Date
    performedBy: BackofficeAccountBillHistoryUserRef
    changes: BackofficeAccountBillHistoryFieldChange[] | null
}

export interface BackofficeStorageInventoryStorage {
    id: string
    name: string
}

export interface BackofficeStorageInventoryCategory {
    id: string
    name: string
    image: ImageUrl | null
}

export interface BackofficeStorageInventoryUser {
    id: string
    name: string
}

export interface BackofficeStorageInventoryWithStorage {
    id: string
    name: string
    storageId: string
    storage: BackofficeStorageInventoryStorage
    categories: BackofficeStorageInventoryCategory[]
    status: BackofficeStorageInventoryStatus
    createdBy: BackofficeStorageInventoryUser
    updatedBy: BackofficeStorageInventoryUser
    createdAt: Date
    updatedAt: Date
    lastReopenReason: string | null
}

export interface BackofficeStorageInventoryProduct {
    productId: string
    name: string
    category: BackofficeStorageInventoryCategory
    fiscalCode: string
    basicStorageUnit: BasicStorageUnit
    count: number | null
}

export interface CompleteBackofficeStorageInventory {
    id: string
    name: string
    storageId: string
    storage: BackofficeStorageInventoryStorage
    categories: BackofficeStorageInventoryCategory[]
    status: BackofficeStorageInventoryStatus
    createdBy: BackofficeStorageInventoryUser
    updatedBy: BackofficeStorageInventoryUser
    createdAt: Date
    updatedAt: Date
    lastReopenReason: string | null
    products: BackofficeStorageInventoryProduct[]
}

export interface BackofficeStorageInventoriesResult {
    items: BackofficeStorageInventoryWithStorage[]
    page: number
    itemsPerPage: number
    totalItems: number
}

export interface BackofficeStorageInventoryProductComparison {
    productId: string
    name: string
    category: BackofficeStorageInventoryCategory
    fiscalCode: string
    basicStorageUnit: BasicStorageUnit
    proportionOfUnit: ProportionOfUnit | null
    storageInventoryCount: number | null
    storageInventoryCountByProportionOfUnit: ConvertedProportionOfUnit | null
    storageCount: number
    storageCountByProportionOfUnit: ConvertedProportionOfUnit | null
    averageUnitCostValue: string | null
    difference: number | null
    image: ImageUrl | null
    storageTransferType: BackofficeStorageInventoryProductTransferType | null
}

export interface BackofficeStorageInventoryAndStorageComparison {
    storageInventory: BackofficeStorageInventoryWithStorage
    products: BackofficeStorageInventoryProductComparison[]
    pagination: PaginationResponse | null
    totalItemsCount: number | null
}

export interface GetBackofficeStorageInventoryAndStorageComparisonFilters {
    categoryName: string | null
    productName: string | null
    filterType: GetBackofficeStorageInventoryAndStorageComparisonFiltersFilterType | null
}

export interface BackofficeUpdateStorageInventoryProductsTransferType {
    productId: string
    storageTransferType: BackofficeStorageInventoryProductTransferType
}

export interface BackofficeStorageInventoryProductInconsistency {
    productId: string
    name: string
    category: BackofficeStorageInventoryCategory
    fiscalCode: string
    basicStorageUnit: BasicStorageUnit
    storageInventoryCount: number | null
    storageInventoryCountByProportionOfUnit: ConvertedProportionOfUnit | null
    storageCount: number
    storageCountByProportionOfUnit: ConvertedProportionOfUnit | null
    averageUnitCostValue: string | null
    quantityDifference: number | null
    unitCostDifference: string | null
    image: ImageUrl | null
    storageTransferType: BackofficeStorageInventoryProductTransferType | null
    proportionOfUnit: ProportionOfUnit | null
}

export interface BackofficeStorageInventoriesTotalizers {
    total: number
    open: number
    inReview: number
    approved: number
    reopened: number
}

export interface Summary {
    addedProducts: number
    returnedProducts: number
    totalSalesCommission: number
    totalSales: number
}

export interface HawkerReportFilters {
    hawkerNames: string[] | null
    hawkerDocuments: string[] | null
    hawkerCashierNames: string[] | null
    hawkerCashierDocuments: string[] | null
    employeeNames: string[] | null
    hawkerIds: string[] | null
    hawkerCycleId: string | null
}

export interface HawkerReportRelease {
    hawkerProductReleaseId: string
    cycleId: string
    dateTime: Date
    quantity: number
    unitValue: number
    total: number
}

export interface Sales {
    productId: string
    productName: string
    type: HawkerSaleType
    quantity: number
    value: number
    total: number
    commission: number | null
    releases: HawkerReportRelease[] | null
}

export interface HawkerPaymentMethod {
    type: AllPaymentMethods
    value: number
}

export interface SessionsOpenedBar {
    id: string
    name: string
}

export interface SessionsClosedBar {
    id: string
    name: string
}

export interface Sessions {
    id: string
    eventId: string
    hawkerId: string
    hawkerName: string
    hawkerDocument: string
    cycleCount: number
    change: number
    receivedValue: number
    valueToReceive: number
    balance: number
    openedAt: Date
    closedAt: Date | null
    usernames: string[]
    openedBar: SessionsOpenedBar | null
    closedBar: SessionsClosedBar | null
    hasCyclesClosedByDifferentCashier: boolean | null
    isClosedByDifferentCashier: boolean | null
}

export interface CycleOpenedBar {
    id: string
    name: string
}

export interface CycleClosedBar {
    id: string
    name: string
}

export interface Cycle {
    id: string
    sessionId: string
    eventId: string
    openedAt: Date
    closedAt: Date | null
    closingValue: number
    receivedValue: number
    balance: number
    cashierIdOpener: string
    cashierNameOpener: string
    cashierUsernameOpener: string
    cashierIdCloser: string | null
    cashierNameCloser: string | null
    cashierUsernameCloser: string | null
    openedBar: CycleOpenedBar | null
    closedBar: CycleClosedBar | null
}

export interface CycleSummary {
    canceled: Sales[]
    devolved: Sales[]
    released: Sales[]
    remained: Sales[]
    transacted: Sales[]
    paymentMethods: HawkerPaymentMethod[]
    total: Sales[]
}

export interface HawkersSummary {
    hawkerId: string
    hawkerName: string
    hawkerDocument: string
    total: number
    commission: number | null
    usernames: string[]
}

export interface EventSummary {
    hawkerSummary: HawkersSummary[]
    quantityReleased: number
    totalReleased: number
}

export interface HawkerReport {
    sales: Sales[]
    total: number
}

export interface Buyer {
    name: string
    document: string
    paymentType: PaymentType
    total: number
}

export interface TableReportBase {
    tableId: string
    tableName: string
    employeeName: string
    numberOfSeats: number
    openedAt: Date
    closedAt: Date | null
    discount: number
    refundValue: number
    totalValue: number
}

export interface TableProduct {
    imageUrl: ImageUrl | null
    sku: string
    name: string
    quantity: number
    unitPrice: number
    subTotal: number
    discount: number
    total: number
}

export interface TableReport {
    tableId: string
    tableName: string
    employeeName: string
    numberOfSeats: number
    openedAt: Date
    closedAt: Date | null
    discount: number
    refundValue: number
    totalValue: number
    userId: string
    eventId: string
    productsValue: number | null
    tip: number | null
    duration: number | null
    buyers: Buyer[]
}

export interface TableProductReport {
    tableId: string
    tableName: string
    employeeName: string
    numberOfSeats: number
    openedAt: Date
    closedAt: Date | null
    discount: number
    refundValue: number
    totalValue: number
    products: TableProduct[]
}

export interface TableReportTotals {
    totalSeats: number
    totalTables: number
    totalRevenue: number
    totalRefund: number
    averageDurationInMinutes: number
}

export interface GetTableReportResponse {
    tables: TableReport[]
    totals: TableReportTotals
}

export interface TablesReportTotals {
    totalSeats: number
    totalTables: number
    totalRevenue: number
    totalRefund: number
    averageDurationInMinutes: number
    openTables: number
    peopleAverageTicket: number
    tableAverageTicket: number
    openTablesAverageTicket: number
}

export interface Filters {
    status: TableFilterStatusEnum | null
    tableNumbers: string[] | null
    employeeIds: string[] | null
}

export interface TableReportV2 {
    tableId: string
    tableName: string
    employeeName: string
    numberOfSeats: number
    openedAt: Date
    closedAt: Date | null
    discount: number
    refundValue: number
    totalValue: number
    userId: string
    eventId: string
    productsValue: number | null
    tip: number | null
    duration: number | null
    checkoutBy: MinimalEmployee | null
}

export interface GetTablesReportV2Response {
    tables: TableReportV2[]
    pagination: PaginationResponse
}

export interface GetTablesMinimun {
    id: string
    name: string | null
    numbers: string[]
}

export interface GetTablesReportPropsPlace {
    id: string
    period: PeriodTime
}

export interface GetTablesReportProps {
    eventId: string | null
    place: GetTablesReportPropsPlace | null
}

export interface GetPlaceZendeskTicketsFilters {
    period: PeriodTime | null
    status: ZendeskTicketStatus[] | null
}

export interface TicketStatus {
    id: string
    name: string
}

export interface ZendeskTicket {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    requesterId: string
    type: string
    status: TicketStatus
    subject: string
    userName: string
    email: string
    phone: string
}

export interface ZendeskTicketsPaginationResponse {
    data: ZendeskTicket[]
    pagination: BasePaginationResponse
}

export interface ListEmployeeZendeskTicketsFilters {
    period: PeriodTime | null
    status: ZigTicketStatus[] | null
    search: string | null
    placeIds: string[]
}

export interface EmployeeZendeskTicket {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    requesterId: string
    type: string | null
    status: ZigTicketStatus
    subject: string
    userName: string
    placeName: string | null
}

export interface EmployeeZendeskTicketsPaginationResponse {
    data: EmployeeZendeskTicket[]
    pagination: BasePaginationResponse
}

export interface ZendeskAttachment {
    id: string
    fileName: string
    contentUrl: string
    contentType: string
    size: number
}

export interface ZendeskMessage {
    id: string
    body: string | null
    authorName: string
    authorAvatarUrl: string | null
    isRequester: boolean
    createdAt: Date
    attachments: ZendeskAttachment[]
}

export interface ZendeskTicketDetails {
    id: string
    subject: string
    status: ZigTicketStatus
    createdAt: Date
    updatedAt: Date
    closedAt: Date | null
    messages: ZendeskMessage[]
}

export interface DeliveryRatePerRadius {
    radius: number
    value: number
}

export interface UpsertMenuConfigRequest {
    name: string | null
    primaryColor: string
    secondaryColor: string
    contrastColor: string
    isOpenStatusVisible: boolean
    isWaitingTimeVisible: boolean
    taxType: MenuConfigsTaxType | null
    baseRateValue: number | null
    ratePerKm: number | null
    waitingTime: number | null
    additionalFieldType: MenuConfigsAdditionalFieldType | null
    postalCode: string | null
    state: string | null
    city: string | null
    neighborhood: string | null
    address: string | null
    number: string | null
    complement: string | null
    logoImage: ArrayBuffer | null
    bannerImage: ArrayBuffer | null
}

export interface UpsertMenuConfigResponse {
    name: string | null
    primaryColor: string
    secondaryColor: string
    contrastColor: string
    isOpenStatusVisible: boolean
    isWaitingTimeVisible: boolean
    taxType: MenuConfigsTaxType | null
    baseRateValue: number | null
    ratePerKm: number | null
    waitingTime: number | null
    additionalFieldType: MenuConfigsAdditionalFieldType | null
    postalCode: string | null
    state: string | null
    city: string | null
    neighborhood: string | null
    address: string | null
    number: string | null
    complement: string | null
    id: string
    logoImage: string | null
    bannerImage: string | null
}

export interface GetActiveMenusResponse {
    dineIn: boolean
    delivery: boolean
    onlineTab: boolean
    onlinePostPayment: boolean
    viewMenu: boolean
}

export interface GetRatePerRadiusResponse {
    isOpenStatusVisible: boolean | null
    isWaitingTimeVisible: boolean | null
    waitingTime: number | null
    taxType: MenuConfigsTaxType | null
    baseRateValue: number | null
    ratePerKm: number | null
    deliveryRatePerRadius: DeliveryRatePerRadius[] | null
}

export interface WorkingPeriods {
    dayOfWeek: WeekDay
    startTime: string
    endTime: string
}

export interface GetWorkingPeriodsResponse {
    days: WeekDay[]
    startTime: string
    endTime: string
}

export interface PlaceSectorBars {
    id: string
    name: string
}

export interface PlaceSectorAccessPolicies {
    id: string
    name: string
}

export interface PlaceSector {
    id: string
    name: string
    description: string | null
    placeId: string
    createdAt: Date
    createdBy: string
    updatedAt: Date
    isDeleted: boolean
    bars: PlaceSectorBars[]
    accessPolicies: PlaceSectorAccessPolicies[]
}

export interface NewPlaceSector {
    placeId: string
    name: string
    description: string | null
    bars: string[]
}

export interface EditPlaceSector {
    name: string | null
    description: string | null
    bars: string[] | null
    accessPolicies: string[] | null
}

export interface AccessPolicySector {
    id: string
    name: string
}

export interface AccessPolicy {
    id: string
    placeId: string
    name: string
    sectors: AccessPolicySector[]
    startDate: Date
    endDate: Date
    allowMultipleAccess: boolean
    createdAt: Date
    createdBy: string
    updatedAt: Date
    isDeleted: boolean
}

export interface NewAccessPolicy {
    placeId: string
    name: string
    sectors: string[]
    startDate: Date
    endDate: Date
    allowMultipleAccess: boolean
    tagIds: string[]
}

export interface EditAccessPolicy {
    name: string | null
    sectors: string[] | null
    startDate: Date | null
    endDate: Date | null
    allowMultipleAccess: boolean | null
}

export interface AccessTag {
    tagId: string
    accessPolicyId: string
    createdAt: Date
}

export interface FinancialEntryTypeGroupTypes {
    id: string
    name: string
}

export interface FinancialEntryTypeGroup {
    id: string
    name: string
    types: FinancialEntryTypeGroupTypes[]
    total: number
}

export interface IfoodWebhookEventInputMetadata {
    string: string | null
}

export interface IfoodWebhookEventInput {
    id: string
    code: IfoodEventCode
    fullCode: IfoodEventFullCode
    orderId: string | null
    merchantId: string | null
    createdAt: Date | null
    merchantIds: string[] | null
    metadata: IfoodWebhookEventInputMetadata | null
}

export interface IfoodWebhookEventOutput {
    success: boolean
    eventId: string | null
    action: string | null
    error: string | null
    merchantIds: string[] | null
}

export interface IntegrationTokenCreatedBy {
    id: string
    name: string
}

export interface IntegrationToken {
    id: string
    token: string
    createdBy: IntegrationTokenCreatedBy
    createdAt: Date
    places: Place[]
    isDeleted: boolean
}

export interface EquipmentDetailByPlace {
    equipmentId: string
    contractId: string
    contractNumber: string
    contractStatus: string
    serialNumber: string | null
    equipmentType: string
    equipmentModel: string | null
    quantity: number
    unitValue: number
}

export interface EquipmentsByPlaceFilters {
    organizationId: string
    placeId: string
    contractId: string | null
    serialNumber: string | null
    model: string | null
    status: string[] | null
}

export interface EquipmentsByPlacePaginationParams {
    page: number | null
    limit: number | null
}

export interface ListEquipmentsByPlaceRequest {
    filters: EquipmentsByPlaceFilters
    pagination: EquipmentsByPlacePaginationParams | null
}

export interface GetEquipmentsByPlaceToExcelRequest {
    filters: EquipmentsByPlaceFilters
}

export interface ListEquipmentsByPlaceResponsePagination {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface ListEquipmentsByPlaceResponse {
    data: EquipmentDetailByPlace[]
    pagination: ListEquipmentsByPlaceResponsePagination
}

export interface DeliverySimplifiedOrderIfoodScheduleSchedule {
    deliveryDateTimeStart: Date
    deliveryDateTimeEnd: Date
}

export interface DeliverySimplifiedOrderIfoodSchedule {
    schedule: DeliverySimplifiedOrderIfoodScheduleSchedule | null
    preparationStartDateTime: Date | null
}

export interface DeliverySimplifiedOrder {
    id: string
    reference: number
    date: Date
    status: DeliveryOrderEventStatus
    deliverySource: DeliverySource
    value: number
    deliveryFee: number
    discountValueDeliveryFee: number | null
    tip: number
    deliveryType: DeliveryType
    customerName: string
    externalReference: string | null
    cancellationReason: string | null
    cancellationObs: string | null
    ifoodSchedule: DeliverySimplifiedOrderIfoodSchedule | null
    isPostPaid: boolean
    discountValue: number | null
    orderFees: OrderFee[] | null
    discountValueMarketplace: number | null
    subTotal: number
    additionalFee: number | null
}

export interface DeliverySimplifiedOrderPayload {
    placeId: string
    status: DeliveryOrderEventStatus[] | null
    paymentMethods: DeliveryOrderPaymentMethod[] | null
    deliverySource: DeliverySource[] | null
    deliveryType: DeliveryType[] | null
}

export interface DeliveryCustomerAddress {
    city: string
    state: string
    number: string
    street: string
    country: string
    nickname: string | null
    createdBy: string | null
    stateAbbr: string
    complement: string | null
    postalCode: string
    addressName: string
    mainAddress: boolean
    neighborhood: string
    municipalityCode: string | null
}

export interface StoreAdditionalFieldAnswerValues {
    id: string
    label: string
    value: string
}

export interface PlaceAddress {
    city: string
    state: string
    postalCode: string
    streetName: string
    addressNumber: string
    province: string
    complement: string
    uf: string
}

export interface OrderDataCustomerAddress {
    city: string
    state: string
    country: string
    complement: string | null
    postalCode: string
    streetName: string
    neighborhood: string
    streetNumber: string
    formattedAddress: string
}

export interface ManagerDeliveryOrderCustomer {
    name: string | null
    email: string | null
    phone: string | null
    isWhatsapp: boolean | null
    documentNumber: string | null
    documentType: ManagerDeliveryOrderCustomerDocumentType | null
    address: OrderDataCustomerAddress | null
}

export interface ManagerDeliveryOrderPlace {
    id: string
    name: string
    address: PlaceAddress
}

export interface ManagerDeliveryOrderMenu {
    id: string
    name: string
}

export interface ManagerDeliveryOrderPayment {
    value: number
    method: PaymentMethod
    brand: string | null
    change: number | null
    partnerPaymentId: string | null
}

export interface ManagerDeliveryOrderItemsSubItems {
    id: string
    sku: string
    name: string
    sectionId: string | null
    sectionName: string | null
    pricing: ManagerDeliveryOrderItemsSubItemsPricing
    price: number
    count: number
}

export interface ManagerDeliveryOrderItems {
    id: string
    sku: string
    name: string
    count: number
    baseUnitPrice: number
    totalUnitPrice: number
    obs: string | null
    subItems: ManagerDeliveryOrderItemsSubItems[]
}

export interface ManagerDeliveryOrder {
    id: string
    reference: number
    obs: string | null
    date: Date
    customer: ManagerDeliveryOrderCustomer
    customerAddress: DeliveryCustomerAddress | null
    value: number
    discountValue: number
    discountValueMarketplace: number | null
    discountValueDeliveryFee: number | null
    discountValueDeliveryFeeMarketplace: number | null
    subTotal: number
    deliveryFee: number
    tip: number
    tipReceivedBy: TipReceiver | null
    channel: DeliveryChannel | null
    status: DeliveryOrderEventStatus
    deliverySource: DeliverySource | null
    deliveryType: DeliveryType
    place: ManagerDeliveryOrderPlace
    menu: ManagerDeliveryOrderMenu | null
    payment: ManagerDeliveryOrderPayment | null
    items: ManagerDeliveryOrderItems[]
    additionalFields: StoreAdditionalFieldAnswerValues[] | null
    externalReference: string | null
    cancellationReason: string | null
    cancellationObs: string | null
    isPostPaid: boolean
    additionalFee: number | null
    orderFees: OrderFee[] | null
    needCutlery: boolean | null
    locator: string | null
}

export interface CreateManualOrderSubItem {
    productId: string
    count: number
}

export interface CreateManualOrderSection {
    sectionId: string
    products: CreateManualOrderSubItem[]
}

export interface CreateManualOrderItem {
    productId: string
    count: number
    obs: string | null
    sections: CreateManualOrderSection[]
}

export interface CreateManualOrderAddress {
    street: string
    number: string
    complement: string | null
    neighborhood: string
    city: string
    state: string
    postalCode: string
    country: string | null
}

export interface CreateManualOrderCustomer {
    name: string
    phone: string | null
    email: string | null
    isWhatsapp: boolean | null
    documentNumber: string | null
    documentType: CreateManualOrderCustomerDocumentType | null
    address: CreateManualOrderAddress | null
}

export interface CreateManualOrderPayload {
    menuId: string
    deliveryType: CreateManualOrderPayloadDeliveryType
    customer: CreateManualOrderCustomer
    items: CreateManualOrderItem[]
    tip: number | null
    obs: string | null
}

export interface CreateManualOrderPixCharge {
    chargeId: string
    emv: string
    qrCode: string
    value: number
    expiresIn: number | null
}

export interface CreateManualOrderResponse {
    deliveryOrderId: string
    reference: number
    pixCharge: CreateManualOrderPixCharge
}

export interface CalculateDeliveryFeeResponse {
    deliveryFee: number
    distanceKm: number
    formattedAddress: string
}

export interface UpsertDeliveryFeeConfigPayload {
    taxType: UpsertDeliveryFeeConfigPayloadTaxType
    baseRateValue: number
    ratePerKm: number
    attendanceRadius: number
}

export interface DeliveryFeeConfigResponse {
    taxType: string
    baseRateValue: number
    ratePerKm: number
    attendanceRadius: number
}

export interface GetURLAuthorizationResponse {
    merchantAuthorizationUrl: string
}

export interface MarketplaceOperationResponse {
    success: boolean
    message: string | null
}

export interface MarketplaceStore {
    id: string
    placeId: string
    merchantId: string | null
    name: string | null
    isAuthorized: boolean
    isActive: boolean
    provider: MarketplaceProvider
    createdAt: Date
}

export interface GetAllMarketplaceIntegrationsGroupedByTypeResponse {
    keeta: MarketplaceStore[]
    food99: MarketplaceStore[]
}

export interface OpenDeliveryNewEventPayload {
    eventId: string
    eventType: string
    orderId: string
    orderURL: string
    createdAt: Date
    sourceAppId: string | null
    virtualBrand: string | null
}

export interface OpenDeliveryWebhookResponse {
    code: number
    message: string
    data: any | null
}

export interface PendingTransactionsFilters {
    placeId: string
    transactionDateStart: Date | null
    transactionDateEnd: Date | null
    searchText: string | null
    status: PendingTransactionStatus[] | null
    vendorIds: string[] | null
    paymentMethods: AcquirerPaymentMethod[] | null
    pagination: Pagination
}

export interface PendingTransactionPlace {
    id: string
    name: string
}

export interface PendingTransactionVendor {
    id: string
    name: string
}

export interface PendingTransaction {
    id: string
    createdAt: Date
    updatedAt: Date
    isDeleted: boolean
    transactionDate: Date
    paymentMethod: AcquirerPaymentMethod | null
    nsu: string
    deviceId: string | null
    status: PendingTransactionStatus
    value: number
    barId: string | null
    placeId: string
    vendorId: string | null
    acquirer: string | null
    cardBrand: string | null
    eventId: string
    createdBy: string
    place: PendingTransactionPlace
    vendor: PendingTransactionVendor | null
}

export interface PaginatedPendingsTransactions {
    data: PendingTransaction[]
    pagination: PaginationResponse
}

export interface FilterOptionValue {
    key: string
    value: string
}

export interface FilterOption {
    name: string
    values: FilterOptionValue[] | null
    rawValue: string | null
}

export interface AcquirerPendingTransactionFilterOptionsResponse {
    options: FilterOption[]
}

export interface PlaceWizardStatus {
    shouldShowOnboarding: boolean
    step: PlaceWizardStep | null
    isFinished: boolean | null
}

export interface PlaceWizardBar {
    id: string
    name: string
}

export interface PlaceWizardSector {
    id: string
    name: string
    bars: PlaceWizardBar[]
}

export interface SavePlaceWizardBarsAndSectorsStepInput {
    placeId: string
    bars: PlaceWizardBar[]
    sectors: PlaceWizardSector[]
}

export interface PlaceWizardFeature {
    id: string
    name: string
    isEditableByPlace: boolean
    isActive: boolean
    description: string
    warning: string | null
    dependsOn: string | null
    category: string
}

export interface PlaceWizardFeatureWithChildren {
    id: string
    name: string
    isEditableByPlace: boolean
    isActive: boolean
    description: string
    warning: string | null
    dependsOn: string | null
    category: string
    children: PlaceWizardFeatureWithChildren[]
}

export interface PlaceWizardFeatureByCategory {
    category: string
    features: PlaceWizardFeatureWithChildren[]
}

export interface GetPlaceWizardBasicInformationStepResponse {
    features: PlaceWizardFeatureByCategory[]
    operationalTypes: OperationalType[] | null
}

export interface SavePlaceWizardBasicInformationStepInput {
    placeId: string
    operationalTypes: OperationalType[]
    placeFeaturesIds: string[]
}

export interface GetPlaceWizardBarsAndSectorsStepResponse {
    bars: PlaceWizardBar[]
    sectors: PlaceWizardSector[]
}

export interface WizardProduct {
    id: string
    name: string
    value: number
    imageUrl: string | null
}

export interface WizardCategory {
    id: string
    name: string
    products: WizardProduct[]
}

export interface WizardMenu {
    id: string
    name: string
    categories: WizardCategory[]
    isDefault: boolean
}

export interface WizardBar {
    id: string
    name: string
    productIds: string[]
    menuIds: string[]
}

export interface GetPlaceWizardProductsAndMenusStepResponse {
    bars: WizardBar[]
    menus: WizardMenu[]
}

export interface SaveWizardProductInput {
    id: string
    name: string
    value: number
    image: EditProductImage | null
}

export interface SaveWizardCategoryInput {
    id: string
    name: string
    products: SaveWizardProductInput[]
}

export interface SaveWizardMenuInput {
    id: string
    name: string
    categories: SaveWizardCategoryInput[]
}

export interface SaveWizardBarInput {
    id: string
    name: string
    productIds: string[]
    menuIds: string[]
}

export interface SavePlaceWizardProductsAndMenusStepInput {
    placeId: string
    menus: SaveWizardMenuInput[]
    bars: SaveWizardBarInput[]
}

export interface FeatureFlag {
    id: string
    key: string
    description: string | null
    defaultOn: boolean
    enabled: boolean
    createdAt: Date
    updatedAt: Date
}

export interface OFXFile {
    TRNTYPE: OFXTypeTransaction
    DTPOSTED: string
    TRNAMT: number
    FITID: string
    MEMO: string
}

export interface OFXFileTransactionResponse {
    value: number
    dateTransaction: Date | null
    description: string
    accountBillId: string | null
    paymentType: string | null
    status: string | null
    typeTransaction: OFXTypeTransaction
    fitid: string
}

export interface OFXFileHeaderResponse {
    dateStart: Date
    dateEnd: Date
    status: OFXFileHeaderResponseStatus
    conciliationDate: Date | null
    currentValue: number
}

export interface OFXFileBankInfo {
    bankId: string | null
    bankName: string | null
    bankCode: string | null
    branchCode: string | null
    accountCode: string | null
}

export interface OFXFileResponse {
    accountName: string | null
    accountId: string | null
    transactions: OFXFileTransactionResponse[]
    dateStart: Date
    dateEnd: Date
    status: OFXFileHeaderResponseStatus
    conciliationDate: Date | null
    currentValue: number
    bankId: string | null
    bankName: string | null
    bankCode: string | null
    branchCode: string | null
    accountCode: string | null
}

export interface BankInfo {
    bank: string | null
    agency: string | null
    account: string | null
    holder: string | null
    purpose: string | null
}

export interface BackofficeBankConciliation {
    bankAccountId: string
    initialPeriod: Date
    finalPeriod: Date
    status: BackofficeBankConciliationStatus
    conciliationDate: Date | null
    placeId: string
    currentBalance: number
    transactions: BackofficeBankConciliationTransactions[]
}

export interface BackofficeBankConciliationResponse {
    id: string
    bankAccountId: string
    initialPeriod: Date
    finalPeriod: Date
    status: BackofficeBankConciliationStatus
    conciliationDate: Date | null
    placeId: string
    transactions: BackofficeBankConciliationTransactionsResponse[]
}

export interface BackofficeBankConciliationBankInfo {
    id: string
    bankAccountId: string
    initialPeriod: Date
    finalPeriod: Date
    status: BackofficeBankConciliationStatus
    conciliationDate: Date | null
    placeId: string
    transactions: BackofficeBankConciliationTransactionsResponse[]
    bankInfo: BankInfo | null
}

export interface BackofficeBankConciliationResponseWithPagination {
    data: BackofficeBankConciliationBankInfo[]
    pagination: PaginationResponse
}

export interface BackofficeBankConciliationTransactions {
    value: number
    date: Date
    description: string
    accountBillId: string | null
    paymentType: string
    status: BackofficeBankConciliationTransactionsType
    bankConciliationId: string | null
    fitid: string
}

export interface BackofficeBankConciliationTransactionsResponse {
    id: string | null
    value: number
    date: Date
    description: string
    accountBillId: string | null
    paymentType: string
    status: BackofficeBankConciliationTransactionsType
    bankConciliationId: string | null
    fitid: string
    chartAccountName: string | null
}

export interface ReprintAuthorizedBy {
    id: string
    name: string
}

export interface ReprintProduct {
    id: string
    name: string
    unitValue: number
}

export interface ReprintEmployee {
    id: string
    name: string
}

export interface Reprint {
    authorizedBy: ReprintAuthorizedBy | null
    product: ReprintProduct
    transactionId: string
    date: Date
    employee: ReprintEmployee
    deviceId: string
}

export interface ReprintResumeAuthorizedBy {
    id: string
    name: string
}

export interface ReprintResume {
    authorizedBy: ReprintResumeAuthorizedBy | null
    qnt: number
    totalValue: number
}

export interface ProductRankingReportImage {
    url: string
    sha256: string
}

export interface ProductRankingReport {
    id: string
    name: string
    image: ProductRankingReportImage | null
    category: string
    categoryId: string
    unitValue: number
    quantity: number
    discount: number
    totalValue: number
}

export interface EmployeeProductRankingReport {
    id: string
    name: string
    username: string | null
    avatar: ImageUrl | null
    quantity: number
    totalValue: number
}

export interface SingleProductReturn {
    productId: string
    employeeId: string
    authorizedBy: string | null
    unitValue: number
    eventId: string
    placeId: string
    date: Date
    barId: string | null
    reason: string | null
    sku: string
    productName: string
    categoryName: string
    categoryId: string
    employeeName: string
    employeeUsername: string
}

export interface SingleProductReturnResponseProduct {
    id: string
    name: string
    sku: string
    unitValue: number
}

export interface SingleProductReturnResponseCategory {
    id: string
    name: string
}

export interface SingleProductReturnResponseEmployee {
    id: string
    name: string
    username: string
}

export interface SingleProductReturnResponse {
    authorizedBy: string | null
    eventId: string
    placeId: string
    date: Date
    barId: string | null
    reason: string | null
    product: SingleProductReturnResponseProduct
    category: SingleProductReturnResponseCategory
    employee: SingleProductReturnResponseEmployee
}

export interface BiPanel {
    panelId: string
    organizationId: string
    placeIds: string[] | null
    name: string
    chatEnabled: boolean
}

export interface BIWorkspace {
    id: string
    name: string
    panels: BiPanel[]
}

export interface BonusCategory {
    id: string
    name: string
    daysToExpire: number
    status: boolean
    lockZigTag: boolean
}

export interface BonusCategoryCreateRequest {
    placeId: string
    name: string
    daysToExpire: number
    status: boolean
    employeeIds: string[]
    categoryIds: string[] | null
    productIds: string[] | null
    lockZigTag: boolean | null
}

export interface BonusCategoryUpdateRequest {
    id: string
    name: string
    daysToExpire: number
    status: boolean
    employeeIds: string[]
    categoryIds: string[] | null
    productIds: string[] | null
    lockZigTag: boolean | null
}

export interface BonusCategoryGetFilters {
    name: string
}

export interface CompleteBonusCategoryEmployees {
    id: string
    name: string
}

export interface CompleteBonusCategoryProducts {
    id: string
    name: string
}

export interface CompleteBonusCategoryCategories {
    id: string
    name: string
}

export interface CompleteBonusCategory {
    id: string
    name: string
    daysToExpire: number
    status: boolean
    lockZigTag: boolean
    employees: CompleteBonusCategoryEmployees[]
    products: CompleteBonusCategoryProducts[]
    categories: CompleteBonusCategoryCategories[]
}

export interface BonusCategoryGetRequest {
    placeId: string
    pagination: Pagination
    filters: BonusCategoryGetFilters | null
}

export interface BonusCategoryGetResponse {
    data: CompleteBonusCategory[]
    pagination: PaginationResponse
}

export interface BonusCategoryDeleteRequest {
    bonusCategoryIds: string[]
}

export interface BaseCashbackConfig {
    name: string | null
    isActive: boolean
    percentage: number
    expiresIn: number | null
    expiresAt: Date | null
    placeIds: string[]
    minimumConsumption: number
    shouldConsiderEntrance: boolean
}

export interface CashbackConfig {
    id: string
    name: string | null
    isActive: boolean
    percentage: number
    expiresIn: number | null
    expiresAt: Date | null
    placeIds: string[]
    minimumConsumption: number
    shouldConsiderEntrance: boolean
}

export interface CashbackConfigDataStatus {
    key: CashbackConfigDataStatusKey
    translation: string
}

export interface CashbackConfigData {
    id: string
    name: string | null
    createdAt: Date
    expiresIn: number | null
    expiresAt: Date | null
    places: MinimalEvent[]
    messagesSent: number
    isActive: boolean
    status: CashbackConfigDataStatus
}

export interface ListCashbackConfigs {
    data: CashbackConfigData[]
    pagination: PaginationResponse
}

export interface CashbackRescue {
    id: string
    name: string | null
    createdAt: Date
    places: MinimalEvent[]
    messagesSent: number
    rescues: number
    totalValue: number
    giftbackSent: number
    giftbackValue: number
    conversionRate: number
}

export interface ListCashbackRescues {
    data: CashbackRescue[]
    pagination: PaginationResponse
}

export interface ListCashbackRescuesOverview {
    giftbacks: number
    messagesSent: number
    rescues: number
    totalValue: number
}

export interface CdpUserSegment {
    id: string
    name: string
}

export interface CdpUserPlace {
    id: string
    name: string
}

export interface CdpUserRfmClassification {
    classification: RfmClassification
    placeId: string
}

export interface CdpUser {
    userId: string
    document: string
    documentType: UserDocumentType | null
    name: string
    phone: string
    phoneCity: string | null
    email: string | null
    gender: Gender | null
    birthDate: Date | null
    country: string | null
    remainingBalance: number
    totalPaidValue: number
    averageTicket: number
    presences: number
    lastInteraction: Date
    firstInteraction: Date
    rfmClassifications: CdpUserRfmClassification[]
    allowCommunication: boolean
    places: CdpUserPlace[]
    segments: CdpUserSegment[]
}

export interface BaseCdpFilters {
    userIds: string[] | null
    eventIds: string[] | null
    dateFrom: Date | null
    dateTo: Date | null
}

export interface CdpUserFilters {
    userIds: string[] | null
    eventIds: string[] | null
    dateFrom: Date | null
    dateTo: Date | null
    rfmClassifications: RfmClassification[] | null
    segments: string[] | null
    userDocument: string | null
    remainingBalance: number | null
    lastInteraction: Date | null
    allowCommunication: boolean | null
    sortBy: CdpUserSortField | null
    sortDirection: CdpSortDirection | null
}

export interface CdpInteractionFilters {
    userIds: string[] | null
    eventIds: string[] | null
    dateFrom: Date | null
    dateTo: Date | null
    types: InteractionType[] | null
    minTotalPaidValue: number | null
    maxTotalPaidValue: number | null
    minAvaliation: number | null
    maxAvaliation: number | null
    productIds: string[] | null
    categoryIds: string[] | null
    categoryNames: string[] | null
    productTypes: ProductPurchaseType[] | null
}

export interface CdpInteractionListFilters {
    eventIds: string[] | null
    dateFrom: Date | null
    dateTo: Date | null
    types: InteractionType[] | null
    minAvaliation: number | null
    maxAvaliation: number | null
}

export interface CdpProductPurchaseListFilters {
    eventIds: string[] | null
    dateFrom: Date | null
    dateTo: Date | null
    productIds: string[] | null
    categoryIds: string[] | null
    categoryNames: string[] | null
    productTypes: ProductPurchaseType[] | null
}

export interface CdpInteraction {
    id: string
    userId: string
    type: InteractionType
    date: Date
    provider: CdpInteractionProvider
    eventId: string | null
    placeId: string | null
    organizationId: string | null
    beginAt: Date | null
    totalPaidValue: number
    totalDiscountValue: number
    totalBonusValue: number
    hadDiscount: boolean
    hadPromotion: boolean
    npsSurveyAnswerId: string | null
    npsSurveyGeneralAvaliation: number | null
    ticketOrderPaidValue: number
    ticketQuantity: number
    channel: CdpInteractionChannel | null
    communicationId: string | null
    communicationChannel: CdpInteractionCommunicationChannel | null
    communicationSubject: CdpInteractionCommunicationSubject | null
    communicationContent: string | null
    toSegmentId: string | null
    toRfmClassification: RfmClassification | null
}

export interface CdpProductPurchase {
    id: string
    interactionId: string
    productId: string
    systemProductId: string
    categoryId: string
    categoryName: string
    productName: string
    unitPrice: number
    quantity: number
    totalValue: number
    totalDiscountValue: number
    wasSplitted: boolean
    type: ProductPurchaseType
}

export interface RfmDistribution {
    classification: RfmClassification
    count: number
}

export interface SegmentDistribution {
    segmentId: string
    count: number
}

export interface ProductCategoryDistribution {
    categoryId: string
    categoryName: string
    totalQuantity: number
    totalValue: number
    uniqueUsers: number
    uniqueProducts: number
}

export interface FavoriteProduct {
    userId: string
    productId: string
    productName: string
    categoryId: string
    categoryName: string
    totalQuantity: number
    totalValue: number
    lastPurchaseDate: Date
}

export interface CdpMetrics {
    averageLTV: number
    churnRate: number
    averageTicket: number
}

export interface CdpUsersPage {
    data: CdpUser[]
    pagination: PaginationResponse
}

export interface CreateCdpPlaceRfmRuleInput {
    placeId: string
    recencyScore5MaxInDays: number
    recencyScore4MaxInDays: number
    recencyScore3MaxInDays: number
    recencyScore2MaxInDays: number
    frequencyScore5MinByMonth: number
    frequencyScore4MinByMonth: number
    frequencyScore3MinByMonth: number
    frequencyScore2MinByMonth: number
    averageTicketScore5Min: number
    averageTicketScore4Min: number
    averageTicketScore3Min: number
    averageTicketScore2Min: number
    analysisPeriodDays: number
}

export interface CdpPlaceRfmRule {
    placeId: string
    recencyScore5MaxInDays: number
    recencyScore4MaxInDays: number
    recencyScore3MaxInDays: number
    recencyScore2MaxInDays: number
    frequencyScore5MinByMonth: number
    frequencyScore4MinByMonth: number
    frequencyScore3MinByMonth: number
    frequencyScore2MinByMonth: number
    averageTicketScore5Min: number
    averageTicketScore4Min: number
    averageTicketScore3Min: number
    averageTicketScore2Min: number
    analysisPeriodDays: number
    id: string
    syncedAt: Date | null
    updatedAt: Date
}

export interface UpdateCdpPlaceRfmRuleInput {
    placeId: string
    recencyScore5MaxInDays: number
    recencyScore4MaxInDays: number
    recencyScore3MaxInDays: number
    recencyScore2MaxInDays: number
    frequencyScore5MinByMonth: number
    frequencyScore4MinByMonth: number
    frequencyScore3MinByMonth: number
    frequencyScore2MinByMonth: number
    averageTicketScore5Min: number
    averageTicketScore4Min: number
    averageTicketScore3Min: number
    averageTicketScore2Min: number
    analysisPeriodDays: number
    id: string
}

export interface CdpSegmentRules {
    birthday: CdpSegmentRulesBirthday | null
    gender: Gender[]
    minFrequencyInDays: number
    minAvgTicket: number
    minTotalPaidValue: number
    minRemainingBalance: number
    rfmClassification: RfmClassification | null
    minPresences: number
    maxLastInteractionDays: number | null
}

export interface CreateCdpOrganizationCustomSegmentInput {
    name: string
    description: string
    rules: CdpSegmentRules
    analysisPeriodDays: number
}

export interface CdpOrganizationCustomSegment {
    name: string
    description: string
    rules: CdpSegmentRules
    analysisPeriodDays: number
    id: string
    syncedAt: Date | null
    updatedAt: Date
}

export interface UpdateCdpOrganizationCustomSegmentInput {
    name: string
    description: string
    rules: CdpSegmentRules
    analysisPeriodDays: number
    id: string
}

export interface AgeGroup {
    minAge: number
    maxAge: number | null
    count: number
}

export interface AudienceMetricsByPeriod {
    period: string
    date: Date
    totalVisitors: number
    previousPeriodVisitors: number
    growthPercentage: number
    newClientsCount: number
    recurringClientsCount: number
    newClientsPercentage: number
    recurringClientsPercentage: number
    previousPeriodNewClientsCount: number
    previousPeriodRecurringClientsCount: number
}

export interface AverageTicketMetricsByPeriod {
    period: string
    date: Date
    averageTicket: number
    previousPeriodAverageTicket: number
    variationPercentage: number
}

export interface TpvMetricsByPeriod {
    period: string
    date: Date
    totalValue: number
    previousPeriodTotalValue: number
    variationPercentage: number
}

export interface DashboardKpis {
    totalVisitors: number
    visitorsVariationPercentage: number
    averageTicket: number
    ticketVariationPercentage: number
    totalTpv: number
    tpvVariationPercentage: number
    activationRate: number
    previousActivationRate: number
    activationRateVariation: number
    newClientsInPeriod: number
    activatedClients: number
    reactivatedClients: number
    previousReactivatedClients: number
    reactivatedClientsVariation: number
    reactivationRate: number
    averageTimeBetweenVisits: number
    newClientsPercentage: number
    recurringClientsPercentage: number
}

export interface DashboardKpisByPeriod {
    period: string
    date: Date
    totalVisitors: number
    visitorsVariationPercentage: number
    averageTicket: number
    ticketVariationPercentage: number
    totalTpv: number
    tpvVariationPercentage: number
}

export interface RfmDistributionByPeriod {
    period: string
    date: Date
    distributions: RfmDistributionEnhanced[]
}

export interface InactiveClientsKpi {
    inactiveDays: number
    count: number
}

export interface ChurnRiskKpi {
    classification: RfmClassification
    count: number
}

export interface TopRfmMetrics {
    classification: RfmClassification
    count: number
    averageTicket: number
    totalTpv: number
    percentageOfTotalTpv: number
}

export interface DemographicDistributionGenderDistribution {
    gender: DemographicGender
    count: number
    percentage: number
}

export interface DemographicDistribution {
    genderDistribution: DemographicDistributionGenderDistribution[]
    ageDistribution: AgeGroup[]
}

export interface RfmFrequencyDistribution {
    classification: RfmClassification
    averageVisitsPerMonth: number
    totalClients: number
}

export interface ActivationRateMetrics {
    activationRate: number
    previousActivationRate: number
    activationRateVariation: number
    newClientsInPeriod: number
    activatedClients: number
}

export interface ActivationRateByPeriod {
    period: string
    date: Date
    activationRate: number
    newClientsInPeriod: number
    activatedClients: number
}

export interface ReactivationMetrics {
    reactivatedClients: number
    previousReactivatedClients: number
    reactivatedClientsVariation: number
    reactivationRate: number
}

export interface AverageTimeBetweenVisitsMetricsByRfmClassification {
    classification: RfmClassification
    averageTimeBetweenVisits: number
    totalClients: number
}

export interface AverageTimeBetweenVisitsMetrics {
    averageTimeBetweenVisits: number
    byRfmClassification: AverageTimeBetweenVisitsMetricsByRfmClassification[]
}

export interface RfmDistributionEnhanced {
    classification: RfmClassification
    count: number
    percentage: number
    averageTicket: number
    totalTpv: number
    percentageOfTotalTpv: number
}

export interface SegmentDistributionEnhanced {
    segmentId: string
    segmentName: string
    count: number
    percentage: number
    averageTicket: number
    totalTpv: number
    percentageOfTotalTpv: number
}

export interface RetentionRateByMonth {
    month: string
    year: number
    retentionRate: number
    clientsRetained: number
    totalClientsPreviousMonth: number
}

export interface OccupancyRate {
    period: string
    date: Date
    averageOccupancy: number
    peakOccupancy: number
    capacity: number
}

export interface ValueMatrixPoint {
    userId: string
    userName: string
    frequencyPerMonth: number
    averageTicket: number
    totalTpv: number
    rfmClassification: RfmClassification
    quadrant: ValueMatrixPointQuadrant
}

export interface ValueMatrixDistributionCell {
    frequencyBinIndex: number
    ticketBinIndex: number
    count: number
}

export interface ValueMatrixDistribution {
    frequencyEdges: number[]
    ticketEdges: number[]
    heatmap: ValueMatrixDistributionCell[]
    totalClients: number
}

export interface RemainingBalanceKpi {
    clientsWithBalance: number
    totalBalance: number
    averageBalance: number
    percentageOfClients: number
}

export interface CityDistribution {
    city: string
    count: number
    percentage: number
}

export interface DashboardInsightData {
    value1: string | null
    value2: string | null
    value3: string | null
}

export interface DashboardInsight {
    type: DashboardInsightType
    message: string
    severity: DashboardInsightSeverity
    data: DashboardInsightData | null
}

export interface PeriodComparison {
    currentPeriod: PeriodTime
    previousPeriod: PeriodTime
    totalVisitors: number
    previousTotalVisitors: number
    visitorsVariation: number
    totalTpv: number
    previousTotalTpv: number
    tpvVariation: number
    averageTicket: number
    previousAverageTicket: number
    ticketVariation: number
    newClients: number
    previousNewClients: number
    newClientsVariation: number
    recurringClients: number
    previousRecurringClients: number
    recurringClientsVariation: number
    activationRate: number
    previousActivationRate: number
    activationRateVariation: number
    reactivatedClients: number
    previousReactivatedClients: number
    reactivatedClientsVariation: number
}

export interface RfmDistributionComparison {
    classification: RfmClassification
    currentCount: number
    previousCount: number
    countVariation: number
    currentPercentage: number
    previousPercentage: number
    percentagePointsChange: number
}

export interface SegmentDistributionComparison {
    segmentId: string
    segmentName: string
    currentCount: number
    previousCount: number
    countVariation: number
    currentPercentage: number
    previousPercentage: number
    percentagePointsChange: number
}

export interface DashboardNotificationList {
    id: string
    classification: DashboardNotificationClassificationEnum
    title: string
    description: string
    tags: DashboardNotificationTagsEnum[] | null
    createdAt: Date
    permissions: string[]
}

export interface DashboardNotificationPaginated {
    data: DashboardNotificationList[]
    pagination: PaginationResponse
}

export interface EmployeeTipReport {
    id: string
    name: string
    username: string
    total: number
    extraTip: number | null
    cashTotal: number
    debitTotal: number
    creditTotal: number
    pixTotal: number
    bonusTotal: number
    appTotal: number
}

export interface EmployeeTipReportFilters {
    employeeIds: string[] | null
}

export interface BaseReportActionsTransactionType {
    id: string
    name: string
}

export interface BaseReportActions {
    id: string
    createdAt: Date
    syncedAt: Date
    employee: MinimalEmployee
    value: number
    transactionType: BaseReportActionsTransactionType | null
    paymentMethod: PaymentMethodWithCashlessAndBonus[]
}

export interface ReportActionsFromEventProducts {
    name: string
    count: number
    value: number
}

export interface ReportActionsFromEventUser {
    cpf: string | null
    name: string | null
}

export interface ReportActionsFromEvent {
    id: string
    createdAt: Date
    syncedAt: Date
    employee: MinimalEmployee
    value: number
    transactionType: BaseReportActionsTransactionType | null
    paymentMethod: PaymentMethodWithCashlessAndBonus[]
    products: ReportActionsFromEventProducts[]
    user: ReportActionsFromEventUser[]
}

export interface FiltersActionsFromEvent {
    employeeIds: string[] | null
    transactionTypeIds: string[] | null
    transactionId: string | null
}

export interface ReportActionsFromEventResponse {
    data: ReportActionsFromEvent[]
    pagination: PaginationResponse
}

export interface ReportActionsFromEventOrPlaceTransactionType {
    id: string
    name: string
}

export interface ReportActionsFromEventOrPlaceUsersAcquirerTransaction {
    acquirer: string | null
    id: string | null
    brand: string | null
    nsu: string | null
    nsuHost: string | null
    authorizationCode: string | null
    bin: string | null
}

export interface ReportActionsFromEventOrPlaceUsers {
    id: string
    cpf: string
    name: string
    zigCode: string | null
    acquirerTransaction: ReportActionsFromEventOrPlaceUsersAcquirerTransaction | null
}

export interface ReportActionsFromEventOrPlaceBar {
    id: string
    name: string
}

export interface ReportActionsFromEventOrPlaceHawker {
    id: string
    name: string
    document: string
}

export interface ReportActionsFromEventOrPlace {
    id: string
    createdAt: Date
    syncedAt: Date
    employee: MinimalEmployee | null
    value: number
    transactionType: ReportActionsFromEventOrPlaceTransactionType
    paymentMethod: PaymentMethodWithCashlessAndBonus[]
    users: ReportActionsFromEventOrPlaceUsers[]
    deviceId: string | null
    terminal: string | null
    bar: ReportActionsFromEventOrPlaceBar | null
    status: string
    hawker: ReportActionsFromEventOrPlaceHawker | null
    productId: string | null
    productName: string | null
    productCount: number | null
    paidInOtherEvent: boolean
}

export interface FiltersActionsFromEventOrPlace {
    terminals: string[] | null
    userDocuments: string[] | null
    employeeNames: string[] | null
    zigCodes: string[] | null
    paymentMethods: string[] | null
    transactionTypeIds: string[] | null
    barIds: string[] | null
    since: Date | null
    until: Date | null
}

export interface FiltersValuesForTransactionsReportTransactionTypes {
    id: string
    name: string
}

export interface FiltersValuesForTransactionsReport {
    paymentMethods: string[]
    transactionTypes: FiltersValuesForTransactionsReportTransactionTypes[]
    barIds: string[]
}

export interface TransactionReportLink {
    id: string
    createdAt: Date
    updatedAt: Date
    employee: MinimalEmployee
    email: string
    status: TransactionReportLinkStatus
    fileUrl: string | null
    since: Date
    until: Date
    eventId: string | null
}

export interface HawkerCashierReleasedProduct {
    id: string
    name: string
    count: number
    value: number
    total: number
}

export interface HawkerCashierPayment {
    method: string
    value: number
}

export interface HawkerCashierAdjustment {
    id: string
    date: Date
    value: number
    type: HawkerCashierAdjustmentType
}

export interface HawkerCashierHawkerClosing {
    id: string
    date: Date
    value: number
    type: HawkerCashierHawkerClosingType
}

export interface HawkerCashierFinancialSummary {
    changeFundsValue: number
    bleedingsValue: number
    cyclesReceivedValue: number
    sessionsReceivedValue: number
    cashValue: number
    valueWithCashier: number
    cashierDiffValue: number
    commissionsValue: number
}

export interface HawkerCashierClosing {
    id: string
    name: string
    document: string
    openedAt: Date
    closedAt: Date
    diffValue: number
    logins: string[]
}

export interface BaseHawkerTransactionsFilters {
    eventTypes: HawkerTransactionType[] | null
    hawkerName: string[] | null
    hawkerDocument: string[] | null
    employeeIds: string[] | null
    employeeLogin: string[] | null
    hawkerCashierName: string[] | null
    hawkerCashierDocument: string[] | null
    cashierEmployeeLogin: string[] | null
    since: Date | null
    until: Date | null
    barName: string[] | null
    cycleId: string[] | null
    productName: string[] | null
    hawkerSessionId: string[] | null
}

export interface HawkerTransactionsFilters {
    eventTypes: HawkerTransactionType[] | null
    hawkerName: string[] | null
    hawkerDocument: string[] | null
    employeeIds: string[] | null
    employeeLogin: string[] | null
    hawkerCashierName: string[] | null
    hawkerCashierDocument: string[] | null
    cashierEmployeeLogin: string[] | null
    since: Date | null
    until: Date | null
    barName: string[] | null
    cycleId: string[] | null
    productName: string[] | null
    hawkerSessionId: string[] | null
}

export interface HawkerTransactionsPlaceFilters {
    eventTypes: HawkerTransactionType[] | null
    hawkerName: string[] | null
    hawkerDocument: string[] | null
    employeeIds: string[] | null
    employeeLogin: string[] | null
    hawkerCashierName: string[] | null
    hawkerCashierDocument: string[] | null
    cashierEmployeeLogin: string[] | null
    since: Date
    until: Date
    barName: string[] | null
    cycleId: string[] | null
    productName: string[] | null
    hawkerSessionId: string[] | null
}

export interface HawkerTransaction {
    id: string | null
    eventType: string | null
    hawkerName: string | null
    hawkerDocument: string | null
    barId: string | null
    barName: string | null
    employeeId: string | null
    employeeLogin: string | null
    cashierEmployeeLogin: string | null
    paymentMethod: string | null
    paymentValue: number | null
    date: Date | null
    productId: string | null
    productName: string | null
    isCancelled: boolean | null
    quantity: number | null
    amount: number | null
    sessionId: string | null
    cycleId: string | null
    cashierId: string | null
    cashierName: string | null
    cashierDocument: string | null
    deviceId: string | null
    terminalSerialNumber: string | null
    discount: number | null
    productTotal: number | null
    totalValue: number | null
    commission: number | null
    closingBalance: number | null
}

export interface HawkerTransactionPlace {
    id: string | null
    eventType: string | null
    hawkerName: string | null
    hawkerDocument: string | null
    barId: string | null
    barName: string | null
    employeeId: string | null
    employeeLogin: string | null
    cashierEmployeeLogin: string | null
    paymentMethod: string | null
    paymentValue: number | null
    date: Date | null
    productId: string | null
    productName: string | null
    isCancelled: boolean | null
    quantity: number | null
    amount: number | null
    sessionId: string | null
    cycleId: string | null
    cashierId: string | null
    cashierName: string | null
    cashierDocument: string | null
    deviceId: string | null
    terminalSerialNumber: string | null
    discount: number | null
    productTotal: number | null
    totalValue: number | null
    commission: number | null
    closingBalance: number | null
    eventId: string
    eventName: string
}

export interface KdsBar {
    id: string
    name: string
}

export interface KdsProductScreen {
    productId: string
}

export interface KdsScreen {
    id: string
    name: string
    type: KdsScreenType
    productsScreen: KdsProductScreen[]
}

export interface ZigBar {
    id: string
    name: string
}

export interface Kds {
    id: string
    ninegridKdsId: number | null
    name: string
    createdAt: Date
    bar: KdsBar | null
    link: string | null
    type: KdsType
    provider: string
    screens: KdsScreen[]
    zigBars: ZigBar[]
}

export interface KdsFilters {
    search: string | null
}

export interface KdsCard {
    showOrder: boolean
    showIntegration: boolean
    showClient: boolean
}

export interface KdsDetails {
    id: number
    name: string
    statusChange: boolean
    timeManagement: boolean
    readyTimeOrder: number
    standardTimeOrder: number
    bar: KdsBar | null
    card: KdsCard
}

export interface KdsRequest {
    barId: string
    name: string
    statusChange: boolean
    timeManagement: boolean
    readyTimeOrder: number
    standardTimeOrder: number
    card: KdsCard | null
}

export interface ReportDateRange {
    dateStart: Date
    dateEnd: Date
}

export interface KdsProductionBySectorReport {
    sectorName: string
    time: string
    timeSeconds: number
}

export interface KdsProductionByProductReport {
    productName: string
    time: string
    timeSeconds: number
}

export interface KdsIntegration {
    name: string
}

export interface KdsProduct {
    code: string
    product: string
    quantity: string
    productionSector: string
    preparationTime: string
}

export interface KdsOrder {
    customer: string
    orderId: number
    notes: string
    datetimeOrder: Date
    locationOrderName: string
    statusName: string
    integration: KdsIntegration
    products: KdsProduct[]
}

export interface KdsAverageProductionTimeByHour {
    hour: number
    time: string
    timeSeconds: number
}

export interface EditKdsRequest {
    barIds: string[]
    name: string
}

export interface CreateKdsScreenResponse {
    id: string
    name: string
}

export interface KdsProductBar {
    productId: string
    barId: string
}

export interface NewMenu {
    name: string
    type: MenuType
    productIds: string[]
    barsIds: string[] | null
    allowFichaExport: boolean
}

export interface BaseEditMenuItem {
    id: string
    action: EditMenuItemAction
}

export interface EditMenu {
    name: string
    type: MenuType
    productsToEdit: BaseEditMenuItem[] | null
    barsToEdit: BaseEditMenuItem[] | null
    allowFichaExport: boolean
}

export interface MenuProduct {
    productId: string
    name: string
    isActive: boolean
    price: number
    proportionalValue: ProportionalValue | null
    hasMountable: boolean
    image: ImageUrl | null
    sku: string | null
}

export interface MenuCategory {
    id: string
    name: string
    description: string | null
    printOrder: number | null
    priority: number
    image: ImageUrl | null
    parentId: string | null
    menuCategoryId: string
    products: MenuProduct[]
}

export interface Menu {
    id: string
    name: string
    type: MenuType
    isDefault: boolean
    isActive: boolean
    categories: MenuCategory[]
    productsCount: number | null
}

export interface BaseBarInfo {
    id: string
    name: string
}

export interface BaseCategoryInfo {
    id: string
    name: string
}

export interface BaseMenu {
    id: string
    name: string
    type: MenuType
    isDefault: boolean
    isActive: boolean
}

export interface MenuList {
    id: string
    name: string
    type: MenuType
    isDefault: boolean
    isActive: boolean
    productsCount: number
    bars: BaseBarInfo[] | null
}

export interface MenuDetails {
    id: string
    name: string
    type: MenuType
    isDefault: boolean
    isActive: boolean
    productsCount: number
    categories: BaseCategoryInfo[] | null
    bars: BaseBarInfo[] | null
    allowFichaExport: boolean | null
}

export interface MenuProductFilters {
    isActive: boolean | null
    name: string | null
}

export interface BaseMenuProduct {
    id: string
    name: string
    description: string | null
    sku: string
    image: ImageUrl | null
}

export interface MenuProducts {
    id: string
    name: string
    description: string | null
    sku: string
    image: ImageUrl | null
    price: number
    hasMountable: boolean
    categoryId: string
    categoryName: string
    isActive: boolean
    proportionalValue: ProportionalValue | null
}

export interface AddableMenuProduct {
    id: string
    name: string
    description: string | null
    sku: string
    image: ImageUrl | null
    isBeingUsed: boolean
}

export interface EditProduct {
    isActive: boolean | null
    price: number | null
}

export interface NewEditProduct {
    productId: string
    isActive: boolean | null
    price: number | null
}

export interface CreateProductRequest {
    name: string
    category: string
    hasAlcohol: boolean
    description: string | null
    fiscalData: NewPlaceProductFiscalData | null
    value: number | null
    proportionalValue: ProportionalValue | null
    fiscalCode: string | null
    kindKey: string
    menuCategory: string | null
    basicStorageUnit: BasicStorageUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    image: EditProductImage | null
    externalId: string | null
    externalStoreId: string | null
    preparationTime: number | null
    systemProductId: string | null
}

export interface ProductMountableSectionItem {
    isActive: boolean
    storageCount: number
    name: string | null
    price: number
    maxCount: number | null
    selectedCount: number | null
    product: CreateProductRequest
}

export interface ProductMountableSection {
    title: string
    min: number
    max: number
    pricing: ProductMountableSectionPricing
    items: ProductMountableSectionItem[]
}

export interface CreateProductWithSectionsRequest {
    name: string
    category: string
    hasAlcohol: boolean
    description: string | null
    fiscalData: NewPlaceProductFiscalData | null
    value: number | null
    proportionalValue: ProportionalValue | null
    fiscalCode: string | null
    kindKey: string
    menuCategory: string | null
    basicStorageUnit: BasicStorageUnit | null
    isHiddenFromApp: boolean | null
    beerProduct: BeerProduct | null
    yieldPercentage: number | null
    isReturnableProduct: boolean | null
    isStockable: boolean | null
    releaseValue: number | null
    image: EditProductImage | null
    externalId: string | null
    externalStoreId: string | null
    preparationTime: number | null
    systemProductId: string | null
    sections: ProductMountableSection[]
}

export interface CreateMenuWithProductsRequest {
    name: string
    type: MenuType
    deliveryIntegratedType: ExternalStoreIntegrationType | null
    products: CreateProductWithSectionsRequest[]
    allowFichaExport: boolean
}

export interface CreateMenuWithProductsResponse {
    id: string
    name: string
    type: MenuType
    deliveryIntegratedType: ExternalStoreIntegrationType | null
    productsCount: number | null
}

export interface UpdateMenuAndExternalProductRequest {
    productId: string
    menuId: string
    price: number
    externalStoreId: string
    externalProductId: string
    externalProductOptionId: string | null
    externalProductSku: string | null
    externalProductSections: ProductMountableSection[] | null
}

export interface ReImportIfoodProductRequest {
    productId: string
    menuId: string
    price: number
    sections: ProductMountableSection[]
}

export interface LinkSyncedProductToDeliveryMenuRequest {
    productId: string
    price: number
}

export interface ProductToRemoveFromExternalStore {
    productId: string
    externalProductId: string
    externalProductOptionId: string | null
}

export interface GetMenusRequest {
    name: string | null
}

export interface GetDeliveryIntegratedMenuResponse {
    id: string
    name: string
    type: MenuType
    isDefault: boolean
    isActive: boolean
    deliveryIntegratedType: ExternalStoreIntegrationType
    createdAt: Date
    numberOfProducts: number
    numberOfNotSyncedProducts: number
    numberOfNotImportedProducts: number
}

export interface GetDeliveryIntegratedMenusResponse {
    items: GetDeliveryIntegratedMenuResponse[]
    pagination: PaginationResponse
}

export interface ReportFilters {
    tableNumbers: string[] | null
}

export interface ReportHeader {
    currentValue: number
    previousValue: number
}

export interface TableReportBaseV2 {
    number: string[]
    name: string
    ids: string[]
    eventId: string
    eventBeginAt: Date
}

export interface TableProfitReport {
    number: string[]
    name: string
    ids: string[]
    eventId: string
    eventBeginAt: Date
    value: number
    tipValue: number
    total: number
}

export interface TablePeopleServedReport {
    number: string[]
    name: string
    ids: string[]
    eventId: string
    eventBeginAt: Date
    clientsAtTable: number
}

export interface TableValueBaseReport {
    number: string[]
    name: string
    ids: string[]
    eventId: string
    eventBeginAt: Date
    value: number
}

export interface TableReportResponse {
    header: ReportHeader
    data: TableValueBaseReport[]
}

export interface TableEmployeeSaleRankingReport {
    id: string
    name: string
    username: string | null
    avatar: ImageUrl | null
    totalSoldValue: number
    mediumValue: number
    openedTables: number
}

export interface TableProductSoldRankingReport {
    id: string
    name: string
    totalSoldValue: number
    totalCount: number
}

export interface MesaStatusConfiguration {
    id: string
    msFromLastInteraction: number
    backgroundColor: string
    detailColor: string
    textColor: string
}

export interface MesaStatusConfigurationReturn {
    id: string | null
    msFromLastInteraction: number
    backgroundColor: string
    detailColor: string
    textColor: string
}

export interface CreateStatusConfiguration {
    msFromLastInteraction: number
    backgroundColor: string
    detailColor: string
    textColor: string
}

export interface EmployeeCardsCreatedBy {
    id: string
    name: string
    username: string
}

export interface EmployeeCardsPermissions {
    id: string
    name: string
}

export interface EmployeeCards {
    createdAt: Date
    createdBy: EmployeeCardsCreatedBy
    id: string
    name: string
    username: string | null
    zigDeviceId: string
    uid: string
    permissions: EmployeeCardsPermissions[]
    status: EmployeeCardsStatuses
}

export interface EmployeeCardsPaginationPagination {
    currentPage: number
    lastPage: number
    perPage: number
    total: number
}

export interface EmployeeCardsPagination {
    data: EmployeeCards[]
    pagination: EmployeeCardsPaginationPagination
}

export interface CardHistory {
    createdAt: Date
    deviceId: string
    employeeCardPasswordId: string | null
    id: string
    name: string
    offlineActionId: string | null
    type: string | null
    uid: string
    price: number | null
    employeeName: string | null
    employeeUsername: string | null
    sourceIds: string[]
}

export interface CardHistoryPaginationPagination {
    currentPage: number
    lastPage: number
    perPage: number
    total: number
}

export interface CardHistoryPagination {
    data: CardHistory[]
    pagination: CardHistoryPaginationPagination
}

export interface PendingOnlineRechargeValue {
    date: Date
    value: number
}

export interface PendingOnlineRechargeResume {
    gender: PendingOnlineRechargeResumeGender
    qnt: number
    value: number
    bonus: number
    refundedValue: number
    retrievedValue: number
    createdAt: Date
}

export interface PendingOnlineRechargeByDateData {
    date: string
    topUpQuantity: number
    maleQuantity: number
    maleValue: number
    femaleQuantity: number
    femaleValue: number
    otherQuantity: number
    otherValue: number
    redeemedQuantity: number
    accumulatedValue: number
    redeemedValue: number
    usedValue: number
    bonusValue: number
}

export interface PendingOnlineRechargeReportCardsGender {
    male: number
    female: number
    other: number
}

export interface PendingOnlineRechargeReportCards {
    redeemedTopUp: number
    topUpUsed: number
    averageTicketOfGivenTopUps: number
    averageRedeemedPerDay: number
    gender: PendingOnlineRechargeReportCardsGender
}

export interface PendingOnlineRechargeReportTotalizer {
    accumulatedValueTotal: number
    redeemedValueTotal: number
    usedValueTotal: number
    topUpQuantityTotal: number
    maleQuantityTotal: number
    maleValueTotal: number
    femaleQuantityTotal: number
    femaleValueTotal: number
    otherQuantityTotal: number
    otherValueTotal: number
    redeemedQuantityTotal: number
    bonusValueTotal: number
}

export interface PendingOnlineRechargeReport {
    cards: PendingOnlineRechargeReportCards
    totalizer: PendingOnlineRechargeReportTotalizer
    rows: PendingOnlineRechargeByDateData[]
}

export interface PendingPlaceContractsEquipments {
    type: string
    unitValue: number
    quantity: number
}

export interface PendingPlaceContractsContractFiles {
    url: string
}

export interface PendingPlaceContracts {
    id: string
    requestType: string
    equipments: PendingPlaceContractsEquipments[]
    contractFiles: PendingPlaceContractsContractFiles[]
}

export interface ListPendingPlaceContracts {
    contracts: PendingPlaceContracts[]
    contactEmails: string[]
}

export interface PlaceContractsListRequestType {
    id: string
    name: string
}

export interface PlaceContractsListContractFiles {
    url: string
}

export interface PlaceContractsList {
    id: string
    requestDate: Date
    signatureDate: Date | null
    requestType: PlaceContractsListRequestType
    signedBy: MinimalEmployee | null
    managerId: string
    managerName: string
    status: string
    contractFiles: PlaceContractsListContractFiles[]
}

export interface PlaceContractListPaginated {
    data: PlaceContractsList[]
    pagination: PaginationResponse
}

export interface PlaceContractListFilters {
    statuses: string[] | null
    requestDatePeriod: PeriodTime | null
}

export interface PlaceContractContractFiles {
    url: string
}

export interface PlaceContractRequestType {
    id: string
    name: string
}

export interface PlaceContractRequestModel {
    id: string
    name: string
}

export interface PlaceContract {
    contractFiles: PlaceContractContractFiles[]
    contractPeriod: PeriodTime | null
    equipments: PlaceContractEquipments[]
    managerContact: PlaceContractManagerContact
    managerId: string
    managerName: string
    requestDate: Date
    requestType: PlaceContractRequestType
    requestModel: PlaceContractRequestModel
    status: string
}

export interface RechargeManagementUser {
    id: string
    name: string
    cpf: string
    documentType: string
}

export interface RechargeManagementAuthor {
    id: string
    name: string
}

export interface RechargeManagementValidPlaces {
    id: string
    name: string
}

export interface RechargeManagement {
    id: string
    user: RechargeManagementUser
    method: string | null
    type: RechargeManagementType
    bonusType: RechargeManagementBonusType | null
    author: RechargeManagementAuthor
    status: RechargeManagementStatus
    date: Date
    totalValue: number
    usedValue: number
    expiresAt: Date | null
    validPlaces: RechargeManagementValidPlaces[] | null
    rechargeType: RechargeManagementRechargeType
}

export interface EmployeesFilter {
    id: string
    name: string
}

export interface RechargeFilters {
    employees: EmployeesFilter[]
    status: RechargeStatusEnum[]
}

export interface RechargesPaginated {
    data: RechargeManagement[]
    pagination: PaginationResponse
}

export interface RechargeRequestFilters {
    eventId: string | null
    placeId: string | null
    employeeId: string | null
    cpf: string | null
    since: Date | null
    until: Date | null
    status: RechargeStatusEnum | null
    order: OrderEnum | null
}

export interface CampaignProductType {
    productId: string
    quantity: number
}

export interface WinnersType {
    position: number
    value: number
}

export interface CampaignRequest {
    name: string
    sponsors: string | null
    beginAt: Date
    endAt: Date
    type: CampaignType
    organizationId: string
    products: CampaignProductType[] | null
    placesIds: string[]
    winnerQuantity: WinnersType[] | null
    paymentType: CampaignsPaymentType
    target: number
    targetPrizeValue: number | null
}

export interface CampaignResponse {
    id: string
    name: string
    sponsors: string | null
    beginAt: Date
    endAt: Date
    type: CampaignType
    status: StatusType
    createdAt: Date
    createdBy: MinimalEmployee
    updatedAt: Date
    updatedBy: MinimalEmployee | null
    products: CampaignProductType[] | null
    placesIds: string[]
    winnerQuantity: WinnersType[] | null
    paymentType: CampaignsPaymentType | null
    target: number
    targetPrizeValue: number | null
}

export interface CampaignResponseFilters {
    name: string
    id: string
}

export interface CampaignTotalsReponse {
    activeCampaigns: number
    scheduledCampaigns: number
    completedCampaigns: number
    totalOnSale: number
}

export interface CampaignFilters {
    status: StatusType[] | null
    campaigns: string[] | null
}

export interface TableCampaignResponse {
    status: StatusType
    name: string
    beginAt: Date
    endAt: Date
    type: CampaignType
    id: string
    total: number
    attendance: number
    productCount: number
}

export interface ListCampaignsReponse {
    data: TableCampaignResponse[]
    pagination: PaginationResponse
}

export interface ListWinners {
    status: StatusType
    campaignName: string
    squadCampaignId: string
    paymentType: CampaignsPaymentType | null
    retrievedAt: Date | null
    retrievedBy: MinimalEmployee | null
    rankingPosition: number
    employee: MinimalEmployee | null
    value: number | null
}

export interface ListWinnersResponse {
    data: ListWinners[]
    pagination: PaginationResponse
}

export interface ListWinnersFilters {
    status: ListWinnersStatus | null
    employeeId: string | null
    campaignId: string | null
}

export interface ListSquadCampaignRanking {
    employee: MinimalEmployee
    totalValue: number
    soldProducts: number
    attendance: number
}

export interface CreateVendorOrg {
    name: string
    login: string
    organizationId: string
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
    places: VendorPlaceRequest[]
    productFees: VendorProductRequest[] | null
    password: string
}

export interface UpdateVendorOrg {
    name: string
    login: string
    organizationId: string
    dailyRentalFeeValue: number
    revenuePercentageFee: number
    tipPercentageFee: number
    anticipationFee: number | null
    paymentMethodFees: VendorPaymentMethodFees
    paymentDaysOffset: number
    fiscalProfileId: string | null
    floorComplement: number | null
    activeFeatures: string[]
    isFinancialVendor: boolean
    fullName: string | null
    document: string | null
    documentType: VendorDocumentType | null
    phone: string | null
    email: string | null
    address: VendorDocumentAddress | null
    places: VendorPlaceRequest[]
    productFees: VendorProductRequest[] | null
    id: string
    password: string | null
}

export interface VendorReceiveTip {
    id: string
    name: string
}

export interface VendorPaymentMethods {
    vendorId: string
    paymentMethod: PlaceVendorPaymentMethodType
}

export interface VendorPaymentMethodsResponse {
    vendorId: string
    paymentMethod: PlaceVendorPaymentMethodType
    vendorName: string
}

export interface VendorExtractResume {
    available: number
    toBeReleased: number
}

export interface VendorConsolidatedExtractSectionValues {
    title: string
    relativeTo: string
    hideIfZero: boolean
    totalValueUnit: VendorConsolidatedExtractSectionValuesTotalValueUnit
    totalValue: number | null
    maxFee: number | null
    minFee: number | null
    payValue: number
    highlighted: boolean
}

export interface VendorConsolidatedExtractSection {
    title: string
    description: string
    total: number
    values: VendorConsolidatedExtractSectionValues[]
}

export interface VendorConsolidatedExtract {
    sections: VendorConsolidatedExtractSection[]
    availableValue: number
    withdrewValue: number
}

export interface BankslipPreviewData {
    type: BankslipAvailableTypes
    barcode: string
    line: string
    amount: number
    dueDate: Date | null
    expirationDate: Date | null
    minAmount: number | null
    maxAmount: number | null
    nominalAmount: number | null
    fine: number | null
    interest: number | null
    discounts: number | null
    recipientName: string | null
    recipientTaxId: string | null
    payerName: string | null
    payerTaxId: string | null
    status: string | null
    description: string | null
    bankslipServiceFee: number
}

export interface CreateWithdrawDto {
    withdrawValue: number
    anticipationValue: number
    bankAccountId: string | null
    type: WithdrawType
    obs: string | null
    vendorWithdrawId: string | null
    bankPaymentSlipInfo: BankPaymentSlipInfo | null
    originWithdrawRequestId: string | null
    thirdPartyFeeFinancedByAnticipation: boolean | null
}

export interface WithdrawResponse {
    withdrawValue: number | null
    anticipationValue: number | null
    bankAccountId: string | null
    anticipationFee: number | null
    proRataFee: number | null
    type: WithdrawType
    obs: string | null
    id: string
}

export interface EventOperationsByPlaceIdFilters {
    placeId: string
}

export interface GetEventOperationsByPlaceIdRequest {
    pagination: Pagination
    filters: EventOperationsByPlaceIdFilters
}

export interface GetEventOperationsByPlaceIdResponseData {
    id: string
    name: string
    contractNumber: number | null
    beginAt: Date
    endAt: Date
}

export interface GetEventOperationsByPlaceIdResponse {
    pagination: PaginationResponse
    data: GetEventOperationsByPlaceIdResponseData[]
}

export interface GetCombinedOrdersReportRequestDtoPeriod {
    since: Date
    until: Date
}

export interface GetCombinedOrdersReportRequestDto {
    reference: string | null
    vendors: Vendor[] | null
    statuses: OrderStatus[] | null
    period: GetCombinedOrdersReportRequestDtoPeriod | null
}

export interface PaginationRequestDto {
    currentPage: number
    perPage: number
}

export interface PaginationResponseDto {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
}

export interface CombinedOrderReportPaymentDto {
    method: PaymentMethodOrder
    brand: string | null
    change: number | null
    partnerPaymentId: string | null
    value: number
}

export interface CombinedOrderReportItemDto {
    id: string
    name: string
    sku: string
    count: number
    baseUnitPrice: number
    totalUnitPrice: number
    obs: string | null
    subItems: CombinedOrderReportSubItemDto[]
}

export interface CombinedOrderReportSubItemDto {
    id: string
    sku: string
    name: string
    sectionId: string | null
    sectionName: string | null
    pricing: CombinedOrderReportSubItemDtoPricing
    price: number
    count: number
}

export interface GetCombinedOrderReportDto {
    id: string
    reference: number
    externalReference: string | null
    obs: string | null
    date: Date
    finishedAt: Date | null
    value: number
    channel: DeliveryChannel
    status: OrderStatus
    vendor: Vendor
    deliveryType: DeliveryTypeOrder
    customerName: string
    customerAddress: string
    deliveryFee: number
    discountValue: number
    discountValueMarketplace: number | null
    discountValueDeliveryFee: number | null
    discountValueDeliveryFeeMarketplace: number | null
    tip: number
    subTotal: number
    payment: CombinedOrderReportPaymentDto | null
    items: CombinedOrderReportItemDto[]
    orderFees: OrderFee[]
}

export interface GetCombinedOrdersReportResponseDto {
    items: GetCombinedOrderReportDto[]
    totalValue: number
    pagination: PaginationResponseDto
}

export interface AdvanceBase {
    id: string
    createdAt: Date
    cnpj: string
    companyName: string | null
    tradingName: string | null
    ticketEventIds: number[] | null
    mainPlaceId: string | null
    mainPlaceName: string | null
    totalValue: number
    interestValue: number
    totalWithInterest: number
    interestConfig: AdvanceInterestConfig | null
    installmentConfig: AdvanceInstallmentConfig | null
    status: AdvanceStatus
    approvedBy: string | null
    approvedAt: Date | null
    obs: string | null
    advanceRequestId: string | null
}

export interface AdvanceInterestConfig {
    type: AdvanceInterestType
    rate: number | null
    gracePeriodMonths: number | null
    fixedInterestValue: number | null
}

export interface AdvanceInstallmentConfig {
    numberOfInstallments: number
    installmentValue: number
    firstDueDate: Date
    downPaymentValue: number | null
}

export interface AdvanceChargeBase {
    id: string
    createdAt: Date
    advanceId: string
    chargeValue: number
    dueDate: Date | null
    paidAt: Date | null
    status: AdvanceChargeStatus
    paymentDocumentUrl: string | null
    chargeType: AdvanceChargePaymentType
    obs: string | null
    ticketEventId: number | null
}

export interface AdvanceDocumentBase {
    id: string
    advanceId: string
    documentName: string
    documentUrl: string
    documentType: AdvanceDocumentType
    uploadedAt: Date
    uploadedBy: string
    obs: string | null
    isClientVisible: boolean
}

export interface AdvancePlace {
    placeId: string
    placeName: string
    bindingType: AdvancePlaceBindingType
    bindBy: string | null
    bindByName: string | null
}

export interface AdvanceApprovalMinutes {
    id: string
    code: string
    meetingDate: Date
}

export interface AdvanceListItem {
    id: string
    code: string | null
    createdAt: Date
    cnpj: string
    companyName: string | null
    mainPlaceName: string
    totalValue: number
    totalWithInterest: number
    remainingValue: number
    status: AdvanceStatus
    chargeType: AdvanceChargeType
    isExistingClient: boolean
    disbursedValue: number
    isOnCommitteeAgenda: boolean | null
    approvalMinutes: AdvanceApprovalMinutes | null
}

export interface AdvanceGroupByCnpj {
    cnpj: string
    companyName: string | null
    totalAdvances: number
    totalValue: number
    totalWithInterest: number
    openValue: number
    advances: AdvanceListItem[]
}

export interface ListAdvancesFilters {
    status: AdvanceStatus | null
    chargeType: AdvanceChargeType | null
    cnpj: string | null
    search: string | null
    dateFrom: Date | null
    dateTo: Date | null
    sortBy: string | null
    sortOrder: string | null
}

export interface Advance {
    id: string
    createdAt: Date
    cnpj: string
    companyName: string | null
    tradingName: string | null
    ticketEventIds: number[] | null
    mainPlaceId: string | null
    mainPlaceName: string | null
    totalValue: number
    interestValue: number
    totalWithInterest: number
    interestConfig: AdvanceInterestConfig | null
    installmentConfig: AdvanceInstallmentConfig | null
    status: AdvanceStatus
    approvedBy: string | null
    approvedAt: Date | null
    obs: string | null
    advanceRequestId: string | null
    isDisbursed: boolean
    disbursedValue: number
    remainingValue: number | null
    openChargesValue: number | null
    documents: AdvanceDocument[]
    charges: AdvanceCharge[]
}

export interface AdvanceCharge {
    id: string
    createdAt: Date
    advanceId: string
    chargeValue: number
    dueDate: Date | null
    paidAt: Date | null
    status: AdvanceChargeStatus
    paymentDocumentUrl: string | null
    chargeType: AdvanceChargePaymentType
    obs: string | null
    ticketEventId: number | null
}

export interface AdvanceDocument {
    id: string
    advanceId: string
    documentName: string
    documentUrl: string
    documentType: AdvanceDocumentType
    uploadedAt: Date
    uploadedBy: string
    obs: string | null
    isClientVisible: boolean
}

export interface ListAdvancesResponse {
    items: AdvanceListItem[]
    totalCount: number
    page: number
    pageSize: number
}

export interface ImageUrl {
    url: string
    sha256: string
}

export interface ClosingEventConferenceDataToProcess {
    id: string
    closingConferenceStatus: ClosingEventConferenceStatus
    checkedBy: string
    checkedAt: Date
}

export interface CheckedBy {
    id: string
    name: string
}

export interface Event {
    id: string
    name: string
    description: string | null
    place: Place | null
    status: EventState
    begin: Date
    end: Date | null
    cover: ImageUrl | null
    image: ImageUrl | null
    attractions: string[] | null
    closingConferenceStatus: ClosingEventConferenceStatus | null
    passTemplateId: string | null
    openedBy: string | null
    openedAt: Date | null
    openingReason: string | null
    checkedBy: CheckedBy | null
    checkedAt: Date | null
}

export interface BaseCombo {
    name: string
    value: number
    description: string | null
    category: string
    active: boolean
    fiscalData: ProductFiscalData | null
}

export interface EventDetails {
    placeId: string
    begin: Date
    end: Date | null
    name: string
    description: string | null
    attractions: string[] | null
    peopleCapacity: number | null
}

export interface OpenedReports {
    type: string
}

export interface EmployeeBase {
    id: string | null
    name: string
    username: string
}

export interface Seller {
    id: string
    name: string
    avatar: ImageUrl | null
}

export interface TransactionProduct {
    id: string
    name: string
    category: string
    value: number
    count: number
    image: ImageUrl | null
}

export interface TransactionComboProduct {
    id: string
    name: string
    count: number
    originalValue: number
}

export interface TransactionCombo {
    id: string
    products: TransactionComboProduct[]
    value: number
    name: string
    category: string
    count: number
    description: string | null
}

export interface Transaction {
    id: string
    date: Date
    products: TransactionProduct[]
    combos: TransactionCombo[]
    place: string
    event: string
    seller: Seller
    buyers: User[]
    paid: boolean
    refunded: boolean
    refundedBy: string | null
    refundedObs: string | null
    value: number
}

export interface StockProduct {
    id: string
    name: string
    quantity: number
}

export interface Transfer {
    value: number
    date: Date
    paid: boolean
    reason: TransferReason
}

export interface ProductTransfer {
    employee: EmployeeBase
    count: number
    date: Date
}

export interface ReportProduct {
    id: string
    name: string
    value: number
    image: ImageUrl | null
    transfers: ProductTransfer[] | null
    finalCount: number | null
    lostCount: number | null
    deliveredCount: number | null
}

export interface StockReportData {
    products: ReportProduct[]
}

export interface BarReportData {
    products: ReportProduct[]
}

export interface CashierTransfer {
    value: number
    employee: EmployeeBase
    date: Date
}

export interface CashierReportDataInput {
    finalInputCredit: number
    finalInputDebit: number
    finalInputCash: number
}

export interface CashierReportData {
    finalInputCredit: number | null
    finalInputDebit: number | null
    finalInputCash: number | null
    transfers: CashierTransfer[]
    salesCredit: number | null
    salesDebit: number | null
    salesCash: number | null
}

export interface EmployeeBaseResponse {
    data: EmployeeBase[]
    pagination: PaginationResponse
}

export interface StockTransfer {
    employeeBar: string
    stocker: string
    product: string
    quantity: number
    date: Date
    bar: string
}

export interface BillProducts {
    category: string
    name: string
    value: number
    quantity: number
}

export interface BillTransaction {
    id: string
    date: Date
    products: BillProducts[]
    seller: string
    refunded: boolean
    value: number
    tip: number
    totalValue: number
    paid: boolean
}

export interface UserBill {
    id: string
    name: string
    transactions: BillTransaction[]
}

export interface CpfOrPhone {
    type: CpfOrPhoneType
    value: string
}

export interface TimelineProduct {
    name: string
    id: string
    count: string
}

export interface TimelineEvent {
    id: string
    type: TimelineEventType
    value: number
    products: TimelineProduct[] | null
    shared: boolean | null
    paid: boolean | null
    refunded: boolean | null
    usedValue: number | null
    expired: boolean | null
    rechargeType: string | null
    date: Date
}

export interface BonusByProductProduct {
    id: string
    name: string
}

export interface BonusByProductCategory {
    id: string
    name: string
}

export interface BonusByProduct {
    product: BonusByProductProduct
    category: BonusByProductCategory
    bonusValue: number
    bonusTipValue: number
    bonusValueSpentFromOtherEvents: number
    bonusTipValueSpentFromOtherEvents: number
    bonusCategoryId: string | null
    bonusCategoryName: string | null
}

export interface GuinnessLog {
    employee: string
    name: string | null
    cpf: string | null
    uid: string
    date: Date
    type: GuinnessLogType
    sector: string | null
}

export interface FilterScopePlace {
    id: string
    period: PeriodTime
}

export interface FilterScope {
    eventId: string | null
    place: FilterScopePlace | null
}

export interface GetEventOperationWithExpenses {
    operation: EventOperationCompleteResponse
    sections: EventOperationExpensesByCategory[]
}

export interface GetEmployeeTypes {
    type: EmployeeType
    name: string
}

export interface GetBackofficeConfig {
    zigAccountId: string
    placeAccountId: string
    zigSupplierId: string
}

export interface ProductsSoldReport {
    productList: ProductsSoldReportResponse[]
    pagination: PaginationResponse
}

export interface ProductsSoldReportForEvent {
    productList: ProductsSoldReportResponse[]
    pagination: PaginationResponse
}

export interface AddCateringProduct {
    productId: string
}

export interface UpdateWithdrawReceipts {
    success: WithdrawRequestIdsWithDate[]
    error: WithdrawRequestIdsWithDate[]
}

export interface GetZigDeviceSyncForcesAtEvent {
    data: ZigDeviceSyncForceAtEvent[]
    pagination: PaginationResponse | null
}

export interface GetRescueRechargeConsumptionsAtEvent {
    pagination: PaginationResponse | null
    data: RechargeConsumptionData
}

export interface ForgotPassword {
    message: string
}

export interface RegisterEmployeeEmail {
    success: boolean
}

export interface ConfirmEmployeeEmail {
    success: boolean
}

export interface RemoveProductionRulesFromSuppliesDeletedRulesSuccess {
    ruleId: string
    productId: string
}

export interface RemoveProductionRulesFromSuppliesDeletedRulesFailed {
    ruleId: string
    productId: string
    error: string
}

export interface RemoveProductionRulesFromSuppliesEditedRulesSuccess {
    ruleId: string
}

export interface RemoveProductionRulesFromSuppliesEditedRulesFailed {
    ruleId: string
    error: string
}

export interface RemoveProductionRulesFromSupplies {
    removedRulesCount: number
    editedRulesCount: number
    affectedSupplyIds: string[]
    deletedRulesSuccess: RemoveProductionRulesFromSuppliesDeletedRulesSuccess[]
    deletedRulesFailed: RemoveProductionRulesFromSuppliesDeletedRulesFailed[]
    editedRulesSuccess: RemoveProductionRulesFromSuppliesEditedRulesSuccess[]
    editedRulesFailed: RemoveProductionRulesFromSuppliesEditedRulesFailed[]
}

export interface PatchProductsFieldsProductFields {
    categoryId: string | null
    kindId: string | null
    fiscalProfileId: string | null
    fiscalProductGroupId: string | null
}

export interface GetExtractOfValuesOwedToTheVendors {
    valueToBePaid: number
}

export interface GetAccessPoliciesFilters {
    accessPolicyName: string | null
}

export interface GetAccessPolicyTags {
    data: AccessTag[]
    pagination: PaginationResponse
}

export interface EditEmployeesPlacesAndBarsEmployeesPlacesBars {
    id: string
    shouldPrint: boolean
    isMainBar: boolean
}

export interface EditEmployeesPlacesAndBarsEmployeesPlaces {
    id: string
    bars: EditEmployeesPlacesAndBarsEmployeesPlacesBars[] | null
}

export interface EditEmployeesPlacesAndBarsEmployees {
    id: string
    places: EditEmployeesPlacesAndBarsEmployeesPlaces[]
}

export interface EditEmployeesPlacesAndBarsErrors {
    employeeId: string
    error: string
}

export interface EditEmployeesPlacesAndBars {
    errors: EditEmployeesPlacesAndBarsErrors[]
}

export interface GetAllEventActionsV2 {
    data: ReportActionsFromEventOrPlace[]
    pagination: PaginationResponse | null
}

export interface GetAllPlaceActions {
    data: ReportActionsFromEventOrPlace[]
    pagination: PaginationResponse | null
}

export interface GetHawkerTransactions {
    transactions: HawkerTransaction[]
    pagination: PaginationResponse
}

export interface GetHawkerTransactionsByPlace {
    transactions: HawkerTransactionPlace[]
    pagination: PaginationResponse
}

export interface GetMenuProductsByCategory {
    data: MenuProducts[]
    pagination: PaginationResponse
}

export interface GetAllMenuProducts {
    data: MenuProducts[]
    pagination: PaginationResponse
}

export interface GetTableProfitReport {
    header: ReportHeader
    data: TableProfitReport[]
}

export interface GetTablePeopleServedReport {
    header: ReportHeader
    data: TablePeopleServedReport[]
}

export interface GetPasswordCardsFromPlaceFilters {
    employeeName: string | null
    status: EmployeeCardsStatuses | null
}

export interface GetProductMasterKinds {
    label: string
    value: ProductMasterKind
}

export interface GetAllVendorFeatures {
    id: string
    name: string
}

export interface GetVendorsBalancesVendor {
    id: string
    name: string
}

export interface GetVendorsBalances {
    vendor: GetVendorsBalancesVendor
    withdraw: number
    anticipation: number
    pendingWithdraw: number
    pendingAnticipation: number
}

export interface GetAutomaticWithdrawHistoryDataVendor {
    id: string
    name: string
}

export interface GetAutomaticWithdrawHistoryDataPlace {
    id: string
    name: string
}

export interface GetAutomaticWithdrawHistoryData {
    id: number
    type: GetAutomaticWithdrawHistoryDataType
    vendor: GetAutomaticWithdrawHistoryDataVendor | null
    place: GetAutomaticWithdrawHistoryDataPlace
    expectedAmount: number
    placeBalance: number | null
    vendorBalance: number | null
    actualAmount: number | null
    status: AutomaticWithdrawStatus
    error: string | null
}

export interface GetAutomaticWithdrawHistory {
    date: Date
    status: AutomaticWithdrawStatus
    data: GetAutomaticWithdrawHistoryData[]
}

export interface RetryPixReceipt {
    receiptUrl: string
}

export class NotFound extends SdkgenError {}

export class ChargeExpired extends SdkgenError {}

export class ChargePaid extends SdkgenError {}

export class GenericError extends SdkgenError {}

export class FocusError extends SdkgenError {}

export class ProductEmissionTest extends SdkgenErrorWithData<ProductEmissionTestData> {}

export class AdvanceNotFound extends SdkgenError {}

export class AdvanceChargeNotFound extends SdkgenError {}

export class AdvanceDocumentNotFound extends SdkgenError {}

export class InvalidAdvanceOperation extends SdkgenError {}

export class InsufficientAdvancePermission extends SdkgenError {}

export class BackofficeError extends SdkgenError {}

export class NotLoggedIn extends SdkgenError {}

export class LacksPermission extends SdkgenError {}

export class InvalidArgument extends SdkgenError {}

export class WrongLogin extends SdkgenError {}

export class DoesntExist extends SdkgenError {}

export class LacksFeature extends SdkgenError {}

export class LimitExceeded extends SdkgenError {}

export class PeriodOutOfRange extends SdkgenError {}

export class EmailRegistrationRequired extends SdkgenError {}

export class Conflict extends SdkgenError {}

export class Fatal extends SdkgenError {}

export class ApiClient extends SdkgenHttpClient {
    constructor(baseUrl: string) {
        super(baseUrl, astJson, errClasses);
    }

    getAddressFromCep(args: {cep: string}): Promise<AddressFromCep> { return this.makeRequest("getAddressFromCep", args || {}); }
    getAdyenPaymentSession(args: {request: AdyenPaymentSessionRequest, shopperReference?: string | null}): Promise<AdyenSession> { return this.makeRequest("getAdyenPaymentSession", args || {}); }
    getBankCodes(args?: {}): Promise<BankCodeResponse[]> { return this.makeRequest("getBankCodes", args || {}); }
    createEventOperationExpense(args: {expense: EventOperationExpenseRequest}): Promise<EventOperationExpenseResponse> { return this.makeRequest("createEventOperationExpense", args || {}); }
    createEventOperationExpenses(args: {expenses: EventOperationExpenseRequest[]}): Promise<EventOperationExpenseResponse[]> { return this.makeRequest("createEventOperationExpenses", args || {}); }
    getEventOperationExpense(args: {id: string}): Promise<EventOperationExpenseResponse> { return this.makeRequest("getEventOperationExpense", args || {}); }
    updateEventOperationExpense(args: {id: string, expense: EventOperationExpenseRequest}): Promise<EventOperationExpenseResponse> { return this.makeRequest("updateEventOperationExpense", args || {}); }
    deleteEventOperationExpense(args: {id: string}): Promise<EventOperationExpenseResponse> { return this.makeRequest("deleteEventOperationExpense", args || {}); }
    getEventOperationExpenseCategories(args: {eventOperationId: string}): Promise<EventOperationExpenseFormFieldsResponse[]> { return this.makeRequest("getEventOperationExpenseCategories", args || {}); }
    createEventOperation(args: {eventOperation: EventOperationRequest}): Promise<EventOperationResponse> { return this.makeRequest("createEventOperation", args || {}); }
    getEventOperation(args: {id: string}): Promise<EventOperationCompleteResponse> { return this.makeRequest("getEventOperation", args || {}); }
    getEventOperationWithExpenses(args: {id: string}): Promise<GetEventOperationWithExpenses> { return this.makeRequest("getEventOperationWithExpenses", args || {}); }
    updateEventOperation(args: {id: string, eventOperation: EventOperationRequest}): Promise<EventOperationResponse> { return this.makeRequest("updateEventOperation", args || {}); }
    deleteEventOperation(args: {id: string}): Promise<void> { return this.makeRequest("deleteEventOperation", args || {}); }
    updateEventOperationEventSize(args: {updateEventOperationEventSizeRequest: UpdateEventOperationEventSizeRequest}): Promise<EventOperationEventSizeType> { return this.makeRequest("updateEventOperationEventSize", args || {}); }
    getEventOperationEventSize(args: {eventOperationId: string}): Promise<EventOperationEventSizeType> { return this.makeRequest("getEventOperationEventSize", args || {}); }
    getEventOperationEventSizeList(args?: {}): Promise<EventOperationEventSizeType[]> { return this.makeRequest("getEventOperationEventSizeList", args || {}); }
    approveEventOperation(args: {approveEventOperationRequest: ApproveEventOperationRequest}): Promise<EventOperationResponse> { return this.makeRequest("approveEventOperation", args || {}); }
    rejectEventOperation(args: {rejectEventOperationRequest: RejectEventOperationRequest}): Promise<EventOperationResponse> { return this.makeRequest("rejectEventOperation", args || {}); }
    getEventOperationHistory(args: {eventOperationId: string}): Promise<EventOperationHistory[]> { return this.makeRequest("getEventOperationHistory", args || {}); }
    getEventOperationFinancialDocument(args: {eventOperationId: string}): Promise<EventOperationFinancialDocumentUploaded | null> { return this.makeRequest("getEventOperationFinancialDocument", args || {}); }
    uploadEventOperationFinancialDocument(args: {eventOperationId: string, financialDocument: Attachment}): Promise<EventOperationFinancialDocumentUploaded> { return this.makeRequest("uploadEventOperationFinancialDocument", args || {}); }
    deleteEventOperationFinancialDocument(args: {financialDocument: EventOperationFinancialDocumentUploaded}): Promise<void> { return this.makeRequest("deleteEventOperationFinancialDocument", args || {}); }
    getEventOperationOperations(args: {searchTerm: string}): Promise<EventOperationOperation[]> { return this.makeRequest("getEventOperationOperations", args || {}); }
    createEventOperationUsedEquipments(args: {batch: EventOperationUsedEquipmentBatch}): Promise<EventOperationUsedEquipmentListResponse> { return this.makeRequest("createEventOperationUsedEquipments", args || {}); }
    getEventOperationUsedEquipments(args: {eventOperationId: string}): Promise<EventOperationUsedEquipmentListResponse> { return this.makeRequest("getEventOperationUsedEquipments", args || {}); }
    deleteEventOperationUsedEquipments(args: {ids: string[]}): Promise<void> { return this.makeRequest("deleteEventOperationUsedEquipments", args || {}); }
    calculateOperationCharges(args: {eventOperationId: string}): Promise<OperationChargesPreviewResponse> { return this.makeRequest("calculateOperationCharges", args || {}); }
    getEmployeeTypes(args?: {}): Promise<GetEmployeeTypes[]> { return this.makeRequest("getEmployeeTypes", args || {}); }
    getExtract(args: {placeId: string, since: Date, until: Date}): Promise<DayResume[]> { return this.makeRequest("getExtract", args || {}); }
    getExtractResume(args: {placeId: string}): Promise<ExtractResume> { return this.makeRequest("getExtractResume", args || {}); }
    extract(args: {placeId: string, since: Date, until: Date}): Promise<DayResume[]> { return this.makeRequest("extract", args || {}); }
    getExtractFlow(args: {placeId: string, since: Date, until: Date}): Promise<ExtractFlowRow[]> { return this.makeRequest("getExtractFlow", args || {}); }
    getConsolidatedExtractInSections(args: {placeId: string, since: Date, until: Date}): Promise<ConsolidatedExtract> { return this.makeRequest("getConsolidatedExtractInSections", args || {}); }
    getWithdraws(args: {placeId: string, since: Date, until: Date}): Promise<Withdraw[]> { return this.makeRequest("getWithdraws", args || {}); }
    getExtractDayResumeInSections(args: {placeId: string, date: Date}): Promise<ExtractDayResumeSection[]> { return this.makeRequest("getExtractDayResumeInSections", args || {}); }
    getRechargeExpireExtract(args: {placeId: string, since: Date, until: Date}): Promise<RechargeExpireDayResume[]> { return this.makeRequest("getRechargeExpireExtract", args || {}); }
    getRechargeExpireResume(args: {placeId: string, since: Date, until: Date}): Promise<RechargeExpireResume> { return this.makeRequest("getRechargeExpireResume", args || {}); }
    getFinancialExtractBlocks(args: {placeId: string, since: Date, until: Date}): Promise<FinancialExtractBlock[]> { return this.makeRequest("getFinancialExtractBlocks", args || {}); }
    getActiveFinancialExtractBlocks(args: {placeId: string}): Promise<FinancialExtractBlock[]> { return this.makeRequest("getActiveFinancialExtractBlocks", args || {}); }
    getAllPermissions(args?: {}): Promise<Permission[]> { return this.makeRequest("getAllPermissions", args || {}); }
    deleteRole(args: {slug: string}): Promise<void> { return this.makeRequest("deleteRole", args || {}); }
    createRole(args: {name: string, permissions: string[]}): Promise<Role> { return this.makeRequest("createRole", args || {}); }
    updateRole(args: {slug: string, name: string, permissions: string[]}): Promise<Role> { return this.makeRequest("updateRole", args || {}); }
    getProductKinds(args?: {}): Promise<ProductKind[]> { return this.makeRequest("getProductKinds", args || {}); }
    getSuggestedImageFor(args: {product: ProductImageSearch}): Promise<SuggestedImages[]> { return this.makeRequest("getSuggestedImageFor", args || {}); }
    getProductImageReferences(args?: {}): Promise<ProductImageReference[]> { return this.makeRequest("getProductImageReferences", args || {}); }
    applySuggestedImageForProduct(args: {imageId: string, productId: string, type: ApplySuggestedImageForProductType}): Promise<void> { return this.makeRequest("applySuggestedImageForProduct", args || {}); }
    getSystemProducts(args?: {}): Promise<SystemProduct[]> { return this.makeRequest("getSystemProducts", args || {}); }
    getMetabaseUrl(args: {question: MetabaseQuestionEnum, params?: any | null}): Promise<string> { return this.makeRequest("getMetabaseUrl", args || {}); }
    getMetabaseResource(args: {code: number, type: MetabaseResourceType}): Promise<MetabaseIntegrationResource> { return this.makeRequest("getMetabaseResource", args || {}); }
    getMetabaseList(args: {type: MetabaseResourceType}): Promise<MetabaseIntegrationResource[]> { return this.makeRequest("getMetabaseList", args || {}); }
    getUserLastConsent(args: {cpf: string, src: ConsentSource}): Promise<UserConsentResponse | null> { return this.makeRequest("getUserLastConsent", args || {}); }
    updateUserConsent(args: {cpf: string, hasAcceptedToShareData: boolean, src: ConsentSource, employeeId?: string | null}): Promise<UserConsentResponse> { return this.makeRequest("updateUserConsent", args || {}); }
    confirmOptout(args: {confirmOptOutParams: ConfirmOptOutParams}): Promise<DBOptOut> { return this.makeRequest("confirmOptout", args || {}); }
    hasUserOptOutForPlace(args: {userPlaceInfo: UserPlaceInfo}): Promise<boolean> { return this.makeRequest("hasUserOptOutForPlace", args || {}); }
    getActivePromotersInPlace(args: {placeId: string}): Promise<PlaceActivePromoters[]> { return this.makeRequest("getActivePromotersInPlace", args || {}); }
    getPlaceCashierAdjustments(args: {placeId: string, since: Date, until: Date}): Promise<CashierAdjustment[]> { return this.makeRequest("getPlaceCashierAdjustments", args || {}); }
    getCashierAdjustments(args: {eventId: string}): Promise<CashierAdjustment[]> { return this.makeRequest("getCashierAdjustments", args || {}); }
    getEstimatedFinanceDetailsByBarAtEvent(args: {eventId: string}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByBarAtEvent", args || {}); }
    getEstimatedFinanceDetailsByEmployeeAtEvent(args: {eventId: string}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByEmployeeAtEvent", args || {}); }
    getConsolidatedBarSellingReport(args: {eventId: string, sources?: TransactionSource[] | null}): Promise<BarReport[]> { return this.makeRequest("getConsolidatedBarSellingReport", args || {}); }
    getConsolidatedBarSellingReportInEvents(args: {eventIds: string[], sources?: TransactionSource[] | null}): Promise<BarReport[]> { return this.makeRequest("getConsolidatedBarSellingReportInEvents", args || {}); }
    getEstimatedFinanceDetailsByBarAtEvents(args: {eventIds: string[]}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByBarAtEvents", args || {}); }
    getEstimatedFinanceDetailsByEmployeeAtEvents(args: {eventIds: string[]}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByEmployeeAtEvents", args || {}); }
    rechargeByZigCodes(args: {placeId: string, rechargeType: RechargeTypeEnum, recharges: RechargeByZigCode[]}): Promise<RechargeResults> { return this.makeRequest("rechargeByZigCodes", args || {}); }
    rechargeByZigDeviceGroup(args: {placeId: string, zigDeviceGroupId: string, recharge: RechargeByZigDevice}): Promise<void> { return this.makeRequest("rechargeByZigDeviceGroup", args || {}); }
    getMenuConfig(args: {placeId?: string | null, slug?: string | null}): Promise<GetMenuConfigResponse | null> { return this.makeRequest("getMenuConfig", args || {}); }
    getWalletSummary(args: {placeId: string}): Promise<WalletSummary> { return this.makeRequest("getWalletSummary", args || {}); }
    getFutureFinancialEntriesGroupedByMonth(args: {placeId: string}): Promise<FutureFinancialEntryByMonth[]> { return this.makeRequest("getFutureFinancialEntriesGroupedByMonth", args || {}); }
    getFutureFinancialEntriesGrouped(args: {placeId: string, groupBy?: FutureFinancialEntryGroupBy | null, search?: string | null, vendorId?: string | null, since?: Date | null, until?: Date | null, typeIds?: string[] | null}): Promise<FutureFinancialEntryGrouped[]> { return this.makeRequest("getFutureFinancialEntriesGrouped", args || {}); }
    getWithdrawsV2(args: {placeId: string, since: Date, until: Date, offset?: number | null, limit?: number | null}): Promise<WithdrawV2Response> { return this.makeRequest("getWithdrawsV2", args || {}); }
    getConsolidatedExtractV2(args: {placeId: string, since: Date, until: Date, dateFilterType?: DateFilterType | null}): Promise<ConsolidatedExtractV2> { return this.makeRequest("getConsolidatedExtractV2", args || {}); }
    getConsolidatedCashFlow(args: {placeId: string, since: Date, until: Date}): Promise<ConsolidatedExtractCashFlow> { return this.makeRequest("getConsolidatedCashFlow", args || {}); }
    getExtractFlowV2(args: {placeId: string, since: Date, until: Date, offset: number, limit: number, search?: string | null, typeIds?: string[] | null, categoryIds?: string[] | null, groupIds?: string[] | null, status?: string[] | null, dateFilterType?: DateFilterType | null}): Promise<ExtractFlowResponseV2> { return this.makeRequest("getExtractFlowV2", args || {}); }
    getGroupedExtractFlow(args: {placeId: string, since: Date, until: Date, groupBy: GroupByOption, offset: number, limit: number, search?: string | null, typeIds?: string[] | null, categoryIds?: string[] | null, groupIds?: string[] | null, status?: string[] | null, dateFilterType?: DateFilterType | null}): Promise<GroupedExtractFlowResponse> { return this.makeRequest("getGroupedExtractFlow", args || {}); }
    getClientProviderDocumentByDocumentNumber(args: {documentNumber: string}): Promise<ClientProviderDocument> { return this.makeRequest("getClientProviderDocumentByDocumentNumber", args || {}); }
    getReceivableUnitsByPlaceIdAndFilters(args: {params: ReceivableUnitByPlaceIdAndFiltersParams}): Promise<ReceivableUnit[]> { return this.makeRequest("getReceivableUnitsByPlaceIdAndFilters", args || {}); }
    getReceivableUnitConsolidated(args: {providerReference: string}): Promise<ReceivableUnitConsolidated> { return this.makeRequest("getReceivableUnitConsolidated", args || {}); }
    getCentralLiquidationOperation(args: {id: string}): Promise<CentralLiquidationOperation> { return this.makeRequest("getCentralLiquidationOperation", args || {}); }
    getCentralLiquidationOperationWithRelatedValues(args: {id: string}): Promise<CentralLiquidationOperationWithRelatedValues> { return this.makeRequest("getCentralLiquidationOperationWithRelatedValues", args || {}); }
    getCentralLiquidationOperationReceivableUnit(args: {receivableUnitId: string}): Promise<CentralLiquidationOperationReceivableUnit> { return this.makeRequest("getCentralLiquidationOperationReceivableUnit", args || {}); }
    getCoalaTempToken(args: {placeId: string}): Promise<CoalaTempToken> { return this.makeRequest("getCoalaTempToken", args || {}); }
    getPlaceCurrentStore(args: {placeId: string}): Promise<GetPlaceStoreResponse | null> { return this.makeRequest("getPlaceCurrentStore", args || {}); }
    upsertManyStoreExternalIntegrations(args: {placeId: string, request: UpdateManyStoreIntegrationsRequest, cnpj?: string | null}): Promise<void> { return this.makeRequest("upsertManyStoreExternalIntegrations", args || {}); }
    getExternalStore(args: {externalStoreId: string, type: ExternalStoreIntegrationType}): Promise<GetExternalStoreResponse | null> { return this.makeRequest("getExternalStore", args || {}); }
    changeStoreStatus(args: {externalStoreId: string, placeId: string}): Promise<void> { return this.makeRequest("changeStoreStatus", args || {}); }
    getManyExternalStoreIntegrationCategoriesWithProductsWithSections(args: {placeId: string}): Promise<GetManyExternalStoreIntegrationCategoriesResponseDto> { return this.makeRequest("getManyExternalStoreIntegrationCategoriesWithProductsWithSections", args || {}); }
    getAlerts(args: {placeId: string, skip: number, limit: number}): Promise<DashboardAlert[]> { return this.makeRequest("getAlerts", args || {}); }
    markAlertAsRead(args: {id: string}): Promise<void> { return this.makeRequest("markAlertAsRead", args || {}); }
    fetchAudits(args: {params: AuditParams}): Promise<AuditResponse> { return this.makeRequest("fetchAudits", args || {}); }
    getBackofficeConfig(args: {placeId: string}): Promise<GetBackofficeConfig> { return this.makeRequest("getBackofficeConfig", args || {}); }
    getBackofficeAccount(args: {id: string, placeId: string}): Promise<BackofficeAccount> { return this.makeRequest("getBackofficeAccount", args || {}); }
    getBackofficeAccounts(args: {placeId: string}): Promise<BackofficeAccount[]> { return this.makeRequest("getBackofficeAccounts", args || {}); }
    createBackofficeAccount(args: {placeId: string, account: BackofficeNewAccount}): Promise<BackofficeAccount> { return this.makeRequest("createBackofficeAccount", args || {}); }
    editBackofficeAccount(args: {placeId: string, id: string, account: BackofficeNewAccount}): Promise<void> { return this.makeRequest("editBackofficeAccount", args || {}); }
    deleteBackofficeAccount(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeAccount", args || {}); }
    createBackofficeBillPlanCategory(args: {placeId: string, name: string, parentId?: string | null}): Promise<BackofficeBillPlanCategoryBase> { return this.makeRequest("createBackofficeBillPlanCategory", args || {}); }
    deleteBackofficeBillPlanCategory(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeBillPlanCategory", args || {}); }
    getBackofficeBillPlanCategory(args: {id: string}): Promise<BackofficeBillPlanCategoryBase> { return this.makeRequest("getBackofficeBillPlanCategory", args || {}); }
    getBackofficeBillPlans(args: {placeId: string}): Promise<BackofficeBillPlanCategory[]> { return this.makeRequest("getBackofficeBillPlans", args || {}); }
    getBackofficeBillPlansTreeLeafs(args: {placeId: string}): Promise<BackofficeBillPlanCategoryBase[]> { return this.makeRequest("getBackofficeBillPlansTreeLeafs", args || {}); }
    getBackofficeBillPlansTreeLeafsByLevel(args: {placeId: string, level: number}): Promise<BackofficeBillPlanCategoryBase[]> { return this.makeRequest("getBackofficeBillPlansTreeLeafsByLevel", args || {}); }
    editBackofficeBillPlanCategoryName(args: {placeId: string, id: string, name: string}): Promise<BackofficeBillPlanCategoryBase> { return this.makeRequest("editBackofficeBillPlanCategoryName", args || {}); }
    editBackofficeBillPlanCategoryParent(args: {placeId: string, id: string, newParentId?: string | null}): Promise<BackofficeBillPlanCategory[]> { return this.makeRequest("editBackofficeBillPlanCategoryParent", args || {}); }
    createBackofficeSuggestedBillPlan(args: {placeId: string}): Promise<BackofficeBillPlanCategory[]> { return this.makeRequest("createBackofficeSuggestedBillPlan", args || {}); }
    exportBackofficeBillPlan(args: {placeId: string}): Promise<string> { return this.makeRequest("exportBackofficeBillPlan", args || {}); }
    importBackofficeBillPlan(args: {placeId: string, file: ArrayBuffer}): Promise<BackofficeBillPlanCategory[]> { return this.makeRequest("importBackofficeBillPlan", args || {}); }
    deleteBackofficeBillPlan(args: {placeId: string}): Promise<void> { return this.makeRequest("deleteBackofficeBillPlan", args || {}); }
    getBackofficeBill(args: {id: string, placeId: string}): Promise<BackofficeBill> { return this.makeRequest("getBackofficeBill", args || {}); }
    getBackofficeBills(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeBill[]> { return this.makeRequest("getBackofficeBills", args || {}); }
    getBackofficeBillInstallments(args: {placeId: string, originId: string}): Promise<BackofficeSplittedBillDataWithId[]> { return this.makeRequest("getBackofficeBillInstallments", args || {}); }
    editBackofficeBill(args: {placeId: string, id: string, bill: BackofficeNewBill}): Promise<void> { return this.makeRequest("editBackofficeBill", args || {}); }
    payBackofficeBill(args: {placeId: string, id: string, date: Date, partial?: number | null}): Promise<void> { return this.makeRequest("payBackofficeBill", args || {}); }
    editBackofficeBillAttachment(args: {placeId: string, id: string, attachment?: BackofficeAttachment | null}): Promise<void> { return this.makeRequest("editBackofficeBillAttachment", args || {}); }
    deleteBackofficeBill(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeBill", args || {}); }
    exportBackofficeBills(args: {placeId: string, exportBillArgs: BackofficeExportBillArgs}): Promise<string> { return this.makeRequest("exportBackofficeBills", args || {}); }
    parseBackofficeBillsToImport(args: {placeId: string, file: ArrayBuffer}): Promise<BackofficeNewBill[]> { return this.makeRequest("parseBackofficeBillsToImport", args || {}); }
    importBackofficeBills(args: {placeId: string, file: ArrayBuffer}): Promise<void> { return this.makeRequest("importBackofficeBills", args || {}); }
    createBackofficeBill(args: {placeId: string, bill: BackofficeNewBill, attachment?: BackofficeAttachment | null}): Promise<BackofficeBill> { return this.makeRequest("createBackofficeBill", args || {}); }
    createBackofficeBillWithRecurrence(args: {bill: BackofficeNewBillWithRecurrence, attachment?: BackofficeAttachment | null}): Promise<BackofficeBill> { return this.makeRequest("createBackofficeBillWithRecurrence", args || {}); }
    createBackofficeBillWithInstallments(args: {bill: BackofficeNewBillWithInstallments, attachment?: BackofficeAttachment | null}): Promise<BackofficeBill> { return this.makeRequest("createBackofficeBillWithInstallments", args || {}); }
    convertBackofficeBillInInstallments(args: {id: string, bill: BackofficeNewBillWithInstallments, attachment?: BackofficeAttachment | null}): Promise<void> { return this.makeRequest("convertBackofficeBillInInstallments", args || {}); }
    editBackofficeBillInstallments(args: {placeId: string, installments: BackofficeSplittedBillDataWithId[], originId: string}): Promise<void> { return this.makeRequest("editBackofficeBillInstallments", args || {}); }
    payBackofficeMultipleBills(args: {ids: string[], date: Date}): Promise<void> { return this.makeRequest("payBackofficeMultipleBills", args || {}); }
    getBackofficeBillsFilteredByAllDates(args: {placeId: string, performDate: BackofficeBaseDate, dueDate: BackofficeBaseDate, payDate: BackofficeBaseDate, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeBill[]> { return this.makeRequest("getBackofficeBillsFilteredByAllDates", args || {}); }
    undoBackofficePayMultipleBills(args: {ids: string[], date: Date}): Promise<void> { return this.makeRequest("undoBackofficePayMultipleBills", args || {}); }
    getBackofficeBillsToDREAnalytics(args: {placeId: string, billIdList: string[], billPlanCategoryId: string}): Promise<BackofficeBillsToDREAnalytics[]> { return this.makeRequest("getBackofficeBillsToDREAnalytics", args || {}); }
    editBackofficeBillDREAnalytics(args: {editBillDREAnalyticsArg: BackofficeEditBillDREAnalyticsArg}): Promise<void> { return this.makeRequest("editBackofficeBillDREAnalytics", args || {}); }
    exportBackofficeBillsDREAnalytics(args: {placeId: string, billIdList: string[], billPlanCategoryId: string}): Promise<string> { return this.makeRequest("exportBackofficeBillsDREAnalytics", args || {}); }
    deleteBackofficeBillPartialPaid(args: {placeId: string, billId: string}): Promise<void> { return this.makeRequest("deleteBackofficeBillPartialPaid", args || {}); }
    getBackofficeBillType(args: {id: string, placeId: string}): Promise<BackofficeBillType> { return this.makeRequest("getBackofficeBillType", args || {}); }
    getBackofficeBillTypes(args: {placeId: string}): Promise<BackofficeBillType[]> { return this.makeRequest("getBackofficeBillTypes", args || {}); }
    createBackofficeBillType(args: {placeId: string, billType: BackofficeNewBillType}): Promise<BackofficeBillType> { return this.makeRequest("createBackofficeBillType", args || {}); }
    editBackofficeBillType(args: {placeId: string, id: string, billType: BackofficeNewBillType}): Promise<void> { return this.makeRequest("editBackofficeBillType", args || {}); }
    deleteBackofficeBillType(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeBillType", args || {}); }
    getBackofficeCashFlow(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeCashFlow> { return this.makeRequest("getBackofficeCashFlow", args || {}); }
    getBackofficeFullCashFlow(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter, accountIds: string[]}): Promise<BackofficeFullCashFlow> { return this.makeRequest("getBackofficeFullCashFlow", args || {}); }
    getBackofficeNeoCashFlow(args: {neoCashFlowArgs: BackofficeNeoCashFlowArgs}): Promise<BackofficeNeoCashFlow[]> { return this.makeRequest("getBackofficeNeoCashFlow", args || {}); }
    exportBackofficeNeoCashFlow(args: {neoCashFlowArgs: BackofficeNeoCashFlowArgs}): Promise<string> { return this.makeRequest("exportBackofficeNeoCashFlow", args || {}); }
    getBackofficeCategory(args: {id: string, placeId: string}): Promise<BackofficeCategory> { return this.makeRequest("getBackofficeCategory", args || {}); }
    getBackofficeCategories(args: {placeId: string}): Promise<BackofficeCategory[]> { return this.makeRequest("getBackofficeCategories", args || {}); }
    createBackofficeCategory(args: {placeId: string, category: BackofficeNewCategory}): Promise<BackofficeCategory> { return this.makeRequest("createBackofficeCategory", args || {}); }
    editBackofficeCategory(args: {placeId: string, id: string, category: BackofficeNewCategory}): Promise<void> { return this.makeRequest("editBackofficeCategory", args || {}); }
    deleteBackofficeCategory(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeCategory", args || {}); }
    getBackofficeProductsCmv(args: {placeId: string, productIds: string[], since: Date, until: Date, shouldUseLastInvoice: boolean}): Promise<BackofficeProductCmv[]> { return this.makeRequest("getBackofficeProductsCmv", args || {}); }
    getBackofficeProductsSimpleCurrentCmv(args: {placeId: string, productIds: string[], shouldUseLastInvoice: boolean}): Promise<BackofficeProductSimpleCmv[]> { return this.makeRequest("getBackofficeProductsSimpleCurrentCmv", args || {}); }
    getBackofficeProductsSimpleCmv(args: {placeId: string, productIds: string[], since: Date, until: Date, shouldUseLastInvoice: boolean}): Promise<BackofficeProductSimpleCmv[]> { return this.makeRequest("getBackofficeProductsSimpleCmv", args || {}); }
    getBackofficeCurrentProductsCmvV2(args: {placeId: string, productIds: string[]}): Promise<BackofficeProductCmvWithQuantity[]> { return this.makeRequest("getBackofficeCurrentProductsCmvV2", args || {}); }
    getBackofficeCurrentProductsCmvV2ForStorages(args: {placeId: string, storageIds: string[]}): Promise<BackofficeProductCmvWithQuantity[]> { return this.makeRequest("getBackofficeCurrentProductsCmvV2ForStorages", args || {}); }
    getBackofficeCostCenter(args: {id: string, placeId: string}): Promise<BackofficeCostCenter> { return this.makeRequest("getBackofficeCostCenter", args || {}); }
    getBackofficeCostCenters(args: {placeId: string}): Promise<BackofficeCostCenter[]> { return this.makeRequest("getBackofficeCostCenters", args || {}); }
    createBackofficeCostCenter(args: {placeId: string, costCenter: BackofficeNewCostCenter}): Promise<BackofficeCostCenter> { return this.makeRequest("createBackofficeCostCenter", args || {}); }
    editBackofficeCostCenter(args: {placeId: string, id: string, costCenter: BackofficeNewCostCenter}): Promise<void> { return this.makeRequest("editBackofficeCostCenter", args || {}); }
    deleteBackofficeCostCenter(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeCostCenter", args || {}); }
    createBackofficeDre(args: {placeId: string, inputedBy: string, dre: BackofficeNewDre}): Promise<BackofficeDre> { return this.makeRequest("createBackofficeDre", args || {}); }
    deleteBackofficeDre(args: {id: string}): Promise<void> { return this.makeRequest("deleteBackofficeDre", args || {}); }
    updateBackofficeDre(args: {id: string, dre: BackofficeNewDre}): Promise<BackofficeDre> { return this.makeRequest("updateBackofficeDre", args || {}); }
    createBackofficeDefaultDre(args: {placeId: string, billPlanContextId: string, inputedBy: string, dre: BackofficeNewDre}): Promise<BackofficeDre> { return this.makeRequest("createBackofficeDefaultDre", args || {}); }
    getBackofficeDres(args: {placeId: string}): Promise<BackofficeDre[]> { return this.makeRequest("getBackofficeDres", args || {}); }
    getBackofficeDreLines(args: {dreId: string}): Promise<BackofficeDreLine[]> { return this.makeRequest("getBackofficeDreLines", args || {}); }
    addBackofficeDreLine(args: {dreId: string, inputedBy: string, line: BackofficeNewDreLine}): Promise<BackofficeDreLine> { return this.makeRequest("addBackofficeDreLine", args || {}); }
    editBackofficeDreLine(args: {lineId: string, inputedBy: string, line: BackofficeNewDreLine}): Promise<BackofficeDreLine> { return this.makeRequest("editBackofficeDreLine", args || {}); }
    deleteBackofficeDreLine(args: {lineId: string}): Promise<void> { return this.makeRequest("deleteBackofficeDreLine", args || {}); }
    getBackofficeDreReport(args: {dreId: string, since: Date, until: Date}): Promise<BackofficeDreReport> { return this.makeRequest("getBackofficeDreReport", args || {}); }
    getBackofficeDreFullReport(args: {dreId: string, since: Date, until: Date, accountIds?: string[] | null}): Promise<BackofficeDreFullReport> { return this.makeRequest("getBackofficeDreFullReport", args || {}); }
    getBackofficeNotCategorizedBillPlans(args: {dreId: string}): Promise<BackofficeSimplyBillPlan[]> { return this.makeRequest("getBackofficeNotCategorizedBillPlans", args || {}); }
    exportBackofficeDre(args: {exportDreArg: BackofficeExportDreArg}): Promise<ArrayBuffer> { return this.makeRequest("exportBackofficeDre", args || {}); }
    insertBackofficeFocusCompany(args: {placeId: string, cnpj: string, token: string, lastInvoiceVersion?: number | null}): Promise<BackofficeFocusCompany> { return this.makeRequest("insertBackofficeFocusCompany", args || {}); }
    updateBackofficeFocusCompany(args: {placeId: string, id: string, token: string}): Promise<BackofficeFocusCompany> { return this.makeRequest("updateBackofficeFocusCompany", args || {}); }
    deleteBackofficeFocusCompany(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeFocusCompany", args || {}); }
    upsertBackofficeFocusCompany(args: {placeId: string, cnpj: string, token: string, lastInvoiceVersion?: number | null}): Promise<BackofficeFocusCompany> { return this.makeRequest("upsertBackofficeFocusCompany", args || {}); }
    getBackofficeFocusCompanies(args: {placeId: string}): Promise<BackofficeFocusCompany[]> { return this.makeRequest("getBackofficeFocusCompanies", args || {}); }
    getBackofficeFocusCompany(args: {id: string, placeId: string}): Promise<BackofficeFocusCompany> { return this.makeRequest("getBackofficeFocusCompany", args || {}); }
    getBackofficeFocusInvoices(args: {placeId: string, focusCompanyId: string}): Promise<BackofficeFocusInvoice[]> { return this.makeRequest("getBackofficeFocusInvoices", args || {}); }
    createBackofficeInventory(args: {inventory: BackofficeNewInventory, shouldOverlapOldInventory: boolean}): Promise<BackofficeInventory> { return this.makeRequest("createBackofficeInventory", args || {}); }
    getBackofficeInventories(args: {placeId: string, since: Date, until: Date}): Promise<BackofficeInventory[]> { return this.makeRequest("getBackofficeInventories", args || {}); }
    getBackofficeOpenedInventories(args: {placeId: string}): Promise<BackofficeInventory[]> { return this.makeRequest("getBackofficeOpenedInventories", args || {}); }
    addBackofficeStorageToInventory(args: {inventoryId: string, storageIds: string[]}): Promise<BackofficeInventory> { return this.makeRequest("addBackofficeStorageToInventory", args || {}); }
    getBackofficeInventoryProductsAtStorage(args: {inventoryId: string, storageId: string}): Promise<BackofficeInventoryProduct[]> { return this.makeRequest("getBackofficeInventoryProductsAtStorage", args || {}); }
    getBackofficeInventoryProducts(args: {inventoryId: string}): Promise<BackofficeInventoryProduct[]> { return this.makeRequest("getBackofficeInventoryProducts", args || {}); }
    updateBackofficeInventoryProduct(args: {inventoryId: string, authorId: string, products: BackofficeInventoryProduct[], shouldDivideUnitCostValueBy?: number | null}): Promise<BackofficeInventoryProduct[]> { return this.makeRequest("updateBackofficeInventoryProduct", args || {}); }
    closeBackofficeInventory(args: {authorId: string, inventoryId: string, alterUnitValue: boolean}): Promise<void> { return this.makeRequest("closeBackofficeInventory", args || {}); }
    cancelBackofficeInventory(args: {authorId: string, inventoryId: string}): Promise<void> { return this.makeRequest("cancelBackofficeInventory", args || {}); }
    getFiscalProfileInvoiceOptions(args: {fiscalProfileId: string, placeId: string}): Promise<SimpleInvoiceInfo[]> { return this.makeRequest("getFiscalProfileInvoiceOptions", args || {}); }
    importFiscalProfileInvoiceFromSefaz(args: {placeId: string, storageId: string, fiscalProfileId: string, invoiceKey: string}): Promise<BackofficeImportedInvoice> { return this.makeRequest("importFiscalProfileInvoiceFromSefaz", args || {}); }
    getFiscalInvoicesBackups(args: {placeId: string, fiscalProfileId: string}): Promise<FiscalInvoiceBackup[]> { return this.makeRequest("getFiscalInvoicesBackups", args || {}); }
    getBackofficeImportedInvoices(args: {placeId: string, since?: Date | null, until?: Date | null}): Promise<BackofficeImportedInvoice[]> { return this.makeRequest("getBackofficeImportedInvoices", args || {}); }
    getBackofficeImportedProductsFromInvoices(args: {placeId: string, since?: Date | null, until?: Date | null}): Promise<BackofficeImportedProductsFromInvoices[]> { return this.makeRequest("getBackofficeImportedProductsFromInvoices", args || {}); }
    importBackofficeInvoice(args: {placeId: string, storageId?: string | null, xml: ArrayBuffer, restriction?: BackofficeImportedInvoiceRestriction | null}): Promise<BackofficeImportedInvoice> { return this.makeRequest("importBackofficeInvoice", args || {}); }
    manualImportBackofficeInvoice(args: {placeId: string, storageId: string, invoice: NewManualBackofficeInvoiceV2}): Promise<BackofficeImportedInvoice> { return this.makeRequest("manualImportBackofficeInvoice", args || {}); }
    importBackofficeMultipleInvoices(args: {placeId: string, storageId?: string | null, xml: BackofficeXmlInput[], restriction?: BackofficeImportedInvoiceRestriction | null}): Promise<BackofficeMultipleImportedInvoice> { return this.makeRequest("importBackofficeMultipleInvoices", args || {}); }
    createBackofficeManualInvoice(args: {placeId: string, manualInvoice: BackofficeNewManualInvoice}): Promise<BackofficeImportedInvoice> { return this.makeRequest("createBackofficeManualInvoice", args || {}); }
    editBackofficeManualInvoiceDetails(args: {placeId: string, invoiceId: string, invoiceInfo: BackofficeNewManualInvoice}): Promise<void> { return this.makeRequest("editBackofficeManualInvoiceDetails", args || {}); }
    updateBackofficeImportedInvoice(args: {placeId: string, invoiceId: string, invoiceDetails: BackofficeImportedInvoiceUpdate}): Promise<BackofficeImportedInvoice> { return this.makeRequest("updateBackofficeImportedInvoice", args || {}); }
    invalidateBackofficeInvoiceProduct(args: {placeId: string, invoiceId: string, entryId: string}): Promise<void> { return this.makeRequest("invalidateBackofficeInvoiceProduct", args || {}); }
    getBackofficeProductLastInvoiceDetails(args: {placeId: string, associatedProductId: string}): Promise<BackofficeProductLastInvoiceDetails | null> { return this.makeRequest("getBackofficeProductLastInvoiceDetails", args || {}); }
    getBackofficeInvoiceProducts(args: {placeId: string, invoiceId: string}): Promise<BackofficeImportedInvoiceProduct[]> { return this.makeRequest("getBackofficeInvoiceProducts", args || {}); }
    editBackofficeInvoiceBill(args: {placeId: string, editInvoiceBillArg: BackofficeEditInvoiceBillArg}): Promise<void> { return this.makeRequest("editBackofficeInvoiceBill", args || {}); }
    editBackofficeInvoiceProduct(args: {placeId: string, invoiceId: string, entryId: string, skipped: boolean, productId?: string | null, unitValue?: number | null, unitMultiplier: number}): Promise<void> { return this.makeRequest("editBackofficeInvoiceProduct", args || {}); }
    editBackofficeInvoiceProductV2(args: {placeId: string, invoiceId: string, entryId: string, skipped: boolean, productId?: string | null, unitMultiplier: string, chartAccountId?: string | null, unitValue?: number | null, commercialQuantity?: number | null}): Promise<void> { return this.makeRequest("editBackofficeInvoiceProductV2", args || {}); }
    editBackofficeInvoiceSupplier(args: {placeId: string, invoiceId: string, skipped: boolean, supplierId?: string | null}): Promise<void> { return this.makeRequest("editBackofficeInvoiceSupplier", args || {}); }
    upsertBackofficeManualInvoiceProduct(args: {placeId: string, invoiceId: string, products: BackofficeUpsertManualProduct[]}): Promise<void> { return this.makeRequest("upsertBackofficeManualInvoiceProduct", args || {}); }
    deleteBackofficeImportedInvoice(args: {placeId: string, invoiceId: string}): Promise<void> { return this.makeRequest("deleteBackofficeImportedInvoice", args || {}); }
    undoBackofficeFinishInvoiceImport(args: {placeId: string, invoiceId: string}): Promise<void> { return this.makeRequest("undoBackofficeFinishInvoiceImport", args || {}); }
    isBackofficeInvoiceAlreadyImported(args: {placeId: string, storageId: string, num: number, serie: number, supplierCpfOrCnpj: string}): Promise<boolean> { return this.makeRequest("isBackofficeInvoiceAlreadyImported", args || {}); }
    finishBackofficeInvoiceImport(args: {invoiceId: string, skipPendings: boolean, placeId: string}): Promise<void> { return this.makeRequest("finishBackofficeInvoiceImport", args || {}); }
    upsertBackofficeInvoiceDuplicates(args: {placeId: string, upsertInvoiceDuplicateArg: BackofficeUpsertInvoiceDuplicateArg}): Promise<BackofficeInvoiceDuplicate[]> { return this.makeRequest("upsertBackofficeInvoiceDuplicates", args || {}); }
    getBackofficeInvoiceDetailsBillPlanCategories(args: {placeId: string, invoiceId: string, invoiceDetailsField: BackofficeImportedInvoiceDetailsField}): Promise<BackofficeImportedInvoiceDetailsBillPlanCategory[]> { return this.makeRequest("getBackofficeInvoiceDetailsBillPlanCategories", args || {}); }
    saveBackofficeDetailsBillPlanCategories(args: {invoiceId: string, objBillPlanCategories: BackofficeImportedInvoiceDetailsObjBillPlanCategory[], invoiceDetailsField: BackofficeImportedInvoiceDetailsField}): Promise<void> { return this.makeRequest("saveBackofficeDetailsBillPlanCategories", args || {}); }
    getBackofficeImportedInvoiceById(args: {placeId: string, id: string}): Promise<BackofficeImportedInvoice> { return this.makeRequest("getBackofficeImportedInvoiceById", args || {}); }
    getBackofficeInvoiceXLSX(args: {invoiceXLSXArgs: BackofficeInvoiceXLSXArgs}): Promise<string> { return this.makeRequest("getBackofficeInvoiceXLSX", args || {}); }
    getBackofficeInvoiceDuplicateByBillId(args: {placeId: string, billId: string}): Promise<BackofficeBillInvoiceDuplicate[]> { return this.makeRequest("getBackofficeInvoiceDuplicateByBillId", args || {}); }
    getBackofficeReceivedInvoices(args: {getReceivedInvoicesArgs: BackofficeGetReceivedInvoicesArgs}): Promise<BackofficeReceivedInvoiceHeader[]> { return this.makeRequest("getBackofficeReceivedInvoices", args || {}); }
    getBackofficeReceivedInvoice(args: {focusCompanyId: string, accessKey: string}): Promise<BackofficeReceivedInvoiceHeader> { return this.makeRequest("getBackofficeReceivedInvoice", args || {}); }
    getBackofficeInvoiceXmlUrl(args: {placeId: string, id: string}): Promise<string> { return this.makeRequest("getBackofficeInvoiceXmlUrl", args || {}); }
    postBackofficeManifest(args: {placeId: string, id: string, manifestType: BackofficeManifestType, reason?: string | null}): Promise<BackofficeResponseInvoiceManifest> { return this.makeRequest("postBackofficeManifest", args || {}); }
    getBackofficeIncomeStatement(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeIncomeStatement> { return this.makeRequest("getBackofficeIncomeStatement", args || {}); }
    getBackofficeIncomeByCategory(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeIncomeByCategory[]> { return this.makeRequest("getBackofficeIncomeByCategory", args || {}); }
    getBackofficeBillHistory(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeBillHistory> { return this.makeRequest("getBackofficeBillHistory", args || {}); }
    getBackofficeExtract(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeExtract> { return this.makeRequest("getBackofficeExtract", args || {}); }
    getBackofficeDescriptionReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeDescriptionReport> { return this.makeRequest("getBackofficeDescriptionReport", args || {}); }
    getBackofficeDayReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeDayReport> { return this.makeRequest("getBackofficeDayReport", args || {}); }
    getBackofficeBillTypeReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeDescriptionReport> { return this.makeRequest("getBackofficeBillTypeReport", args || {}); }
    getBackofficeBillCategoryReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeDescriptionReport> { return this.makeRequest("getBackofficeBillCategoryReport", args || {}); }
    getBackofficeCostCenterReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeCostCenterReport> { return this.makeRequest("getBackofficeCostCenterReport", args || {}); }
    getBackofficeCategoryHistoryReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeCategoryHistory> { return this.makeRequest("getBackofficeCategoryHistoryReport", args || {}); }
    getBackofficeBillSupplierTrackerReport(args: {placeId: string, since: Date, until: Date, statusFilter: BackofficeBillStatusFilter, dateFilter: BackofficeBillDateFilter}): Promise<BackofficeBillSupplierTrackerReport> { return this.makeRequest("getBackofficeBillSupplierTrackerReport", args || {}); }
    getBackofficeResume(args: {placeId: string}): Promise<BackofficeResume> { return this.makeRequest("getBackofficeResume", args || {}); }
    getBackofficeResumeInPeriod(args: {placeId: string, since: Date, until: Date}): Promise<BackofficePeriodResume> { return this.makeRequest("getBackofficeResumeInPeriod", args || {}); }
    getBackofficeBillPlanCategoriesReport(args: {billPlanCategoryIds: string[], since: Date, until: Date}): Promise<BackofficeBillPlanCategoriesReport[]> { return this.makeRequest("getBackofficeBillPlanCategoriesReport", args || {}); }
    getBackofficeStoragePositionReport(args: {storageId: string, placeId: string, date: Date}): Promise<StoragePositionReport> { return this.makeRequest("getBackofficeStoragePositionReport", args || {}); }
    getBackofficeStorage(args: {id: string, placeId: string}): Promise<BackofficeStorage> { return this.makeRequest("getBackofficeStorage", args || {}); }
    getBackofficeStorages(args: {placeId: string}): Promise<BackofficeStorage[]> { return this.makeRequest("getBackofficeStorages", args || {}); }
    getBackofficeStorageWithResume(args: {id: string, placeId: string}): Promise<BackofficeStorageWithResume> { return this.makeRequest("getBackofficeStorageWithResume", args || {}); }
    getBackofficeStoragesWithResume(args: {placeId: string}): Promise<BackofficeStoragesWithResume> { return this.makeRequest("getBackofficeStoragesWithResume", args || {}); }
    getBackofficeStorageInsights(args: {storageId: string, placeId: string}): Promise<BackofficeSingleStorageInsights> { return this.makeRequest("getBackofficeStorageInsights", args || {}); }
    getBackofficeStoragesInsights(args: {placeId: string}): Promise<BackofficeStorageInsights> { return this.makeRequest("getBackofficeStoragesInsights", args || {}); }
    createBackofficeStorage(args: {placeId?: string | null, organizationId?: string | null, storage: BackofficeNewStorage}): Promise<BackofficeStorage> { return this.makeRequest("createBackofficeStorage", args || {}); }
    editBackofficeStorage(args: {placeId?: string | null, organizationId?: string | null, id: string, storage: BackofficeNewStorage}): Promise<void> { return this.makeRequest("editBackofficeStorage", args || {}); }
    deleteBackofficeStorage(args: {placeId?: string | null, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeStorage", args || {}); }
    getBackofficeProductsAtStorage(args: {placeId: string, storageId: string}): Promise<BackofficeStorageProductUnitCost[]> { return this.makeRequest("getBackofficeProductsAtStorage", args || {}); }
    getBackofficeProductsStorageAtContext(args: {placeId: string}): Promise<BackofficeStorageProduct[]> { return this.makeRequest("getBackofficeProductsStorageAtContext", args || {}); }
    getBackofficeProductsStorageAtContextByProducts(args: {placeId: string, productIds: string[]}): Promise<BackofficeStorageProduct[]> { return this.makeRequest("getBackofficeProductsStorageAtContextByProducts", args || {}); }
    getBackofficeProductsTransfersResumeAtStorage(args: {placeId: string, storageId: string, productIds: string[], since: Date, until: Date, page?: number | null, itemsPerPage?: number | null}): Promise<BackofficePaginationStorageProductTransfersResume> { return this.makeRequest("getBackofficeProductsTransfersResumeAtStorage", args || {}); }
    getBackofficeProductStorageHistoryV3(args: {placeId: string, storageId: string, productId: string, filterBy?: BackofficeProductStorageHistoryFilterBy | null, since: Date, until: Date, page?: number | null, itemsPerPage?: number | null}): Promise<BackofficeStorageHistoryV4> { return this.makeRequest("getBackofficeProductStorageHistoryV3", args || {}); }
    getBackofficeProductsStorageHistoryV3(args: {placeId: string, storageId: string, productIds: string[], filterBy?: BackofficeProductStorageHistoryFilterBy | null, since: Date, until: Date, page?: number | null, itemsPerPage?: number | null}): Promise<BackofficeStorageProductsHistoryV3[]> { return this.makeRequest("getBackofficeProductsStorageHistoryV3", args || {}); }
    getBackofficeProductsStoragesHistoryV3(args: {placeId: string, storageIds: string[], productIds: string[], filterBy?: BackofficeProductStorageHistoryFilterBy | null, since: Date, until: Date, page?: number | null, itemsPerPage?: number | null}): Promise<BackofficeStorageProductsHistoryV3[]> { return this.makeRequest("getBackofficeProductsStoragesHistoryV3", args || {}); }
    sellBackofficeProductAtStorage(args: {placeId: string, employeeId?: string | null, storageId: string, productId: string, count: number, date: Date, shouldApplyProductionRule: boolean}): Promise<void> { return this.makeRequest("sellBackofficeProductAtStorage", args || {}); }
    refundBackofficeSellProductAtStorage(args: {placeId: string, storageId: string, productId: string, count: number, date: Date}): Promise<void> { return this.makeRequest("refundBackofficeSellProductAtStorage", args || {}); }
    cancelBackofficeSellProductAtStorage(args: {placeId: string, storageId: string, productId: string, count: number, date: Date}): Promise<void> { return this.makeRequest("cancelBackofficeSellProductAtStorage", args || {}); }
    lostBackofficeProductAtStorage(args: {placeId: string, storageId: string, productId: string, count: number, basicStorageUnit: BasicStorageUnit, date: Date}): Promise<void> { return this.makeRequest("lostBackofficeProductAtStorage", args || {}); }
    manualBackofficeAdjustProductAtStorageV2(args: {placeId?: string | null, storageId: string, productId: string, count: number, basicStorageUnit: BasicStorageUnit, date: Date, obs?: string | null}): Promise<void> { return this.makeRequest("manualBackofficeAdjustProductAtStorageV2", args || {}); }
    transferBackofficeProduct(args: {placeId?: string | null, productId: string, fromId: string, toId: string, count: number, date: Date}): Promise<void> { return this.makeRequest("transferBackofficeProduct", args || {}); }
    transferBackofficeProducts(args: {placeId?: string | null, fromId: string, toId: string, date: Date, products: BackofficeMultipleStorageTransferProduct[]}): Promise<BackofficeMultipleStorageTransferProductResult> { return this.makeRequest("transferBackofficeProducts", args || {}); }
    transferBackofficeProductsV2(args: {placeId?: string | null, fromId: string, toId: string, date: Date, products: BackofficeMultipleStorageTransferProductV2[], activateProducts: boolean}): Promise<BackofficeMultipleStorageTransferProductResultV2> { return this.makeRequest("transferBackofficeProductsV2", args || {}); }
    deleteBackofficeProductAtStorage(args: {placeId?: string | null, storageId: string, productId: string}): Promise<void> { return this.makeRequest("deleteBackofficeProductAtStorage", args || {}); }
    deleteBackofficeProductsAtStorage(args: {placeId?: string | null, storageId: string, productIds: string[]}): Promise<BackofficeDeleteProductsResult> { return this.makeRequest("deleteBackofficeProductsAtStorage", args || {}); }
    zeroBackofficeAllProductsAtStorage(args: {placeId?: string | null, storageId: string}): Promise<void> { return this.makeRequest("zeroBackofficeAllProductsAtStorage", args || {}); }
    zeroBackofficeProductsAtStorage(args: {placeId?: string | null, storageId: string, productIds: string[]}): Promise<void> { return this.makeRequest("zeroBackofficeProductsAtStorage", args || {}); }
    inputBackofficeProductV2(args: {placeId?: string | null, input: BackofficeInputV2, transferType?: BackofficeStorageTransferType | null, referenceCode?: string | null}): Promise<void> { return this.makeRequest("inputBackofficeProductV2", args || {}); }
    inputBackofficeProductsV2(args: {placeId?: string | null, inputs: BackofficeInputV2[], transferType?: BackofficeStorageTransferType | null, referenceCode?: string | null}): Promise<BackofficeInputsResultV2> { return this.makeRequest("inputBackofficeProductsV2", args || {}); }
    inputBackofficeProductV3(args: {placeId: string, input: BackofficeInputV3, transferType?: BackofficeStorageTransferType | null, referenceCode?: string | null}): Promise<void> { return this.makeRequest("inputBackofficeProductV3", args || {}); }
    inputBackofficeProductsV3(args: {placeId: string, inputs: BackofficeInputV3[], transferType?: BackofficeStorageTransferType | null, referenceCode?: string | null}): Promise<void> { return this.makeRequest("inputBackofficeProductsV3", args || {}); }
    createBackofficeProductionRule(args: {placeId: string, rule: BackofficeNewProductionRule}): Promise<string> { return this.makeRequest("createBackofficeProductionRule", args || {}); }
    editBackofficeProductionRuleInputs(args: {placeId: string, productionRuleId: string, inputs: BackofficeProductionRuleInput[]}): Promise<void> { return this.makeRequest("editBackofficeProductionRuleInputs", args || {}); }
    deleteBackofficeProductionRule(args: {placeId: string, ruleId: string}): Promise<void> { return this.makeRequest("deleteBackofficeProductionRule", args || {}); }
    applyBackofficeProductionRule(args: {placeId: string, storageId: string, ruleId: string, inputs: BackofficeProductionRuleInput[], outputs: BackofficeProductionOutput[]}): Promise<void> { return this.makeRequest("applyBackofficeProductionRule", args || {}); }
    getBackofficeProductionRules(args: {placeId: string}): Promise<BackofficeProductionRule[]> { return this.makeRequest("getBackofficeProductionRules", args || {}); }
    getBackofficeProductsStatusAtStorageAndDate(args: {productIds: string[], storageIds: string[], date: Date}): Promise<BackofficeProductStatusAtStorage[]> { return this.makeRequest("getBackofficeProductsStatusAtStorageAndDate", args || {}); }
    createBackofficeMinimumStorageRules(args: {placeId: string, createdBy: string, rules: BackofficeNewProductRule[]}): Promise<ResultCreateProductRule> { return this.makeRequest("createBackofficeMinimumStorageRules", args || {}); }
    editBackofficeMinimumStorageRule(args: {placeId: string, rules: BackofficeEditProductRule[]}): Promise<BackofficeResultEditProductRule> { return this.makeRequest("editBackofficeMinimumStorageRule", args || {}); }
    deleteBackofficeMinimumStorageRule(args: {placeId: string, ids: string[]}): Promise<void> { return this.makeRequest("deleteBackofficeMinimumStorageRule", args || {}); }
    getBackofficeMinimumStorageRules(args: {placeIds: string[]}): Promise<BackofficeProductRule[]> { return this.makeRequest("getBackofficeMinimumStorageRules", args || {}); }
    getBackofficeMinimumStorageRulesByProducts(args: {placeIds: string[], productIds: string[]}): Promise<BackofficeProductRule[]> { return this.makeRequest("getBackofficeMinimumStorageRulesByProducts", args || {}); }
    getBackofficeProductsMinimumStorageAlert(args: {placeIds: string[], productIds: string[]}): Promise<BackofficeProductAlert[]> { return this.makeRequest("getBackofficeProductsMinimumStorageAlert", args || {}); }
    getBackofficeProductMinimumStorageAlert(args: {placeIds: string[], productId: string}): Promise<BackofficeProductAlert> { return this.makeRequest("getBackofficeProductMinimumStorageAlert", args || {}); }
    getBackofficeMinimumStorageAlert(args: {placeIds: string[]}): Promise<BackofficeProductAlert[]> { return this.makeRequest("getBackofficeMinimumStorageAlert", args || {}); }
    getBackofficeCurrentReportStorages(args: {placeId: string, storageIds: string[]}): Promise<BackofficeCurrentReportStorage> { return this.makeRequest("getBackofficeCurrentReportStorages", args || {}); }
    getBackofficeSupplier(args: {id: string, placeId: string}): Promise<BackofficeSupplier> { return this.makeRequest("getBackofficeSupplier", args || {}); }
    getBackofficeSuppliers(args: {placeId: string}): Promise<BackofficeSupplier[]> { return this.makeRequest("getBackofficeSuppliers", args || {}); }
    getBackofficeSuppliersWithFilters(args: {placeId: string, params?: BackofficeGetSuppliersParams | null}): Promise<BackofficeGetSuppliersResponse> { return this.makeRequest("getBackofficeSuppliersWithFilters", args || {}); }
    getBackofficeSuppliersXLSX(args: {placeId: string}): Promise<string> { return this.makeRequest("getBackofficeSuppliersXLSX", args || {}); }
    createBackofficeSupplier(args: {placeId: string, supplier: BackofficeNewSupplier}): Promise<BackofficeSupplier> { return this.makeRequest("createBackofficeSupplier", args || {}); }
    editBackofficeSupplier(args: {placeId: string, id: string, supplier: BackofficeNewSupplier}): Promise<void> { return this.makeRequest("editBackofficeSupplier", args || {}); }
    deleteBackofficeSupplier(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeSupplier", args || {}); }
    createBackofficeUniqSupplier(args: {placeId: string, supplier: BackofficeNewSupplier}): Promise<BackofficeSupplier> { return this.makeRequest("createBackofficeUniqSupplier", args || {}); }
    editBackofficeUniqSupplier(args: {id: string, supplier: BackofficeNewSupplier}): Promise<void> { return this.makeRequest("editBackofficeUniqSupplier", args || {}); }
    getBackofficeTransfers(args: {placeId: string, since: Date, until: Date}): Promise<BackofficeTransfer[]> { return this.makeRequest("getBackofficeTransfers", args || {}); }
    doBackofficeTransfer(args: {placeId: string, transfer: BackofficeNewTransfer}): Promise<BackofficeTransfer> { return this.makeRequest("doBackofficeTransfer", args || {}); }
    editBackofficeTransfer(args: {placeId: string, id: string, transfer: BackofficeNewTransfer}): Promise<BackofficeTransfer> { return this.makeRequest("editBackofficeTransfer", args || {}); }
    deleteBackofficeTransfer(args: {placeId: string, id: string}): Promise<void> { return this.makeRequest("deleteBackofficeTransfer", args || {}); }
    importBackofficeProducts(args: {placeId: string, storageId: string, products: BackofficeProductImporting[]}): Promise<BackofficeProductImportingResult> { return this.makeRequest("importBackofficeProducts", args || {}); }
    generateDefaultBackofficeInputTemplate(args: {placeId: string, storageId: string}): Promise<string> { return this.makeRequest("generateDefaultBackofficeInputTemplate", args || {}); }
    getBackofficeSupplierAbcCurve(args: {placeId: string, since: Date, until: Date, supplierName?: string | null, pagination: Pagination}): Promise<SupplierAbcCurve | null> { return this.makeRequest("getBackofficeSupplierAbcCurve", args || {}); }
    exportBackofficeSupplierAbcCurveReport(args: {placeId: string, since: Date, until: Date, supplierName?: string | null}): Promise<string> { return this.makeRequest("exportBackofficeSupplierAbcCurveReport", args || {}); }
    getBackofficeProductAbcCurve(args: {placeId: string, since: Date, until: Date, productName?: string | null}): Promise<ProductAbcCurve | null> { return this.makeRequest("getBackofficeProductAbcCurve", args || {}); }
    exportBackofficeProductAbcCurveReport(args: {placeId: string, since: Date, until: Date, productName?: string | null}): Promise<string> { return this.makeRequest("exportBackofficeProductAbcCurveReport", args || {}); }
    getBackofficeCashFlowV2(args: {placeId: string, since: Date, until: Date, groupBy: GetBackofficeCashFlowV2GroupBy}): Promise<BackofficeAccountBillsReportResponse | null> { return this.makeRequest("getBackofficeCashFlowV2", args || {}); }
    updateBackofficeStorageProductsUnitCostValueAtStorages(args: {placeId: string, products: BackofficeUpdateStorageUnitCostProduct[]}): Promise<void> { return this.makeRequest("updateBackofficeStorageProductsUnitCostValueAtStorages", args || {}); }
    createBankAccount(args: {placeId: string, newBankAccount: BankAccountRequest, shouldSaveBankAccount: boolean}): Promise<PlaceBankAccountResponse> { return this.makeRequest("createBankAccount", args || {}); }
    getBankAccount(args: {bankAccountId: string}): Promise<PlaceBankAccountResponse> { return this.makeRequest("getBankAccount", args || {}); }
    getBankAccounts(args: {placeId: string, pagination: Pagination, bankName?: string | null}): Promise<PlaceBankAccountPaginationResponse> { return this.makeRequest("getBankAccounts", args || {}); }
    deleteBankAccount(args: {bankAccountId: string}): Promise<void> { return this.makeRequest("deleteBankAccount", args || {}); }
    updateBankAccount(args: {bankAccountId: string, bankAccount: BankAccountRequest}): Promise<PlaceBankAccountResponse> { return this.makeRequest("updateBankAccount", args || {}); }
    editBar(args: {bar: BarRequest}): Promise<void> { return this.makeRequest("editBar", args || {}); }
    editBarV2(args: {id: string, bar: EditableBarFields, newFichaLogo?: ArrayBuffer | null, menuIds: string[]}): Promise<void> { return this.makeRequest("editBarV2", args || {}); }
    deleteBar(args: {id: string}): Promise<void> { return this.makeRequest("deleteBar", args || {}); }
    addBar(args: {placeId: string, barName: string, storageId: string, internalIp?: string | null, internalIps?: string[] | null, fichaLogo?: ArrayBuffer | null, menuIds: string[]}): Promise<string> { return this.makeRequest("addBar", args || {}); }
    addBarV2(args: {placeId: string, bar: EditableBarFields, fichaLogo?: ArrayBuffer | null, menuIds: string[]}): Promise<string> { return this.makeRequest("addBarV2", args || {}); }
    getBars(args: {placeId: string, includeDeleted?: boolean | null}): Promise<BarWithMenus[]> { return this.makeRequest("getBars", args || {}); }
    activateProductAtBar(args: {placeId: string, barId: string, productIds: string[]}): Promise<void> { return this.makeRequest("activateProductAtBar", args || {}); }
    deactivateProductAtBar(args: {placeId: string, barId: string, productIds: string[]}): Promise<void> { return this.makeRequest("deactivateProductAtBar", args || {}); }
    activateAllProductsAtBar(args: {placeId: string, barId: string}): Promise<void> { return this.makeRequest("activateAllProductsAtBar", args || {}); }
    deactivateAllProductsAtBar(args: {placeId: string, barId: string}): Promise<void> { return this.makeRequest("deactivateAllProductsAtBar", args || {}); }
    getBarsDevices(args: {eventId: string}): Promise<BarsDevices[]> { return this.makeRequest("getBarsDevices", args || {}); }
    deliveredProductsByBarsAtEvent(args: {eventId: string, barIds?: string[] | null, sources?: TransactionSource[] | null, productMasterKinds?: ProductMasterKind[] | null, sectorIds?: string[] | null}): Promise<ProductSold[]> { return this.makeRequest("deliveredProductsByBarsAtEvent", args || {}); }
    productsSoldAtPlace(args: {since: Date, until: Date, placeId: string, sources?: TransactionSource[] | null}): Promise<ProductSold[]> { return this.makeRequest("productsSoldAtPlace", args || {}); }
    productsSoldAtOrg(args: {since: Date, until: Date, orgId: string, placeIds?: string[] | null}): Promise<ProductSold[]> { return this.makeRequest("productsSoldAtOrg", args || {}); }
    placesProductsWereSoldAtOrg(args: {orgId: string, placeIds?: string[] | null, since: Date, until: Date, productId: string, isMountable: boolean}): Promise<PlacesProductsWereSoldBody[]> { return this.makeRequest("placesProductsWereSoldAtOrg", args || {}); }
    deliveredProductsByBarsAtPlace(args: {since: Date, until: Date, placeId: string, barIds?: string[] | null, sources?: TransactionSource[] | null, productMasterKinds?: ProductMasterKind[] | null, sectorIds?: string[] | null}): Promise<ProductSold[]> { return this.makeRequest("deliveredProductsByBarsAtPlace", args || {}); }
    compareProductsSoldByBars(args: {since: Date, until: Date, placeId: string, barIds?: string[] | null, sources?: TransactionSource[] | null, productMasterKinds?: ProductMasterKind[] | null, sectorIds?: string[] | null}): Promise<ProductBarReport[]> { return this.makeRequest("compareProductsSoldByBars", args || {}); }
    getSellerReports(args: {eventId: string, sources?: TransactionSource[] | null}): Promise<SellerReport[]> { return this.makeRequest("getSellerReports", args || {}); }
    getSellerReportForPlace(args: {placeId: string, since: Date, until: Date, sources?: TransactionSource[] | null}): Promise<SellerReport[]> { return this.makeRequest("getSellerReportForPlace", args || {}); }
    productsSoldReport(args: {since: Date, until: Date, placeId: string, filters: ProductSoldFilters, pagination: Pagination, orderBy?: ProductsSoldOrderBy | null}): Promise<ProductsSoldReport> { return this.makeRequest("productsSoldReport", args || {}); }
    productsSoldOverview(args: {since: Date, until: Date, placeId: string, filters: ProductSoldFilters}): Promise<ProductsSoldOverviewResponse> { return this.makeRequest("productsSoldOverview", args || {}); }
    productsSoldForEventOverview(args: {eventId: string, filters: ProductSoldFilters}): Promise<ProductsSoldOverviewResponse> { return this.makeRequest("productsSoldForEventOverview", args || {}); }
    productsSoldReportForEvent(args: {eventId: string, filters: ProductSoldFilters, pagination: Pagination, orderBy?: ProductsSoldOrderBy | null}): Promise<ProductsSoldReportForEvent> { return this.makeRequest("productsSoldReportForEvent", args || {}); }
    productsSoldByBarReport(args: {since: Date, until: Date, placeId: string, filters: ProductByBarFilters, orderBy?: ProductsSoldOrderBy | null}): Promise<ProductsByBarsAtPlace[]> { return this.makeRequest("productsSoldByBarReport", args || {}); }
    productsSoldXlsx(args: {scope: GetReportByScope, filters: ProductByBarFilters}): Promise<string> { return this.makeRequest("productsSoldXlsx", args || {}); }
    productsSoldByBarXlsx(args: {scope: GetReportByScope, filters: ProductByBarFilters}): Promise<string> { return this.makeRequest("productsSoldByBarXlsx", args || {}); }
    productsSoldByBarReportByEvent(args: {eventId: string, filters: ProductByBarFilters, orderBy?: ProductsSoldOrderBy | null}): Promise<ProductsByBarsAtPlace[]> { return this.makeRequest("productsSoldByBarReportByEvent", args || {}); }
    productsSoldReportByBarOverview(args: {since: Date, until: Date, placeId: string, filters: ProductSoldFilters}): Promise<ProductsSoldOverviewResponse> { return this.makeRequest("productsSoldReportByBarOverview", args || {}); }
    productsSoldByBarReportByEventOverview(args: {eventId: string, filters: ProductByBarFilters}): Promise<ProductsSoldOverviewResponse> { return this.makeRequest("productsSoldByBarReportByEventOverview", args || {}); }
    getSellerDetails(args: {eventId: string, sellerId: string, sources?: TransactionSource[] | null}): Promise<SellerTransaction[]> { return this.makeRequest("getSellerDetails", args || {}); }
    getSellerDetailsPlace(args: {placeId: string, sellerId: string, since: Date, until: Date, sources?: TransactionSource[] | null}): Promise<SellerTransaction[]> { return this.makeRequest("getSellerDetailsPlace", args || {}); }
    getSellerProductDetails(args: {eventId: string, sellerId: string, sources?: TransactionSource[] | null}): Promise<ProductSold[]> { return this.makeRequest("getSellerProductDetails", args || {}); }
    getSellerProductDetailsPlace(args: {placeId: string, sellerId: string, since: Date, until: Date, sources?: TransactionSource[] | null}): Promise<ProductSold[]> { return this.makeRequest("getSellerProductDetailsPlace", args || {}); }
    exportAllTransactionProductsXlsx(args: {eventId: string, sectorIds?: string[] | null}): Promise<string> { return this.makeRequest("exportAllTransactionProductsXlsx", args || {}); }
    getSoldBaseProductsAtEvent(args: {eventId: string, sources?: TransactionSource[] | null}): Promise<BaseProduct[]> { return this.makeRequest("getSoldBaseProductsAtEvent", args || {}); }
    getSoldBaseProductsAtPlace(args: {placeId: string, since: Date, until: Date, sources?: TransactionSource[] | null}): Promise<BaseProduct[]> { return this.makeRequest("getSoldBaseProductsAtPlace", args || {}); }
    getSimplifiedSellers(args: {eventId: string}): Promise<SimplifiedSeller[]> { return this.makeRequest("getSimplifiedSellers", args || {}); }
    refundFichaSell(args: {transactionId: string, reason: string, shouldReturnToStorage: boolean}): Promise<void> { return this.makeRequest("refundFichaSell", args || {}); }
    getBurnedPaperTicketsForEvent(args: {eventId: string, barIds?: string[] | null}): Promise<BurnedPaperTicket[]> { return this.makeRequest("getBurnedPaperTicketsForEvent", args || {}); }
    getBurnedPaperTicketsForPlace(args: {placeId: string, since: Date, until: Date, barIds?: string[] | null}): Promise<BurnedPaperTicket[]> { return this.makeRequest("getBurnedPaperTicketsForPlace", args || {}); }
    getProductsBurnedPaperTicketsForPlace(args: {placeId: string, barIds?: string[] | null, since?: Date | null, until?: Date | null}): Promise<ProductBurnedTicketSold[]> { return this.makeRequest("getProductsBurnedPaperTicketsForPlace", args || {}); }
    getProductsBurnedPaperTicketsForEvent(args: {eventId: string, barIds?: string[] | null, since?: Date | null, until?: Date | null}): Promise<ProductBurnedTicketSold[]> { return this.makeRequest("getProductsBurnedPaperTicketsForEvent", args || {}); }
    getEstimatedFinanceDetailsByBarAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByBarAtPlace", args || {}); }
    getEstimatedFinanceDetailsByEmployeeAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<BarOrEmployeeFinance[]> { return this.makeRequest("getEstimatedFinanceDetailsByEmployeeAtPlace", args || {}); }
    getConsolidatedBarSellingReportAtPlace(args: {placeId: string, since: Date, until: Date, sources?: TransactionSource[] | null}): Promise<BarReport[]> { return this.makeRequest("getConsolidatedBarSellingReportAtPlace", args || {}); }
    bleedCashier(args: {eventId: string, cashierId: string, value: number, obs?: string | null}): Promise<void> { return this.makeRequest("bleedCashier", args || {}); }
    getPossibleCloseMethods(args?: {}): Promise<CloseMethod[]> { return this.makeRequest("getPossibleCloseMethods", args || {}); }
    cashierDetailsAtEvent(args: {eventId: string, barIds?: string[] | null, sectorIds?: string[] | null}): Promise<Cashier[]> { return this.makeRequest("cashierDetailsAtEvent", args || {}); }
    cashierDetailsAtPlace(args: {since: Date, until: Date, placeId: string, barIds?: string[] | null, sectorIds?: string[] | null}): Promise<Cashier[]> { return this.makeRequest("cashierDetailsAtPlace", args || {}); }
    getCashierRechargeDetails(args: {eventId: string, cashierId: string}): Promise<RechargeDetails[]> { return this.makeRequest("getCashierRechargeDetails", args || {}); }
    getCashierPostDetails(args: {eventId: string, cashierId: string}): Promise<PostDetails[]> { return this.makeRequest("getCashierPostDetails", args || {}); }
    updateCashierClosingValues(args: {eventId: string, cashierId: string, values: CloseValue[]}): Promise<Cashier> { return this.makeRequest("updateCashierClosingValues", args || {}); }
    closeCashier(args: {eventId: string, cashierId: string}): Promise<void> { return this.makeRequest("closeCashier", args || {}); }
    reopenCashier(args: {eventId: string, cashierId: string}): Promise<void> { return this.makeRequest("reopenCashier", args || {}); }
    addCashierClosingObs(args: {eventId: string, cashierId: string, obs: string}): Promise<void> { return this.makeRequest("addCashierClosingObs", args || {}); }
    getCashierClosingObs(args: {eventId: string, cashierId: string}): Promise<CashierClosingObs[]> { return this.makeRequest("getCashierClosingObs", args || {}); }
    listCateringProducts(args: {placeId: string, categoryId?: string | null, productName?: string | null, types?: CateringProductSubType[] | null, pagination?: Pagination | null, orderBy?: CateringProductsOrderBy | null, order?: CateringProductsOrderDirection | null}): Promise<CateringProductListResponse> { return this.makeRequest("listCateringProducts", args || {}); }
    addCateringProduct(args: {placeId: string, product: NewCateringProduct, image?: EditProductImage | null}): Promise<AddCateringProduct> { return this.makeRequest("addCateringProduct", args || {}); }
    updateCateringProduct(args: {placeId: string, productId: string, product: NewCateringProduct, image?: EditProductImage | null}): Promise<void> { return this.makeRequest("updateCateringProduct", args || {}); }
    updateCateringProductPrice(args: {placeId: string, productId: string, value: number}): Promise<void> { return this.makeRequest("updateCateringProductPrice", args || {}); }
    deleteCateringProducts(args: {placeId: string, productIds: string[]}): Promise<DeleteCateringProductsResponse> { return this.makeRequest("deleteCateringProducts", args || {}); }
    bulkImportCateringProducts(args: {placeId: string, items: NewCateringProductBulkItem[]}): Promise<BulkImportCateringProductsResponse> { return this.makeRequest("bulkImportCateringProducts", args || {}); }
    exportCateringProducts(args: {placeId: string, categoryId?: string | null, productName?: string | null, types?: CateringProductSubType[] | null, orderBy?: CateringProductsOrderBy | null, order?: CateringProductsOrderDirection | null}): Promise<string> { return this.makeRequest("exportCateringProducts", args || {}); }
    getPlainCategories(args?: {}): Promise<BaseCategory[]> { return this.makeRequest("getPlainCategories", args || {}); }
    getCategories(args?: {}): Promise<CategoryWithTotalProducts[]> { return this.makeRequest("getCategories", args || {}); }
    getPlaceCategories(args: {placeId: string}): Promise<BaseCategory[]> { return this.makeRequest("getPlaceCategories", args || {}); }
    createCategory(args: {category: NewCategory, data?: ArrayBuffer | null}): Promise<Category> { return this.makeRequest("createCategory", args || {}); }
    editCategory(args: {id: string, category: NewCategory, data?: ArrayBuffer | null}): Promise<void> { return this.makeRequest("editCategory", args || {}); }
    deleteCategory(args: {id: string}): Promise<void> { return this.makeRequest("deleteCategory", args || {}); }
    getSellablesFromCategory(args: {categoryId: string}): Promise<SellableList> { return this.makeRequest("getSellablesFromCategory", args || {}); }
    filterSellablesCategories(args: {name: string}): Promise<Category[]> { return this.makeRequest("filterSellablesCategories", args || {}); }
    getSummarizedCategories(args: {placeId: string, productsSearchQuery?: string | null, status?: ProductStatus | null, kind: CategoryKind, includeEmpty?: boolean | null}): Promise<SummarizedCategory[]> { return this.makeRequest("getSummarizedCategories", args || {}); }
    getCostOfGoodsSoldByProductList(args: {placeId: string, productIds: string[]}): Promise<CostOfGoodsSold[]> { return this.makeRequest("getCostOfGoodsSoldByProductList", args || {}); }
    getCmvReport(args: {placeId: string, since: Date, until: Date, type: CmvReportType}): Promise<CmvReportResult> { return this.makeRequest("getCmvReport", args || {}); }
    exportCmvReport(args: {placeId: string, since: Date, until: Date, type: CmvReportType, productIds?: string[] | null}): Promise<string> { return this.makeRequest("exportCmvReport", args || {}); }
    getStoragePositionAt(args: {placeId: string, month: number, year: number}): Promise<ProductStoragePosition[]> { return this.makeRequest("getStoragePositionAt", args || {}); }
    getLostReport(args: {placeId: string, storageIds?: string[] | null, since: Date, until: Date}): Promise<ProductStoragePosition[]> { return this.makeRequest("getLostReport", args || {}); }
    getCmvMonthlyClosing(args: {placeId: string, month: number, year: number}): Promise<CmvMonthlyClosing> { return this.makeRequest("getCmvMonthlyClosing", args || {}); }
    getLostReportV2(args: {placeId: string, storageIds?: string[] | null, since: Date, until: Date, pagination?: BackofficeLostReportPagination | null}): Promise<BackofficeLostReport> { return this.makeRequest("getLostReportV2", args || {}); }
    addNewCombo(args: {placeId: string, combo: NewPlaceCombo, data?: ArrayBuffer | null}): Promise<string> { return this.makeRequest("addNewCombo", args || {}); }
    editCombo(args: {comboId: string, placeId: string, combo: NewPlaceCombo}): Promise<void> { return this.makeRequest("editCombo", args || {}); }
    editComboImage(args: {comboId: string, data: ArrayBuffer}): Promise<void> { return this.makeRequest("editComboImage", args || {}); }
    deleteCombo(args: {id: string}): Promise<void> { return this.makeRequest("deleteCombo", args || {}); }
    getNewCombo(args: {comboId: string, placeId: string}): Promise<DataCombo | null> { return this.makeRequest("getNewCombo", args || {}); }
    getCombos(args: {placeId: string}): Promise<DataCombo[]> { return this.makeRequest("getCombos", args || {}); }
    exportAllCombosXlsx(args: {placeId: string}): Promise<string> { return this.makeRequest("exportAllCombosXlsx", args || {}); }
    listComodatoContracts(args: {request: ComodatoContractListRequest}): Promise<ComodatoContractListResponse> { return this.makeRequest("listComodatoContracts", args || {}); }
    exportComodatoContractsToExcel(args: {request: ExportComodatoContractsRequest}): Promise<ComodatoContractListResponse> { return this.makeRequest("exportComodatoContractsToExcel", args || {}); }
    resendComodatoContractSignatureEmail(args: {request: ResendComodatoContractSignatureRequest}): Promise<void> { return this.makeRequest("resendComodatoContractSignatureEmail", args || {}); }
    getProductsWebConfigs(args: {placeId: string}): Promise<UpsertProductsWebResponse> { return this.makeRequest("getProductsWebConfigs", args || {}); }
    upsertProductsWebConfigs(args: {placeId: string, data: UpsertProductsWebRequest}): Promise<UpsertProductsWebResponse> { return this.makeRequest("upsertProductsWebConfigs", args || {}); }
    setDeliveryFeeFiscalProductGroup(args: {placeId: string, deliveryFeeId: string, fiscalProductGroupId: string}): Promise<void> { return this.makeRequest("setDeliveryFeeFiscalProductGroup", args || {}); }
    removeDeliveryFeeFiscalProductGroup(args: {placeId: string, deliveryFeeId: string}): Promise<void> { return this.makeRequest("removeDeliveryFeeFiscalProductGroup", args || {}); }
    getDeliveryFeeFiscalProductGroupsByPlace(args: {placeId: string}): Promise<DeliveryFeeFiscalProductGroupBinding[]> { return this.makeRequest("getDeliveryFeeFiscalProductGroupsByPlace", args || {}); }
    removeDeviceFromEvent(args: {deviceId: string, eventId: string}): Promise<void> { return this.makeRequest("removeDeviceFromEvent", args || {}); }
    getDeviceEventStatus(args: {eventId: string}): Promise<DeviceEventStatus[]> { return this.makeRequest("getDeviceEventStatus", args || {}); }
    getPlaceDevices(args: {placeId: string}): Promise<DeviceConfig[]> { return this.makeRequest("getPlaceDevices", args || {}); }
    linkDevicesToPlace(args: {placeId: string, smallIds: string[]}): Promise<DeviceConfig[]> { return this.makeRequest("linkDevicesToPlace", args || {}); }
    shouldUpdateDashboardAppVersion(args?: {}): Promise<void> { return this.makeRequest("shouldUpdateDashboardAppVersion", args || {}); }
    createDiscountCategory(args: {discountCategory: CreateDiscountCategoryRequest, employeeIds?: string[] | null}): Promise<DiscountCategoryResponse> { return this.makeRequest("createDiscountCategory", args || {}); }
    getDiscountCategories(args: {placeId: string, pagination: Pagination, filters: DiscountCategoryFilters}): Promise<DiscountCategoriesResponse> { return this.makeRequest("getDiscountCategories", args || {}); }
    updateDiscountCategory(args: {discountCategoryId: string, discountCategory: UpdateDiscountCategoryRequest, employeeIds?: string[] | null}): Promise<DiscountCategoryResponse> { return this.makeRequest("updateDiscountCategory", args || {}); }
    deleteDiscountCategory(args: {discountCategoryId: string}): Promise<DiscountCategoryResponse> { return this.makeRequest("deleteDiscountCategory", args || {}); }
    givePermissionToUseDiscountCategory(args: {employeeIds: string[], discountCategoryId: string}): Promise<void> { return this.makeRequest("givePermissionToUseDiscountCategory", args || {}); }
    removePermissionToUseDiscountCategory(args: {employeeIds: string[], discountCategoryId: string}): Promise<void> { return this.makeRequest("removePermissionToUseDiscountCategory", args || {}); }
    activateDiscountCategoryOnPlaces(args: {placeIds: string[], discountCategoryId: string}): Promise<void> { return this.makeRequest("activateDiscountCategoryOnPlaces", args || {}); }
    disableDiscountCategoryOnPlaces(args: {placeIds: string[], discountCategoryId: string}): Promise<void> { return this.makeRequest("disableDiscountCategoryOnPlaces", args || {}); }
    getEmployeesByDiscountCategory(args: {discountCategoryId: string}): Promise<EmployeesByDiscountCategory[]> { return this.makeRequest("getEmployeesByDiscountCategory", args || {}); }
    getEmployee(args: {employeeId: string}): Promise<Employee> { return this.makeRequest("getEmployee", args || {}); }
    addEmployee(args: {employee: NewEmployee, password?: string | null, image?: ArrayBuffer | null}): Promise<string> { return this.makeRequest("addEmployee", args || {}); }
    editEmployee(args: {id: string, employee: EditEmployee}): Promise<void> { return this.makeRequest("editEmployee", args || {}); }
    editEmployeePassword(args: {id: string, password: string}): Promise<void> { return this.makeRequest("editEmployeePassword", args || {}); }
    editEmployeeImage(args: {id: string, data: ArrayBuffer}): Promise<void> { return this.makeRequest("editEmployeeImage", args || {}); }
    editMultipleEmployees(args: {employeeIds: string[], edition: EditMultipleEmployees}): Promise<void> { return this.makeRequest("editMultipleEmployees", args || {}); }
    removeMultipleEmployees(args: {employeeIds: string[]}): Promise<MultipleEmployeeResult> { return this.makeRequest("removeMultipleEmployees", args || {}); }
    removeEmployee(args: {id: string}): Promise<void> { return this.makeRequest("removeEmployee", args || {}); }
    addZigTagToWaiter(args: {zigCode: string, employeeId: string}): Promise<void> { return this.makeRequest("addZigTagToWaiter", args || {}); }
    getEmployeesV2(args: {filters?: GetEmployeesV2Filters | null}): Promise<EmployeeV2[]> { return this.makeRequest("getEmployeesV2", args || {}); }
    addMultipleEmployees(args: {employee: MultipleEmployees, password?: string | null, image?: ArrayBuffer | null}): Promise<AddMultipleEmployees> { return this.makeRequest("addMultipleEmployees", args || {}); }
    addMultipleEmployeesV2(args: {employees: AddMultipleEmployeesV2Employee[]}): Promise<AddMultipleEmployees> { return this.makeRequest("addMultipleEmployeesV2", args || {}); }
    updateMultipleEmployeeDeviceConfigs(args: {employeeIds: string[], config: EmployeeDeviceConfigsUpdate}): Promise<void> { return this.makeRequest("updateMultipleEmployeeDeviceConfigs", args || {}); }
    duplicateEmployee(args: {employeeId: string, name: string, username: string, password: string}): Promise<string> { return this.makeRequest("duplicateEmployee", args || {}); }
    updateEmployeePassword(args: {token: string, password: string, confirmPassword: string}): Promise<void> { return this.makeRequest("updateEmployeePassword", args || {}); }
    createEntrance(args: {placeId: string, entrance: Entrance, data?: ArrayBuffer | null}): Promise<string> { return this.makeRequest("createEntrance", args || {}); }
    deleteEntrance(args: {id: string}): Promise<void> { return this.makeRequest("deleteEntrance", args || {}); }
    getEntrance(args: {placeId: string, id: string}): Promise<Entrance | null> { return this.makeRequest("getEntrance", args || {}); }
    getAllEntrances(args: {placeId: string}): Promise<Entrance[]> { return this.makeRequest("getAllEntrances", args || {}); }
    editEntrance(args: {placeId: string, entrance: Entrance}): Promise<void> { return this.makeRequest("editEntrance", args || {}); }
    editEntranceImage(args: {entranceId: string, data?: ArrayBuffer | null}): Promise<void> { return this.makeRequest("editEntranceImage", args || {}); }
    entrancesSoldAtPlace(args: {since: Date, until: Date, placeId: string}): Promise<EntranceSold[]> { return this.makeRequest("entrancesSoldAtPlace", args || {}); }
    entrancesSoldAtEvent(args: {eventId: string}): Promise<EntranceSold[]> { return this.makeRequest("entrancesSoldAtEvent", args || {}); }
    entrancesSoldByEmployee(args: {eventId: string}): Promise<Bilheteiro[]> { return this.makeRequest("entrancesSoldByEmployee", args || {}); }
    getEntrancesSoldToUserAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<EntranceUser[]> { return this.makeRequest("getEntrancesSoldToUserAtPlace", args || {}); }
    getEntrancesSoldToUserAtEvent(args: {eventId: string}): Promise<EntranceUser[]> { return this.makeRequest("getEntrancesSoldToUserAtEvent", args || {}); }
    usersEntrancesConsumed(args: {eventId?: string | null, placeId?: string | null, filters: UsersEntrancesConsumedReportFilters, pagination: Pagination}): Promise<UsersEntrancesConsumedReportResponse> { return this.makeRequest("usersEntrancesConsumed", args || {}); }
    usersEntrancesConsumedOverview(args: {eventId?: string | null, placeId?: string | null, filters: UsersEntrancesConsumedReportFilters}): Promise<UsersEntrancesConsumedOverview> { return this.makeRequest("usersEntrancesConsumedOverview", args || {}); }
    getAllEvents(args: {since: Date, until: Date, placeId: string}): Promise<Event[]> { return this.makeRequest("getAllEvents", args || {}); }
    createEvent(args: {details: EventDetails, image?: ArrayBuffer | null, cover?: ArrayBuffer | null}): Promise<string> { return this.makeRequest("createEvent", args || {}); }
    openEvent(args: {id: string, actualizingdatetime: boolean}): Promise<void> { return this.makeRequest("openEvent", args || {}); }
    closeEvent(args: {id: string}): Promise<OpenedReports[]> { return this.makeRequest("closeEvent", args || {}); }
    deleteEvent(args: {id: string}): Promise<void> { return this.makeRequest("deleteEvent", args || {}); }
    getEvent(args: {id: string}): Promise<Event> { return this.makeRequest("getEvent", args || {}); }
    updateEvent(args: {id: string, passTemplateId?: string | null}): Promise<void> { return this.makeRequest("updateEvent", args || {}); }
    getEvents(args: {placeId: string, month: number, year: number}): Promise<EventList> { return this.makeRequest("getEvents", args || {}); }
    getOpenedEventsBaseInfo(args: {placeIds: string[]}): Promise<EventBaseInfo[]> { return this.makeRequest("getOpenedEventsBaseInfo", args || {}); }
    getWithdrawAuthKeys(args: {request: GetWithdrawAuthKeysRequest}): Promise<WithdrawAuthKeyResponse[]> { return this.makeRequest("getWithdrawAuthKeys", args || {}); }
    createWithdrawAuthKeys(args: {request: CreateWithdrawAuthKeyRequest}): Promise<CreateWithdrawAuthKeysResponse> { return this.makeRequest("createWithdrawAuthKeys", args || {}); }
    deleteWithdrawAuthKey(args: {request: DeleteWithdrawAuthKeyRequest}): Promise<DeleteWithdrawAuthKeyResponse> { return this.makeRequest("deleteWithdrawAuthKey", args || {}); }
    unlockWithdrawAuthKey(args: {request: UnlockWithdrawAuthKeyRequest}): Promise<WithdrawAuthKeyResponse> { return this.makeRequest("unlockWithdrawAuthKey", args || {}); }
    requestAuthKeyCode(args: {request: RequestAuthKeyCodeRequest}): Promise<RequestAuthKeyCodeResponse> { return this.makeRequest("requestAuthKeyCode", args || {}); }
    validateAuthKeyCode(args: {request: ValidateAuthKeyCodeRequest}): Promise<ValidateAuthKeyCodeResponse> { return this.makeRequest("validateAuthKeyCode", args || {}); }
    getRequestProRataPercentage(args: {placeId: string, anticipationValue: number}): Promise<number> { return this.makeRequest("getRequestProRataPercentage", args || {}); }
    getMaximumPossibleAnticipationValues(args: {placeId: string}): Promise<MaximumPossibleAnticipationValuesResult> { return this.makeRequest("getMaximumPossibleAnticipationValues", args || {}); }
    transferBalance(args: {fromPlaceId: string, toPlaceId: string, transferValue: number}): Promise<void> { return this.makeRequest("transferBalance", args || {}); }
    isThereAPendingBankslip(args: {placeId: string}): Promise<BankslipInfo> { return this.makeRequest("isThereAPendingBankslip", args || {}); }
    getExtractAdjusts(args: {placeId: string, since: Date, until: Date}): Promise<AdjustResponse[]> { return this.makeRequest("getExtractAdjusts", args || {}); }
    getDebitNotes(args: {placeId: string, since: Date, until: Date}): Promise<DebitNote[]> { return this.makeRequest("getDebitNotes", args || {}); }
    getRentNotes(args: {placeId: string, since: Date, until: Date}): Promise<RentNote[]> { return this.makeRequest("getRentNotes", args || {}); }
    updateWithdrawReceipts(args: {placeId: string, since: Date}): Promise<UpdateWithdrawReceipts> { return this.makeRequest("updateWithdrawReceipts", args || {}); }
    payBillAtEventWithMultiplePayments(args: {userId: string, eventId: string, payments: BillPayment[], reason?: string | null}): Promise<PixCharge | null> { return this.makeRequest("payBillAtEventWithMultiplePayments", args || {}); }
    payBillAtPlaceInPeriodWithMultiplePayments(args: {userId: string, placeId: string, payments: BillPayment[], since: Date, until: Date, reason?: string | null}): Promise<PixCharge | null> { return this.makeRequest("payBillAtPlaceInPeriodWithMultiplePayments", args || {}); }
    payBillsAtEventWithMultiplePayments(args: {userIds: string[], eventId: string, method: PaymentMethod}): Promise<MultipleUserIdsResult> { return this.makeRequest("payBillsAtEventWithMultiplePayments", args || {}); }
    payBillsAtPlaceInPeriodWithMultiplePayments(args: {userIds: string[], placeId: string, since: Date, until: Date, method: PaymentMethod}): Promise<MultipleUserIdsResult> { return this.makeRequest("payBillsAtPlaceInPeriodWithMultiplePayments", args || {}); }
    sendPixEmailToPayBill(args: {pixChargeId: string, userEmail: string}): Promise<void> { return this.makeRequest("sendPixEmailToPayBill", args || {}); }
    sendOpenBillChargeByEmail(args: {userEmail: string, openBillChargeId: string}): Promise<void> { return this.makeRequest("sendOpenBillChargeByEmail", args || {}); }
    getOpenBillChargeDetails(args: {openBillChargeId: string, placeId: string}): Promise<OpenBillChargeDetails> { return this.makeRequest("getOpenBillChargeDetails", args || {}); }
    getOpenBillDetailsByUserInPlace(args: {userId: string, placeId: string, since: Date, until: Date}): Promise<OpenBillChargeDetails> { return this.makeRequest("getOpenBillDetailsByUserInPlace", args || {}); }
    executeLiquidationMotor(args: {placeId: string, vendorId?: string | null}): Promise<void> { return this.makeRequest("executeLiquidationMotor", args || {}); }
    getClientsAtEvent(args: {eventId: string, options: OptionsClientsEvent}): Promise<Client[]> { return this.makeRequest("getClientsAtEvent", args || {}); }
    clientsAtEvent(args: {eventId: string}): Promise<Client[]> { return this.makeRequest("clientsAtEvent", args || {}); }
    clientsAtPlace(args: {since: Date, until: Date, placeId: string}): Promise<Client[]> { return this.makeRequest("clientsAtPlace", args || {}); }
    clientAtPlace(args: {userId: string, placeId: string}): Promise<ClientAtPlace> { return this.makeRequest("clientAtPlace", args || {}); }
    clientTransactionsAtEvent(args: {userId: string, eventId: string}): Promise<UserTransaction[]> { return this.makeRequest("clientTransactionsAtEvent", args || {}); }
    debtorsInEvent(args: {eventId: string}): Promise<Debtor[]> { return this.makeRequest("debtorsInEvent", args || {}); }
    debtorsInPlace(args: {placeId: string, since: Date, until: Date}): Promise<Debtor[]> { return this.makeRequest("debtorsInPlace", args || {}); }
    debtorsInEventV2(args: {eventId: string, pagination: Pagination, filters: DebtorsFilters}): Promise<PaginatedDebtorsResponse> { return this.makeRequest("debtorsInEventV2", args || {}); }
    debtorsInPlaceV2(args: {placeId: string, since: Date, until: Date, pagination: Pagination, filters: DebtorsFilters}): Promise<PaginatedDebtorsResponse> { return this.makeRequest("debtorsInPlaceV2", args || {}); }
    getDebtorsXls(args: {input: DebtorsXlsInput}): Promise<string> { return this.makeRequest("getDebtorsXls", args || {}); }
    getBonusReport(args: {input: BonusReportInput}): Promise<BonusReportResponse> { return this.makeRequest("getBonusReport", args || {}); }
    getBonusReportForPlace(args: {input: BonusReportForPlaceInput}): Promise<BonusReportResponse> { return this.makeRequest("getBonusReportForPlace", args || {}); }
    getBonusReportForPlaceOverview(args: {input: BonusReportForPlaceOverviewInput}): Promise<BonusReportOverview> { return this.makeRequest("getBonusReportForPlaceOverview", args || {}); }
    getBonusReportOverview(args: {input: BonusReportOverviewInput}): Promise<BonusReportOverview> { return this.makeRequest("getBonusReportOverview", args || {}); }
    getBonusReportXls(args: {input: BonusReportXlsInput}): Promise<string> { return this.makeRequest("getBonusReportXls", args || {}); }
    getBonusReportSummary(args: {placeId: string, period?: PeriodTime | null, eventId?: string | null}): Promise<BonusReportSummary> { return this.makeRequest("getBonusReportSummary", args || {}); }
    getMinimumConsumptionReport(args: {eventId: string}): Promise<MinimumConsumptionReport[]> { return this.makeRequest("getMinimumConsumptionReport", args || {}); }
    getMinimumConsumptionReportForPlace(args: {placeId: string, since: Date, until: Date}): Promise<MinimumConsumptionReport[]> { return this.makeRequest("getMinimumConsumptionReportForPlace", args || {}); }
    getUsedBonusReport(args: {eventId: string}): Promise<UsedBonusReport[]> { return this.makeRequest("getUsedBonusReport", args || {}); }
    getUsedBonusReportForPlace(args: {placeId: string, since: Date, until: Date}): Promise<UsedBonusReport[]> { return this.makeRequest("getUsedBonusReportForPlace", args || {}); }
    getClientDetails(args: {clientId: string}): Promise<ClientDetails> { return this.makeRequest("getClientDetails", args || {}); }
    editClient(args: {clientId: string, name: string, phone: string}): Promise<void> { return this.makeRequest("editClient", args || {}); }
    getBonusByProduct(args: {eventId: string}): Promise<BonusByProduct[]> { return this.makeRequest("getBonusByProduct", args || {}); }
    getBonusByProductAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<BonusByProduct[]> { return this.makeRequest("getBonusByProductAtPlace", args || {}); }
    getOpenedBillsProduct(args: {eventId: string}): Promise<OpenedProduct[]> { return this.makeRequest("getOpenedBillsProduct", args || {}); }
    getOpenedBillsProductAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<OpenedProduct[]> { return this.makeRequest("getOpenedBillsProductAtPlace", args || {}); }
    getRechargeConsumptions(args: {eventId: string}): Promise<RechargeConsumption[]> { return this.makeRequest("getRechargeConsumptions", args || {}); }
    getRefundedRechargesAtEvent(args: {eventId: string}): Promise<RefundedRecharge[]> { return this.makeRequest("getRefundedRechargesAtEvent", args || {}); }
    getCardActivationReturnReportAtEvent(args: {eventId: string}): Promise<ActivationReturnReport> { return this.makeRequest("getCardActivationReturnReportAtEvent", args || {}); }
    getPromotionsUsedAtEvent(args: {eventId: string}): Promise<UsedPromotion[]> { return this.makeRequest("getPromotionsUsedAtEvent", args || {}); }
    getPromotionsUsedAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<UsedPromotion[]> { return this.makeRequest("getPromotionsUsedAtPlace", args || {}); }
    getUserPromotionsUsedAtEvent(args: {eventId: string}): Promise<UserUsedPromotion[]> { return this.makeRequest("getUserPromotionsUsedAtEvent", args || {}); }
    getUserPromotionsUsedAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<UserUsedPromotion[]> { return this.makeRequest("getUserPromotionsUsedAtPlace", args || {}); }
    getTablePromotionsUsed(args: {filterScope: FilterScope, pagination: Pagination, filters?: TablePromotionsUsedFilters | null}): Promise<TotalTablePromotionReport> { return this.makeRequest("getTablePromotionsUsed", args || {}); }
    exportTablePromotionsUsedXlsl(args: {filterScope: FilterScope, filters?: TablePromotionsUsedFilters | null}): Promise<string> { return this.makeRequest("exportTablePromotionsUsedXlsl", args || {}); }
    getTableUsedPromotionsInScope(args: {filterScope: FilterScope}): Promise<UsedPromotionsInScope[]> { return this.makeRequest("getTableUsedPromotionsInScope", args || {}); }
    getEntrancesSoldByEmployeeAtEvent(args: {eventId: string}): Promise<SoldEntranceWithEmployee[]> { return this.makeRequest("getEntrancesSoldByEmployeeAtEvent", args || {}); }
    getEntrancesSoldByEmployeeAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<SoldEntranceWithEmployee[]> { return this.makeRequest("getEntrancesSoldByEmployeeAtPlace", args || {}); }
    getRefundedProductsAtEvent(args: {eventId: string}): Promise<RefundedProduct[]> { return this.makeRequest("getRefundedProductsAtEvent", args || {}); }
    getRefundedProductsAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<RefundedProduct[]> { return this.makeRequest("getRefundedProductsAtPlace", args || {}); }
    getTipsRemovedAtEvent(args: {eventId: string}): Promise<TipRemovedList[]> { return this.makeRequest("getTipsRemovedAtEvent", args || {}); }
    getTipsRemovedAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<TipRemovedList[]> { return this.makeRequest("getTipsRemovedAtPlace", args || {}); }
    getCardActivationReturnReportByEmployeeAtEvent(args: {eventId: string}): Promise<CardReturnEmployee[]> { return this.makeRequest("getCardActivationReturnReportByEmployeeAtEvent", args || {}); }
    getCardActivationReturnReportByEmployeeAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<CardReturnEmployee[]> { return this.makeRequest("getCardActivationReturnReportByEmployeeAtPlace", args || {}); }
    getDiscountsAtEventByEmployee(args: {eventId: string}): Promise<DiscountEmployee[]> { return this.makeRequest("getDiscountsAtEventByEmployee", args || {}); }
    getDiscountsAtPlaceByEmployee(args: {placeId: string, since: Date, until: Date}): Promise<DiscountEmployee[]> { return this.makeRequest("getDiscountsAtPlaceByEmployee", args || {}); }
    getPostLimitChangesAtEvent(args: {eventId: string}): Promise<PostLimitChange[]> { return this.makeRequest("getPostLimitChangesAtEvent", args || {}); }
    getPostLimitChanges(args: {placeId: string, since: Date, until: Date}): Promise<PostLimitChange[]> { return this.makeRequest("getPostLimitChanges", args || {}); }
    emitInnovaroGeneralInvoices(args: {eventId: string}): Promise<void> { return this.makeRequest("emitInnovaroGeneralInvoices", args || {}); }
    getOpenedBillPayments(args: {eventId: string}): Promise<OpenedBillPayment[]> { return this.makeRequest("getOpenedBillPayments", args || {}); }
    getOpenedBillPaymentsAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<OpenedBillPayment[]> { return this.makeRequest("getOpenedBillPaymentsAtPlace", args || {}); }
    getOpenedBillPaymentsV2(args: {eventId: string}): Promise<OpenedBillPaymentV2[]> { return this.makeRequest("getOpenedBillPaymentsV2", args || {}); }
    getOpenedBillPaymentsAtPlaceV2(args: {placeId: string, since: Date, until: Date}): Promise<OpenedBillPaymentV2[]> { return this.makeRequest("getOpenedBillPaymentsAtPlaceV2", args || {}); }
    getOpenedBillPaymentsV3(args: {eventId: string, pagination: Pagination, filters: OpenedBillPaymentsFilters}): Promise<PaginatedOpenedBillPaymentsResponse> { return this.makeRequest("getOpenedBillPaymentsV3", args || {}); }
    getOpenedBillPaymentsAtPlaceV3(args: {placeId: string, since: Date, until: Date, pagination: Pagination, filters: OpenedBillPaymentsFilters}): Promise<PaginatedOpenedBillPaymentsResponse> { return this.makeRequest("getOpenedBillPaymentsAtPlaceV3", args || {}); }
    getOpenedBillReportOverview(args: {scope: GetReportByScope}): Promise<OpenedBillReportOverview> { return this.makeRequest("getOpenedBillReportOverview", args || {}); }
    getOpenedBillPaymentsXls(args: {input: OpenedBillPaymentsXlsInput}): Promise<string> { return this.makeRequest("getOpenedBillPaymentsXls", args || {}); }
    getRappiDiscountsAtEvent(args: {eventId: string}): Promise<RappiDiscount[]> { return this.makeRequest("getRappiDiscountsAtEvent", args || {}); }
    getRappiDiscountsAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<RappiDiscount[]> { return this.makeRequest("getRappiDiscountsAtPlace", args || {}); }
    getConsumptionObligationReportAtEvent(args: {eventId: string}): Promise<ConsumptionObligationReport[]> { return this.makeRequest("getConsumptionObligationReportAtEvent", args || {}); }
    getConsumptionObligationReportAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<ConsumptionObligationReport[]> { return this.makeRequest("getConsumptionObligationReportAtPlace", args || {}); }
    getAllMoneyOperationsAtEvent(args: {eventId: string}): Promise<MoneyOperation[]> { return this.makeRequest("getAllMoneyOperationsAtEvent", args || {}); }
    getAllMoneyOperations(args: {placeId: string, since: Date, until: Date}): Promise<MoneyOperation[]> { return this.makeRequest("getAllMoneyOperations", args || {}); }
    getAllTransactionsAfterEventClosing(args: {eventId: string, filters: FilterReportAfterEventClosing[]}): Promise<ReportAfterEventClosing[]> { return this.makeRequest("getAllTransactionsAfterEventClosing", args || {}); }
    getZigDeviceSyncForcesAtEvent(args: {eventId: string, pagination?: Pagination | null}): Promise<GetZigDeviceSyncForcesAtEvent> { return this.makeRequest("getZigDeviceSyncForcesAtEvent", args || {}); }
    getCashRechargeConsumptionsAtEvent(args: {eventId: string, pagination?: Pagination | null}): Promise<RechargeConsumptionByAuthorPaginated> { return this.makeRequest("getCashRechargeConsumptionsAtEvent", args || {}); }
    getPixRechargeConsumptionsAtEvent(args: {eventId: string, pagination?: Pagination | null}): Promise<RechargeConsumptionByAuthorPaginated> { return this.makeRequest("getPixRechargeConsumptionsAtEvent", args || {}); }
    getRescueRechargeConsumptionsAtEvent(args: {eventId: string, pagination?: Pagination | null}): Promise<GetRescueRechargeConsumptionsAtEvent> { return this.makeRequest("getRescueRechargeConsumptionsAtEvent", args || {}); }
    getAuthorRechargeConsumptionsDetailsAtEvent(args: {authorId: string, eventId: string}): Promise<RechargeConsumptionFromAuthor[]> { return this.makeRequest("getAuthorRechargeConsumptionsDetailsAtEvent", args || {}); }
    getRescueRechargeConsumptionsDetailsAtEvent(args: {eventId: string}): Promise<RechargeConsumptionFromAuthor[]> { return this.makeRequest("getRescueRechargeConsumptionsDetailsAtEvent", args || {}); }
    getTotemTransactions(args: {placeId: string, since: Date, until: Date, pagination: Pagination, filters: TotemTransactionFilters}): Promise<TotemTransactionResponse> { return this.makeRequest("getTotemTransactions", args || {}); }
    getTotemTransactionTotalizer(args: {placeId: string, since: Date, until: Date}): Promise<TotemTransactionTotalizerResponse> { return this.makeRequest("getTotemTransactionTotalizer", args || {}); }
    getAppTransactionsAtEvent(args: {eventId: string, pagination: Pagination, filters: AppTransactionsFilters}): Promise<AppTransactionDetailsPaginationResponse> { return this.makeRequest("getAppTransactionsAtEvent", args || {}); }
    getAppTransactionsAtPlace(args: {placeId: string, since: Date, until: Date, pagination: Pagination, filters: AppTransactionsFilters}): Promise<AppTransactionDetailsPaginationResponse> { return this.makeRequest("getAppTransactionsAtPlace", args || {}); }
    getAppTotalizerByPlace(args: {placeId: string, since: Date, until: Date}): Promise<AppTransactionsTotalizer> { return this.makeRequest("getAppTotalizerByPlace", args || {}); }
    getAppTotalizerByEvent(args: {eventId: string}): Promise<AppTransactionsTotalizer> { return this.makeRequest("getAppTotalizerByEvent", args || {}); }
    createOpenBillChargeByPlace(args: {placeId: string, since: Date, until: Date, userId: string, shouldChargeTip: boolean}): Promise<OpenBillCharge> { return this.makeRequest("createOpenBillChargeByPlace", args || {}); }
    getTransactionTransfersAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<TransactionTransfer[]> { return this.makeRequest("getTransactionTransfersAtPlace", args || {}); }
    getTransactionTransfersAtEvent(args: {eventId: string}): Promise<TransactionTransfer[]> { return this.makeRequest("getTransactionTransfersAtEvent", args || {}); }
    getTransactionTransfersXlsx(args: {scope: GetReportByScope}): Promise<string> { return this.makeRequest("getTransactionTransfersXlsx", args || {}); }
    getRechargeValueTransacted(args: {eventIds: string[]}): Promise<number> { return this.makeRequest("getRechargeValueTransacted", args || {}); }
    getTotalTransactionsByEvents(args: {placeId: string, date: PeriodTime}): Promise<number> { return this.makeRequest("getTotalTransactionsByEvents", args || {}); }
    getAllPlaceSales(args: {placeId: string, period: PeriodTime, filters: SalesDetailsFilters, pagination: Pagination}): Promise<AllSalesPaginationResponse | null> { return this.makeRequest("getAllPlaceSales", args || {}); }
    getAllPlaceSalesInEvent(args: {placeId: string, eventId: string, filters: SalesDetailsFilters, pagination: Pagination}): Promise<AllSalesPaginationResponse | null> { return this.makeRequest("getAllPlaceSalesInEvent", args || {}); }
    getAllPlaceSalesSummary(args: {placeId: string, period: PeriodTime, filters: SalesFilters}): Promise<AllSalesSummaryResponse | null> { return this.makeRequest("getAllPlaceSalesSummary", args || {}); }
    getAllPlaceSalesSummaryInEvent(args: {placeId: string, eventId: string, filters: SalesFilters}): Promise<AllSalesSummaryResponse | null> { return this.makeRequest("getAllPlaceSalesSummaryInEvent", args || {}); }
    getAllPlaceSalesXls(args: {placeId: string, period: PeriodTime, filters: SalesFilters}): Promise<string> { return this.makeRequest("getAllPlaceSalesXls", args || {}); }
    getAllPlaceSalesInEventXls(args: {placeId: string, eventId: string, filters: SalesFilters}): Promise<string> { return this.makeRequest("getAllPlaceSalesInEventXls", args || {}); }
    getResumeForEventInSections(args: {eventId: string}): Promise<EventResumeSection[]> { return this.makeRequest("getResumeForEventInSections", args || {}); }
    getResumeForPlaceInSections(args: {placeId: string, from: Date, until: Date}): Promise<EventResumeSection[]> { return this.makeRequest("getResumeForPlaceInSections", args || {}); }
    getClosingReportsByPlace(args: {placeIds: string[], since: Date, until: Date}): Promise<PlaceReport[]> { return this.makeRequest("getClosingReportsByPlace", args || {}); }
    getEntranceResumeForEventInSections(args: {eventId: string}): Promise<EventResumeSection[]> { return this.makeRequest("getEntranceResumeForEventInSections", args || {}); }
    getEntranceResumeForPlaceInSections(args: {placeId: string, since: Date, until: Date}): Promise<EventResumeSection[]> { return this.makeRequest("getEntranceResumeForPlaceInSections", args || {}); }
    getClosingResumeReportForEventInSections(args: {eventId: string}): Promise<EventResumeSection[]> { return this.makeRequest("getClosingResumeReportForEventInSections", args || {}); }
    getClosingResumeReportForPlaceInSections(args: {placeId: string, since: Date, until: Date}): Promise<EventResumeSection[]> { return this.makeRequest("getClosingResumeReportForPlaceInSections", args || {}); }
    createFinancialClosingReportMap(args: {data: CreateFinancialClosingReportMapInput}): Promise<FinancialClosingReportMapItem> { return this.makeRequest("createFinancialClosingReportMap", args || {}); }
    updateFinancialClosingReportMap(args: {id: string, data: UpdateFinancialClosingReportMapInput}): Promise<FinancialClosingReportMapItem> { return this.makeRequest("updateFinancialClosingReportMap", args || {}); }
    deleteFinancialClosingReportMap(args: {id: string}): Promise<boolean> { return this.makeRequest("deleteFinancialClosingReportMap", args || {}); }
    getCouvertFiscalDataForPlaces(args?: {}): Promise<ProductFiscalDataWithPlaceInfo[]> { return this.makeRequest("getCouvertFiscalDataForPlaces", args || {}); }
    setCouvertFiscalData(args: {placeId: string, data: ProductFiscalData}): Promise<void> { return this.makeRequest("setCouvertFiscalData", args || {}); }
    getCouvertFiscalData(args: {placeId: string}): Promise<CouvertFiscalDataForPlace | null> { return this.makeRequest("getCouvertFiscalData", args || {}); }
    isNcmValid(args: {ncm: string}): Promise<boolean> { return this.makeRequest("isNcmValid", args || {}); }
    getInvoicePrintout(args: {invoiceId: string}): Promise<ArrayBuffer[]> { return this.makeRequest("getInvoicePrintout", args || {}); }
    issueInvoicesForUser(args: {eventId: string, userId: string}): Promise<IssueResult> { return this.makeRequest("issueInvoicesForUser", args || {}); }
    emitAllInvoicesInMonth(args: {placeId: string}): Promise<SimpleIssueResult> { return this.makeRequest("emitAllInvoicesInMonth", args || {}); }
    issueInvoicesOfTransactions(args: {eventId: string, transactionIds: string[], cpf?: string | null, cnpj?: string | null, nif?: string | null}): Promise<IssueResult> { return this.makeRequest("issueInvoicesOfTransactions", args || {}); }
    issueInvoicesOfTransactionsWithConsumptionObligation(args: {eventId: string, transactionIds: string[], cpf?: string | null, cnpj?: string | null, nif?: string | null, obligations: ObligationPaymentsForInvoice[], recipientExtraInfo?: RecipientExtraInfo | null}): Promise<IssueResult> { return this.makeRequest("issueInvoicesOfTransactionsWithConsumptionObligation", args || {}); }
    getInvoicesBySearchValue(args: {searchValue: string, country: GetInvoicesBySearchValueCountry}): Promise<MinimalInvoiceWithEvent[]> { return this.makeRequest("getInvoicesBySearchValue", args || {}); }
    getInvoices(args: {eventId: string}): Promise<Invoice[]> { return this.makeRequest("getInvoices", args || {}); }
    getInvoicesFromUser(args: {eventId: string, userId: string}): Promise<Invoice[]> { return this.makeRequest("getInvoicesFromUser", args || {}); }
    getInvoicesFromUserAtPlace(args: {placeId: string, userId: string, since: Date, until: Date}): Promise<InvoiceWithEvent[]> { return this.makeRequest("getInvoicesFromUserAtPlace", args || {}); }
    hasPendingInvoices(args: {eventId: string, userId: string}): Promise<boolean> { return this.makeRequest("hasPendingInvoices", args || {}); }
    sendInvoicesByEmail(args: {invoiceIds: string[], email?: string | null}): Promise<void> { return this.makeRequest("sendInvoicesByEmail", args || {}); }
    hasPrinter(args: {invoiceId: string}): Promise<boolean> { return this.makeRequest("hasPrinter", args || {}); }
    getFiscalProfile(args: {fiscalProfileId: string}): Promise<FiscalProfile> { return this.makeRequest("getFiscalProfile", args || {}); }
    getFiscalProfiles(args?: {}): Promise<FiscalProfile[]> { return this.makeRequest("getFiscalProfiles", args || {}); }
    getFiscalProfilesAtPlace(args: {placeId: string}): Promise<FiscalProfile[]> { return this.makeRequest("getFiscalProfilesAtPlace", args || {}); }
    createFiscalProfile(args: {fiscalProfile: FiscalProfile}): Promise<FiscalProfile> { return this.makeRequest("createFiscalProfile", args || {}); }
    updateFiscalProfile(args: {fiscalProfile: FiscalProfile}): Promise<FiscalProfile> { return this.makeRequest("updateFiscalProfile", args || {}); }
    deleteFiscalProfile(args: {id: string}): Promise<void> { return this.makeRequest("deleteFiscalProfile", args || {}); }
    listFiscalProfilesPending(args?: {}): Promise<FiscalProfileDraft[]> { return this.makeRequest("listFiscalProfilesPending", args || {}); }
    listFiscalProfileDraftHistory(args: {parentId: string}): Promise<FiscalProfileDraft[]> { return this.makeRequest("listFiscalProfileDraftHistory", args || {}); }
    getFiscalProfileWithPendingDraft(args: {parentId: string}): Promise<FiscalProfileWithPendingDraft> { return this.makeRequest("getFiscalProfileWithPendingDraft", args || {}); }
    approveFiscalProfileDraft(args: {draftId: string}): Promise<FiscalProfile> { return this.makeRequest("approveFiscalProfileDraft", args || {}); }
    rejectFiscalProfileDraft(args: {draftId: string}): Promise<void> { return this.makeRequest("rejectFiscalProfileDraft", args || {}); }
    getFiscalProfileActivePlaces(args: {fiscalProfileId: string}): Promise<string[] | null> { return this.makeRequest("getFiscalProfileActivePlaces", args || {}); }
    setFiscalProfileActivePlaces(args: {fiscalProfileId: string, placeIds?: string[] | null}): Promise<void> { return this.makeRequest("setFiscalProfileActivePlaces", args || {}); }
    getFiscalProductGroupActivePlaces(args: {fiscalProductGroupId: string}): Promise<string[] | null> { return this.makeRequest("getFiscalProductGroupActivePlaces", args || {}); }
    setFiscalProductGroupActivePlaces(args: {fiscalProductGroupId: string, placeIds?: string[] | null}): Promise<void> { return this.makeRequest("setFiscalProductGroupActivePlaces", args || {}); }
    getFiscalProductGroup(args: {fiscalProductGroupId: string}): Promise<FiscalProductGroup> { return this.makeRequest("getFiscalProductGroup", args || {}); }
    getFiscalProductGroups(args?: {}): Promise<FiscalProductGroup[]> { return this.makeRequest("getFiscalProductGroups", args || {}); }
    getFiscalProductGroupsAtPlace(args: {placeId: string}): Promise<FiscalProductGroup[]> { return this.makeRequest("getFiscalProductGroupsAtPlace", args || {}); }
    createFiscalProductGroup(args: {fiscalProductGroup: FiscalProductGroup}): Promise<FiscalProductGroup> { return this.makeRequest("createFiscalProductGroup", args || {}); }
    updateFiscalProductGroup(args: {fiscalProductGroup: FiscalProductGroup}): Promise<FiscalProductGroup> { return this.makeRequest("updateFiscalProductGroup", args || {}); }
    deleteFiscalProductGroup(args: {id: string}): Promise<void> { return this.makeRequest("deleteFiscalProductGroup", args || {}); }
    listFiscalProductGroupsPending(args?: {}): Promise<FiscalProductGroupDraft[]> { return this.makeRequest("listFiscalProductGroupsPending", args || {}); }
    listFiscalProductGroupDraftHistory(args: {parentId: string}): Promise<FiscalProductGroupDraft[]> { return this.makeRequest("listFiscalProductGroupDraftHistory", args || {}); }
    getFiscalProductGroupWithPendingDraft(args: {parentId: string}): Promise<FiscalProductGroupWithPendingDraft> { return this.makeRequest("getFiscalProductGroupWithPendingDraft", args || {}); }
    approveFiscalProductGroupDraft(args: {draftId: string}): Promise<FiscalProductGroup> { return this.makeRequest("approveFiscalProductGroupDraft", args || {}); }
    rejectFiscalProductGroupDraft(args: {draftId: string}): Promise<void> { return this.makeRequest("rejectFiscalProductGroupDraft", args || {}); }
    getFiscalInvoices(args: {placeId: string, fiscalProfileId: string, since: Date, until: Date}): Promise<Invoice[]> { return this.makeRequest("getFiscalInvoices", args || {}); }
    getFiscalInvoicesV2(args: {placeId: string, since: Date, until: Date, pagination: Pagination, filterOptions?: InvoicesV2Filter | null}): Promise<InvoicesV2PaginationResponse> { return this.makeRequest("getFiscalInvoicesV2", args || {}); }
    getNationalFiscalInvoices(args: {placeId: string, filters: NationalFiscalInvoiceFilter, pagination: Pagination}): Promise<NationalFiscalInvoiceResponse> { return this.makeRequest("getNationalFiscalInvoices", args || {}); }
    getNationalFiscalInvoicesXlsx(args: {placeId: string, filters: NationalFiscalInvoiceFilter}): Promise<string> { return this.makeRequest("getNationalFiscalInvoicesXlsx", args || {}); }
    getNationalFiscalInvoicesZip(args: {placeId: string, filters: NationalFiscalInvoiceFilter}): Promise<string> { return this.makeRequest("getNationalFiscalInvoicesZip", args || {}); }
    getInvoice(args: {id: string}): Promise<Invoice> { return this.makeRequest("getInvoice", args || {}); }
    getZippedInvoices(args: {placeId: string, fiscalProfileId: string, since: Date, until: Date, sendToEmail?: string | null}): Promise<string | null> { return this.makeRequest("getZippedInvoices", args || {}); }
    getNotEmmitedTransactionsFromEvent(args: {eventId: string, userId: string}): Promise<NotEmmitedTransaction[]> { return this.makeRequest("getNotEmmitedTransactionsFromEvent", args || {}); }
    getNotEmmitedConsumptionObligationsFromEvent(args: {eventId: string, userId: string}): Promise<number> { return this.makeRequest("getNotEmmitedConsumptionObligationsFromEvent", args || {}); }
    issueManualInvoice(args: {eventId: string, manualRequest: ManualRequest, cpf?: string | null, cnpj?: string | null, nif?: string | null}): Promise<IssueResult> { return this.makeRequest("issueManualInvoice", args || {}); }
    issueManualInvoiceForReserve(args: {eventId: string, manualRequest: ManualRequest, cpf?: string | null, cnpj?: string | null, nif?: string | null, reserveId: string}): Promise<IssueResult[]> { return this.makeRequest("issueManualInvoiceForReserve", args || {}); }
    getReportNotIssuedWithErrorXlsx(args: {placeId: string, since: Date, until: Date}): Promise<string> { return this.makeRequest("getReportNotIssuedWithErrorXlsx", args || {}); }
    getNotIssuedWithError(args: {placeId: string, since: Date, until: Date, currentPage: number}): Promise<NotIssuedWithErrorResponse> { return this.makeRequest("getNotIssuedWithError", args || {}); }
    getInvoiceIssuedByPerfilFiscal(args: {placeId: string, since: Date, until: Date}): Promise<InvoiceIssuedByPerfilFiscal[]> { return this.makeRequest("getInvoiceIssuedByPerfilFiscal", args || {}); }
    getInvoiceIssuedByMode(args: {placeId: string, since: Date, until: Date}): Promise<InvoiceIssuedByMode> { return this.makeRequest("getInvoiceIssuedByMode", args || {}); }
    getFiscalSumupSections(args: {placeId: string, since: Date, until: Date}): Promise<EventResumeSection[]> { return this.makeRequest("getFiscalSumupSections", args || {}); }
    getReportFiscal(args: {placeId: string, fiscalProfileIds: string[], since: Date, until: Date}): Promise<ReportFiscal[]> { return this.makeRequest("getReportFiscal", args || {}); }
    getReportFiscalXlsx(args: {placeId: string, fiscalProfileIds: string[], since: Date, until: Date}): Promise<string> { return this.makeRequest("getReportFiscalXlsx", args || {}); }
    getUnusedInvoices(args: {fiscalProfileId: string, since: Date, until: Date, placeId: string}): Promise<UnusedInvoice[]> { return this.makeRequest("getUnusedInvoices", args || {}); }
    getPendingInvoicesInternational(args: {timePeriod: PeriodTime, placeId: string, pagination: Pagination, filterOptions?: PendingInvoicesFilter | null}): Promise<PendingInvoicesPaginatedResponse> { return this.makeRequest("getPendingInvoicesInternational", args || {}); }
    getTotalPendingAutoissuanceOrders(args: {timePeriod: PeriodTime, placeId: string, filterOptions?: PendingInvoicesFilter | null}): Promise<number> { return this.makeRequest("getTotalPendingAutoissuanceOrders", args || {}); }
    getZippedUnusedInvoices(args: {fiscalProfileId: string, since: Date, until: Date}): Promise<string> { return this.makeRequest("getZippedUnusedInvoices", args || {}); }
    getAllTransactionsWithInvoices(args: {placeId: string, since: Date, until: Date, isIssued?: boolean | null}): Promise<TransactionProductWithInvoice[]> { return this.makeRequest("getAllTransactionsWithInvoices", args || {}); }
    getAllRechargesWithInvoicesByEvents(args: {eventIds: string[], pagination: Pagination, filterOptions?: RechargeWithInvoiceFilter | null}): Promise<RechargeWithInvoicePaginatedResponse> { return this.makeRequest("getAllRechargesWithInvoicesByEvents", args || {}); }
    getRechargesInvoicesEmittedValue(args: {eventIds: string[]}): Promise<number> { return this.makeRequest("getRechargesInvoicesEmittedValue", args || {}); }
    getRechargesInvoicesEmittedNetValue(args: {eventIds: string[]}): Promise<number> { return this.makeRequest("getRechargesInvoicesEmittedNetValue", args || {}); }
    getRechargesInvoicesXlsx(args: {eventIds: string[], filterOptions?: RechargeWithInvoiceFilter | null}): Promise<string> { return this.makeRequest("getRechargesInvoicesXlsx", args || {}); }
    getEmittedValue(args: {placeId: string, since: Date, until: Date}): Promise<number> { return this.makeRequest("getEmittedValue", args || {}); }
    getIvaVendusEmittedNetValueForTransactions(args: {placeId: string, since: Date, until: Date}): Promise<number> { return this.makeRequest("getIvaVendusEmittedNetValueForTransactions", args || {}); }
    getEmittedValueByBar(args: {placeId: string, date: PeriodTime}): Promise<BarEmittedValue[]> { return this.makeRequest("getEmittedValueByBar", args || {}); }
    getEmittedValueByPaymentMethod(args: {placeId: string, period: PeriodTime}): Promise<EmittedValueByPaymentType[]> { return this.makeRequest("getEmittedValueByPaymentMethod", args || {}); }
    getEmittedValueByFiscalProfile(args: {placeId: string, since: Date, until: Date}): Promise<FiscalProfileEmittedValue[]> { return this.makeRequest("getEmittedValueByFiscalProfile", args || {}); }
    getEmittedValueByEmployee(args: {placeId: string, dateFilter: PeriodTime}): Promise<EmployeeEmittedValue[]> { return this.makeRequest("getEmittedValueByEmployee", args || {}); }
    getEmittedValueReport(args: {placeId: string, since: Date, until: Date}): Promise<GenericValueForReport[]> { return this.makeRequest("getEmittedValueReport", args || {}); }
    findInvoices(args: {placeId: string, since: Date, until: Date, num: number}): Promise<SearchInvoice[]> { return this.makeRequest("findInvoices", args || {}); }
    getNotEmittedProduct(args: {placeId: string, since: Date, until: Date}): Promise<NotEmittedProduct[]> { return this.makeRequest("getNotEmittedProduct", args || {}); }
    getLastEmissionDetails(args: {placeId: string, since: Date, until: Date, errorMessage: string}): Promise<LastEmissionDetails> { return this.makeRequest("getLastEmissionDetails", args || {}); }
    cancelInvoice(args: {invoiceId: string}): Promise<void> { return this.makeRequest("cancelInvoice", args || {}); }
    getReportInvoiceFiscalProductGroups(args: {placeId: string, since: Date, until: Date}): Promise<InvoiceFiscalProductGroup[]> { return this.makeRequest("getReportInvoiceFiscalProductGroups", args || {}); }
    testEmissionForProduct(args: {placeId: string, productId: string}): Promise<void> { return this.makeRequest("testEmissionForProduct", args || {}); }
    testEmissionForProducts(args: {placeId: string, productIds: string[]}): Promise<void> { return this.makeRequest("testEmissionForProducts", args || {}); }
    importNCMCEST(args: {file: ArrayBuffer, options: ImportCESTNCMConfig}): Promise<ResumeImportCest> { return this.makeRequest("importNCMCEST", args || {}); }
    getCESTbyNCM(args: {ncmId: string}): Promise<CEST[]> { return this.makeRequest("getCESTbyNCM", args || {}); }
    getNifData(args: {nif: string}): Promise<NifData | null> { return this.makeRequest("getNifData", args || {}); }
    getConsumptionObligationConfigForPlace(args: {placeId: string}): Promise<PlaceConsumptionObligationConfig> { return this.makeRequest("getConsumptionObligationConfigForPlace", args || {}); }
    getConsumptionObligationConfigForPlaces(args?: {}): Promise<PlaceConsumptionObligationConfig[]> { return this.makeRequest("getConsumptionObligationConfigForPlaces", args || {}); }
    setConsumptionObligationConfigForPlace(args: {placeId: string, config?: ConsumptionObligationConfig | null}): Promise<PlaceConsumptionObligationConfig> { return this.makeRequest("setConsumptionObligationConfigForPlace", args || {}); }
    getPlacesRechargeFiscalConfigsByEmployee(args?: {}): Promise<PlaceRechargeFiscalConfig[]> { return this.makeRequest("getPlacesRechargeFiscalConfigsByEmployee", args || {}); }
    setRechargeFiscalConfigForPlace(args: {placeId: string, config?: RechargeFiscalConfigPayload | null}): Promise<PlaceRechargeFiscalConfig> { return this.makeRequest("setRechargeFiscalConfigForPlace", args || {}); }
    getEmployeesFromInvoicesByDateRange(args: {placeId: string, period: PeriodTime}): Promise<EmployeeWithIssuedInvoices[]> { return this.makeRequest("getEmployeesFromInvoicesByDateRange", args || {}); }
    issueInvoicesWithSelectedProducts(args: {eventId: string, selectableInvoiceRequest: SelectableInvoiceRequest}): Promise<IssueResult> { return this.makeRequest("issueInvoicesWithSelectedProducts", args || {}); }
    getInsights(args?: {}): Promise<Insight[]> { return this.makeRequest("getInsights", args || {}); }
    reactToInsight(args: {insightId: string, reaction?: InsightReaction | null}): Promise<void> { return this.makeRequest("reactToInsight", args || {}); }
    createInventory(args: {placeId: string, storageIds: string[], newInventory: NewInventory}): Promise<Inventory> { return this.makeRequest("createInventory", args || {}); }
    cancelInventory(args: {inventoryId: string}): Promise<void> { return this.makeRequest("cancelInventory", args || {}); }
    addStorageToInventory(args: {inventoryId: string, storageIds: string[]}): Promise<Inventory> { return this.makeRequest("addStorageToInventory", args || {}); }
    getInventories(args: {placeId: string, since: Date, until: Date}): Promise<Inventory[]> { return this.makeRequest("getInventories", args || {}); }
    getOpenedInventories(args: {placeId: string}): Promise<Inventory[]> { return this.makeRequest("getOpenedInventories", args || {}); }
    closeInventory(args: {inventoryId: string}): Promise<void> { return this.makeRequest("closeInventory", args || {}); }
    getInventoryProductsAtStorage(args: {inventoryId: string, storageId: string}): Promise<InventoryProduct[]> { return this.makeRequest("getInventoryProductsAtStorage", args || {}); }
    getInventoryProducts(args: {inventoryId: string}): Promise<InventoryProduct[]> { return this.makeRequest("getInventoryProducts", args || {}); }
    updateInventoryProduct(args: {inventoryId: string, products: NewInventoryProduct[]}): Promise<InventoryProduct[]> { return this.makeRequest("updateInventoryProduct", args || {}); }
    getPublic(args: {eventId: string}): Promise<Public> { return this.makeRequest("getPublic", args || {}); }
    getNewPublic(args: {eventId: string}): Promise<NewPublic> { return this.makeRequest("getNewPublic", args || {}); }
    getTopSellingProducts(args: {eventId: string}): Promise<TopSellingProducts> { return this.makeRequest("getTopSellingProducts", args || {}); }
    getSelledProducts(args: {eventId: string}): Promise<SelledProduct[]> { return this.makeRequest("getSelledProducts", args || {}); }
    getTotalReceipt(args: {eventId: string}): Promise<TotalReceipt> { return this.makeRequest("getTotalReceipt", args || {}); }
    getTableReceipt(args: {eventId: string}): Promise<number> { return this.makeRequest("getTableReceipt", args || {}); }
    getDeliveryReceipt(args: {eventId: string}): Promise<DeliveryReceipt> { return this.makeRequest("getDeliveryReceipt", args || {}); }
    getRechargeTimeline(args: {eventId: string}): Promise<ConsumptionTimeline[]> { return this.makeRequest("getRechargeTimeline", args || {}); }
    getConsumptionTimeline(args: {eventId: string}): Promise<ConsumptionTimeline[]> { return this.makeRequest("getConsumptionTimeline", args || {}); }
    getTableConsumptionTimeline(args: {eventId: string}): Promise<ConsumptionTimeline[]> { return this.makeRequest("getTableConsumptionTimeline", args || {}); }
    getTopClients(args: {eventId: string}): Promise<TopSellingClient[]> { return this.makeRequest("getTopClients", args || {}); }
    getBarConsumptionResume(args: {eventId: string}): Promise<ConsumptionResume> { return this.makeRequest("getBarConsumptionResume", args || {}); }
    getEntrancesConsumptionResume(args: {eventId: string}): Promise<ConsumptionResume> { return this.makeRequest("getEntrancesConsumptionResume", args || {}); }
    getOpenTablesTimeline(args: {eventId: string}): Promise<OpenTableTimeline[]> { return this.makeRequest("getOpenTablesTimeline", args || {}); }
    getClientsInTagTimeline(args: {eventId: string}): Promise<ClientsInTagTimeline[]> { return this.makeRequest("getClientsInTagTimeline", args || {}); }
    getVendorsResume(args: {eventId: string}): Promise<VendorResume[]> { return this.makeRequest("getVendorsResume", args || {}); }
    logIn(args: {username: string, password: string, organizationUsername: string}): Promise<Employee> { return this.makeRequest("logIn", args || {}); }
    loginByTokenForVirtualAssistantMVP(args: {username: string, token: string, organizationUsername: string}): Promise<Employee> { return this.makeRequest("loginByTokenForVirtualAssistantMVP", args || {}); }
    logOut(args?: {}): Promise<void> { return this.makeRequest("logOut", args || {}); }
    getCurrentEmployee(args?: {}): Promise<Employee> { return this.makeRequest("getCurrentEmployee", args || {}); }
    getCurrentOrganization(args?: {}): Promise<OrganizationWithFeatures> { return this.makeRequest("getCurrentOrganization", args || {}); }
    getCurrentAdmin(args?: {}): Promise<AdminResponse | null> { return this.makeRequest("getCurrentAdmin", args || {}); }
    forgotPassword(args: {organization: string, email: string}): Promise<ForgotPassword> { return this.makeRequest("forgotPassword", args || {}); }
    registerEmployeeEmail(args: {input: RegisterEmployeeEmailInput}): Promise<RegisterEmployeeEmail> { return this.makeRequest("registerEmployeeEmail", args || {}); }
    confirmEmployeeEmail(args: {token: string}): Promise<ConfirmEmployeeEmail> { return this.makeRequest("confirmEmployeeEmail", args || {}); }
    createLoyaltyProgram(args: {loyaltyProgram: BaseLoyaltyProgram}): Promise<string> { return this.makeRequest("createLoyaltyProgram", args || {}); }
    editLoyaltyProgram(args: {id: string, loyaltyProgram: BaseLoyaltyProgram}): Promise<void> { return this.makeRequest("editLoyaltyProgram", args || {}); }
    getLoyaltyProgramById(args: {programId: string}): Promise<LoyaltyProgram> { return this.makeRequest("getLoyaltyProgramById", args || {}); }
    getLoyaltyCompleteReport(args: {organizationId: string, paginationAndFilters: PaginationAndFilters}): Promise<LoyaltyCompleteReport> { return this.makeRequest("getLoyaltyCompleteReport", args || {}); }
    getLoyaltyCompleteReportById(args: {programId: string, filters?: LoyaltyProgramFilters | null}): Promise<LoyaltyProgramReport> { return this.makeRequest("getLoyaltyCompleteReportById", args || {}); }
    getLoyaltyProgramParticipantsReport(args: {loyaltyProgramId: string, paginationAndFilters: PaginationAndFilters}): Promise<ProgramParticipantReportResponse> { return this.makeRequest("getLoyaltyProgramParticipantsReport", args || {}); }
    activateLoyaltyProgram(args: {id: string}): Promise<void> { return this.makeRequest("activateLoyaltyProgram", args || {}); }
    deactivateLoyaltyProgram(args: {id: string}): Promise<void> { return this.makeRequest("deactivateLoyaltyProgram", args || {}); }
    getLoyaltyProgramSmsCost(args: {id: string}): Promise<SmsCostInfo> { return this.makeRequest("getLoyaltyProgramSmsCost", args || {}); }
    sendSmsToLoyaltyProgramRelatives(args: {id: string, message: string}): Promise<void> { return this.makeRequest("sendSmsToLoyaltyProgramRelatives", args || {}); }
    getLoyaltyPrograms(args?: {}): Promise<LoyaltyProgram[]> { return this.makeRequest("getLoyaltyPrograms", args || {}); }
    generateCoupons(args: {quantity: number, coupon: BaseCoupon, campaignName?: string | null}): Promise<Coupon[]> { return this.makeRequest("generateCoupons", args || {}); }
    getGiftCardCampaign(args?: {}): Promise<GiftCardCampaign[]> { return this.makeRequest("getGiftCardCampaign", args || {}); }
    changeStatusGiftCardCampaign(args: {id: string, status: boolean}): Promise<void> { return this.makeRequest("changeStatusGiftCardCampaign", args || {}); }
    getNpsFromPlaces(args: {placeIds: string[], since: Date, until: Date}): Promise<QuestionsScore> { return this.makeRequest("getNpsFromPlaces", args || {}); }
    editNpsQuestions(args: {placeId: string, questions: QuestionType[]}): Promise<NpsPlaceInfo> { return this.makeRequest("editNpsQuestions", args || {}); }
    getNpsCustomerAnswers(args: {placeIds: string[], since: Date, until: Date, pageConfig: PageArgs}): Promise<CustomerResult> { return this.makeRequest("getNpsCustomerAnswers", args || {}); }
    getNpsConfig(args: {placeIds: string[]}): Promise<NpsPlaceInfo[]> { return this.makeRequest("getNpsConfig", args || {}); }
    getNpsSmsSents(args: {placeIds: string[], since: Date, until: Date}): Promise<NpsSmsSents> { return this.makeRequest("getNpsSmsSents", args || {}); }
    listNpsSmsSent(args: {placeIds: string[], date: PeriodTime}): Promise<NpsSmsSent> { return this.makeRequest("listNpsSmsSent", args || {}); }
    editSendSmsOnNpsForm(args: {placeIds: string[], shouldSendSmsOnCheckout?: boolean | null, dailySmsLimit?: number | null}): Promise<SimpleNpsForm[]> { return this.makeRequest("editSendSmsOnNpsForm", args || {}); }
    getCustomerAnswerDetails(args: {userId: string, eventId: string}): Promise<AnswerDetails> { return this.makeRequest("getCustomerAnswerDetails", args || {}); }
    getNpsQuestionDetails(args: {questionId: QuestionType, placeIds: string[], since: Date, until: Date}): Promise<NpsQuestionDetails> { return this.makeRequest("getNpsQuestionDetails", args || {}); }
    getAllOpenSalesByEmployee(args: {eventId: string, employeeId: string}): Promise<OpenSale[]> { return this.makeRequest("getAllOpenSalesByEmployee", args || {}); }
    getAllOpenSalesAtPlaceByEmployee(args: {placeId: string, employeeId: string, since: Date, until: Date}): Promise<OpenSale[]> { return this.makeRequest("getAllOpenSalesAtPlaceByEmployee", args || {}); }
    getOpenSaleReport(args: {eventId: string}): Promise<OpenSaleReport[]> { return this.makeRequest("getOpenSaleReport", args || {}); }
    getOpenSaleReportAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<OpenSaleReport[]> { return this.makeRequest("getOpenSaleReportAtPlace", args || {}); }
    getReportMailsOfOrganization(args: {organizationId: string}): Promise<string[]> { return this.makeRequest("getReportMailsOfOrganization", args || {}); }
    editReportMailsInOrganization(args: {organizationId: string, reportMails: string[]}): Promise<void> { return this.makeRequest("editReportMailsInOrganization", args || {}); }
    createPaymentLink(args: {placeId: string, amount: number, installments?: number | null, paymentOrigin: PaymentOrigin, description: string}): Promise<CreatePaymentLinkResult> { return this.makeRequest("createPaymentLink", args || {}); }
    listPaymentLinks(args: {placeId: string, page?: number | null, pageSize?: number | null, filter?: PaymentLinkFilter | null}): Promise<PaymentLinkPage> { return this.makeRequest("listPaymentLinks", args || {}); }
    getAllRoles(args?: {}): Promise<Role[]> { return this.makeRequest("getAllRoles", args || {}); }
    getPlaces(args?: {}): Promise<Place[]> { return this.makeRequest("getPlaces", args || {}); }
    checkPlaceConfig(args: {placeId: string}): Promise<boolean> { return this.makeRequest("checkPlaceConfig", args || {}); }
    getPlaceContractDetails(args: {placeId: string}): Promise<PlaceContractDetails> { return this.makeRequest("getPlaceContractDetails", args || {}); }
    getPlace(args: {placeId: string}): Promise<PlaceData> { return this.makeRequest("getPlace", args || {}); }
    editPlace(args: {place: NewPlace, image?: ArrayBuffer | null}): Promise<Place> { return this.makeRequest("editPlace", args || {}); }
    getPlaceFeatures(args: {placeId: string}): Promise<PlaceFeature[]> { return this.makeRequest("getPlaceFeatures", args || {}); }
    activePlaceFeature(args: {placeId: string, featureId: string}): Promise<void> { return this.makeRequest("activePlaceFeature", args || {}); }
    deactivePlaceFeature(args: {placeId: string, featureId: string}): Promise<void> { return this.makeRequest("deactivePlaceFeature", args || {}); }
    setZigPlaceFeatures(args: {placeId: string, featureIds: string[]}): Promise<void> { return this.makeRequest("setZigPlaceFeatures", args || {}); }
    editPlacePassword(args: {placeId: string, pass?: string | null}): Promise<void> { return this.makeRequest("editPlacePassword", args || {}); }
    getPlacePassword(args: {placeId: string}): Promise<string | null> { return this.makeRequest("getPlacePassword", args || {}); }
    overridePlaceAccountId(args: {placeId: string, accountId?: string | null}): Promise<void> { return this.makeRequest("overridePlaceAccountId", args || {}); }
    getOverridenPlaceAccount(args: {placeId: string}): Promise<BackofficeAccount | null> { return this.makeRequest("getOverridenPlaceAccount", args || {}); }
    editPlaceEverestConfig(args: {placeId: string, config?: EverestConfig | null}): Promise<void> { return this.makeRequest("editPlaceEverestConfig", args || {}); }
    getPlaceEverestConfig(args: {placeId: string}): Promise<EverestConfig | null> { return this.makeRequest("getPlaceEverestConfig", args || {}); }
    getAllPlaces(args?: {}): Promise<Place[]> { return this.makeRequest("getAllPlaces", args || {}); }
    getPlacesWithFeatures(args?: {}): Promise<PlaceWithFeatures[]> { return this.makeRequest("getPlacesWithFeatures", args || {}); }
    getSimplifiedPlaces(args?: {}): Promise<SimplifiedPlace[]> { return this.makeRequest("getSimplifiedPlaces", args || {}); }
    getBeerTaps(args: {placeId: string}): Promise<BeerTap[]> { return this.makeRequest("getBeerTaps", args || {}); }
    removeBeerTap(args: {id: string}): Promise<void> { return this.makeRequest("removeBeerTap", args || {}); }
    editBeerTap(args: {tap: BeerTap}): Promise<void> { return this.makeRequest("editBeerTap", args || {}); }
    createBeerTap(args: {placeId: string, tap: BaseBeerTap}): Promise<void> { return this.makeRequest("createBeerTap", args || {}); }
    changeBeerTapStatus(args: {id: string, status: boolean}): Promise<void> { return this.makeRequest("changeBeerTapStatus", args || {}); }
    getPlacesResume(args: {placeIds: string[], since: Date, until: Date}): Promise<PlacesResume> { return this.makeRequest("getPlacesResume", args || {}); }
    getPlaceUsersByAverageTicket(args: {placeIds: string[], since: Date, until: Date, filters?: AverageTicketFilter | null}): Promise<UsersWithAverageTicket[]> { return this.makeRequest("getPlaceUsersByAverageTicket", args || {}); }
    getPlaceMessageCost(args: {placeId: string, channel: string}): Promise<number> { return this.makeRequest("getPlaceMessageCost", args || {}); }
    getFichaExtraConfig(args: {placeId: string}): Promise<FichaExtraConfig> { return this.makeRequest("getFichaExtraConfig", args || {}); }
    alterFichaText(args: {placeId: string, str?: string | null}): Promise<FichaExtraConfig> { return this.makeRequest("alterFichaText", args || {}); }
    alterFichaLogo(args: {placeId: string, data?: ArrayBuffer | null}): Promise<FichaExtraConfig> { return this.makeRequest("alterFichaLogo", args || {}); }
    alterPlaceImage(args: {placeId: string, image?: ArrayBuffer | null}): Promise<void> { return this.makeRequest("alterPlaceImage", args || {}); }
    getZigLocations(args?: {}): Promise<ZigLocation[]> { return this.makeRequest("getZigLocations", args || {}); }
    getSimplifiedPlacesWhatsapp(args?: {}): Promise<SimplifiedPlaceWhatsapp[]> { return this.makeRequest("getSimplifiedPlacesWhatsapp", args || {}); }
    getPlaceSettingsGeneralSection(args: {placeId: string}): Promise<PlaceSettingsGeneralSectionResponse> { return this.makeRequest("getPlaceSettingsGeneralSection", args || {}); }
    updatePlaceSettingsGeneralSection(args: {placeId: string, data: PlaceSettingsGeneralSectionRequest}): Promise<PlaceSettingsGeneralSectionResponse> { return this.makeRequest("updatePlaceSettingsGeneralSection", args || {}); }
    getProductsAvailableToZigTag(args: {placeId: string}): Promise<ProductToZigTag[]> { return this.makeRequest("getProductsAvailableToZigTag", args || {}); }
    getPlaceSettingsCouvertSection(args: {placeId: string}): Promise<PlaceSettingsCouvertSectionResponse> { return this.makeRequest("getPlaceSettingsCouvertSection", args || {}); }
    updatePlaceSettingsCouvertSection(args: {placeId: string, data: PlaceSettingsCouvertSectionRequest}): Promise<PlaceSettingsCouvertSectionResponse> { return this.makeRequest("updatePlaceSettingsCouvertSection", args || {}); }
    getPlaceSettingsPlaceFeatureSection(args: {placeId: string}): Promise<PlaceSettingsPlaceFeatureSectionResponse> { return this.makeRequest("getPlaceSettingsPlaceFeatureSection", args || {}); }
    updatePlaceSettingsPlaceFeatureSection(args: {placeId: string, data: PlaceSettingsPlaceFeatureSectionRequest}): Promise<PlaceSettingsPlaceFeatureSectionResponse> { return this.makeRequest("updatePlaceSettingsPlaceFeatureSection", args || {}); }
    getPlaceSettingsFichaSection(args: {placeId: string}): Promise<PlaceSettingsFichaSectionResponse> { return this.makeRequest("getPlaceSettingsFichaSection", args || {}); }
    updatePlaceSettingsFichaSection(args: {placeId: string, data: PlaceSettingsFichaSectionRequest}): Promise<PlaceSettingsFichaSectionResponse> { return this.makeRequest("updatePlaceSettingsFichaSection", args || {}); }
    getPlaceSettingsPdvSection(args: {placeId: string}): Promise<PlaceSettingsPdvSectionResponse> { return this.makeRequest("getPlaceSettingsPdvSection", args || {}); }
    updatePlaceSettingsPdvSection(args: {placeId: string, data: PlaceSettingsPdvSectionRequest}): Promise<PlaceSettingsPdvSectionReturn> { return this.makeRequest("updatePlaceSettingsPdvSection", args || {}); }
    getPlaceSettingsTotemSection(args: {placeId: string}): Promise<TotemPlaceConfigResponse> { return this.makeRequest("getPlaceSettingsTotemSection", args || {}); }
    updatePlaceSettingsTotemSection(args: {placeId: string, data: TotemConfigsRequest}): Promise<TotemPlaceConfigResponse> { return this.makeRequest("updatePlaceSettingsTotemSection", args || {}); }
    createFiscalPrinters(args: {placeId: string, fiscalPrinters: FiscalPrinter[]}): Promise<FiscalPrintersResult> { return this.makeRequest("createFiscalPrinters", args || {}); }
    listFiscalPrinters(args: {placeId: string}): Promise<FiscalPrinter[] | null> { return this.makeRequest("listFiscalPrinters", args || {}); }
    editFiscalPrinter(args: {placeId: string, oldFiscalPrinter: FiscalPrinter, newFiscalPrinter: FiscalPrinter}): Promise<FiscalPrinter[]> { return this.makeRequest("editFiscalPrinter", args || {}); }
    deleteFiscalPrinters(args: {placeId: string, fiscalPrinters: FiscalPrinter[]}): Promise<FiscalPrintersResult> { return this.makeRequest("deleteFiscalPrinters", args || {}); }
    getPlaceDetail(args: {placeId: string}): Promise<PlaceDetail> { return this.makeRequest("getPlaceDetail", args || {}); }
    editPlaceDetail(args: {placeId: string, detail: EditPlaceDetail}): Promise<PlaceDetail> { return this.makeRequest("editPlaceDetail", args || {}); }
    addImageToPlaceDetail(args: {placeId: string, data: ArrayBuffer}): Promise<PlaceDetailImage> { return this.makeRequest("addImageToPlaceDetail", args || {}); }
    deletePlaceDetailImage(args: {placeId: string, imageId: string}): Promise<void> { return this.makeRequest("deletePlaceDetailImage", args || {}); }
    getPlaceDetailTags(args: {placeId: string}): Promise<PlaceDetailTag[]> { return this.makeRequest("getPlaceDetailTags", args || {}); }
    editPlaceDetailTags(args: {placeId: string, tags: PlaceDetailTag[]}): Promise<PlaceDetailTag[]> { return this.makeRequest("editPlaceDetailTags", args || {}); }
    getWorkingDays(args: {placeId: string}): Promise<WorkingDays> { return this.makeRequest("getWorkingDays", args || {}); }
    setWorkingDays(args: {placeId: string, days: WorkingDays}): Promise<WorkingDays> { return this.makeRequest("setWorkingDays", args || {}); }
    getAllBaseTags(args?: {}): Promise<BaseTag[]> { return this.makeRequest("getAllBaseTags", args || {}); }
    setPlaceDetailStatus(args: {placeId: string, status: boolean}): Promise<PlaceDetail> { return this.makeRequest("setPlaceDetailStatus", args || {}); }
    getPlaceDetailMusicTags(args: {placeId: string}): Promise<PlaceDetailMusicTag[]> { return this.makeRequest("getPlaceDetailMusicTags", args || {}); }
    editPlaceDetailMusicTags(args: {placeId: string, musicTagIds: PlaceDetailMusicTag[]}): Promise<PlaceDetailMusicTag[]> { return this.makeRequest("editPlaceDetailMusicTags", args || {}); }
    getAllMusicBaseTags(args?: {}): Promise<BaseMusicTag[]> { return this.makeRequest("getAllMusicBaseTags", args || {}); }
    getPosMachineTransactions(args: {placeId: string, dates: Date[], page: number, searchTerm?: string | null, itemsPerPage?: number | null}): Promise<PaginationPosTransaction> { return this.makeRequest("getPosMachineTransactions", args || {}); }
    getConsolidatedPosMachineTransactions(args: {placeId: string, since: Date, until: Date}): Promise<PosMachineDayResume[]> { return this.makeRequest("getConsolidatedPosMachineTransactions", args || {}); }
    createPrechargeOperation(args: {precharge: BasePrechargeOperation, logo?: ArrayBuffer | null, mainImage?: ArrayBuffer | null}): Promise<PrechargeOperation> { return this.makeRequest("createPrechargeOperation", args || {}); }
    getPrechargeOperationsForPlace(args: {placeId: string}): Promise<PrechargeOperation[]> { return this.makeRequest("getPrechargeOperationsForPlace", args || {}); }
    updatePrechargeOperationData(args: {id: string, precharge: BasePrechargeOperation}): Promise<PrechargeOperation> { return this.makeRequest("updatePrechargeOperationData", args || {}); }
    updatePrechargeOperationLogo(args: {id: string, logo?: ArrayBuffer | null}): Promise<PrechargeOperation> { return this.makeRequest("updatePrechargeOperationLogo", args || {}); }
    updatePrechargeOperationMainImage(args: {id: string, mainImage?: ArrayBuffer | null}): Promise<PrechargeOperation> { return this.makeRequest("updatePrechargeOperationMainImage", args || {}); }
    deletePrecharge(args: {id: string}): Promise<void> { return this.makeRequest("deletePrecharge", args || {}); }
    getPrechargeReport(args: {operationId: string}): Promise<PrechargeOperationReport> { return this.makeRequest("getPrechargeReport", args || {}); }
    getPrechargesByOperation(args: {operationId: string, pagination: Pagination, filters: PrechargesFilters}): Promise<PrechargeResponse> { return this.makeRequest("getPrechargesByOperation", args || {}); }
    createPrinters(args: {placeId: string, printers: CreatePrinter[]}): Promise<PrintersResult> { return this.makeRequest("createPrinters", args || {}); }
    getPrinters(args: {placeId: string, barId: string}): Promise<Printer[]> { return this.makeRequest("getPrinters", args || {}); }
    listPrinters(args: {placeId: string, barIds: string[]}): Promise<ListPrinters[]> { return this.makeRequest("listPrinters", args || {}); }
    editPrinters(args: {placeId: string, printers: Printer[]}): Promise<PrintersResult> { return this.makeRequest("editPrinters", args || {}); }
    deletePrinters(args: {placeId: string, barId: string, printerIds: string[]}): Promise<void> { return this.makeRequest("deletePrinters", args || {}); }
    activateProductInPlace(args: {placeId: string, productId: string, activateMountableItems?: boolean | null}): Promise<void> { return this.makeRequest("activateProductInPlace", args || {}); }
    deactivateProductInPlace(args: {placeId: string, productId: string, deactivateMountableItems?: boolean | null}): Promise<void> { return this.makeRequest("deactivateProductInPlace", args || {}); }
    updatePriceAtPlace(args: {placeId: string, productId: string, value: number}): Promise<void> { return this.makeRequest("updatePriceAtPlace", args || {}); }
    activateMountableSectionItem(args: {placeId: string, mountableSectionId?: string | null, productId: string, activateAllItems: boolean}): Promise<void> { return this.makeRequest("activateMountableSectionItem", args || {}); }
    deactivateMountableSectionItem(args: {placeId: string, mountableSectionId?: string | null, productId: string, deactivateAllItems: boolean}): Promise<void> { return this.makeRequest("deactivateMountableSectionItem", args || {}); }
    activateProductsInPlace(args: {placeId: string, productIds: string[]}): Promise<void> { return this.makeRequest("activateProductsInPlace", args || {}); }
    deactivateProductsInPlace(args: {placeId: string, productIds: string[]}): Promise<void> { return this.makeRequest("deactivateProductsInPlace", args || {}); }
    addProductToPlace(args: {placeId: string, productId: string, fiscalData?: NewPlaceProductFiscalData | null, price?: number | null}): Promise<void> { return this.makeRequest("addProductToPlace", args || {}); }
    removeProductFromPlace(args: {placeId: string, productId: string}): Promise<void> { return this.makeRequest("removeProductFromPlace", args || {}); }
    getProductsByPlace(args: {place: string}): Promise<Product[]> { return this.makeRequest("getProductsByPlace", args || {}); }
    addNewProductToOrganization(args: {product: NewProduct, image?: EditProductImage | null}): Promise<OrganizationProduct> { return this.makeRequest("addNewProductToOrganization", args || {}); }
    addNewProductToOrganizationAndPlaces(args: {product: NewProduct, placesIds: string[], image?: EditProductImage | null}): Promise<CreatedResults> { return this.makeRequest("addNewProductToOrganizationAndPlaces", args || {}); }
    addNewProduct(args: {product: NewPlaceProductWithMountableDetails, placeId: string, image?: EditProductImage | null, isActive?: boolean | null}): Promise<PlaceProduct> { return this.makeRequest("addNewProduct", args || {}); }
    editProduct(args: {id: string, product: NewProduct}): Promise<Product> { return this.makeRequest("editProduct", args || {}); }
    editProducts(args: {products: EditedProduct[]}): Promise<EditedResults> { return this.makeRequest("editProducts", args || {}); }
    editPlaceProduct(args: {id: string, product: NewPlaceProductWithMountableDetails, placeId: string, image?: EditProductImage | null, isActive?: boolean | null}): Promise<PlaceProduct> { return this.makeRequest("editPlaceProduct", args || {}); }
    editProductAndPlaceProducts(args: {placesIds: string[], product: EditedProduct}): Promise<EditedResults> { return this.makeRequest("editProductAndPlaceProducts", args || {}); }
    editProductImage(args: {id: string, image: EditProductImage, placeId?: string | null}): Promise<string | null> { return this.makeRequest("editProductImage", args || {}); }
    deleteProduct(args: {id: string}): Promise<DeleteProductResult> { return this.makeRequest("deleteProduct", args || {}); }
    deleteMultipleProducts(args: {productIds: string[], placeId?: string | null}): Promise<DeleteMultipleProductsResult> { return this.makeRequest("deleteMultipleProducts", args || {}); }
    createSupply(args: {supplies: CreateSupply[]}): Promise<CreateSupplyResponse> { return this.makeRequest("createSupply", args || {}); }
    editSupply(args: {id: string, placeId: string, name: string, basicStorageUnit: BasicStorageUnit, fiscalCode?: string | null, yieldPercentage?: number | null, image?: EditProductImage | null, proportionOfUnit?: ProportionOfUnit | null}): Promise<void> { return this.makeRequest("editSupply", args || {}); }
    getPlaceProduct(args: {placeId: string, productId: string}): Promise<PlaceProduct> { return this.makeRequest("getPlaceProduct", args || {}); }
    getPlaceProducts(args: {placeId: string}): Promise<PlaceProduct[]> { return this.makeRequest("getPlaceProducts", args || {}); }
    getBarProducts(args: {barId: string}): Promise<BarProduct[]> { return this.makeRequest("getBarProducts", args || {}); }
    createSupplyWithProductionRule(args: {placeId: string, name: string, image?: EditProductImage | null, basicStorageUnit: BasicStorageUnit, fiscalCode?: string | null, yieldPercentage?: number | null, productionRule: SupplyProductionRule, proportionOfUnit?: ProportionOfUnit | null}): Promise<SupplyWithProductionRule> { return this.makeRequest("createSupplyWithProductionRule", args || {}); }
    updateSupplyWithProductionRule(args: {placeId: string, supplyId: string, name: string, image?: EditProductImage | null, basicStorageUnit: BasicStorageUnit, fiscalCode?: string | null, yieldPercentage?: number | null, productionRule: SupplyProductionRule, proportionOfUnit?: ProportionOfUnit | null}): Promise<SupplyWithProductionRule | null> { return this.makeRequest("updateSupplyWithProductionRule", args || {}); }
    getSuppliesWithProductionRule(args: {placeId: string, supplyIds?: string[] | null}): Promise<SupplyWithProductionRule[]> { return this.makeRequest("getSuppliesWithProductionRule", args || {}); }
    getSupplyWithProductionRule(args: {placeId: string, supplyId: string}): Promise<SupplyWithProductionRule> { return this.makeRequest("getSupplyWithProductionRule", args || {}); }
    deleteSupplyWithProductionRule(args: {placeId: string, supplyId: string}): Promise<void> { return this.makeRequest("deleteSupplyWithProductionRule", args || {}); }
    removeProductionRulesFromSupplies(args: {placeId: string, supplyIds: string[]}): Promise<RemoveProductionRulesFromSupplies> { return this.makeRequest("removeProductionRulesFromSupplies", args || {}); }
    getAllProducts(args: {placeIds?: string[] | null}): Promise<OrganizationProduct[]> { return this.makeRequest("getAllProducts", args || {}); }
    getAllProductsGroupedByCategory(args?: {}): Promise<GroupedByCategoryOrganizationProduct[]> { return this.makeRequest("getAllProductsGroupedByCategory", args || {}); }
    getProduct(args: {id: string}): Promise<OrganizationProduct> { return this.makeRequest("getProduct", args || {}); }
    removePlaceProductProductionRule(args: {productId: string, placeId: string}): Promise<void> { return this.makeRequest("removePlaceProductProductionRule", args || {}); }
    getProductionRuleFromProduct(args: {productId: string, placeId: string}): Promise<ProductRule> { return this.makeRequest("getProductionRuleFromProduct", args || {}); }
    getProductionRuleFromProductWithResume(args: {productId: string, placeId: string}): Promise<ProductRuleWithResume> { return this.makeRequest("getProductionRuleFromProductWithResume", args || {}); }
    getProductsFromPlaceReportXls(args: {placeId: string}): Promise<string> { return this.makeRequest("getProductsFromPlaceReportXls", args || {}); }
    getPlaceProductsByType(args: {placeId: string, productType: ProductType, productName?: string | null, pagination?: Pagination | null, orderBy?: GetPlaceProductsByTypeOrderBy | null, order?: GetPlaceProductsByTypeOrder | null}): Promise<PlaceProductsByTypeResponse> { return this.makeRequest("getPlaceProductsByType", args || {}); }
    exportPlaceProductsByType(args: {placeId: string, productType: ProductType, productName?: string | null, orderBy?: ExportPlaceProductsByTypeOrderBy | null, order?: ExportPlaceProductsByTypeOrder | null}): Promise<string> { return this.makeRequest("exportPlaceProductsByType", args || {}); }
    editProductsThroughImport(args: {products: EditedProductThroughImport[]}): Promise<OrganizationProduct[]> { return this.makeRequest("editProductsThroughImport", args || {}); }
    getGrabAndGoProducts(args: {placeId: string}): Promise<GrabAndGoProduct[]> { return this.makeRequest("getGrabAndGoProducts", args || {}); }
    activateGrabAndGoProduct(args: {placeId: string, productId: string}): Promise<void> { return this.makeRequest("activateGrabAndGoProduct", args || {}); }
    deactivateGrabAndGoProduct(args: {placeId: string, productId: string}): Promise<void> { return this.makeRequest("deactivateGrabAndGoProduct", args || {}); }
    verifyPatchProducts(args: {products: PatchProduct[], placeId: string, type?: VerifyPatchProductsType | null}): Promise<VerifyPatchProductsResult | null> { return this.makeRequest("verifyPatchProducts", args || {}); }
    patchProducts(args: {products: PatchProduct[], placeId: string, activeAllProducts?: boolean | null, skipMountableSections?: boolean | null}): Promise<string[]> { return this.makeRequest("patchProducts", args || {}); }
    getPlaceProductsWithSections(args: {placeId: string, filters: GetProductsWithSectionsRequest, pagination: Pagination}): Promise<GetProductsWithSectionsWithProductsResponse> { return this.makeRequest("getPlaceProductsWithSections", args || {}); }
    getManyExternalStoreIntegrationCategoriesWithProducts(args: {placeId: string, menuId: string}): Promise<GetManyExternalStoreIntegrationCategoriesResponse> { return this.makeRequest("getManyExternalStoreIntegrationCategoriesWithProducts", args || {}); }
    filterProductsAtPlaceByName(args: {placeIds: string[], name: string}): Promise<TinyProduct[]> { return this.makeRequest("filterProductsAtPlaceByName", args || {}); }
    getCategoryProducts(args: {placeId: string, searchQuery?: string | null, status?: ProductStatus | null, categoryId: string, categoryKind?: CategoryKind | null}): Promise<CategoryProduct[]> { return this.makeRequest("getCategoryProducts", args || {}); }
    getAllCategoriesProducts(args: {placeId: string, searchQuery?: string | null, status?: ProductStatus | null, categoryKind?: CategoryKind | null}): Promise<CategoryProduct[]> { return this.makeRequest("getAllCategoriesProducts", args || {}); }
    migrateProductsFromCategory(args: {placeId: string, fromCategoryId: string, toCategoryId: string}): Promise<void> { return this.makeRequest("migrateProductsFromCategory", args || {}); }
    patchProductsFields(args: {placeId: string, productsIds: string[], productFields: PatchProductsFieldsProductFields}): Promise<void> { return this.makeRequest("patchProductsFields", args || {}); }
    createProductFeature(args: {productFeature: BaseProductFeature}): Promise<ProductFeature> { return this.makeRequest("createProductFeature", args || {}); }
    getProductFeatures(args: {productId: string}): Promise<ProductFeature[]> { return this.makeRequest("getProductFeatures", args || {}); }
    removeProductFeature(args: {id: string}): Promise<void> { return this.makeRequest("removeProductFeature", args || {}); }
    editProductFeature(args: {productFeature: ProductFeature}): Promise<ProductFeature> { return this.makeRequest("editProductFeature", args || {}); }
    changeProductFeatureStatus(args: {id: string, status: boolean}): Promise<void> { return this.makeRequest("changeProductFeatureStatus", args || {}); }
    changeProductFeatureStatusByTemplateId(args: {id: string, status: boolean}): Promise<void> { return this.makeRequest("changeProductFeatureStatusByTemplateId", args || {}); }
    removeProductFeaturesByTemplateId(args: {id: string}): Promise<void> { return this.makeRequest("removeProductFeaturesByTemplateId", args || {}); }
    getUsableProductFeatures(args: {productId: string}): Promise<ProductFeature[]> { return this.makeRequest("getUsableProductFeatures", args || {}); }
    createProductFeatureTemplate(args: {productFeatureTemplate: BaseProductFeatureTemplate}): Promise<ProductFeatureTemplate> { return this.makeRequest("createProductFeatureTemplate", args || {}); }
    getProductFeatureTemplates(args: {organizationId: string}): Promise<ProductFeatureTemplate[]> { return this.makeRequest("getProductFeatureTemplates", args || {}); }
    removeProductFeatureTemplate(args: {id: string}): Promise<void> { return this.makeRequest("removeProductFeatureTemplate", args || {}); }
    editProductFeatureTemplate(args: {productFeatureTemplate: ProductFeatureTemplate}): Promise<ProductFeatureTemplate> { return this.makeRequest("editProductFeatureTemplate", args || {}); }
    changeProductFeatureTemplateStatus(args: {id: string, status: boolean}): Promise<ProductFeatureTemplate> { return this.makeRequest("changeProductFeatureTemplateStatus", args || {}); }
    getUsableProductFeatureTemplates(args: {organizationId: string}): Promise<ProductFeatureTemplate[]> { return this.makeRequest("getUsableProductFeatureTemplates", args || {}); }
    getZigProductFeatureTemplates(args?: {}): Promise<ProductFeatureTemplate[]> { return this.makeRequest("getZigProductFeatureTemplates", args || {}); }
    getPlacePromoters(args: {placeId: string}): Promise<PlacePromoter[]> { return this.makeRequest("getPlacePromoters", args || {}); }
    getPendingPromoters(args: {placeId: string}): Promise<PlacePromoter[]> { return this.makeRequest("getPendingPromoters", args || {}); }
    cancelPromoterInvitation(args: {placeId: string, email: string}): Promise<void> { return this.makeRequest("cancelPromoterInvitation", args || {}); }
    invitePromoters(args: {placeId: string, emails: string[]}): Promise<void> { return this.makeRequest("invitePromoters", args || {}); }
    activatePromoter(args: {placeId: string, id: string}): Promise<PlacePromoter> { return this.makeRequest("activatePromoter", args || {}); }
    deactivatePromoter(args: {placeId: string, id: string}): Promise<PlacePromoter> { return this.makeRequest("deactivatePromoter", args || {}); }
    editPromoterInPlace(args: {placeId: string, promoterId: string, promoter: EditPromoterPlace}): Promise<PlacePromoter> { return this.makeRequest("editPromoterInPlace", args || {}); }
    getPromoterRoles(args?: {}): Promise<PromoterRoles[]> { return this.makeRequest("getPromoterRoles", args || {}); }
    createPromotion(args: {promotion: NewPromotion}): Promise<Promotion> { return this.makeRequest("createPromotion", args || {}); }
    deletePromotion(args: {id: string}): Promise<void> { return this.makeRequest("deletePromotion", args || {}); }
    getPromotions(args: {placeId: string}): Promise<Promotion[]> { return this.makeRequest("getPromotions", args || {}); }
    getPromotion(args: {promotionId: string}): Promise<Promotion> { return this.makeRequest("getPromotion", args || {}); }
    editPromotion(args: {promotionId: string, promotion: NewPromotion}): Promise<Promotion> { return this.makeRequest("editPromotion", args || {}); }
    togglePromotion(args: {promotionId: string, isActive: boolean}): Promise<Promotion> { return this.makeRequest("togglePromotion", args || {}); }
    getPromotionUsers(args: {promotionId: string}): Promise<PromotionUser[]> { return this.makeRequest("getPromotionUsers", args || {}); }
    givePromotionToManyUsers(args: {promotionId: string, cpfPhones: CpfOrPhone[]}): Promise<MultipleUserPromotionResult> { return this.makeRequest("givePromotionToManyUsers", args || {}); }
    removePromotionFromManyUsers(args: {promotionId: string, userIds: string[]}): Promise<void> { return this.makeRequest("removePromotionFromManyUsers", args || {}); }
    listRefundReasons(args: {placeId: string}): Promise<RefundReason[]> { return this.makeRequest("listRefundReasons", args || {}); }
    createRefundReasons(args: {placeId: string, refundReasons: CreateRefundReason[]}): Promise<RefundReasonResult> { return this.makeRequest("createRefundReasons", args || {}); }
    editRefundReasons(args: {placeId: string, refundReasons: EditRefundReason[]}): Promise<RefundReasonResult> { return this.makeRequest("editRefundReasons", args || {}); }
    deleteRefundReasons(args: {placeId: string, refundReasonIds: string[]}): Promise<void> { return this.makeRequest("deleteRefundReasons", args || {}); }
    createRelation(args: {relation: NewRelation}): Promise<Relation> { return this.makeRequest("createRelation", args || {}); }
    editRelation(args: {id: string, relation: NewRelation}): Promise<Relation> { return this.makeRequest("editRelation", args || {}); }
    deleteRelation(args: {id: string}): Promise<void> { return this.makeRequest("deleteRelation", args || {}); }
    deleteMultipleRelation(args: {id: string[]}): Promise<void> { return this.makeRequest("deleteMultipleRelation", args || {}); }
    getRelations(args: {placeId: string, eventId?: string | null}): Promise<Relation[]> { return this.makeRequest("getRelations", args || {}); }
    activeOrDeactiveRelation(args: {id: string, isActive: boolean}): Promise<void> { return this.makeRequest("activeOrDeactiveRelation", args || {}); }
    importRelation(args: {relationIds: string[], placeId: string, eventId: string}): Promise<ImportRelationResponse> { return this.makeRequest("importRelation", args || {}); }
    getRelationUsers(args: {relationId: string}): Promise<RelationUser[]> { return this.makeRequest("getRelationUsers", args || {}); }
    addRelationUser(args: {relationId: string, user: NewRelationUser}): Promise<RelationUser[]> { return this.makeRequest("addRelationUser", args || {}); }
    deleteRelationUser(args: {relationId: string, relationUserId: string}): Promise<void> { return this.makeRequest("deleteRelationUser", args || {}); }
    addMultipleRelationUser(args: {relationId: string, users: NewRelationUser[]}): Promise<MultipleRelationUser> { return this.makeRequest("addMultipleRelationUser", args || {}); }
    deleteMultipleRelationUser(args: {relationId: string, relationUserIds: string[]}): Promise<void> { return this.makeRequest("deleteMultipleRelationUser", args || {}); }
    editRelationUser(args: {relationId: string, relationUserId: string, user: NewRelationUser}): Promise<RelationUser[]> { return this.makeRequest("editRelationUser", args || {}); }
    getRelationReportByPromoters(args: {placeId: string, eventId?: string | null, promoters: string[], relationIds: string[], since: Date, until: Date}): Promise<RelationPromoters[]> { return this.makeRequest("getRelationReportByPromoters", args || {}); }
    getRelationReportByLists(args: {placeId: string, eventId?: string | null, promoters: string[], relationIds: string[], since: Date, until: Date}): Promise<RelationReport[]> { return this.makeRequest("getRelationReportByLists", args || {}); }
    getPromoters(args: {placeId: string, eventId?: string | null, since: Date, until: Date}): Promise<string[]> { return this.makeRequest("getPromoters", args || {}); }
    getRelationLists(args: {placeId: string, eventId?: string | null, since: Date, until: Date}): Promise<Relation[]> { return this.makeRequest("getRelationLists", args || {}); }
    getRelationReportOverview(args: {placeId: string, eventId?: string | null, promoters: string[], relationIds: string[], since: Date, until: Date}): Promise<RelationDataOverview> { return this.makeRequest("getRelationReportOverview", args || {}); }
    getRelationReportGuests(args: {placeId: string, eventId?: string | null, promoters: string[], relationIds: string[], since: Date, until: Date, pagination: Pagination}): Promise<GuestReportResponse> { return this.makeRequest("getRelationReportGuests", args || {}); }
    getPlaceEmployeeReport(args: {placeId: string, since: Date, until: Date}): Promise<EmployeeReport> { return this.makeRequest("getPlaceEmployeeReport", args || {}); }
    getFinanceBiReport(args: {placeId: string, since: Date, until: Date}): Promise<FinanceBiReport> { return this.makeRequest("getFinanceBiReport", args || {}); }
    getConsumptionTimeLineAtPlaceBy30Min(args: {placeId: string, since: Date, until: Date}): Promise<BiConsumptionTimeline[]> { return this.makeRequest("getConsumptionTimeLineAtPlaceBy30Min", args || {}); }
    getConsumptionTimeLineAtPlaceBy30MinByDay(args: {placeId: string, since: Date, until: Date}): Promise<BiConsumptionTimeline[]> { return this.makeRequest("getConsumptionTimeLineAtPlaceBy30MinByDay", args || {}); }
    getConsumptionTimeLineAtOrganizationBy30MinByDay(args: {placesId: string[], since: Date, until: Date}): Promise<OrgConsumptionTimeline[]> { return this.makeRequest("getConsumptionTimeLineAtOrganizationBy30MinByDay", args || {}); }
    getClientsBiReport(args: {placeId: string, since: Date, until: Date}): Promise<ClientByReport> { return this.makeRequest("getClientsBiReport", args || {}); }
    getProductsBiReport(args: {placeId: string, since: Date, until: Date}): Promise<ProductBiReport[]> { return this.makeRequest("getProductsBiReport", args || {}); }
    getReportIdForLoggedOrganization(args?: {}): Promise<string> { return this.makeRequest("getReportIdForLoggedOrganization", args || {}); }
    getReportPdvZigCardErrors(args: {eventId: string, pagination: Pagination, filters: ReportPdvZigCardFilters}): Promise<ReportPdvZigCardReport> { return this.makeRequest("getReportPdvZigCardErrors", args || {}); }
    getProductsSoldReportV2(args: {filters: ProductsSoldReportV2Filters}): Promise<ProductsSoldReportV2Row[]> { return this.makeRequest("getProductsSoldReportV2", args || {}); }
    requestExportProductsSoldReportV2(args: {filters: ProductsSoldReportV2Filters, format: ReportExportFormat, email: string}): Promise<void> { return this.makeRequest("requestExportProductsSoldReportV2", args || {}); }
    getKdsProductsReport(args: {filters: KdsProductsReportFilters}): Promise<KdsProductsReportRow[]> { return this.makeRequest("getKdsProductsReport", args || {}); }
    requestExportKdsProductsReport(args: {filters: KdsProductsReportFilters, format: ReportExportFormat, email: string}): Promise<void> { return this.makeRequest("requestExportKdsProductsReport", args || {}); }
    getDetailedTransactionsReport(args: {filters: DetailedTransactionsReportFilters, pagination: Pagination}): Promise<DetailedTransactionsReportResponse> { return this.makeRequest("getDetailedTransactionsReport", args || {}); }
    getDetailedTransactionsReportTotals(args: {filters: DetailedTransactionsReportFilters}): Promise<DetailedTransactionsReportTotals> { return this.makeRequest("getDetailedTransactionsReportTotals", args || {}); }
    requestExportDetailedTransactionsReport(args: {filters: DetailedTransactionsReportFilters, format: ReportExportFormat, email: string}): Promise<void> { return this.makeRequest("requestExportDetailedTransactionsReport", args || {}); }
    getKdsOrdersReport(args: {filters: KdsOrdersReportFilters, pagination: Pagination}): Promise<KdsOrdersReportResponse> { return this.makeRequest("getKdsOrdersReport", args || {}); }
    requestExportKdsOrdersReport(args: {filters: KdsOrdersReportFilters, format: ReportExportFormat, email: string}): Promise<void> { return this.makeRequest("requestExportKdsOrdersReport", args || {}); }
    getRetrospective(args: {year: number, placeIds: string[]}): Promise<any> { return this.makeRequest("getRetrospective", args || {}); }
    createReserve(args: {eventId: string, reserve: NewReserve}): Promise<string> { return this.makeRequest("createReserve", args || {}); }
    deleteReserve(args: {reserveId: string}): Promise<void> { return this.makeRequest("deleteReserve", args || {}); }
    updateReserve(args: {reserveId: string, reserve: NewReserve}): Promise<void> { return this.makeRequest("updateReserve", args || {}); }
    getReserves(args: {eventId: string}): Promise<Reserve[]> { return this.makeRequest("getReserves", args || {}); }
    getReserveDetail(args: {reserveId: string}): Promise<ReserveDetail> { return this.makeRequest("getReserveDetail", args || {}); }
    getReserveDiscountDetails(args: {reserveId: string}): Promise<ReserveDiscountDetail[]> { return this.makeRequest("getReserveDiscountDetails", args || {}); }
    getReserveReportAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<ReserveReportRow[]> { return this.makeRequest("getReserveReportAtPlace", args || {}); }
    getReserveReportAtEvent(args: {eventId: string}): Promise<ReserveReportRow[]> { return this.makeRequest("getReserveReportAtEvent", args || {}); }
    getReserveReportDetail(args: {reserveId: string}): Promise<ReserveReportDetails> { return this.makeRequest("getReserveReportDetail", args || {}); }
    createReserveTemplate(args: {reserveTemplate: NewReserveTemplate}): Promise<string> { return this.makeRequest("createReserveTemplate", args || {}); }
    getReserveTemplates(args: {placeId: string, pagination: Pagination}): Promise<ReserveTemplate[]> { return this.makeRequest("getReserveTemplates", args || {}); }
    deleteReserveTemplate(args: {reserveTemplateId: string}): Promise<void> { return this.makeRequest("deleteReserveTemplate", args || {}); }
    getProductsAtStorage(args: {placeId?: string | null, storageId: string, filters: GetProductsAtStorageFilters}): Promise<StorageProduct[]> { return this.makeRequest("getProductsAtStorage", args || {}); }
    getAllBackofficeStorages(args: {organizationId: string}): Promise<BackofficeStorage[]> { return this.makeRequest("getAllBackofficeStorages", args || {}); }
    getBackofficeProductStorageHistoryXls(args: {placeId: string, storageId: string, productId: string, filterBy?: GetBackofficeProductStorageHistoryXlsFilterBy | null, since: Date, until: Date}): Promise<string> { return this.makeRequest("getBackofficeProductStorageHistoryXls", args || {}); }
    createStorageAlerts(args: {placeId: string, alerts: NewProductAlert[]}): Promise<ResultCreateProductRule> { return this.makeRequest("createStorageAlerts", args || {}); }
    editStorageAlerts(args: {placeId: string, alerts: EditProductAlert[]}): Promise<ResultEditProductRule> { return this.makeRequest("editStorageAlerts", args || {}); }
    deleteStorageAlerts(args: {placeId: string, ids: string[]}): Promise<void> { return this.makeRequest("deleteStorageAlerts", args || {}); }
    getStorageAlerts(args: {placeId: string}): Promise<ProductAlert[]> { return this.makeRequest("getStorageAlerts", args || {}); }
    addEmailToMinimumStorageAlert(args: {placeId: string, users: UserAlert[]}): Promise<void> { return this.makeRequest("addEmailToMinimumStorageAlert", args || {}); }
    removeEmailToMinimumStorageAlert(args: {placeId: string, emails: string[]}): Promise<void> { return this.makeRequest("removeEmailToMinimumStorageAlert", args || {}); }
    getEmailsToMinimumStorageAlert(args: {placeId: string}): Promise<UserAlert[]> { return this.makeRequest("getEmailsToMinimumStorageAlert", args || {}); }
    hasCentralStorage(args: {organizationId: string}): Promise<boolean> { return this.makeRequest("hasCentralStorage", args || {}); }
    getProductsWithoutRetroUnitCostFilled(args: {placeId: string, since: Date, until: Date}): Promise<ProductWithoutCostAtStorage[]> { return this.makeRequest("getProductsWithoutRetroUnitCostFilled", args || {}); }
    updateProductsWithoutUnitCostOnSells(args: {placeId: string, products: UpdatedProductWithoutCostAtStorage[]}): Promise<void> { return this.makeRequest("updateProductsWithoutUnitCostOnSells", args || {}); }
    exportProductsWithoutUnitCostOnSells(args: {placeId: string, since: Date, until: Date}): Promise<string> { return this.makeRequest("exportProductsWithoutUnitCostOnSells", args || {}); }
    getBackofficeProductionHistoryForProducts(args: {placeId: string, query?: string | null, since?: Date | null, until?: Date | null, page?: number | null, itemsPerPage?: number | null, orderBy?: GetBackofficeProductionHistoryForProductsOrderBy | null, order?: GetBackofficeProductionHistoryForProductsOrder | null}): Promise<BackofficeProductionHistoryResult> { return this.makeRequest("getBackofficeProductionHistoryForProducts", args || {}); }
    getBackofficeProduction(args: {placeId: string, productionId: string}): Promise<Production> { return this.makeRequest("getBackofficeProduction", args || {}); }
    exportBackofficeProductionHistoryForProducts(args: {placeId: string, query?: string | null, since?: Date | null, until?: Date | null, orderBy?: ExportBackofficeProductionHistoryForProductsOrderBy | null, order?: ExportBackofficeProductionHistoryForProductsOrder | null}): Promise<string> { return this.makeRequest("exportBackofficeProductionHistoryForProducts", args || {}); }
    getProfitMarginReport(args: {placeId: string, since: Date, until: Date, productName?: string | null, categoryName?: string | null}): Promise<ProfitMarginReportResult> { return this.makeRequest("getProfitMarginReport", args || {}); }
    exportProfitMarginReport(args: {placeId: string, since: Date, until: Date, productName?: string | null, categoryName?: string | null}): Promise<string> { return this.makeRequest("exportProfitMarginReport", args || {}); }
    getStoragesTransfersHistory(args: {placeId: string, filters: GetStoragesTransfersHistoryByContextFilters}): Promise<StorageTransferHistoryResult> { return this.makeRequest("getStoragesTransfersHistory", args || {}); }
    exportStoragesTransfersHistory(args: {placeId: string, filters: BaseGetStoragesTransfersHistoryByContextFilters}): Promise<string> { return this.makeRequest("exportStoragesTransfersHistory", args || {}); }
    getBackofficeTransfersBetweenStorages(args: {placeId: string, orderBy?: GetBackofficeTransfersBetweenStoragesOrderBy | null, order?: GetBackofficeTransfersBetweenStoragesOrder | null, filters: GetBackofficeTransfersBetweenStoragesFilters}): Promise<BackofficeTransfersBetweenStoragesResult> { return this.makeRequest("getBackofficeTransfersBetweenStorages", args || {}); }
    exportBackofficeTransfersBetweenStorages(args: {placeId: string, orderBy?: ExportBackofficeTransfersBetweenStoragesOrderBy | null, order?: ExportBackofficeTransfersBetweenStoragesOrder | null, filters: BaseGetBackofficeTransfersBetweenStoragesFilters}): Promise<string> { return this.makeRequest("exportBackofficeTransfersBetweenStorages", args || {}); }
    exportLostReport(args: {placeId: string, storageIds?: string[] | null, since: Date, until: Date}): Promise<string> { return this.makeRequest("exportLostReport", args || {}); }
    exportBackofficeProductsStoragesHistory(args: {placeId: string, storageIds: string[], productIds: string[], filterBy?: BackofficeProductStorageHistoryFilterBy | null, since: Date, until: Date}): Promise<string> { return this.makeRequest("exportBackofficeProductsStoragesHistory", args || {}); }
    getTableBarRanges(args: {placeId: string}): Promise<TableBarRangeResponse[]> { return this.makeRequest("getTableBarRanges", args || {}); }
    addTableBarRange(args: {placeId: string, range: BaseTableBarRange}): Promise<TableBarRangeResponse[]> { return this.makeRequest("addTableBarRange", args || {}); }
    editTableBarRange(args: {id: string, range: BaseTableBarRange}): Promise<TableBarRangeResponse[]> { return this.makeRequest("editTableBarRange", args || {}); }
    deleteRange(args: {id: string}): Promise<TableBarRangeResponse[]> { return this.makeRequest("deleteRange", args || {}); }
    getTableMapByEnvironmentAndStatus(args: {placeId: string, filters?: TableMapFilters | null, pagination: Pagination}): Promise<GetTablesByEnvironmentAndStatusResponse> { return this.makeRequest("getTableMapByEnvironmentAndStatus", args || {}); }
    getTableMapOverview(args: {placeId: string}): Promise<TableMapOverview> { return this.makeRequest("getTableMapOverview", args || {}); }
    getEntrancesSoldAtEventInPeriod(args: {eventId: string, since?: Date | null, until?: Date | null}): Promise<EntranceSold[]> { return this.makeRequest("getEntrancesSoldAtEventInPeriod", args || {}); }
    getProductsSoldAtEventInPeriod(args: {eventId: string, since?: Date | null, until?: Date | null, sources?: TransactionSource[] | null}): Promise<ProductSold[]> { return this.makeRequest("getProductsSoldAtEventInPeriod", args || {}); }
    getProductsSoldAtEventInPeriodV2(args: {eventId?: string | null, placeId?: string | null, since?: Date | null, until?: Date | null, sources?: TransactionSource[] | null}): Promise<ProductSoldV2[]> { return this.makeRequest("getProductsSoldAtEventInPeriodV2", args || {}); }
    getUser(args: {placeId: string, cpf?: string | null, phone?: string | null}): Promise<User> { return this.makeRequest("getUser", args || {}); }
    getUserAtEvent(args: {eventId: string, filter: UserFilter}): Promise<User> { return this.makeRequest("getUserAtEvent", args || {}); }
    getUserDetailsAtEvent(args: {eventId: string, userId: string}): Promise<UserDetails> { return this.makeRequest("getUserDetailsAtEvent", args || {}); }
    getUserDetailsAtPlace(args: {placeId: string, userId: string, since: Date, until: Date}): Promise<UserDetails> { return this.makeRequest("getUserDetailsAtPlace", args || {}); }
    editUserDetails(args: {userId: string, user: EditUser}): Promise<void> { return this.makeRequest("editUserDetails", args || {}); }
    getUserRechargesInEvent(args: {userId: string, eventId: string}): Promise<UserRecharge[]> { return this.makeRequest("getUserRechargesInEvent", args || {}); }
    giveRechargeToUsers(args: {eventId: string, recharges: NewUserRecharge[], prioritizeDigitalCardOnRecharge?: boolean | null}): Promise<GiveRechargeError[]> { return this.makeRequest("giveRechargeToUsers", args || {}); }
    giveRechargeToUser(args: {placeId: string, recharge: NewUserRecharge, documentType?: UserDocumentType | null, prioritizeDigitalCardOnRecharge?: boolean | null}): Promise<void> { return this.makeRequest("giveRechargeToUser", args || {}); }
    giveRechargeToInternationalUsers(args: {eventId: string, recharges: InternationalUserRecharge[], prioritizeDigitalCardOnRecharge?: boolean | null}): Promise<GiveRechargeError[] | null> { return this.makeRequest("giveRechargeToInternationalUsers", args || {}); }
    getAllUsersAtEvent(args: {eventId: string}): Promise<EventUser[]> { return this.makeRequest("getAllUsersAtEvent", args || {}); }
    getEventUserAtEvent(args: {eventId: string, userId: string}): Promise<EventUser> { return this.makeRequest("getEventUserAtEvent", args || {}); }
    getClientsAtPlaceWithFilter(args: {placeId: string, filters: SearchFilters, pagination?: Pagination | null}): Promise<ClientsAtPlaceResponse | null> { return this.makeRequest("getClientsAtPlaceWithFilter", args || {}); }
    getClientsAtPlaceWithFilterXls(args: {placeId: string, filters: SearchFilters}): Promise<string> { return this.makeRequest("getClientsAtPlaceWithFilterXls", args || {}); }
    getUserByCpf(args: {placeId: string, cpf: string}): Promise<SearchResult | null> { return this.makeRequest("getUserByCpf", args || {}); }
    getUserByName(args: {placeId: string, name: string, limit: number}): Promise<SearchResult[]> { return this.makeRequest("getUserByName", args || {}); }
    getUsersFromProducts(args: {placeId: string, productIds: string[], period: PeriodTime, limit: number, offset: number}): Promise<SearchResult[]> { return this.makeRequest("getUsersFromProducts", args || {}); }
    getUsersFromProductsXls(args: {placeId: string, productIds: string[], period: PeriodTime, limit: number, offset: number}): Promise<string> { return this.makeRequest("getUsersFromProductsXls", args || {}); }
    getUserDetailsPastBills(args: {placeId: string, userId: string, since: Date, until: Date}): Promise<UserDetailsByEvents[]> { return this.makeRequest("getUserDetailsPastBills", args || {}); }
    getClientsAtMultiplePlaceWithFilter(args: {placeIds: string[], filters: ClientSearchFilters, offset: number}): Promise<ClientSearchResult[]> { return this.makeRequest("getClientsAtMultiplePlaceWithFilter", args || {}); }
    getClientsAtMultiplePlaceWithFilterXls(args: {placeIds: string[], filters: ClientSearchFilters}): Promise<string> { return this.makeRequest("getClientsAtMultiplePlaceWithFilterXls", args || {}); }
    getUserConsolidatedHistoryInEvent(args: {eventId: string, userId: string}): Promise<ConsolidatedHistory> { return this.makeRequest("getUserConsolidatedHistoryInEvent", args || {}); }
    getUserConsolidatedHistoryInPlace(args: {placeId: string, userId: string, since: Date, until: Date}): Promise<ConsolidatedHistory[]> { return this.makeRequest("getUserConsolidatedHistoryInPlace", args || {}); }
    getUserConsolidatedHistoryInOrganization(args: {placeIds: string[], userId: string, since: Date, until: Date}): Promise<ConsolidatedHistory[]> { return this.makeRequest("getUserConsolidatedHistoryInOrganization", args || {}); }
    getUserCompleteHistoryInEvent(args: {eventId: string, userId: string}): Promise<UserEventHistory> { return this.makeRequest("getUserCompleteHistoryInEvent", args || {}); }
    getUserCompleteHistoryInPlace(args: {placeId: string, userId: string, since: Date, until: Date}): Promise<UserEventHistory[]> { return this.makeRequest("getUserCompleteHistoryInPlace", args || {}); }
    getUserCompleteHistoryInOrganization(args: {placeIds: string[], userId: string, since: Date, until: Date}): Promise<UserEventHistory[]> { return this.makeRequest("getUserCompleteHistoryInOrganization", args || {}); }
    getUserTransaction(args: {id: string, userId: string}): Promise<UserTransactionResponse> { return this.makeRequest("getUserTransaction", args || {}); }
    getUserSingleProductReturn(args: {id: string}): Promise<UserTransactionResponse> { return this.makeRequest("getUserSingleProductReturn", args || {}); }
    getUserRefundTransaction(args: {id: string}): Promise<UserRefundTransaction> { return this.makeRequest("getUserRefundTransaction", args || {}); }
    getUserPostPayment(args: {id: string}): Promise<PostPaymentWithPastBill> { return this.makeRequest("getUserPostPayment", args || {}); }
    getOpenedBillsForClient(args: {userId: string, placeId: string, since: Date, until: Date}): Promise<ClientOpenedBill[]> { return this.makeRequest("getOpenedBillsForClient", args || {}); }
    getBonusForClient(args: {userId: string, placeId: string, since: Date, until: Date}): Promise<ClientBonus[]> { return this.makeRequest("getBonusForClient", args || {}); }
    getDiscountForClient(args: {userId: string, placeId: string, since: Date, until: Date}): Promise<ClientDiscount[]> { return this.makeRequest("getDiscountForClient", args || {}); }
    payOpenedBillAtEventWithUserBalance(args: {userId: string, eventId: string}): Promise<void> { return this.makeRequest("payOpenedBillAtEventWithUserBalance", args || {}); }
    getClientTransactionTransferProducts(args: {transactionId: string}): Promise<ClientTransferTransactionDetails[]> { return this.makeRequest("getClientTransactionTransferProducts", args || {}); }
    getClientOnlineFichaHistoryAtEvent(args: {userId: string, eventId: string}): Promise<ClientOnlineFichaHistory[]> { return this.makeRequest("getClientOnlineFichaHistoryAtEvent", args || {}); }
    refundAppSell(args: {transactionId: string, reason: string, shouldReturnToStorage: boolean}): Promise<void> { return this.makeRequest("refundAppSell", args || {}); }
    getSuggestedImages(args: {keyword: string}): Promise<string[]> { return this.makeRequest("getSuggestedImages", args || {}); }
    getAllOfflineActionTypes(args?: {}): Promise<AllOfflineActionTypes[]> { return this.makeRequest("getAllOfflineActionTypes", args || {}); }
    getVendors(args?: {}): Promise<VendorOrg[]> { return this.makeRequest("getVendors", args || {}); }
    getVendorsForPlace(args: {placeId: string}): Promise<VendorOrg[]> { return this.makeRequest("getVendorsForPlace", args || {}); }
    deleteVendor(args: {id: string}): Promise<void> { return this.makeRequest("deleteVendor", args || {}); }
    setVendorFeatures(args: {vendorId: string, features: string[]}): Promise<void> { return this.makeRequest("setVendorFeatures", args || {}); }
    getVendorFeatures(args: {vendorId: string}): Promise<VendorFeature[]> { return this.makeRequest("getVendorFeatures", args || {}); }
    getVendorProductFees(args: {id: string}): Promise<VendorProductFee[]> { return this.makeRequest("getVendorProductFees", args || {}); }
    editVendorProductFees(args: {id: string, fees: VendorProductFee[]}): Promise<VendorProductFee[]> { return this.makeRequest("editVendorProductFees", args || {}); }
    getVendorClosingsAtEvent(args: {eventId: string}): Promise<VendorClosing[]> { return this.makeRequest("getVendorClosingsAtEvent", args || {}); }
    getVendorClosings(args: {placeId: string, since: Date, until: Date}): Promise<VendorClosing[]> { return this.makeRequest("getVendorClosings", args || {}); }
    getVendorProductSoldAtEvent(args: {vendorId: string, eventId: string}): Promise<ProductSold[]> { return this.makeRequest("getVendorProductSoldAtEvent", args || {}); }
    getVendorProductSold(args: {vendorId: string, placeId: string, since: Date, until: Date}): Promise<ProductSold[]> { return this.makeRequest("getVendorProductSold", args || {}); }
    getVendorsRevenuesAtEvent(args: {eventId: string}): Promise<VendorRevenue[]> { return this.makeRequest("getVendorsRevenuesAtEvent", args || {}); }
    getVendorsRevenues(args: {placeId: string, since: Date, until: Date}): Promise<VendorRevenue[]> { return this.makeRequest("getVendorsRevenues", args || {}); }
    createAdjustmentInVendorExtract(args: {adjust: VendorFinancialAdjustDto}): Promise<void> { return this.makeRequest("createAdjustmentInVendorExtract", args || {}); }
    createAdjustmentsInVendorExtract(args: {placeId: string, adjusts: VendorFinancialAdjustDto[]}): Promise<void> { return this.makeRequest("createAdjustmentsInVendorExtract", args || {}); }
    getVendorExtractAdjustments(args: {placeId: string, since: Date, until: Date}): Promise<VendorFinancialAdjustResponse[]> { return this.makeRequest("getVendorExtractAdjustments", args || {}); }
    revertVendorWithdrawRequest(args: {placeId: string, withdrawId: string, reason: string}): Promise<void> { return this.makeRequest("revertVendorWithdrawRequest", args || {}); }
    getOpenVendorWithdrawRequests(args: {placeId: string, period?: PeriodTime | null}): Promise<VendorWithdrawalRequestResponse[]> { return this.makeRequest("getOpenVendorWithdrawRequests", args || {}); }
    payVendorWithdrawRequest(args: {placeId: string, withdrawId: string, methodType: VendorWithdrawRequestMethod, attachments?: Attachment[] | null, obs?: string | null}): Promise<void> { return this.makeRequest("payVendorWithdrawRequest", args || {}); }
    payVendorWithdrawRequests(args: {placeId: string, withdrawIds: string[], methodType: VendorWithdrawRequestMethod, obs?: string | null, attachments?: Attachment[] | null}): Promise<void> { return this.makeRequest("payVendorWithdrawRequests", args || {}); }
    getVendorWithdrawRequestsHistory(args: {placeId: string, since: Date, until: Date}): Promise<VendorWithdrawRequestHistoryResponse[]> { return this.makeRequest("getVendorWithdrawRequestsHistory", args || {}); }
    getExtractOfValuesOwedToTheVendors(args: {placeId: string}): Promise<GetExtractOfValuesOwedToTheVendors> { return this.makeRequest("getExtractOfValuesOwedToTheVendors", args || {}); }
    getVendorDebtors(args: {vendorId: string, since: Date, until: Date, placeId: string}): Promise<VendorDebtor[]> { return this.makeRequest("getVendorDebtors", args || {}); }
    getZigTagBlockConfirmsAtEvent(args: {eventId: string}): Promise<ZigTagBlockConfirm[]> { return this.makeRequest("getZigTagBlockConfirmsAtEvent", args || {}); }
    getZigTagBlockConfirmsAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<ZigTagBlockConfirm[]> { return this.makeRequest("getZigTagBlockConfirmsAtPlace", args || {}); }
    getZigTagSyncForcesAtEvent(args: {eventId: string}): Promise<ZigTagSyncForce[]> { return this.makeRequest("getZigTagSyncForcesAtEvent", args || {}); }
    getZigTagSyncForcesAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<ZigTagSyncForce[]> { return this.makeRequest("getZigTagSyncForcesAtPlace", args || {}); }
    getZigTag(args: {eventId: string, zigCode: string}): Promise<ZigTag> { return this.makeRequest("getZigTag", args || {}); }
    blockZigDeviceIfPossible(args: {id: string, eventId: string}): Promise<void> { return this.makeRequest("blockZigDeviceIfPossible", args || {}); }
    blockZigDeviceByZigCodes(args: {zigCodes: string[], placeId: string}): Promise<void> { return this.makeRequest("blockZigDeviceByZigCodes", args || {}); }
    unblockZigDeviceByZigCodes(args: {zigCodes: string[], placeId: string}): Promise<void> { return this.makeRequest("unblockZigDeviceByZigCodes", args || {}); }
    createZigDeviceGroup(args: {placeId: string, name: string}): Promise<ZigDeviceGroup> { return this.makeRequest("createZigDeviceGroup", args || {}); }
    getZigDevicesWithGroups(args: {placeId: string}): Promise<ZigDeviceWithGroupAndBalance[]> { return this.makeRequest("getZigDevicesWithGroups", args || {}); }
    getZigDeviceGroupsByPlace(args: {placeId: string}): Promise<ZigDeviceGroup[]> { return this.makeRequest("getZigDeviceGroupsByPlace", args || {}); }
    editZigDeviceGroupOfZigDevices(args: {zigCodes: string[], zigDeviceGroupId?: string | null}): Promise<void> { return this.makeRequest("editZigDeviceGroupOfZigDevices", args || {}); }
    getMessages(args: {page: number, limit: number, campaignIds?: string[] | null}): Promise<Message[]> { return this.makeRequest("getMessages", args || {}); }
    cancelMessage(args: {id: string}): Promise<void> { return this.makeRequest("cancelMessage", args || {}); }
    editMessageClients(args: {id: string, clients: MessageClient[]}): Promise<MessageClientInsertResponse[]> { return this.makeRequest("editMessageClients", args || {}); }
    getMessageClients(args: {id: string, page: number, limit: number}): Promise<MessageClient[]> { return this.makeRequest("getMessageClients", args || {}); }
    getMessageClientData(args: {placeId: string, userIds: string[]}): Promise<MessageClientDataForPlace[]> { return this.makeRequest("getMessageClientData", args || {}); }
    createMessage(args: {message: NewMessage}): Promise<Message> { return this.makeRequest("createMessage", args || {}); }
    getSentMessageClients(args: {id: string, page: number, limit: number}): Promise<SentMessageClient[]> { return this.makeRequest("getSentMessageClients", args || {}); }
    getMessageExamples(args: {placeId: string}): Promise<string[]> { return this.makeRequest("getMessageExamples", args || {}); }
    getMessage(args: {id: string}): Promise<Message> { return this.makeRequest("getMessage", args || {}); }
    editMessage(args: {id: string, campaign: EditMessage}): Promise<Message> { return this.makeRequest("editMessage", args || {}); }
    getSentMessageClientsResume(args: {messageId: string, channel: string}): Promise<MessageSentResume> { return this.makeRequest("getSentMessageClientsResume", args || {}); }
    createMessageCampaign(args: {name: string}): Promise<MessageCampaign> { return this.makeRequest("createMessageCampaign", args || {}); }
    fetchMessagesCampaign(args: {id?: string | null, name?: string | null}): Promise<MessageCampaign[]> { return this.makeRequest("fetchMessagesCampaign", args || {}); }
    createMessageTemplate(args: {messageTemplate: MessageTemplate}): Promise<MessageTemplateResponse> { return this.makeRequest("createMessageTemplate", args || {}); }
    updateMessageTemplate(args: {id: string, messageTemplate: MessageTemplate}): Promise<MessageTemplateResponse> { return this.makeRequest("updateMessageTemplate", args || {}); }
    updateStatusMessageTemplate(args: {id: string, status: MessageTemplateStatus}): Promise<MessageTemplateResponse> { return this.makeRequest("updateStatusMessageTemplate", args || {}); }
    getMessageTemplate(args: {id: string}): Promise<MessageTemplateResponse> { return this.makeRequest("getMessageTemplate", args || {}); }
    fetchMessageTemplate(args: {placeId: string}): Promise<MessageTemplateResponse[]> { return this.makeRequest("fetchMessageTemplate", args || {}); }
    fetchMessageTemplateTwilio(args?: {}): Promise<void> { return this.makeRequest("fetchMessageTemplateTwilio", args || {}); }
    updateMessageTemplateTwilio(args?: {}): Promise<void> { return this.makeRequest("updateMessageTemplateTwilio", args || {}); }
    setMessageTemplateTwilioIsUsed(args: {id: string}): Promise<MessageTemplateResponse> { return this.makeRequest("setMessageTemplateTwilioIsUsed", args || {}); }
    getCampaignsInvestment(args: {placeIds: string[], since: Date, until: Date}): Promise<CampaignsInvestmentResult> { return this.makeRequest("getCampaignsInvestment", args || {}); }
    sendMessageCronJob(args?: {}): Promise<void> { return this.makeRequest("sendMessageCronJob", args || {}); }
    getMessagesSentAnalytics(args: {filters: MessagesSentAnalyticsFilters}): Promise<MessagesSentAnalytics> { return this.makeRequest("getMessagesSentAnalytics", args || {}); }
    getMessagesSentList(args: {filters: MessagesSentAnalyticsFilters, pagination: Pagination}): Promise<MessagesSentListResult> { return this.makeRequest("getMessagesSentList", args || {}); }
    requestExportMessagesSent(args: {filters: MessagesSentAnalyticsFilters, format: ReportExportFormat, email: string}): Promise<void> { return this.makeRequest("requestExportMessagesSent", args || {}); }
    getBackofficeNewChartAccountCode(args: {chartAccountParentId?: string | null}): Promise<string> { return this.makeRequest("getBackofficeNewChartAccountCode", args || {}); }
    createBackOfficeChartAccount(args: {chartAccount: BackOfficeChartAccountCreate}): Promise<BackOfficeChartAccountResponse> { return this.makeRequest("createBackOfficeChartAccount", args || {}); }
    updateBackOfficeChartAccount(args: {chartAccountId: string, chartAccount: BackOfficeChartAccountUpdate}): Promise<BackOfficeChartAccountResponse> { return this.makeRequest("updateBackOfficeChartAccount", args || {}); }
    deleteBackOfficeChartAccount(args: {chartAccountId: string}): Promise<void> { return this.makeRequest("deleteBackOfficeChartAccount", args || {}); }
    getBackOfficeChartAccountTree(args?: {}): Promise<BackOfficeChartAccountResponseTree[]> { return this.makeRequest("getBackOfficeChartAccountTree", args || {}); }
    getBackOfficeChartAccount(args: {id: string}): Promise<BackOfficeChartAccountResponse> { return this.makeRequest("getBackOfficeChartAccount", args || {}); }
    importBackofficeChartAccountXlsx(args: {file: ArrayBuffer}): Promise<BackOfficeChartAccountResponse[]> { return this.makeRequest("importBackofficeChartAccountXlsx", args || {}); }
    exportBackofficeDefaultChartAccountXlsx(args?: {}): Promise<string> { return this.makeRequest("exportBackofficeDefaultChartAccountXlsx", args || {}); }
    exportBackofficeChartAccount(args?: {}): Promise<ArrayBuffer> { return this.makeRequest("exportBackofficeChartAccount", args || {}); }
    setBackOfficeDefaultChartAccountToOrganization(args?: {}): Promise<any> { return this.makeRequest("setBackOfficeDefaultChartAccountToOrganization", args || {}); }
    getBackofficeChartAccounts(args: {operation?: BackOfficeOperationChartAccount | null, acceptTransactions?: boolean | null, isDre?: boolean | null, isCashflow?: boolean | null}): Promise<BackOfficeChartAccountResponse[]> { return this.makeRequest("getBackofficeChartAccounts", args || {}); }
    getBackofficeAvailableChartAccountsForImportedInvoices(args?: {}): Promise<BackOfficeChartAccountResponse[]> { return this.makeRequest("getBackofficeAvailableChartAccountsForImportedInvoices", args || {}); }
    getBackOfficeChartAccountTreeDefault(args?: {}): Promise<any> { return this.makeRequest("getBackOfficeChartAccountTreeDefault", args || {}); }
    updateBackofficeChartAccountDefaultList(args: {organizationId: string}): Promise<void> { return this.makeRequest("updateBackofficeChartAccountDefaultList", args || {}); }
    getBackofficeChartAccountsAsTree(args: {searchTerm?: string | null, operation?: BackOfficeOperationChartAccount | null, acceptTransactions?: boolean | null, isDre?: boolean | null, isCashflow?: boolean | null}): Promise<BackOfficeChartAccountTree[]> { return this.makeRequest("getBackofficeChartAccountsAsTree", args || {}); }
    getBackofficeAccountV2(args: {placeId: string, accountId: string}): Promise<BackofficeAccountV2> { return this.makeRequest("getBackofficeAccountV2", args || {}); }
    getBackofficeAccountsV2(args: {placeId: string, showDeleted?: boolean | null}): Promise<BackofficeAccountV2[]> { return this.makeRequest("getBackofficeAccountsV2", args || {}); }
    createBackofficeAccountV2(args: {placeId: string, account: BackofficeBaseAccountV2}): Promise<void> { return this.makeRequest("createBackofficeAccountV2", args || {}); }
    updateBackofficeAccount(args: {placeId: string, accountId: string, account: BackofficeBaseAccountV2}): Promise<void> { return this.makeRequest("updateBackofficeAccount", args || {}); }
    deleteBackofficeAccountV2(args: {placeId: string, accountId: string}): Promise<void> { return this.makeRequest("deleteBackofficeAccountV2", args || {}); }
    createBackofficeAccountBills(args: {placeId: string, account: BackofficeBaseAccountBills}): Promise<BackofficeGetAccountBillsResponse> { return this.makeRequest("createBackofficeAccountBills", args || {}); }
    getBackofficeAccountBills(args: {placeId: string, id: string, type: BackofficeTypeAccountBills}): Promise<BackofficeGetAccountBillsResponse | null> { return this.makeRequest("getBackofficeAccountBills", args || {}); }
    getBackofficeAccountsBills(args: {placeId: string, params: BackofficeGetParamsAccountsBills}): Promise<BackofficeGetAccountBillsResponseWithPagination> { return this.makeRequest("getBackofficeAccountsBills", args || {}); }
    getBackofficeResumeAccounts(args: {params: BackofficeGetParamsAccountsBills}): Promise<BackofficeGetResumeAccountBillsResponse> { return this.makeRequest("getBackofficeResumeAccounts", args || {}); }
    deleteBackofficeAccountBills(args: {placeId: string, id: string}): Promise<boolean> { return this.makeRequest("deleteBackofficeAccountBills", args || {}); }
    updateBackofficeAccountBills(args: {id: string, placeId: string, account: BackofficeBaseAccountBills}): Promise<BackofficeGetAccountBillsResponse> { return this.makeRequest("updateBackofficeAccountBills", args || {}); }
    getBackofficeAccountBillsRecurrences(args: {placeId: string, recurringGroupId: string, type: BackofficeTypeAccountBills}): Promise<BackofficeGetAccountBillsResponse[]> { return this.makeRequest("getBackofficeAccountBillsRecurrences", args || {}); }
    createBackofficeAccountBillAttachment(args: {placeId: string, accountBillId: string, attachment: BackofficeAttachment}): Promise<boolean> { return this.makeRequest("createBackofficeAccountBillAttachment", args || {}); }
    deleteBackofficeAccountBillAttachment(args: {placeId: string, accountBillId: string, attachmentId: string}): Promise<boolean> { return this.makeRequest("deleteBackofficeAccountBillAttachment", args || {}); }
    getBackofficeDRE(args: {placeId: string, interval: BackofficeParamDates}): Promise<BackofficeAccountBillsReportResponse | null> { return this.makeRequest("getBackofficeDRE", args || {}); }
    setBackofficeAccountBillIsPaid(args: {placeId: string, id: string, isPaid: boolean}): Promise<boolean> { return this.makeRequest("setBackofficeAccountBillIsPaid", args || {}); }
    getEventClosingDataToConference(args: {eventId: string, placeId: string}): Promise<FinancialEventClosingConference> { return this.makeRequest("getEventClosingDataToConference", args || {}); }
    createBackofficeAccountBillsOnClosingEvent(args: {eventId: string, placeId: string, eventName: string}): Promise<void> { return this.makeRequest("createBackofficeAccountBillsOnClosingEvent", args || {}); }
    previewBackofficeInstallments(args: {request: BackofficePreviewInstallmentsRequest}): Promise<BackofficeInstallmentPreviewResponse[]> { return this.makeRequest("previewBackofficeInstallments", args || {}); }
    updateBackofficePreviewInstallments(args: {request: BackofficeUpdatePreviewInstallmentsRequest}): Promise<BackofficeInstallmentPreviewResponse[]> { return this.makeRequest("updateBackofficePreviewInstallments", args || {}); }
    createBackofficeInstallmentAccountBills(args: {placeId: string, account: BackofficeBaseAccountBills, installments: BackofficeInstallmentPreviewResponse[], installmentIntervalType?: TypeInterval | null, installmentIntervalValue?: number | null}): Promise<BackofficeCreateInstallmentResponse> { return this.makeRequest("createBackofficeInstallmentAccountBills", args || {}); }
    updateBackofficeFinancialAccountOnPayment(args: {placeId: string, accountBillId: string, type: BackofficeTypeAccountBills, paymentDate: Date, accountId: string, paymentMethod?: BackofficePaymentMethod | null, accountBillValues?: BackofficeAccountBillValues | null}): Promise<boolean> { return this.makeRequest("updateBackofficeFinancialAccountOnPayment", args || {}); }
    exportBackofficeAccountsPayableReceivable(args: {placeId: string, params: BackofficeGetParamsAccountsBills}): Promise<string> { return this.makeRequest("exportBackofficeAccountsPayableReceivable", args || {}); }
    addBackofficeMissingAccountBillsOnEventClosing(args: {params: MissingAccountBillsOnEventClosingParams}): Promise<boolean> { return this.makeRequest("addBackofficeMissingAccountBillsOnEventClosing", args || {}); }
    getBackofficeAccountBillHistory(args: {placeId: string, id: string}): Promise<BackofficeAccountBillHistoryEntry[]> { return this.makeRequest("getBackofficeAccountBillHistory", args || {}); }
    getBackofficeStorageInventories(args: {placeId: string, status?: BackofficeStorageInventoryStatus | null, query?: string | null, orderBy?: GetBackofficeStorageInventoriesOrderBy | null, order?: GetBackofficeStorageInventoriesOrder | null, since?: Date | null, until?: Date | null, categoriesIds?: string[] | null, productsIds?: string[] | null, storageIds?: string[] | null, page?: number | null, itemsPerPage?: number | null}): Promise<BackofficeStorageInventoriesResult> { return this.makeRequest("getBackofficeStorageInventories", args || {}); }
    getBackofficeStorageInventory(args: {placeId: string, id: string}): Promise<CompleteBackofficeStorageInventory> { return this.makeRequest("getBackofficeStorageInventory", args || {}); }
    updateBackofficeStorageInventoryProducts(args: {placeId: string, storageInventoryId: string, products: BackofficeStorageInventoryProduct[]}): Promise<CompleteBackofficeStorageInventory> { return this.makeRequest("updateBackofficeStorageInventoryProducts", args || {}); }
    deleteBackofficeStorageInventoryProducts(args: {placeId: string, storageInventoryId: string, productsIds: string[]}): Promise<string[]> { return this.makeRequest("deleteBackofficeStorageInventoryProducts", args || {}); }
    createBackofficeStorageInventory(args: {placeId: string, name: string, storageId: string, categoriesIds: string[]}): Promise<BackofficeStorageInventoryWithStorage> { return this.makeRequest("createBackofficeStorageInventory", args || {}); }
    updateBackofficeStorageInventoryStatus(args: {placeId: string, storageInventoryId: string, status: BackofficeStorageInventoryStatus, reason?: string | null}): Promise<BackofficeStorageInventoryWithStorage> { return this.makeRequest("updateBackofficeStorageInventoryStatus", args || {}); }
    updateBackofficeStorageInventory(args: {placeId: string, storageInventoryId: string, name: string}): Promise<BackofficeStorageInventoryWithStorage> { return this.makeRequest("updateBackofficeStorageInventory", args || {}); }
    getBackofficeStorageInventoryAndStorageComparison(args: {placeId: string, storageInventoryId: string, filters: GetBackofficeStorageInventoryAndStorageComparisonFilters, order?: GetBackofficeStorageInventoryAndStorageComparisonOrder | null, orderBy?: GetBackofficeStorageInventoryAndStorageComparisonOrderBy | null, pagination?: Pagination | null}): Promise<BackofficeStorageInventoryAndStorageComparison> { return this.makeRequest("getBackofficeStorageInventoryAndStorageComparison", args || {}); }
    exportBackofficeStorageInventoryAndStorageComparison(args: {placeId: string, storageInventoryId: string, filters: GetBackofficeStorageInventoryAndStorageComparisonFilters, order?: ExportBackofficeStorageInventoryAndStorageComparisonOrder | null, orderBy?: ExportBackofficeStorageInventoryAndStorageComparisonOrderBy | null, pagination: Pagination}): Promise<string> { return this.makeRequest("exportBackofficeStorageInventoryAndStorageComparison", args || {}); }
    exportBackofficeStorageInventoryAndStorageComparisonPdf(args: {placeId: string, storageInventoryId: string, filters: GetBackofficeStorageInventoryAndStorageComparisonFilters, order?: ExportBackofficeStorageInventoryAndStorageComparisonPdfOrder | null, orderBy?: ExportBackofficeStorageInventoryAndStorageComparisonPdfOrderBy | null}): Promise<string> { return this.makeRequest("exportBackofficeStorageInventoryAndStorageComparisonPdf", args || {}); }
    deleteBackofficeStorageInventory(args: {placeId: string, storageInventoryId: string}): Promise<void> { return this.makeRequest("deleteBackofficeStorageInventory", args || {}); }
    updateBackofficeStorageInventoryProductsTransferType(args: {placeId: string, storageInventoryId: string, products: BackofficeUpdateStorageInventoryProductsTransferType[]}): Promise<void> { return this.makeRequest("updateBackofficeStorageInventoryProductsTransferType", args || {}); }
    getBackofficeStorageInventoryTopInconsistencies(args: {placeId: string, storageInventoryId: string, limit: number, type: GetBackofficeStorageInventoryTopInconsistenciesType}): Promise<BackofficeStorageInventoryProductInconsistency[]> { return this.makeRequest("getBackofficeStorageInventoryTopInconsistencies", args || {}); }
    getBackofficeStorageInventoriesTotalizers(args: {placeId: string, query?: string | null, since?: Date | null, until?: Date | null, categoriesIds?: string[] | null, productsIds?: string[] | null, storageIds?: string[] | null}): Promise<BackofficeStorageInventoriesTotalizers> { return this.makeRequest("getBackofficeStorageInventoriesTotalizers", args || {}); }
    getHawkerEventSummary(args: {eventId: string}): Promise<Summary> { return this.makeRequest("getHawkerEventSummary", args || {}); }
    getHawkerSales(args: {eventId: string, type: HawkerSaleType, filters?: HawkerReportFilters | null}): Promise<Sales[]> { return this.makeRequest("getHawkerSales", args || {}); }
    getHawkerPayments(args: {eventId: string, filters?: HawkerReportFilters | null}): Promise<HawkerPaymentMethod[]> { return this.makeRequest("getHawkerPayments", args || {}); }
    getHawkerSessions(args: {eventId: string, filters?: HawkerReportFilters | null}): Promise<Sessions[]> { return this.makeRequest("getHawkerSessions", args || {}); }
    getHawkerCycles(args: {eventId: string, hawkerId: string, sessionId: string, filters?: HawkerReportFilters | null}): Promise<Cycle[]> { return this.makeRequest("getHawkerCycles", args || {}); }
    getHawkerCycleSummary(args: {eventId: string, hawkerId: string, hawkerCycleId: string}): Promise<CycleSummary> { return this.makeRequest("getHawkerCycleSummary", args || {}); }
    getHawkersSummary(args: {eventId: string, filters?: HawkerReportFilters | null}): Promise<EventSummary> { return this.makeRequest("getHawkersSummary", args || {}); }
    getHawkerReport(args: {eventId: string, hawkerId: string}): Promise<HawkerReport> { return this.makeRequest("getHawkerReport", args || {}); }
    getHawkersRanking(args: {eventId: string, hawkerCashierNames?: string[] | null, hawkerCashierDocuments?: string[] | null}): Promise<HawkersSummary[]> { return this.makeRequest("getHawkersRanking", args || {}); }
    getTableReportV2(args: {scope: GetTablesReportProps, filters: Filters, pagination: Pagination}): Promise<GetTablesReportV2Response> { return this.makeRequest("getTableReportV2", args || {}); }
    getTableReportTotals(args: {scope: GetTablesReportProps, filters: Filters}): Promise<TablesReportTotals> { return this.makeRequest("getTableReportTotals", args || {}); }
    exportTablesReport(args: {scope: GetTablesReportProps, filters: Filters}): Promise<string> { return this.makeRequest("exportTablesReport", args || {}); }
    getTablesMinimum(args: {scope: GetTablesReportProps}): Promise<GetTablesMinimun[]> { return this.makeRequest("getTablesMinimum", args || {}); }
    getTableReport(args: {eventId?: string | null, placeId?: string | null, since?: Date | null, until?: Date | null}): Promise<GetTableReportResponse> { return this.makeRequest("getTableReport", args || {}); }
    getTableProductReport(args: {eventId?: string | null, placeId?: string | null, since?: Date | null, until?: Date | null}): Promise<TableProductReport[]> { return this.makeRequest("getTableProductReport", args || {}); }
    getEmployeesWithTableInteraction(args: {placeId: string, eventId?: string | null}): Promise<MinimalEmployee[]> { return this.makeRequest("getEmployeesWithTableInteraction", args || {}); }
    getPlaceZendeskTickets(args: {placeId: string, filters: GetPlaceZendeskTicketsFilters, pagination: Pagination}): Promise<ZendeskTicketsPaginationResponse> { return this.makeRequest("getPlaceZendeskTickets", args || {}); }
    listEmployeeZendeskTickets(args: {filters: ListEmployeeZendeskTicketsFilters, pagination: Pagination}): Promise<EmployeeZendeskTicketsPaginationResponse> { return this.makeRequest("listEmployeeZendeskTickets", args || {}); }
    getEmployeeZendeskTicketDetails(args: {ticketId: string}): Promise<ZendeskTicketDetails> { return this.makeRequest("getEmployeeZendeskTicketDetails", args || {}); }
    getZendeskMessagingJwt(args?: {}): Promise<string> { return this.makeRequest("getZendeskMessagingJwt", args || {}); }
    upsertMenuConfigs(args: {placeId: string, data: UpsertMenuConfigRequest}): Promise<UpsertMenuConfigResponse> { return this.makeRequest("upsertMenuConfigs", args || {}); }
    getActiveMenus(args: {placeId: string}): Promise<GetActiveMenusResponse> { return this.makeRequest("getActiveMenus", args || {}); }
    getRatePerRadius(args: {placeId: string, menuConfigId: string}): Promise<GetRatePerRadiusResponse> { return this.makeRequest("getRatePerRadius", args || {}); }
    upsertRatePerRadius(args: {placeId: string, menuConfigId: string, ratePerRadius: DeliveryRatePerRadius[]}): Promise<DeliveryRatePerRadius[]> { return this.makeRequest("upsertRatePerRadius", args || {}); }
    upsertWorkingPeriods(args: {placeId: string, workingPeriods: WorkingPeriods[]}): Promise<void> { return this.makeRequest("upsertWorkingPeriods", args || {}); }
    getWorkingPeriods(args: {placeId: string}): Promise<GetWorkingPeriodsResponse[]> { return this.makeRequest("getWorkingPeriods", args || {}); }
    getMetabases(args?: {}): Promise<OrganizationMetabaseResponse[]> { return this.makeRequest("getMetabases", args || {}); }
    getMetabasesByContext(args: {contextLevel: OrganizationMetabaseContextLevel}): Promise<OrganizationMetabaseResponse[]> { return this.makeRequest("getMetabasesByContext", args || {}); }
    getMetabaseIframeUrl(args: {organizationMetabaseId: string, contextLevel: OrganizationMetabaseContextLevel, eventId?: string | null, placeId?: string | null}): Promise<string> { return this.makeRequest("getMetabaseIframeUrl", args || {}); }
    createPlaceSector(args: {placeSector: NewPlaceSector}): Promise<PlaceSector> { return this.makeRequest("createPlaceSector", args || {}); }
    getPlaceSectors(args: {placeId: string}): Promise<PlaceSector[]> { return this.makeRequest("getPlaceSectors", args || {}); }
    deletePlaceSector(args: {placeSectorId: string}): Promise<PlaceSector> { return this.makeRequest("deletePlaceSector", args || {}); }
    editPlaceSector(args: {placeSectorId: string, placeSector: EditPlaceSector}): Promise<PlaceSector> { return this.makeRequest("editPlaceSector", args || {}); }
    createAccessPolicy(args: {accessPolicy: NewAccessPolicy}): Promise<AccessPolicy> { return this.makeRequest("createAccessPolicy", args || {}); }
    getAccessPolicies(args: {placeId: string, filters?: GetAccessPoliciesFilters | null}): Promise<AccessPolicy[]> { return this.makeRequest("getAccessPolicies", args || {}); }
    getAccessPolicyTags(args: {placeId: string, accessPolicyId: string, pagination: Pagination}): Promise<GetAccessPolicyTags> { return this.makeRequest("getAccessPolicyTags", args || {}); }
    editAccessPolicy(args: {placeId: string, accessPolicyId: string, accessPolicy: EditAccessPolicy}): Promise<AccessPolicy> { return this.makeRequest("editAccessPolicy", args || {}); }
    deleteAccessPolicy(args: {placeId: string, accessPolicyId: string}): Promise<AccessPolicy> { return this.makeRequest("deleteAccessPolicy", args || {}); }
    importAccessPolicyTags(args: {placeId: string, accessPolicyId: string, tagIds: string[]}): Promise<void> { return this.makeRequest("importAccessPolicyTags", args || {}); }
    getFinancialEntryTypes(args?: {}): Promise<FinancialEntryTypeGroup[]> { return this.makeRequest("getFinancialEntryTypes", args || {}); }
    ifoodWebhook(args: {signature: string, event: IfoodWebhookEventInput}): Promise<IfoodWebhookEventOutput> { return this.makeRequest("ifoodWebhook", args || {}); }
    getIntegrationTokens(args?: {}): Promise<IntegrationToken[]> { return this.makeRequest("getIntegrationTokens", args || {}); }
    getAvailablePlacesForToken(args?: {}): Promise<Place[]> { return this.makeRequest("getAvailablePlacesForToken", args || {}); }
    createIntegrationToken(args: {placeIds?: string[] | null}): Promise<IntegrationToken> { return this.makeRequest("createIntegrationToken", args || {}); }
    deleteIntegrationToken(args: {tokenId: string}): Promise<void> { return this.makeRequest("deleteIntegrationToken", args || {}); }
    listEquipmentsByPlace(args: {request: ListEquipmentsByPlaceRequest}): Promise<ListEquipmentsByPlaceResponse> { return this.makeRequest("listEquipmentsByPlace", args || {}); }
    getEquipmentsByPlaceToExcel(args: {request: GetEquipmentsByPlaceToExcelRequest}): Promise<ListEquipmentsByPlaceResponse> { return this.makeRequest("getEquipmentsByPlaceToExcel", args || {}); }
    getSimplifiedOrders(args: {payload: DeliverySimplifiedOrderPayload}): Promise<DeliverySimplifiedOrder[]> { return this.makeRequest("getSimplifiedOrders", args || {}); }
    acceptOrder(args: {placeId: string, orderId: string}): Promise<ManagerDeliveryOrder> { return this.makeRequest("acceptOrder", args || {}); }
    finishOrder(args: {placeId: string, orderId: string}): Promise<ManagerDeliveryOrder> { return this.makeRequest("finishOrder", args || {}); }
    cancelOrder(args: {placeId: string, orderId: string, zigReason?: ZigCancelReason | null, reasonText?: string | null}): Promise<ManagerDeliveryOrder> { return this.makeRequest("cancelOrder", args || {}); }
    dispatchOrder(args: {placeId: string, orderId: string}): Promise<ManagerDeliveryOrder> { return this.makeRequest("dispatchOrder", args || {}); }
    readyOrder(args: {placeId: string, orderId: string}): Promise<ManagerDeliveryOrder> { return this.makeRequest("readyOrder", args || {}); }
    getOrder(args: {placeId: string, orderId: string}): Promise<ManagerDeliveryOrder> { return this.makeRequest("getOrder", args || {}); }
    createManualOrder(args: {placeId: string, payload: CreateManualOrderPayload}): Promise<CreateManualOrderResponse> { return this.makeRequest("createManualOrder", args || {}); }
    calculateDeliveryFee(args: {placeId: string, address: CreateManualOrderAddress}): Promise<CalculateDeliveryFeeResponse> { return this.makeRequest("calculateDeliveryFee", args || {}); }
    upsertDeliveryFeeConfig(args: {placeId: string, payload: UpsertDeliveryFeeConfigPayload}): Promise<DeliveryFeeConfigResponse> { return this.makeRequest("upsertDeliveryFeeConfig", args || {}); }
    getDeliveryFeeConfig(args: {placeId: string}): Promise<DeliveryFeeConfigResponse> { return this.makeRequest("getDeliveryFeeConfig", args || {}); }
    getURLAuthorization(args: {provider: MarketplaceProvider, placeId: string, redirectURI: string}): Promise<GetURLAuthorizationResponse> { return this.makeRequest("getURLAuthorization", args || {}); }
    exchangeAuthIdForMerchantAuthorized(args: {provider: MarketplaceProvider, authId: string, placeId: string}): Promise<void> { return this.makeRequest("exchangeAuthIdForMerchantAuthorized", args || {}); }
    updateMarketplaceStoreStatus(args: {provider: MarketplaceProvider, placeId: string, merchantId?: string | null, isActive: boolean}): Promise<MarketplaceOperationResponse> { return this.makeRequest("updateMarketplaceStoreStatus", args || {}); }
    getAllMarketplaceIntegrationsGroupedByType(args: {placeId: string}): Promise<GetAllMarketplaceIntegrationsGroupedByTypeResponse> { return this.makeRequest("getAllMarketplaceIntegrationsGroupedByType", args || {}); }
    deleteMarketplaceIntegration(args: {placeId: string, storeId: string}): Promise<void> { return this.makeRequest("deleteMarketplaceIntegration", args || {}); }
    openDeliveryWebhook(args: {merchantId: string, signature: string, payload: OpenDeliveryNewEventPayload}): Promise<OpenDeliveryWebhookResponse> { return this.makeRequest("openDeliveryWebhook", args || {}); }
    bindFood99Store(args: {placeId: string, shopId: string}): Promise<MarketplaceStore> { return this.makeRequest("bindFood99Store", args || {}); }
    getPendingsTransactions(args: {request: PendingTransactionsFilters}): Promise<PaginatedPendingsTransactions> { return this.makeRequest("getPendingsTransactions", args || {}); }
    getAcquirerPendingTransactionFilterOptions(args?: {}): Promise<AcquirerPendingTransactionFilterOptionsResponse> { return this.makeRequest("getAcquirerPendingTransactionFilterOptions", args || {}); }
    getPlaceWizardStatus(args: {placeId: string}): Promise<PlaceWizardStatus> { return this.makeRequest("getPlaceWizardStatus", args || {}); }
    savePlaceWizardBarsAndSectorsStep(args: {input: SavePlaceWizardBarsAndSectorsStepInput}): Promise<void> { return this.makeRequest("savePlaceWizardBarsAndSectorsStep", args || {}); }
    getPlaceWizardBasicInformationStep(args: {placeId: string}): Promise<GetPlaceWizardBasicInformationStepResponse> { return this.makeRequest("getPlaceWizardBasicInformationStep", args || {}); }
    savePlaceWizardBasicInformationStep(args: {input: SavePlaceWizardBasicInformationStepInput}): Promise<void> { return this.makeRequest("savePlaceWizardBasicInformationStep", args || {}); }
    getPlaceWizardBarsAndSectorsStep(args: {placeId: string}): Promise<GetPlaceWizardBarsAndSectorsStepResponse> { return this.makeRequest("getPlaceWizardBarsAndSectorsStep", args || {}); }
    getPlaceWizardProductsAndMenusStep(args: {placeId: string}): Promise<GetPlaceWizardProductsAndMenusStepResponse> { return this.makeRequest("getPlaceWizardProductsAndMenusStep", args || {}); }
    savePlaceWizardProductsAndMenusStep(args: {input: SavePlaceWizardProductsAndMenusStepInput}): Promise<void> { return this.makeRequest("savePlaceWizardProductsAndMenusStep", args || {}); }
    getFeatureFlags(args: {placeId?: string | null}): Promise<FeatureFlag[]> { return this.makeRequest("getFeatureFlags", args || {}); }
    getOFXfile(args: {file: ArrayBuffer, placeId: string}): Promise<OFXFileResponse> { return this.makeRequest("getOFXfile", args || {}); }
    createBackofficeBankConciliation(args: {bankConciliation: BackofficeBankConciliation, placeId: string}): Promise<void> { return this.makeRequest("createBackofficeBankConciliation", args || {}); }
    getBackofficeBankConciliation(args: {id: string, placeId: string}): Promise<BackofficeBankConciliationResponse> { return this.makeRequest("getBackofficeBankConciliation", args || {}); }
    getBackofficeBankConciliations(args: {placeId: string, date?: Date | null, status?: BackofficeBankConciliationStatus | null, pagination?: Pagination | null}): Promise<BackofficeBankConciliationResponseWithPagination> { return this.makeRequest("getBackofficeBankConciliations", args || {}); }
    saveBackofficeBankConciliationTransaction(args: {id: string, type: BackofficeSaveBankConciliationType, placeId: string, accountBillId?: string | null}): Promise<boolean> { return this.makeRequest("saveBackofficeBankConciliationTransaction", args || {}); }
    saveBackofficeBankConciliation(args: {id: string, placeId: string}): Promise<boolean> { return this.makeRequest("saveBackofficeBankConciliation", args || {}); }
    exportAllTransactionProductsXlsxPlace(args: {placeId: string, since: Date, until: Date, sectorIds?: string[] | null}): Promise<string> { return this.makeRequest("exportAllTransactionProductsXlsxPlace", args || {}); }
    getReprintsAtEvent(args: {eventId: string}): Promise<Reprint[]> { return this.makeRequest("getReprintsAtEvent", args || {}); }
    getReprintResumeAtEvent(args: {eventId: string}): Promise<ReprintResume[]> { return this.makeRequest("getReprintResumeAtEvent", args || {}); }
    getReprintResumeAtPlace(args: {placeId: string, since: Date, until: Date}): Promise<ReprintResume[]> { return this.makeRequest("getReprintResumeAtPlace", args || {}); }
    productRankingReport(args: {eventId?: string | null, placeId?: string | null, period?: PeriodTime | null}): Promise<ProductRankingReport[]> { return this.makeRequest("productRankingReport", args || {}); }
    productRankingEmployees(args: {productIds: string[], eventId?: string | null, placeId?: string | null, period?: PeriodTime | null}): Promise<EmployeeProductRankingReport[]> { return this.makeRequest("productRankingEmployees", args || {}); }
    getSingleProductReturns(args: {placeId: string, period: PeriodTime}): Promise<SingleProductReturnResponse[]> { return this.makeRequest("getSingleProductReturns", args || {}); }
    getSingleProductReturnsByEvent(args: {eventId: string, placeId: string}): Promise<SingleProductReturnResponse[]> { return this.makeRequest("getSingleProductReturnsByEvent", args || {}); }
    getBiPanelsGroupedByWorkspace(args?: {}): Promise<BIWorkspace[]> { return this.makeRequest("getBiPanelsGroupedByWorkspace", args || {}); }
    createBonusCategory(args: {placeId: string, name: string, daysToExpire: number, status: boolean, employeeIds: string[], categoryIds?: string[] | null, productIds?: string[] | null, lockZigTag?: boolean | null}): Promise<BonusCategory> { return this.makeRequest("createBonusCategory", args || {}); }
    editBonusCategory(args: {id: string, name: string, daysToExpire: number, status: boolean, employeeIds: string[], categoryIds?: string[] | null, productIds?: string[] | null, lockZigTag?: boolean | null}): Promise<BonusCategory> { return this.makeRequest("editBonusCategory", args || {}); }
    getBonusCategories(args: {placeId: string, pagination: Pagination, filters?: BonusCategoryGetFilters | null}): Promise<BonusCategoryGetResponse> { return this.makeRequest("getBonusCategories", args || {}); }
    deleteBonusCategories(args: {bonusCategoryIds: string[]}): Promise<void> { return this.makeRequest("deleteBonusCategories", args || {}); }
    getCashbackConfigs(args?: {}): Promise<CashbackConfig[]> { return this.makeRequest("getCashbackConfigs", args || {}); }
    createCashbackConfig(args: {cashback: BaseCashbackConfig}): Promise<CashbackConfig[]> { return this.makeRequest("createCashbackConfig", args || {}); }
    editCashbackConfig(args: {id: string, cashback: BaseCashbackConfig}): Promise<CashbackConfig[]> { return this.makeRequest("editCashbackConfig", args || {}); }
    editStatusCashbackConfig(args: {id: string, isActive: boolean}): Promise<void> { return this.makeRequest("editStatusCashbackConfig", args || {}); }
    deleteCashbackConfig(args: {id: string}): Promise<void> { return this.makeRequest("deleteCashbackConfig", args || {}); }
    listCashbacks(args: {pagination: Pagination}): Promise<ListCashbackConfigs> { return this.makeRequest("listCashbacks", args || {}); }
    exportListCashbacksXlsx(args?: {}): Promise<string> { return this.makeRequest("exportListCashbacksXlsx", args || {}); }
    listCashbackRescues(args: {period: PeriodTime, pagination: Pagination, cashbackIds: string[]}): Promise<ListCashbackRescues> { return this.makeRequest("listCashbackRescues", args || {}); }
    exportListCashbackRescuesXlsx(args: {period: PeriodTime, cashbackIds: string[]}): Promise<string> { return this.makeRequest("exportListCashbackRescuesXlsx", args || {}); }
    listCashbackRescuesOverview(args: {period: PeriodTime, cashbackIds: string[]}): Promise<ListCashbackRescuesOverview> { return this.makeRequest("listCashbackRescuesOverview", args || {}); }
    applyCashbackForEvents(args: {eventIds: string[]}): Promise<void> { return this.makeRequest("applyCashbackForEvents", args || {}); }
    getCdpUsers(args: {placeIds: string[], filters?: CdpUserFilters | null, pagination?: Pagination | null}): Promise<CdpUsersPage> { return this.makeRequest("getCdpUsers", args || {}); }
    getCdpUser(args: {userId: string, placeIds: string[]}): Promise<CdpUser> { return this.makeRequest("getCdpUser", args || {}); }
    getCdpUsersBySegment(args: {segmentId: string, placeIds: string[]}): Promise<CdpUser[]> { return this.makeRequest("getCdpUsersBySegment", args || {}); }
    getCdpUsersByRfmClassification(args: {classification: RfmClassification, placeIds: string[]}): Promise<CdpUser[]> { return this.makeRequest("getCdpUsersByRfmClassification", args || {}); }
    getRfmDistribution(args: {placeIds: string[], mixMode?: MixMode | null}): Promise<RfmDistribution[]> { return this.makeRequest("getRfmDistribution", args || {}); }
    getSegmentDistribution(args: {placeIds: string[]}): Promise<SegmentDistribution[]> { return this.makeRequest("getSegmentDistribution", args || {}); }
    getCdpInteractions(args: {userId: string, placeIds: string[], filters?: CdpInteractionListFilters | null, pagination?: Pagination | null}): Promise<CdpInteraction[]> { return this.makeRequest("getCdpInteractions", args || {}); }
    getCdpProductPurchases(args: {userId: string, placeIds: string[], filters?: CdpProductPurchaseListFilters | null, pagination?: Pagination | null}): Promise<CdpProductPurchase[]> { return this.makeRequest("getCdpProductPurchases", args || {}); }
    getCdpProductPurchasesByCategory(args: {placeIds: string[], filters?: CdpInteractionFilters | null}): Promise<ProductCategoryDistribution[]> { return this.makeRequest("getCdpProductPurchasesByCategory", args || {}); }
    getCdpFavoriteProducts(args: {placeIds: string[], filters?: BaseCdpFilters | null, limit?: number | null}): Promise<FavoriteProduct[]> { return this.makeRequest("getCdpFavoriteProducts", args || {}); }
    getCdpChurnRate(args: {placeIds: string[], period: PeriodTime}): Promise<number> { return this.makeRequest("getCdpChurnRate", args || {}); }
    getCdpAverageTicket(args: {placeIds: string[], period: PeriodTime}): Promise<number> { return this.makeRequest("getCdpAverageTicket", args || {}); }
    getCdpAverageLTV(args: {placeIds: string[]}): Promise<number> { return this.makeRequest("getCdpAverageLTV", args || {}); }
    getCdpMetrics(args: {placeIds: string[], period?: PeriodTime | null}): Promise<CdpMetrics> { return this.makeRequest("getCdpMetrics", args || {}); }
    createCdpPlaceRfmRule(args: {input: CreateCdpPlaceRfmRuleInput}): Promise<CdpPlaceRfmRule> { return this.makeRequest("createCdpPlaceRfmRule", args || {}); }
    getCdpPlaceRfmRule(args: {placeId: string}): Promise<CdpPlaceRfmRule | null> { return this.makeRequest("getCdpPlaceRfmRule", args || {}); }
    getCdpPlaceRfmRules(args: {organizationId: string}): Promise<CdpPlaceRfmRule[]> { return this.makeRequest("getCdpPlaceRfmRules", args || {}); }
    updateCdpPlaceRfmRule(args: {input: UpdateCdpPlaceRfmRuleInput}): Promise<CdpPlaceRfmRule> { return this.makeRequest("updateCdpPlaceRfmRule", args || {}); }
    deleteCdpPlaceRfmRule(args: {placeId: string}): Promise<void> { return this.makeRequest("deleteCdpPlaceRfmRule", args || {}); }
    createCdpOrganizationCustomSegment(args: {input: CreateCdpOrganizationCustomSegmentInput}): Promise<CdpOrganizationCustomSegment> { return this.makeRequest("createCdpOrganizationCustomSegment", args || {}); }
    getCdpOrganizationCustomSegment(args: {segmentId: string}): Promise<CdpOrganizationCustomSegment> { return this.makeRequest("getCdpOrganizationCustomSegment", args || {}); }
    getCdpOrganizationCustomSegments(args: {organizationId: string}): Promise<CdpOrganizationCustomSegment[]> { return this.makeRequest("getCdpOrganizationCustomSegments", args || {}); }
    updateCdpOrganizationCustomSegment(args: {input: UpdateCdpOrganizationCustomSegmentInput}): Promise<CdpOrganizationCustomSegment> { return this.makeRequest("updateCdpOrganizationCustomSegment", args || {}); }
    deleteCdpOrganizationCustomSegment(args: {segmentId: string}): Promise<void> { return this.makeRequest("deleteCdpOrganizationCustomSegment", args || {}); }
    getCdpAudienceMetrics(args: {placeIds: string[], period: PeriodTime, groupBy: DashboardTimeGrouping}): Promise<AudienceMetricsByPeriod> { return this.makeRequest("getCdpAudienceMetrics", args || {}); }
    getCdpAverageTicketMetrics(args: {placeIds: string[], period: PeriodTime, groupBy: DashboardTimeGrouping}): Promise<AverageTicketMetricsByPeriod> { return this.makeRequest("getCdpAverageTicketMetrics", args || {}); }
    getCdpTpvMetrics(args: {placeIds: string[], period: PeriodTime, groupBy: DashboardTimeGrouping}): Promise<TpvMetricsByPeriod> { return this.makeRequest("getCdpTpvMetrics", args || {}); }
    getCdpDashboardKpis(args: {placeIds: string[], period: PeriodTime}): Promise<DashboardKpis> { return this.makeRequest("getCdpDashboardKpis", args || {}); }
    getCdpDashboardKpisTimeSeries(args: {placeIds: string[], period: PeriodTime, groupBy: GetCdpDashboardKpisTimeSeriesGroupBy}): Promise<DashboardKpisByPeriod[]> { return this.makeRequest("getCdpDashboardKpisTimeSeries", args || {}); }
    getCdpAudienceMetricsTimeSeries(args: {placeIds: string[], period: PeriodTime, groupBy: GetCdpAudienceMetricsTimeSeriesGroupBy}): Promise<AudienceMetricsByPeriod[]> { return this.makeRequest("getCdpAudienceMetricsTimeSeries", args || {}); }
    getCdpInactiveClients(args: {placeIds: string[], inactiveDays: number, mixMode?: MixMode | null}): Promise<InactiveClientsKpi> { return this.makeRequest("getCdpInactiveClients", args || {}); }
    getCdpChurnRiskClients(args: {placeIds: string[], mixMode?: MixMode | null}): Promise<ChurnRiskKpi[]> { return this.makeRequest("getCdpChurnRiskClients", args || {}); }
    getCdpTopRfmMetrics(args: {placeIds: string[], period?: PeriodTime | null}): Promise<TopRfmMetrics[]> { return this.makeRequest("getCdpTopRfmMetrics", args || {}); }
    getCdpDemographicDistribution(args: {placeIds: string[], period?: PeriodTime | null}): Promise<DemographicDistribution> { return this.makeRequest("getCdpDemographicDistribution", args || {}); }
    getCdpCityDistribution(args: {placeIds: string[], period?: PeriodTime | null}): Promise<CityDistribution[]> { return this.makeRequest("getCdpCityDistribution", args || {}); }
    getCdpRfmDistributionEnhanced(args: {placeIds: string[], period?: PeriodTime | null, mixMode?: MixMode | null}): Promise<RfmDistributionEnhanced[]> { return this.makeRequest("getCdpRfmDistributionEnhanced", args || {}); }
    getCdpRfmDistributionTimeSeries(args: {placeIds: string[], period: PeriodTime, groupBy: GetCdpRfmDistributionTimeSeriesGroupBy}): Promise<RfmDistributionByPeriod[]> { return this.makeRequest("getCdpRfmDistributionTimeSeries", args || {}); }
    getCdpSegmentDistributionEnhanced(args: {placeIds: string[], period?: PeriodTime | null}): Promise<SegmentDistributionEnhanced[]> { return this.makeRequest("getCdpSegmentDistributionEnhanced", args || {}); }
    getCdpRfmFrequencyDistribution(args: {placeIds: string[], period: PeriodTime, mixMode?: MixMode | null}): Promise<RfmFrequencyDistribution[]> { return this.makeRequest("getCdpRfmFrequencyDistribution", args || {}); }
    getCdpActivationRate(args: {placeIds: string[], period: PeriodTime}): Promise<ActivationRateMetrics> { return this.makeRequest("getCdpActivationRate", args || {}); }
    getCdpActivationRateTimeSeries(args: {placeIds: string[], period: PeriodTime, groupBy: DashboardTimeGrouping}): Promise<ActivationRateByPeriod[]> { return this.makeRequest("getCdpActivationRateTimeSeries", args || {}); }
    getCdpReactivationMetrics(args: {placeIds: string[], period: PeriodTime}): Promise<ReactivationMetrics> { return this.makeRequest("getCdpReactivationMetrics", args || {}); }
    getCdpAverageTimeBetweenVisits(args: {placeIds: string[], period: PeriodTime}): Promise<AverageTimeBetweenVisitsMetrics> { return this.makeRequest("getCdpAverageTimeBetweenVisits", args || {}); }
    getCdpOccupancyRate(args: {placeIds: string[], period: PeriodTime, groupBy: DashboardTimeGrouping}): Promise<OccupancyRate[]> { return this.makeRequest("getCdpOccupancyRate", args || {}); }
    getCdpValueMatrix(args: {placeIds: string[], period: PeriodTime, limit?: number | null}): Promise<ValueMatrixPoint[]> { return this.makeRequest("getCdpValueMatrix", args || {}); }
    getCdpValueMatrixDistribution(args: {placeIds: string[], period: PeriodTime, customFrequencyEdges?: number[] | null, customTicketEdges?: number[] | null}): Promise<ValueMatrixDistribution> { return this.makeRequest("getCdpValueMatrixDistribution", args || {}); }
    getCdpRemainingBalance(args: {placeIds: string[]}): Promise<RemainingBalanceKpi> { return this.makeRequest("getCdpRemainingBalance", args || {}); }
    listUnreadDashboardNotificationsForEmployee(args: {pagination: Pagination}): Promise<DashboardNotificationPaginated> { return this.makeRequest("listUnreadDashboardNotificationsForEmployee", args || {}); }
    listReadDashboardNotificationsForEmployee(args: {pagination: Pagination}): Promise<DashboardNotificationPaginated> { return this.makeRequest("listReadDashboardNotificationsForEmployee", args || {}); }
    setReadDashboardNotificationsForEmployee(args: {dashboardNotificationIds: string[]}): Promise<void> { return this.makeRequest("setReadDashboardNotificationsForEmployee", args || {}); }
    editEmployeesPlacesAndBars(args: {employees: EditEmployeesPlacesAndBarsEmployees[]}): Promise<EditEmployeesPlacesAndBars> { return this.makeRequest("editEmployeesPlacesAndBars", args || {}); }
    getSellerTipReportForPlace(args: {placeId: string, since: Date, until: Date, filters: EmployeeTipReportFilters}): Promise<EmployeeTipReport[]> { return this.makeRequest("getSellerTipReportForPlace", args || {}); }
    getSellerTipReportForEvent(args: {eventId: string, filters: EmployeeTipReportFilters}): Promise<EmployeeTipReport[]> { return this.makeRequest("getSellerTipReportForEvent", args || {}); }
    getAllEventActions(args: {eventId: string, filters: FiltersActionsFromEvent, pagination: Pagination}): Promise<ReportActionsFromEventResponse> { return this.makeRequest("getAllEventActions", args || {}); }
    getAllEventActionsFromTotem(args: {eventId: string, filters: FiltersActionsFromEvent, pagination: Pagination}): Promise<ReportActionsFromEventResponse> { return this.makeRequest("getAllEventActionsFromTotem", args || {}); }
    getFiltersValuesForTransactionsReport(args: {placeId: string}): Promise<FiltersValuesForTransactionsReport> { return this.makeRequest("getFiltersValuesForTransactionsReport", args || {}); }
    getAllEventActionsV2(args: {eventId: string, filters: FiltersActionsFromEventOrPlace, pagination: Pagination}): Promise<GetAllEventActionsV2> { return this.makeRequest("getAllEventActionsV2", args || {}); }
    getAllPlaceActions(args: {placeId: string, filters: FiltersActionsFromEventOrPlace, pagination: Pagination}): Promise<GetAllPlaceActions> { return this.makeRequest("getAllPlaceActions", args || {}); }
    exportAllPlaceOrEventActions(args: {placeId?: string | null, eventId?: string | null, email: string, since?: Date | null, until?: Date | null}): Promise<string> { return this.makeRequest("exportAllPlaceOrEventActions", args || {}); }
    getTransactionReportLinks(args: {placeId: string, since?: Date | null}): Promise<TransactionReportLink[]> { return this.makeRequest("getTransactionReportLinks", args || {}); }
    sendTransactionReportMail(args: {email: string, linkId: string}): Promise<void> { return this.makeRequest("sendTransactionReportMail", args || {}); }
    getHawkerCashierReleasedProductsForClosingReport(args: {id: string, eventId: string}): Promise<HawkerCashierReleasedProduct[]> { return this.makeRequest("getHawkerCashierReleasedProductsForClosingReport", args || {}); }
    getHawkerCashierPaymentsForClosingReport(args: {id: string, eventId: string}): Promise<HawkerCashierPayment[]> { return this.makeRequest("getHawkerCashierPaymentsForClosingReport", args || {}); }
    getHawkerCashierAdjustmentsForClosingReport(args: {id: string, eventId: string}): Promise<HawkerCashierAdjustment[]> { return this.makeRequest("getHawkerCashierAdjustmentsForClosingReport", args || {}); }
    getHawkerCashierHawkerClosingsForClosingReport(args: {id: string, eventId: string}): Promise<HawkerCashierHawkerClosing[]> { return this.makeRequest("getHawkerCashierHawkerClosingsForClosingReport", args || {}); }
    getHawkerCashierFinancialSummaryForClosingReport(args: {id: string, eventId: string}): Promise<HawkerCashierFinancialSummary> { return this.makeRequest("getHawkerCashierFinancialSummaryForClosingReport", args || {}); }
    getHawkerCashiersClosingsForEvent(args: {eventId: string, filters?: HawkerReportFilters | null}): Promise<HawkerCashierClosing[]> { return this.makeRequest("getHawkerCashiersClosingsForEvent", args || {}); }
    getHawkerTransactions(args: {placeId: string, eventIds: string[], pagination: Pagination, filters?: HawkerTransactionsFilters | null}): Promise<GetHawkerTransactions> { return this.makeRequest("getHawkerTransactions", args || {}); }
    getHawkerTransactionsByPlace(args: {placeId: string, pagination: Pagination, filters: HawkerTransactionsPlaceFilters}): Promise<GetHawkerTransactionsByPlace> { return this.makeRequest("getHawkerTransactionsByPlace", args || {}); }
    getHawkerTransactionsXlsx(args: {placeId: string, eventIds: string[], filters?: HawkerTransactionsFilters | null}): Promise<string> { return this.makeRequest("getHawkerTransactionsXlsx", args || {}); }
    getAllKds(args: {placeId: string, filters: KdsFilters}): Promise<Kds[]> { return this.makeRequest("getAllKds", args || {}); }
    getKds(args: {placeId: string, kdsId: string, ninegridKdsId: number}): Promise<KdsDetails> { return this.makeRequest("getKds", args || {}); }
    editKds(args: {placeId: string, kdsId: string, ninegridKdsId: number, kdsRequest: KdsRequest}): Promise<void> { return this.makeRequest("editKds", args || {}); }
    getKdsAverageAssemblyOrder(args: {placeId: string, rangeDate: ReportDateRange}): Promise<string> { return this.makeRequest("getKdsAverageAssemblyOrder", args || {}); }
    getKdsProductionBySector(args: {placeId: string, rangeDate: ReportDateRange}): Promise<KdsProductionBySectorReport[]> { return this.makeRequest("getKdsProductionBySector", args || {}); }
    getKdsProductionByProduct(args: {placeId: string, rangeDate: ReportDateRange}): Promise<KdsProductionByProductReport[]> { return this.makeRequest("getKdsProductionByProduct", args || {}); }
    getKdsTop10LongestOrders(args: {placeId: string, rangeDate: ReportDateRange}): Promise<KdsOrder[]> { return this.makeRequest("getKdsTop10LongestOrders", args || {}); }
    getKdsAverageProductionTimeByHour(args: {placeId: string, rangeDate: ReportDateRange}): Promise<KdsAverageProductionTimeByHour[]> { return this.makeRequest("getKdsAverageProductionTimeByHour", args || {}); }
    createKds(args: {placeId: string, barIds: string[], name: string}): Promise<Kds> { return this.makeRequest("createKds", args || {}); }
    deleteKds(args: {placeId: string, kdsId: string}): Promise<void> { return this.makeRequest("deleteKds", args || {}); }
    editZigKds(args: {placeId: string, kdsId: string, kdsRequest: EditKdsRequest}): Promise<void> { return this.makeRequest("editZigKds", args || {}); }
    createKdsScreen(args: {placeId: string, kdsId: string}): Promise<CreateKdsScreenResponse> { return this.makeRequest("createKdsScreen", args || {}); }
    deleteKdsScreen(args: {placeId: string, kdsScreenId: string}): Promise<void> { return this.makeRequest("deleteKdsScreen", args || {}); }
    editKdsScreen(args: {placeId: string, kdsScreenId: string, name: string}): Promise<void> { return this.makeRequest("editKdsScreen", args || {}); }
    createKdsProductScreen(args: {placeId: string, kdsScreenId: string, kdsProductBars: KdsProductBar[]}): Promise<void> { return this.makeRequest("createKdsProductScreen", args || {}); }
    deleteKdsProductScreen(args: {placeId: string, kdsScreenId: string, kdsProductBars: KdsProductBar[]}): Promise<void> { return this.makeRequest("deleteKdsProductScreen", args || {}); }
    createMenu(args: {placeId: string, menu: NewMenu}): Promise<MenuDetails> { return this.makeRequest("createMenu", args || {}); }
    deleteMenu(args: {menuId: string}): Promise<void> { return this.makeRequest("deleteMenu", args || {}); }
    editMenu(args: {menuId: string, menu: EditMenu}): Promise<MenuDetails> { return this.makeRequest("editMenu", args || {}); }
    getMenus(args: {placeId: string}): Promise<MenuList[]> { return this.makeRequest("getMenus", args || {}); }
    duplicateMenu(args: {name: string, menuId: string}): Promise<MenuDetails> { return this.makeRequest("duplicateMenu", args || {}); }
    changeMenuStatus(args: {menuId: string, status: boolean}): Promise<MenuDetails> { return this.makeRequest("changeMenuStatus", args || {}); }
    getMenu(args: {menuId: string}): Promise<MenuDetails> { return this.makeRequest("getMenu", args || {}); }
    getMenuProductsByCategory(args: {menuId: string, categoryId: string, filters?: MenuProductFilters | null, pagination: Pagination}): Promise<GetMenuProductsByCategory> { return this.makeRequest("getMenuProductsByCategory", args || {}); }
    getAllMenuProducts(args: {menuId: string, filters?: MenuProductFilters | null, pagination: Pagination}): Promise<GetAllMenuProducts> { return this.makeRequest("getAllMenuProducts", args || {}); }
    getMenuAddableProductsByName(args: {placeId: string, menuId: string, productName: string}): Promise<AddableMenuProduct[]> { return this.makeRequest("getMenuAddableProductsByName", args || {}); }
    getMenuAddableProductsByCategory(args: {placeId: string, categoryId: string, menuId: string}): Promise<AddableMenuProduct[]> { return this.makeRequest("getMenuAddableProductsByCategory", args || {}); }
    editMenuProduct(args: {menuId: string, products: NewEditProduct[]}): Promise<void> { return this.makeRequest("editMenuProduct", args || {}); }
    removeProductFromMenu(args: {menuId: string, productId: string}): Promise<void> { return this.makeRequest("removeProductFromMenu", args || {}); }
    createMenuAndProductsAndUpdateSku(args: {placeId: string, request: CreateMenuWithProductsRequest}): Promise<CreateMenuWithProductsResponse> { return this.makeRequest("createMenuAndProductsAndUpdateSku", args || {}); }
    createManyProductsAndAddToMenuAndUpdateSku(args: {placeId: string, menuId: string, products: CreateProductWithSectionsRequest[]}): Promise<CreateMenuWithProductsResponse> { return this.makeRequest("createManyProductsAndAddToMenuAndUpdateSku", args || {}); }
    addProductToMenuAndUpdateExternalProductSku(args: {placeId: string, request: UpdateMenuAndExternalProductRequest}): Promise<void> { return this.makeRequest("addProductToMenuAndUpdateExternalProductSku", args || {}); }
    reImportIfoodProduct(args: {placeId: string, request: ReImportIfoodProductRequest}): Promise<void> { return this.makeRequest("reImportIfoodProduct", args || {}); }
    linkSyncedProductsToDeliveryMenu(args: {placeId: string, menuId: string, products: LinkSyncedProductToDeliveryMenuRequest[]}): Promise<void> { return this.makeRequest("linkSyncedProductsToDeliveryMenu", args || {}); }
    removeProductFromMenuAndUpdateExternalProductSku(args: {placeId: string, menuId: string, externalStoreId: string, productsToRemove: ProductToRemoveFromExternalStore[]}): Promise<void> { return this.makeRequest("removeProductFromMenuAndUpdateExternalProductSku", args || {}); }
    getDeliveryIntegratedMenus(args: {placeId: string, filters?: GetMenusRequest | null, pagination: Pagination}): Promise<GetDeliveryIntegratedMenusResponse> { return this.makeRequest("getDeliveryIntegratedMenus", args || {}); }
    processUpdateManyExternalProductsSkus(args: {placeId: string, externalStoresIds: string[]}): Promise<void> { return this.makeRequest("processUpdateManyExternalProductsSkus", args || {}); }
    getTableProfitReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<GetTableProfitReport> { return this.makeRequest("getTableProfitReport", args || {}); }
    getTablePeopleServedReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<GetTablePeopleServedReport> { return this.makeRequest("getTablePeopleServedReport", args || {}); }
    getTableMediumTicketPerTableReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableReportResponse> { return this.makeRequest("getTableMediumTicketPerTableReport", args || {}); }
    getTableMediumTicketPerPersonReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableReportResponse> { return this.makeRequest("getTableMediumTicketPerPersonReport", args || {}); }
    getTableTurnoverReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableReportResponse> { return this.makeRequest("getTableTurnoverReport", args || {}); }
    getTableLengthOfStayReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableReportResponse> { return this.makeRequest("getTableLengthOfStayReport", args || {}); }
    getTableMergeCombinationsReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableReportResponse> { return this.makeRequest("getTableMergeCombinationsReport", args || {}); }
    getTableEmployeeSaleRankingReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableEmployeeSaleRankingReport[]> { return this.makeRequest("getTableEmployeeSaleRankingReport", args || {}); }
    getTableProductSoldRankingReport(args: {scope: GetReportByScope, filters: ReportFilters}): Promise<TableProductSoldRankingReport[]> { return this.makeRequest("getTableProductSoldRankingReport", args || {}); }
    getMesaStatusConfiguration(args: {placeId: string}): Promise<MesaStatusConfigurationReturn[]> { return this.makeRequest("getMesaStatusConfiguration", args || {}); }
    createMesaStatusConfigurations(args: {placeId: string, configurations: CreateStatusConfiguration[]}): Promise<MesaStatusConfiguration[]> { return this.makeRequest("createMesaStatusConfigurations", args || {}); }
    getPasswordCardsFromPlace(args: {placeId: string, pagination: Pagination, filters: GetPasswordCardsFromPlaceFilters}): Promise<EmployeeCardsPagination> { return this.makeRequest("getPasswordCardsFromPlace", args || {}); }
    getPasswordCardHistory(args: {passwordCardId: string, pagination: Pagination}): Promise<CardHistoryPagination> { return this.makeRequest("getPasswordCardHistory", args || {}); }
    blockPasswordCards(args: {passwordCardIds: string[]}): Promise<void> { return this.makeRequest("blockPasswordCards", args || {}); }
    deleteEmployeePasswordCard(args: {passwordCardIds: string[]}): Promise<void> { return this.makeRequest("deleteEmployeePasswordCard", args || {}); }
    pendingOnlineRechargeValueByDate(args: {placeId: string, since: Date, until: Date}): Promise<PendingOnlineRechargeValue[]> { return this.makeRequest("pendingOnlineRechargeValueByDate", args || {}); }
    getPendingOnlineRechargeResume(args: {placeId: string, since: Date, until: Date}): Promise<PendingOnlineRechargeResume[]> { return this.makeRequest("getPendingOnlineRechargeResume", args || {}); }
    getPendingOnlineRechargeReport(args: {placeId: string, since: Date, until: Date}): Promise<PendingOnlineRechargeReport> { return this.makeRequest("getPendingOnlineRechargeReport", args || {}); }
    deletePendingOnlineRecharge(args: {placeId: string, pendingRechargeId: string}): Promise<void> { return this.makeRequest("deletePendingOnlineRecharge", args || {}); }
    deletePendingOnlineRechargesByZigDeviceUids(args: {placeId: string, zigDeviceUids: string[]}): Promise<void> { return this.makeRequest("deletePendingOnlineRechargesByZigDeviceUids", args || {}); }
    getPendingPlaceContracts(args: {placeId: string}): Promise<ListPendingPlaceContracts> { return this.makeRequest("getPendingPlaceContracts", args || {}); }
    signPlaceContracts(args: {contractIds: string[]}): Promise<void> { return this.makeRequest("signPlaceContracts", args || {}); }
    confirmSignPlaceContracts(args: {code: string, placeId: string}): Promise<void> { return this.makeRequest("confirmSignPlaceContracts", args || {}); }
    listPlaceContracts(args: {placeId: string, pagination: Pagination, filters: PlaceContractListFilters}): Promise<PlaceContractListPaginated> { return this.makeRequest("listPlaceContracts", args || {}); }
    getPlaceContract(args: {contractId: string}): Promise<PlaceContract> { return this.makeRequest("getPlaceContract", args || {}); }
    downloadFilesFromContracts(args: {contractIds: string[]}): Promise<string> { return this.makeRequest("downloadFilesFromContracts", args || {}); }
    applyMountableProductsForProducts(args: {placeId: string, fromProductId: string, toProductIds: string[]}): Promise<void> { return this.makeRequest("applyMountableProductsForProducts", args || {}); }
    getProductMasterKinds(args?: {}): Promise<GetProductMasterKinds[]> { return this.makeRequest("getProductMasterKinds", args || {}); }
    getAllRecharges(args: {filters: RechargeRequestFilters, pagination: Pagination}): Promise<RechargesPaginated> { return this.makeRequest("getAllRecharges", args || {}); }
    getAllRechargeIds(args: {filters: RechargeRequestFilters}): Promise<string[]> { return this.makeRequest("getAllRechargeIds", args || {}); }
    cancelRechargeUpload(args: {rechargeIds: string[]}): Promise<void> { return this.makeRequest("cancelRechargeUpload", args || {}); }
    alterRechargeExpirations(args: {rechargeIds: string[], expiresAt: Date}): Promise<void> { return this.makeRequest("alterRechargeExpirations", args || {}); }
    addRechargesToPlace(args: {rechargeIds: string[], placeIds: string[]}): Promise<void> { return this.makeRequest("addRechargesToPlace", args || {}); }
    getAllRechargeFilters(args: {eventId?: string | null, placeId?: string | null}): Promise<RechargeFilters> { return this.makeRequest("getAllRechargeFilters", args || {}); }
    listSquadCampaigns(args: {period: PeriodTime, filters: CampaignFilters, pagination: Pagination}): Promise<ListCampaignsReponse> { return this.makeRequest("listSquadCampaigns", args || {}); }
    squadCampaignTotals(args: {period: PeriodTime, filters?: CampaignFilters | null}): Promise<CampaignTotalsReponse> { return this.makeRequest("squadCampaignTotals", args || {}); }
    getListWinners(args: {period: PeriodTime, pagination: Pagination, filters?: ListWinnersFilters | null}): Promise<ListWinnersResponse> { return this.makeRequest("getListWinners", args || {}); }
    createSquadCampaign(args: {data: CampaignRequest}): Promise<CampaignResponse> { return this.makeRequest("createSquadCampaign", args || {}); }
    getSquadCampaignById(args: {campaignId: string}): Promise<CampaignResponse> { return this.makeRequest("getSquadCampaignById", args || {}); }
    listSquadCampaignFilters(args?: {}): Promise<CampaignResponseFilters[]> { return this.makeRequest("listSquadCampaignFilters", args || {}); }
    finalizeSquadCampaign(args: {campaignId: string}): Promise<CampaignResponse> { return this.makeRequest("finalizeSquadCampaign", args || {}); }
    payEmployee(args: {squadCampaignId: string, employeeWinner: string}): Promise<void> { return this.makeRequest("payEmployee", args || {}); }
    squadCampaignRanking(args: {squadCampaignId: string}): Promise<ListSquadCampaignRanking[]> { return this.makeRequest("squadCampaignRanking", args || {}); }
    squadCampaignRankingXlsx(args: {squadCampaignId: string}): Promise<string> { return this.makeRequest("squadCampaignRankingXlsx", args || {}); }
    createVendorForOrganization(args: {vendor: CreateVendorOrg}): Promise<VendorOrg> { return this.makeRequest("createVendorForOrganization", args || {}); }
    updateVendorForOrganization(args: {vendor: UpdateVendorOrg}): Promise<VendorOrg> { return this.makeRequest("updateVendorForOrganization", args || {}); }
    batchUpdateVendorForOrganization(args: {vendors: UpdateVendorOrg[]}): Promise<VendorOrg[]> { return this.makeRequest("batchUpdateVendorForOrganization", args || {}); }
    getVendorsFromOrganization(args?: {}): Promise<VendorOrg[]> { return this.makeRequest("getVendorsFromOrganization", args || {}); }
    getAllVendorFeatures(args?: {}): Promise<GetAllVendorFeatures[]> { return this.makeRequest("getAllVendorFeatures", args || {}); }
    deleteVendorAdjust(args: {id: string}): Promise<void> { return this.makeRequest("deleteVendorAdjust", args || {}); }
    getVendorToReceiveAllTips(args: {placeId: string}): Promise<VendorReceiveTip | null> { return this.makeRequest("getVendorToReceiveAllTips", args || {}); }
    setVendorToReceiveAllTips(args: {vendorId?: string | null, placeId: string}): Promise<VendorReceiveTip | null> { return this.makeRequest("setVendorToReceiveAllTips", args || {}); }
    editVendorPaymentMethods(args: {placeId: string, vendorsPaymentMethods: VendorPaymentMethods[]}): Promise<VendorPaymentMethodsResponse[]> { return this.makeRequest("editVendorPaymentMethods", args || {}); }
    getPlaceVendorPaymentMethods(args: {placeId: string}): Promise<VendorPaymentMethodsResponse[]> { return this.makeRequest("getPlaceVendorPaymentMethods", args || {}); }
    getVendorsBalances(args: {placeId: string}): Promise<GetVendorsBalances[]> { return this.makeRequest("getVendorsBalances", args || {}); }
    reprocessAllVendorsAtEvent(args: {eventId: string}): Promise<void> { return this.makeRequest("reprocessAllVendorsAtEvent", args || {}); }
    reprocessAllVendorsAtEventAsync(args: {eventId: string}): Promise<void> { return this.makeRequest("reprocessAllVendorsAtEventAsync", args || {}); }
    getVendorExtractResume(args: {placeId: string, vendorId: string}): Promise<VendorExtractResume[]> { return this.makeRequest("getVendorExtractResume", args || {}); }
    getVendorConsolidatedExtractInSections(args: {since: Date, until: Date, placeId: string, vendorId: string}): Promise<VendorConsolidatedExtract> { return this.makeRequest("getVendorConsolidatedExtractInSections", args || {}); }
    getAutomaticWithdrawHistory(args: {placeId: string, since: Date, until: Date}): Promise<GetAutomaticWithdrawHistory[]> { return this.makeRequest("getAutomaticWithdrawHistory", args || {}); }
    createWithdraw(args: {placeId: string, newWithdraw: CreateWithdrawDto}): Promise<WithdrawResponse> { return this.makeRequest("createWithdraw", args || {}); }
    validateWithdrawPlaceConfirmationCode(args: {placeId: string, code: string}): Promise<void> { return this.makeRequest("validateWithdrawPlaceConfirmationCode", args || {}); }
    resendWithdrawRequestPlaceConfirmationCode(args: {placeId: string}): Promise<void> { return this.makeRequest("resendWithdrawRequestPlaceConfirmationCode", args || {}); }
    cancelWithdrawRequestPlaceConfirmation(args: {placeId: string}): Promise<void> { return this.makeRequest("cancelWithdrawRequestPlaceConfirmation", args || {}); }
    isWithdrawRequestPendingPlaceConfirmation(args: {id: string}): Promise<boolean> { return this.makeRequest("isWithdrawRequestPendingPlaceConfirmation", args || {}); }
    orderWithdrawCancellation(args: {withdrawId: string}): Promise<void> { return this.makeRequest("orderWithdrawCancellation", args || {}); }
    retryPixReceipt(args: {placeId: string, withdrawId: string}): Promise<RetryPixReceipt> { return this.makeRequest("retryPixReceipt", args || {}); }
    getBankslipPreviewData(args: {barcode: string, placeId?: string | null}): Promise<BankslipPreviewData> { return this.makeRequest("getBankslipPreviewData", args || {}); }
    getEventOperationsByPlaceId(args: {request: GetEventOperationsByPlaceIdRequest}): Promise<GetEventOperationsByPlaceIdResponse> { return this.makeRequest("getEventOperationsByPlaceId", args || {}); }
    requestClosingOfEventOperation(args: {id: string}): Promise<RequestClosingOfEventOperationResponse> { return this.makeRequest("requestClosingOfEventOperation", args || {}); }
    getCombinedOrdersReport(args: {placeId: string, filters?: GetCombinedOrdersReportRequestDto | null, orderBy?: GetCombinedOrdersReportOrderBy | null, orderDirection?: GetCombinedOrdersReportOrderDirection | null, pagination: PaginationRequestDto}): Promise<GetCombinedOrdersReportResponseDto> { return this.makeRequest("getCombinedOrdersReport", args || {}); }
    exportCombinedOrdersReport(args: {placeId: string, filters?: GetCombinedOrdersReportRequestDto | null, orderBy?: GetCombinedOrdersReportOrderBy | null, orderDirection?: GetCombinedOrdersReportOrderDirection | null}): Promise<ArrayBuffer> { return this.makeRequest("exportCombinedOrdersReport", args || {}); }
    listAdvances(args: {placeId: string, page: number, pageSize: number, filters: ListAdvancesFilters}): Promise<ListAdvancesResponse> { return this.makeRequest("listAdvances", args || {}); }
    getAdvance(args: {advanceId: string}): Promise<Advance> { return this.makeRequest("getAdvance", args || {}); }
    getAdvanceCharges(args: {advanceId: string}): Promise<AdvanceCharge[]> { return this.makeRequest("getAdvanceCharges", args || {}); }
    getAdvanceDocuments(args: {advanceId: string}): Promise<AdvanceDocument[]> { return this.makeRequest("getAdvanceDocuments", args || {}); }
    getNotOpenedCashiers(args: {eventId: string}): Promise<EmployeeBase[]> { return this.makeRequest("getNotOpenedCashiers", args || {}); }
    getBaseEmployees(args: {pagination: Pagination}): Promise<EmployeeBaseResponse> { return this.makeRequest("getBaseEmployees", args || {}); }
    getStockTransferReport(args: {eventId: string}): Promise<StockTransfer[]> { return this.makeRequest("getStockTransferReport", args || {}); }
    getGuinnessResume(args: {eventId: string}): Promise<number> { return this.makeRequest("getGuinnessResume", args || {}); }
    getGuinnessLog(args: {eventId: string}): Promise<GuinnessLog[]> { return this.makeRequest("getGuinnessLog", args || {}); }
    sendDataHubChatResponse(args: {deviceId: string, chatId: string, response: string, extra?: any | null}): Promise<void> { return this.makeRequest("sendDataHubChatResponse", args || {}); }
}

const errClasses = {
    NotFound,
    ChargeExpired,
    ChargePaid,
    GenericError,
    FocusError,
    ProductEmissionTest,
    AdvanceNotFound,
    AdvanceChargeNotFound,
    AdvanceDocumentNotFound,
    InvalidAdvanceOperation,
    InsufficientAdvancePermission,
    BackofficeError,
    NotLoggedIn,
    LacksPermission,
    InvalidArgument,
    WrongLogin,
    DoesntExist,
    LacksFeature,
    LimitExceeded,
    PeriodOutOfRange,
    EmailRegistrationRequired,
    Conflict,
    Fatal
};

const astJson = {
    annotations: {
        "type.BackofficeStorageHistoryV3Transfers.employeeName": [
            {
                type: "description",
                value: "Display name of the employee responsible for the transfer. For Zig internal employees, returns the localized \"Zig Employee\" label."
            }
        ],
        "type.BackofficeStorageHistoryV3Transfers.employeeUsername": [
            {
                type: "description",
                value: "Username of the employee. Returns null when there is no employee or when the employee is a Zig internal user (masked)."
            }
        ],
        "type.FinancialExtractBlock.canBeReleased": [
            {
                type: "description",
                value: "\"true = block is eligible for release (every linked receivable unit is in the allow-list, or there are no linked URs). false = release is prevented (a linked UR is in a non-releasable status, or the block has already been released). null = API does not compute this field (Enterprise/Integration).\""
            }
        ],
        "type.OrderFee.name": [
            {
                type: "description",
                value: "Nome interno da fee no catalogo (ex: serviceFee, minimumOrderFee, tip)."
            }
        ],
        "type.OrderFee.description": [
            {
                type: "description",
                value: "Descricao humana da fee, explicando seu tratamento fiscal. Pode ser null."
            }
        ],
        "type.OrderFee.value": [
            {
                type: "description",
                value: "Valor da fee em centavos."
            }
        ],
        "type.OrderFee.issueInvoice": [
            {
                type: "description",
                value: "Indica se a fee entra na NF da loja (true) ou fica fora da emissao fiscal (false)."
            }
        ],
        "type.OrderFee.receivedBy": [
            {
                type: "description",
                value: "Destinatário da gorjeta quando name = \"tip\". Ausente para fees não-tip."
            }
        ],
        "type.SimplifiedOrder.orderFees": [
            {
                type: "description",
                value: "Lista de fees discriminadas do pedido (serviceFee, minimumOrderFee, etc), vindas de delivery_order_fees. Substitui o uso de tip como dump de fees fiscais."
            }
        ],
        "type.PairInfo.id": [
            {
                type: "description",
                value: "\"ID da contraparte (vendor ou place)\""
            }
        ],
        "type.PairInfo.name": [
            {
                type: "description",
                value: "\"Nome da contraparte (vendor ou place)\""
            }
        ],
        "type.PairInfo.type": [
            {
                type: "description",
                value: "\"Tipo da contraparte: 'vendor' para fornecedores/ambulantes ou 'place' para estabelecimentos\""
            }
        ],
        "type.PairInfo.document": [
            {
                type: "description",
                value: "\"CNPJ/CPF do credor. Aplicável apenas para entradas do tipo 'ContractEffect' (cessão de recebíveis)\""
            }
        ],
        "type.PairInfo.relatedVendor": [
            {
                type: "description",
                value: "\"Vendor que originou o repasse (para entradas do tipo 'RelatedStakeholderRetention')\""
            }
        ],
        "type.ConsolidatedExtractV2GroupTypes.typeId": [
            {
                type: "description",
                value: "\"ID do tipo da entrada financeira (faz fallback para o campo id quando não fornecido)\""
            }
        ],
        "type.ConsolidatedExtractV2GroupTypes.categoryId": [
            {
                type: "description",
                value: "\"ID da categoria da entrada financeira (pode ser nulo quando não houver categoria)\""
            }
        ],
        "type.ConsolidatedExtractV2GroupTypes.originDestination": [
            {
                type: "description",
                value: "\"Origem/Destino da entrada (place + vendor para entradas do tipo 'RelatedStakeholderRetention')\""
            }
        ],
        "type.DetailedEntry.categoryId": [
            {
                type: "description",
                value: "\"ID da categoria associada à entrada\""
            }
        ],
        "type.DetailedEntry.groupId": [
            {
                type: "description",
                value: "\"ID do grupo ao qual a entrada pertence\""
            }
        ],
        "type.DetailedEntry.groupName": [
            {
                type: "description",
                value: "\"Nome do grupo ao qual a entrada pertence\""
            }
        ],
        "type.BarWithMenus.kds": [
            {
                type: "description",
                value: "KDS vinculado ao bar (se existir)"
            }
        ],
        "type.BarWithMenus.productsCount": [
            {
                type: "description",
                value: "Quantidade de produtos vinculados ao bar"
            }
        ],
        "type.CateringProductListItem.comboProducts": [
            {
                type: "description",
                value: "\"Filhos do combo. Populado apenas quando `type = Combo`.\""
            }
        ],
        "type.CateringProductListItem.mountableSections": [
            {
                type: "description",
                value: "\"Secoes do produto montavel. Populado apenas quando `type = Mountable`.\""
            }
        ],
        "type.NewCateringComboPayloadProducts.count": [
            {
                type: "description",
                value: "\"Quantidade do filho dentro do combo (deve ser >= 1).\""
            }
        ],
        "type.NewCateringComboPayload.products": [
            {
                type: "description",
                value: "\"Lista de produtos filhos do combo. Minimo de 2 itens. Todos devem ser produtos de catering (`products.type = 'Catering'`) pertencentes a mesma organizacao do caller e com `place_product_entry` no place do request.\""
            }
        ],
        "type.NewCateringProduct.type": [
            {
                type: "description",
                value: "\"Discriminador da variante de catering. Define quais sub-payloads sao obrigatorios. Product: produto simples — mountableDescription e combo sao ignorados. Combo: combo de catering — combo e obrigatorio, mountableDescription ignorado. Mountable: produto montavel — mountableDescription e obrigatorio, combo ignorado.\""
            }
        ],
        "type.NewCateringProduct.mountableDescription": [
            {
                type: "description",
                value: "\"Obrigatorio quando `type = Mountable`. Ignorado para outras variantes.\""
            }
        ],
        "type.NewCateringProduct.combo": [
            {
                type: "description",
                value: "\"Obrigatorio quando `type = Combo`. Ignorado para outras variantes.\""
            }
        ],
        "type.PlaceCombo.printComboProductsIndividually": [
            {
                type: "description",
                value: "\"When true, the products of the combo will be printed individually on the receipt\""
            }
        ],
        "type.DeliveryFeeFiscalProductGroupDeliveryFee.id": [
            {
                type: "description",
                value: "Identificador único da taxa de delivery."
            }
        ],
        "type.DeliveryFeeFiscalProductGroupDeliveryFee.name": [
            {
                type: "description",
                value: "Nome interno da taxa (ex: serviceFee, minimumOrderFee)."
            }
        ],
        "type.DeliveryFeeFiscalProductGroupDeliveryFee.description": [
            {
                type: "description",
                value: "Descrição humana da taxa, explicando seu tratamento fiscal. Pode ser null."
            }
        ],
        "type.DeliveryFeeFiscalProductGroupDeliveryFee.issueInvoice": [
            {
                type: "description",
                value: "Indica se a taxa entra na NF da loja (true) ou se fica fora da emissão fiscal (false)."
            }
        ],
        "type.DeliveryFeeFiscalProductGroupBinding.deliveryFee": [
            {
                type: "description",
                value: "Dados da taxa de delivery do catálogo."
            }
        ],
        "type.DeliveryFeeFiscalProductGroupBinding.fiscalProductGroupId": [
            {
                type: "description",
                value: "Identificador do grupo fiscal vinculado a essa taxa para o place. Null quando não há vínculo."
            }
        ],
        "type.Debtor.userId": [
            {
                type: "description",
                value: "ID do usuário"
            }
        ],
        "type.Debtor.userName": [
            {
                type: "description",
                value: "Nome do usuário"
            }
        ],
        "type.Debtor.userDocument": [
            {
                type: "description",
                value: "Documento (CPF) do usuário"
            }
        ],
        "type.Debtor.value": [
            {
                type: "description",
                value: "Valor da conta em aberto"
            }
        ],
        "type.Debtor.tipValue": [
            {
                type: "description",
                value: "Tip em aberto"
            }
        ],
        "type.Debtor.paidValue": [
            {
                type: "description",
                value: "Valor pago após o evento"
            }
        ],
        "type.Debtor.paidTipValue": [
            {
                type: "description",
                value: "Valor pago em tip após o evento"
            }
        ],
        "type.Debtor.phone": [
            {
                type: "description",
                value: "Telefone do usuário"
            }
        ],
        "type.Debtor.email": [
            {
                type: "description",
                value: "E-mail do usuário"
            }
        ],
        "type.Debtor.status": [
            {
                type: "description",
                value: "Status da conta em aberto"
            }
        ],
        "type.Debtor.openBillChargeId": [
            {
                type: "description",
                value: "ID da cobrança da conta em aberto"
            }
        ],
        "type.DebtorsFilters.status": [
            {
                type: "description",
                value: "Filtro por status da conta em aberto"
            }
        ],
        "type.DebtorsFilters.userName": [
            {
                type: "description",
                value: "Filtro por nome do usuário"
            }
        ],
        "type.DebtorsFilters.userDocument": [
            {
                type: "description",
                value: "Filtro por documento (CPF) do usuário"
            }
        ],
        "type.OpenedBillsOverview.value": [
            {
                type: "description",
                value: "Total em contas em aberto (consumo)"
            }
        ],
        "type.OpenedBillsOverview.tipValue": [
            {
                type: "description",
                value: "Total em tip em aberto"
            }
        ],
        "type.OpenedBillsOverview.paidValue": [
            {
                type: "description",
                value: "Total pago (consumo) após o evento"
            }
        ],
        "type.OpenedBillsOverview.paidTipValue": [
            {
                type: "description",
                value: "Total pago em tip após o evento"
            }
        ],
        "type.OpenedBillsOverview.valueExemptFromTip": [
            {
                type: "description",
                value: "Valor isento de tip"
            }
        ],
        "type.OpenedBillsOverview.paidInOtherEvents": [
            {
                type: "description",
                value: "Valor pago em outros eventos"
            }
        ],
        "type.OpenedBillsOverview.openBillsTotal": [
            {
                type: "description",
                value: "Total geral em contas em aberto"
            }
        ],
        "type.PaginatedDebtorsResponse.data": [
            {
                type: "description",
                value: "Lista de contas em aberto (devedores)"
            }
        ],
        "type.PaginatedDebtorsResponse.pagination": [
            {
                type: "description",
                value: "Informações de paginação"
            }
        ],
        "type.PaginatedDebtorsResponse.totalizers": [
            {
                type: "description",
                value: "Totalizadores do relatório"
            }
        ],
        "type.DebtorsXlsInput.scope": [
            {
                type: "description",
                value: "Escopo do relatório (evento ou place com período)"
            }
        ],
        "type.DebtorsXlsInput.filters": [
            {
                type: "description",
                value: "Filtros aplicados à exportação"
            }
        ],
        "type.OpenedBillPaymentV2.user": [
            {
                type: "description",
                value: "Dados do usuário que realizou o pagamento"
            }
        ],
        "type.OpenedBillPaymentV2.employee": [
            {
                type: "description",
                value: "Funcionário que registrou o pagamento"
            }
        ],
        "type.OpenedBillPaymentV2.value": [
            {
                type: "description",
                value: "Valor pago (consumo)"
            }
        ],
        "type.OpenedBillPaymentV2.tipValue": [
            {
                type: "description",
                value: "Valor pago em tip"
            }
        ],
        "type.OpenedBillPaymentV2.methods": [
            {
                type: "description",
                value: "Formas de pagamento utilizadas"
            }
        ],
        "type.OpenedBillPaymentV2.openedEventId": [
            {
                type: "description",
                value: "ID do evento em que a conta foi aberta"
            }
        ],
        "type.OpenedBillPaymentV2.openedEventDate": [
            {
                type: "description",
                value: "Data do evento em que a conta foi aberta"
            }
        ],
        "type.OpenedBillPaymentV2.date": [
            {
                type: "description",
                value: "Data/hora do pagamento"
            }
        ],
        "type.OpenedBillPaymentV2.reason": [
            {
                type: "description",
                value: "Motivo do pagamento (quando aplicável)"
            }
        ],
        "type.OpenedBillPaymentsFilters.userName": [
            {
                type: "description",
                value: "Filtro por nome do usuário"
            }
        ],
        "type.OpenedBillPaymentsFilters.userDocument": [
            {
                type: "description",
                value: "Filtro por documento (CPF) do usuário"
            }
        ],
        "type.OpenedBillPaymentsOverview.value": [
            {
                type: "description",
                value: "Total pago em consumo"
            }
        ],
        "type.OpenedBillPaymentsOverview.tipValue": [
            {
                type: "description",
                value: "Total pago em tip"
            }
        ],
        "type.OpenedBillPaymentsOverview.openBillsTotal": [
            {
                type: "description",
                value: "Total ainda em aberto"
            }
        ],
        "type.PaginatedOpenedBillPaymentsResponse.data": [
            {
                type: "description",
                value: "Lista de pagamentos de contas em aberto"
            }
        ],
        "type.PaginatedOpenedBillPaymentsResponse.pagination": [
            {
                type: "description",
                value: "Informações de paginação"
            }
        ],
        "type.PaginatedOpenedBillPaymentsResponse.totalizers": [
            {
                type: "description",
                value: "Totalizadores do relatório"
            }
        ],
        "type.OpenedBillReportOverview.openBillsTotal": [
            {
                type: "description",
                value: "Total ainda em aberto"
            }
        ],
        "type.OpenedBillReportOverview.linksGenerated": [
            {
                type: "description",
                value: "Quantidade de links de pagamento gerados"
            }
        ],
        "type.OpenedBillReportOverview.paidValueTotal": [
            {
                type: "description",
                value: "Total pago em pagamentos de contas em aberto"
            }
        ],
        "type.OpenedBillPaymentsXlsInput.scope": [
            {
                type: "description",
                value: "Escopo do relatório (evento ou place com período)"
            }
        ],
        "type.OpenedBillPaymentsXlsInput.filters": [
            {
                type: "description",
                value: "Filtros aplicados à exportação"
            }
        ],
        "type.FiscalDraftWorkflow.draftId": [
            {
                type: "description",
                value: "Draft row id (workflow handle — use as argument to approve/reject)."
            }
        ],
        "type.FiscalDraftWorkflow.parentId": [
            {
                type: "description",
                value: "Principal id (fiscal_profiles / fiscal_product_groups). Null when the draft represents a brand-new admin-Zig creation not yet materialized."
            }
        ],
        "type.FiscalDraftWorkflow.createdBy": [
            {
                type: "description",
                value: "Who opened the draft. Always present (CHECK chk_*_draft_creator_xor in the database)."
            }
        ],
        "type.FiscalProfileOrg.hasCadastroNacionalContribuinte": [
            {
                type: "description",
                value: "\"Indicates whether the fiscal profile has a national taxpayer registration. When true, the municipal registration (inscricao municipal) must not be sent on NF-e and NFC-e emissions.\""
            }
        ],
        "type.FiscalProfile.hasPendingDraft": [
            {
                type: "description",
                value: "True when there is a pending draft (approvedAt IS NULL AND rejectedAt IS NULL) referencing this profile. Populated by the server on GET endpoints."
            }
        ],
        "type.FiscalProfile.validatedAt": [
            {
                type: "description",
                value: "Timestamp of the most recent client approval. Null means \"pré-existente\" (profile predates the validation flow) when there is also no pending draft."
            }
        ],
        "type.FiscalProductGroupServiceNational.codigoTributacaoMunicipalIss": [
            {
                type: "description",
                value: "\"Municipal tax code for ISS (Imposto Sobre Serviços). Format and values vary by municipality. When provided, it is sent as codigo_tributacao_municipal_iss to the Focus NFSe API.\""
            }
        ],
        "type.FiscalProductGroup.hasPendingDraft": [
            {
                type: "description",
                value: "True when there is a pending draft referencing this group. Populated by the server on GET endpoints."
            }
        ],
        "type.FiscalProductGroup.validatedAt": [
            {
                type: "description",
                value: "Timestamp of the most recent client approval. Null = \"pré-existente\" (group predates the validation flow) when there is also no pending draft."
            }
        ],
        "type.FiscalProfileDraft.hasPendingDraft": [
            {
                type: "description",
                value: "True when there is a pending draft (approvedAt IS NULL AND rejectedAt IS NULL) referencing this profile. Populated by the server on GET endpoints."
            }
        ],
        "type.FiscalProfileDraft.validatedAt": [
            {
                type: "description",
                value: "Timestamp of the most recent client approval. Null means \"pré-existente\" (profile predates the validation flow) when there is also no pending draft."
            }
        ],
        "type.FiscalProfileDraft.parentId": [
            {
                type: "description",
                value: "Principal id when this draft represents an edit; null for brand-new admin-Zig creations not yet materialized."
            }
        ],
        "type.FiscalProductGroupDraft.hasPendingDraft": [
            {
                type: "description",
                value: "True when there is a pending draft referencing this group. Populated by the server on GET endpoints."
            }
        ],
        "type.FiscalProductGroupDraft.validatedAt": [
            {
                type: "description",
                value: "Timestamp of the most recent client approval. Null = \"pré-existente\" (group predates the validation flow) when there is also no pending draft."
            }
        ],
        "type.InvoiceFiscalProductGroupServiceNational.codigoTributacaoMunicipalIss": [
            {
                type: "description",
                value: "\"Municipal tax code for ISS (Imposto Sobre Serviços). Format and values vary by municipality. When provided, it is sent as codigo_tributacao_municipal_iss to the Focus NFSe API.\""
            }
        ],
        "type.DeliveryReceiptItem.source": [
            {
                type: "description",
                value: "Delivery channel from `delivery_orders.deliverySource` (shared `DeliverySource` enum). Recharges without a matching delivery_order fall under `other`."
            }
        ],
        "type.DeliveryReceiptItem.value": [
            {
                type: "description",
                value: "Sum of recharge value for this source, applying `isExpired ? totalValue : isRefunded ? usedValue : totalValue`."
            }
        ],
        "type.DeliveryReceipt.total": [
            {
                type: "description",
                value: "Sum of all `items[].value`. Zero when there are no delivery recharges."
            }
        ],
        "type.DeliveryReceipt.items": [
            {
                type: "description",
                value: "Per-source breakdown. Empty array when there are no delivery recharges."
            }
        ],
        "type.Organization.isTest": [
            {
                type: "description",
                value: "True when the organization is flagged as a test/demo org. The dashboard uses it to suppress the fiscal validation UI (CU-86e1vdvh1). Optional: only populated on the login/session payload."
            }
        ],
        "type.OrganizationWithFeatures.isKeyAccount": [
            {
                type: "description",
                value: "Indica se a organização é classificada como Key Account."
            }
        ],
        "type.OrganizationWithFeatures.isTest": [
            {
                type: "description",
                value: "True when the organization is flagged as a test/demo org. The dashboard uses it to suppress the fiscal validation UI (CU-86e1vdvh1)."
            }
        ],
        "type.PaymentLink.id": [
            {
                type: "description",
                value: "\"Identificador interno do link.\""
            }
        ],
        "type.PaymentLink.url": [
            {
                type: "description",
                value: "\"URL de checkout para o pagador.\""
            }
        ],
        "type.PaymentLink.status": [
            {
                type: "description",
                value: "\"Situação atual do link.\""
            }
        ],
        "type.PaymentLink.amount": [
            {
                type: "description",
                value: "\"Valor da cobrança em centavos.\""
            }
        ],
        "type.PaymentLink.installments": [
            {
                type: "description",
                value: "\"Número de parcelas.\""
            }
        ],
        "type.PaymentLink.paymentOrigin": [
            {
                type: "description",
                value: "\"Conta que recebe a liquidação (zig ou place).\""
            }
        ],
        "type.PaymentLink.description": [
            {
                type: "description",
                value: "\"Descrição da cobrança (exibida na listagem).\""
            }
        ],
        "type.PaymentLink.createdAt": [
            {
                type: "description",
                value: "\"Data de criação do link.\""
            }
        ],
        "type.PaymentLink.paidAt": [
            {
                type: "description",
                value: "\"Data em que o link foi pago; ausente enquanto não pago.\""
            }
        ],
        "type.CreatePaymentLinkResult.id": [
            {
                type: "description",
                value: "\"Identificador interno do link criado.\""
            }
        ],
        "type.CreatePaymentLinkResult.url": [
            {
                type: "description",
                value: "\"URL de checkout para o pagador.\""
            }
        ],
        "type.CreatePaymentLinkResult.status": [
            {
                type: "description",
                value: "\"Situação inicial do link.\""
            }
        ],
        "type.PaymentLinkPage.rows": [
            {
                type: "description",
                value: "\"Links da página atual.\""
            }
        ],
        "type.PaymentLinkPage.total": [
            {
                type: "description",
                value: "\"Total de links do estabelecimento (todas as páginas).\""
            }
        ],
        "type.PaymentLinkFilter.search": [
            {
                type: "description",
                value: "\"Filtra por ID do link ou descrição (match parcial, case-insensitive).\""
            }
        ],
        "type.PaymentLinkFilter.statuses": [
            {
                type: "description",
                value: "\"Filtra pelos status informados (vazio = todos).\""
            }
        ],
        "type.PaymentLinkFilter.startDate": [
            {
                type: "description",
                value: "\"Limite inferior do período (inclusivo), aplicado à coluna definida em dateField.\""
            }
        ],
        "type.PaymentLinkFilter.endDate": [
            {
                type: "description",
                value: "\"Limite superior do período (inclusivo), aplicado à coluna definida em dateField.\""
            }
        ],
        "type.PaymentLinkFilter.dateField": [
            {
                type: "description",
                value: "\"Define se startDate/endDate filtram por data de criação ou de pagamento. Ausente = createdAt.\""
            }
        ],
        "type.PlaceContractDetails.charges": [
            {
                type: "description",
                value: "Lista de cobranças (null quando o usuário não possui permissão read:charges)"
            }
        ],
        "type.SimplifiedPlace.isHouse": [
            {
                type: "description",
                value: "Indica se o place é House (operação própria). Vem de place_configs.isHouse — null quando o place não possui place_configs."
            }
        ],
        "type.NewProduct.systemProductId": [
            {
                type: "description",
                value: "Required when SYSTEM_PRODUCT feature is enabled for the organization."
            }
        ],
        "type.EditedProductThroughImport.systemProductId": [
            {
                type: "description",
                value: "Required when SYSTEM_PRODUCT feature is enabled for the organization."
            }
        ],
        "type.OrganizationProduct.isPendingDeletion": [
            {
                type: "description",
                value: "True when the product is queued or running in an async deletion job. The UI should hide edit actions while this flag is true."
            }
        ],
        "type.OrganizationProduct.deletionFailedReason": [
            {
                type: "description",
                value: "When the last deletion job failed for this product, carries the failure code/message. Null when there has been no failure or when the product was never targeted for deletion."
            }
        ],
        "type.OrganizationProductToPlaceProduct.isPendingDeletion": [
            {
                type: "description",
                value: "True when the product is queued or running in an async deletion job. The UI should hide edit actions while this flag is true."
            }
        ],
        "type.OrganizationProductToPlaceProduct.deletionFailedReason": [
            {
                type: "description",
                value: "When the last deletion job failed for this product, carries the failure code/message. Null when there has been no failure or when the product was never targeted for deletion."
            }
        ],
        "type.CategoryProduct.isMountable": [
            {
                type: "description",
                value: "True when the product has its own mountable sections. The product-list query does not hydrate `mountableDescription` (it stays null) for performance; use this flag for \"is mountable\" checks and refetch the product by id for the sections. Nullable so clients don't hard-break if served by an API revision that predates this field."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.count": [
            {
                type: "description",
                value: "Number of units sold at this price variation."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.unitValue": [
            {
                type: "description",
                value: "Unit price of this variation."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.subtotal": [
            {
                type: "description",
                value: "Subtotal before discounts."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.discount": [
            {
                type: "description",
                value: "Discount applied."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.totalValue": [
            {
                type: "description",
                value: "Total after discounts."
            }
        ],
        "type.ProductsSoldReportV2PriceVariation.proportionalValue": [
            {
                type: "description",
                value: "Proportional value by category or custom dimension."
            }
        ],
        "type.ProductsSoldReportV2MountableComponent.id": [
            {
                type: "description",
                value: "Component ID."
            }
        ],
        "type.ProductsSoldReportV2MountableComponent.name": [
            {
                type: "description",
                value: "Component name."
            }
        ],
        "type.ProductsSoldReportV2MountableComponent.count": [
            {
                type: "description",
                value: "Number of units sold."
            }
        ],
        "type.ProductsSoldReportV2MountableComponent.section": [
            {
                type: "description",
                value: "Section this component belongs to."
            }
        ],
        "type.ProductsSoldReportV2Row.productId": [
            {
                type: "description",
                value: "Product ID."
            }
        ],
        "type.ProductsSoldReportV2Row.fiscalCode": [
            {
                type: "description",
                value: "Fiscal code (NCM/CEST), if available."
            }
        ],
        "type.ProductsSoldReportV2Row.productName": [
            {
                type: "description",
                value: "Product name."
            }
        ],
        "type.ProductsSoldReportV2Row.categoryId": [
            {
                type: "description",
                value: "Category ID."
            }
        ],
        "type.ProductsSoldReportV2Row.categoryName": [
            {
                type: "description",
                value: "Category name."
            }
        ],
        "type.ProductsSoldReportV2Row.image": [
            {
                type: "description",
                value: "Product image with SHA-256 hash and URL."
            }
        ],
        "type.ProductsSoldReportV2Row.count": [
            {
                type: "description",
                value: "Total units sold."
            }
        ],
        "type.ProductsSoldReportV2Row.subtotal": [
            {
                type: "description",
                value: "Subtotal before discounts."
            }
        ],
        "type.ProductsSoldReportV2Row.discount": [
            {
                type: "description",
                value: "Total discounts applied."
            }
        ],
        "type.ProductsSoldReportV2Row.totalValue": [
            {
                type: "description",
                value: "Total after discounts."
            }
        ],
        "type.ProductsSoldReportV2Row.priceVariations": [
            {
                type: "description",
                value: "Breakdown by price variation."
            }
        ],
        "type.ProductsSoldReportV2Row.mountableComponents": [
            {
                type: "description",
                value: "Mountable components, if applicable."
            }
        ],
        "type.ProductsSoldReportV2Row.barId": [
            {
                type: "description",
                value: "Bar ID where the product was sold."
            }
        ],
        "type.ProductsSoldReportV2Row.barName": [
            {
                type: "description",
                value: "Bar name where the product was sold."
            }
        ],
        "type.ProductsSoldReportV2Row.sectorId": [
            {
                type: "description",
                value: "Sector ID of the bar."
            }
        ],
        "type.ProductsSoldReportV2Row.sectorName": [
            {
                type: "description",
                value: "Sector name of the bar."
            }
        ],
        "type.ProductsSoldReportV2Row.source": [
            {
                type: "description",
                value: "Transaction source."
            }
        ],
        "type.ProductsSoldReportV2Row.productStatus": [
            {
                type: "description",
                value: "Product status relative to the place."
            }
        ],
        "type.ProductsSoldReportV2Row.masterKind": [
            {
                type: "description",
                value: "Master kind of the product."
            }
        ],
        "type.ProductsSoldReportV2Row.isReturnable": [
            {
                type: "description",
                value: "Whether this row represents a single product return."
            }
        ],
        "type.ProductsSoldReportV2Filters.placeId": [
            {
                type: "description",
                value: "Place ID."
            }
        ],
        "type.ProductsSoldReportV2Filters.since": [
            {
                type: "description",
                value: "Start of date range."
            }
        ],
        "type.ProductsSoldReportV2Filters.until": [
            {
                type: "description",
                value: "End of date range."
            }
        ],
        "type.ProductsSoldReportV2Filters.eventIds": [
            {
                type: "description",
                value: "Filter by event IDs."
            }
        ],
        "type.ProductsSoldReportV2Filters.categoryIds": [
            {
                type: "description",
                value: "Filter by category IDs."
            }
        ],
        "type.ProductsSoldReportV2Filters.productIds": [
            {
                type: "description",
                value: "Filter by product IDs."
            }
        ],
        "type.ProductsSoldReportV2Filters.barIds": [
            {
                type: "description",
                value: "Filter by bar IDs."
            }
        ],
        "type.ProductsSoldReportV2Filters.sectorIds": [
            {
                type: "description",
                value: "Filter by sector IDs."
            }
        ],
        "type.ProductsSoldReportV2Filters.sources": [
            {
                type: "description",
                value: "Filter by sale sources."
            }
        ],
        "type.ProductsSoldReportV2Filters.statuses": [
            {
                type: "description",
                value: "Filter by sale statuses."
            }
        ],
        "type.ProductsSoldReportV2Filters.masterKinds": [
            {
                type: "description",
                value: "Filter by master kinds."
            }
        ],
        "type.ProductsSoldReportV2Filters.operationTypes": [
            {
                type: "description",
                value: "Filter by operation types."
            }
        ],
        "type.KdsProductsReportRow.productId": [
            {
                type: "description",
                value: "Product ID."
            }
        ],
        "type.KdsProductsReportRow.productName": [
            {
                type: "description",
                value: "Product name."
            }
        ],
        "type.KdsProductsReportRow.productImageUrl": [
            {
                type: "description",
                value: "Product image URL, if available."
            }
        ],
        "type.KdsProductsReportRow.categoryName": [
            {
                type: "description",
                value: "Category name."
            }
        ],
        "type.KdsProductsReportRow.source": [
            {
                type: "description",
                value: "Order source from the KDS (e.g. PDV, TOTEM, WEB_COMANDA_ONLINE)."
            }
        ],
        "type.KdsProductsReportRow.quantity": [
            {
                type: "description",
                value: "Total quantity produced (sum of item amounts)."
            }
        ],
        "type.KdsProductsReportRow.expectedTime": [
            {
                type: "description",
                value: "Expected production time in seconds, based on product configuration. Null when product has no preparation time configured."
            }
        ],
        "type.KdsProductsReportRow.actualTime": [
            {
                type: "description",
                value: "Average actual production time in seconds."
            }
        ],
        "type.KdsProductsReportRow.variation": [
            {
                type: "description",
                value: "Difference between actual and expected time in seconds. Null when expectedTime is null."
            }
        ],
        "type.KdsProductsReportFilters.placeId": [
            {
                type: "description",
                value: "Place ID."
            }
        ],
        "type.KdsProductsReportFilters.since": [
            {
                type: "description",
                value: "Start of date range."
            }
        ],
        "type.KdsProductsReportFilters.until": [
            {
                type: "description",
                value: "End of date range."
            }
        ],
        "type.KdsProductsReportFilters.kdsIds": [
            {
                type: "description",
                value: "Filter by KDS IDs."
            }
        ],
        "type.KdsProductsReportFilters.screenIds": [
            {
                type: "description",
                value: "Filter by screen IDs."
            }
        ],
        "type.KdsProductsReportFilters.sources": [
            {
                type: "description",
                value: "Filter by order sources."
            }
        ],
        "type.KdsProductsReportFilters.categoryIds": [
            {
                type: "description",
                value: "Filter by product category IDs."
            }
        ],
        "type.KdsProductsReportFilters.productIds": [
            {
                type: "description",
                value: "Filter by product IDs."
            }
        ],
        "type.DetailedTransactionsReportProduct.name": [
            {
                type: "description",
                value: "Product name."
            }
        ],
        "type.DetailedTransactionsReportProduct.fiscalCode": [
            {
                type: "description",
                value: "Fiscal code (NCM/CEST), if available."
            }
        ],
        "type.DetailedTransactionsReportProduct.category": [
            {
                type: "description",
                value: "Category name, if any."
            }
        ],
        "type.DetailedTransactionsReportProduct.count": [
            {
                type: "description",
                value: "Number of units sold."
            }
        ],
        "type.DetailedTransactionsReportProduct.value": [
            {
                type: "description",
                value: "Unit value."
            }
        ],
        "type.DetailedTransactionsReportProduct.discount": [
            {
                type: "description",
                value: "Discount applied to this product line."
            }
        ],
        "type.DetailedTransactionsReportProduct.total": [
            {
                type: "description",
                value: "Total value of this product line (count * value - discount)."
            }
        ],
        "type.DetailedTransactionsReportRow.date": [
            {
                type: "description",
                value: "Transaction date (earliest non-tip buyer payment date)."
            }
        ],
        "type.DetailedTransactionsReportRow.transactionId": [
            {
                type: "description",
                value: "Transaction ID."
            }
        ],
        "type.DetailedTransactionsReportRow.userId": [
            {
                type: "description",
                value: "Customer user ID, if associated."
            }
        ],
        "type.DetailedTransactionsReportRow.name": [
            {
                type: "description",
                value: "Customer display name (or \"Venda Avulsa\" when no user)."
            }
        ],
        "type.DetailedTransactionsReportRow.document": [
            {
                type: "description",
                value: "Customer document (CPF), masked when not applicable."
            }
        ],
        "type.DetailedTransactionsReportRow.sellerId": [
            {
                type: "description",
                value: "Seller (employee) ID, if any."
            }
        ],
        "type.DetailedTransactionsReportRow.sellerName": [
            {
                type: "description",
                value: "Seller (employee) name, if any."
            }
        ],
        "type.DetailedTransactionsReportRow.value": [
            {
                type: "description",
                value: "Total transaction value (grossValue - discount)."
            }
        ],
        "type.DetailedTransactionsReportRow.grossValue": [
            {
                type: "description",
                value: "Subtotal before discounts."
            }
        ],
        "type.DetailedTransactionsReportRow.discount": [
            {
                type: "description",
                value: "Total discounts applied."
            }
        ],
        "type.DetailedTransactionsReportRow.paymentMethods": [
            {
                type: "description",
                value: "Payment methods used in the transaction."
            }
        ],
        "type.DetailedTransactionsReportRow.isRefunded": [
            {
                type: "description",
                value: "Whether the transaction is fully refunded (BOOL_AND over non-tip payments)."
            }
        ],
        "type.DetailedTransactionsReportRow.products": [
            {
                type: "description",
                value: "Products breakdown for this transaction."
            }
        ],
        "type.DetailedTransactionsReportFilters.placeId": [
            {
                type: "description",
                value: "Place ID."
            }
        ],
        "type.DetailedTransactionsReportFilters.since": [
            {
                type: "description",
                value: "Start of date range."
            }
        ],
        "type.DetailedTransactionsReportFilters.until": [
            {
                type: "description",
                value: "End of date range."
            }
        ],
        "type.DetailedTransactionsReportFilters.eventIds": [
            {
                type: "description",
                value: "Filter by event IDs."
            }
        ],
        "type.DetailedTransactionsReportFilters.customerName": [
            {
                type: "description",
                value: "Filter by customer name (UNACCENT + ILIKE)."
            }
        ],
        "type.DetailedTransactionsReportFilters.employeeIds": [
            {
                type: "description",
                value: "Filter by employee (seller) IDs."
            }
        ],
        "type.DetailedTransactionsReportFilters.paymentMethods": [
            {
                type: "description",
                value: "Filter by payment methods."
            }
        ],
        "type.DetailedTransactionsReportFilters.sectorIds": [
            {
                type: "description",
                value: "Filter by sector IDs."
            }
        ],
        "type.DetailedTransactionsReportFilters.orderBy": [
            {
                type: "description",
                value: "Sorting criteria (default: [{date, desc}])."
            }
        ],
        "type.DetailedTransactionsReportTotals.totalTransactions": [
            {
                type: "description",
                value: "Total number of transactions matching the filters."
            }
        ],
        "type.DetailedTransactionsReportTotals.refundedCount": [
            {
                type: "description",
                value: "Number of fully refunded transactions."
            }
        ],
        "type.DetailedTransactionsReportTotals.uniqueCustomers": [
            {
                type: "description",
                value: "Distinct customers (unique non-null userIds) across the matching transactions."
            }
        ],
        "type.DetailedTransactionsReportTotals.grossValue": [
            {
                type: "description",
                value: "Sum of grossValue (count * value) across all non-refunded product lines."
            }
        ],
        "type.DetailedTransactionsReportTotals.discount": [
            {
                type: "description",
                value: "Sum of discounts across all non-refunded product lines."
            }
        ],
        "type.DetailedTransactionsReportTotals.value": [
            {
                type: "description",
                value: "Sum of (grossValue - discount)."
            }
        ],
        "type.KdsOrdersReportRow.orderId": [
            {
                type: "description",
                value: "Order ID."
            }
        ],
        "type.KdsOrdersReportRow.orderPassword": [
            {
                type: "description",
                value: "Order password (human-friendly identifier from the order metadata)."
            }
        ],
        "type.KdsOrdersReportRow.date": [
            {
                type: "description",
                value: "Order start date."
            }
        ],
        "type.KdsOrdersReportRow.source": [
            {
                type: "description",
                value: "Order source from the KDS (e.g. PDV, TOTEM, WEB_COMANDA_ONLINE)."
            }
        ],
        "type.KdsOrdersReportRow.kdsName": [
            {
                type: "description",
                value: "Name of the KDS that received the order. Null when not available."
            }
        ],
        "type.KdsOrdersReportRow.totalTimeMin": [
            {
                type: "description",
                value: "Total order time in minutes (from ORDER_STARTED to ORDER_FINISHED)."
            }
        ],
        "type.KdsOrdersReportRow.finalStatus": [
            {
                type: "description",
                value: "Final status of the order: ON_TIME or DELAYED."
            }
        ],
        "type.KdsOrdersReportResponse.data": [
            {
                type: "description",
                value: "Rows for the current page."
            }
        ],
        "type.KdsOrdersReportResponse.pagination": [
            {
                type: "description",
                value: "Pagination metadata (current page, page size, total matching orders, last page)."
            }
        ],
        "type.KdsOrdersReportFilters.placeId": [
            {
                type: "description",
                value: "Place ID."
            }
        ],
        "type.KdsOrdersReportFilters.since": [
            {
                type: "description",
                value: "Start of date range."
            }
        ],
        "type.KdsOrdersReportFilters.until": [
            {
                type: "description",
                value: "End of date range."
            }
        ],
        "type.KdsOrdersReportFilters.kdsIds": [
            {
                type: "description",
                value: "Filter by KDS IDs."
            }
        ],
        "type.KdsOrdersReportFilters.screenIds": [
            {
                type: "description",
                value: "Filter by screen IDs."
            }
        ],
        "type.KdsOrdersReportFilters.sources": [
            {
                type: "description",
                value: "Filter by order sources."
            }
        ],
        "type.KdsOrdersReportFilters.orderPassword": [
            {
                type: "description",
                value: "Filter by order password (free text, case-insensitive partial match)."
            }
        ],
        "type.KdsOrdersReportFilters.finalStatus": [
            {
                type: "description",
                value: "Filter by final status: ON_TIME or DELAYED."
            }
        ],
        "type.KdsOrdersReportFilters.sortBy": [
            {
                type: "description",
                value: "Column to sort by: date or totalTimeMin."
            }
        ],
        "type.KdsOrdersReportFilters.sortDir": [
            {
                type: "description",
                value: "Sort direction: asc or desc."
            }
        ],
        "type.BackofficeSingleStorageInsights.lowTurnoverProducts": [
            {
                type: "description",
                value: "Flattened list of products with low turnover for the given storage"
            }
        ],
        "type.BackofficeSingleStorageInsights.highTurnoverProducts": [
            {
                type: "description",
                value: "Flattened list of products with high turnover for the given storage"
            }
        ],
        "type.BackofficeSingleStorageInsights.zeroQuantityProducts": [
            {
                type: "description",
                value: "Flattened list of zero-quantity irregular products"
            }
        ],
        "type.BackofficeSingleStorageInsights.productsWithoutUnitCostValue": [
            {
                type: "description",
                value: "Flattened list of products without unit cost value"
            }
        ],
        "type.SearchFilters.presenceDays": [
            {
                type: "description",
                value: "Follows postgres' days of week (0 = Sunday, 6 = Saturday)"
            }
        ],
        "type.UserTransactionOrderFee.name": [
            {
                type: "description",
                value: "Nome da taxa (ex: serviceFee, minimumOrderFee, tip)."
            }
        ],
        "type.UserTransactionOrderFee.description": [
            {
                type: "description",
                value: "Descrição opcional da taxa para exibição."
            }
        ],
        "type.UserTransactionOrderFee.value": [
            {
                type: "description",
                value: "Valor da taxa em centavos."
            }
        ],
        "type.UserTransactionOrderFee.issueInvoice": [
            {
                type: "description",
                value: "Indica se a taxa compõe receita da loja e deve sair na nota fiscal."
            }
        ],
        "type.UserTransactionOrderFee.deliverySource": [
            {
                type: "description",
                value: "Origem do pedido que gerou a taxa (coala, ifood, ubereats, rappi, keeta, 99food). Null quando indisponível."
            }
        ],
        "type.UserTransactionOrderFee.receivedBy": [
            {
                type: "description",
                value: "Destinatário da gorjeta quando name = \"tip\". Ausente para taxas não-tip."
            }
        ],
        "type.UserTransactionResponse.orderFees": [
            {
                type: "description",
                value: "Lista de taxas discriminadas do pedido (serviceFee, minimumOrderFee, etc), vindas de delivery_order_fees. Inclui também uma linha sintética com name=\"deliveryFee\" quando a transação é de delivery e tem taxa de entrega. Vazio quando a transação não é originada de delivery."
            }
        ],
        "type.UserTransactionResponse.total": [
            {
                type: "description",
                value: "Valor total final do pedido (subTotal + deliveryFee + tip - descontos). Vem direto de delivery_orders.value. Null quando a transação não é originada de delivery."
            }
        ],
        "type.HawkerReportRelease.hawkerProductReleaseId": [
            {
                type: "description",
                value: "Identificador único da devolução/liberação"
            }
        ],
        "type.HawkerReportRelease.cycleId": [
            {
                type: "description",
                value: "UUID do ciclo de caixa em que a devolução ocorreu"
            }
        ],
        "type.HawkerReportRelease.dateTime": [
            {
                type: "description",
                value: "Data e hora da devolução em ISO 8601 (UTC)"
            }
        ],
        "type.HawkerReportRelease.quantity": [
            {
                type: "description",
                value: "Quantidade de unidades devolvidas/liberadas"
            }
        ],
        "type.HawkerReportRelease.unitValue": [
            {
                type: "description",
                value: "Valor unitário do produto em centavos"
            }
        ],
        "type.HawkerReportRelease.total": [
            {
                type: "description",
                value: "Valor total da devolução em centavos (quantity × unitValue)"
            }
        ],
        "type.Sales.productId": [
            {
                type: "description",
                value: "Identificador único do produto vendido"
            }
        ],
        "type.Sales.productName": [
            {
                type: "description",
                value: "Nome do produto (ex: \"Cerveja Heineken 350ml\")"
            }
        ],
        "type.Sales.type": [
            {
                type: "description",
                value: "Tipo de transação: 'transacted' (venda concluída), 'devolved' (devolução), 'released' (liberação), 'canceled' (cancelado), 'remained' (permaneceu em estoque) ou 'all' (agregado)"
            }
        ],
        "type.Sales.quantity": [
            {
                type: "description",
                value: "Quantidade total de unidades deste produto"
            }
        ],
        "type.Sales.value": [
            {
                type: "description",
                value: "Valor unitário do produto em centavos"
            }
        ],
        "type.Sales.total": [
            {
                type: "description",
                value: "Valor total em centavos (quantity × value)"
            }
        ],
        "type.Sales.commission": [
            {
                type: "description",
                value: "Valor da comissão do ambulante em centavos (null para devoluções, cancelamentos e permanências)"
            }
        ],
        "type.Sales.releases": [
            {
                type: "description",
                value: "Array com detalhes de devoluções/liberações do produto (null se não houver devoluções)"
            }
        ],
        "type.SessionsOpenedBar.id": [
            {
                type: "description",
                value: "\"Unique identifier of the bar.\""
            }
        ],
        "type.SessionsOpenedBar.name": [
            {
                type: "description",
                value: "\"Name of the bar.\""
            }
        ],
        "type.SessionsClosedBar.id": [
            {
                type: "description",
                value: "\"Unique identifier of the bar.\""
            }
        ],
        "type.SessionsClosedBar.name": [
            {
                type: "description",
                value: "\"Name of the bar.\""
            }
        ],
        "type.Sessions.id": [
            {
                type: "description",
                value: "\"Unique identifier of the hawker session.\""
            }
        ],
        "type.Sessions.eventId": [
            {
                type: "description",
                value: "\"Identifier of the event this session belongs to.\""
            }
        ],
        "type.Sessions.hawkerId": [
            {
                type: "description",
                value: "\"Identifier of the hawker (seller) associated with this session.\""
            }
        ],
        "type.Sessions.hawkerName": [
            {
                type: "description",
                value: "\"Full name of the hawker.\""
            }
        ],
        "type.Sessions.hawkerDocument": [
            {
                type: "description",
                value: "\"Document number (CPF/CNPJ) of the hawker.\""
            }
        ],
        "type.Sessions.cycleCount": [
            {
                type: "description",
                value: "\"Total number of cycles completed within this session.\""
            }
        ],
        "type.Sessions.change": [
            {
                type: "description",
                value: "\"Total change fund amount provided to the hawker across all cycles.\""
            }
        ],
        "type.Sessions.receivedValue": [
            {
                type: "description",
                value: "\"Total value received from the hawker across all cycles.\""
            }
        ],
        "type.Sessions.valueToReceive": [
            {
                type: "description",
                value: "\"Total value to receive from the hawker across all cycles.\""
            }
        ],
        "type.Sessions.balance": [
            {
                type: "description",
                value: "\"Total balance from the hawker across all cycles.\""
            }
        ],
        "type.Sessions.openedAt": [
            {
                type: "description",
                value: "\"Date and time when the session was opened.\""
            }
        ],
        "type.Sessions.closedAt": [
            {
                type: "description",
                value: "\"Date and time when the session was closed. Null if the session is still open.\""
            }
        ],
        "type.Sessions.usernames": [
            {
                type: "description",
                value: "\"List of usernames of employees who operated in this session.\""
            }
        ],
        "type.Sessions.openedBar": [
            {
                type: "description",
                value: "\"Bar where the session was opened. Null if no bar was assigned at opening.\""
            }
        ],
        "type.Sessions.closedBar": [
            {
                type: "description",
                value: "\"Bar where the session was closed. Null if the session is still open or no bar was assigned at closing.\""
            }
        ],
        "type.Sessions.hasCyclesClosedByDifferentCashier": [
            {
                type: "description",
                value: "\"Indicates whether any cycle within this session was closed by a different cashier than the one who opened it. Defaults to false when there are no cycles.\""
            }
        ],
        "type.Sessions.isClosedByDifferentCashier": [
            {
                type: "description",
                value: "\"Indicates whether the session itself was closed by a different cashier than the one who opened it.\""
            }
        ],
        "type.HawkersSummary.hawkerId": [
            {
                type: "description",
                value: "UUID do vendedor ambulante"
            }
        ],
        "type.HawkersSummary.hawkerName": [
            {
                type: "description",
                value: "Nome do vendedor ambulante"
            }
        ],
        "type.HawkersSummary.hawkerDocument": [
            {
                type: "description",
                value: "Documento (CPF) do vendedor ambulante"
            }
        ],
        "type.HawkersSummary.total": [
            {
                type: "description",
                value: "Valor total vendido em centavos"
            }
        ],
        "type.HawkersSummary.commission": [
            {
                type: "description",
                value: "Valor total de comissão em centavos"
            }
        ],
        "type.HawkersSummary.usernames": [
            {
                type: "description",
                value: "Lista de usernames dos funcionários que operaram com este ambulante"
            }
        ],
        "type.HawkerReport.sales": [
            {
                type: "description",
                value: "Todas as vendas do ambulante agrupadas por produto"
            }
        ],
        "type.HawkerReport.total": [
            {
                type: "description",
                value: "Valor total consolidado de todas as vendas em centavos"
            }
        ],
        "type.PlaceSectorBars.id": [
            {
                type: "description",
                value: "The id of the bar."
            }
        ],
        "type.PlaceSectorBars.name": [
            {
                type: "description",
                value: "The name of the bar."
            }
        ],
        "type.PlaceSectorAccessPolicies.id": [
            {
                type: "description",
                value: "The id of the access policy."
            }
        ],
        "type.PlaceSectorAccessPolicies.name": [
            {
                type: "description",
                value: "The name of the access policy."
            }
        ],
        "type.PlaceSector.id": [
            {
                type: "description",
                value: "The id of the place sector."
            }
        ],
        "type.PlaceSector.name": [
            {
                type: "description",
                value: "The name of the place sector."
            }
        ],
        "type.PlaceSector.description": [
            {
                type: "description",
                value: "The description of the place sector."
            }
        ],
        "type.PlaceSector.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "type.PlaceSector.createdAt": [
            {
                type: "description",
                value: "The creation date of the place sector."
            }
        ],
        "type.PlaceSector.createdBy": [
            {
                type: "description",
                value: "The id of the user who created the place sector."
            }
        ],
        "type.PlaceSector.updatedAt": [
            {
                type: "description",
                value: "The update date of the place sector."
            }
        ],
        "type.PlaceSector.isDeleted": [
            {
                type: "description",
                value: "Whether the place sector is deleted."
            }
        ],
        "type.PlaceSector.bars": [
            {
                type: "description",
                value: "The bars associated with the place sector."
            }
        ],
        "type.PlaceSector.accessPolicies": [
            {
                type: "description",
                value: "The access policies associated with the place sector."
            }
        ],
        "type.NewPlaceSector.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "type.NewPlaceSector.name": [
            {
                type: "description",
                value: "The name of the place sector."
            }
        ],
        "type.NewPlaceSector.description": [
            {
                type: "description",
                value: "The description of the place sector."
            }
        ],
        "type.NewPlaceSector.bars": [
            {
                type: "description",
                value: "The ids of the bars associated with the place sector."
            }
        ],
        "type.EditPlaceSector.name": [
            {
                type: "description",
                value: "The name of the place sector."
            }
        ],
        "type.EditPlaceSector.description": [
            {
                type: "description",
                value: "The description of the place sector."
            }
        ],
        "type.EditPlaceSector.bars": [
            {
                type: "description",
                value: "The ids of the bars associated with the place sector."
            }
        ],
        "type.EditPlaceSector.accessPolicies": [
            {
                type: "description",
                value: "The ids of the access policies associated with the place sector."
            }
        ],
        "type.AccessPolicySector.id": [
            {
                type: "description",
                value: "The id of the place sector."
            }
        ],
        "type.AccessPolicySector.name": [
            {
                type: "description",
                value: "The name of the place sector."
            }
        ],
        "type.AccessPolicy.id": [
            {
                type: "description",
                value: "The id of the access policy."
            }
        ],
        "type.AccessPolicy.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "type.AccessPolicy.name": [
            {
                type: "description",
                value: "The name of the access policy."
            }
        ],
        "type.AccessPolicy.sectors": [
            {
                type: "description",
                value: "The sectors associated with the access policy."
            }
        ],
        "type.AccessPolicy.startDate": [
            {
                type: "description",
                value: "The start date of the access policy validity."
            }
        ],
        "type.AccessPolicy.endDate": [
            {
                type: "description",
                value: "The end date of the access policy validity."
            }
        ],
        "type.AccessPolicy.allowMultipleAccess": [
            {
                type: "description",
                value: "Whether the access policy allows multiple access."
            }
        ],
        "type.AccessPolicy.createdAt": [
            {
                type: "description",
                value: "The date when the access policy was created."
            }
        ],
        "type.AccessPolicy.createdBy": [
            {
                type: "description",
                value: "The id of the user who created the access policy."
            }
        ],
        "type.AccessPolicy.updatedAt": [
            {
                type: "description",
                value: "The date when the access policy was updated."
            }
        ],
        "type.AccessPolicy.isDeleted": [
            {
                type: "description",
                value: "Whether the access policy is deleted."
            }
        ],
        "type.NewAccessPolicy.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "type.NewAccessPolicy.name": [
            {
                type: "description",
                value: "The name of the access policy."
            }
        ],
        "type.NewAccessPolicy.sectors": [
            {
                type: "description",
                value: "The ids of the sectors associated with the access policy."
            }
        ],
        "type.NewAccessPolicy.startDate": [
            {
                type: "description",
                value: "The start date of the access policy validity."
            }
        ],
        "type.NewAccessPolicy.endDate": [
            {
                type: "description",
                value: "The end date of the access policy validity."
            }
        ],
        "type.NewAccessPolicy.allowMultipleAccess": [
            {
                type: "description",
                value: "Whether the access policy allows multiple access."
            }
        ],
        "type.NewAccessPolicy.tagIds": [
            {
                type: "description",
                value: "The ids of the tags associated with the access policy."
            }
        ],
        "type.EditAccessPolicy.name": [
            {
                type: "description",
                value: "The name of the access policy."
            }
        ],
        "type.EditAccessPolicy.sectors": [
            {
                type: "description",
                value: "The ids of the sectors associated with the access policy."
            }
        ],
        "type.EditAccessPolicy.startDate": [
            {
                type: "description",
                value: "The start date of the access policy validity."
            }
        ],
        "type.EditAccessPolicy.endDate": [
            {
                type: "description",
                value: "The end date of the access policy validity."
            }
        ],
        "type.EditAccessPolicy.allowMultipleAccess": [
            {
                type: "description",
                value: "Whether the access policy allows multiple access."
            }
        ],
        "type.AccessTag.tagId": [
            {
                type: "description",
                value: "The id of the tag."
            }
        ],
        "type.AccessTag.accessPolicyId": [
            {
                type: "description",
                value: "The id of the access policy."
            }
        ],
        "type.AccessTag.createdAt": [
            {
                type: "description",
                value: "The date when the access tag was created."
            }
        ],
        "type.EquipmentDetailByPlace.equipmentId": [
            {
                type: "description",
                value: "Unique identifier of the equipment"
            }
        ],
        "type.EquipmentDetailByPlace.contractId": [
            {
                type: "description",
                value: "Unique identifier of the contract"
            }
        ],
        "type.EquipmentDetailByPlace.contractNumber": [
            {
                type: "description",
                value: "Contract number"
            }
        ],
        "type.EquipmentDetailByPlace.contractStatus": [
            {
                type: "description",
                value: "Current status of the contract"
            }
        ],
        "type.EquipmentDetailByPlace.serialNumber": [
            {
                type: "description",
                value: "Serial number of the equipment (optional)"
            }
        ],
        "type.EquipmentDetailByPlace.equipmentType": [
            {
                type: "description",
                value: "Equipment type. Valid values: \"terminal\", \"battery\", \"charger\", \"connector\", \"cardOrBracelet\", \"simCard\", \"workwear\", \"totem\", \"cellphonePdv\""
            }
        ],
        "type.EquipmentDetailByPlace.equipmentModel": [
            {
                type: "description",
                value: "Equipment model (optional). Valid values include: \"smartPosSunmiP2\", \"smartPosPaxA930\", \"paxPagseguroExtraBattery\", \"chargerTypeC\", \"usbTypeCCable\", \"nCardStandard\", \"vivoDataChip\" and others. See equipment catalog for complete list."
            }
        ],
        "type.EquipmentDetailByPlace.quantity": [
            {
                type: "description",
                value: "Quantity of this equipment"
            }
        ],
        "type.EquipmentDetailByPlace.unitValue": [
            {
                type: "description",
                value: "Unit value of the equipment"
            }
        ],
        "type.EquipmentsByPlaceFilters.organizationId": [
            {
                type: "description",
                value: "Organization identifier (required)"
            }
        ],
        "type.EquipmentsByPlaceFilters.placeId": [
            {
                type: "description",
                value: "Place identifier (required)"
            }
        ],
        "type.EquipmentsByPlaceFilters.contractId": [
            {
                type: "description",
                value: "Filter by contract identifier (optional)"
            }
        ],
        "type.EquipmentsByPlaceFilters.serialNumber": [
            {
                type: "description",
                value: "Filter by equipment serial number (optional)"
            }
        ],
        "type.EquipmentsByPlaceFilters.model": [
            {
                type: "description",
                value: "Filter by equipment model (partial match, case-insensitive). Valid values include: \"smartPosSunmiP2\", \"smartPosPaxA930\", \"paxPagseguroExtraBattery\", \"chargerTypeC\", \"usbTypeCCable\", \"nCardStandard\", \"vivoDataChip\" and others."
            }
        ],
        "type.EquipmentsByPlaceFilters.status": [
            {
                type: "description",
                value: "Filter by contract status. Can provide multiple statuses as array."
            }
        ],
        "type.EquipmentsByPlacePaginationParams.page": [
            {
                type: "description",
                value: "Page number (starts at 1)"
            }
        ],
        "type.EquipmentsByPlacePaginationParams.limit": [
            {
                type: "description",
                value: "Number of items per page"
            }
        ],
        "type.ListEquipmentsByPlaceRequest.filters": [
            {
                type: "description",
                value: "Filters to apply to the equipment details (organizationId and placeId are required)"
            }
        ],
        "type.ListEquipmentsByPlaceRequest.pagination": [
            {
                type: "description",
                value: "Optional pagination parameters"
            }
        ],
        "type.GetEquipmentsByPlaceToExcelRequest.filters": [
            {
                type: "description",
                value: "Filters to apply to the equipment details export (organizationId and placeId are required)"
            }
        ],
        "type.ListEquipmentsByPlaceResponsePagination.currentPage": [
            {
                type: "description",
                value: "Current page number"
            }
        ],
        "type.ListEquipmentsByPlaceResponsePagination.perPage": [
            {
                type: "description",
                value: "Number of items per page"
            }
        ],
        "type.ListEquipmentsByPlaceResponsePagination.total": [
            {
                type: "description",
                value: "Total number of items available"
            }
        ],
        "type.ListEquipmentsByPlaceResponsePagination.lastPage": [
            {
                type: "description",
                value: "Last page number"
            }
        ],
        "type.ListEquipmentsByPlaceResponse.data": [
            {
                type: "description",
                value: "Array of detailed equipment information by place"
            }
        ],
        "type.ListEquipmentsByPlaceResponse.pagination": [
            {
                type: "description",
                value: "Pagination information"
            }
        ],
        "type.DeliverySimplifiedOrder.orderFees": [
            {
                type: "description",
                value: "Lista de fees discriminadas do pedido (serviceFee, minimumOrderFee, etc), vindas de delivery_order_fees. Substitui o uso de tip como dump de fees fiscais. Populado por getSimplifiedOrders."
            }
        ],
        "type.ManagerDeliveryOrder.tipReceivedBy": [
            {
                type: "description",
                value: "Destinatário da gorjeta. Indica se o tip foi para a loja (MERCHANT), entregador (LOGISTIC_SERVICES) ou marketplace. Null quando não há tip ou origem não informa."
            }
        ],
        "type.ManagerDeliveryOrder.orderFees": [
            {
                type: "description",
                value: "Lista de fees discriminadas do pedido (serviceFee, minimumOrderFee, etc), vindas de delivery_order_fees. Substitui o uso de tip como dump de fees fiscais. Populado por getOrder."
            }
        ],
        "type.CreateManualOrderSubItem.productId": [
            {
                type: "description",
                value: "ID do produto adicional"
            }
        ],
        "type.CreateManualOrderSubItem.count": [
            {
                type: "description",
                value: "Quantidade selecionada do adicional"
            }
        ],
        "type.CreateManualOrderSection.sectionId": [
            {
                type: "description",
                value: "ID da seção montável"
            }
        ],
        "type.CreateManualOrderSection.products": [
            {
                type: "description",
                value: "Adicionais selecionados na seção"
            }
        ],
        "type.CreateManualOrderItem.productId": [
            {
                type: "description",
                value: "ID do produto do cardápio"
            }
        ],
        "type.CreateManualOrderItem.count": [
            {
                type: "description",
                value: "Quantidade do item"
            }
        ],
        "type.CreateManualOrderItem.obs": [
            {
                type: "description",
                value: "Observação do item"
            }
        ],
        "type.CreateManualOrderItem.sections": [
            {
                type: "description",
                value: "Seções montáveis escolhidas"
            }
        ],
        "type.CreateManualOrderAddress.street": [
            {
                type: "description",
                value: "Logradouro"
            }
        ],
        "type.CreateManualOrderAddress.number": [
            {
                type: "description",
                value: "Número"
            }
        ],
        "type.CreateManualOrderAddress.complement": [
            {
                type: "description",
                value: "Complemento"
            }
        ],
        "type.CreateManualOrderAddress.neighborhood": [
            {
                type: "description",
                value: "Bairro"
            }
        ],
        "type.CreateManualOrderAddress.city": [
            {
                type: "description",
                value: "Cidade"
            }
        ],
        "type.CreateManualOrderAddress.state": [
            {
                type: "description",
                value: "Estado (UF)"
            }
        ],
        "type.CreateManualOrderAddress.postalCode": [
            {
                type: "description",
                value: "CEP"
            }
        ],
        "type.CreateManualOrderAddress.country": [
            {
                type: "description",
                value: "País"
            }
        ],
        "type.CreateManualOrderCustomer.name": [
            {
                type: "description",
                value: "Nome do cliente"
            }
        ],
        "type.CreateManualOrderCustomer.phone": [
            {
                type: "description",
                value: "Telefone"
            }
        ],
        "type.CreateManualOrderCustomer.email": [
            {
                type: "description",
                value: "E-mail"
            }
        ],
        "type.CreateManualOrderCustomer.isWhatsapp": [
            {
                type: "description",
                value: "Telefone é o mesmo do WhatsApp"
            }
        ],
        "type.CreateManualOrderCustomer.documentNumber": [
            {
                type: "description",
                value: "Documento (CPF)"
            }
        ],
        "type.CreateManualOrderCustomer.documentType": [
            {
                type: "description",
                value: "Tipo de documento"
            }
        ],
        "type.CreateManualOrderCustomer.address": [
            {
                type: "description",
                value: "Endereço de entrega (obrigatório para deliveryByRestaurant)"
            }
        ],
        "type.CreateManualOrderPayload.menuId": [
            {
                type: "description",
                value: "ID do cardápio de onde vêm os produtos"
            }
        ],
        "type.CreateManualOrderPayload.deliveryType": [
            {
                type: "description",
                value: "Tipo de entrega: entrega pelo restaurante ou retirada"
            }
        ],
        "type.CreateManualOrderPayload.customer": [
            {
                type: "description",
                value: "Dados do cliente"
            }
        ],
        "type.CreateManualOrderPayload.items": [
            {
                type: "description",
                value: "Itens do pedido (id do produto + quantidade)"
            }
        ],
        "type.CreateManualOrderPayload.tip": [
            {
                type: "description",
                value: "Gorjeta em centavos"
            }
        ],
        "type.CreateManualOrderPayload.obs": [
            {
                type: "description",
                value: "Observação geral do pedido"
            }
        ],
        "type.CreateManualOrderPixCharge.chargeId": [
            {
                type: "description",
                value: "ID da cobrança PIX"
            }
        ],
        "type.CreateManualOrderPixCharge.emv": [
            {
                type: "description",
                value: "EMV copia-e-cola"
            }
        ],
        "type.CreateManualOrderPixCharge.qrCode": [
            {
                type: "description",
                value: "QR code (imagem base64)"
            }
        ],
        "type.CreateManualOrderPixCharge.value": [
            {
                type: "description",
                value: "Valor em centavos"
            }
        ],
        "type.CreateManualOrderPixCharge.expiresIn": [
            {
                type: "description",
                value: "Segundos até expirar"
            }
        ],
        "type.CreateManualOrderResponse.deliveryOrderId": [
            {
                type: "description",
                value: "ID do pedido de entrega criado"
            }
        ],
        "type.CreateManualOrderResponse.reference": [
            {
                type: "description",
                value: "Número de referência do pedido (exibido como #número)"
            }
        ],
        "type.CreateManualOrderResponse.pixCharge": [
            {
                type: "description",
                value: "Cobrança PIX para pagamento"
            }
        ],
        "type.CalculateDeliveryFeeResponse.deliveryFee": [
            {
                type: "description",
                value: "Taxa de entrega em centavos"
            }
        ],
        "type.CalculateDeliveryFeeResponse.distanceKm": [
            {
                type: "description",
                value: "Distância rodoviária em km entre o local e o endereço do cliente"
            }
        ],
        "type.CalculateDeliveryFeeResponse.formattedAddress": [
            {
                type: "description",
                value: "Endereço normalizado retornado pela geocodificação"
            }
        ],
        "type.UpsertDeliveryFeeConfigPayload.taxType": [
            {
                type: "description",
                value: "Tipo de taxa (ratePerRadius ainda não suportado por este endpoint)"
            }
        ],
        "type.UpsertDeliveryFeeConfigPayload.baseRateValue": [
            {
                type: "description",
                value: "Taxa base/fixa em centavos"
            }
        ],
        "type.UpsertDeliveryFeeConfigPayload.ratePerKm": [
            {
                type: "description",
                value: "Valor por km em centavos (usado em baseRateWithVariableKm)"
            }
        ],
        "type.UpsertDeliveryFeeConfigPayload.attendanceRadius": [
            {
                type: "description",
                value: "Raio máximo de atendimento em km (0 = sem limite)"
            }
        ],
        "type.DeliveryFeeConfigResponse.taxType": [
            {
                type: "description",
                value: "Tipo de taxa aplicado"
            }
        ],
        "type.DeliveryFeeConfigResponse.baseRateValue": [
            {
                type: "description",
                value: "Taxa base/fixa em centavos"
            }
        ],
        "type.DeliveryFeeConfigResponse.ratePerKm": [
            {
                type: "description",
                value: "Valor por km em centavos"
            }
        ],
        "type.DeliveryFeeConfigResponse.attendanceRadius": [
            {
                type: "description",
                value: "Raio máximo de atendimento em km"
            }
        ],
        "type.FilterOptionValue.key": [
            {
                type: "description",
                value: "Option key/identifier"
            }
        ],
        "type.FilterOptionValue.value": [
            {
                type: "description",
                value: "Display label (i18n key for frontend translation)"
            }
        ],
        "type.FilterOption.name": [
            {
                type: "description",
                value: "Filter group name (i18n key for frontend translation)"
            }
        ],
        "type.FilterOption.values": [
            {
                type: "description",
                value: "Available filter values"
            }
        ],
        "type.FilterOption.rawValue": [
            {
                type: "description",
                value: "Raw backend field to be filtered (present for free-text filters like nsu, value, place, vendor, etc.)"
            }
        ],
        "type.AcquirerPendingTransactionFilterOptionsResponse.options": [
            {
                type: "description",
                value: "List of filter option groups. Returns: Payment Methods (Credit, Debit, Pix), Status (pending, conciliated, processed, cancelled), and column metadata (nsu, place.name, paymentMethod, vendor.name, value)"
            }
        ],
        "type.OFXFile.TRNTYPE": [
            {
                type: "description",
                value: "tipo de transação"
            },
            {
                type: "description",
                value: "CREDIT: Crédito"
            },
            {
                type: "description",
                value: "DEBIT: Débito"
            },
            {
                type: "description",
                value: "INT: Juros recebidos"
            },
            {
                type: "description",
                value: "DIV: Dividendos"
            },
            {
                type: "description",
                value: "FEE: Taxas"
            },
            {
                type: "description",
                value: "SRVCHG: Cobrança de serviço"
            },
            {
                type: "description",
                value: "DEP: Depósito"
            },
            {
                type: "description",
                value: "ATM: Transação em caixa eletrônico"
            },
            {
                type: "description",
                value: "POS: Ponto de venda (compra com cartão de débito/crédito)"
            },
            {
                type: "description",
                value: "XFER: Transferência"
            },
            {
                type: "description",
                value: "CHECK: Cheque"
            },
            {
                type: "description",
                value: "PAYMENT: Pagamento"
            },
            {
                type: "description",
                value: "CASH: Retirada de dinheiro"
            },
            {
                type: "description",
                value: "DIRECTDEP: Depósito direto"
            },
            {
                type: "description",
                value: "DIRECTDEBIT: Débito direto"
            },
            {
                type: "description",
                value: "REPEATPMT: Pagamento recorrente"
            },
            {
                type: "description",
                value: "OTHER: Outro tipo de transação"
            }
        ],
        "type.OFXFile.DTPOSTED": [
            {
                type: "description",
                value: "data da transação"
            }
        ],
        "type.OFXFile.TRNAMT": [
            {
                type: "description",
                value: "valor da transação"
            }
        ],
        "type.OFXFile.FITID": [
            {
                type: "description",
                value: "identificador do banco da transação"
            }
        ],
        "type.OFXFile.MEMO": [
            {
                type: "description",
                value: "descrição da transação"
            }
        ],
        "type.OFXFileTransactionResponse.typeTransaction": [
            {
                type: "description",
                value: "tipo de transação."
            }
        ],
        "type.OFXFileBankInfo.bankId": [
            {
                type: "description",
                value: "uuid banco"
            }
        ],
        "type.OFXFileBankInfo.bankName": [
            {
                type: "description",
                value: "nome da organização"
            }
        ],
        "type.OFXFileBankInfo.bankCode": [
            {
                type: "description",
                value: "código do banco"
            }
        ],
        "type.OFXFileBankInfo.branchCode": [
            {
                type: "description",
                value: "número da agência"
            }
        ],
        "type.OFXFileBankInfo.accountCode": [
            {
                type: "description",
                value: "número da conta"
            }
        ],
        "type.OFXFileResponse.bankId": [
            {
                type: "description",
                value: "uuid banco"
            }
        ],
        "type.OFXFileResponse.bankName": [
            {
                type: "description",
                value: "nome da organização"
            }
        ],
        "type.OFXFileResponse.bankCode": [
            {
                type: "description",
                value: "código do banco"
            }
        ],
        "type.OFXFileResponse.branchCode": [
            {
                type: "description",
                value: "número da agência"
            }
        ],
        "type.OFXFileResponse.accountCode": [
            {
                type: "description",
                value: "número da conta"
            }
        ],
        "type.BonusCategory.id": [
            {
                type: "description",
                value: "\"The unique identifier\""
            }
        ],
        "type.BonusCategory.name": [
            {
                type: "description",
                value: "\"The name\""
            }
        ],
        "type.BonusCategory.daysToExpire": [
            {
                type: "description",
                value: "\"The number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "type.BonusCategory.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "type.BonusCategory.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "type.BonusCategoryCreateRequest.placeId": [
            {
                type: "description",
                value: "\"place unique identifier\""
            }
        ],
        "type.BonusCategoryCreateRequest.name": [
            {
                type: "description",
                value: "\"name\""
            }
        ],
        "type.BonusCategoryCreateRequest.daysToExpire": [
            {
                type: "description",
                value: "\"number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "type.BonusCategoryCreateRequest.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "type.BonusCategoryCreateRequest.employeeIds": [
            {
                type: "description",
                value: "\"The employees that have access to use this bonus category\""
            }
        ],
        "type.BonusCategoryCreateRequest.categoryIds": [
            {
                type: "description",
                value: "\"The product's categories that can be bought with this bonus category\""
            }
        ],
        "type.BonusCategoryCreateRequest.productIds": [
            {
                type: "description",
                value: "\"The products that can be bought with this bonus category\""
            }
        ],
        "type.BonusCategoryCreateRequest.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "type.BonusCategoryUpdateRequest.id": [
            {
                type: "description",
                value: "\"The unique identifier\""
            }
        ],
        "type.BonusCategoryUpdateRequest.name": [
            {
                type: "description",
                value: "\"The name\""
            }
        ],
        "type.BonusCategoryUpdateRequest.daysToExpire": [
            {
                type: "description",
                value: "\"The number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "type.BonusCategoryUpdateRequest.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "type.BonusCategoryUpdateRequest.employeeIds": [
            {
                type: "description",
                value: "\"The employees that have access to use this bonus category\""
            }
        ],
        "type.BonusCategoryUpdateRequest.categoryIds": [
            {
                type: "description",
                value: "\"The product's categories that can be bought with this bonus category\""
            }
        ],
        "type.BonusCategoryUpdateRequest.productIds": [
            {
                type: "description",
                value: "\"The products that can be bought with this bonus category\""
            }
        ],
        "type.BonusCategoryUpdateRequest.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "type.CompleteBonusCategory.id": [
            {
                type: "description",
                value: "\"The unique identifier\""
            }
        ],
        "type.CompleteBonusCategory.name": [
            {
                type: "description",
                value: "\"The name\""
            }
        ],
        "type.CompleteBonusCategory.daysToExpire": [
            {
                type: "description",
                value: "\"The number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "type.CompleteBonusCategory.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "type.CompleteBonusCategory.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "type.CompleteBonusCategory.employees": [
            {
                type: "description",
                value: "\"The employees that have access to use this bonus category\""
            }
        ],
        "type.CompleteBonusCategory.products": [
            {
                type: "description",
                value: "\"The products that can be bought with this bonus category\""
            }
        ],
        "type.CompleteBonusCategory.categories": [
            {
                type: "description",
                value: "\"The product's categories that can be bought with this bonus category\""
            }
        ],
        "type.BonusCategoryGetRequest.placeId": [
            {
                type: "description",
                value: "\"The place unique identifier\""
            }
        ],
        "type.BonusCategoryGetRequest.pagination": [
            {
                type: "description",
                value: "\"The pagination object\""
            }
        ],
        "type.BonusCategoryGetRequest.filters": [
            {
                type: "description",
                value: "\"The filters object\""
            }
        ],
        "type.BonusCategoryGetResponse.data": [
            {
                type: "description",
                value: "\"The data object\""
            }
        ],
        "type.BonusCategoryGetResponse.pagination": [
            {
                type: "description",
                value: "\"The pagination object\""
            }
        ],
        "type.BonusCategoryDeleteRequest.bonusCategoryIds": [
            {
                type: "description",
                value: "\"The bonus category unique identifiers\""
            }
        ],
        "type.DashboardNotificationList.description": [
            {
                type: "description",
                value: "chars limited to 100"
            }
        ],
        "type.CreateProductRequest.systemProductId": [
            {
                type: "description",
                value: "Required when SYSTEM_PRODUCT feature is enabled for the organization."
            }
        ],
        "type.CreateProductWithSectionsRequest.systemProductId": [
            {
                type: "description",
                value: "Required when SYSTEM_PRODUCT feature is enabled for the organization."
            }
        ],
        "type.ReportFilters.tableNumbers": [
            {
                type: "description",
                value: "A list of table numbers, when a table is merged and has more than one number, the numbers needs to be passed together and separated by `,`, e.g. [\"40,41\"]. This is needed because snowflake filter works this way with merged tables"
            }
        ],
        "type.MesaStatusConfigurationReturn.id": [
            {
                type: "description",
                value: "\"Null indicates that the value is a default returned by the API when the place has no saved configurations yet.\""
            }
        ],
        "type.GetCombinedOrderReportDto.orderFees": [
            {
                type: "description",
                value: "Fees discriminadas do pedido (serviceFee, minimumOrderFee, custom). Mesma fonte de delivery_order_fees."
            }
        ],
        "type.ForgotPassword.message": [
            {
                type: "description",
                value: "\"Generic confirmation message\""
            }
        ],
        "fn.createEventOperationUsedEquipments": [
            {
                type: "description",
                value: "\"Create or update used equipments for an event operation (batch)\""
            }
        ],
        "fn.getEventOperationUsedEquipments": [
            {
                type: "description",
                value: "\"Get all used equipments for an event operation (returns events with or without equipment entries)\""
            }
        ],
        "fn.deleteEventOperationUsedEquipments": [
            {
                type: "description",
                value: "\"Delete multiple used equipment entries\""
            }
        ],
        "fn.calculateOperationCharges": [
            {
                type: "description",
                value: "\"Pure read-only calculation of all charges (cobranças) for a house event_operation. Idempotent and side-effect-free.\""
            }
        ],
        "fn.getAllPermissions": [
            {
                type: "description",
                value: "Retorna todas as permissões de colaboradores disponíveis no sistema"
            }
        ],
        "fn.getBackofficeStorageInsights": [
            {
                type: "description",
                value: "Returns insights about a specific storage"
            },
            {
                type: "throws",
                value: "BackofficeError"
            }
        ],
        "fn.getBackofficeStoragesInsights": [
            {
                type: "description",
                value: "Returns insights about all storages from context"
            },
            {
                type: "throws",
                value: "BackofficeError"
            }
        ],
        "fn.getBackofficeProductStorageHistoryV3": [
            {
                type: "description",
                value: "Returns the paginated stock movement history of a product in a storage."
            }
        ],
        "fn.manualBackofficeAdjustProductAtStorage": [
            {
                type: "hidden",
                value: null
            },
            {
                type: "description",
                value: "DEPRECATED: use manualBackofficeAdjustProductAtStorageV2"
            }
        ],
        "fn.manualBackofficeAdjustProductAtStorageV2": [
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            },
            {
                type: "throws",
                value: "LacksPermission"
            },
            {
                type: "description",
                value: "Manually adjusts the quantity of a product at a storage. Unlike V1, receives the desired storage unit from the client, validates its compatibility with the product, and converts the quantity server-side."
            }
        ],
        "fn.getBackofficeSuppliersWithFilters": [
            {
                type: "description",
                value: "\"Buscar fornecedores com filtros e paginação\""
            }
        ],
        "fn.updateBackofficeStorageProductsUnitCostValueAtStorages": [
            {
                type: "description",
                value: "Updates the unit cost value of products at storages"
            },
            {
                type: "throws",
                value: "BackofficeError"
            }
        ],
        "fn.getBars": [
            {
                type: "description",
                value: "Get bars in a place. If includeDeleted is true, return all, otherwise return only not deleted"
            }
        ],
        "fn.cashierDetailsAtEvent.barIds": [
            {
                type: "description",
                value: "Lista de ids de bares para filtrar onde foram feitas as recargas e pós-pagamentos. Se for passado null vai listar todas as recargas e pós-pagamentos. Caso queira listar as recargas e pós-pagamento que não possuam um bar associado informar um array vazio []."
            }
        ],
        "fn.listCateringProducts.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.listCateringProducts.categoryId": [
            {
                type: "description",
                value: "\"Filtro por categoria (opcional)\""
            }
        ],
        "fn.listCateringProducts.productName": [
            {
                type: "description",
                value: "\"Busca por nome (opcional)\""
            }
        ],
        "fn.listCateringProducts.types": [
            {
                type: "description",
                value: "\"Filtro por tipo de produto (opcional). Quando omitido, retorna todos.\""
            }
        ],
        "fn.listCateringProducts.pagination": [
            {
                type: "description",
                value: "\"Configuracao de paginacao\""
            }
        ],
        "fn.listCateringProducts.orderBy": [
            {
                type: "description",
                value: "\"Campo de ordenacao\""
            }
        ],
        "fn.listCateringProducts.order": [
            {
                type: "description",
                value: "\"Direcao da ordenacao\""
            }
        ],
        "fn.listCateringProducts": [
            {
                type: "description",
                value: "\"Lista produtos de catering com filtros e paginacao. O filtro `types` aceita 1..N entre 'Product', 'Combo' e 'Mountable' — quando omitido, retorna todos.\""
            }
        ],
        "fn.addCateringProduct.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.addCateringProduct.product": [
            {
                type: "description",
                value: "\"Payload do produto de catering\""
            }
        ],
        "fn.addCateringProduct.image": [
            {
                type: "description",
                value: "\"Imagem opcional\""
            }
        ],
        "fn.addCateringProduct": [
            {
                type: "description",
                value: "\"Cria um produto de catering (Padrao, Montavel ou Combo). Produtos de catering ficam invisiveis nos fluxos de F&B/PDV. Combos so aceitam filhos que ja sejam produtos de catering.\""
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.updateCateringProduct.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.updateCateringProduct.productId": [
            {
                type: "description",
                value: "\"ID do produto a atualizar\""
            }
        ],
        "fn.updateCateringProduct.product": [
            {
                type: "description",
                value: "\"Novo payload do produto de catering\""
            }
        ],
        "fn.updateCateringProduct.image": [
            {
                type: "description",
                value: "\"Nova imagem opcional (substitui a atual)\""
            }
        ],
        "fn.updateCateringProduct": [
            {
                type: "description",
                value: "\"Atualiza um produto de catering existente. O shape do payload espelha `addCateringProduct`. A variante (Product/Mountable/Combo) deve coincidir com a variante atual do produto — Update nao converte tipo: para trocar o tipo, exclua e crie de novo. Imagens, secoes montaveis e filhos do combo sao reescritos pelo payload (lista enviada substitui a atual).\""
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.updateCateringProductPrice.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.updateCateringProductPrice.productId": [
            {
                type: "description",
                value: "\"ID do produto\""
            }
        ],
        "fn.updateCateringProductPrice.value": [
            {
                type: "description",
                value: "\"Novo preco em centavos (>= 0)\""
            }
        ],
        "fn.updateCateringProductPrice": [
            {
                type: "description",
                value: "\"Atualiza o preco de um produto de catering nos cardapios do place. Propaga para `menu_category_products.price` apenas no place informado — `place_product_entries.value` nao eh alterado, leitores devem usar `COALESCE(mcp.price, ppe.value)` (como `getPlaceCateringProducts` ja faz). Outros places do mesmo produto nao sao afetados.\""
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.deleteCateringProducts.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.deleteCateringProducts.productIds": [
            {
                type: "description",
                value: "\"IDs dos produtos a deletar (1..500)\""
            }
        ],
        "fn.deleteCateringProducts": [
            {
                type: "description",
                value: "\"Remove (inativa) um ou mais produtos de catering em um unico request, escopado por place. Erros por item nao abortam o lote — o retorno separa `deleted` de `failed`. Para apagar 1 produto, envie `[productId]`. Ids duplicados sao deduplicados antes do processamento. Variantes Product/Mountable usam o caminho legado `removeProductFromPlace` (place-scoped: remove do `place_product_entries` e dos menus do place). Variante Combo usa soft-delete em `products` (`isDeleted = true`), espelhando `deleteCombo`.\""
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.bulkImportCateringProducts.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.bulkImportCateringProducts.items": [
            {
                type: "description",
                value: "\"Itens a importar (lista nao-vazia)\""
            }
        ],
        "fn.bulkImportCateringProducts": [
            {
                type: "description",
                value: "\"Importa em lote produtos de catering simples (variante Product apenas). Apenas criacao — nao atualiza produtos existentes. Erros por item nao abortam o lote: o retorno separa `created` de `failed`, preservando o `index` original. Sem limite maximo de itens. Imagem segue o shape `EditProductImage` (sha256/imageId/data), com fallback automatico para a imagem do systemProduct (equivalente ao `patchProducts`) quando a feature `SYSTEM_PRODUCT` esta habilitada para a organizacao e o item nao envia imagem.\""
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.exportCateringProducts.placeId": [
            {
                type: "description",
                value: "\"ID do place\""
            }
        ],
        "fn.exportCateringProducts.categoryId": [
            {
                type: "description",
                value: "\"Filtro por categoria (opcional)\""
            }
        ],
        "fn.exportCateringProducts.productName": [
            {
                type: "description",
                value: "\"Busca por nome (opcional)\""
            }
        ],
        "fn.exportCateringProducts.types": [
            {
                type: "description",
                value: "\"Filtro por tipo de produto (opcional). Quando omitido, exporta todos.\""
            }
        ],
        "fn.exportCateringProducts.orderBy": [
            {
                type: "description",
                value: "\"Campo de ordenacao\""
            }
        ],
        "fn.exportCateringProducts.order": [
            {
                type: "description",
                value: "\"Direcao da ordenacao\""
            }
        ],
        "fn.exportCateringProducts": [
            {
                type: "description",
                value: "\"Exporta a lista de produtos de catering do place em XLSX e devolve a URL publica do arquivo. Aceita os mesmos filtros de `listCateringProducts` (categoria, nome, subtipos, ordenacao) e exporta TODOS os resultados (sem paginacao). Colunas: id do produto, nome, tipo (label localizado), categoryId, nome da categoria, preco (em centavos), URL da imagem (vazia quando ausente).\""
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.getSummarizedCategories.placeId": [
            {
                type: "description",
                value: "Place ID"
            }
        ],
        "fn.getSummarizedCategories.productsSearchQuery": [
            {
                type: "description",
                value: "Filter by category name or product name"
            }
        ],
        "fn.getSummarizedCategories.status": [
            {
                type: "description",
                value: "Filter by product status (active or inactive) on the place"
            }
        ],
        "fn.getSummarizedCategories.kind": [
            {
                type: "description",
                value: "Filter by kind of category (product categories or menu categories)"
            }
        ],
        "fn.getSummarizedCategories.includeEmpty": [
            {
                type: "description",
                value: "When true, returns categories even if they have no products. When null/false (default), only categories with matching products (and their ancestors) are returned."
            }
        ],
        "fn.getSummarizedCategories": [
            {
                type: "description",
                value: "List categories with total of products based on filters and kind."
            }
        ],
        "fn.listComodatoContracts": [
            {
                type: "description",
                value: "Lista contratos de comodato do place com filtros, ordenação e paginação"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.exportComodatoContractsToExcel": [
            {
                type: "description",
                value: "Exporta contratos de comodato para Excel"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.resendComodatoContractSignatureEmail": [
            {
                type: "description",
                value: "Reenvia email de assinatura do contrato via ClickSign"
            },
            {
                type: "throws",
                value: "NotFound"
            },
            {
                type: "throws",
                value: "LacksPermission"
            }
        ],
        "fn.setDeliveryFeeFiscalProductGroup.placeId": [
            {
                type: "description",
                value: "Identificador do place onde o vínculo será aplicado."
            }
        ],
        "fn.setDeliveryFeeFiscalProductGroup.deliveryFeeId": [
            {
                type: "description",
                value: "Identificador da taxa de delivery a ser vinculada."
            }
        ],
        "fn.setDeliveryFeeFiscalProductGroup.fiscalProductGroupId": [
            {
                type: "description",
                value: "Identificador do grupo fiscal a ser vinculado à taxa."
            }
        ],
        "fn.setDeliveryFeeFiscalProductGroup": [
            {
                type: "description",
                value: "Cria ou atualiza o vínculo entre uma taxa de delivery e um grupo fiscal de produto para o place. Reativa vínculos previamente removidos. Valida que o grupo fiscal pertence à mesma organização do place. Lança InvalidArgument quando UUIDs são inválidos ou o grupo fiscal não pertence à organização do place. Lança NotFound quando place, taxa ou grupo não existem."
            }
        ],
        "fn.removeDeliveryFeeFiscalProductGroup.placeId": [
            {
                type: "description",
                value: "Identificador do place."
            }
        ],
        "fn.removeDeliveryFeeFiscalProductGroup.deliveryFeeId": [
            {
                type: "description",
                value: "Identificador da taxa de delivery cujo vínculo deve ser removido."
            }
        ],
        "fn.removeDeliveryFeeFiscalProductGroup": [
            {
                type: "description",
                value: "Remove (soft delete) o vínculo entre uma taxa de delivery e um grupo fiscal para o place. Idempotente — não falha quando o vínculo já não existe. Lança InvalidArgument quando UUIDs são inválidos. Lança NotFound quando o place não existe."
            }
        ],
        "fn.getDeliveryFeeFiscalProductGroupsByPlace.placeId": [
            {
                type: "description",
                value: "Identificador do place cujos vínculos serão listados."
            }
        ],
        "fn.getDeliveryFeeFiscalProductGroupsByPlace": [
            {
                type: "description",
                value: "Retorna o catálogo completo de taxas de delivery com o respectivo vínculo de grupo fiscal para o place. Taxas sem vínculo retornam fiscalProductGroupId como null. Lança InvalidArgument quando placeId não é UUID válido. Lança NotFound quando o place não existe."
            }
        ],
        "fn.addEmployee": [
            {
                type: "description",
                value: "Creates a new employee. If assignableRoleIds is provided, assignableBarIds must also be provided (and vice-versa). Both arrays are normalized (duplicates and empty strings removed) and limited to 100 items each."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            }
        ],
        "fn.addMultipleEmployees": [
            {
                type: "description",
                value: "Deprecated: use addMultipleEmployeesV2 for new flows. The legacy endpoint receives a single template and top-level password, so it cannot represent per-employee PDV passwords."
            }
        ],
        "fn.updateEmployeePassword.token": [
            {
                type: "description",
                value: "\"Reset token received by e-mail\""
            }
        ],
        "fn.updateEmployeePassword.password": [
            {
                type: "description",
                value: "\"New password\""
            }
        ],
        "fn.updateEmployeePassword.confirmPassword": [
            {
                type: "description",
                value: "\"Password confirmation — must match password\""
            }
        ],
        "fn.updateEmployeePassword": [
            {
                type: "description",
                value: "\"Validates the password reset token and updates the employee password.\""
            }
        ],
        "fn.executeLiquidationMotor": [
            {
                type: "description",
                value: "Força a execução do motor de liquidação para um place (e vendor opcional), processando as future financial entries ainda não registradas. Uso operacional/manual."
            }
        ],
        "fn.getClientsAtEvent": [
            {
                type: "description",
                value: "New function to get clients at event with filter"
            }
        ],
        "fn.clientsAtEvent": [
            {
                type: "description",
                value: "Function deprecated use getClientsAtEvent"
            }
        ],
        "fn.debtorsInEventV2.eventId": [
            {
                type: "description",
                value: "ID do evento"
            }
        ],
        "fn.debtorsInEventV2.pagination": [
            {
                type: "description",
                value: "Parâmetros de paginação"
            }
        ],
        "fn.debtorsInEventV2.filters": [
            {
                type: "description",
                value: "Filtros da lista (status, nome, documento)"
            }
        ],
        "fn.debtorsInEventV2": [
            {
                type: "description",
                value: "Lista contas em aberto de um evento com paginação e filtros. Retorna dados, paginação e totalizadores."
            }
        ],
        "fn.debtorsInPlaceV2.placeId": [
            {
                type: "description",
                value: "ID do place"
            }
        ],
        "fn.debtorsInPlaceV2.since": [
            {
                type: "description",
                value: "Data/hora inicial do período"
            }
        ],
        "fn.debtorsInPlaceV2.until": [
            {
                type: "description",
                value: "Data/hora final do período"
            }
        ],
        "fn.debtorsInPlaceV2.pagination": [
            {
                type: "description",
                value: "Parâmetros de paginação"
            }
        ],
        "fn.debtorsInPlaceV2.filters": [
            {
                type: "description",
                value: "Filtros da lista (status, nome, documento)"
            }
        ],
        "fn.debtorsInPlaceV2": [
            {
                type: "description",
                value: "Lista contas em aberto de um place no período com paginação e filtros. Retorna dados, paginação e totalizadores."
            }
        ],
        "fn.getDebtorsXls.input": [
            {
                type: "description",
                value: "Parâmetros da exportação (escopo e filtros)"
            }
        ],
        "fn.getDebtorsXls": [
            {
                type: "description",
                value: "Exporta a lista de contas em aberto em planilha XLS. Retorna URL do arquivo."
            }
        ],
        "fn.getOpenedBillPaymentsV3.eventId": [
            {
                type: "description",
                value: "ID do evento"
            }
        ],
        "fn.getOpenedBillPaymentsV3.pagination": [
            {
                type: "description",
                value: "Parâmetros de paginação"
            }
        ],
        "fn.getOpenedBillPaymentsV3.filters": [
            {
                type: "description",
                value: "Filtros da lista (nome, documento do usuário)"
            }
        ],
        "fn.getOpenedBillPaymentsV3": [
            {
                type: "description",
                value: "Lista pagamentos de contas em aberto de um evento com paginação e filtros. Retorna dados, paginação e totalizadores."
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3.placeId": [
            {
                type: "description",
                value: "ID do place"
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3.since": [
            {
                type: "description",
                value: "Data inicial do período"
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3.until": [
            {
                type: "description",
                value: "Data final do período"
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3.pagination": [
            {
                type: "description",
                value: "Parâmetros de paginação"
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3.filters": [
            {
                type: "description",
                value: "Filtros da lista (nome, documento do usuário)"
            }
        ],
        "fn.getOpenedBillPaymentsAtPlaceV3": [
            {
                type: "description",
                value: "Lista pagamentos de contas em aberto de um place no período com paginação e filtros. Retorna dados, paginação e totalizadores."
            }
        ],
        "fn.getOpenedBillReportOverview.scope": [
            {
                type: "description",
                value: "Escopo do relatório (evento ou place com período)"
            }
        ],
        "fn.getOpenedBillReportOverview": [
            {
                type: "description",
                value: "Retorna totalizador geral do relatório de contas em aberto e pagamentos de contas em aberto."
            }
        ],
        "fn.getOpenedBillPaymentsXls.input": [
            {
                type: "description",
                value: "Parâmetros da exportação (escopo e filtros)"
            }
        ],
        "fn.getOpenedBillPaymentsXls": [
            {
                type: "description",
                value: "Exporta a lista de pagamentos de contas em aberto em planilha XLS. Retorna URL do arquivo."
            }
        ],
        "fn.listFiscalProfilesPending": [
            {
                type: "description",
                value: "Lists every fiscal profile draft awaiting client approval (approvedAt IS NULL AND rejectedAt IS NULL) for the caller's organization. Includes both brand-new admin-Zig creations (parentId null) and pending edits."
            }
        ],
        "fn.listFiscalProfileDraftHistory": [
            {
                type: "description",
                value: "Full draft history (approved, rejected, pending) for a given principal fiscal profile, newest first."
            }
        ],
        "fn.getFiscalProfileWithPendingDraft": [
            {
                type: "description",
                value: "Returns the principal fiscal profile plus its pending admin-Zig draft (if any) for the side panel. See FiscalProfileWithPendingDraft."
            }
        ],
        "fn.approveFiscalProfileDraft": [
            {
                type: "description",
                value: "Approves a pending fiscal profile draft. For new admin-Zig drafts (parentId null) the principal is inserted with validatedAt + validatedByAdminId set; for edits the principal is updated with the snapshot. Idempotent race-guarded — concurrent approve/reject raises a ConflictError."
            }
        ],
        "fn.rejectFiscalProfileDraft": [
            {
                type: "description",
                value: "Rejects a pending fiscal profile draft. Idempotent race-guarded — concurrent approve/reject raises a ConflictError."
            }
        ],
        "fn.createFiscalProductGroup": [
            {
                type: "description",
                value: "Creates a new fiscal product group"
            }
        ],
        "fn.updateFiscalProductGroup": [
            {
                type: "description",
                value: "Updates a fiscal product group"
            }
        ],
        "fn.deleteFiscalProductGroup": [
            {
                type: "description",
                value: "Deletes a fiscal product group"
            }
        ],
        "fn.listFiscalProductGroupsPending": [
            {
                type: "description",
                value: "Lists every fiscal product group draft awaiting client approval. Same semantics as listFiscalProfilesPending."
            }
        ],
        "fn.listFiscalProductGroupDraftHistory": [
            {
                type: "description",
                value: "Full draft history for a given principal fiscal product group, newest first."
            }
        ],
        "fn.getFiscalProductGroupWithPendingDraft": [
            {
                type: "description",
                value: "Returns the principal fiscal product group plus its pending admin-Zig draft (if any) for the side panel. See FiscalProductGroupWithPendingDraft."
            }
        ],
        "fn.approveFiscalProductGroupDraft": [
            {
                type: "description",
                value: "Approves a pending fiscal product group draft. Race-guarded."
            }
        ],
        "fn.rejectFiscalProductGroupDraft": [
            {
                type: "description",
                value: "Rejects a pending fiscal product group draft. Race-guarded."
            }
        ],
        "fn.forgotPassword.organization": [
            {
                type: "description",
                value: "\"Organization username (code)\""
            }
        ],
        "fn.forgotPassword.email": [
            {
                type: "description",
                value: "\"Registered and verified e-mail of the employee\""
            }
        ],
        "fn.forgotPassword": [
            {
                type: "description",
                value: "\"Requests a password reset for a Dash employee. For security reasons, always returns a generic success response regardless of the internal result (e-mail not found, invalid organization, etc.). The reset token expires in 1 hour.\""
            }
        ],
        "fn.registerEmployeeEmail": [
            {
                type: "description",
                value: "Registers employee email and sends a verification email."
            },
            {
                type: "throws",
                value: "WrongLogin"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "rest",
                value: {
                    bodyVariable: "input",
                    headers: [],
                    method: "POST",
                    path: "/employees/email/register",
                    pathVariables: [],
                    queryVariables: []
                }
            }
        ],
        "fn.confirmEmployeeEmail": [
            {
                type: "description",
                value: "Confirms the employee email using the provided token."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "rest",
                value: {
                    bodyVariable: "token",
                    headers: [],
                    method: "POST",
                    path: "/employees/email/confirm",
                    pathVariables: [],
                    queryVariables: []
                }
            }
        ],
        "fn.createPaymentLink": [
            {
                type: "description",
                value: "\"Cria um link de pagamento avulso para o estabelecimento cobrar quem quiser; a Zig atua como gateway. paymentOrigin define a conta que recebe a liquidação.\""
            }
        ],
        "fn.listPaymentLinks": [
            {
                type: "description",
                value: "\"Lista paginada dos links de pagamento avulsos de um estabelecimento, mais recentes primeiro. page começa em 1; pageSize padrão 20, máximo 100.\""
            }
        ],
        "fn.addNewProduct.isActive": [
            {
                type: "description",
                value: "Define o status inicial do produto (true = ativo, false/null = inativo)."
            }
        ],
        "fn.addNewProduct": [
            {
                type: "description",
                value: "Cria um produto."
            }
        ],
        "fn.removeProductionRulesFromSupplies": [
            {
                type: "description",
                value: "Remove production rules from supplies. For each supply, removes it from production rule inputs. If the supply is the only input, the entire rule is deleted. Otherwise, the rule is edited to remove only that supply. This operation is idempotent - calling it multiple times with the same supplies has no additional effect. Returns 403 if user lacks 'manageProductionControl' permission. Returns detailed information about successful and failed operations for better error handling."
            },
            {
                type: "throws",
                value: "LacksPermission"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            }
        ],
        "fn.verifyPatchProducts.type": [
            {
                type: "description",
                value: "Do not use it, the function should be dynamic checking if the product has an ID or not"
            }
        ],
        "fn.patchProducts.skipMountableSections": [
            {
                type: "description",
                value: "When true, preserves the existing mountable sections of the product"
            }
        ],
        "fn.getProductsSoldReportV2": [
            {
                type: "description",
                value: "Returns products sold report rows for a place in the given period."
            }
        ],
        "fn.requestExportProductsSoldReportV2": [
            {
                type: "description",
                value: "Enqueues an async export of the products sold report, delivered via email."
            }
        ],
        "fn.getKdsProductsReport": [
            {
                type: "description",
                value: "Returns KDS production performance data grouped by product and source."
            }
        ],
        "fn.requestExportKdsProductsReport": [
            {
                type: "description",
                value: "Enqueues an async export of the KDS products report, delivered via email."
            }
        ],
        "fn.getDetailedTransactionsReport": [
            {
                type: "description",
                value: "Returns paginated detailed transactions for a place in the given period."
            }
        ],
        "fn.getDetailedTransactionsReportTotals": [
            {
                type: "description",
                value: "Aggregated totals over the same transactions returned by `getDetailedTransactionsReport`. `orderBy` is ignored."
            }
        ],
        "fn.requestExportDetailedTransactionsReport": [
            {
                type: "description",
                value: "Enqueues an async export of the detailed transactions report, delivered via email."
            }
        ],
        "fn.getKdsOrdersReport": [
            {
                type: "description",
                value: "Returns KDS orders performance data, paginated, with final status per order."
            }
        ],
        "fn.requestExportKdsOrdersReport": [
            {
                type: "description",
                value: "Enqueues an async export of the KDS orders report, delivered via email."
            }
        ],
        "fn.getProductsAtStorage": [
            {
                type: "description",
                value: "Returns the products at a storage and its current state"
            }
        ],
        "fn.getUserSingleProductReturn": [
            {
                type: "description",
                value: "Gets a single product return by its ID"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.requestExportMessagesSent": [
            {
                type: "description",
                value: "Enqueues an async export of the messages sent report, delivered via email."
            }
        ],
        "fn.getBackofficeStorageInventories.placeId": [
            {
                type: "description",
                value: "\"ID of the place owning the inventories.\""
            }
        ],
        "fn.getBackofficeStorageInventories.status": [
            {
                type: "description",
                value: "\"Optional inventory status filter.\""
            }
        ],
        "fn.getBackofficeStorageInventories.query": [
            {
                type: "description",
                value: "\"Free-text search applied to the inventory name and, for reviewers, to the creator's name.\""
            }
        ],
        "fn.getBackofficeStorageInventories.orderBy": [
            {
                type: "description",
                value: "\"Field used to order the results.\""
            }
        ],
        "fn.getBackofficeStorageInventories.order": [
            {
                type: "description",
                value: "\"Sort direction.\""
            }
        ],
        "fn.getBackofficeStorageInventories.since": [
            {
                type: "description",
                value: "\"Lower bound (inclusive) of the inventory creation date.\""
            }
        ],
        "fn.getBackofficeStorageInventories.until": [
            {
                type: "description",
                value: "\"Upper bound (inclusive) of the inventory creation date.\""
            }
        ],
        "fn.getBackofficeStorageInventories.categoriesIds": [
            {
                type: "description",
                value: "\"Filters inventories whose categories include ANY of the given category IDs. Empty array is treated as no filter.\""
            }
        ],
        "fn.getBackofficeStorageInventories.productsIds": [
            {
                type: "description",
                value: "\"Filters inventories whose products include ANY of the given product IDs. Empty array is treated as no filter.\""
            }
        ],
        "fn.getBackofficeStorageInventories.storageIds": [
            {
                type: "description",
                value: "\"Filters inventories by storage ID. Mapped to storagesIds in the backoffice payload. Empty array is treated as no filter.\""
            }
        ],
        "fn.getBackofficeStorageInventories.page": [
            {
                type: "description",
                value: "\"1-based page number for pagination.\""
            }
        ],
        "fn.getBackofficeStorageInventories.itemsPerPage": [
            {
                type: "description",
                value: "\"Number of items per page.\""
            }
        ],
        "fn.getBackofficeStorageInventories": [
            {
                type: "description",
                value: "\"Lists backoffice storage inventories for a given place, optionally filtered by status, date range, query, categories, products and storages.\""
            }
        ],
        "fn.updateBackofficeStorageInventoryStatus.reason": [
            {
                type: "description",
                value: "\"Justification for the status change. Required by the backoffice when rejecting (status `reopened`).\""
            }
        ],
        "fn.updateBackofficeStorageInventoryStatus": [
            {
                type: "description",
                value: "\"Updates the status of a storage inventory. `reason` is the rejection justification; it is required by the backoffice when rejecting (transition to `reopened`) and optional otherwise.\""
            }
        ],
        "fn.updateBackofficeStorageInventory": [
            {
                type: "description",
                value: "Updates editable metadata of a storage inventory (currently only `name`). Validation of status, duplicate name and length lives in the backoffice."
            }
        ],
        "fn.exportBackofficeStorageInventoryAndStorageComparisonPdf": [
            {
                type: "description",
                value: "\"Exports the storage inventory comparison as a PDF report. Returns a presigned URL for the generated file.\""
            }
        ],
        "fn.getBackofficeStorageInventoriesTotalizers": [
            {
                type: "description",
                value: "Returns the storage inventory totalizers for a place. Stockists only see their own inventories; reviewers see all and may search stockists by name through `query`."
            }
        ],
        "fn.getHawkerSessions": [
            {
                type: "description",
                value: "\"Returns hawker sessions grouped by hawker for a given event. Each session includes aggregated data such as cycle count, received value, change fund, bar references, and whether the session or any of its cycles were closed by a different cashier than the one who opened it. Supports filtering by hawker name, document, cashier, employee, or specific hawker IDs.\""
            }
        ],
        "fn.getHawkerReport.eventId": [
            {
                type: "description",
                value: "UUID do evento para o qual se deseja obter o relatório"
            }
        ],
        "fn.getHawkerReport.hawkerId": [
            {
                type: "description",
                value: "UUID do vendedor ambulante cujas vendas serão consolidadas"
            }
        ],
        "fn.getHawkerReport": [
            {
                type: "description",
                value: "Retorna um relatório consolidado de vendas de um vendedor ambulante em um evento específico. O relatório agrupa todas as transações por produto e fornece o total geral de vendas do ambulante. Útil para acompanhar desempenho, gerar comissões e análises de vendedores."
            }
        ],
        "fn.getHawkersRanking.eventId": [
            {
                type: "description",
                value: "UUID do evento para o qual se deseja obter o ranking"
            }
        ],
        "fn.getHawkersRanking.hawkerCashierNames": [
            {
                type: "description",
                value: "Lista de nomes (ou partes de nomes) dos caixas ambulantes para filtrar os resultados. Quando informado, retorna apenas ambulantes cujos ciclos foram fechados por esses caixas."
            }
        ],
        "fn.getHawkersRanking.hawkerCashierDocuments": [
            {
                type: "description",
                value: "Lista de documentos (CPF) dos caixas ambulantes para filtrar os resultados. Quando informado, retorna apenas ambulantes cujos ciclos foram fechados por caixas com esses documentos."
            }
        ],
        "fn.getHawkersRanking": [
            {
                type: "description",
                value: "Retorna o ranking de vendedores ambulantes de um evento, ordenado por vendas. Cada item inclui o total vendido, comissão e os usernames dos funcionários que operaram com aquele ambulante. Opcionalmente filtra por nomes e/ou documentos do caixa ambulante para exibir apenas os ambulantes vinculados a eles, permitindo conferência de comissões."
            }
        ],
        "fn.listEmployeeZendeskTickets": [
            {
                type: "description",
                value: "Lists Zendesk tickets requested by the authenticated employee (filtered by external_id = employee.id)."
            }
        ],
        "fn.getEmployeeZendeskTicketDetails": [
            {
                type: "description",
                value: "Returns ticket details and full conversation history for a specific ticket owned by the authenticated employee."
            }
        ],
        "fn.getZendeskMessagingJwt": [
            {
                type: "description",
                value: "Generates a signed JWT for authenticating the current user with Zendesk Messaging."
            }
        ],
        "fn.createPlaceSector.placeSector": [
            {
                type: "description",
                value: "The new place sector information."
            }
        ],
        "fn.createPlaceSector": [
            {
                type: "description",
                value: "Create a new place sector."
            }
        ],
        "fn.getPlaceSectors.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.getPlaceSectors": [
            {
                type: "description",
                value: "Get all place sectors for a specific place."
            }
        ],
        "fn.deletePlaceSector.placeSectorId": [
            {
                type: "description",
                value: "The id of the place sector to be deleted."
            }
        ],
        "fn.deletePlaceSector": [
            {
                type: "description",
                value: "Delete a place sector."
            }
        ],
        "fn.editPlaceSector.placeSectorId": [
            {
                type: "description",
                value: "The id of the place sector to be edited."
            }
        ],
        "fn.editPlaceSector.placeSector": [
            {
                type: "description",
                value: "The new information for the place sector."
            }
        ],
        "fn.editPlaceSector": [
            {
                type: "description",
                value: "Edit a place sector."
            }
        ],
        "fn.createAccessPolicy.accessPolicy": [
            {
                type: "description",
                value: "The new access policy information."
            }
        ],
        "fn.createAccessPolicy": [
            {
                type: "description",
                value: "Create a new access policy."
            }
        ],
        "fn.getAccessPolicies.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.getAccessPolicies.filters": [
            {
                type: "description",
                value: "The filters to apply to the access policies. For now, only the access policy name is supported."
            }
        ],
        "fn.getAccessPolicies": [
            {
                type: "description",
                value: "Get all access policies."
            }
        ],
        "fn.getAccessPolicyTags.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.getAccessPolicyTags.accessPolicyId": [
            {
                type: "description",
                value: "The id of the access policy."
            }
        ],
        "fn.getAccessPolicyTags.pagination": [
            {
                type: "description",
                value: "The pagination information."
            }
        ],
        "fn.getAccessPolicyTags": [
            {
                type: "description",
                value: "Get all access policy tags for a specific access policy."
            }
        ],
        "fn.editAccessPolicy.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.editAccessPolicy.accessPolicyId": [
            {
                type: "description",
                value: "The id of the access policy to be edited."
            }
        ],
        "fn.editAccessPolicy.accessPolicy": [
            {
                type: "description",
                value: "The new information for the access policy."
            }
        ],
        "fn.editAccessPolicy": [
            {
                type: "description",
                value: "Edit an access policy."
            }
        ],
        "fn.deleteAccessPolicy.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.deleteAccessPolicy.accessPolicyId": [
            {
                type: "description",
                value: "The id of the access policy to be deleted."
            }
        ],
        "fn.deleteAccessPolicy": [
            {
                type: "description",
                value: "Delete an access policy."
            }
        ],
        "fn.importAccessPolicyTags.placeId": [
            {
                type: "description",
                value: "The id of the place."
            }
        ],
        "fn.importAccessPolicyTags.accessPolicyId": [
            {
                type: "description",
                value: "The id of the access policy."
            }
        ],
        "fn.importAccessPolicyTags.tagIds": [
            {
                type: "description",
                value: "The ids of the tags to be imported."
            }
        ],
        "fn.importAccessPolicyTags": [
            {
                type: "description",
                value: "Import new access policy tags for an access policy. Deletes all existing tags for the access policy."
            }
        ],
        "fn.ifoodWebhook": [
            {
                type: "rest",
                value: {
                    bodyVariable: "event",
                    headers: [
                        [
                            "x-ifood-signature",
                            "signature"
                        ]
                    ],
                    method: "POST",
                    path: "/ifood/webhook",
                    pathVariables: [],
                    queryVariables: []
                }
            },
            {
                type: "description",
                value: "\"Receives order events from iFood webhook in real-time\""
            }
        ],
        "fn.getIntegrationTokens": [
            {
                type: "description",
                value: "Returns all integration tokens that the user has access to. User can only see tokens when they have access to ALL linked places. Tokens are returned with partially masked values."
            }
        ],
        "fn.getAvailablePlacesForToken": [
            {
                type: "description",
                value: "Lists places available to link to a token. Returns only places that the user has access to."
            }
        ],
        "fn.createIntegrationToken": [
            {
                type: "description",
                value: "Creates a new integration token. Requires MANAGE_INTEGRATION_TOKEN permission (Master user). Can create tokens for specific places (placeIds: string[]) or for all organization places (placeIds: null)."
            }
        ],
        "fn.deleteIntegrationToken": [
            {
                type: "description",
                value: "Removes an existing integration token. Requires MANAGE_INTEGRATION_TOKEN permission (Master user). Performs soft delete and invalidates token for authentication."
            }
        ],
        "fn.listEquipmentsByPlace": [
            {
                type: "description",
                value: "Lists detailed equipment information for a specific place with optional filters and pagination"
            },
            {
                type: "throws",
                value: "LacksPermission"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.getEquipmentsByPlaceToExcel": [
            {
                type: "description",
                value: "Exports detailed equipment information by place to Excel (returns all data without pagination)"
            },
            {
                type: "throws",
                value: "LacksPermission"
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.readyOrder": [
            {
                type: "description",
                value: "Marca um pedido de delivery como pronto para retirada"
            }
        ],
        "fn.createManualOrder": [
            {
                type: "description",
                value: "Cria um pedido manual de entrega (origem manualOrder, pagamento só PIX). Resolve preços e frete no backend e devolve a cobrança PIX."
            }
        ],
        "fn.calculateDeliveryFee": [
            {
                type: "description",
                value: "Calcula (preview) a taxa de entrega de um endereço sem criar pedido. Geocodifica o endereço (CEP), mede a distância até o local e aplica o modelo de taxa configurado."
            }
        ],
        "fn.upsertDeliveryFeeConfig": [
            {
                type: "description",
                value: "Cria/atualiza a configuração de taxa de entrega do local (tabela configs_by_menu_type, lida pelo cálculo de frete). ratePerRadius ainda não é suportado por este endpoint."
            }
        ],
        "fn.getDeliveryFeeConfig": [
            {
                type: "description",
                value: "Busca a configuração de taxa de entrega do local (tabela configs_by_menu_type). Retorna os valores padrão (unique / 0) quando o local ainda não possui configuração persistida."
            }
        ],
        "fn.getURLAuthorization": [
            {
                type: "description",
                value: "\"Get the authorization URL for a merchant to authorize the marketplace integration. The merchant will be redirected to this URL to complete the OAuth authorization flow.\""
            }
        ],
        "fn.exchangeAuthIdForMerchantAuthorized": [
            {
                type: "description",
                value: "\"Exchange an authorization ID for authorized merchant shops. Logs the shop information received from the marketplace and persists marketplace stores.\""
            }
        ],
        "fn.updateMarketplaceStoreStatus": [
            {
                type: "description",
                value: "\"Update the status of a marketplace store integration (enable/disable). Returns success/failure payload.\""
            }
        ],
        "fn.getAllMarketplaceIntegrationsGroupedByType": [
            {
                type: "description",
                value: "\"Get all marketplace integrations for a place, grouped by provider type.\""
            }
        ],
        "fn.deleteMarketplaceIntegration": [
            {
                type: "description",
                value: "\"Delete (soft delete) a marketplace store integration by ID. Returns 204 No Content on success.\""
            }
        ],
        "fn.openDeliveryWebhook": [
            {
                type: "description",
                value: "\"Webhook endpoint for receiving Open Delivery order events from marketplace platforms\""
            },
            {
                type: "rest",
                value: {
                    bodyVariable: "payload",
                    headers: [
                        [
                            "x-app-merchantid",
                            "merchantId"
                        ],
                        [
                            "x-app-signature",
                            "signature"
                        ]
                    ],
                    method: "POST",
                    path: "/open-delivery/orders/webhook",
                    pathVariables: [],
                    queryVariables: []
                }
            }
        ],
        "fn.bindFood99Store": [
            {
                type: "description",
                value: "\"Bind a 99Food store by its shop ID (the int64 visible in the 99Food Admin panel). Calls shopBind on 99Food and creates the marketplace store record. Returns storeNotAuthorized error if the merchant has not yet authorized our app.\""
            }
        ],
        "fn.getPendingsTransactions": [
            {
                type: "description",
                value: "Returns pending transactions filtered by criteria."
            }
        ],
        "fn.getAcquirerPendingTransactionFilterOptions": [
            {
                type: "description",
                value: "Returns available filter options for acquirer pending transactions dashboard. Returns i18n keys for frontend translation."
            }
        ],
        "fn.getPlaceWizardBarsAndSectorsStep": [
            {
                type: "description",
                value: "\"Returns the bars without a sector and the sectors (each with its bars) of a place, for the wizard step.\""
            }
        ],
        "fn.savePlaceWizardProductsAndMenusStep": [
            {
                type: "description",
                value: "\"Creates the products, categories and menus of the products-and-menus wizard step, linking them to the place bars.\""
            }
        ],
        "fn.getFeatureFlags": [
            {
                type: "description",
                value: "Returns all feature flags. If place is provided, the overwritings are returned."
            }
        ],
        "fn.getOFXfile.file": [
            {
                type: "description",
                value: "entrada do arquivo no format base64"
            }
        ],
        "fn.getOFXfile": [
            {
                type: "description",
                value: "Função para fazer a leitura do arquivo ofx"
            }
        ],
        "fn.createBonusCategory.placeId": [
            {
                type: "description",
                value: "\"place unique identifier\""
            }
        ],
        "fn.createBonusCategory.name": [
            {
                type: "description",
                value: "\"name\""
            }
        ],
        "fn.createBonusCategory.daysToExpire": [
            {
                type: "description",
                value: "\"number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "fn.createBonusCategory.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "fn.createBonusCategory.employeeIds": [
            {
                type: "description",
                value: "\"The employees that have access to use this bonus category\""
            }
        ],
        "fn.createBonusCategory.categoryIds": [
            {
                type: "description",
                value: "\"The product's categories that can be bought with this bonus category\""
            }
        ],
        "fn.createBonusCategory.productIds": [
            {
                type: "description",
                value: "\"The products that can be bought with this bonus category\""
            }
        ],
        "fn.createBonusCategory.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "fn.createBonusCategory": [
            {
                type: "description",
                value: "\"Create a new bonus category\""
            }
        ],
        "fn.editBonusCategory.id": [
            {
                type: "description",
                value: "\"The unique identifier\""
            }
        ],
        "fn.editBonusCategory.name": [
            {
                type: "description",
                value: "\"The name\""
            }
        ],
        "fn.editBonusCategory.daysToExpire": [
            {
                type: "description",
                value: "\"The number of days to expire a given bonus in a specific bonus category\""
            }
        ],
        "fn.editBonusCategory.status": [
            {
                type: "description",
                value: "\"The status (true = active, false = inactive)\""
            }
        ],
        "fn.editBonusCategory.employeeIds": [
            {
                type: "description",
                value: "\"The employees that have access to use this bonus category\""
            }
        ],
        "fn.editBonusCategory.categoryIds": [
            {
                type: "description",
                value: "\"The product's categories that can be bought with this bonus category\""
            }
        ],
        "fn.editBonusCategory.productIds": [
            {
                type: "description",
                value: "\"The products that can be bought with this bonus category\""
            }
        ],
        "fn.editBonusCategory.lockZigTag": [
            {
                type: "description",
                value: "\"Forbid or not the use of bonus category another than this one in the ZigTag\""
            }
        ],
        "fn.editBonusCategory": [
            {
                type: "description",
                value: "\"Update a bonus category\""
            }
        ],
        "fn.getBonusCategories.placeId": [
            {
                type: "description",
                value: "\"The place unique identifier\""
            }
        ],
        "fn.getBonusCategories.pagination": [
            {
                type: "description",
                value: "\"The pagination object\""
            }
        ],
        "fn.getBonusCategories.filters": [
            {
                type: "description",
                value: "\"The filters object\""
            }
        ],
        "fn.getBonusCategories": [
            {
                type: "description",
                value: "\"Get bonus categories\""
            }
        ],
        "fn.deleteBonusCategories.bonusCategoryIds": [
            {
                type: "description",
                value: "\"The bonus category unique identifiers\""
            }
        ],
        "fn.deleteBonusCategories": [
            {
                type: "description",
                value: "\"Delete bonus categories\""
            }
        ],
        "fn.getCdpUsers": [
            {
                type: "description",
                value: "Busca usuários do CDP com filtros opcionais e paginação. Permite filtrar por classificação RFM, segmentos, documento, saldo, última interação e permissão de comunicação. Retorna a página atual junto com metadados de paginação (total global após filtros) para que o FE consiga navegar todas as páginas"
            }
        ],
        "fn.getCdpUser": [
            {
                type: "description",
                value: "Busca um usuário específico do CDP pelo ID. Retorna dados completos do usuário incluindo classificações RFM, segmentos, métricas comportamentais e histórico de interações"
            }
        ],
        "fn.getCdpUsersBySegment": [
            {
                type: "description",
                value: "Busca todos os usuários que pertencem a um segmento específico. Útil para campanhas de marketing e comunicações direcionadas a um grupo customizado de clientes"
            }
        ],
        "fn.getCdpUsersByRfmClassification": [
            {
                type: "description",
                value: "Busca todos os usuários que possuem uma classificação RFM específica (ex: champions, at risk, lost). Permite identificar grupos de clientes para estratégias de retenção ou reativação"
            }
        ],
        "fn.getRfmDistribution": [
            {
                type: "description",
                value: "Obtém a distribuição de usuários por classificação RFM. Retorna a quantidade de clientes em cada segmento RFM (champions, loyal, at risk, lost, etc). Útil para visualizar a saúde geral da base de clientes e identificar oportunidades de retenção"
            }
        ],
        "fn.getSegmentDistribution": [
            {
                type: "description",
                value: "Obtém a distribuição de usuários por segmentos customizados. Retorna a quantidade de clientes em cada segmento definido pelo estabelecimento. Útil para entender o tamanho de cada grupo de clientes e planejar campanhas"
            }
        ],
        "fn.getCdpInteractions": [
            {
                type: "description",
                value: "Busca o histórico de interações de um usuário específico. Retorna eventos, compras de ingressos, respostas NPS, comunicações recebidas e alterações de segmento. Permite filtrar por tipo de interação, eventos, período e avaliações. Útil para visualizar o engajamento completo de um cliente"
            }
        ],
        "fn.getCdpProductPurchases": [
            {
                type: "description",
                value: "Busca o histórico detalhado de compras de produtos de um usuário. Retorna cada item comprado com informações de produto, categoria, preços, quantidades e descontos. Permite filtrar por eventos, período, produtos e categorias específicas"
            }
        ],
        "fn.getCdpProductPurchasesByCategory": [
            {
                type: "description",
                value: "Obtém compras agregadas por categoria de produto. Retorna estatísticas por categoria incluindo quantidade total, valor total, usuários únicos e produtos únicos. Útil para análise de performance de categorias e identificação de produtos mais populares"
            }
        ],
        "fn.getCdpFavoriteProducts": [
            {
                type: "description",
                value: "Busca os produtos favoritos dos usuários baseado no histórico de compras. Retorna os produtos mais comprados por cada cliente, incluindo quantidade total, valor gasto e última data de compra. Permite filtrar por usuários, eventos e período. Útil para criar recomendações personalizadas e identificar preferências de consumo"
            }
        ],
        "fn.getCdpChurnRate": [
            {
                type: "description",
                value: "Calcula a taxa de churn (perda de clientes) no período especificado. Indica a porcentagem de clientes que deixaram de interagir com o estabelecimento. Métrica crucial para avaliar retenção de clientes e efetividade de estratégias de fidelização"
            }
        ],
        "fn.getCdpAverageTicket": [
            {
                type: "description",
                value: "Calcula o ticket médio (valor médio de compra) no período especificado. Indica quanto cada cliente gasta em média por transação. Útil para avaliar estratégias de upselling e cross-selling"
            }
        ],
        "fn.getCdpAverageLTV": [
            {
                type: "description",
                value: "Calcula o LTV médio (Lifetime Value - valor vitalício do cliente) considerando todo o histórico. Indica quanto valor cada cliente gera ao longo de seu relacionamento com o estabelecimento. Métrica fundamental para calcular o retorno sobre investimento em aquisição de clientes"
            }
        ],
        "fn.getCdpMetrics": [
            {
                type: "description",
                value: "Retorna todas as métricas agregadas do CDP em uma única chamada. Inclui LTV médio, taxa de churn e ticket médio. Permite visualizar um dashboard completo da saúde da base de clientes. Se o período for fornecido, calcula churn e ticket médio para o período específico"
            }
        ],
        "fn.createCdpPlaceRfmRule": [
            {
                type: "description",
                value: "Cria uma nova regra RFM para um estabelecimento. Apenas uma regra RFM ativa pode existir por estabelecimento. Se já existir uma regra ativa, ela será desativada (soft delete) antes de criar a nova"
            }
        ],
        "fn.getCdpPlaceRfmRule": [
            {
                type: "description",
                value: "Busca a regra RFM ativa de um estabelecimento específico"
            }
        ],
        "fn.getCdpPlaceRfmRules": [
            {
                type: "description",
                value: "Lista todas as regras RFM (ativas e inativas) de uma organização"
            }
        ],
        "fn.updateCdpPlaceRfmRule": [
            {
                type: "description",
                value: "Atualiza a regra RFM de um estabelecimento. Apenas campos fornecidos serão atualizados"
            }
        ],
        "fn.deleteCdpPlaceRfmRule": [
            {
                type: "description",
                value: "Remove (soft delete) a regra RFM de um estabelecimento, faz com que use a default"
            }
        ],
        "fn.createCdpOrganizationCustomSegment": [
            {
                type: "description",
                value: "Cria um novo segmento customizado para uma organização"
            }
        ],
        "fn.getCdpOrganizationCustomSegment": [
            {
                type: "description",
                value: "Busca um segmento customizado específico pelo ID"
            }
        ],
        "fn.getCdpOrganizationCustomSegments": [
            {
                type: "description",
                value: "Lista todos os segmentos customizados (ativos e inativos) de uma organização"
            }
        ],
        "fn.updateCdpOrganizationCustomSegment": [
            {
                type: "description",
                value: "Atualiza um segmento customizado existente. Apenas campos fornecidos serão atualizados"
            }
        ],
        "fn.deleteCdpOrganizationCustomSegment": [
            {
                type: "description",
                value: "Remove (soft delete) um segmento customizado"
            }
        ],
        "fn.getCdpAudienceMetrics": [
            {
                type: "description",
                value: "Obtém métricas de público (audiência) agrupadas por período. Retorna total de visitantes, crescimento e proporção de clientes novos vs recorrentes. Permite agrupar por dia da semana, semana ou mês"
            }
        ],
        "fn.getCdpAverageTicketMetrics": [
            {
                type: "description",
                value: "Obtém métricas de ticket médio agrupadas por período. Mostra o valor médio gasto por cliente e sua variação. Útil para identificar padrões de consumo por dia da semana, semana ou mês"
            }
        ],
        "fn.getCdpTpvMetrics": [
            {
                type: "description",
                value: "Obtém métricas de TPV (Total Payment Value) agrupadas por período. Apresenta o faturamento total e sua evolução. Permite análise de receita por dia da semana, semana ou mês"
            }
        ],
        "fn.getCdpDashboardKpis": [
            {
                type: "description",
                value: "Calcula os KPIs principais do dashboard para o período especificado. Retorna público total, ticket médio e TPV com variações percentuais em relação ao período anterior"
            }
        ],
        "fn.getCdpDashboardKpisTimeSeries": [
            {
                type: "description",
                value: "Obtém série temporal dos KPIs principais do dashboard. Retorna KPIs agregados por mês ou semana dentro do período escolhido, com variações em relação ao período correspondente anterior"
            }
        ],
        "fn.getCdpAudienceMetricsTimeSeries": [
            {
                type: "description",
                value: "Obtém série temporal das métricas de público (audiência). Retorna, para cada bucket do período (semana ou mês), o total de visitantes e a divisão entre clientes novos (com firstInteraction dentro do bucket) e recorrentes (firstInteraction anterior ao bucket). As variações `previousPeriod*` são calculadas via LAG sobre o bucket imediatamente anterior, mesmo padrão de getCdpDashboardKpisTimeSeries. Substitui o `audienceTimeSeries={[]}` hardcoded do FE"
            }
        ],
        "fn.getCdpInactiveClients": [
            {
                type: "description",
                value: "Identifica clientes inativos que não interagem há mais de X dias. Útil para campanhas de reativação e análise de churn"
            }
        ],
        "fn.getCdpChurnRiskClients": [
            {
                type: "description",
                value: "Identifica clientes em risco de churn baseado em classificações RFM. Retorna contagem de clientes nas categorias de risco (risk, canNotLose, closeToHibernation)"
            }
        ],
        "fn.getCdpTopRfmMetrics": [
            {
                type: "description",
                value: "Obtém métricas detalhadas das classificações RFM de maior valor. Foca em champions, loyal e highPotential mostrando ticket médio, TPV e representatividade no faturamento"
            }
        ],
        "fn.getCdpDemographicDistribution": [
            {
                type: "description",
                value: "Obtém distribuição demográfica da base de clientes por gênero e faixa etária. Útil para entender o perfil do público e direcionar campanhas"
            }
        ],
        "fn.getCdpCityDistribution": [
            {
                type: "description",
                value: "Obtém distribuição geográfica de clientes por cidade. Mostra top 10 cidades com mais clientes baseado no DDD do telefone, agrupando demais em \"Outras\""
            }
        ],
        "fn.getCdpRfmDistributionEnhanced": [
            {
                type: "description",
                value: "Obtém distribuição de classificações RFM enriquecida com métricas financeiras. Além da contagem, mostra ticket médio e TPV de cada segmento RFM"
            }
        ],
        "fn.getCdpRfmDistributionTimeSeries": [
            {
                type: "description",
                value: "Obtém série temporal da distribuição RFM enriquecida. Mostra evolução das classificações RFM ao longo dos meses/semanas"
            }
        ],
        "fn.getCdpSegmentDistributionEnhanced": [
            {
                type: "description",
                value: "Obtém distribuição de segmentos customizados enriquecida com métricas financeiras. Mostra performance de cada segmento definido pela organização"
            }
        ],
        "fn.getCdpRfmFrequencyDistribution": [
            {
                type: "description",
                value: "Obtém frequência média de visitas por mês segmentada por classificação RFM. Mostra quantas vezes cada segmento visita o estabelecimento mensalmente"
            }
        ],
        "fn.getCdpActivationRate": [
            {
                type: "description",
                value: "Calcula a taxa de ativação de novos clientes. Mostra percentual de clientes com primeira compra no período que retornaram para segunda visita"
            }
        ],
        "fn.getCdpActivationRateTimeSeries": [
            {
                type: "description",
                value: "Retorna taxa de ativação agrupada por período (semana ou mês) para gráfico de série temporal"
            }
        ],
        "fn.getCdpReactivationMetrics": [
            {
                type: "description",
                value: "Calcula métricas de clientes reativados. Identifica clientes que estavam inativos (>30 dias) e retornaram no período"
            }
        ],
        "fn.getCdpAverageTimeBetweenVisits": [
            {
                type: "description",
                value: "Calcula o tempo médio entre visitas dos clientes, geral e por classificação RFM"
            }
        ],
        "fn.getCdpOccupancyRate": [
            {
                type: "description",
                value: "Calcula a taxa de ocupação do estabelecimento. Só retorna dados se o place tiver capacidade definida. Útil para gestão de fluxo e otimização de operação"
            }
        ],
        "fn.getCdpValueMatrix": [
            {
                type: "description",
                value: "Gera matriz de valor relacionando frequência de visitas com ticket médio. Retorna pontos para scatter plot identificando segmentos de alto valor (alta frequência + alto ticket)"
            }
        ],
        "fn.getCdpValueMatrixDistribution": [
            {
                type: "description",
                value: "Distribuição agregada da base no eixo frequência × ticket. Diferente do getCdpValueMatrix, não devolve pontos individuais — bina toda a base nas faixas configuradas e devolve contagens. customFrequencyEdges/customTicketEdges (opcionais) são arrays de lower bounds: se passados com >= 2 valores, viram a definição dos bins (cada par adjacente é um bin, último bin aberto). Sem override, BE deriva bins log-spaced do min/max real do place e arredonda"
            }
        ],
        "fn.getCdpRemainingBalance": [
            {
                type: "description",
                value: "Obtém métricas de saldo/crédito remanescente dos clientes. Mostra quantidade de clientes com saldo positivo, valor total disponível e ticket médio. Útil para gestão de fluxo de caixa e identificação de créditos não utilizados"
            }
        ],
        "fn.exportAllPlaceOrEventActions": [
            {
                type: "description",
                value: "Generate and send the transaction report to the email."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            }
        ],
        "fn.getTransactionReportLinks": [
            {
                type: "description",
                value: "Get the transaction report links for a place."
            }
        ],
        "fn.sendTransactionReportMail": [
            {
                type: "description",
                value: "Send the transaction report mail to the email."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.reImportIfoodProduct": [
            {
                type: "description",
                value: "Updates the menu product price and re-imports its mountable section complements from iFood. Requires fiscalCode on every complement item."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.linkSyncedProductsToDeliveryMenu": [
            {
                type: "description",
                value: "Links already-synced products to a delivery menu. Skips products already linked or whose type is not linkable."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.getBankslipPreviewData": [
            {
                type: "description",
                value: "Obtém prévia dos dados de um boleto/convênio a partir do código de barras ou linha digitável. `placeId` é opcional e identifica o place onde o saque será feito — `bankslipServiceFee` retornado é o configurado nesse place. Quando omitido, o backend usa o primeiro place do employee (consistente com o padrão do sistema)."
            },
            {
                type: "throws",
                value: "InvalidArgument"
            },
            {
                type: "throws",
                value: "LacksPermission"
            },
            {
                type: "throws",
                value: "NotFound"
            }
        ],
        "fn.getEventOperationsByPlaceId": [
            {
                type: "description",
                value: "Get event operation by place ID"
            }
        ],
        "fn.requestClosingOfEventOperation": [
            {
                type: "description",
                value: "Request closing of event operation"
            }
        ],
        "fn.sendDataToEverest": [
            {
                type: "hidden",
                value: null
            }
        ],
        "fn.sendDatasToEverest": [
            {
                type: "hidden",
                value: null
            }
        ],
        "fn.sendInvoiceToEverest": [
            {
                type: "hidden",
                value: null
            }
        ],
        "fn.sendFinanceToEverest": [
            {
                type: "hidden",
                value: null
            }
        ],
        "fn.testEverest": [
            {
                type: "hidden",
                value: null
            }
        ],
        "error.Conflict": [
            {
                type: "statusCode",
                value: 409
            }
        ]
    },
    errors: [
        "NotFound",
        "ChargeExpired",
        "ChargePaid",
        "GenericError",
        "FocusError",
        [
            "ProductEmissionTest",
            "ProductEmissionTestData"
        ],
        "AdvanceNotFound",
        "AdvanceChargeNotFound",
        "AdvanceDocumentNotFound",
        "InvalidAdvanceOperation",
        "InsufficientAdvancePermission",
        "BackofficeError",
        "NotLoggedIn",
        "LacksPermission",
        "InvalidArgument",
        "WrongLogin",
        "DoesntExist",
        "LacksFeature",
        "LimitExceeded",
        "PeriodOutOfRange",
        "EmailRegistrationRequired",
        "Conflict",
        "Fatal"
    ],
    functionTable: {
        getAddressFromCep: {
            args: {
                cep: "string"
            },
            ret: "AddressFromCep"
        },
        getAdyenPaymentSession: {
            args: {
                request: "AdyenPaymentSessionRequest",
                shopperReference: "string?"
            },
            ret: "AdyenSession"
        },
        getBankCodes: {
            args: {},
            ret: "BankCodeResponse[]"
        },
        createEventOperationExpense: {
            args: {
                expense: "EventOperationExpenseRequest"
            },
            ret: "EventOperationExpenseResponse"
        },
        createEventOperationExpenses: {
            args: {
                expenses: "EventOperationExpenseRequest[]"
            },
            ret: "EventOperationExpenseResponse[]"
        },
        getEventOperationExpense: {
            args: {
                id: "uuid"
            },
            ret: "EventOperationExpenseResponse"
        },
        updateEventOperationExpense: {
            args: {
                id: "uuid",
                expense: "EventOperationExpenseRequest"
            },
            ret: "EventOperationExpenseResponse"
        },
        deleteEventOperationExpense: {
            args: {
                id: "uuid"
            },
            ret: "EventOperationExpenseResponse"
        },
        getEventOperationExpenseCategories: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "EventOperationExpenseFormFieldsResponse[]"
        },
        createEventOperation: {
            args: {
                eventOperation: "EventOperationRequest"
            },
            ret: "EventOperationResponse"
        },
        getEventOperation: {
            args: {
                id: "uuid"
            },
            ret: "EventOperationCompleteResponse"
        },
        getEventOperationWithExpenses: {
            args: {
                id: "uuid"
            },
            ret: "GetEventOperationWithExpenses"
        },
        updateEventOperation: {
            args: {
                id: "uuid",
                eventOperation: "EventOperationRequest"
            },
            ret: "EventOperationResponse"
        },
        deleteEventOperation: {
            args: {
                id: "uuid"
            },
            ret: "void"
        },
        updateEventOperationEventSize: {
            args: {
                updateEventOperationEventSizeRequest: "UpdateEventOperationEventSizeRequest"
            },
            ret: "EventOperationEventSizeType"
        },
        getEventOperationEventSize: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "EventOperationEventSizeType"
        },
        getEventOperationEventSizeList: {
            args: {},
            ret: "EventOperationEventSizeType[]"
        },
        approveEventOperation: {
            args: {
                approveEventOperationRequest: "ApproveEventOperationRequest"
            },
            ret: "EventOperationResponse"
        },
        rejectEventOperation: {
            args: {
                rejectEventOperationRequest: "RejectEventOperationRequest"
            },
            ret: "EventOperationResponse"
        },
        getEventOperationHistory: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "EventOperationHistory[]"
        },
        getEventOperationFinancialDocument: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "EventOperationFinancialDocumentUploaded?"
        },
        uploadEventOperationFinancialDocument: {
            args: {
                eventOperationId: "uuid",
                financialDocument: "Attachment"
            },
            ret: "EventOperationFinancialDocumentUploaded"
        },
        deleteEventOperationFinancialDocument: {
            args: {
                financialDocument: "EventOperationFinancialDocumentUploaded"
            },
            ret: "void"
        },
        getEventOperationOperations: {
            args: {
                searchTerm: "string"
            },
            ret: "EventOperationOperation[]"
        },
        createEventOperationUsedEquipments: {
            args: {
                batch: "EventOperationUsedEquipmentBatch"
            },
            ret: "EventOperationUsedEquipmentListResponse"
        },
        getEventOperationUsedEquipments: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "EventOperationUsedEquipmentListResponse"
        },
        deleteEventOperationUsedEquipments: {
            args: {
                ids: "uuid[]"
            },
            ret: "void"
        },
        calculateOperationCharges: {
            args: {
                eventOperationId: "uuid"
            },
            ret: "OperationChargesPreviewResponse"
        },
        getEmployeeTypes: {
            args: {},
            ret: "GetEmployeeTypes[]"
        },
        getExtract: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "DayResume[]"
        },
        getExtractResume: {
            args: {
                placeId: "string"
            },
            ret: "ExtractResume"
        },
        extract: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "DayResume[]"
        },
        getExtractFlow: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "ExtractFlowRow[]"
        },
        getConsolidatedExtractInSections: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ConsolidatedExtract"
        },
        getWithdraws: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "Withdraw[]"
        },
        getExtractDayResumeInSections: {
            args: {
                placeId: "string",
                date: "date"
            },
            ret: "ExtractDayResumeSection[]"
        },
        getRechargeExpireExtract: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "RechargeExpireDayResume[]"
        },
        getRechargeExpireResume: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "RechargeExpireResume"
        },
        getFinancialExtractBlocks: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime"
            },
            ret: "FinancialExtractBlock[]"
        },
        getActiveFinancialExtractBlocks: {
            args: {
                placeId: "uuid"
            },
            ret: "FinancialExtractBlock[]"
        },
        getAllPermissions: {
            args: {},
            ret: "Permission[]"
        },
        deleteRole: {
            args: {
                slug: "string"
            },
            ret: "void"
        },
        createRole: {
            args: {
                name: "string",
                permissions: "string[]"
            },
            ret: "Role"
        },
        updateRole: {
            args: {
                slug: "string",
                name: "string",
                permissions: "string[]"
            },
            ret: "Role"
        },
        getProductKinds: {
            args: {},
            ret: "ProductKind[]"
        },
        getSuggestedImageFor: {
            args: {
                product: "ProductImageSearch"
            },
            ret: "SuggestedImages[]"
        },
        getProductImageReferences: {
            args: {},
            ret: "ProductImageReference[]"
        },
        applySuggestedImageForProduct: {
            args: {
                imageId: "string",
                productId: "string",
                type: "ApplySuggestedImageForProductType"
            },
            ret: "void"
        },
        getSystemProducts: {
            args: {},
            ret: "SystemProduct[]"
        },
        getMetabaseUrl: {
            args: {
                question: "MetabaseQuestionEnum",
                params: "json?"
            },
            ret: "string"
        },
        getMetabaseResource: {
            args: {
                code: "int",
                type: "MetabaseResourceType"
            },
            ret: "MetabaseIntegrationResource"
        },
        getMetabaseList: {
            args: {
                type: "MetabaseResourceType"
            },
            ret: "MetabaseIntegrationResource[]"
        },
        getUserLastConsent: {
            args: {
                cpf: "string",
                src: "ConsentSource"
            },
            ret: "UserConsentResponse?"
        },
        updateUserConsent: {
            args: {
                cpf: "string",
                hasAcceptedToShareData: "bool",
                src: "ConsentSource",
                employeeId: "string?"
            },
            ret: "UserConsentResponse"
        },
        confirmOptout: {
            args: {
                confirmOptOutParams: "ConfirmOptOutParams"
            },
            ret: "DBOptOut"
        },
        hasUserOptOutForPlace: {
            args: {
                userPlaceInfo: "UserPlaceInfo"
            },
            ret: "bool"
        },
        getActivePromotersInPlace: {
            args: {
                placeId: "string"
            },
            ret: "PlaceActivePromoters[]"
        },
        getPlaceCashierAdjustments: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date"
            },
            ret: "CashierAdjustment[]"
        },
        getCashierAdjustments: {
            args: {
                eventId: "uuid"
            },
            ret: "CashierAdjustment[]"
        },
        getEstimatedFinanceDetailsByBarAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        getEstimatedFinanceDetailsByEmployeeAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        getConsolidatedBarSellingReport: {
            args: {
                eventId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "BarReport[]"
        },
        getConsolidatedBarSellingReportInEvents: {
            args: {
                eventIds: "string[]",
                sources: "TransactionSource[]?"
            },
            ret: "BarReport[]"
        },
        getEstimatedFinanceDetailsByBarAtEvents: {
            args: {
                eventIds: "string[]"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        getEstimatedFinanceDetailsByEmployeeAtEvents: {
            args: {
                eventIds: "string[]"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        rechargeByZigCodes: {
            args: {
                placeId: "string",
                rechargeType: "RechargeTypeEnum",
                recharges: "RechargeByZigCode[]"
            },
            ret: "RechargeResults"
        },
        rechargeByZigDeviceGroup: {
            args: {
                placeId: "string",
                zigDeviceGroupId: "string",
                recharge: "RechargeByZigDevice"
            },
            ret: "void"
        },
        getMenuConfig: {
            args: {
                placeId: "string?",
                slug: "string?"
            },
            ret: "GetMenuConfigResponse?"
        },
        getWalletSummary: {
            args: {
                placeId: "uuid"
            },
            ret: "WalletSummary"
        },
        getFutureFinancialEntriesGroupedByMonth: {
            args: {
                placeId: "uuid"
            },
            ret: "FutureFinancialEntryByMonth[]"
        },
        getFutureFinancialEntriesGrouped: {
            args: {
                placeId: "uuid",
                groupBy: "FutureFinancialEntryGroupBy?",
                search: "string?",
                vendorId: "uuid?",
                since: "date?",
                until: "date?",
                typeIds: "string[]?"
            },
            ret: "FutureFinancialEntryGrouped[]"
        },
        getWithdrawsV2: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date",
                offset: "int?",
                limit: "int?"
            },
            ret: "WithdrawV2Response"
        },
        getConsolidatedExtractV2: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                dateFilterType: "DateFilterType?"
            },
            ret: "ConsolidatedExtractV2"
        },
        getConsolidatedCashFlow: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date"
            },
            ret: "ConsolidatedExtractCashFlow"
        },
        getExtractFlowV2: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date",
                offset: "int",
                limit: "int",
                search: "string?",
                typeIds: "string[]?",
                categoryIds: "string[]?",
                groupIds: "string[]?",
                status: "string[]?",
                dateFilterType: "DateFilterType?"
            },
            ret: "ExtractFlowResponseV2"
        },
        getGroupedExtractFlow: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date",
                groupBy: "GroupByOption",
                offset: "int",
                limit: "int",
                search: "string?",
                typeIds: "string[]?",
                categoryIds: "string[]?",
                groupIds: "string[]?",
                status: "string[]?",
                dateFilterType: "DateFilterType?"
            },
            ret: "GroupedExtractFlowResponse"
        },
        getClientProviderDocumentByDocumentNumber: {
            args: {
                documentNumber: "string"
            },
            ret: "ClientProviderDocument"
        },
        getReceivableUnitsByPlaceIdAndFilters: {
            args: {
                params: "ReceivableUnitByPlaceIdAndFiltersParams"
            },
            ret: "ReceivableUnit[]"
        },
        getReceivableUnitConsolidated: {
            args: {
                providerReference: "string"
            },
            ret: "ReceivableUnitConsolidated"
        },
        getCentralLiquidationOperation: {
            args: {
                id: "string"
            },
            ret: "CentralLiquidationOperation"
        },
        getCentralLiquidationOperationWithRelatedValues: {
            args: {
                id: "string"
            },
            ret: "CentralLiquidationOperationWithRelatedValues"
        },
        getCentralLiquidationOperationReceivableUnit: {
            args: {
                receivableUnitId: "string"
            },
            ret: "CentralLiquidationOperationReceivableUnit"
        },
        getCoalaTempToken: {
            args: {
                placeId: "string"
            },
            ret: "CoalaTempToken"
        },
        getPlaceCurrentStore: {
            args: {
                placeId: "uuid"
            },
            ret: "GetPlaceStoreResponse?"
        },
        upsertManyStoreExternalIntegrations: {
            args: {
                placeId: "uuid",
                request: "UpdateManyStoreIntegrationsRequest",
                cnpj: "string?"
            },
            ret: "void"
        },
        getExternalStore: {
            args: {
                externalStoreId: "string",
                type: "ExternalStoreIntegrationType"
            },
            ret: "GetExternalStoreResponse?"
        },
        changeStoreStatus: {
            args: {
                externalStoreId: "string",
                placeId: "uuid"
            },
            ret: "void"
        },
        getManyExternalStoreIntegrationCategoriesWithProductsWithSections: {
            args: {
                placeId: "uuid"
            },
            ret: "GetManyExternalStoreIntegrationCategoriesResponseDto"
        },
        getAlerts: {
            args: {
                placeId: "string",
                skip: "int",
                limit: "int"
            },
            ret: "DashboardAlert[]"
        },
        markAlertAsRead: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        fetchAudits: {
            args: {
                params: "AuditParams"
            },
            ret: "AuditResponse"
        },
        getBackofficeConfig: {
            args: {
                placeId: "string"
            },
            ret: "GetBackofficeConfig"
        },
        getBackofficeAccount: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeAccount"
        },
        getBackofficeAccounts: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeAccount[]"
        },
        createBackofficeAccount: {
            args: {
                placeId: "string",
                account: "BackofficeNewAccount"
            },
            ret: "BackofficeAccount"
        },
        editBackofficeAccount: {
            args: {
                placeId: "string",
                id: "string",
                account: "BackofficeNewAccount"
            },
            ret: "void"
        },
        deleteBackofficeAccount: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        createBackofficeBillPlanCategory: {
            args: {
                placeId: "string",
                name: "string",
                parentId: "string?"
            },
            ret: "BackofficeBillPlanCategoryBase"
        },
        deleteBackofficeBillPlanCategory: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        getBackofficeBillPlanCategory: {
            args: {
                id: "string"
            },
            ret: "BackofficeBillPlanCategoryBase"
        },
        getBackofficeBillPlans: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeBillPlanCategory[]"
        },
        getBackofficeBillPlansTreeLeafs: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeBillPlanCategoryBase[]"
        },
        getBackofficeBillPlansTreeLeafsByLevel: {
            args: {
                placeId: "string",
                level: "uint"
            },
            ret: "BackofficeBillPlanCategoryBase[]"
        },
        editBackofficeBillPlanCategoryName: {
            args: {
                placeId: "string",
                id: "string",
                name: "string"
            },
            ret: "BackofficeBillPlanCategoryBase"
        },
        editBackofficeBillPlanCategoryParent: {
            args: {
                placeId: "string",
                id: "string",
                newParentId: "string?"
            },
            ret: "BackofficeBillPlanCategory[]"
        },
        createBackofficeSuggestedBillPlan: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeBillPlanCategory[]"
        },
        exportBackofficeBillPlan: {
            args: {
                placeId: "string"
            },
            ret: "string"
        },
        importBackofficeBillPlan: {
            args: {
                placeId: "string",
                file: "bytes"
            },
            ret: "BackofficeBillPlanCategory[]"
        },
        deleteBackofficeBillPlan: {
            args: {
                placeId: "string"
            },
            ret: "void"
        },
        getBackofficeBill: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeBill"
        },
        getBackofficeBills: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeBill[]"
        },
        getBackofficeBillInstallments: {
            args: {
                placeId: "string",
                originId: "string"
            },
            ret: "BackofficeSplittedBillDataWithId[]"
        },
        editBackofficeBill: {
            args: {
                placeId: "string",
                id: "string",
                bill: "BackofficeNewBill"
            },
            ret: "void"
        },
        payBackofficeBill: {
            args: {
                placeId: "string",
                id: "string",
                date: "datetime",
                partial: "uint?"
            },
            ret: "void"
        },
        editBackofficeBillAttachment: {
            args: {
                placeId: "string",
                id: "string",
                attachment: "BackofficeAttachment?"
            },
            ret: "void"
        },
        deleteBackofficeBill: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        exportBackofficeBills: {
            args: {
                placeId: "string",
                exportBillArgs: "BackofficeExportBillArgs"
            },
            ret: "string"
        },
        parseBackofficeBillsToImport: {
            args: {
                placeId: "string",
                file: "bytes"
            },
            ret: "BackofficeNewBill[]"
        },
        importBackofficeBills: {
            args: {
                placeId: "string",
                file: "bytes"
            },
            ret: "void"
        },
        createBackofficeBill: {
            args: {
                placeId: "string",
                bill: "BackofficeNewBill",
                attachment: "BackofficeAttachment?"
            },
            ret: "BackofficeBill"
        },
        createBackofficeBillWithRecurrence: {
            args: {
                bill: "BackofficeNewBillWithRecurrence",
                attachment: "BackofficeAttachment?"
            },
            ret: "BackofficeBill"
        },
        createBackofficeBillWithInstallments: {
            args: {
                bill: "BackofficeNewBillWithInstallments",
                attachment: "BackofficeAttachment?"
            },
            ret: "BackofficeBill"
        },
        convertBackofficeBillInInstallments: {
            args: {
                id: "string",
                bill: "BackofficeNewBillWithInstallments",
                attachment: "BackofficeAttachment?"
            },
            ret: "void"
        },
        editBackofficeBillInstallments: {
            args: {
                placeId: "string",
                installments: "BackofficeSplittedBillDataWithId[]",
                originId: "string"
            },
            ret: "void"
        },
        payBackofficeMultipleBills: {
            args: {
                ids: "string[]",
                date: "datetime"
            },
            ret: "void"
        },
        getBackofficeBillsFilteredByAllDates: {
            args: {
                placeId: "string",
                performDate: "BackofficeBaseDate",
                dueDate: "BackofficeBaseDate",
                payDate: "BackofficeBaseDate",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeBill[]"
        },
        undoBackofficePayMultipleBills: {
            args: {
                ids: "string[]",
                date: "datetime"
            },
            ret: "void"
        },
        getBackofficeBillsToDREAnalytics: {
            args: {
                placeId: "string",
                billIdList: "string[]",
                billPlanCategoryId: "string"
            },
            ret: "BackofficeBillsToDREAnalytics[]"
        },
        editBackofficeBillDREAnalytics: {
            args: {
                editBillDREAnalyticsArg: "BackofficeEditBillDREAnalyticsArg"
            },
            ret: "void"
        },
        exportBackofficeBillsDREAnalytics: {
            args: {
                placeId: "string",
                billIdList: "string[]",
                billPlanCategoryId: "string"
            },
            ret: "string"
        },
        deleteBackofficeBillPartialPaid: {
            args: {
                placeId: "string",
                billId: "string"
            },
            ret: "void"
        },
        getBackofficeBillType: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeBillType"
        },
        getBackofficeBillTypes: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeBillType[]"
        },
        createBackofficeBillType: {
            args: {
                placeId: "string",
                billType: "BackofficeNewBillType"
            },
            ret: "BackofficeBillType"
        },
        editBackofficeBillType: {
            args: {
                placeId: "string",
                id: "string",
                billType: "BackofficeNewBillType"
            },
            ret: "void"
        },
        deleteBackofficeBillType: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        getBackofficeCashFlow: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeCashFlow"
        },
        getBackofficeFullCashFlow: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter",
                accountIds: "string[]"
            },
            ret: "BackofficeFullCashFlow"
        },
        getBackofficeNeoCashFlow: {
            args: {
                neoCashFlowArgs: "BackofficeNeoCashFlowArgs"
            },
            ret: "BackofficeNeoCashFlow[]"
        },
        exportBackofficeNeoCashFlow: {
            args: {
                neoCashFlowArgs: "BackofficeNeoCashFlowArgs"
            },
            ret: "string"
        },
        getBackofficeCategory: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeCategory"
        },
        getBackofficeCategories: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeCategory[]"
        },
        createBackofficeCategory: {
            args: {
                placeId: "string",
                category: "BackofficeNewCategory"
            },
            ret: "BackofficeCategory"
        },
        editBackofficeCategory: {
            args: {
                placeId: "string",
                id: "string",
                category: "BackofficeNewCategory"
            },
            ret: "void"
        },
        deleteBackofficeCategory: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        getBackofficeProductsCmv: {
            args: {
                placeId: "string",
                productIds: "string[]",
                since: "datetime",
                until: "datetime",
                shouldUseLastInvoice: "bool"
            },
            ret: "BackofficeProductCmv[]"
        },
        getBackofficeProductsSimpleCurrentCmv: {
            args: {
                placeId: "string",
                productIds: "string[]",
                shouldUseLastInvoice: "bool"
            },
            ret: "BackofficeProductSimpleCmv[]"
        },
        getBackofficeProductsSimpleCmv: {
            args: {
                placeId: "string",
                productIds: "string[]",
                since: "datetime",
                until: "datetime",
                shouldUseLastInvoice: "bool"
            },
            ret: "BackofficeProductSimpleCmv[]"
        },
        getBackofficeCurrentProductsCmvV2: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "BackofficeProductCmvWithQuantity[]"
        },
        getBackofficeCurrentProductsCmvV2ForStorages: {
            args: {
                placeId: "string",
                storageIds: "string[]"
            },
            ret: "BackofficeProductCmvWithQuantity[]"
        },
        getBackofficeCostCenter: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeCostCenter"
        },
        getBackofficeCostCenters: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeCostCenter[]"
        },
        createBackofficeCostCenter: {
            args: {
                placeId: "string",
                costCenter: "BackofficeNewCostCenter"
            },
            ret: "BackofficeCostCenter"
        },
        editBackofficeCostCenter: {
            args: {
                placeId: "string",
                id: "string",
                costCenter: "BackofficeNewCostCenter"
            },
            ret: "void"
        },
        deleteBackofficeCostCenter: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        createBackofficeDre: {
            args: {
                placeId: "string",
                inputedBy: "string",
                dre: "BackofficeNewDre"
            },
            ret: "BackofficeDre"
        },
        deleteBackofficeDre: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        updateBackofficeDre: {
            args: {
                id: "string",
                dre: "BackofficeNewDre"
            },
            ret: "BackofficeDre"
        },
        createBackofficeDefaultDre: {
            args: {
                placeId: "string",
                billPlanContextId: "string",
                inputedBy: "string",
                dre: "BackofficeNewDre"
            },
            ret: "BackofficeDre"
        },
        getBackofficeDres: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeDre[]"
        },
        getBackofficeDreLines: {
            args: {
                dreId: "string"
            },
            ret: "BackofficeDreLine[]"
        },
        addBackofficeDreLine: {
            args: {
                dreId: "string",
                inputedBy: "string",
                line: "BackofficeNewDreLine"
            },
            ret: "BackofficeDreLine"
        },
        editBackofficeDreLine: {
            args: {
                lineId: "string",
                inputedBy: "string",
                line: "BackofficeNewDreLine"
            },
            ret: "BackofficeDreLine"
        },
        deleteBackofficeDreLine: {
            args: {
                lineId: "string"
            },
            ret: "void"
        },
        getBackofficeDreReport: {
            args: {
                dreId: "string",
                since: "date",
                until: "date"
            },
            ret: "BackofficeDreReport"
        },
        getBackofficeDreFullReport: {
            args: {
                dreId: "string",
                since: "date",
                until: "date",
                accountIds: "string[]?"
            },
            ret: "BackofficeDreFullReport"
        },
        getBackofficeNotCategorizedBillPlans: {
            args: {
                dreId: "string"
            },
            ret: "BackofficeSimplyBillPlan[]"
        },
        exportBackofficeDre: {
            args: {
                exportDreArg: "BackofficeExportDreArg"
            },
            ret: "bytes"
        },
        insertBackofficeFocusCompany: {
            args: {
                placeId: "string",
                cnpj: "string",
                token: "string",
                lastInvoiceVersion: "uint?"
            },
            ret: "BackofficeFocusCompany"
        },
        updateBackofficeFocusCompany: {
            args: {
                placeId: "string",
                id: "string",
                token: "string"
            },
            ret: "BackofficeFocusCompany"
        },
        deleteBackofficeFocusCompany: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        upsertBackofficeFocusCompany: {
            args: {
                placeId: "string",
                cnpj: "string",
                token: "string",
                lastInvoiceVersion: "uint?"
            },
            ret: "BackofficeFocusCompany"
        },
        getBackofficeFocusCompanies: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeFocusCompany[]"
        },
        getBackofficeFocusCompany: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeFocusCompany"
        },
        getBackofficeFocusInvoices: {
            args: {
                placeId: "string",
                focusCompanyId: "string"
            },
            ret: "BackofficeFocusInvoice[]"
        },
        createBackofficeInventory: {
            args: {
                inventory: "BackofficeNewInventory",
                shouldOverlapOldInventory: "bool"
            },
            ret: "BackofficeInventory"
        },
        getBackofficeInventories: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "BackofficeInventory[]"
        },
        getBackofficeOpenedInventories: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeInventory[]"
        },
        addBackofficeStorageToInventory: {
            args: {
                inventoryId: "string",
                storageIds: "string[]"
            },
            ret: "BackofficeInventory"
        },
        getBackofficeInventoryProductsAtStorage: {
            args: {
                inventoryId: "string",
                storageId: "string"
            },
            ret: "BackofficeInventoryProduct[]"
        },
        getBackofficeInventoryProducts: {
            args: {
                inventoryId: "string"
            },
            ret: "BackofficeInventoryProduct[]"
        },
        updateBackofficeInventoryProduct: {
            args: {
                inventoryId: "string",
                authorId: "string",
                products: "BackofficeInventoryProduct[]",
                shouldDivideUnitCostValueBy: "uint?"
            },
            ret: "BackofficeInventoryProduct[]"
        },
        closeBackofficeInventory: {
            args: {
                authorId: "string",
                inventoryId: "string",
                alterUnitValue: "bool"
            },
            ret: "void"
        },
        cancelBackofficeInventory: {
            args: {
                authorId: "string",
                inventoryId: "string"
            },
            ret: "void"
        },
        getFiscalProfileInvoiceOptions: {
            args: {
                fiscalProfileId: "string",
                placeId: "string"
            },
            ret: "SimpleInvoiceInfo[]"
        },
        importFiscalProfileInvoiceFromSefaz: {
            args: {
                placeId: "string",
                storageId: "string",
                fiscalProfileId: "string",
                invoiceKey: "string"
            },
            ret: "BackofficeImportedInvoice"
        },
        getFiscalInvoicesBackups: {
            args: {
                placeId: "string",
                fiscalProfileId: "uuid"
            },
            ret: "FiscalInvoiceBackup[]"
        },
        getBackofficeImportedInvoices: {
            args: {
                placeId: "string",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "BackofficeImportedInvoice[]"
        },
        getBackofficeImportedProductsFromInvoices: {
            args: {
                placeId: "string",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "BackofficeImportedProductsFromInvoices[]"
        },
        importBackofficeInvoice: {
            args: {
                placeId: "string",
                storageId: "string?",
                xml: "bytes",
                restriction: "BackofficeImportedInvoiceRestriction?"
            },
            ret: "BackofficeImportedInvoice"
        },
        manualImportBackofficeInvoice: {
            args: {
                placeId: "string",
                storageId: "string",
                invoice: "NewManualBackofficeInvoiceV2"
            },
            ret: "BackofficeImportedInvoice"
        },
        importBackofficeMultipleInvoices: {
            args: {
                placeId: "string",
                storageId: "string?",
                xml: "BackofficeXmlInput[]",
                restriction: "BackofficeImportedInvoiceRestriction?"
            },
            ret: "BackofficeMultipleImportedInvoice"
        },
        createBackofficeManualInvoice: {
            args: {
                placeId: "string",
                manualInvoice: "BackofficeNewManualInvoice"
            },
            ret: "BackofficeImportedInvoice"
        },
        editBackofficeManualInvoiceDetails: {
            args: {
                placeId: "string",
                invoiceId: "string",
                invoiceInfo: "BackofficeNewManualInvoice"
            },
            ret: "void"
        },
        updateBackofficeImportedInvoice: {
            args: {
                placeId: "string",
                invoiceId: "string",
                invoiceDetails: "BackofficeImportedInvoiceUpdate"
            },
            ret: "BackofficeImportedInvoice"
        },
        invalidateBackofficeInvoiceProduct: {
            args: {
                placeId: "string",
                invoiceId: "string",
                entryId: "string"
            },
            ret: "void"
        },
        getBackofficeProductLastInvoiceDetails: {
            args: {
                placeId: "string",
                associatedProductId: "string"
            },
            ret: "BackofficeProductLastInvoiceDetails?"
        },
        getBackofficeInvoiceProducts: {
            args: {
                placeId: "string",
                invoiceId: "string"
            },
            ret: "BackofficeImportedInvoiceProduct[]"
        },
        editBackofficeInvoiceBill: {
            args: {
                placeId: "string",
                editInvoiceBillArg: "BackofficeEditInvoiceBillArg"
            },
            ret: "void"
        },
        editBackofficeInvoiceProduct: {
            args: {
                placeId: "string",
                invoiceId: "string",
                entryId: "string",
                skipped: "bool",
                productId: "string?",
                unitValue: "uint?",
                unitMultiplier: "uint"
            },
            ret: "void"
        },
        editBackofficeInvoiceProductV2: {
            args: {
                placeId: "string",
                invoiceId: "string",
                entryId: "string",
                skipped: "bool",
                productId: "string?",
                unitMultiplier: "string",
                chartAccountId: "uuid?",
                unitValue: "uint?",
                commercialQuantity: "float?"
            },
            ret: "void"
        },
        editBackofficeInvoiceSupplier: {
            args: {
                placeId: "string",
                invoiceId: "string",
                skipped: "bool",
                supplierId: "string?"
            },
            ret: "void"
        },
        upsertBackofficeManualInvoiceProduct: {
            args: {
                placeId: "string",
                invoiceId: "string",
                products: "BackofficeUpsertManualProduct[]"
            },
            ret: "void"
        },
        deleteBackofficeImportedInvoice: {
            args: {
                placeId: "string",
                invoiceId: "string"
            },
            ret: "void"
        },
        undoBackofficeFinishInvoiceImport: {
            args: {
                placeId: "string",
                invoiceId: "string"
            },
            ret: "void"
        },
        isBackofficeInvoiceAlreadyImported: {
            args: {
                placeId: "string",
                storageId: "string",
                num: "uint",
                serie: "uint",
                supplierCpfOrCnpj: "string"
            },
            ret: "bool"
        },
        finishBackofficeInvoiceImport: {
            args: {
                invoiceId: "string",
                skipPendings: "bool",
                placeId: "string"
            },
            ret: "void"
        },
        upsertBackofficeInvoiceDuplicates: {
            args: {
                placeId: "string",
                upsertInvoiceDuplicateArg: "BackofficeUpsertInvoiceDuplicateArg"
            },
            ret: "BackofficeInvoiceDuplicate[]"
        },
        getBackofficeInvoiceDetailsBillPlanCategories: {
            args: {
                placeId: "string",
                invoiceId: "string",
                invoiceDetailsField: "BackofficeImportedInvoiceDetailsField"
            },
            ret: "BackofficeImportedInvoiceDetailsBillPlanCategory[]"
        },
        saveBackofficeDetailsBillPlanCategories: {
            args: {
                invoiceId: "string",
                objBillPlanCategories: "BackofficeImportedInvoiceDetailsObjBillPlanCategory[]",
                invoiceDetailsField: "BackofficeImportedInvoiceDetailsField"
            },
            ret: "void"
        },
        getBackofficeImportedInvoiceById: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "BackofficeImportedInvoice"
        },
        getBackofficeInvoiceXLSX: {
            args: {
                invoiceXLSXArgs: "BackofficeInvoiceXLSXArgs"
            },
            ret: "string"
        },
        getBackofficeInvoiceDuplicateByBillId: {
            args: {
                placeId: "string",
                billId: "string"
            },
            ret: "BackofficeBillInvoiceDuplicate[]"
        },
        getBackofficeReceivedInvoices: {
            args: {
                getReceivedInvoicesArgs: "BackofficeGetReceivedInvoicesArgs"
            },
            ret: "BackofficeReceivedInvoiceHeader[]"
        },
        getBackofficeReceivedInvoice: {
            args: {
                focusCompanyId: "string",
                accessKey: "string"
            },
            ret: "BackofficeReceivedInvoiceHeader"
        },
        getBackofficeInvoiceXmlUrl: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "string"
        },
        postBackofficeManifest: {
            args: {
                placeId: "string",
                id: "string",
                manifestType: "BackofficeManifestType",
                reason: "string?"
            },
            ret: "BackofficeResponseInvoiceManifest"
        },
        getBackofficeIncomeStatement: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeIncomeStatement"
        },
        getBackofficeIncomeByCategory: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeIncomeByCategory[]"
        },
        getBackofficeBillHistory: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeBillHistory"
        },
        getBackofficeExtract: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeExtract"
        },
        getBackofficeDescriptionReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeDescriptionReport"
        },
        getBackofficeDayReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeDayReport"
        },
        getBackofficeBillTypeReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeDescriptionReport"
        },
        getBackofficeBillCategoryReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeDescriptionReport"
        },
        getBackofficeCostCenterReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeCostCenterReport"
        },
        getBackofficeCategoryHistoryReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeCategoryHistory"
        },
        getBackofficeBillSupplierTrackerReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                statusFilter: "BackofficeBillStatusFilter",
                dateFilter: "BackofficeBillDateFilter"
            },
            ret: "BackofficeBillSupplierTrackerReport"
        },
        getBackofficeResume: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeResume"
        },
        getBackofficeResumeInPeriod: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "BackofficePeriodResume"
        },
        getBackofficeBillPlanCategoriesReport: {
            args: {
                billPlanCategoryIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "BackofficeBillPlanCategoriesReport[]"
        },
        getBackofficeStoragePositionReport: {
            args: {
                storageId: "string",
                placeId: "string",
                date: "datetime"
            },
            ret: "StoragePositionReport"
        },
        getBackofficeStorage: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeStorage"
        },
        getBackofficeStorages: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeStorage[]"
        },
        getBackofficeStorageWithResume: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeStorageWithResume"
        },
        getBackofficeStoragesWithResume: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeStoragesWithResume"
        },
        getBackofficeStorageInsights: {
            args: {
                storageId: "string",
                placeId: "string"
            },
            ret: "BackofficeSingleStorageInsights"
        },
        getBackofficeStoragesInsights: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeStorageInsights"
        },
        createBackofficeStorage: {
            args: {
                placeId: "string?",
                organizationId: "string?",
                storage: "BackofficeNewStorage"
            },
            ret: "BackofficeStorage"
        },
        editBackofficeStorage: {
            args: {
                placeId: "string?",
                organizationId: "string?",
                id: "string",
                storage: "BackofficeNewStorage"
            },
            ret: "void"
        },
        deleteBackofficeStorage: {
            args: {
                placeId: "string?",
                id: "string"
            },
            ret: "void"
        },
        getBackofficeProductsAtStorage: {
            args: {
                placeId: "string",
                storageId: "string"
            },
            ret: "BackofficeStorageProductUnitCost[]"
        },
        getBackofficeProductsStorageAtContext: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeStorageProduct[]"
        },
        getBackofficeProductsStorageAtContextByProducts: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "BackofficeStorageProduct[]"
        },
        getBackofficeProductsTransfersResumeAtStorage: {
            args: {
                placeId: "string",
                storageId: "string",
                productIds: "string[]",
                since: "datetime",
                until: "datetime",
                page: "uint?",
                itemsPerPage: "uint?"
            },
            ret: "BackofficePaginationStorageProductTransfersResume"
        },
        getBackofficeProductStorageHistoryV3: {
            args: {
                placeId: "string",
                storageId: "string",
                productId: "string",
                filterBy: "BackofficeProductStorageHistoryFilterBy?",
                since: "datetime",
                until: "datetime",
                page: "uint?",
                itemsPerPage: "uint?"
            },
            ret: "BackofficeStorageHistoryV4"
        },
        getBackofficeProductsStorageHistoryV3: {
            args: {
                placeId: "string",
                storageId: "string",
                productIds: "string[]",
                filterBy: "BackofficeProductStorageHistoryFilterBy?",
                since: "datetime",
                until: "datetime",
                page: "uint?",
                itemsPerPage: "uint?"
            },
            ret: "BackofficeStorageProductsHistoryV3[]"
        },
        getBackofficeProductsStoragesHistoryV3: {
            args: {
                placeId: "string",
                storageIds: "string[]",
                productIds: "string[]",
                filterBy: "BackofficeProductStorageHistoryFilterBy?",
                since: "datetime",
                until: "datetime",
                page: "uint?",
                itemsPerPage: "uint?"
            },
            ret: "BackofficeStorageProductsHistoryV3[]"
        },
        sellBackofficeProductAtStorage: {
            args: {
                placeId: "string",
                employeeId: "string?",
                storageId: "string",
                productId: "string",
                count: "uint",
                date: "datetime",
                shouldApplyProductionRule: "bool"
            },
            ret: "void"
        },
        refundBackofficeSellProductAtStorage: {
            args: {
                placeId: "string",
                storageId: "string",
                productId: "string",
                count: "uint",
                date: "datetime"
            },
            ret: "void"
        },
        cancelBackofficeSellProductAtStorage: {
            args: {
                placeId: "string",
                storageId: "string",
                productId: "string",
                count: "uint",
                date: "datetime"
            },
            ret: "void"
        },
        lostBackofficeProductAtStorage: {
            args: {
                placeId: "string",
                storageId: "string",
                productId: "string",
                count: "float",
                basicStorageUnit: "BasicStorageUnit",
                date: "datetime"
            },
            ret: "void"
        },
        manualBackofficeAdjustProductAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string",
                productId: "string",
                count: "float",
                date: "datetime",
                obs: "string?"
            },
            ret: "void"
        },
        manualBackofficeAdjustProductAtStorageV2: {
            args: {
                placeId: "string?",
                storageId: "string",
                productId: "string",
                count: "float",
                basicStorageUnit: "BasicStorageUnit",
                date: "datetime",
                obs: "string?"
            },
            ret: "void"
        },
        transferBackofficeProduct: {
            args: {
                placeId: "string?",
                productId: "string",
                fromId: "string",
                toId: "string",
                count: "uint",
                date: "datetime"
            },
            ret: "void"
        },
        transferBackofficeProducts: {
            args: {
                placeId: "string?",
                fromId: "string",
                toId: "string",
                date: "datetime",
                products: "BackofficeMultipleStorageTransferProduct[]"
            },
            ret: "BackofficeMultipleStorageTransferProductResult"
        },
        transferBackofficeProductsV2: {
            args: {
                placeId: "string?",
                fromId: "string",
                toId: "string",
                date: "datetime",
                products: "BackofficeMultipleStorageTransferProductV2[]",
                activateProducts: "bool"
            },
            ret: "BackofficeMultipleStorageTransferProductResultV2"
        },
        deleteBackofficeProductAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string",
                productId: "string"
            },
            ret: "void"
        },
        deleteBackofficeProductsAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string",
                productIds: "string[]"
            },
            ret: "BackofficeDeleteProductsResult"
        },
        zeroBackofficeAllProductsAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string"
            },
            ret: "void"
        },
        zeroBackofficeProductsAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string",
                productIds: "string[]"
            },
            ret: "void"
        },
        inputBackofficeProductV2: {
            args: {
                placeId: "string?",
                input: "BackofficeInputV2",
                transferType: "BackofficeStorageTransferType?",
                referenceCode: "string?"
            },
            ret: "void"
        },
        inputBackofficeProductsV2: {
            args: {
                placeId: "string?",
                inputs: "BackofficeInputV2[]",
                transferType: "BackofficeStorageTransferType?",
                referenceCode: "string?"
            },
            ret: "BackofficeInputsResultV2"
        },
        inputBackofficeProductV3: {
            args: {
                placeId: "string",
                input: "BackofficeInputV3",
                transferType: "BackofficeStorageTransferType?",
                referenceCode: "string?"
            },
            ret: "void"
        },
        inputBackofficeProductsV3: {
            args: {
                placeId: "string",
                inputs: "BackofficeInputV3[]",
                transferType: "BackofficeStorageTransferType?",
                referenceCode: "string?"
            },
            ret: "void"
        },
        createBackofficeProductionRule: {
            args: {
                placeId: "string",
                rule: "BackofficeNewProductionRule"
            },
            ret: "string"
        },
        editBackofficeProductionRuleInputs: {
            args: {
                placeId: "string",
                productionRuleId: "string",
                inputs: "BackofficeProductionRuleInput[]"
            },
            ret: "void"
        },
        deleteBackofficeProductionRule: {
            args: {
                placeId: "string",
                ruleId: "string"
            },
            ret: "void"
        },
        applyBackofficeProductionRule: {
            args: {
                placeId: "string",
                storageId: "string",
                ruleId: "string",
                inputs: "BackofficeProductionRuleInput[]",
                outputs: "BackofficeProductionOutput[]"
            },
            ret: "void"
        },
        getBackofficeProductionRules: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeProductionRule[]"
        },
        getBackofficeProductsStatusAtStorageAndDate: {
            args: {
                productIds: "string[]",
                storageIds: "string[]",
                date: "datetime"
            },
            ret: "BackofficeProductStatusAtStorage[]"
        },
        createBackofficeMinimumStorageRules: {
            args: {
                placeId: "string",
                createdBy: "string",
                rules: "BackofficeNewProductRule[]"
            },
            ret: "ResultCreateProductRule"
        },
        editBackofficeMinimumStorageRule: {
            args: {
                placeId: "string",
                rules: "BackofficeEditProductRule[]"
            },
            ret: "BackofficeResultEditProductRule"
        },
        deleteBackofficeMinimumStorageRule: {
            args: {
                placeId: "string",
                ids: "string[]"
            },
            ret: "void"
        },
        getBackofficeMinimumStorageRules: {
            args: {
                placeIds: "string[]"
            },
            ret: "BackofficeProductRule[]"
        },
        getBackofficeMinimumStorageRulesByProducts: {
            args: {
                placeIds: "string[]",
                productIds: "string[]"
            },
            ret: "BackofficeProductRule[]"
        },
        getBackofficeProductsMinimumStorageAlert: {
            args: {
                placeIds: "string[]",
                productIds: "string[]"
            },
            ret: "BackofficeProductAlert[]"
        },
        getBackofficeProductMinimumStorageAlert: {
            args: {
                placeIds: "string[]",
                productId: "string"
            },
            ret: "BackofficeProductAlert"
        },
        getBackofficeMinimumStorageAlert: {
            args: {
                placeIds: "string[]"
            },
            ret: "BackofficeProductAlert[]"
        },
        getBackofficeCurrentReportStorages: {
            args: {
                placeId: "string",
                storageIds: "string[]"
            },
            ret: "BackofficeCurrentReportStorage"
        },
        getBackofficeSupplier: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeSupplier"
        },
        getBackofficeSuppliers: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeSupplier[]"
        },
        getBackofficeSuppliersWithFilters: {
            args: {
                placeId: "string",
                params: "BackofficeGetSuppliersParams?"
            },
            ret: "BackofficeGetSuppliersResponse"
        },
        getBackofficeSuppliersXLSX: {
            args: {
                placeId: "string"
            },
            ret: "string"
        },
        createBackofficeSupplier: {
            args: {
                placeId: "string",
                supplier: "BackofficeNewSupplier"
            },
            ret: "BackofficeSupplier"
        },
        editBackofficeSupplier: {
            args: {
                placeId: "string",
                id: "string",
                supplier: "BackofficeNewSupplier"
            },
            ret: "void"
        },
        deleteBackofficeSupplier: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        createBackofficeUniqSupplier: {
            args: {
                placeId: "string",
                supplier: "BackofficeNewSupplier"
            },
            ret: "BackofficeSupplier"
        },
        editBackofficeUniqSupplier: {
            args: {
                id: "string",
                supplier: "BackofficeNewSupplier"
            },
            ret: "void"
        },
        getBackofficeTransfers: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "BackofficeTransfer[]"
        },
        doBackofficeTransfer: {
            args: {
                placeId: "string",
                transfer: "BackofficeNewTransfer"
            },
            ret: "BackofficeTransfer"
        },
        editBackofficeTransfer: {
            args: {
                placeId: "string",
                id: "string",
                transfer: "BackofficeNewTransfer"
            },
            ret: "BackofficeTransfer"
        },
        deleteBackofficeTransfer: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "void"
        },
        importBackofficeProducts: {
            args: {
                placeId: "string",
                storageId: "string",
                products: "BackofficeProductImporting[]"
            },
            ret: "BackofficeProductImportingResult"
        },
        generateDefaultBackofficeInputTemplate: {
            args: {
                placeId: "string",
                storageId: "string"
            },
            ret: "string"
        },
        getBackofficeSupplierAbcCurve: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                supplierName: "string?",
                pagination: "Pagination"
            },
            ret: "SupplierAbcCurve?"
        },
        exportBackofficeSupplierAbcCurveReport: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                supplierName: "string?"
            },
            ret: "string"
        },
        getBackofficeProductAbcCurve: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                productName: "string?"
            },
            ret: "ProductAbcCurve?"
        },
        exportBackofficeProductAbcCurveReport: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                productName: "string?"
            },
            ret: "string"
        },
        getBackofficeCashFlowV2: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                groupBy: "GetBackofficeCashFlowV2GroupBy"
            },
            ret: "BackofficeAccountBillsReportResponse?"
        },
        updateBackofficeStorageProductsUnitCostValueAtStorages: {
            args: {
                placeId: "uuid",
                products: "BackofficeUpdateStorageUnitCostProduct[]"
            },
            ret: "void"
        },
        createBankAccount: {
            args: {
                placeId: "string",
                newBankAccount: "BankAccountRequest",
                shouldSaveBankAccount: "bool"
            },
            ret: "PlaceBankAccountResponse"
        },
        getBankAccount: {
            args: {
                bankAccountId: "string"
            },
            ret: "PlaceBankAccountResponse"
        },
        getBankAccounts: {
            args: {
                placeId: "string",
                pagination: "Pagination",
                bankName: "string?"
            },
            ret: "PlaceBankAccountPaginationResponse"
        },
        deleteBankAccount: {
            args: {
                bankAccountId: "string"
            },
            ret: "void"
        },
        updateBankAccount: {
            args: {
                bankAccountId: "string",
                bankAccount: "BankAccountRequest"
            },
            ret: "PlaceBankAccountResponse"
        },
        editBar: {
            args: {
                bar: "BarRequest"
            },
            ret: "void"
        },
        editBarV2: {
            args: {
                id: "string",
                bar: "EditableBarFields",
                newFichaLogo: "bytes?",
                menuIds: "string[]"
            },
            ret: "void"
        },
        deleteBar: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        addBar: {
            args: {
                placeId: "string",
                barName: "string",
                storageId: "string",
                internalIp: "string?",
                internalIps: "string[]?",
                fichaLogo: "bytes?",
                menuIds: "string[]"
            },
            ret: "string"
        },
        addBarV2: {
            args: {
                placeId: "string",
                bar: "EditableBarFields",
                fichaLogo: "bytes?",
                menuIds: "string[]"
            },
            ret: "string"
        },
        getBars: {
            args: {
                placeId: "string",
                includeDeleted: "bool?"
            },
            ret: "BarWithMenus[]"
        },
        activateProductAtBar: {
            args: {
                placeId: "string",
                barId: "string",
                productIds: "string[]"
            },
            ret: "void"
        },
        deactivateProductAtBar: {
            args: {
                placeId: "string",
                barId: "string",
                productIds: "string[]"
            },
            ret: "void"
        },
        activateAllProductsAtBar: {
            args: {
                placeId: "string",
                barId: "string"
            },
            ret: "void"
        },
        deactivateAllProductsAtBar: {
            args: {
                placeId: "string",
                barId: "string"
            },
            ret: "void"
        },
        getBarsDevices: {
            args: {
                eventId: "string"
            },
            ret: "BarsDevices[]"
        },
        deliveredProductsByBarsAtEvent: {
            args: {
                eventId: "string",
                barIds: "string[]?",
                sources: "TransactionSource[]?",
                productMasterKinds: "ProductMasterKind[]?",
                sectorIds: "string[]?"
            },
            ret: "ProductSold[]"
        },
        productsSoldAtPlace: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "ProductSold[]"
        },
        productsSoldAtOrg: {
            args: {
                since: "datetime",
                until: "datetime",
                orgId: "string",
                placeIds: "string[]?"
            },
            ret: "ProductSold[]"
        },
        placesProductsWereSoldAtOrg: {
            args: {
                orgId: "string",
                placeIds: "string[]?",
                since: "datetime",
                until: "datetime",
                productId: "string",
                isMountable: "bool"
            },
            ret: "PlacesProductsWereSoldBody[]"
        },
        deliveredProductsByBarsAtPlace: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                barIds: "string[]?",
                sources: "TransactionSource[]?",
                productMasterKinds: "ProductMasterKind[]?",
                sectorIds: "string[]?"
            },
            ret: "ProductSold[]"
        },
        compareProductsSoldByBars: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                barIds: "string[]?",
                sources: "TransactionSource[]?",
                productMasterKinds: "ProductMasterKind[]?",
                sectorIds: "string[]?"
            },
            ret: "ProductBarReport[]"
        },
        getSellerReports: {
            args: {
                eventId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "SellerReport[]"
        },
        getSellerReportForPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                sources: "TransactionSource[]?"
            },
            ret: "SellerReport[]"
        },
        productsSoldReport: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                filters: "ProductSoldFilters",
                pagination: "Pagination",
                orderBy: "ProductsSoldOrderBy?"
            },
            ret: "ProductsSoldReport"
        },
        productsSoldOverview: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                filters: "ProductSoldFilters"
            },
            ret: "ProductsSoldOverviewResponse"
        },
        productsSoldForEventOverview: {
            args: {
                eventId: "string",
                filters: "ProductSoldFilters"
            },
            ret: "ProductsSoldOverviewResponse"
        },
        productsSoldReportForEvent: {
            args: {
                eventId: "string",
                filters: "ProductSoldFilters",
                pagination: "Pagination",
                orderBy: "ProductsSoldOrderBy?"
            },
            ret: "ProductsSoldReportForEvent"
        },
        productsSoldByBarReport: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                filters: "ProductByBarFilters",
                orderBy: "ProductsSoldOrderBy?"
            },
            ret: "ProductsByBarsAtPlace[]"
        },
        productsSoldXlsx: {
            args: {
                scope: "GetReportByScope",
                filters: "ProductByBarFilters"
            },
            ret: "string"
        },
        productsSoldByBarXlsx: {
            args: {
                scope: "GetReportByScope",
                filters: "ProductByBarFilters"
            },
            ret: "string"
        },
        productsSoldByBarReportByEvent: {
            args: {
                eventId: "string",
                filters: "ProductByBarFilters",
                orderBy: "ProductsSoldOrderBy?"
            },
            ret: "ProductsByBarsAtPlace[]"
        },
        productsSoldReportByBarOverview: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                filters: "ProductSoldFilters"
            },
            ret: "ProductsSoldOverviewResponse"
        },
        productsSoldByBarReportByEventOverview: {
            args: {
                eventId: "string",
                filters: "ProductByBarFilters"
            },
            ret: "ProductsSoldOverviewResponse"
        },
        getSellerDetails: {
            args: {
                eventId: "string",
                sellerId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "SellerTransaction[]"
        },
        getSellerDetailsPlace: {
            args: {
                placeId: "string",
                sellerId: "string",
                since: "datetime",
                until: "datetime",
                sources: "TransactionSource[]?"
            },
            ret: "SellerTransaction[]"
        },
        getSellerProductDetails: {
            args: {
                eventId: "string",
                sellerId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "ProductSold[]"
        },
        getSellerProductDetailsPlace: {
            args: {
                placeId: "string",
                sellerId: "string",
                since: "datetime",
                until: "datetime",
                sources: "TransactionSource[]?"
            },
            ret: "ProductSold[]"
        },
        exportAllTransactionProductsXlsx: {
            args: {
                eventId: "string",
                sectorIds: "string[]?"
            },
            ret: "string"
        },
        getSoldBaseProductsAtEvent: {
            args: {
                eventId: "string",
                sources: "TransactionSource[]?"
            },
            ret: "BaseProduct[]"
        },
        getSoldBaseProductsAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                sources: "TransactionSource[]?"
            },
            ret: "BaseProduct[]"
        },
        getSimplifiedSellers: {
            args: {
                eventId: "string"
            },
            ret: "SimplifiedSeller[]"
        },
        refundFichaSell: {
            args: {
                transactionId: "string",
                reason: "string",
                shouldReturnToStorage: "bool"
            },
            ret: "void"
        },
        getBurnedPaperTicketsForEvent: {
            args: {
                eventId: "string",
                barIds: "string[]?"
            },
            ret: "BurnedPaperTicket[]"
        },
        getBurnedPaperTicketsForPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                barIds: "string[]?"
            },
            ret: "BurnedPaperTicket[]"
        },
        getProductsBurnedPaperTicketsForPlace: {
            args: {
                placeId: "string",
                barIds: "string[]?",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "ProductBurnedTicketSold[]"
        },
        getProductsBurnedPaperTicketsForEvent: {
            args: {
                eventId: "string",
                barIds: "string[]?",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "ProductBurnedTicketSold[]"
        },
        getEstimatedFinanceDetailsByBarAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        getEstimatedFinanceDetailsByEmployeeAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "BarOrEmployeeFinance[]"
        },
        getConsolidatedBarSellingReportAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                sources: "TransactionSource[]?"
            },
            ret: "BarReport[]"
        },
        bleedCashier: {
            args: {
                eventId: "string",
                cashierId: "string",
                value: "int",
                obs: "string?"
            },
            ret: "void"
        },
        getPossibleCloseMethods: {
            args: {},
            ret: "CloseMethod[]"
        },
        cashierDetailsAtEvent: {
            args: {
                eventId: "string",
                barIds: "string[]?",
                sectorIds: "string[]?"
            },
            ret: "Cashier[]"
        },
        cashierDetailsAtPlace: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string",
                barIds: "string[]?",
                sectorIds: "string[]?"
            },
            ret: "Cashier[]"
        },
        getCashierRechargeDetails: {
            args: {
                eventId: "string",
                cashierId: "string"
            },
            ret: "RechargeDetails[]"
        },
        getCashierPostDetails: {
            args: {
                eventId: "string",
                cashierId: "string"
            },
            ret: "PostDetails[]"
        },
        updateCashierClosingValues: {
            args: {
                eventId: "string",
                cashierId: "string",
                values: "CloseValue[]"
            },
            ret: "Cashier"
        },
        closeCashier: {
            args: {
                eventId: "string",
                cashierId: "string"
            },
            ret: "void"
        },
        reopenCashier: {
            args: {
                eventId: "string",
                cashierId: "string"
            },
            ret: "void"
        },
        addCashierClosingObs: {
            args: {
                eventId: "string",
                cashierId: "string",
                obs: "string"
            },
            ret: "void"
        },
        getCashierClosingObs: {
            args: {
                eventId: "string",
                cashierId: "string"
            },
            ret: "CashierClosingObs[]"
        },
        listCateringProducts: {
            args: {
                placeId: "string",
                categoryId: "string?",
                productName: "string?",
                types: "CateringProductSubType[]?",
                pagination: "Pagination?",
                orderBy: "CateringProductsOrderBy?",
                order: "CateringProductsOrderDirection?"
            },
            ret: "CateringProductListResponse"
        },
        addCateringProduct: {
            args: {
                placeId: "string",
                product: "NewCateringProduct",
                image: "EditProductImage?"
            },
            ret: "AddCateringProduct"
        },
        updateCateringProduct: {
            args: {
                placeId: "string",
                productId: "string",
                product: "NewCateringProduct",
                image: "EditProductImage?"
            },
            ret: "void"
        },
        updateCateringProductPrice: {
            args: {
                placeId: "string",
                productId: "string",
                value: "uint"
            },
            ret: "void"
        },
        deleteCateringProducts: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "DeleteCateringProductsResponse"
        },
        bulkImportCateringProducts: {
            args: {
                placeId: "string",
                items: "NewCateringProductBulkItem[]"
            },
            ret: "BulkImportCateringProductsResponse"
        },
        exportCateringProducts: {
            args: {
                placeId: "string",
                categoryId: "string?",
                productName: "string?",
                types: "CateringProductSubType[]?",
                orderBy: "CateringProductsOrderBy?",
                order: "CateringProductsOrderDirection?"
            },
            ret: "string"
        },
        getPlainCategories: {
            args: {},
            ret: "BaseCategory[]"
        },
        getCategories: {
            args: {},
            ret: "CategoryWithTotalProducts[]"
        },
        getPlaceCategories: {
            args: {
                placeId: "uuid"
            },
            ret: "BaseCategory[]"
        },
        createCategory: {
            args: {
                category: "NewCategory",
                data: "bytes?"
            },
            ret: "Category"
        },
        editCategory: {
            args: {
                id: "string",
                category: "NewCategory",
                data: "bytes?"
            },
            ret: "void"
        },
        deleteCategory: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getSellablesFromCategory: {
            args: {
                categoryId: "string"
            },
            ret: "SellableList"
        },
        filterSellablesCategories: {
            args: {
                name: "string"
            },
            ret: "Category[]"
        },
        getSummarizedCategories: {
            args: {
                placeId: "uuid",
                productsSearchQuery: "string?",
                status: "ProductStatus?",
                kind: "CategoryKind",
                includeEmpty: "bool?"
            },
            ret: "SummarizedCategory[]"
        },
        getCostOfGoodsSoldByProductList: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "CostOfGoodsSold[]"
        },
        getCmvReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                type: "CmvReportType"
            },
            ret: "CmvReportResult"
        },
        exportCmvReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                type: "CmvReportType",
                productIds: "string[]?"
            },
            ret: "string"
        },
        getStoragePositionAt: {
            args: {
                placeId: "string",
                month: "uint",
                year: "uint"
            },
            ret: "ProductStoragePosition[]"
        },
        getLostReport: {
            args: {
                placeId: "string",
                storageIds: "string[]?",
                since: "date",
                until: "date"
            },
            ret: "ProductStoragePosition[]"
        },
        getCmvMonthlyClosing: {
            args: {
                placeId: "string",
                month: "uint",
                year: "uint"
            },
            ret: "CmvMonthlyClosing"
        },
        getLostReportV2: {
            args: {
                placeId: "string",
                storageIds: "string[]?",
                since: "datetime",
                until: "datetime",
                pagination: "BackofficeLostReportPagination?"
            },
            ret: "BackofficeLostReport"
        },
        addNewCombo: {
            args: {
                placeId: "string",
                combo: "NewPlaceCombo",
                data: "bytes?"
            },
            ret: "string"
        },
        editCombo: {
            args: {
                comboId: "string",
                placeId: "string",
                combo: "NewPlaceCombo"
            },
            ret: "void"
        },
        editComboImage: {
            args: {
                comboId: "string",
                data: "bytes"
            },
            ret: "void"
        },
        deleteCombo: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getNewCombo: {
            args: {
                comboId: "string",
                placeId: "string"
            },
            ret: "DataCombo?"
        },
        getCombos: {
            args: {
                placeId: "string"
            },
            ret: "DataCombo[]"
        },
        exportAllCombosXlsx: {
            args: {
                placeId: "string"
            },
            ret: "string"
        },
        listComodatoContracts: {
            args: {
                request: "ComodatoContractListRequest"
            },
            ret: "ComodatoContractListResponse"
        },
        exportComodatoContractsToExcel: {
            args: {
                request: "ExportComodatoContractsRequest"
            },
            ret: "ComodatoContractListResponse"
        },
        resendComodatoContractSignatureEmail: {
            args: {
                request: "ResendComodatoContractSignatureRequest"
            },
            ret: "void"
        },
        getProductsWebConfigs: {
            args: {
                placeId: "string"
            },
            ret: "UpsertProductsWebResponse"
        },
        upsertProductsWebConfigs: {
            args: {
                placeId: "string",
                data: "UpsertProductsWebRequest"
            },
            ret: "UpsertProductsWebResponse"
        },
        setDeliveryFeeFiscalProductGroup: {
            args: {
                placeId: "uuid",
                deliveryFeeId: "uuid",
                fiscalProductGroupId: "uuid"
            },
            ret: "void"
        },
        removeDeliveryFeeFiscalProductGroup: {
            args: {
                placeId: "uuid",
                deliveryFeeId: "uuid"
            },
            ret: "void"
        },
        getDeliveryFeeFiscalProductGroupsByPlace: {
            args: {
                placeId: "uuid"
            },
            ret: "DeliveryFeeFiscalProductGroupBinding[]"
        },
        removeDeviceFromEvent: {
            args: {
                deviceId: "string",
                eventId: "string"
            },
            ret: "void"
        },
        getDeviceEventStatus: {
            args: {
                eventId: "string"
            },
            ret: "DeviceEventStatus[]"
        },
        getPlaceDevices: {
            args: {
                placeId: "string"
            },
            ret: "DeviceConfig[]"
        },
        linkDevicesToPlace: {
            args: {
                placeId: "string",
                smallIds: "string[]"
            },
            ret: "DeviceConfig[]"
        },
        shouldUpdateDashboardAppVersion: {
            args: {},
            ret: "void"
        },
        createDiscountCategory: {
            args: {
                discountCategory: "CreateDiscountCategoryRequest",
                employeeIds: "string[]?"
            },
            ret: "DiscountCategoryResponse"
        },
        getDiscountCategories: {
            args: {
                placeId: "string",
                pagination: "Pagination",
                filters: "DiscountCategoryFilters"
            },
            ret: "DiscountCategoriesResponse"
        },
        updateDiscountCategory: {
            args: {
                discountCategoryId: "string",
                discountCategory: "UpdateDiscountCategoryRequest",
                employeeIds: "string[]?"
            },
            ret: "DiscountCategoryResponse"
        },
        deleteDiscountCategory: {
            args: {
                discountCategoryId: "string"
            },
            ret: "DiscountCategoryResponse"
        },
        givePermissionToUseDiscountCategory: {
            args: {
                employeeIds: "string[]",
                discountCategoryId: "string"
            },
            ret: "void"
        },
        removePermissionToUseDiscountCategory: {
            args: {
                employeeIds: "string[]",
                discountCategoryId: "string"
            },
            ret: "void"
        },
        activateDiscountCategoryOnPlaces: {
            args: {
                placeIds: "string[]",
                discountCategoryId: "string"
            },
            ret: "void"
        },
        disableDiscountCategoryOnPlaces: {
            args: {
                placeIds: "string[]",
                discountCategoryId: "string"
            },
            ret: "void"
        },
        getEmployeesByDiscountCategory: {
            args: {
                discountCategoryId: "string"
            },
            ret: "EmployeesByDiscountCategory[]"
        },
        getEmployee: {
            args: {
                employeeId: "string"
            },
            ret: "Employee"
        },
        addEmployee: {
            args: {
                employee: "NewEmployee",
                password: "string?",
                image: "bytes?"
            },
            ret: "string"
        },
        editEmployee: {
            args: {
                id: "string",
                employee: "EditEmployee"
            },
            ret: "void"
        },
        editEmployeePassword: {
            args: {
                id: "string",
                password: "string"
            },
            ret: "void"
        },
        editEmployeeImage: {
            args: {
                id: "string",
                data: "bytes"
            },
            ret: "void"
        },
        editMultipleEmployees: {
            args: {
                employeeIds: "string[]",
                edition: "EditMultipleEmployees"
            },
            ret: "void"
        },
        removeMultipleEmployees: {
            args: {
                employeeIds: "string[]"
            },
            ret: "MultipleEmployeeResult"
        },
        removeEmployee: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        addZigTagToWaiter: {
            args: {
                zigCode: "string",
                employeeId: "string"
            },
            ret: "void"
        },
        getEmployeesV2: {
            args: {
                filters: "GetEmployeesV2Filters?"
            },
            ret: "EmployeeV2[]"
        },
        addMultipleEmployees: {
            args: {
                employee: "MultipleEmployees",
                password: "string?",
                image: "bytes?"
            },
            ret: "AddMultipleEmployees"
        },
        addMultipleEmployeesV2: {
            args: {
                employees: "AddMultipleEmployeesV2Employee[]"
            },
            ret: "AddMultipleEmployees"
        },
        updateMultipleEmployeeDeviceConfigs: {
            args: {
                employeeIds: "string[]",
                config: "EmployeeDeviceConfigsUpdate"
            },
            ret: "void"
        },
        duplicateEmployee: {
            args: {
                employeeId: "uuid",
                name: "string",
                username: "string",
                password: "string"
            },
            ret: "uuid"
        },
        updateEmployeePassword: {
            args: {
                token: "string",
                password: "string",
                confirmPassword: "string"
            },
            ret: "void"
        },
        createEntrance: {
            args: {
                placeId: "string",
                entrance: "Entrance",
                data: "bytes?"
            },
            ret: "string"
        },
        deleteEntrance: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getEntrance: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "Entrance?"
        },
        getAllEntrances: {
            args: {
                placeId: "string"
            },
            ret: "Entrance[]"
        },
        editEntrance: {
            args: {
                placeId: "string",
                entrance: "Entrance"
            },
            ret: "void"
        },
        editEntranceImage: {
            args: {
                entranceId: "string",
                data: "bytes?"
            },
            ret: "void"
        },
        entrancesSoldAtPlace: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string"
            },
            ret: "EntranceSold[]"
        },
        entrancesSoldAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "EntranceSold[]"
        },
        entrancesSoldByEmployee: {
            args: {
                eventId: "string"
            },
            ret: "Bilheteiro[]"
        },
        getEntrancesSoldToUserAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "EntranceUser[]"
        },
        getEntrancesSoldToUserAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "EntranceUser[]"
        },
        usersEntrancesConsumed: {
            args: {
                eventId: "string?",
                placeId: "string?",
                filters: "UsersEntrancesConsumedReportFilters",
                pagination: "Pagination"
            },
            ret: "UsersEntrancesConsumedReportResponse"
        },
        usersEntrancesConsumedOverview: {
            args: {
                eventId: "string?",
                placeId: "string?",
                filters: "UsersEntrancesConsumedReportFilters"
            },
            ret: "UsersEntrancesConsumedOverview"
        },
        getAllEvents: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string"
            },
            ret: "Event[]"
        },
        createEvent: {
            args: {
                details: "EventDetails",
                image: "bytes?",
                cover: "bytes?"
            },
            ret: "string"
        },
        openEvent: {
            args: {
                id: "string",
                actualizingdatetime: "bool"
            },
            ret: "void"
        },
        closeEvent: {
            args: {
                id: "string"
            },
            ret: "OpenedReports[]"
        },
        deleteEvent: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getEvent: {
            args: {
                id: "string"
            },
            ret: "Event"
        },
        updateEvent: {
            args: {
                id: "string",
                passTemplateId: "string?"
            },
            ret: "void"
        },
        getEvents: {
            args: {
                placeId: "uuid",
                month: "uint",
                year: "uint"
            },
            ret: "EventList"
        },
        getOpenedEventsBaseInfo: {
            args: {
                placeIds: "uuid[]"
            },
            ret: "EventBaseInfo[]"
        },
        getWithdrawAuthKeys: {
            args: {
                request: "GetWithdrawAuthKeysRequest"
            },
            ret: "WithdrawAuthKeyResponse[]"
        },
        createWithdrawAuthKeys: {
            args: {
                request: "CreateWithdrawAuthKeyRequest"
            },
            ret: "CreateWithdrawAuthKeysResponse"
        },
        deleteWithdrawAuthKey: {
            args: {
                request: "DeleteWithdrawAuthKeyRequest"
            },
            ret: "DeleteWithdrawAuthKeyResponse"
        },
        unlockWithdrawAuthKey: {
            args: {
                request: "UnlockWithdrawAuthKeyRequest"
            },
            ret: "WithdrawAuthKeyResponse"
        },
        requestAuthKeyCode: {
            args: {
                request: "RequestAuthKeyCodeRequest"
            },
            ret: "RequestAuthKeyCodeResponse"
        },
        validateAuthKeyCode: {
            args: {
                request: "ValidateAuthKeyCodeRequest"
            },
            ret: "ValidateAuthKeyCodeResponse"
        },
        getRequestProRataPercentage: {
            args: {
                placeId: "string",
                anticipationValue: "float"
            },
            ret: "float"
        },
        getMaximumPossibleAnticipationValues: {
            args: {
                placeId: "string"
            },
            ret: "MaximumPossibleAnticipationValuesResult"
        },
        transferBalance: {
            args: {
                fromPlaceId: "string",
                toPlaceId: "string",
                transferValue: "money"
            },
            ret: "void"
        },
        isThereAPendingBankslip: {
            args: {
                placeId: "string"
            },
            ret: "BankslipInfo"
        },
        getExtractAdjusts: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "AdjustResponse[]"
        },
        getDebitNotes: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime"
            },
            ret: "DebitNote[]"
        },
        getRentNotes: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime"
            },
            ret: "RentNote[]"
        },
        updateWithdrawReceipts: {
            args: {
                placeId: "uuid",
                since: "datetime"
            },
            ret: "UpdateWithdrawReceipts"
        },
        payBillAtEventWithMultiplePayments: {
            args: {
                userId: "string",
                eventId: "string",
                payments: "BillPayment[]",
                reason: "string?"
            },
            ret: "PixCharge?"
        },
        payBillAtPlaceInPeriodWithMultiplePayments: {
            args: {
                userId: "string",
                placeId: "string",
                payments: "BillPayment[]",
                since: "datetime",
                until: "datetime",
                reason: "string?"
            },
            ret: "PixCharge?"
        },
        payBillsAtEventWithMultiplePayments: {
            args: {
                userIds: "string[]",
                eventId: "string",
                method: "PaymentMethod"
            },
            ret: "MultipleUserIdsResult"
        },
        payBillsAtPlaceInPeriodWithMultiplePayments: {
            args: {
                userIds: "string[]",
                placeId: "string",
                since: "date",
                until: "date",
                method: "PaymentMethod"
            },
            ret: "MultipleUserIdsResult"
        },
        sendPixEmailToPayBill: {
            args: {
                pixChargeId: "string",
                userEmail: "email"
            },
            ret: "void"
        },
        sendOpenBillChargeByEmail: {
            args: {
                userEmail: "email",
                openBillChargeId: "uuid"
            },
            ret: "void"
        },
        getOpenBillChargeDetails: {
            args: {
                openBillChargeId: "uuid",
                placeId: "uuid"
            },
            ret: "OpenBillChargeDetails"
        },
        getOpenBillDetailsByUserInPlace: {
            args: {
                userId: "string",
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "OpenBillChargeDetails"
        },
        executeLiquidationMotor: {
            args: {
                placeId: "string",
                vendorId: "string?"
            },
            ret: "void"
        },
        getClientsAtEvent: {
            args: {
                eventId: "string",
                options: "OptionsClientsEvent"
            },
            ret: "Client[]"
        },
        clientsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "Client[]"
        },
        clientsAtPlace: {
            args: {
                since: "datetime",
                until: "datetime",
                placeId: "string"
            },
            ret: "Client[]"
        },
        clientAtPlace: {
            args: {
                userId: "string",
                placeId: "string"
            },
            ret: "ClientAtPlace"
        },
        clientTransactionsAtEvent: {
            args: {
                userId: "string",
                eventId: "string"
            },
            ret: "UserTransaction[]"
        },
        debtorsInEvent: {
            args: {
                eventId: "string"
            },
            ret: "Debtor[]"
        },
        debtorsInPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "Debtor[]"
        },
        debtorsInEventV2: {
            args: {
                eventId: "string",
                pagination: "Pagination",
                filters: "DebtorsFilters"
            },
            ret: "PaginatedDebtorsResponse"
        },
        debtorsInPlaceV2: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                pagination: "Pagination",
                filters: "DebtorsFilters"
            },
            ret: "PaginatedDebtorsResponse"
        },
        getDebtorsXls: {
            args: {
                input: "DebtorsXlsInput"
            },
            ret: "string"
        },
        getBonusReport: {
            args: {
                input: "BonusReportInput"
            },
            ret: "BonusReportResponse"
        },
        getBonusReportForPlace: {
            args: {
                input: "BonusReportForPlaceInput"
            },
            ret: "BonusReportResponse"
        },
        getBonusReportForPlaceOverview: {
            args: {
                input: "BonusReportForPlaceOverviewInput"
            },
            ret: "BonusReportOverview"
        },
        getBonusReportOverview: {
            args: {
                input: "BonusReportOverviewInput"
            },
            ret: "BonusReportOverview"
        },
        getBonusReportXls: {
            args: {
                input: "BonusReportXlsInput"
            },
            ret: "string"
        },
        getBonusReportSummary: {
            args: {
                placeId: "string",
                period: "PeriodTime?",
                eventId: "string?"
            },
            ret: "BonusReportSummary"
        },
        getMinimumConsumptionReport: {
            args: {
                eventId: "string"
            },
            ret: "MinimumConsumptionReport[]"
        },
        getMinimumConsumptionReportForPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "MinimumConsumptionReport[]"
        },
        getUsedBonusReport: {
            args: {
                eventId: "string"
            },
            ret: "UsedBonusReport[]"
        },
        getUsedBonusReportForPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "UsedBonusReport[]"
        },
        getClientDetails: {
            args: {
                clientId: "string"
            },
            ret: "ClientDetails"
        },
        editClient: {
            args: {
                clientId: "string",
                name: "string",
                phone: "string"
            },
            ret: "void"
        },
        getBonusByProduct: {
            args: {
                eventId: "string"
            },
            ret: "BonusByProduct[]"
        },
        getBonusByProductAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "BonusByProduct[]"
        },
        getOpenedBillsProduct: {
            args: {
                eventId: "string"
            },
            ret: "OpenedProduct[]"
        },
        getOpenedBillsProductAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "OpenedProduct[]"
        },
        getRechargeConsumptions: {
            args: {
                eventId: "string"
            },
            ret: "RechargeConsumption[]"
        },
        getRefundedRechargesAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "RefundedRecharge[]"
        },
        getCardActivationReturnReportAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ActivationReturnReport"
        },
        getPromotionsUsedAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "UsedPromotion[]"
        },
        getPromotionsUsedAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "UsedPromotion[]"
        },
        getUserPromotionsUsedAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "UserUsedPromotion[]"
        },
        getUserPromotionsUsedAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "UserUsedPromotion[]"
        },
        getTablePromotionsUsed: {
            args: {
                filterScope: "FilterScope",
                pagination: "Pagination",
                filters: "TablePromotionsUsedFilters?"
            },
            ret: "TotalTablePromotionReport"
        },
        exportTablePromotionsUsedXlsl: {
            args: {
                filterScope: "FilterScope",
                filters: "TablePromotionsUsedFilters?"
            },
            ret: "string"
        },
        getTableUsedPromotionsInScope: {
            args: {
                filterScope: "FilterScope"
            },
            ret: "UsedPromotionsInScope[]"
        },
        getEntrancesSoldByEmployeeAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "SoldEntranceWithEmployee[]"
        },
        getEntrancesSoldByEmployeeAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "SoldEntranceWithEmployee[]"
        },
        getRefundedProductsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "RefundedProduct[]"
        },
        getRefundedProductsAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "RefundedProduct[]"
        },
        getTipsRemovedAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "TipRemovedList[]"
        },
        getTipsRemovedAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "TipRemovedList[]"
        },
        getCardActivationReturnReportByEmployeeAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "CardReturnEmployee[]"
        },
        getCardActivationReturnReportByEmployeeAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "CardReturnEmployee[]"
        },
        getDiscountsAtEventByEmployee: {
            args: {
                eventId: "string"
            },
            ret: "DiscountEmployee[]"
        },
        getDiscountsAtPlaceByEmployee: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "DiscountEmployee[]"
        },
        getPostLimitChangesAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "PostLimitChange[]"
        },
        getPostLimitChanges: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "PostLimitChange[]"
        },
        emitInnovaroGeneralInvoices: {
            args: {
                eventId: "string"
            },
            ret: "void"
        },
        getOpenedBillPayments: {
            args: {
                eventId: "string"
            },
            ret: "OpenedBillPayment[]"
        },
        getOpenedBillPaymentsAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "OpenedBillPayment[]"
        },
        getOpenedBillPaymentsV2: {
            args: {
                eventId: "string"
            },
            ret: "OpenedBillPaymentV2[]"
        },
        getOpenedBillPaymentsAtPlaceV2: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "OpenedBillPaymentV2[]"
        },
        getOpenedBillPaymentsV3: {
            args: {
                eventId: "string",
                pagination: "Pagination",
                filters: "OpenedBillPaymentsFilters"
            },
            ret: "PaginatedOpenedBillPaymentsResponse"
        },
        getOpenedBillPaymentsAtPlaceV3: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                pagination: "Pagination",
                filters: "OpenedBillPaymentsFilters"
            },
            ret: "PaginatedOpenedBillPaymentsResponse"
        },
        getOpenedBillReportOverview: {
            args: {
                scope: "GetReportByScope"
            },
            ret: "OpenedBillReportOverview"
        },
        getOpenedBillPaymentsXls: {
            args: {
                input: "OpenedBillPaymentsXlsInput"
            },
            ret: "string"
        },
        getRappiDiscountsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "RappiDiscount[]"
        },
        getRappiDiscountsAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "RappiDiscount[]"
        },
        getConsumptionObligationReportAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionObligationReport[]"
        },
        getConsumptionObligationReportAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ConsumptionObligationReport[]"
        },
        getAllMoneyOperationsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "MoneyOperation[]"
        },
        getAllMoneyOperations: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "MoneyOperation[]"
        },
        getAllTransactionsAfterEventClosing: {
            args: {
                eventId: "string",
                filters: "FilterReportAfterEventClosing[]"
            },
            ret: "ReportAfterEventClosing[]"
        },
        getZigDeviceSyncForcesAtEvent: {
            args: {
                eventId: "uuid",
                pagination: "Pagination?"
            },
            ret: "GetZigDeviceSyncForcesAtEvent"
        },
        getCashRechargeConsumptionsAtEvent: {
            args: {
                eventId: "uuid",
                pagination: "Pagination?"
            },
            ret: "RechargeConsumptionByAuthorPaginated"
        },
        getPixRechargeConsumptionsAtEvent: {
            args: {
                eventId: "uuid",
                pagination: "Pagination?"
            },
            ret: "RechargeConsumptionByAuthorPaginated"
        },
        getRescueRechargeConsumptionsAtEvent: {
            args: {
                eventId: "uuid",
                pagination: "Pagination?"
            },
            ret: "GetRescueRechargeConsumptionsAtEvent"
        },
        getAuthorRechargeConsumptionsDetailsAtEvent: {
            args: {
                authorId: "uuid",
                eventId: "uuid"
            },
            ret: "RechargeConsumptionFromAuthor[]"
        },
        getRescueRechargeConsumptionsDetailsAtEvent: {
            args: {
                eventId: "uuid"
            },
            ret: "RechargeConsumptionFromAuthor[]"
        },
        getTotemTransactions: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                pagination: "Pagination",
                filters: "TotemTransactionFilters"
            },
            ret: "TotemTransactionResponse"
        },
        getTotemTransactionTotalizer: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "TotemTransactionTotalizerResponse"
        },
        getAppTransactionsAtEvent: {
            args: {
                eventId: "string",
                pagination: "Pagination",
                filters: "AppTransactionsFilters"
            },
            ret: "AppTransactionDetailsPaginationResponse"
        },
        getAppTransactionsAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                pagination: "Pagination",
                filters: "AppTransactionsFilters"
            },
            ret: "AppTransactionDetailsPaginationResponse"
        },
        getAppTotalizerByPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "AppTransactionsTotalizer"
        },
        getAppTotalizerByEvent: {
            args: {
                eventId: "string"
            },
            ret: "AppTransactionsTotalizer"
        },
        createOpenBillChargeByPlace: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                userId: "uuid",
                shouldChargeTip: "bool"
            },
            ret: "OpenBillCharge"
        },
        getTransactionTransfersAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "TransactionTransfer[]"
        },
        getTransactionTransfersAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "TransactionTransfer[]"
        },
        getTransactionTransfersXlsx: {
            args: {
                scope: "GetReportByScope"
            },
            ret: "string"
        },
        getRechargeValueTransacted: {
            args: {
                eventIds: "string[]"
            },
            ret: "uint"
        },
        getTotalTransactionsByEvents: {
            args: {
                placeId: "string",
                date: "PeriodTime"
            },
            ret: "uint"
        },
        getAllPlaceSales: {
            args: {
                placeId: "string",
                period: "PeriodTime",
                filters: "SalesDetailsFilters",
                pagination: "Pagination"
            },
            ret: "AllSalesPaginationResponse?"
        },
        getAllPlaceSalesInEvent: {
            args: {
                placeId: "string",
                eventId: "string",
                filters: "SalesDetailsFilters",
                pagination: "Pagination"
            },
            ret: "AllSalesPaginationResponse?"
        },
        getAllPlaceSalesSummary: {
            args: {
                placeId: "string",
                period: "PeriodTime",
                filters: "SalesFilters"
            },
            ret: "AllSalesSummaryResponse?"
        },
        getAllPlaceSalesSummaryInEvent: {
            args: {
                placeId: "string",
                eventId: "string",
                filters: "SalesFilters"
            },
            ret: "AllSalesSummaryResponse?"
        },
        getAllPlaceSalesXls: {
            args: {
                placeId: "string",
                period: "PeriodTime",
                filters: "SalesFilters"
            },
            ret: "string"
        },
        getAllPlaceSalesInEventXls: {
            args: {
                placeId: "string",
                eventId: "string",
                filters: "SalesFilters"
            },
            ret: "string"
        },
        getResumeForEventInSections: {
            args: {
                eventId: "string"
            },
            ret: "EventResumeSection[]"
        },
        getResumeForPlaceInSections: {
            args: {
                placeId: "string",
                from: "datetime",
                until: "datetime"
            },
            ret: "EventResumeSection[]"
        },
        getClosingReportsByPlace: {
            args: {
                placeIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "PlaceReport[]"
        },
        getEntranceResumeForEventInSections: {
            args: {
                eventId: "string"
            },
            ret: "EventResumeSection[]"
        },
        getEntranceResumeForPlaceInSections: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "EventResumeSection[]"
        },
        getClosingResumeReportForEventInSections: {
            args: {
                eventId: "string"
            },
            ret: "EventResumeSection[]"
        },
        getClosingResumeReportForPlaceInSections: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "EventResumeSection[]"
        },
        createFinancialClosingReportMap: {
            args: {
                data: "CreateFinancialClosingReportMapInput"
            },
            ret: "FinancialClosingReportMapItem"
        },
        updateFinancialClosingReportMap: {
            args: {
                id: "uuid",
                data: "UpdateFinancialClosingReportMapInput"
            },
            ret: "FinancialClosingReportMapItem"
        },
        deleteFinancialClosingReportMap: {
            args: {
                id: "uuid"
            },
            ret: "bool"
        },
        getCouvertFiscalDataForPlaces: {
            args: {},
            ret: "ProductFiscalDataWithPlaceInfo[]"
        },
        setCouvertFiscalData: {
            args: {
                placeId: "string",
                data: "ProductFiscalData"
            },
            ret: "void"
        },
        getCouvertFiscalData: {
            args: {
                placeId: "string"
            },
            ret: "CouvertFiscalDataForPlace?"
        },
        isNcmValid: {
            args: {
                ncm: "string"
            },
            ret: "bool"
        },
        getInvoicePrintout: {
            args: {
                invoiceId: "string"
            },
            ret: "bytes[]"
        },
        issueInvoicesForUser: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "IssueResult"
        },
        emitAllInvoicesInMonth: {
            args: {
                placeId: "string"
            },
            ret: "SimpleIssueResult"
        },
        issueInvoicesOfTransactions: {
            args: {
                eventId: "string",
                transactionIds: "string[]",
                cpf: "string?",
                cnpj: "string?",
                nif: "string?"
            },
            ret: "IssueResult"
        },
        issueInvoicesOfTransactionsWithConsumptionObligation: {
            args: {
                eventId: "string",
                transactionIds: "string[]",
                cpf: "string?",
                cnpj: "string?",
                nif: "string?",
                obligations: "ObligationPaymentsForInvoice[]",
                recipientExtraInfo: "RecipientExtraInfo?"
            },
            ret: "IssueResult"
        },
        getInvoicesBySearchValue: {
            args: {
                searchValue: "string",
                country: "GetInvoicesBySearchValueCountry"
            },
            ret: "MinimalInvoiceWithEvent[]"
        },
        getInvoices: {
            args: {
                eventId: "string"
            },
            ret: "Invoice[]"
        },
        getInvoicesFromUser: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "Invoice[]"
        },
        getInvoicesFromUserAtPlace: {
            args: {
                placeId: "string",
                userId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "InvoiceWithEvent[]"
        },
        hasPendingInvoices: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "bool"
        },
        sendInvoicesByEmail: {
            args: {
                invoiceIds: "string[]",
                email: "string?"
            },
            ret: "void"
        },
        hasPrinter: {
            args: {
                invoiceId: "string"
            },
            ret: "bool"
        },
        getFiscalProfile: {
            args: {
                fiscalProfileId: "string"
            },
            ret: "FiscalProfile"
        },
        getFiscalProfiles: {
            args: {},
            ret: "FiscalProfile[]"
        },
        getFiscalProfilesAtPlace: {
            args: {
                placeId: "string"
            },
            ret: "FiscalProfile[]"
        },
        createFiscalProfile: {
            args: {
                fiscalProfile: "FiscalProfile"
            },
            ret: "FiscalProfile"
        },
        updateFiscalProfile: {
            args: {
                fiscalProfile: "FiscalProfile"
            },
            ret: "FiscalProfile"
        },
        deleteFiscalProfile: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        listFiscalProfilesPending: {
            args: {},
            ret: "FiscalProfileDraft[]"
        },
        listFiscalProfileDraftHistory: {
            args: {
                parentId: "string"
            },
            ret: "FiscalProfileDraft[]"
        },
        getFiscalProfileWithPendingDraft: {
            args: {
                parentId: "string"
            },
            ret: "FiscalProfileWithPendingDraft"
        },
        approveFiscalProfileDraft: {
            args: {
                draftId: "string"
            },
            ret: "FiscalProfile"
        },
        rejectFiscalProfileDraft: {
            args: {
                draftId: "string"
            },
            ret: "void"
        },
        getFiscalProfileActivePlaces: {
            args: {
                fiscalProfileId: "string"
            },
            ret: "string[]?"
        },
        setFiscalProfileActivePlaces: {
            args: {
                fiscalProfileId: "string",
                placeIds: "string[]?"
            },
            ret: "void"
        },
        getFiscalProductGroupActivePlaces: {
            args: {
                fiscalProductGroupId: "string"
            },
            ret: "string[]?"
        },
        setFiscalProductGroupActivePlaces: {
            args: {
                fiscalProductGroupId: "string",
                placeIds: "string[]?"
            },
            ret: "void"
        },
        getFiscalProductGroup: {
            args: {
                fiscalProductGroupId: "string"
            },
            ret: "FiscalProductGroup"
        },
        getFiscalProductGroups: {
            args: {},
            ret: "FiscalProductGroup[]"
        },
        getFiscalProductGroupsAtPlace: {
            args: {
                placeId: "string"
            },
            ret: "FiscalProductGroup[]"
        },
        createFiscalProductGroup: {
            args: {
                fiscalProductGroup: "FiscalProductGroup"
            },
            ret: "FiscalProductGroup"
        },
        updateFiscalProductGroup: {
            args: {
                fiscalProductGroup: "FiscalProductGroup"
            },
            ret: "FiscalProductGroup"
        },
        deleteFiscalProductGroup: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        listFiscalProductGroupsPending: {
            args: {},
            ret: "FiscalProductGroupDraft[]"
        },
        listFiscalProductGroupDraftHistory: {
            args: {
                parentId: "string"
            },
            ret: "FiscalProductGroupDraft[]"
        },
        getFiscalProductGroupWithPendingDraft: {
            args: {
                parentId: "string"
            },
            ret: "FiscalProductGroupWithPendingDraft"
        },
        approveFiscalProductGroupDraft: {
            args: {
                draftId: "string"
            },
            ret: "FiscalProductGroup"
        },
        rejectFiscalProductGroupDraft: {
            args: {
                draftId: "string"
            },
            ret: "void"
        },
        getFiscalInvoices: {
            args: {
                placeId: "string",
                fiscalProfileId: "string",
                since: "date",
                until: "date"
            },
            ret: "Invoice[]"
        },
        getFiscalInvoicesV2: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                pagination: "Pagination",
                filterOptions: "InvoicesV2Filter?"
            },
            ret: "InvoicesV2PaginationResponse"
        },
        getNationalFiscalInvoices: {
            args: {
                placeId: "string",
                filters: "NationalFiscalInvoiceFilter",
                pagination: "Pagination"
            },
            ret: "NationalFiscalInvoiceResponse"
        },
        getNationalFiscalInvoicesXlsx: {
            args: {
                placeId: "string",
                filters: "NationalFiscalInvoiceFilter"
            },
            ret: "string"
        },
        getNationalFiscalInvoicesZip: {
            args: {
                placeId: "string",
                filters: "NationalFiscalInvoiceFilter"
            },
            ret: "string"
        },
        getInvoice: {
            args: {
                id: "string"
            },
            ret: "Invoice"
        },
        getZippedInvoices: {
            args: {
                placeId: "string",
                fiscalProfileId: "string",
                since: "date",
                until: "date",
                sendToEmail: "string?"
            },
            ret: "string?"
        },
        getNotEmmitedTransactionsFromEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "NotEmmitedTransaction[]"
        },
        getNotEmmitedConsumptionObligationsFromEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "uint"
        },
        issueManualInvoice: {
            args: {
                eventId: "string",
                manualRequest: "ManualRequest",
                cpf: "string?",
                cnpj: "string?",
                nif: "string?"
            },
            ret: "IssueResult"
        },
        issueManualInvoiceForReserve: {
            args: {
                eventId: "string",
                manualRequest: "ManualRequest",
                cpf: "string?",
                cnpj: "string?",
                nif: "string?",
                reserveId: "string"
            },
            ret: "IssueResult[]"
        },
        getReportNotIssuedWithErrorXlsx: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "string"
        },
        getNotIssuedWithError: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                currentPage: "uint"
            },
            ret: "NotIssuedWithErrorResponse"
        },
        getInvoiceIssuedByPerfilFiscal: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "InvoiceIssuedByPerfilFiscal[]"
        },
        getInvoiceIssuedByMode: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "InvoiceIssuedByMode"
        },
        getFiscalSumupSections: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "EventResumeSection[]"
        },
        getReportFiscal: {
            args: {
                placeId: "string",
                fiscalProfileIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "ReportFiscal[]"
        },
        getReportFiscalXlsx: {
            args: {
                placeId: "string",
                fiscalProfileIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "string"
        },
        getUnusedInvoices: {
            args: {
                fiscalProfileId: "string",
                since: "date",
                until: "date",
                placeId: "string"
            },
            ret: "UnusedInvoice[]"
        },
        getPendingInvoicesInternational: {
            args: {
                timePeriod: "PeriodTime",
                placeId: "string",
                pagination: "Pagination",
                filterOptions: "PendingInvoicesFilter?"
            },
            ret: "PendingInvoicesPaginatedResponse"
        },
        getTotalPendingAutoissuanceOrders: {
            args: {
                timePeriod: "PeriodTime",
                placeId: "string",
                filterOptions: "PendingInvoicesFilter?"
            },
            ret: "uint"
        },
        getZippedUnusedInvoices: {
            args: {
                fiscalProfileId: "string",
                since: "date",
                until: "date"
            },
            ret: "string"
        },
        getAllTransactionsWithInvoices: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                isIssued: "bool?"
            },
            ret: "TransactionProductWithInvoice[]"
        },
        getAllRechargesWithInvoicesByEvents: {
            args: {
                eventIds: "string[]",
                pagination: "Pagination",
                filterOptions: "RechargeWithInvoiceFilter?"
            },
            ret: "RechargeWithInvoicePaginatedResponse"
        },
        getRechargesInvoicesEmittedValue: {
            args: {
                eventIds: "string[]"
            },
            ret: "uint"
        },
        getRechargesInvoicesEmittedNetValue: {
            args: {
                eventIds: "string[]"
            },
            ret: "uint"
        },
        getRechargesInvoicesXlsx: {
            args: {
                eventIds: "string[]",
                filterOptions: "RechargeWithInvoiceFilter?"
            },
            ret: "string"
        },
        getEmittedValue: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "uint"
        },
        getIvaVendusEmittedNetValueForTransactions: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "uint"
        },
        getEmittedValueByBar: {
            args: {
                placeId: "string",
                date: "PeriodTime"
            },
            ret: "BarEmittedValue[]"
        },
        getEmittedValueByPaymentMethod: {
            args: {
                placeId: "string",
                period: "PeriodTime"
            },
            ret: "EmittedValueByPaymentType[]"
        },
        getEmittedValueByFiscalProfile: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "FiscalProfileEmittedValue[]"
        },
        getEmittedValueByEmployee: {
            args: {
                placeId: "string",
                dateFilter: "PeriodTime"
            },
            ret: "EmployeeEmittedValue[]"
        },
        getEmittedValueReport: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "GenericValueForReport[]"
        },
        findInvoices: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                num: "uint"
            },
            ret: "SearchInvoice[]"
        },
        getNotEmittedProduct: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "NotEmittedProduct[]"
        },
        getLastEmissionDetails: {
            args: {
                placeId: "string",
                since: "date",
                until: "date",
                errorMessage: "string"
            },
            ret: "LastEmissionDetails"
        },
        cancelInvoice: {
            args: {
                invoiceId: "string"
            },
            ret: "void"
        },
        getReportInvoiceFiscalProductGroups: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "InvoiceFiscalProductGroup[]"
        },
        testEmissionForProduct: {
            args: {
                placeId: "string",
                productId: "string"
            },
            ret: "void"
        },
        testEmissionForProducts: {
            args: {
                placeId: "string",
                productIds: "uuid[]"
            },
            ret: "void"
        },
        importNCMCEST: {
            args: {
                file: "bytes",
                options: "ImportCESTNCMConfig"
            },
            ret: "ResumeImportCest"
        },
        getCESTbyNCM: {
            args: {
                ncmId: "string"
            },
            ret: "CEST[]"
        },
        getNifData: {
            args: {
                nif: "string"
            },
            ret: "NifData?"
        },
        getConsumptionObligationConfigForPlace: {
            args: {
                placeId: "string"
            },
            ret: "PlaceConsumptionObligationConfig"
        },
        getConsumptionObligationConfigForPlaces: {
            args: {},
            ret: "PlaceConsumptionObligationConfig[]"
        },
        setConsumptionObligationConfigForPlace: {
            args: {
                placeId: "string",
                config: "ConsumptionObligationConfig?"
            },
            ret: "PlaceConsumptionObligationConfig"
        },
        getPlacesRechargeFiscalConfigsByEmployee: {
            args: {},
            ret: "PlaceRechargeFiscalConfig[]"
        },
        setRechargeFiscalConfigForPlace: {
            args: {
                placeId: "string",
                config: "RechargeFiscalConfigPayload?"
            },
            ret: "PlaceRechargeFiscalConfig"
        },
        getEmployeesFromInvoicesByDateRange: {
            args: {
                placeId: "string",
                period: "PeriodTime"
            },
            ret: "EmployeeWithIssuedInvoices[]"
        },
        issueInvoicesWithSelectedProducts: {
            args: {
                eventId: "string",
                selectableInvoiceRequest: "SelectableInvoiceRequest"
            },
            ret: "IssueResult"
        },
        getInsights: {
            args: {},
            ret: "Insight[]"
        },
        reactToInsight: {
            args: {
                insightId: "string",
                reaction: "InsightReaction?"
            },
            ret: "void"
        },
        createInventory: {
            args: {
                placeId: "string",
                storageIds: "string[]",
                newInventory: "NewInventory"
            },
            ret: "Inventory"
        },
        cancelInventory: {
            args: {
                inventoryId: "string"
            },
            ret: "void"
        },
        addStorageToInventory: {
            args: {
                inventoryId: "string",
                storageIds: "string[]"
            },
            ret: "Inventory"
        },
        getInventories: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "Inventory[]"
        },
        getOpenedInventories: {
            args: {
                placeId: "string"
            },
            ret: "Inventory[]"
        },
        closeInventory: {
            args: {
                inventoryId: "string"
            },
            ret: "void"
        },
        getInventoryProductsAtStorage: {
            args: {
                inventoryId: "string",
                storageId: "string"
            },
            ret: "InventoryProduct[]"
        },
        getInventoryProducts: {
            args: {
                inventoryId: "string"
            },
            ret: "InventoryProduct[]"
        },
        updateInventoryProduct: {
            args: {
                inventoryId: "string",
                products: "NewInventoryProduct[]"
            },
            ret: "InventoryProduct[]"
        },
        getPublic: {
            args: {
                eventId: "string"
            },
            ret: "Public"
        },
        getNewPublic: {
            args: {
                eventId: "string"
            },
            ret: "NewPublic"
        },
        getTopSellingProducts: {
            args: {
                eventId: "string"
            },
            ret: "TopSellingProducts"
        },
        getSelledProducts: {
            args: {
                eventId: "string"
            },
            ret: "SelledProduct[]"
        },
        getTotalReceipt: {
            args: {
                eventId: "string"
            },
            ret: "TotalReceipt"
        },
        getTableReceipt: {
            args: {
                eventId: "string"
            },
            ret: "money"
        },
        getDeliveryReceipt: {
            args: {
                eventId: "string"
            },
            ret: "DeliveryReceipt"
        },
        getRechargeTimeline: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionTimeline[]"
        },
        getConsumptionTimeline: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionTimeline[]"
        },
        getTableConsumptionTimeline: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionTimeline[]"
        },
        getTopClients: {
            args: {
                eventId: "string"
            },
            ret: "TopSellingClient[]"
        },
        getBarConsumptionResume: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionResume"
        },
        getEntrancesConsumptionResume: {
            args: {
                eventId: "string"
            },
            ret: "ConsumptionResume"
        },
        getOpenTablesTimeline: {
            args: {
                eventId: "string"
            },
            ret: "OpenTableTimeline[]"
        },
        getClientsInTagTimeline: {
            args: {
                eventId: "string"
            },
            ret: "ClientsInTagTimeline[]"
        },
        getVendorsResume: {
            args: {
                eventId: "string"
            },
            ret: "VendorResume[]"
        },
        logIn: {
            args: {
                username: "string",
                password: "string",
                organizationUsername: "string"
            },
            ret: "Employee"
        },
        loginByTokenForVirtualAssistantMVP: {
            args: {
                username: "string",
                token: "string",
                organizationUsername: "string"
            },
            ret: "Employee"
        },
        logOut: {
            args: {},
            ret: "void"
        },
        getCurrentEmployee: {
            args: {},
            ret: "Employee"
        },
        getCurrentOrganization: {
            args: {},
            ret: "OrganizationWithFeatures"
        },
        getCurrentAdmin: {
            args: {},
            ret: "AdminResponse?"
        },
        forgotPassword: {
            args: {
                organization: "string",
                email: "string"
            },
            ret: "ForgotPassword"
        },
        registerEmployeeEmail: {
            args: {
                input: "RegisterEmployeeEmailInput"
            },
            ret: "RegisterEmployeeEmail"
        },
        confirmEmployeeEmail: {
            args: {
                token: "string"
            },
            ret: "ConfirmEmployeeEmail"
        },
        createLoyaltyProgram: {
            args: {
                loyaltyProgram: "BaseLoyaltyProgram"
            },
            ret: "string"
        },
        editLoyaltyProgram: {
            args: {
                id: "string",
                loyaltyProgram: "BaseLoyaltyProgram"
            },
            ret: "void"
        },
        getLoyaltyProgramById: {
            args: {
                programId: "string"
            },
            ret: "LoyaltyProgram"
        },
        getLoyaltyCompleteReport: {
            args: {
                organizationId: "string",
                paginationAndFilters: "PaginationAndFilters"
            },
            ret: "LoyaltyCompleteReport"
        },
        getLoyaltyCompleteReportById: {
            args: {
                programId: "string",
                filters: "LoyaltyProgramFilters?"
            },
            ret: "LoyaltyProgramReport"
        },
        getLoyaltyProgramParticipantsReport: {
            args: {
                loyaltyProgramId: "string",
                paginationAndFilters: "PaginationAndFilters"
            },
            ret: "ProgramParticipantReportResponse"
        },
        activateLoyaltyProgram: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        deactivateLoyaltyProgram: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getLoyaltyProgramSmsCost: {
            args: {
                id: "string"
            },
            ret: "SmsCostInfo"
        },
        sendSmsToLoyaltyProgramRelatives: {
            args: {
                id: "string",
                message: "string"
            },
            ret: "void"
        },
        getLoyaltyPrograms: {
            args: {},
            ret: "LoyaltyProgram[]"
        },
        generateCoupons: {
            args: {
                quantity: "uint",
                coupon: "BaseCoupon",
                campaignName: "string?"
            },
            ret: "Coupon[]"
        },
        getGiftCardCampaign: {
            args: {},
            ret: "GiftCardCampaign[]"
        },
        changeStatusGiftCardCampaign: {
            args: {
                id: "uuid",
                status: "bool"
            },
            ret: "void"
        },
        getNpsFromPlaces: {
            args: {
                placeIds: "string[]",
                since: "date",
                until: "date"
            },
            ret: "QuestionsScore"
        },
        editNpsQuestions: {
            args: {
                placeId: "string",
                questions: "QuestionType[]"
            },
            ret: "NpsPlaceInfo"
        },
        getNpsCustomerAnswers: {
            args: {
                placeIds: "string[]",
                since: "date",
                until: "date",
                pageConfig: "PageArgs"
            },
            ret: "CustomerResult"
        },
        getNpsConfig: {
            args: {
                placeIds: "string[]"
            },
            ret: "NpsPlaceInfo[]"
        },
        getNpsSmsSents: {
            args: {
                placeIds: "string[]",
                since: "date",
                until: "date"
            },
            ret: "NpsSmsSents"
        },
        listNpsSmsSent: {
            args: {
                placeIds: "string[]",
                date: "PeriodTime"
            },
            ret: "NpsSmsSent"
        },
        editSendSmsOnNpsForm: {
            args: {
                placeIds: "string[]",
                shouldSendSmsOnCheckout: "bool?",
                dailySmsLimit: "uint?"
            },
            ret: "SimpleNpsForm[]"
        },
        getCustomerAnswerDetails: {
            args: {
                userId: "string",
                eventId: "string"
            },
            ret: "AnswerDetails"
        },
        getNpsQuestionDetails: {
            args: {
                questionId: "QuestionType",
                placeIds: "string[]",
                since: "date",
                until: "date"
            },
            ret: "NpsQuestionDetails"
        },
        getAllOpenSalesByEmployee: {
            args: {
                eventId: "string",
                employeeId: "uuid"
            },
            ret: "OpenSale[]"
        },
        getAllOpenSalesAtPlaceByEmployee: {
            args: {
                placeId: "string",
                employeeId: "uuid",
                since: "datetime",
                until: "datetime"
            },
            ret: "OpenSale[]"
        },
        getOpenSaleReport: {
            args: {
                eventId: "string"
            },
            ret: "OpenSaleReport[]"
        },
        getOpenSaleReportAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "OpenSaleReport[]"
        },
        getReportMailsOfOrganization: {
            args: {
                organizationId: "string"
            },
            ret: "string[]"
        },
        editReportMailsInOrganization: {
            args: {
                organizationId: "string",
                reportMails: "string[]"
            },
            ret: "void"
        },
        createPaymentLink: {
            args: {
                placeId: "string",
                amount: "uint",
                installments: "uint?",
                paymentOrigin: "PaymentOrigin",
                description: "string"
            },
            ret: "CreatePaymentLinkResult"
        },
        listPaymentLinks: {
            args: {
                placeId: "string",
                page: "uint?",
                pageSize: "uint?",
                filter: "PaymentLinkFilter?"
            },
            ret: "PaymentLinkPage"
        },
        getAllRoles: {
            args: {},
            ret: "Role[]"
        },
        getPlaces: {
            args: {},
            ret: "Place[]"
        },
        checkPlaceConfig: {
            args: {
                placeId: "string"
            },
            ret: "bool"
        },
        getPlaceContractDetails: {
            args: {
                placeId: "string"
            },
            ret: "PlaceContractDetails"
        },
        getPlace: {
            args: {
                placeId: "string"
            },
            ret: "PlaceData"
        },
        editPlace: {
            args: {
                place: "NewPlace",
                image: "bytes?"
            },
            ret: "Place"
        },
        getPlaceFeatures: {
            args: {
                placeId: "string"
            },
            ret: "PlaceFeature[]"
        },
        activePlaceFeature: {
            args: {
                placeId: "string",
                featureId: "string"
            },
            ret: "void"
        },
        deactivePlaceFeature: {
            args: {
                placeId: "string",
                featureId: "string"
            },
            ret: "void"
        },
        setZigPlaceFeatures: {
            args: {
                placeId: "string",
                featureIds: "string[]"
            },
            ret: "void"
        },
        editPlacePassword: {
            args: {
                placeId: "string",
                pass: "string?"
            },
            ret: "void"
        },
        getPlacePassword: {
            args: {
                placeId: "string"
            },
            ret: "string?"
        },
        overridePlaceAccountId: {
            args: {
                placeId: "string",
                accountId: "string?"
            },
            ret: "void"
        },
        getOverridenPlaceAccount: {
            args: {
                placeId: "string"
            },
            ret: "BackofficeAccount?"
        },
        editPlaceEverestConfig: {
            args: {
                placeId: "string",
                config: "EverestConfig?"
            },
            ret: "void"
        },
        getPlaceEverestConfig: {
            args: {
                placeId: "string"
            },
            ret: "EverestConfig?"
        },
        getAllPlaces: {
            args: {},
            ret: "Place[]"
        },
        getPlacesWithFeatures: {
            args: {},
            ret: "PlaceWithFeatures[]"
        },
        getSimplifiedPlaces: {
            args: {},
            ret: "SimplifiedPlace[]"
        },
        getBeerTaps: {
            args: {
                placeId: "string"
            },
            ret: "BeerTap[]"
        },
        removeBeerTap: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        editBeerTap: {
            args: {
                tap: "BeerTap"
            },
            ret: "void"
        },
        createBeerTap: {
            args: {
                placeId: "string",
                tap: "BaseBeerTap"
            },
            ret: "void"
        },
        changeBeerTapStatus: {
            args: {
                id: "string",
                status: "bool"
            },
            ret: "void"
        },
        getPlacesResume: {
            args: {
                placeIds: "string[]",
                since: "date",
                until: "date"
            },
            ret: "PlacesResume"
        },
        getPlaceUsersByAverageTicket: {
            args: {
                placeIds: "string[]",
                since: "date",
                until: "date",
                filters: "AverageTicketFilter?"
            },
            ret: "UsersWithAverageTicket[]"
        },
        getPlaceMessageCost: {
            args: {
                placeId: "string",
                channel: "string"
            },
            ret: "uint"
        },
        getFichaExtraConfig: {
            args: {
                placeId: "string"
            },
            ret: "FichaExtraConfig"
        },
        alterFichaText: {
            args: {
                placeId: "string",
                str: "string?"
            },
            ret: "FichaExtraConfig"
        },
        alterFichaLogo: {
            args: {
                placeId: "string",
                data: "bytes?"
            },
            ret: "FichaExtraConfig"
        },
        alterPlaceImage: {
            args: {
                placeId: "string",
                image: "bytes?"
            },
            ret: "void"
        },
        getZigLocations: {
            args: {},
            ret: "ZigLocation[]"
        },
        getSimplifiedPlacesWhatsapp: {
            args: {},
            ret: "SimplifiedPlaceWhatsapp[]"
        },
        getPlaceSettingsGeneralSection: {
            args: {
                placeId: "uuid"
            },
            ret: "PlaceSettingsGeneralSectionResponse"
        },
        updatePlaceSettingsGeneralSection: {
            args: {
                placeId: "uuid",
                data: "PlaceSettingsGeneralSectionRequest"
            },
            ret: "PlaceSettingsGeneralSectionResponse"
        },
        getProductsAvailableToZigTag: {
            args: {
                placeId: "uuid"
            },
            ret: "ProductToZigTag[]"
        },
        getPlaceSettingsCouvertSection: {
            args: {
                placeId: "uuid"
            },
            ret: "PlaceSettingsCouvertSectionResponse"
        },
        updatePlaceSettingsCouvertSection: {
            args: {
                placeId: "uuid",
                data: "PlaceSettingsCouvertSectionRequest"
            },
            ret: "PlaceSettingsCouvertSectionResponse"
        },
        getPlaceSettingsPlaceFeatureSection: {
            args: {
                placeId: "uuid"
            },
            ret: "PlaceSettingsPlaceFeatureSectionResponse"
        },
        updatePlaceSettingsPlaceFeatureSection: {
            args: {
                placeId: "uuid",
                data: "PlaceSettingsPlaceFeatureSectionRequest"
            },
            ret: "PlaceSettingsPlaceFeatureSectionResponse"
        },
        getPlaceSettingsFichaSection: {
            args: {
                placeId: "string"
            },
            ret: "PlaceSettingsFichaSectionResponse"
        },
        updatePlaceSettingsFichaSection: {
            args: {
                placeId: "string",
                data: "PlaceSettingsFichaSectionRequest"
            },
            ret: "PlaceSettingsFichaSectionResponse"
        },
        getPlaceSettingsPdvSection: {
            args: {
                placeId: "uuid"
            },
            ret: "PlaceSettingsPdvSectionResponse"
        },
        updatePlaceSettingsPdvSection: {
            args: {
                placeId: "uuid",
                data: "PlaceSettingsPdvSectionRequest"
            },
            ret: "PlaceSettingsPdvSectionReturn"
        },
        getPlaceSettingsTotemSection: {
            args: {
                placeId: "uuid"
            },
            ret: "TotemPlaceConfigResponse"
        },
        updatePlaceSettingsTotemSection: {
            args: {
                placeId: "uuid",
                data: "TotemConfigsRequest"
            },
            ret: "TotemPlaceConfigResponse"
        },
        createFiscalPrinters: {
            args: {
                placeId: "string",
                fiscalPrinters: "FiscalPrinter[]"
            },
            ret: "FiscalPrintersResult"
        },
        listFiscalPrinters: {
            args: {
                placeId: "string"
            },
            ret: "FiscalPrinter[]?"
        },
        editFiscalPrinter: {
            args: {
                placeId: "string",
                oldFiscalPrinter: "FiscalPrinter",
                newFiscalPrinter: "FiscalPrinter"
            },
            ret: "FiscalPrinter[]"
        },
        deleteFiscalPrinters: {
            args: {
                placeId: "string",
                fiscalPrinters: "FiscalPrinter[]"
            },
            ret: "FiscalPrintersResult"
        },
        getPlaceDetail: {
            args: {
                placeId: "string"
            },
            ret: "PlaceDetail"
        },
        editPlaceDetail: {
            args: {
                placeId: "string",
                detail: "EditPlaceDetail"
            },
            ret: "PlaceDetail"
        },
        addImageToPlaceDetail: {
            args: {
                placeId: "string",
                data: "bytes"
            },
            ret: "PlaceDetailImage"
        },
        deletePlaceDetailImage: {
            args: {
                placeId: "string",
                imageId: "string"
            },
            ret: "void"
        },
        getPlaceDetailTags: {
            args: {
                placeId: "string"
            },
            ret: "PlaceDetailTag[]"
        },
        editPlaceDetailTags: {
            args: {
                placeId: "string",
                tags: "PlaceDetailTag[]"
            },
            ret: "PlaceDetailTag[]"
        },
        getWorkingDays: {
            args: {
                placeId: "string"
            },
            ret: "WorkingDays"
        },
        setWorkingDays: {
            args: {
                placeId: "string",
                days: "WorkingDays"
            },
            ret: "WorkingDays"
        },
        getAllBaseTags: {
            args: {},
            ret: "BaseTag[]"
        },
        setPlaceDetailStatus: {
            args: {
                placeId: "string",
                status: "bool"
            },
            ret: "PlaceDetail"
        },
        getPlaceDetailMusicTags: {
            args: {
                placeId: "string"
            },
            ret: "PlaceDetailMusicTag[]"
        },
        editPlaceDetailMusicTags: {
            args: {
                placeId: "string",
                musicTagIds: "PlaceDetailMusicTag[]"
            },
            ret: "PlaceDetailMusicTag[]"
        },
        getAllMusicBaseTags: {
            args: {},
            ret: "BaseMusicTag[]"
        },
        getPosMachineTransactions: {
            args: {
                placeId: "string",
                dates: "date[]",
                page: "uint",
                searchTerm: "string?",
                itemsPerPage: "uint?"
            },
            ret: "PaginationPosTransaction"
        },
        getConsolidatedPosMachineTransactions: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "PosMachineDayResume[]"
        },
        createPrechargeOperation: {
            args: {
                precharge: "BasePrechargeOperation",
                logo: "bytes?",
                mainImage: "bytes?"
            },
            ret: "PrechargeOperation"
        },
        getPrechargeOperationsForPlace: {
            args: {
                placeId: "uuid"
            },
            ret: "PrechargeOperation[]"
        },
        updatePrechargeOperationData: {
            args: {
                id: "uuid",
                precharge: "BasePrechargeOperation"
            },
            ret: "PrechargeOperation"
        },
        updatePrechargeOperationLogo: {
            args: {
                id: "uuid",
                logo: "bytes?"
            },
            ret: "PrechargeOperation"
        },
        updatePrechargeOperationMainImage: {
            args: {
                id: "uuid",
                mainImage: "bytes?"
            },
            ret: "PrechargeOperation"
        },
        deletePrecharge: {
            args: {
                id: "uuid"
            },
            ret: "void"
        },
        getPrechargeReport: {
            args: {
                operationId: "uuid"
            },
            ret: "PrechargeOperationReport"
        },
        getPrechargesByOperation: {
            args: {
                operationId: "uuid",
                pagination: "Pagination",
                filters: "PrechargesFilters"
            },
            ret: "PrechargeResponse"
        },
        createPrinters: {
            args: {
                placeId: "string",
                printers: "CreatePrinter[]"
            },
            ret: "PrintersResult"
        },
        getPrinters: {
            args: {
                placeId: "string",
                barId: "string"
            },
            ret: "Printer[]"
        },
        listPrinters: {
            args: {
                placeId: "string",
                barIds: "string[]"
            },
            ret: "ListPrinters[]"
        },
        editPrinters: {
            args: {
                placeId: "string",
                printers: "Printer[]"
            },
            ret: "PrintersResult"
        },
        deletePrinters: {
            args: {
                placeId: "string",
                barId: "string",
                printerIds: "string[]"
            },
            ret: "void"
        },
        activateProductInPlace: {
            args: {
                placeId: "string",
                productId: "string",
                activateMountableItems: "bool?"
            },
            ret: "void"
        },
        deactivateProductInPlace: {
            args: {
                placeId: "string",
                productId: "string",
                deactivateMountableItems: "bool?"
            },
            ret: "void"
        },
        updatePriceAtPlace: {
            args: {
                placeId: "string",
                productId: "string",
                value: "int"
            },
            ret: "void"
        },
        activateMountableSectionItem: {
            args: {
                placeId: "string",
                mountableSectionId: "string?",
                productId: "string",
                activateAllItems: "bool"
            },
            ret: "void"
        },
        deactivateMountableSectionItem: {
            args: {
                placeId: "string",
                mountableSectionId: "string?",
                productId: "string",
                deactivateAllItems: "bool"
            },
            ret: "void"
        },
        activateProductsInPlace: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "void"
        },
        deactivateProductsInPlace: {
            args: {
                placeId: "string",
                productIds: "string[]"
            },
            ret: "void"
        },
        addProductToPlace: {
            args: {
                placeId: "string",
                productId: "string",
                fiscalData: "NewPlaceProductFiscalData?",
                price: "uint?"
            },
            ret: "void"
        },
        removeProductFromPlace: {
            args: {
                placeId: "string",
                productId: "string"
            },
            ret: "void"
        },
        getProductsByPlace: {
            args: {
                place: "string"
            },
            ret: "Product[]"
        },
        addNewProductToOrganization: {
            args: {
                product: "NewProduct",
                image: "EditProductImage?"
            },
            ret: "OrganizationProduct"
        },
        addNewProductToOrganizationAndPlaces: {
            args: {
                product: "NewProduct",
                placesIds: "string[]",
                image: "EditProductImage?"
            },
            ret: "CreatedResults"
        },
        addNewProduct: {
            args: {
                product: "NewPlaceProductWithMountableDetails",
                placeId: "string",
                image: "EditProductImage?",
                isActive: "bool?"
            },
            ret: "PlaceProduct"
        },
        editProduct: {
            args: {
                id: "string",
                product: "NewProduct"
            },
            ret: "Product"
        },
        editProducts: {
            args: {
                products: "EditedProduct[]"
            },
            ret: "EditedResults"
        },
        editPlaceProduct: {
            args: {
                id: "string",
                product: "NewPlaceProductWithMountableDetails",
                placeId: "string",
                image: "EditProductImage?",
                isActive: "bool?"
            },
            ret: "PlaceProduct"
        },
        editProductAndPlaceProducts: {
            args: {
                placesIds: "string[]",
                product: "EditedProduct"
            },
            ret: "EditedResults"
        },
        editProductImage: {
            args: {
                id: "string",
                image: "EditProductImage",
                placeId: "string?"
            },
            ret: "string?"
        },
        deleteProduct: {
            args: {
                id: "string"
            },
            ret: "DeleteProductResult"
        },
        deleteMultipleProducts: {
            args: {
                productIds: "string[]",
                placeId: "string?"
            },
            ret: "DeleteMultipleProductsResult"
        },
        createSupply: {
            args: {
                supplies: "CreateSupply[]"
            },
            ret: "CreateSupplyResponse"
        },
        editSupply: {
            args: {
                id: "string",
                placeId: "string",
                name: "string",
                basicStorageUnit: "BasicStorageUnit",
                fiscalCode: "string?",
                yieldPercentage: "float?",
                image: "EditProductImage?",
                proportionOfUnit: "ProportionOfUnit?"
            },
            ret: "void"
        },
        getPlaceProduct: {
            args: {
                placeId: "string",
                productId: "string"
            },
            ret: "PlaceProduct"
        },
        getPlaceProducts: {
            args: {
                placeId: "string"
            },
            ret: "PlaceProduct[]"
        },
        getBarProducts: {
            args: {
                barId: "string"
            },
            ret: "BarProduct[]"
        },
        createSupplyWithProductionRule: {
            args: {
                placeId: "string",
                name: "string",
                image: "EditProductImage?",
                basicStorageUnit: "BasicStorageUnit",
                fiscalCode: "string?",
                yieldPercentage: "float?",
                productionRule: "SupplyProductionRule",
                proportionOfUnit: "ProportionOfUnit?"
            },
            ret: "SupplyWithProductionRule"
        },
        updateSupplyWithProductionRule: {
            args: {
                placeId: "string",
                supplyId: "string",
                name: "string",
                image: "EditProductImage?",
                basicStorageUnit: "BasicStorageUnit",
                fiscalCode: "string?",
                yieldPercentage: "float?",
                productionRule: "SupplyProductionRule",
                proportionOfUnit: "ProportionOfUnit?"
            },
            ret: "SupplyWithProductionRule?"
        },
        getSuppliesWithProductionRule: {
            args: {
                placeId: "string",
                supplyIds: "string[]?"
            },
            ret: "SupplyWithProductionRule[]"
        },
        getSupplyWithProductionRule: {
            args: {
                placeId: "string",
                supplyId: "string"
            },
            ret: "SupplyWithProductionRule"
        },
        deleteSupplyWithProductionRule: {
            args: {
                placeId: "string",
                supplyId: "string"
            },
            ret: "void"
        },
        removeProductionRulesFromSupplies: {
            args: {
                placeId: "string",
                supplyIds: "string[]"
            },
            ret: "RemoveProductionRulesFromSupplies"
        },
        getAllProducts: {
            args: {
                placeIds: "string[]?"
            },
            ret: "OrganizationProduct[]"
        },
        getAllProductsGroupedByCategory: {
            args: {},
            ret: "GroupedByCategoryOrganizationProduct[]"
        },
        getProduct: {
            args: {
                id: "string"
            },
            ret: "OrganizationProduct"
        },
        removePlaceProductProductionRule: {
            args: {
                productId: "string",
                placeId: "string"
            },
            ret: "void"
        },
        getProductionRuleFromProduct: {
            args: {
                productId: "string",
                placeId: "string"
            },
            ret: "ProductRule"
        },
        getProductionRuleFromProductWithResume: {
            args: {
                productId: "string",
                placeId: "string"
            },
            ret: "ProductRuleWithResume"
        },
        getProductsFromPlaceReportXls: {
            args: {
                placeId: "string"
            },
            ret: "string"
        },
        getPlaceProductsByType: {
            args: {
                placeId: "string",
                productType: "ProductType",
                productName: "string?",
                pagination: "Pagination?",
                orderBy: "GetPlaceProductsByTypeOrderBy?",
                order: "GetPlaceProductsByTypeOrder?"
            },
            ret: "PlaceProductsByTypeResponse"
        },
        exportPlaceProductsByType: {
            args: {
                placeId: "string",
                productType: "ProductType",
                productName: "string?",
                orderBy: "ExportPlaceProductsByTypeOrderBy?",
                order: "ExportPlaceProductsByTypeOrder?"
            },
            ret: "string"
        },
        editProductsThroughImport: {
            args: {
                products: "EditedProductThroughImport[]"
            },
            ret: "OrganizationProduct[]"
        },
        getGrabAndGoProducts: {
            args: {
                placeId: "string"
            },
            ret: "GrabAndGoProduct[]"
        },
        activateGrabAndGoProduct: {
            args: {
                placeId: "string",
                productId: "string"
            },
            ret: "void"
        },
        deactivateGrabAndGoProduct: {
            args: {
                placeId: "string",
                productId: "string"
            },
            ret: "void"
        },
        verifyPatchProducts: {
            args: {
                products: "PatchProduct[]",
                placeId: "string",
                type: "VerifyPatchProductsType?"
            },
            ret: "VerifyPatchProductsResult?"
        },
        patchProducts: {
            args: {
                products: "PatchProduct[]",
                placeId: "string",
                activeAllProducts: "bool?",
                skipMountableSections: "bool?"
            },
            ret: "string[]"
        },
        getPlaceProductsWithSections: {
            args: {
                placeId: "uuid",
                filters: "GetProductsWithSectionsRequest",
                pagination: "Pagination"
            },
            ret: "GetProductsWithSectionsWithProductsResponse"
        },
        getManyExternalStoreIntegrationCategoriesWithProducts: {
            args: {
                placeId: "uuid",
                menuId: "uuid"
            },
            ret: "GetManyExternalStoreIntegrationCategoriesResponse"
        },
        filterProductsAtPlaceByName: {
            args: {
                placeIds: "string[]",
                name: "string"
            },
            ret: "TinyProduct[]"
        },
        getCategoryProducts: {
            args: {
                placeId: "uuid",
                searchQuery: "string?",
                status: "ProductStatus?",
                categoryId: "uuid",
                categoryKind: "CategoryKind?"
            },
            ret: "CategoryProduct[]"
        },
        getAllCategoriesProducts: {
            args: {
                placeId: "uuid",
                searchQuery: "string?",
                status: "ProductStatus?",
                categoryKind: "CategoryKind?"
            },
            ret: "CategoryProduct[]"
        },
        migrateProductsFromCategory: {
            args: {
                placeId: "uuid",
                fromCategoryId: "uuid",
                toCategoryId: "uuid"
            },
            ret: "void"
        },
        patchProductsFields: {
            args: {
                placeId: "uuid",
                productsIds: "uuid[]",
                productFields: "PatchProductsFieldsProductFields"
            },
            ret: "void"
        },
        createProductFeature: {
            args: {
                productFeature: "BaseProductFeature"
            },
            ret: "ProductFeature"
        },
        getProductFeatures: {
            args: {
                productId: "string"
            },
            ret: "ProductFeature[]"
        },
        removeProductFeature: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        editProductFeature: {
            args: {
                productFeature: "ProductFeature"
            },
            ret: "ProductFeature"
        },
        changeProductFeatureStatus: {
            args: {
                id: "string",
                status: "bool"
            },
            ret: "void"
        },
        changeProductFeatureStatusByTemplateId: {
            args: {
                id: "string",
                status: "bool"
            },
            ret: "void"
        },
        removeProductFeaturesByTemplateId: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getUsableProductFeatures: {
            args: {
                productId: "string"
            },
            ret: "ProductFeature[]"
        },
        createProductFeatureTemplate: {
            args: {
                productFeatureTemplate: "BaseProductFeatureTemplate"
            },
            ret: "ProductFeatureTemplate"
        },
        getProductFeatureTemplates: {
            args: {
                organizationId: "string"
            },
            ret: "ProductFeatureTemplate[]"
        },
        removeProductFeatureTemplate: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        editProductFeatureTemplate: {
            args: {
                productFeatureTemplate: "ProductFeatureTemplate"
            },
            ret: "ProductFeatureTemplate"
        },
        changeProductFeatureTemplateStatus: {
            args: {
                id: "string",
                status: "bool"
            },
            ret: "ProductFeatureTemplate"
        },
        getUsableProductFeatureTemplates: {
            args: {
                organizationId: "string"
            },
            ret: "ProductFeatureTemplate[]"
        },
        getZigProductFeatureTemplates: {
            args: {},
            ret: "ProductFeatureTemplate[]"
        },
        getPlacePromoters: {
            args: {
                placeId: "string"
            },
            ret: "PlacePromoter[]"
        },
        getPendingPromoters: {
            args: {
                placeId: "string"
            },
            ret: "PlacePromoter[]"
        },
        cancelPromoterInvitation: {
            args: {
                placeId: "string",
                email: "string"
            },
            ret: "void"
        },
        invitePromoters: {
            args: {
                placeId: "string",
                emails: "string[]"
            },
            ret: "void"
        },
        activatePromoter: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "PlacePromoter"
        },
        deactivatePromoter: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "PlacePromoter"
        },
        editPromoterInPlace: {
            args: {
                placeId: "string",
                promoterId: "string",
                promoter: "EditPromoterPlace"
            },
            ret: "PlacePromoter"
        },
        getPromoterRoles: {
            args: {},
            ret: "PromoterRoles[]"
        },
        createPromotion: {
            args: {
                promotion: "NewPromotion"
            },
            ret: "Promotion"
        },
        deletePromotion: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        getPromotions: {
            args: {
                placeId: "string"
            },
            ret: "Promotion[]"
        },
        getPromotion: {
            args: {
                promotionId: "string"
            },
            ret: "Promotion"
        },
        editPromotion: {
            args: {
                promotionId: "string",
                promotion: "NewPromotion"
            },
            ret: "Promotion"
        },
        togglePromotion: {
            args: {
                promotionId: "string",
                isActive: "bool"
            },
            ret: "Promotion"
        },
        getPromotionUsers: {
            args: {
                promotionId: "string"
            },
            ret: "PromotionUser[]"
        },
        givePromotionToManyUsers: {
            args: {
                promotionId: "string",
                cpfPhones: "CpfOrPhone[]"
            },
            ret: "MultipleUserPromotionResult"
        },
        removePromotionFromManyUsers: {
            args: {
                promotionId: "string",
                userIds: "string[]"
            },
            ret: "void"
        },
        listRefundReasons: {
            args: {
                placeId: "string"
            },
            ret: "RefundReason[]"
        },
        createRefundReasons: {
            args: {
                placeId: "string",
                refundReasons: "CreateRefundReason[]"
            },
            ret: "RefundReasonResult"
        },
        editRefundReasons: {
            args: {
                placeId: "string",
                refundReasons: "EditRefundReason[]"
            },
            ret: "RefundReasonResult"
        },
        deleteRefundReasons: {
            args: {
                placeId: "string",
                refundReasonIds: "string[]"
            },
            ret: "void"
        },
        createRelation: {
            args: {
                relation: "NewRelation"
            },
            ret: "Relation"
        },
        editRelation: {
            args: {
                id: "string",
                relation: "NewRelation"
            },
            ret: "Relation"
        },
        deleteRelation: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        deleteMultipleRelation: {
            args: {
                id: "string[]"
            },
            ret: "void"
        },
        getRelations: {
            args: {
                placeId: "string",
                eventId: "string?"
            },
            ret: "Relation[]"
        },
        activeOrDeactiveRelation: {
            args: {
                id: "string",
                isActive: "bool"
            },
            ret: "void"
        },
        importRelation: {
            args: {
                relationIds: "string[]",
                placeId: "string",
                eventId: "string"
            },
            ret: "ImportRelationResponse"
        },
        getRelationUsers: {
            args: {
                relationId: "string"
            },
            ret: "RelationUser[]"
        },
        addRelationUser: {
            args: {
                relationId: "string",
                user: "NewRelationUser"
            },
            ret: "RelationUser[]"
        },
        deleteRelationUser: {
            args: {
                relationId: "string",
                relationUserId: "string"
            },
            ret: "void"
        },
        addMultipleRelationUser: {
            args: {
                relationId: "string",
                users: "NewRelationUser[]"
            },
            ret: "MultipleRelationUser"
        },
        deleteMultipleRelationUser: {
            args: {
                relationId: "string",
                relationUserIds: "string[]"
            },
            ret: "void"
        },
        editRelationUser: {
            args: {
                relationId: "string",
                relationUserId: "string",
                user: "NewRelationUser"
            },
            ret: "RelationUser[]"
        },
        getRelationReportByPromoters: {
            args: {
                placeId: "string",
                eventId: "string?",
                promoters: "string[]",
                relationIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "RelationPromoters[]"
        },
        getRelationReportByLists: {
            args: {
                placeId: "string",
                eventId: "string?",
                promoters: "string[]",
                relationIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "RelationReport[]"
        },
        getPromoters: {
            args: {
                placeId: "string",
                eventId: "string?",
                since: "datetime",
                until: "datetime"
            },
            ret: "string[]"
        },
        getRelationLists: {
            args: {
                placeId: "string",
                eventId: "string?",
                since: "datetime",
                until: "datetime"
            },
            ret: "Relation[]"
        },
        getRelationReportOverview: {
            args: {
                placeId: "string",
                eventId: "string?",
                promoters: "string[]",
                relationIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "RelationDataOverview"
        },
        getRelationReportGuests: {
            args: {
                placeId: "string",
                eventId: "string?",
                promoters: "string[]",
                relationIds: "string[]",
                since: "datetime",
                until: "datetime",
                pagination: "Pagination"
            },
            ret: "GuestReportResponse"
        },
        getPlaceEmployeeReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "EmployeeReport"
        },
        getFinanceBiReport: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "FinanceBiReport"
        },
        getConsumptionTimeLineAtPlaceBy30Min: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "BiConsumptionTimeline[]"
        },
        getConsumptionTimeLineAtPlaceBy30MinByDay: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "BiConsumptionTimeline[]"
        },
        getConsumptionTimeLineAtOrganizationBy30MinByDay: {
            args: {
                placesId: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "OrgConsumptionTimeline[]"
        },
        getClientsBiReport: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ClientByReport"
        },
        getProductsBiReport: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ProductBiReport[]"
        },
        getReportIdForLoggedOrganization: {
            args: {},
            ret: "string"
        },
        getReportPdvZigCardErrors: {
            args: {
                eventId: "string",
                pagination: "Pagination",
                filters: "ReportPdvZigCardFilters"
            },
            ret: "ReportPdvZigCardReport"
        },
        getProductsSoldReportV2: {
            args: {
                filters: "ProductsSoldReportV2Filters"
            },
            ret: "ProductsSoldReportV2Row[]"
        },
        requestExportProductsSoldReportV2: {
            args: {
                filters: "ProductsSoldReportV2Filters",
                format: "ReportExportFormat",
                email: "string"
            },
            ret: "void"
        },
        getKdsProductsReport: {
            args: {
                filters: "KdsProductsReportFilters"
            },
            ret: "KdsProductsReportRow[]"
        },
        requestExportKdsProductsReport: {
            args: {
                filters: "KdsProductsReportFilters",
                format: "ReportExportFormat",
                email: "string"
            },
            ret: "void"
        },
        getDetailedTransactionsReport: {
            args: {
                filters: "DetailedTransactionsReportFilters",
                pagination: "Pagination"
            },
            ret: "DetailedTransactionsReportResponse"
        },
        getDetailedTransactionsReportTotals: {
            args: {
                filters: "DetailedTransactionsReportFilters"
            },
            ret: "DetailedTransactionsReportTotals"
        },
        requestExportDetailedTransactionsReport: {
            args: {
                filters: "DetailedTransactionsReportFilters",
                format: "ReportExportFormat",
                email: "string"
            },
            ret: "void"
        },
        getKdsOrdersReport: {
            args: {
                filters: "KdsOrdersReportFilters",
                pagination: "Pagination"
            },
            ret: "KdsOrdersReportResponse"
        },
        requestExportKdsOrdersReport: {
            args: {
                filters: "KdsOrdersReportFilters",
                format: "ReportExportFormat",
                email: "string"
            },
            ret: "void"
        },
        getRetrospective: {
            args: {
                year: "uint",
                placeIds: "string[]"
            },
            ret: "json"
        },
        createReserve: {
            args: {
                eventId: "string",
                reserve: "NewReserve"
            },
            ret: "string"
        },
        deleteReserve: {
            args: {
                reserveId: "string"
            },
            ret: "void"
        },
        updateReserve: {
            args: {
                reserveId: "string",
                reserve: "NewReserve"
            },
            ret: "void"
        },
        getReserves: {
            args: {
                eventId: "string"
            },
            ret: "Reserve[]"
        },
        getReserveDetail: {
            args: {
                reserveId: "string"
            },
            ret: "ReserveDetail"
        },
        getReserveDiscountDetails: {
            args: {
                reserveId: "string"
            },
            ret: "ReserveDiscountDetail[]"
        },
        getReserveReportAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ReserveReportRow[]"
        },
        getReserveReportAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ReserveReportRow[]"
        },
        getReserveReportDetail: {
            args: {
                reserveId: "string"
            },
            ret: "ReserveReportDetails"
        },
        createReserveTemplate: {
            args: {
                reserveTemplate: "NewReserveTemplate"
            },
            ret: "string"
        },
        getReserveTemplates: {
            args: {
                placeId: "string",
                pagination: "Pagination"
            },
            ret: "ReserveTemplate[]"
        },
        deleteReserveTemplate: {
            args: {
                reserveTemplateId: "string"
            },
            ret: "void"
        },
        getProductsAtStorage: {
            args: {
                placeId: "string?",
                storageId: "string",
                filters: "GetProductsAtStorageFilters"
            },
            ret: "StorageProduct[]"
        },
        getAllBackofficeStorages: {
            args: {
                organizationId: "string"
            },
            ret: "BackofficeStorage[]"
        },
        getBackofficeProductStorageHistoryXls: {
            args: {
                placeId: "string",
                storageId: "string",
                productId: "string",
                filterBy: "GetBackofficeProductStorageHistoryXlsFilterBy?",
                since: "datetime",
                until: "datetime"
            },
            ret: "string"
        },
        createStorageAlerts: {
            args: {
                placeId: "string",
                alerts: "NewProductAlert[]"
            },
            ret: "ResultCreateProductRule"
        },
        editStorageAlerts: {
            args: {
                placeId: "string",
                alerts: "EditProductAlert[]"
            },
            ret: "ResultEditProductRule"
        },
        deleteStorageAlerts: {
            args: {
                placeId: "string",
                ids: "string[]"
            },
            ret: "void"
        },
        getStorageAlerts: {
            args: {
                placeId: "string"
            },
            ret: "ProductAlert[]"
        },
        addEmailToMinimumStorageAlert: {
            args: {
                placeId: "string",
                users: "UserAlert[]"
            },
            ret: "void"
        },
        removeEmailToMinimumStorageAlert: {
            args: {
                placeId: "string",
                emails: "string[]"
            },
            ret: "void"
        },
        getEmailsToMinimumStorageAlert: {
            args: {
                placeId: "string"
            },
            ret: "UserAlert[]"
        },
        hasCentralStorage: {
            args: {
                organizationId: "string"
            },
            ret: "bool"
        },
        getProductsWithoutRetroUnitCostFilled: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ProductWithoutCostAtStorage[]"
        },
        updateProductsWithoutUnitCostOnSells: {
            args: {
                placeId: "string",
                products: "UpdatedProductWithoutCostAtStorage[]"
            },
            ret: "void"
        },
        exportProductsWithoutUnitCostOnSells: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "string"
        },
        getBackofficeProductionHistoryForProducts: {
            args: {
                placeId: "string",
                query: "string?",
                since: "datetime?",
                until: "datetime?",
                page: "uint?",
                itemsPerPage: "uint?",
                orderBy: "GetBackofficeProductionHistoryForProductsOrderBy?",
                order: "GetBackofficeProductionHistoryForProductsOrder?"
            },
            ret: "BackofficeProductionHistoryResult"
        },
        getBackofficeProduction: {
            args: {
                placeId: "string",
                productionId: "string"
            },
            ret: "Production"
        },
        exportBackofficeProductionHistoryForProducts: {
            args: {
                placeId: "string",
                query: "string?",
                since: "datetime?",
                until: "datetime?",
                orderBy: "ExportBackofficeProductionHistoryForProductsOrderBy?",
                order: "ExportBackofficeProductionHistoryForProductsOrder?"
            },
            ret: "string"
        },
        getProfitMarginReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                productName: "string?",
                categoryName: "string?"
            },
            ret: "ProfitMarginReportResult"
        },
        exportProfitMarginReport: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                productName: "string?",
                categoryName: "string?"
            },
            ret: "string"
        },
        getStoragesTransfersHistory: {
            args: {
                placeId: "string",
                filters: "GetStoragesTransfersHistoryByContextFilters"
            },
            ret: "StorageTransferHistoryResult"
        },
        exportStoragesTransfersHistory: {
            args: {
                placeId: "string",
                filters: "BaseGetStoragesTransfersHistoryByContextFilters"
            },
            ret: "string"
        },
        getBackofficeTransfersBetweenStorages: {
            args: {
                placeId: "string",
                orderBy: "GetBackofficeTransfersBetweenStoragesOrderBy?",
                order: "GetBackofficeTransfersBetweenStoragesOrder?",
                filters: "GetBackofficeTransfersBetweenStoragesFilters"
            },
            ret: "BackofficeTransfersBetweenStoragesResult"
        },
        exportBackofficeTransfersBetweenStorages: {
            args: {
                placeId: "string",
                orderBy: "ExportBackofficeTransfersBetweenStoragesOrderBy?",
                order: "ExportBackofficeTransfersBetweenStoragesOrder?",
                filters: "BaseGetBackofficeTransfersBetweenStoragesFilters"
            },
            ret: "string"
        },
        exportLostReport: {
            args: {
                placeId: "string",
                storageIds: "string[]?",
                since: "datetime",
                until: "datetime"
            },
            ret: "string"
        },
        exportBackofficeProductsStoragesHistory: {
            args: {
                placeId: "string",
                storageIds: "string[]",
                productIds: "string[]",
                filterBy: "BackofficeProductStorageHistoryFilterBy?",
                since: "datetime",
                until: "datetime"
            },
            ret: "string"
        },
        getTableBarRanges: {
            args: {
                placeId: "string"
            },
            ret: "TableBarRangeResponse[]"
        },
        addTableBarRange: {
            args: {
                placeId: "string",
                range: "BaseTableBarRange"
            },
            ret: "TableBarRangeResponse[]"
        },
        editTableBarRange: {
            args: {
                id: "string",
                range: "BaseTableBarRange"
            },
            ret: "TableBarRangeResponse[]"
        },
        deleteRange: {
            args: {
                id: "string"
            },
            ret: "TableBarRangeResponse[]"
        },
        getTableMapByEnvironmentAndStatus: {
            args: {
                placeId: "string",
                filters: "TableMapFilters?",
                pagination: "Pagination"
            },
            ret: "GetTablesByEnvironmentAndStatusResponse"
        },
        getTableMapOverview: {
            args: {
                placeId: "string"
            },
            ret: "TableMapOverview"
        },
        getEntrancesSoldAtEventInPeriod: {
            args: {
                eventId: "string",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "EntranceSold[]"
        },
        getProductsSoldAtEventInPeriod: {
            args: {
                eventId: "string",
                since: "datetime?",
                until: "datetime?",
                sources: "TransactionSource[]?"
            },
            ret: "ProductSold[]"
        },
        getProductsSoldAtEventInPeriodV2: {
            args: {
                eventId: "string?",
                placeId: "string?",
                since: "datetime?",
                until: "datetime?",
                sources: "TransactionSource[]?"
            },
            ret: "ProductSoldV2[]"
        },
        getUser: {
            args: {
                placeId: "string",
                cpf: "string?",
                phone: "string?"
            },
            ret: "User"
        },
        getUserAtEvent: {
            args: {
                eventId: "string",
                filter: "UserFilter"
            },
            ret: "User"
        },
        getUserDetailsAtEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "UserDetails"
        },
        getUserDetailsAtPlace: {
            args: {
                placeId: "string",
                userId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "UserDetails"
        },
        editUserDetails: {
            args: {
                userId: "string",
                user: "EditUser"
            },
            ret: "void"
        },
        getUserRechargesInEvent: {
            args: {
                userId: "string",
                eventId: "string"
            },
            ret: "UserRecharge[]"
        },
        giveRechargeToUsers: {
            args: {
                eventId: "string",
                recharges: "NewUserRecharge[]",
                prioritizeDigitalCardOnRecharge: "bool?"
            },
            ret: "GiveRechargeError[]"
        },
        giveRechargeToUser: {
            args: {
                placeId: "string",
                recharge: "NewUserRecharge",
                documentType: "UserDocumentType?",
                prioritizeDigitalCardOnRecharge: "bool?"
            },
            ret: "void"
        },
        giveRechargeToInternationalUsers: {
            args: {
                eventId: "string",
                recharges: "InternationalUserRecharge[]",
                prioritizeDigitalCardOnRecharge: "bool?"
            },
            ret: "GiveRechargeError[]?"
        },
        getAllUsersAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "EventUser[]"
        },
        getEventUserAtEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "EventUser"
        },
        getClientsAtPlaceWithFilter: {
            args: {
                placeId: "string",
                filters: "SearchFilters",
                pagination: "Pagination?"
            },
            ret: "ClientsAtPlaceResponse?"
        },
        getClientsAtPlaceWithFilterXls: {
            args: {
                placeId: "string",
                filters: "SearchFilters"
            },
            ret: "string"
        },
        getUserByCpf: {
            args: {
                placeId: "string",
                cpf: "string"
            },
            ret: "SearchResult?"
        },
        getUserByName: {
            args: {
                placeId: "uuid",
                name: "string",
                limit: "uint"
            },
            ret: "SearchResult[]"
        },
        getUsersFromProducts: {
            args: {
                placeId: "string",
                productIds: "string[]",
                period: "PeriodTime",
                limit: "uint",
                offset: "uint"
            },
            ret: "SearchResult[]"
        },
        getUsersFromProductsXls: {
            args: {
                placeId: "string",
                productIds: "string[]",
                period: "PeriodTime",
                limit: "uint",
                offset: "uint"
            },
            ret: "string"
        },
        getUserDetailsPastBills: {
            args: {
                placeId: "string",
                userId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "UserDetailsByEvents[]"
        },
        getClientsAtMultiplePlaceWithFilter: {
            args: {
                placeIds: "string[]",
                filters: "ClientSearchFilters",
                offset: "uint"
            },
            ret: "ClientSearchResult[]"
        },
        getClientsAtMultiplePlaceWithFilterXls: {
            args: {
                placeIds: "string[]",
                filters: "ClientSearchFilters"
            },
            ret: "string"
        },
        getUserConsolidatedHistoryInEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "ConsolidatedHistory"
        },
        getUserConsolidatedHistoryInPlace: {
            args: {
                placeId: "string",
                userId: "string",
                since: "date",
                until: "date"
            },
            ret: "ConsolidatedHistory[]"
        },
        getUserConsolidatedHistoryInOrganization: {
            args: {
                placeIds: "string[]",
                userId: "string",
                since: "date",
                until: "date"
            },
            ret: "ConsolidatedHistory[]"
        },
        getUserCompleteHistoryInEvent: {
            args: {
                eventId: "string",
                userId: "string"
            },
            ret: "UserEventHistory"
        },
        getUserCompleteHistoryInPlace: {
            args: {
                placeId: "string",
                userId: "string",
                since: "date",
                until: "date"
            },
            ret: "UserEventHistory[]"
        },
        getUserCompleteHistoryInOrganization: {
            args: {
                placeIds: "string[]",
                userId: "string",
                since: "date",
                until: "date"
            },
            ret: "UserEventHistory[]"
        },
        getUserTransaction: {
            args: {
                id: "string",
                userId: "string"
            },
            ret: "UserTransactionResponse"
        },
        getUserSingleProductReturn: {
            args: {
                id: "string"
            },
            ret: "UserTransactionResponse"
        },
        getUserRefundTransaction: {
            args: {
                id: "string"
            },
            ret: "UserRefundTransaction"
        },
        getUserPostPayment: {
            args: {
                id: "string"
            },
            ret: "PostPaymentWithPastBill"
        },
        getOpenedBillsForClient: {
            args: {
                userId: "string",
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ClientOpenedBill[]"
        },
        getBonusForClient: {
            args: {
                userId: "string",
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ClientBonus[]"
        },
        getDiscountForClient: {
            args: {
                userId: "string",
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ClientDiscount[]"
        },
        payOpenedBillAtEventWithUserBalance: {
            args: {
                userId: "string",
                eventId: "string"
            },
            ret: "void"
        },
        getClientTransactionTransferProducts: {
            args: {
                transactionId: "string"
            },
            ret: "ClientTransferTransactionDetails[]"
        },
        getClientOnlineFichaHistoryAtEvent: {
            args: {
                userId: "string",
                eventId: "string"
            },
            ret: "ClientOnlineFichaHistory[]"
        },
        refundAppSell: {
            args: {
                transactionId: "string",
                reason: "string",
                shouldReturnToStorage: "bool"
            },
            ret: "void"
        },
        getSuggestedImages: {
            args: {
                keyword: "string"
            },
            ret: "string[]"
        },
        getAllOfflineActionTypes: {
            args: {},
            ret: "AllOfflineActionTypes[]"
        },
        getVendors: {
            args: {},
            ret: "VendorOrg[]"
        },
        getVendorsForPlace: {
            args: {
                placeId: "string"
            },
            ret: "VendorOrg[]"
        },
        deleteVendor: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        setVendorFeatures: {
            args: {
                vendorId: "uuid",
                features: "string[]"
            },
            ret: "void"
        },
        getVendorFeatures: {
            args: {
                vendorId: "string"
            },
            ret: "VendorFeature[]"
        },
        getVendorProductFees: {
            args: {
                id: "string"
            },
            ret: "VendorProductFee[]"
        },
        editVendorProductFees: {
            args: {
                id: "string",
                fees: "VendorProductFee[]"
            },
            ret: "VendorProductFee[]"
        },
        getVendorClosingsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "VendorClosing[]"
        },
        getVendorClosings: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "VendorClosing[]"
        },
        getVendorProductSoldAtEvent: {
            args: {
                vendorId: "string",
                eventId: "string"
            },
            ret: "ProductSold[]"
        },
        getVendorProductSold: {
            args: {
                vendorId: "string",
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ProductSold[]"
        },
        getVendorsRevenuesAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "VendorRevenue[]"
        },
        getVendorsRevenues: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "VendorRevenue[]"
        },
        createAdjustmentInVendorExtract: {
            args: {
                adjust: "VendorFinancialAdjustDto"
            },
            ret: "void"
        },
        createAdjustmentsInVendorExtract: {
            args: {
                placeId: "string",
                adjusts: "VendorFinancialAdjustDto[]"
            },
            ret: "void"
        },
        getVendorExtractAdjustments: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "VendorFinancialAdjustResponse[]"
        },
        revertVendorWithdrawRequest: {
            args: {
                placeId: "string",
                withdrawId: "string",
                reason: "string"
            },
            ret: "void"
        },
        getOpenVendorWithdrawRequests: {
            args: {
                placeId: "string",
                period: "PeriodTime?"
            },
            ret: "VendorWithdrawalRequestResponse[]"
        },
        payVendorWithdrawRequest: {
            args: {
                placeId: "string",
                withdrawId: "string",
                methodType: "VendorWithdrawRequestMethod",
                attachments: "Attachment[]?",
                obs: "string?"
            },
            ret: "void"
        },
        payVendorWithdrawRequests: {
            args: {
                placeId: "string",
                withdrawIds: "string[]",
                methodType: "VendorWithdrawRequestMethod",
                obs: "string?",
                attachments: "Attachment[]?"
            },
            ret: "void"
        },
        getVendorWithdrawRequestsHistory: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "VendorWithdrawRequestHistoryResponse[]"
        },
        getExtractOfValuesOwedToTheVendors: {
            args: {
                placeId: "string"
            },
            ret: "GetExtractOfValuesOwedToTheVendors"
        },
        getVendorDebtors: {
            args: {
                vendorId: "uuid",
                since: "date",
                until: "date",
                placeId: "uuid"
            },
            ret: "VendorDebtor[]"
        },
        getZigTagBlockConfirmsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ZigTagBlockConfirm[]"
        },
        getZigTagBlockConfirmsAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "ZigTagBlockConfirm[]"
        },
        getZigTagSyncForcesAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ZigTagSyncForce[]"
        },
        getZigTagSyncForcesAtPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime"
            },
            ret: "ZigTagSyncForce[]"
        },
        getZigTag: {
            args: {
                eventId: "string",
                zigCode: "string"
            },
            ret: "ZigTag"
        },
        blockZigDeviceIfPossible: {
            args: {
                id: "string",
                eventId: "string"
            },
            ret: "void"
        },
        blockZigDeviceByZigCodes: {
            args: {
                zigCodes: "string[]",
                placeId: "string"
            },
            ret: "void"
        },
        unblockZigDeviceByZigCodes: {
            args: {
                zigCodes: "string[]",
                placeId: "string"
            },
            ret: "void"
        },
        createZigDeviceGroup: {
            args: {
                placeId: "string",
                name: "string"
            },
            ret: "ZigDeviceGroup"
        },
        getZigDevicesWithGroups: {
            args: {
                placeId: "string"
            },
            ret: "ZigDeviceWithGroupAndBalance[]"
        },
        getZigDeviceGroupsByPlace: {
            args: {
                placeId: "string"
            },
            ret: "ZigDeviceGroup[]"
        },
        editZigDeviceGroupOfZigDevices: {
            args: {
                zigCodes: "string[]",
                zigDeviceGroupId: "string?"
            },
            ret: "void"
        },
        getMessages: {
            args: {
                page: "uint",
                limit: "uint",
                campaignIds: "string[]?"
            },
            ret: "Message[]"
        },
        cancelMessage: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        editMessageClients: {
            args: {
                id: "string",
                clients: "MessageClient[]"
            },
            ret: "MessageClientInsertResponse[]"
        },
        getMessageClients: {
            args: {
                id: "string",
                page: "uint",
                limit: "uint"
            },
            ret: "MessageClient[]"
        },
        getMessageClientData: {
            args: {
                placeId: "string",
                userIds: "string[]"
            },
            ret: "MessageClientDataForPlace[]"
        },
        createMessage: {
            args: {
                message: "NewMessage"
            },
            ret: "Message"
        },
        getSentMessageClients: {
            args: {
                id: "string",
                page: "uint",
                limit: "uint"
            },
            ret: "SentMessageClient[]"
        },
        getMessageExamples: {
            args: {
                placeId: "string"
            },
            ret: "string[]"
        },
        getMessage: {
            args: {
                id: "string"
            },
            ret: "Message"
        },
        editMessage: {
            args: {
                id: "string",
                campaign: "EditMessage"
            },
            ret: "Message"
        },
        getSentMessageClientsResume: {
            args: {
                messageId: "string",
                channel: "string"
            },
            ret: "MessageSentResume"
        },
        createMessageCampaign: {
            args: {
                name: "string"
            },
            ret: "MessageCampaign"
        },
        fetchMessagesCampaign: {
            args: {
                id: "string?",
                name: "string?"
            },
            ret: "MessageCampaign[]"
        },
        createMessageTemplate: {
            args: {
                messageTemplate: "MessageTemplate"
            },
            ret: "MessageTemplateResponse"
        },
        updateMessageTemplate: {
            args: {
                id: "string",
                messageTemplate: "MessageTemplate"
            },
            ret: "MessageTemplateResponse"
        },
        updateStatusMessageTemplate: {
            args: {
                id: "string",
                status: "MessageTemplateStatus"
            },
            ret: "MessageTemplateResponse"
        },
        getMessageTemplate: {
            args: {
                id: "string"
            },
            ret: "MessageTemplateResponse"
        },
        fetchMessageTemplate: {
            args: {
                placeId: "string"
            },
            ret: "MessageTemplateResponse[]"
        },
        fetchMessageTemplateTwilio: {
            args: {},
            ret: "void"
        },
        updateMessageTemplateTwilio: {
            args: {},
            ret: "void"
        },
        setMessageTemplateTwilioIsUsed: {
            args: {
                id: "string"
            },
            ret: "MessageTemplateResponse"
        },
        getCampaignsInvestment: {
            args: {
                placeIds: "string[]",
                since: "datetime",
                until: "datetime"
            },
            ret: "CampaignsInvestmentResult"
        },
        sendMessageCronJob: {
            args: {},
            ret: "void"
        },
        getMessagesSentAnalytics: {
            args: {
                filters: "MessagesSentAnalyticsFilters"
            },
            ret: "MessagesSentAnalytics"
        },
        getMessagesSentList: {
            args: {
                filters: "MessagesSentAnalyticsFilters",
                pagination: "Pagination"
            },
            ret: "MessagesSentListResult"
        },
        requestExportMessagesSent: {
            args: {
                filters: "MessagesSentAnalyticsFilters",
                format: "ReportExportFormat",
                email: "string"
            },
            ret: "void"
        },
        getBackofficeNewChartAccountCode: {
            args: {
                chartAccountParentId: "string?"
            },
            ret: "string"
        },
        createBackOfficeChartAccount: {
            args: {
                chartAccount: "BackOfficeChartAccountCreate"
            },
            ret: "BackOfficeChartAccountResponse"
        },
        updateBackOfficeChartAccount: {
            args: {
                chartAccountId: "string",
                chartAccount: "BackOfficeChartAccountUpdate"
            },
            ret: "BackOfficeChartAccountResponse"
        },
        deleteBackOfficeChartAccount: {
            args: {
                chartAccountId: "string"
            },
            ret: "void"
        },
        getBackOfficeChartAccountTree: {
            args: {},
            ret: "BackOfficeChartAccountResponseTree[]"
        },
        getBackOfficeChartAccount: {
            args: {
                id: "string"
            },
            ret: "BackOfficeChartAccountResponse"
        },
        importBackofficeChartAccountXlsx: {
            args: {
                file: "bytes"
            },
            ret: "BackOfficeChartAccountResponse[]"
        },
        exportBackofficeDefaultChartAccountXlsx: {
            args: {},
            ret: "string"
        },
        exportBackofficeChartAccount: {
            args: {},
            ret: "bytes"
        },
        setBackOfficeDefaultChartAccountToOrganization: {
            args: {},
            ret: "json"
        },
        getBackofficeChartAccounts: {
            args: {
                operation: "BackOfficeOperationChartAccount?",
                acceptTransactions: "bool?",
                isDre: "bool?",
                isCashflow: "bool?"
            },
            ret: "BackOfficeChartAccountResponse[]"
        },
        getBackofficeAvailableChartAccountsForImportedInvoices: {
            args: {},
            ret: "BackOfficeChartAccountResponse[]"
        },
        getBackOfficeChartAccountTreeDefault: {
            args: {},
            ret: "json"
        },
        updateBackofficeChartAccountDefaultList: {
            args: {
                organizationId: "string"
            },
            ret: "void"
        },
        getBackofficeChartAccountsAsTree: {
            args: {
                searchTerm: "string?",
                operation: "BackOfficeOperationChartAccount?",
                acceptTransactions: "bool?",
                isDre: "bool?",
                isCashflow: "bool?"
            },
            ret: "BackOfficeChartAccountTree[]"
        },
        getBackofficeAccountV2: {
            args: {
                placeId: "uuid",
                accountId: "uuid"
            },
            ret: "BackofficeAccountV2"
        },
        getBackofficeAccountsV2: {
            args: {
                placeId: "uuid",
                showDeleted: "bool?"
            },
            ret: "BackofficeAccountV2[]"
        },
        createBackofficeAccountV2: {
            args: {
                placeId: "uuid",
                account: "BackofficeBaseAccountV2"
            },
            ret: "void"
        },
        updateBackofficeAccount: {
            args: {
                placeId: "uuid",
                accountId: "uuid",
                account: "BackofficeBaseAccountV2"
            },
            ret: "void"
        },
        deleteBackofficeAccountV2: {
            args: {
                placeId: "uuid",
                accountId: "uuid"
            },
            ret: "void"
        },
        createBackofficeAccountBills: {
            args: {
                placeId: "string",
                account: "BackofficeBaseAccountBills"
            },
            ret: "BackofficeGetAccountBillsResponse"
        },
        getBackofficeAccountBills: {
            args: {
                placeId: "string",
                id: "string",
                type: "BackofficeTypeAccountBills"
            },
            ret: "BackofficeGetAccountBillsResponse?"
        },
        getBackofficeAccountsBills: {
            args: {
                placeId: "string",
                params: "BackofficeGetParamsAccountsBills"
            },
            ret: "BackofficeGetAccountBillsResponseWithPagination"
        },
        getBackofficeResumeAccounts: {
            args: {
                params: "BackofficeGetParamsAccountsBills"
            },
            ret: "BackofficeGetResumeAccountBillsResponse"
        },
        deleteBackofficeAccountBills: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "bool"
        },
        updateBackofficeAccountBills: {
            args: {
                id: "string",
                placeId: "string",
                account: "BackofficeBaseAccountBills"
            },
            ret: "BackofficeGetAccountBillsResponse"
        },
        getBackofficeAccountBillsRecurrences: {
            args: {
                placeId: "string",
                recurringGroupId: "string",
                type: "BackofficeTypeAccountBills"
            },
            ret: "BackofficeGetAccountBillsResponse[]"
        },
        createBackofficeAccountBillAttachment: {
            args: {
                placeId: "string",
                accountBillId: "string",
                attachment: "BackofficeAttachment"
            },
            ret: "bool"
        },
        deleteBackofficeAccountBillAttachment: {
            args: {
                placeId: "string",
                accountBillId: "string",
                attachmentId: "string"
            },
            ret: "bool"
        },
        getBackofficeDRE: {
            args: {
                placeId: "string",
                interval: "BackofficeParamDates"
            },
            ret: "BackofficeAccountBillsReportResponse?"
        },
        setBackofficeAccountBillIsPaid: {
            args: {
                placeId: "string",
                id: "string",
                isPaid: "bool"
            },
            ret: "bool"
        },
        getEventClosingDataToConference: {
            args: {
                eventId: "string",
                placeId: "string"
            },
            ret: "FinancialEventClosingConference"
        },
        createBackofficeAccountBillsOnClosingEvent: {
            args: {
                eventId: "string",
                placeId: "string",
                eventName: "string"
            },
            ret: "void"
        },
        previewBackofficeInstallments: {
            args: {
                request: "BackofficePreviewInstallmentsRequest"
            },
            ret: "BackofficeInstallmentPreviewResponse[]"
        },
        updateBackofficePreviewInstallments: {
            args: {
                request: "BackofficeUpdatePreviewInstallmentsRequest"
            },
            ret: "BackofficeInstallmentPreviewResponse[]"
        },
        createBackofficeInstallmentAccountBills: {
            args: {
                placeId: "string",
                account: "BackofficeBaseAccountBills",
                installments: "BackofficeInstallmentPreviewResponse[]",
                installmentIntervalType: "TypeInterval?",
                installmentIntervalValue: "uint?"
            },
            ret: "BackofficeCreateInstallmentResponse"
        },
        updateBackofficeFinancialAccountOnPayment: {
            args: {
                placeId: "string",
                accountBillId: "string",
                type: "BackofficeTypeAccountBills",
                paymentDate: "datetime",
                accountId: "string",
                paymentMethod: "BackofficePaymentMethod?",
                accountBillValues: "BackofficeAccountBillValues?"
            },
            ret: "bool"
        },
        exportBackofficeAccountsPayableReceivable: {
            args: {
                placeId: "string",
                params: "BackofficeGetParamsAccountsBills"
            },
            ret: "string"
        },
        addBackofficeMissingAccountBillsOnEventClosing: {
            args: {
                params: "MissingAccountBillsOnEventClosingParams"
            },
            ret: "bool"
        },
        getBackofficeAccountBillHistory: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "BackofficeAccountBillHistoryEntry[]"
        },
        getBackofficeStorageInventories: {
            args: {
                placeId: "string",
                status: "BackofficeStorageInventoryStatus?",
                query: "string?",
                orderBy: "GetBackofficeStorageInventoriesOrderBy?",
                order: "GetBackofficeStorageInventoriesOrder?",
                since: "datetime?",
                until: "datetime?",
                categoriesIds: "string[]?",
                productsIds: "string[]?",
                storageIds: "string[]?",
                page: "uint?",
                itemsPerPage: "uint?"
            },
            ret: "BackofficeStorageInventoriesResult"
        },
        getBackofficeStorageInventory: {
            args: {
                placeId: "string",
                id: "string"
            },
            ret: "CompleteBackofficeStorageInventory"
        },
        updateBackofficeStorageInventoryProducts: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                products: "BackofficeStorageInventoryProduct[]"
            },
            ret: "CompleteBackofficeStorageInventory"
        },
        deleteBackofficeStorageInventoryProducts: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                productsIds: "string[]"
            },
            ret: "string[]"
        },
        createBackofficeStorageInventory: {
            args: {
                placeId: "string",
                name: "string",
                storageId: "string",
                categoriesIds: "string[]"
            },
            ret: "BackofficeStorageInventoryWithStorage"
        },
        updateBackofficeStorageInventoryStatus: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                status: "BackofficeStorageInventoryStatus",
                reason: "string?"
            },
            ret: "BackofficeStorageInventoryWithStorage"
        },
        updateBackofficeStorageInventory: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                name: "string"
            },
            ret: "BackofficeStorageInventoryWithStorage"
        },
        getBackofficeStorageInventoryAndStorageComparison: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                filters: "GetBackofficeStorageInventoryAndStorageComparisonFilters",
                order: "GetBackofficeStorageInventoryAndStorageComparisonOrder?",
                orderBy: "GetBackofficeStorageInventoryAndStorageComparisonOrderBy?",
                pagination: "Pagination?"
            },
            ret: "BackofficeStorageInventoryAndStorageComparison"
        },
        exportBackofficeStorageInventoryAndStorageComparison: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                filters: "GetBackofficeStorageInventoryAndStorageComparisonFilters",
                order: "ExportBackofficeStorageInventoryAndStorageComparisonOrder?",
                orderBy: "ExportBackofficeStorageInventoryAndStorageComparisonOrderBy?",
                pagination: "Pagination"
            },
            ret: "string"
        },
        exportBackofficeStorageInventoryAndStorageComparisonPdf: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                filters: "GetBackofficeStorageInventoryAndStorageComparisonFilters",
                order: "ExportBackofficeStorageInventoryAndStorageComparisonPdfOrder?",
                orderBy: "ExportBackofficeStorageInventoryAndStorageComparisonPdfOrderBy?"
            },
            ret: "string"
        },
        deleteBackofficeStorageInventory: {
            args: {
                placeId: "string",
                storageInventoryId: "string"
            },
            ret: "void"
        },
        updateBackofficeStorageInventoryProductsTransferType: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                products: "BackofficeUpdateStorageInventoryProductsTransferType[]"
            },
            ret: "void"
        },
        getBackofficeStorageInventoryTopInconsistencies: {
            args: {
                placeId: "string",
                storageInventoryId: "string",
                limit: "uint",
                type: "GetBackofficeStorageInventoryTopInconsistenciesType"
            },
            ret: "BackofficeStorageInventoryProductInconsistency[]"
        },
        getBackofficeStorageInventoriesTotalizers: {
            args: {
                placeId: "string",
                query: "string?",
                since: "datetime?",
                until: "datetime?",
                categoriesIds: "string[]?",
                productsIds: "string[]?",
                storageIds: "string[]?"
            },
            ret: "BackofficeStorageInventoriesTotalizers"
        },
        getHawkerEventSummary: {
            args: {
                eventId: "string"
            },
            ret: "Summary"
        },
        getHawkerSales: {
            args: {
                eventId: "string",
                type: "HawkerSaleType",
                filters: "HawkerReportFilters?"
            },
            ret: "Sales[]"
        },
        getHawkerPayments: {
            args: {
                eventId: "string",
                filters: "HawkerReportFilters?"
            },
            ret: "HawkerPaymentMethod[]"
        },
        getHawkerSessions: {
            args: {
                eventId: "string",
                filters: "HawkerReportFilters?"
            },
            ret: "Sessions[]"
        },
        getHawkerCycles: {
            args: {
                eventId: "string",
                hawkerId: "string",
                sessionId: "string",
                filters: "HawkerReportFilters?"
            },
            ret: "Cycle[]"
        },
        getHawkerCycleSummary: {
            args: {
                eventId: "string",
                hawkerId: "string",
                hawkerCycleId: "string"
            },
            ret: "CycleSummary"
        },
        getHawkersSummary: {
            args: {
                eventId: "string",
                filters: "HawkerReportFilters?"
            },
            ret: "EventSummary"
        },
        getHawkerReport: {
            args: {
                eventId: "string",
                hawkerId: "string"
            },
            ret: "HawkerReport"
        },
        getHawkersRanking: {
            args: {
                eventId: "string",
                hawkerCashierNames: "string[]?",
                hawkerCashierDocuments: "string[]?"
            },
            ret: "HawkersSummary[]"
        },
        getTableReportV2: {
            args: {
                scope: "GetTablesReportProps",
                filters: "Filters",
                pagination: "Pagination"
            },
            ret: "GetTablesReportV2Response"
        },
        getTableReportTotals: {
            args: {
                scope: "GetTablesReportProps",
                filters: "Filters"
            },
            ret: "TablesReportTotals"
        },
        exportTablesReport: {
            args: {
                scope: "GetTablesReportProps",
                filters: "Filters"
            },
            ret: "string"
        },
        getTablesMinimum: {
            args: {
                scope: "GetTablesReportProps"
            },
            ret: "GetTablesMinimun[]"
        },
        getTableReport: {
            args: {
                eventId: "uuid?",
                placeId: "uuid?",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "GetTableReportResponse"
        },
        getTableProductReport: {
            args: {
                eventId: "uuid?",
                placeId: "uuid?",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "TableProductReport[]"
        },
        getEmployeesWithTableInteraction: {
            args: {
                placeId: "string",
                eventId: "string?"
            },
            ret: "MinimalEmployee[]"
        },
        getPlaceZendeskTickets: {
            args: {
                placeId: "string",
                filters: "GetPlaceZendeskTicketsFilters",
                pagination: "Pagination"
            },
            ret: "ZendeskTicketsPaginationResponse"
        },
        listEmployeeZendeskTickets: {
            args: {
                filters: "ListEmployeeZendeskTicketsFilters",
                pagination: "Pagination"
            },
            ret: "EmployeeZendeskTicketsPaginationResponse"
        },
        getEmployeeZendeskTicketDetails: {
            args: {
                ticketId: "string"
            },
            ret: "ZendeskTicketDetails"
        },
        getZendeskMessagingJwt: {
            args: {},
            ret: "string"
        },
        upsertMenuConfigs: {
            args: {
                placeId: "uuid",
                data: "UpsertMenuConfigRequest"
            },
            ret: "UpsertMenuConfigResponse"
        },
        getActiveMenus: {
            args: {
                placeId: "uuid"
            },
            ret: "GetActiveMenusResponse"
        },
        getRatePerRadius: {
            args: {
                placeId: "uuid",
                menuConfigId: "uuid"
            },
            ret: "GetRatePerRadiusResponse"
        },
        upsertRatePerRadius: {
            args: {
                placeId: "uuid",
                menuConfigId: "uuid",
                ratePerRadius: "DeliveryRatePerRadius[]"
            },
            ret: "DeliveryRatePerRadius[]"
        },
        upsertWorkingPeriods: {
            args: {
                placeId: "uuid",
                workingPeriods: "WorkingPeriods[]"
            },
            ret: "void"
        },
        getWorkingPeriods: {
            args: {
                placeId: "uuid"
            },
            ret: "GetWorkingPeriodsResponse[]"
        },
        getMetabases: {
            args: {},
            ret: "OrganizationMetabaseResponse[]"
        },
        getMetabasesByContext: {
            args: {
                contextLevel: "OrganizationMetabaseContextLevel"
            },
            ret: "OrganizationMetabaseResponse[]"
        },
        getMetabaseIframeUrl: {
            args: {
                organizationMetabaseId: "string",
                contextLevel: "OrganizationMetabaseContextLevel",
                eventId: "string?",
                placeId: "string?"
            },
            ret: "string"
        },
        createPlaceSector: {
            args: {
                placeSector: "NewPlaceSector"
            },
            ret: "PlaceSector"
        },
        getPlaceSectors: {
            args: {
                placeId: "string"
            },
            ret: "PlaceSector[]"
        },
        deletePlaceSector: {
            args: {
                placeSectorId: "string"
            },
            ret: "PlaceSector"
        },
        editPlaceSector: {
            args: {
                placeSectorId: "string",
                placeSector: "EditPlaceSector"
            },
            ret: "PlaceSector"
        },
        createAccessPolicy: {
            args: {
                accessPolicy: "NewAccessPolicy"
            },
            ret: "AccessPolicy"
        },
        getAccessPolicies: {
            args: {
                placeId: "string",
                filters: "GetAccessPoliciesFilters?"
            },
            ret: "AccessPolicy[]"
        },
        getAccessPolicyTags: {
            args: {
                placeId: "string",
                accessPolicyId: "string",
                pagination: "Pagination"
            },
            ret: "GetAccessPolicyTags"
        },
        editAccessPolicy: {
            args: {
                placeId: "string",
                accessPolicyId: "string",
                accessPolicy: "EditAccessPolicy"
            },
            ret: "AccessPolicy"
        },
        deleteAccessPolicy: {
            args: {
                placeId: "string",
                accessPolicyId: "string"
            },
            ret: "AccessPolicy"
        },
        importAccessPolicyTags: {
            args: {
                placeId: "string",
                accessPolicyId: "string",
                tagIds: "string[]"
            },
            ret: "void"
        },
        getFinancialEntryTypes: {
            args: {},
            ret: "FinancialEntryTypeGroup[]"
        },
        ifoodWebhook: {
            args: {
                signature: "string",
                event: "IfoodWebhookEventInput"
            },
            ret: "IfoodWebhookEventOutput"
        },
        getIntegrationTokens: {
            args: {},
            ret: "IntegrationToken[]"
        },
        getAvailablePlacesForToken: {
            args: {},
            ret: "Place[]"
        },
        createIntegrationToken: {
            args: {
                placeIds: "string[]?"
            },
            ret: "IntegrationToken"
        },
        deleteIntegrationToken: {
            args: {
                tokenId: "string"
            },
            ret: "void"
        },
        listEquipmentsByPlace: {
            args: {
                request: "ListEquipmentsByPlaceRequest"
            },
            ret: "ListEquipmentsByPlaceResponse"
        },
        getEquipmentsByPlaceToExcel: {
            args: {
                request: "GetEquipmentsByPlaceToExcelRequest"
            },
            ret: "ListEquipmentsByPlaceResponse"
        },
        getSimplifiedOrders: {
            args: {
                payload: "DeliverySimplifiedOrderPayload"
            },
            ret: "DeliverySimplifiedOrder[]"
        },
        acceptOrder: {
            args: {
                placeId: "string",
                orderId: "string"
            },
            ret: "ManagerDeliveryOrder"
        },
        finishOrder: {
            args: {
                placeId: "string",
                orderId: "string"
            },
            ret: "ManagerDeliveryOrder"
        },
        cancelOrder: {
            args: {
                placeId: "string",
                orderId: "string",
                zigReason: "ZigCancelReason?",
                reasonText: "string?"
            },
            ret: "ManagerDeliveryOrder"
        },
        dispatchOrder: {
            args: {
                placeId: "string",
                orderId: "string"
            },
            ret: "ManagerDeliveryOrder"
        },
        readyOrder: {
            args: {
                placeId: "string",
                orderId: "string"
            },
            ret: "ManagerDeliveryOrder"
        },
        getOrder: {
            args: {
                placeId: "string",
                orderId: "string"
            },
            ret: "ManagerDeliveryOrder"
        },
        createManualOrder: {
            args: {
                placeId: "string",
                payload: "CreateManualOrderPayload"
            },
            ret: "CreateManualOrderResponse"
        },
        calculateDeliveryFee: {
            args: {
                placeId: "string",
                address: "CreateManualOrderAddress"
            },
            ret: "CalculateDeliveryFeeResponse"
        },
        upsertDeliveryFeeConfig: {
            args: {
                placeId: "string",
                payload: "UpsertDeliveryFeeConfigPayload"
            },
            ret: "DeliveryFeeConfigResponse"
        },
        getDeliveryFeeConfig: {
            args: {
                placeId: "string"
            },
            ret: "DeliveryFeeConfigResponse"
        },
        getURLAuthorization: {
            args: {
                provider: "MarketplaceProvider",
                placeId: "string",
                redirectURI: "string"
            },
            ret: "GetURLAuthorizationResponse"
        },
        exchangeAuthIdForMerchantAuthorized: {
            args: {
                provider: "MarketplaceProvider",
                authId: "string",
                placeId: "string"
            },
            ret: "void"
        },
        updateMarketplaceStoreStatus: {
            args: {
                provider: "MarketplaceProvider",
                placeId: "string",
                merchantId: "string?",
                isActive: "bool"
            },
            ret: "MarketplaceOperationResponse"
        },
        getAllMarketplaceIntegrationsGroupedByType: {
            args: {
                placeId: "string"
            },
            ret: "GetAllMarketplaceIntegrationsGroupedByTypeResponse"
        },
        deleteMarketplaceIntegration: {
            args: {
                placeId: "string",
                storeId: "string"
            },
            ret: "void"
        },
        openDeliveryWebhook: {
            args: {
                merchantId: "string",
                signature: "string",
                payload: "OpenDeliveryNewEventPayload"
            },
            ret: "OpenDeliveryWebhookResponse"
        },
        bindFood99Store: {
            args: {
                placeId: "string",
                shopId: "string"
            },
            ret: "MarketplaceStore"
        },
        getPendingsTransactions: {
            args: {
                request: "PendingTransactionsFilters"
            },
            ret: "PaginatedPendingsTransactions"
        },
        getAcquirerPendingTransactionFilterOptions: {
            args: {},
            ret: "AcquirerPendingTransactionFilterOptionsResponse"
        },
        getPlaceWizardStatus: {
            args: {
                placeId: "uuid"
            },
            ret: "PlaceWizardStatus"
        },
        savePlaceWizardBarsAndSectorsStep: {
            args: {
                input: "SavePlaceWizardBarsAndSectorsStepInput"
            },
            ret: "void"
        },
        getPlaceWizardBasicInformationStep: {
            args: {
                placeId: "uuid"
            },
            ret: "GetPlaceWizardBasicInformationStepResponse"
        },
        savePlaceWizardBasicInformationStep: {
            args: {
                input: "SavePlaceWizardBasicInformationStepInput"
            },
            ret: "void"
        },
        getPlaceWizardBarsAndSectorsStep: {
            args: {
                placeId: "uuid"
            },
            ret: "GetPlaceWizardBarsAndSectorsStepResponse"
        },
        getPlaceWizardProductsAndMenusStep: {
            args: {
                placeId: "uuid"
            },
            ret: "GetPlaceWizardProductsAndMenusStepResponse"
        },
        savePlaceWizardProductsAndMenusStep: {
            args: {
                input: "SavePlaceWizardProductsAndMenusStepInput"
            },
            ret: "void"
        },
        getFeatureFlags: {
            args: {
                placeId: "uuid?"
            },
            ret: "FeatureFlag[]"
        },
        getOFXfile: {
            args: {
                file: "bytes",
                placeId: "string"
            },
            ret: "OFXFileResponse"
        },
        createBackofficeBankConciliation: {
            args: {
                bankConciliation: "BackofficeBankConciliation",
                placeId: "string"
            },
            ret: "void"
        },
        getBackofficeBankConciliation: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "BackofficeBankConciliationResponse"
        },
        getBackofficeBankConciliations: {
            args: {
                placeId: "string",
                date: "datetime?",
                status: "BackofficeBankConciliationStatus?",
                pagination: "Pagination?"
            },
            ret: "BackofficeBankConciliationResponseWithPagination"
        },
        saveBackofficeBankConciliationTransaction: {
            args: {
                id: "string",
                type: "BackofficeSaveBankConciliationType",
                placeId: "string",
                accountBillId: "string?"
            },
            ret: "bool"
        },
        saveBackofficeBankConciliation: {
            args: {
                id: "string",
                placeId: "string"
            },
            ret: "bool"
        },
        exportAllTransactionProductsXlsxPlace: {
            args: {
                placeId: "string",
                since: "datetime",
                until: "datetime",
                sectorIds: "string[]?"
            },
            ret: "string"
        },
        getReprintsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "Reprint[]"
        },
        getReprintResumeAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "ReprintResume[]"
        },
        getReprintResumeAtPlace: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "ReprintResume[]"
        },
        productRankingReport: {
            args: {
                eventId: "string?",
                placeId: "string?",
                period: "PeriodTime?"
            },
            ret: "ProductRankingReport[]"
        },
        productRankingEmployees: {
            args: {
                productIds: "string[]",
                eventId: "string?",
                placeId: "string?",
                period: "PeriodTime?"
            },
            ret: "EmployeeProductRankingReport[]"
        },
        getSingleProductReturns: {
            args: {
                placeId: "uuid",
                period: "PeriodTime"
            },
            ret: "SingleProductReturnResponse[]"
        },
        getSingleProductReturnsByEvent: {
            args: {
                eventId: "uuid",
                placeId: "uuid"
            },
            ret: "SingleProductReturnResponse[]"
        },
        getBiPanelsGroupedByWorkspace: {
            args: {},
            ret: "BIWorkspace[]"
        },
        createBonusCategory: {
            args: {
                placeId: "string",
                name: "string",
                daysToExpire: "uint",
                status: "bool",
                employeeIds: "uuid[]",
                categoryIds: "uuid[]?",
                productIds: "string[]?",
                lockZigTag: "bool?"
            },
            ret: "BonusCategory"
        },
        editBonusCategory: {
            args: {
                id: "string",
                name: "string",
                daysToExpire: "uint",
                status: "bool",
                employeeIds: "uuid[]",
                categoryIds: "uuid[]?",
                productIds: "string[]?",
                lockZigTag: "bool?"
            },
            ret: "BonusCategory"
        },
        getBonusCategories: {
            args: {
                placeId: "string",
                pagination: "Pagination",
                filters: "BonusCategoryGetFilters?"
            },
            ret: "BonusCategoryGetResponse"
        },
        deleteBonusCategories: {
            args: {
                bonusCategoryIds: "uuid[]"
            },
            ret: "void"
        },
        getCashbackConfigs: {
            args: {},
            ret: "CashbackConfig[]"
        },
        createCashbackConfig: {
            args: {
                cashback: "BaseCashbackConfig"
            },
            ret: "CashbackConfig[]"
        },
        editCashbackConfig: {
            args: {
                id: "string",
                cashback: "BaseCashbackConfig"
            },
            ret: "CashbackConfig[]"
        },
        editStatusCashbackConfig: {
            args: {
                id: "string",
                isActive: "bool"
            },
            ret: "void"
        },
        deleteCashbackConfig: {
            args: {
                id: "string"
            },
            ret: "void"
        },
        listCashbacks: {
            args: {
                pagination: "Pagination"
            },
            ret: "ListCashbackConfigs"
        },
        exportListCashbacksXlsx: {
            args: {},
            ret: "string"
        },
        listCashbackRescues: {
            args: {
                period: "PeriodTime",
                pagination: "Pagination",
                cashbackIds: "string[]"
            },
            ret: "ListCashbackRescues"
        },
        exportListCashbackRescuesXlsx: {
            args: {
                period: "PeriodTime",
                cashbackIds: "string[]"
            },
            ret: "string"
        },
        listCashbackRescuesOverview: {
            args: {
                period: "PeriodTime",
                cashbackIds: "string[]"
            },
            ret: "ListCashbackRescuesOverview"
        },
        applyCashbackForEvents: {
            args: {
                eventIds: "string[]"
            },
            ret: "void"
        },
        getCdpUsers: {
            args: {
                placeIds: "uuid[]",
                filters: "CdpUserFilters?",
                pagination: "Pagination?"
            },
            ret: "CdpUsersPage"
        },
        getCdpUser: {
            args: {
                userId: "uuid",
                placeIds: "uuid[]"
            },
            ret: "CdpUser"
        },
        getCdpUsersBySegment: {
            args: {
                segmentId: "string",
                placeIds: "uuid[]"
            },
            ret: "CdpUser[]"
        },
        getCdpUsersByRfmClassification: {
            args: {
                classification: "RfmClassification",
                placeIds: "uuid[]"
            },
            ret: "CdpUser[]"
        },
        getRfmDistribution: {
            args: {
                placeIds: "uuid[]",
                mixMode: "MixMode?"
            },
            ret: "RfmDistribution[]"
        },
        getSegmentDistribution: {
            args: {
                placeIds: "uuid[]"
            },
            ret: "SegmentDistribution[]"
        },
        getCdpInteractions: {
            args: {
                userId: "uuid",
                placeIds: "uuid[]",
                filters: "CdpInteractionListFilters?",
                pagination: "Pagination?"
            },
            ret: "CdpInteraction[]"
        },
        getCdpProductPurchases: {
            args: {
                userId: "uuid",
                placeIds: "uuid[]",
                filters: "CdpProductPurchaseListFilters?",
                pagination: "Pagination?"
            },
            ret: "CdpProductPurchase[]"
        },
        getCdpProductPurchasesByCategory: {
            args: {
                placeIds: "uuid[]",
                filters: "CdpInteractionFilters?"
            },
            ret: "ProductCategoryDistribution[]"
        },
        getCdpFavoriteProducts: {
            args: {
                placeIds: "uuid[]",
                filters: "BaseCdpFilters?",
                limit: "uint?"
            },
            ret: "FavoriteProduct[]"
        },
        getCdpChurnRate: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "float"
        },
        getCdpAverageTicket: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "money"
        },
        getCdpAverageLTV: {
            args: {
                placeIds: "uuid[]"
            },
            ret: "money"
        },
        getCdpMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?"
            },
            ret: "CdpMetrics"
        },
        createCdpPlaceRfmRule: {
            args: {
                input: "CreateCdpPlaceRfmRuleInput"
            },
            ret: "CdpPlaceRfmRule"
        },
        getCdpPlaceRfmRule: {
            args: {
                placeId: "uuid"
            },
            ret: "CdpPlaceRfmRule?"
        },
        getCdpPlaceRfmRules: {
            args: {
                organizationId: "uuid"
            },
            ret: "CdpPlaceRfmRule[]"
        },
        updateCdpPlaceRfmRule: {
            args: {
                input: "UpdateCdpPlaceRfmRuleInput"
            },
            ret: "CdpPlaceRfmRule"
        },
        deleteCdpPlaceRfmRule: {
            args: {
                placeId: "uuid"
            },
            ret: "void"
        },
        createCdpOrganizationCustomSegment: {
            args: {
                input: "CreateCdpOrganizationCustomSegmentInput"
            },
            ret: "CdpOrganizationCustomSegment"
        },
        getCdpOrganizationCustomSegment: {
            args: {
                segmentId: "uuid"
            },
            ret: "CdpOrganizationCustomSegment"
        },
        getCdpOrganizationCustomSegments: {
            args: {
                organizationId: "uuid"
            },
            ret: "CdpOrganizationCustomSegment[]"
        },
        updateCdpOrganizationCustomSegment: {
            args: {
                input: "UpdateCdpOrganizationCustomSegmentInput"
            },
            ret: "CdpOrganizationCustomSegment"
        },
        deleteCdpOrganizationCustomSegment: {
            args: {
                segmentId: "uuid"
            },
            ret: "void"
        },
        getCdpAudienceMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "DashboardTimeGrouping"
            },
            ret: "AudienceMetricsByPeriod"
        },
        getCdpAverageTicketMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "DashboardTimeGrouping"
            },
            ret: "AverageTicketMetricsByPeriod"
        },
        getCdpTpvMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "DashboardTimeGrouping"
            },
            ret: "TpvMetricsByPeriod"
        },
        getCdpDashboardKpis: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "DashboardKpis"
        },
        getCdpDashboardKpisTimeSeries: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "GetCdpDashboardKpisTimeSeriesGroupBy"
            },
            ret: "DashboardKpisByPeriod[]"
        },
        getCdpAudienceMetricsTimeSeries: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "GetCdpAudienceMetricsTimeSeriesGroupBy"
            },
            ret: "AudienceMetricsByPeriod[]"
        },
        getCdpInactiveClients: {
            args: {
                placeIds: "uuid[]",
                inactiveDays: "uint",
                mixMode: "MixMode?"
            },
            ret: "InactiveClientsKpi"
        },
        getCdpChurnRiskClients: {
            args: {
                placeIds: "uuid[]",
                mixMode: "MixMode?"
            },
            ret: "ChurnRiskKpi[]"
        },
        getCdpTopRfmMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?"
            },
            ret: "TopRfmMetrics[]"
        },
        getCdpDemographicDistribution: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?"
            },
            ret: "DemographicDistribution"
        },
        getCdpCityDistribution: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?"
            },
            ret: "CityDistribution[]"
        },
        getCdpRfmDistributionEnhanced: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?",
                mixMode: "MixMode?"
            },
            ret: "RfmDistributionEnhanced[]"
        },
        getCdpRfmDistributionTimeSeries: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "GetCdpRfmDistributionTimeSeriesGroupBy"
            },
            ret: "RfmDistributionByPeriod[]"
        },
        getCdpSegmentDistributionEnhanced: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime?"
            },
            ret: "SegmentDistributionEnhanced[]"
        },
        getCdpRfmFrequencyDistribution: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                mixMode: "MixMode?"
            },
            ret: "RfmFrequencyDistribution[]"
        },
        getCdpActivationRate: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "ActivationRateMetrics"
        },
        getCdpActivationRateTimeSeries: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "DashboardTimeGrouping"
            },
            ret: "ActivationRateByPeriod[]"
        },
        getCdpReactivationMetrics: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "ReactivationMetrics"
        },
        getCdpAverageTimeBetweenVisits: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime"
            },
            ret: "AverageTimeBetweenVisitsMetrics"
        },
        getCdpOccupancyRate: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                groupBy: "DashboardTimeGrouping"
            },
            ret: "OccupancyRate[]"
        },
        getCdpValueMatrix: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                limit: "uint?"
            },
            ret: "ValueMatrixPoint[]"
        },
        getCdpValueMatrixDistribution: {
            args: {
                placeIds: "uuid[]",
                period: "PeriodTime",
                customFrequencyEdges: "float[]?",
                customTicketEdges: "money[]?"
            },
            ret: "ValueMatrixDistribution"
        },
        getCdpRemainingBalance: {
            args: {
                placeIds: "uuid[]"
            },
            ret: "RemainingBalanceKpi"
        },
        listUnreadDashboardNotificationsForEmployee: {
            args: {
                pagination: "Pagination"
            },
            ret: "DashboardNotificationPaginated"
        },
        listReadDashboardNotificationsForEmployee: {
            args: {
                pagination: "Pagination"
            },
            ret: "DashboardNotificationPaginated"
        },
        setReadDashboardNotificationsForEmployee: {
            args: {
                dashboardNotificationIds: "string[]"
            },
            ret: "void"
        },
        editEmployeesPlacesAndBars: {
            args: {
                employees: "EditEmployeesPlacesAndBarsEmployees[]"
            },
            ret: "EditEmployeesPlacesAndBars"
        },
        getSellerTipReportForPlace: {
            args: {
                placeId: "uuid",
                since: "datetime",
                until: "datetime",
                filters: "EmployeeTipReportFilters"
            },
            ret: "EmployeeTipReport[]"
        },
        getSellerTipReportForEvent: {
            args: {
                eventId: "uuid",
                filters: "EmployeeTipReportFilters"
            },
            ret: "EmployeeTipReport[]"
        },
        getAllEventActions: {
            args: {
                eventId: "string",
                filters: "FiltersActionsFromEvent",
                pagination: "Pagination"
            },
            ret: "ReportActionsFromEventResponse"
        },
        getAllEventActionsFromTotem: {
            args: {
                eventId: "string",
                filters: "FiltersActionsFromEvent",
                pagination: "Pagination"
            },
            ret: "ReportActionsFromEventResponse"
        },
        getFiltersValuesForTransactionsReport: {
            args: {
                placeId: "string"
            },
            ret: "FiltersValuesForTransactionsReport"
        },
        getAllEventActionsV2: {
            args: {
                eventId: "string",
                filters: "FiltersActionsFromEventOrPlace",
                pagination: "Pagination"
            },
            ret: "GetAllEventActionsV2"
        },
        getAllPlaceActions: {
            args: {
                placeId: "string",
                filters: "FiltersActionsFromEventOrPlace",
                pagination: "Pagination"
            },
            ret: "GetAllPlaceActions"
        },
        exportAllPlaceOrEventActions: {
            args: {
                placeId: "string?",
                eventId: "string?",
                email: "string",
                since: "datetime?",
                until: "datetime?"
            },
            ret: "string"
        },
        getTransactionReportLinks: {
            args: {
                placeId: "string",
                since: "datetime?"
            },
            ret: "TransactionReportLink[]"
        },
        sendTransactionReportMail: {
            args: {
                email: "string",
                linkId: "string"
            },
            ret: "void"
        },
        getHawkerCashierReleasedProductsForClosingReport: {
            args: {
                id: "uuid",
                eventId: "uuid"
            },
            ret: "HawkerCashierReleasedProduct[]"
        },
        getHawkerCashierPaymentsForClosingReport: {
            args: {
                id: "uuid",
                eventId: "uuid"
            },
            ret: "HawkerCashierPayment[]"
        },
        getHawkerCashierAdjustmentsForClosingReport: {
            args: {
                id: "uuid",
                eventId: "uuid"
            },
            ret: "HawkerCashierAdjustment[]"
        },
        getHawkerCashierHawkerClosingsForClosingReport: {
            args: {
                id: "uuid",
                eventId: "uuid"
            },
            ret: "HawkerCashierHawkerClosing[]"
        },
        getHawkerCashierFinancialSummaryForClosingReport: {
            args: {
                id: "uuid",
                eventId: "uuid"
            },
            ret: "HawkerCashierFinancialSummary"
        },
        getHawkerCashiersClosingsForEvent: {
            args: {
                eventId: "uuid",
                filters: "HawkerReportFilters?"
            },
            ret: "HawkerCashierClosing[]"
        },
        getHawkerTransactions: {
            args: {
                placeId: "string",
                eventIds: "string[]",
                pagination: "Pagination",
                filters: "HawkerTransactionsFilters?"
            },
            ret: "GetHawkerTransactions"
        },
        getHawkerTransactionsByPlace: {
            args: {
                placeId: "string",
                pagination: "Pagination",
                filters: "HawkerTransactionsPlaceFilters"
            },
            ret: "GetHawkerTransactionsByPlace"
        },
        getHawkerTransactionsXlsx: {
            args: {
                placeId: "string",
                eventIds: "string[]",
                filters: "HawkerTransactionsFilters?"
            },
            ret: "string"
        },
        getAllKds: {
            args: {
                placeId: "string",
                filters: "KdsFilters"
            },
            ret: "Kds[]"
        },
        getKds: {
            args: {
                placeId: "string",
                kdsId: "string",
                ninegridKdsId: "uint"
            },
            ret: "KdsDetails"
        },
        editKds: {
            args: {
                placeId: "string",
                kdsId: "string",
                ninegridKdsId: "uint",
                kdsRequest: "KdsRequest"
            },
            ret: "void"
        },
        getKdsAverageAssemblyOrder: {
            args: {
                placeId: "string",
                rangeDate: "ReportDateRange"
            },
            ret: "string"
        },
        getKdsProductionBySector: {
            args: {
                placeId: "string",
                rangeDate: "ReportDateRange"
            },
            ret: "KdsProductionBySectorReport[]"
        },
        getKdsProductionByProduct: {
            args: {
                placeId: "string",
                rangeDate: "ReportDateRange"
            },
            ret: "KdsProductionByProductReport[]"
        },
        getKdsTop10LongestOrders: {
            args: {
                placeId: "string",
                rangeDate: "ReportDateRange"
            },
            ret: "KdsOrder[]"
        },
        getKdsAverageProductionTimeByHour: {
            args: {
                placeId: "string",
                rangeDate: "ReportDateRange"
            },
            ret: "KdsAverageProductionTimeByHour[]"
        },
        createKds: {
            args: {
                placeId: "string",
                barIds: "string[]",
                name: "string"
            },
            ret: "Kds"
        },
        deleteKds: {
            args: {
                placeId: "string",
                kdsId: "string"
            },
            ret: "void"
        },
        editZigKds: {
            args: {
                placeId: "string",
                kdsId: "string",
                kdsRequest: "EditKdsRequest"
            },
            ret: "void"
        },
        createKdsScreen: {
            args: {
                placeId: "string",
                kdsId: "string"
            },
            ret: "CreateKdsScreenResponse"
        },
        deleteKdsScreen: {
            args: {
                placeId: "string",
                kdsScreenId: "string"
            },
            ret: "void"
        },
        editKdsScreen: {
            args: {
                placeId: "string",
                kdsScreenId: "string",
                name: "string"
            },
            ret: "void"
        },
        createKdsProductScreen: {
            args: {
                placeId: "string",
                kdsScreenId: "string",
                kdsProductBars: "KdsProductBar[]"
            },
            ret: "void"
        },
        deleteKdsProductScreen: {
            args: {
                placeId: "string",
                kdsScreenId: "string",
                kdsProductBars: "KdsProductBar[]"
            },
            ret: "void"
        },
        createMenu: {
            args: {
                placeId: "uuid",
                menu: "NewMenu"
            },
            ret: "MenuDetails"
        },
        deleteMenu: {
            args: {
                menuId: "uuid"
            },
            ret: "void"
        },
        editMenu: {
            args: {
                menuId: "uuid",
                menu: "EditMenu"
            },
            ret: "MenuDetails"
        },
        getMenus: {
            args: {
                placeId: "uuid"
            },
            ret: "MenuList[]"
        },
        duplicateMenu: {
            args: {
                name: "string",
                menuId: "uuid"
            },
            ret: "MenuDetails"
        },
        changeMenuStatus: {
            args: {
                menuId: "uuid",
                status: "bool"
            },
            ret: "MenuDetails"
        },
        getMenu: {
            args: {
                menuId: "uuid"
            },
            ret: "MenuDetails"
        },
        getMenuProductsByCategory: {
            args: {
                menuId: "uuid",
                categoryId: "uuid",
                filters: "MenuProductFilters?",
                pagination: "Pagination"
            },
            ret: "GetMenuProductsByCategory"
        },
        getAllMenuProducts: {
            args: {
                menuId: "uuid",
                filters: "MenuProductFilters?",
                pagination: "Pagination"
            },
            ret: "GetAllMenuProducts"
        },
        getMenuAddableProductsByName: {
            args: {
                placeId: "uuid",
                menuId: "uuid",
                productName: "string"
            },
            ret: "AddableMenuProduct[]"
        },
        getMenuAddableProductsByCategory: {
            args: {
                placeId: "uuid",
                categoryId: "uuid",
                menuId: "uuid"
            },
            ret: "AddableMenuProduct[]"
        },
        editMenuProduct: {
            args: {
                menuId: "uuid",
                products: "NewEditProduct[]"
            },
            ret: "void"
        },
        removeProductFromMenu: {
            args: {
                menuId: "uuid",
                productId: "uuid"
            },
            ret: "void"
        },
        createMenuAndProductsAndUpdateSku: {
            args: {
                placeId: "uuid",
                request: "CreateMenuWithProductsRequest"
            },
            ret: "CreateMenuWithProductsResponse"
        },
        createManyProductsAndAddToMenuAndUpdateSku: {
            args: {
                placeId: "uuid",
                menuId: "uuid",
                products: "CreateProductWithSectionsRequest[]"
            },
            ret: "CreateMenuWithProductsResponse"
        },
        addProductToMenuAndUpdateExternalProductSku: {
            args: {
                placeId: "uuid",
                request: "UpdateMenuAndExternalProductRequest"
            },
            ret: "void"
        },
        reImportIfoodProduct: {
            args: {
                placeId: "uuid",
                request: "ReImportIfoodProductRequest"
            },
            ret: "void"
        },
        linkSyncedProductsToDeliveryMenu: {
            args: {
                placeId: "uuid",
                menuId: "uuid",
                products: "LinkSyncedProductToDeliveryMenuRequest[]"
            },
            ret: "void"
        },
        removeProductFromMenuAndUpdateExternalProductSku: {
            args: {
                placeId: "uuid",
                menuId: "uuid",
                externalStoreId: "string",
                productsToRemove: "ProductToRemoveFromExternalStore[]"
            },
            ret: "void"
        },
        getDeliveryIntegratedMenus: {
            args: {
                placeId: "uuid",
                filters: "GetMenusRequest?",
                pagination: "Pagination"
            },
            ret: "GetDeliveryIntegratedMenusResponse"
        },
        processUpdateManyExternalProductsSkus: {
            args: {
                placeId: "uuid",
                externalStoresIds: "string[]"
            },
            ret: "void"
        },
        getTableProfitReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "GetTableProfitReport"
        },
        getTablePeopleServedReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "GetTablePeopleServedReport"
        },
        getTableMediumTicketPerTableReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableReportResponse"
        },
        getTableMediumTicketPerPersonReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableReportResponse"
        },
        getTableTurnoverReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableReportResponse"
        },
        getTableLengthOfStayReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableReportResponse"
        },
        getTableMergeCombinationsReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableReportResponse"
        },
        getTableEmployeeSaleRankingReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableEmployeeSaleRankingReport[]"
        },
        getTableProductSoldRankingReport: {
            args: {
                scope: "GetReportByScope",
                filters: "ReportFilters"
            },
            ret: "TableProductSoldRankingReport[]"
        },
        getMesaStatusConfiguration: {
            args: {
                placeId: "uuid"
            },
            ret: "MesaStatusConfigurationReturn[]"
        },
        createMesaStatusConfigurations: {
            args: {
                placeId: "uuid",
                configurations: "CreateStatusConfiguration[]"
            },
            ret: "MesaStatusConfiguration[]"
        },
        getPasswordCardsFromPlace: {
            args: {
                placeId: "uuid",
                pagination: "Pagination",
                filters: "GetPasswordCardsFromPlaceFilters"
            },
            ret: "EmployeeCardsPagination"
        },
        getPasswordCardHistory: {
            args: {
                passwordCardId: "string",
                pagination: "Pagination"
            },
            ret: "CardHistoryPagination"
        },
        blockPasswordCards: {
            args: {
                passwordCardIds: "string[]"
            },
            ret: "void"
        },
        deleteEmployeePasswordCard: {
            args: {
                passwordCardIds: "string[]"
            },
            ret: "void"
        },
        pendingOnlineRechargeValueByDate: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "PendingOnlineRechargeValue[]"
        },
        getPendingOnlineRechargeResume: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "PendingOnlineRechargeResume[]"
        },
        getPendingOnlineRechargeReport: {
            args: {
                placeId: "string",
                since: "date",
                until: "date"
            },
            ret: "PendingOnlineRechargeReport"
        },
        deletePendingOnlineRecharge: {
            args: {
                placeId: "string",
                pendingRechargeId: "string"
            },
            ret: "void"
        },
        deletePendingOnlineRechargesByZigDeviceUids: {
            args: {
                placeId: "string",
                zigDeviceUids: "string[]"
            },
            ret: "void"
        },
        getPendingPlaceContracts: {
            args: {
                placeId: "string"
            },
            ret: "ListPendingPlaceContracts"
        },
        signPlaceContracts: {
            args: {
                contractIds: "string[]"
            },
            ret: "void"
        },
        confirmSignPlaceContracts: {
            args: {
                code: "string",
                placeId: "string"
            },
            ret: "void"
        },
        listPlaceContracts: {
            args: {
                placeId: "string",
                pagination: "Pagination",
                filters: "PlaceContractListFilters"
            },
            ret: "PlaceContractListPaginated"
        },
        getPlaceContract: {
            args: {
                contractId: "string"
            },
            ret: "PlaceContract"
        },
        downloadFilesFromContracts: {
            args: {
                contractIds: "string[]"
            },
            ret: "string"
        },
        applyMountableProductsForProducts: {
            args: {
                placeId: "uuid",
                fromProductId: "uuid",
                toProductIds: "uuid[]"
            },
            ret: "void"
        },
        getProductMasterKinds: {
            args: {},
            ret: "GetProductMasterKinds[]"
        },
        getAllRecharges: {
            args: {
                filters: "RechargeRequestFilters",
                pagination: "Pagination"
            },
            ret: "RechargesPaginated"
        },
        getAllRechargeIds: {
            args: {
                filters: "RechargeRequestFilters"
            },
            ret: "string[]"
        },
        cancelRechargeUpload: {
            args: {
                rechargeIds: "string[]"
            },
            ret: "void"
        },
        alterRechargeExpirations: {
            args: {
                rechargeIds: "string[]",
                expiresAt: "datetime"
            },
            ret: "void"
        },
        addRechargesToPlace: {
            args: {
                rechargeIds: "string[]",
                placeIds: "string[]"
            },
            ret: "void"
        },
        getAllRechargeFilters: {
            args: {
                eventId: "string?",
                placeId: "string?"
            },
            ret: "RechargeFilters"
        },
        listSquadCampaigns: {
            args: {
                period: "PeriodTime",
                filters: "CampaignFilters",
                pagination: "Pagination"
            },
            ret: "ListCampaignsReponse"
        },
        squadCampaignTotals: {
            args: {
                period: "PeriodTime",
                filters: "CampaignFilters?"
            },
            ret: "CampaignTotalsReponse"
        },
        getListWinners: {
            args: {
                period: "PeriodTime",
                pagination: "Pagination",
                filters: "ListWinnersFilters?"
            },
            ret: "ListWinnersResponse"
        },
        createSquadCampaign: {
            args: {
                data: "CampaignRequest"
            },
            ret: "CampaignResponse"
        },
        getSquadCampaignById: {
            args: {
                campaignId: "string"
            },
            ret: "CampaignResponse"
        },
        listSquadCampaignFilters: {
            args: {},
            ret: "CampaignResponseFilters[]"
        },
        finalizeSquadCampaign: {
            args: {
                campaignId: "string"
            },
            ret: "CampaignResponse"
        },
        payEmployee: {
            args: {
                squadCampaignId: "string",
                employeeWinner: "string"
            },
            ret: "void"
        },
        squadCampaignRanking: {
            args: {
                squadCampaignId: "string"
            },
            ret: "ListSquadCampaignRanking[]"
        },
        squadCampaignRankingXlsx: {
            args: {
                squadCampaignId: "string"
            },
            ret: "string"
        },
        createVendorForOrganization: {
            args: {
                vendor: "CreateVendorOrg"
            },
            ret: "VendorOrg"
        },
        updateVendorForOrganization: {
            args: {
                vendor: "UpdateVendorOrg"
            },
            ret: "VendorOrg"
        },
        batchUpdateVendorForOrganization: {
            args: {
                vendors: "UpdateVendorOrg[]"
            },
            ret: "VendorOrg[]"
        },
        getVendorsFromOrganization: {
            args: {},
            ret: "VendorOrg[]"
        },
        getAllVendorFeatures: {
            args: {},
            ret: "GetAllVendorFeatures[]"
        },
        deleteVendorAdjust: {
            args: {
                id: "uuid"
            },
            ret: "void"
        },
        getVendorToReceiveAllTips: {
            args: {
                placeId: "uuid"
            },
            ret: "VendorReceiveTip?"
        },
        setVendorToReceiveAllTips: {
            args: {
                vendorId: "uuid?",
                placeId: "uuid"
            },
            ret: "VendorReceiveTip?"
        },
        editVendorPaymentMethods: {
            args: {
                placeId: "string",
                vendorsPaymentMethods: "VendorPaymentMethods[]"
            },
            ret: "VendorPaymentMethodsResponse[]"
        },
        getPlaceVendorPaymentMethods: {
            args: {
                placeId: "string"
            },
            ret: "VendorPaymentMethodsResponse[]"
        },
        getVendorsBalances: {
            args: {
                placeId: "uuid"
            },
            ret: "GetVendorsBalances[]"
        },
        reprocessAllVendorsAtEvent: {
            args: {
                eventId: "string"
            },
            ret: "void"
        },
        reprocessAllVendorsAtEventAsync: {
            args: {
                eventId: "uuid"
            },
            ret: "void"
        },
        getVendorExtractResume: {
            args: {
                placeId: "string",
                vendorId: "string"
            },
            ret: "VendorExtractResume[]"
        },
        getVendorConsolidatedExtractInSections: {
            args: {
                since: "date",
                until: "date",
                placeId: "string",
                vendorId: "string"
            },
            ret: "VendorConsolidatedExtract"
        },
        getAutomaticWithdrawHistory: {
            args: {
                placeId: "uuid",
                since: "date",
                until: "date"
            },
            ret: "GetAutomaticWithdrawHistory[]"
        },
        createWithdraw: {
            args: {
                placeId: "string",
                newWithdraw: "CreateWithdrawDto"
            },
            ret: "WithdrawResponse"
        },
        validateWithdrawPlaceConfirmationCode: {
            args: {
                placeId: "uuid",
                code: "string"
            },
            ret: "void"
        },
        resendWithdrawRequestPlaceConfirmationCode: {
            args: {
                placeId: "uuid"
            },
            ret: "void"
        },
        cancelWithdrawRequestPlaceConfirmation: {
            args: {
                placeId: "uuid"
            },
            ret: "void"
        },
        isWithdrawRequestPendingPlaceConfirmation: {
            args: {
                id: "uuid"
            },
            ret: "bool"
        },
        orderWithdrawCancellation: {
            args: {
                withdrawId: "string"
            },
            ret: "void"
        },
        retryPixReceipt: {
            args: {
                placeId: "uuid",
                withdrawId: "string"
            },
            ret: "RetryPixReceipt"
        },
        getBankslipPreviewData: {
            args: {
                barcode: "string",
                placeId: "uuid?"
            },
            ret: "BankslipPreviewData"
        },
        getEventOperationsByPlaceId: {
            args: {
                request: "GetEventOperationsByPlaceIdRequest"
            },
            ret: "GetEventOperationsByPlaceIdResponse"
        },
        requestClosingOfEventOperation: {
            args: {
                id: "uuid"
            },
            ret: "RequestClosingOfEventOperationResponse"
        },
        getCombinedOrdersReport: {
            args: {
                placeId: "uuid",
                filters: "GetCombinedOrdersReportRequestDto?",
                orderBy: "GetCombinedOrdersReportOrderBy?",
                orderDirection: "GetCombinedOrdersReportOrderDirection?",
                pagination: "PaginationRequestDto"
            },
            ret: "GetCombinedOrdersReportResponseDto"
        },
        exportCombinedOrdersReport: {
            args: {
                placeId: "uuid",
                filters: "GetCombinedOrdersReportRequestDto?",
                orderBy: "GetCombinedOrdersReportOrderBy?",
                orderDirection: "GetCombinedOrdersReportOrderDirection?"
            },
            ret: "bytes"
        },
        listAdvances: {
            args: {
                placeId: "string",
                page: "int",
                pageSize: "int",
                filters: "ListAdvancesFilters"
            },
            ret: "ListAdvancesResponse"
        },
        getAdvance: {
            args: {
                advanceId: "string"
            },
            ret: "Advance"
        },
        getAdvanceCharges: {
            args: {
                advanceId: "string"
            },
            ret: "AdvanceCharge[]"
        },
        getAdvanceDocuments: {
            args: {
                advanceId: "string"
            },
            ret: "AdvanceDocument[]"
        },
        getNotOpenedCashiers: {
            args: {
                eventId: "string"
            },
            ret: "EmployeeBase[]"
        },
        getBaseEmployees: {
            args: {
                pagination: "Pagination"
            },
            ret: "EmployeeBaseResponse"
        },
        getStockTransferReport: {
            args: {
                eventId: "string"
            },
            ret: "StockTransfer[]"
        },
        getGuinnessResume: {
            args: {
                eventId: "string"
            },
            ret: "uint"
        },
        getGuinnessLog: {
            args: {
                eventId: "string"
            },
            ret: "GuinnessLog[]"
        },
        sendDataToEverest: {
            args: {
                eventId: "string"
            },
            ret: "void"
        },
        sendDatasToEverest: {
            args: {
                eventIds: "string[]"
            },
            ret: "void"
        },
        sendInvoiceToEverest: {
            args: {
                invoiceId: "string"
            },
            ret: "void"
        },
        sendFinanceToEverest: {
            args: {
                eventId: "string"
            },
            ret: "void"
        },
        testEverest: {
            args: {},
            ret: "void"
        },
        sendDataHubChatResponse: {
            args: {
                deviceId: "string",
                chatId: "string",
                response: "string",
                extra: "json?"
            },
            ret: "void"
        }
    },
    typeTable: {
        ProductEmissionTestDataProducts: {
            productId: "uuid",
            error: "string"
        },
        ProductEmissionTestData: {
            products: "ProductEmissionTestDataProducts[]"
        },
        AddressFromCep: {
            tipo: "AddressFromCepTipo?",
            cep: "string",
            logradouro: "string",
            bairro: "string?",
            estado: "string",
            cidade: "string",
            uf: "string",
            codigoMunicipio: "string?",
            pais: "string?"
        },
        Address: {
            numero: "string",
            complemento: "string?",
            tipo: "AddressFromCepTipo?",
            cep: "string",
            logradouro: "string",
            bairro: "string?",
            estado: "string",
            cidade: "string",
            uf: "string",
            codigoMunicipio: "string?",
            pais: "string?"
        },
        AdyenCard: {
            encryptedCardNumber: "string?",
            encryptedExpiryMonth: "string?",
            encryptedExpiryYear: "string?",
            encryptedSecurityCode: "string?",
            brand: "string?",
            type: "string?",
            holderName: "string?",
            checkoutAttemptId: "string?",
            storedPaymentMethodId: "string?",
            googlePayToken: "string?",
            applePayToken: "string?"
        },
        AdyenCardPayment: {
            card: "AdyenCard",
            address: "Address?",
            shopperReference: "string?"
        },
        AdyenSession: {
            id: "string",
            data: "string",
            paymentMethods: "string?"
        },
        AdyenPaymentSessionRequest: {
            amountValue: "uint?",
            amountCurrency: "string?"
        },
        BackofficeNewStorage: {
            name: "string"
        },
        BackofficeStorage: {
            isCentral: "bool",
            placeId: "string?",
            id: "string",
            name: "string"
        },
        BackofficeStorageWithResumeBar: {
            id: "string",
            name: "string",
            internalIps: "string[]"
        },
        BackofficeStorageWithResume: {
            isCentral: "bool",
            placeId: "string?",
            id: "string",
            name: "string",
            productsCount: "float",
            totalCost: "string",
            createdAt: "datetime",
            attachedBars: "BackofficeStorageWithResumeBar[]"
        },
        BackofficeStorageProduct: {
            id: "string",
            count: "float"
        },
        BackofficeInput: {
            productId: "string",
            storageId: "string",
            unitCostValue: "uint?",
            obs: "string?",
            count: "uint",
            date: "datetime"
        },
        BackofficeInputV2: {
            productId: "string",
            storageId: "string",
            unitCostValue: "string?",
            obs: "string?",
            count: "money",
            date: "datetime"
        },
        BackofficeInputsResultV2Error: {
            input: "BackofficeInputV2",
            reason: "string"
        },
        BackofficeInputsResultV2: {
            success: "BackofficeInputV2[]",
            error: "BackofficeInputsResultV2Error[]"
        },
        BackofficeInputsResultError: {
            input: "BackofficeInput",
            reason: "string"
        },
        BackofficeInputsResult: {
            success: "BackofficeInput[]",
            error: "BackofficeInputsResultError[]"
        },
        BackofficeDeleteProductsResultError: {
            productId: "string",
            reason: "string"
        },
        BackofficeDeleteProductsResult: {
            success: "string[]",
            error: "BackofficeDeleteProductsResultError[]"
        },
        BackofficeStorageHistoryV3TransfersTargetProductionProduct: {
            id: "uuid",
            name: "string"
        },
        BackofficeStorageHistoryV3Transfers: {
            date: "datetime",
            type: "BackofficeStorageTransferType",
            count: "float",
            remainingCount: "float?",
            employeeId: "string?",
            employeeName: "string?",
            employeeUsername: "string?",
            unitCostValue: "string?",
            referenceCode: "string?",
            obs: "string?",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            remainingCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            targetProductionProduct: "BackofficeStorageHistoryV3TransfersTargetProductionProduct?"
        },
        BackofficeStorageHistoryV3: {
            currentPage: "uint?",
            initial: "float",
            totalTransfersItems: "uint",
            transfers: "BackofficeStorageHistoryV3Transfers[]"
        },
        BackofficeStorageProductsHistoryV3: {
            productName: "string?",
            fiscalCode: "string?",
            hasProductionRule: "bool?",
            basicStorageUnit: "BasicStorageUnit",
            proportionOfUnit: "ProportionOfUnit?",
            productId: "string",
            history: "BackofficeStorageHistoryV3"
        },
        BackofficeImportedInvoiceRestriction: {
            supplierDocument: "string"
        },
        BackofficeImportedInvoiceProductInvoiceEntry: {
            index: "int",
            code: "string",
            description: "string",
            commercialUnit: "string",
            commercialQuantity: "float",
            unitValue: "uint",
            EAN: "string?",
            totalValue: "uint",
            icmsStValue: "uint?",
            icmsStAliquot: "uint?",
            icmsStBase: "uint?",
            icmsFcpStValue: "uint?",
            ipiValue: "uint?",
            ipiAliquot: "uint?",
            ipiBase: "uint?",
            shippingValue: "uint?",
            otherExpensesValue: "uint?",
            discountValue: "uint?",
            insuranceValue: "uint?"
        },
        BackofficeInvoiceDuplicate: {
            id: "string?",
            code: "string?",
            dueDate: "datetime?",
            performDate: "datetime",
            value: "uint"
        },
        BackofficeImportedInvoiceProduct: {
            entryId: "string",
            pending: "bool",
            skipped: "bool",
            associatedProduct: "Product?",
            chartAccountId: "uuid?",
            unitValue: "string",
            unitMultiplier: "uint",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            commercialQuantity: "float",
            hasChangedCommercialQuantity: "bool",
            invoiceEntry: "BackofficeImportedInvoiceProductInvoiceEntry"
        },
        BackofficeAddress: {
            street: "string",
            number: "string",
            complemento: "string?",
            cep: "string",
            state: "string",
            city: "string",
            neighborhood: "string"
        },
        BackofficeBankAccount: {
            bank: "string",
            account: "string",
            agency: "string",
            cpfOrCnpj: "string",
            ownerName: "string"
        },
        BackofficeBaseSupplier: {
            name: "string",
            legalName: "string?",
            inscricaoEstadual: "string?",
            cpfOrCnpj: "string?",
            address: "BackofficeAddress?",
            bankAccount: "BackofficeBankAccount?",
            billPlanCategoryId: "string?",
            registerType: "BackofficeSupplierRegisterType?",
            chartAccountId: "string?",
            organizationId: "string?",
            pixKeyType: "PixKeyTypeDto?",
            pixKey: "string?"
        },
        BackofficeInvoiceSupplier: {
            name: "string",
            legalName: "string?",
            inscricaoEstadual: "string?",
            cpfOrCnpj: "string?",
            address: "BackofficeAddress?",
            bankAccount: "BackofficeBankAccount?",
            billPlanCategoryId: "string?",
            registerType: "BackofficeSupplierRegisterType?",
            chartAccountId: "string?",
            organizationId: "string?",
            pixKeyType: "PixKeyTypeDto?",
            pixKey: "string?",
            id: "string"
        },
        BackofficeImportedProductsFromInvoicesProduct: {
            entryId: "string",
            associatedProduct: "Product?",
            chartAccountId: "uuid?",
            unitValue: "string",
            unitMultiplier: "uint",
            invoiceEntry: "BackofficeImportedInvoiceProductInvoiceEntry",
            skipped: "bool",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            commercialQuantity: "float",
            hasChangedCommercialQuantity: "bool"
        },
        BackofficeImportedProductsFromInvoices: {
            invoiceId: "string",
            num: "uint",
            serie: "uint",
            supplierName: "string",
            supplierCpfOrCnpj: "string",
            processedAt: "datetime?",
            createdAt: "datetime",
            storageId: "string?",
            date: "datetime",
            inputDate: "datetime?",
            product: "BackofficeImportedProductsFromInvoicesProduct"
        },
        BackofficeImportedInvoiceBill: {
            accountId: "string?",
            createBill: "bool",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?"
        },
        BackofficeImportedInvoiceDetailsSupplier: {
            name: "string",
            cpfOrCnpj: "string"
        },
        BackofficeImportedInvoiceDetailsTaxs: {
            icmsBase: "uint",
            icmsValue: "uint",
            icmsstBase: "uint",
            icmsstValue: "uint",
            ipiValue: "uint"
        },
        BackofficeImportedInvoiceDetails: {
            num: "uint",
            serie: "uint",
            operationType: "string?",
            accessKey: "string?",
            date: "datetime",
            supplier: "BackofficeImportedInvoiceDetailsSupplier",
            totalValue: "uint",
            totalProductsValue: "uint",
            taxs: "BackofficeImportedInvoiceDetailsTaxs",
            insuranceValue: "uint",
            discountValue: "uint",
            otherExpensesValue: "uint",
            shippingValue: "uint",
            cfop: "uint?"
        },
        BackofficeImportedInvoiceSupplierInvoiceEntry: {
            cpfOrCnpj: "string",
            name: "string",
            legalName: "string?",
            inscricaoEstadual: "string?",
            address: "BackofficeAddress?"
        },
        BackofficeImportedInvoiceSupplier: {
            pending: "bool",
            skipped: "bool",
            associatedSupplier: "BackofficeInvoiceSupplier?",
            invoiceEntry: "BackofficeImportedInvoiceSupplierInvoiceEntry?"
        },
        BackofficeImportedInvoice: {
            id: "string",
            createdAt: "datetime",
            xml: "string?",
            completed: "bool",
            storageId: "string?",
            bill: "BackofficeImportedInvoiceBill",
            details: "BackofficeImportedInvoiceDetails",
            supplier: "BackofficeImportedInvoiceSupplier",
            products: "BackofficeImportedInvoiceProduct[]",
            duplicates: "BackofficeInvoiceDuplicate[]",
            processedAt: "datetime?",
            inputDate: "datetime?"
        },
        BackofficeProductCmvInputs: {
            productId: "string",
            count: "uint",
            unitCostValue: "string?",
            realUnitCostValue: "string?",
            isCompound: "bool"
        },
        BackofficeProductCmv: {
            productId: "string",
            unitCostValue: "string?",
            realUnitCostValue: "string?",
            absolutePopularity: "float?",
            relativePopularity: "float?",
            soldCount: "uint",
            inputs: "BackofficeProductCmvInputs[]"
        },
        BackofficeProductCmvWithQuantity: {
            productId: "string",
            unitCostValue: "string?",
            realUnitCostValue: "string?",
            absolutePopularity: "float?",
            relativePopularity: "float?",
            soldCount: "uint",
            inputs: "BackofficeProductCmvInputs[]",
            quantity: "money"
        },
        BackofficeProductSimpleCmv: {
            productId: "string",
            unitCostValue: "string?",
            realUnitCostValue: "string?",
            absolutePopularity: "float?",
            relativePopularity: "float?"
        },
        PixKeyDto: {
            value: "string",
            type: "PixKeyTypeDto"
        },
        BankAccountReceiverDto: {
            bank: "string",
            account: "string",
            agency: "string",
            name: "string",
            documentNumber: "string",
            accountType: "BankAccountReceiverTypeDto",
            documentType: "BankAccountDocumentTypeDto"
        },
        BankAccountDto: {
            holder: "string",
            name: "string",
            pixKey: "PixKeyDto?",
            receiver: "BankAccountReceiverDto?",
            isDefault: "bool"
        },
        BankAccountResponse: {
            id: "string",
            createdAt: "date",
            updatedAt: "date",
            holder: "string",
            name: "string",
            pixKey: "PixKeyDto?",
            receiver: "BankAccountReceiverDto?",
            isDefault: "bool"
        },
        BankAccountRequestPixKey: {
            value: "string",
            type: "PixKeyTypeDto?"
        },
        BankAccountRequestReceiver: {
            bank: "string",
            account: "string",
            agency: "string",
            name: "string",
            documentNumber: "string",
            accountType: "BankAccountReceiverTypeDto"
        },
        BankAccountRequest: {
            holder: "string",
            name: "string",
            pixKey: "BankAccountRequestPixKey?",
            receiver: "BankAccountRequestReceiver?",
            isDefault: "bool"
        },
        Attachment: {
            name: "string",
            bytes: "bytes"
        },
        BankCodeResponse: {
            ispb: "string",
            name: "string",
            code: "int?",
            fullName: "string"
        },
        CostOfGoodsSoldSupplies: {
            id: "string",
            name: "string",
            quantity: "uint",
            unitCost: "string?",
            realCost: "string?",
            isCompound: "bool"
        },
        CostOfGoodsSold: {
            id: "string",
            name: "string",
            supplies: "CostOfGoodsSoldSupplies[]",
            resellingPrice: "uint",
            productUnitCost: "string?",
            productRealCost: "string?",
            relativePopularity: "float?",
            absolutePopularity: "uint?"
        },
        CmvReportProduct: {
            id: "string",
            productName: "string",
            productCategory: "string",
            fiscalCode: "string",
            ncm: "string?",
            count: "float",
            totalValue: "string",
            totalDiscount: "string",
            productUnitCost: "string?"
        },
        CmvReportMountables: {
            id: "string",
            name: "string",
            count: "float",
            section: "string",
            productUnitCost: "string?"
        },
        CmvReport: {
            id: "string",
            productName: "string",
            productCategory: "string",
            fiscalCode: "string",
            ncm: "string?",
            count: "float",
            totalValue: "string",
            totalDiscount: "string",
            productUnitCost: "string?",
            mountables: "CmvReportMountables[]"
        },
        EventOperationExpenseCategoryTypeCategory: {
            name: "EventOperationExpenseCategory",
            types: "EventOperationExpenseType[]?"
        },
        EventOperationExpenseCategoryType: {
            category: "EventOperationExpenseCategoryTypeCategory"
        },
        EventOperationExpense: {
            eventOperationId: "uuid",
            category: "EventOperationExpenseCategory",
            role: "string?",
            setupDays: "uint?",
            operationDays: "uint?",
            operatorsCount: "uint?",
            hours: "uint?",
            minutes: "uint?",
            responsible: "string?",
            categoryExpense: "string?",
            defaultValueLogisticExpense: "bool?",
            value: "money?",
            cardsAndBraceletsTypes: "string?",
            initialQty: "uint?",
            qtyExchangeByProduct: "uint?",
            finalQty: "uint?",
            categoryOthersExpense: "string?",
            qtyExpense: "uint?",
            equipment: "string?",
            breakdown: "string?",
            breakage: "string?",
            qtyEquipments: "uint?",
            othersUsedEquipmentsType: "string?",
            description: "string?",
            pointOfSales: "string?",
            pointOfSalesType: "string?",
            equipmentUse: "string?",
            advanceFee: "float?"
        },
        EventOperationExpenseTranslatedField: {
            id: "string",
            name: "string"
        },
        EventOperationExpenseRequest: {
            eventOperationId: "uuid",
            category: "EventOperationExpenseCategory",
            role: "string?",
            setupDays: "uint?",
            operationDays: "uint?",
            operatorsCount: "uint?",
            hours: "uint?",
            minutes: "uint?",
            responsible: "string?",
            categoryExpense: "string?",
            defaultValueLogisticExpense: "bool?",
            value: "money?",
            cardsAndBraceletsTypes: "string?",
            initialQty: "uint?",
            qtyExchangeByProduct: "uint?",
            finalQty: "uint?",
            categoryOthersExpense: "string?",
            qtyExpense: "uint?",
            equipment: "string?",
            breakdown: "string?",
            breakage: "string?",
            qtyEquipments: "uint?",
            othersUsedEquipmentsType: "string?",
            description: "string?",
            pointOfSales: "string?",
            pointOfSalesType: "string?",
            equipmentUse: "string?",
            advanceFee: "float?",
            attachments: "Attachment[]?"
        },
        EventOperationExpenseResponse: {
            id: "uuid",
            eventOperationId: "uuid",
            category: "EventOperationExpenseCategory",
            role: "EventOperationExpenseTranslatedField?",
            setupDays: "uint?",
            operationDays: "uint?",
            operatorsCount: "uint?",
            hours: "uint?",
            minutes: "uint?",
            responsible: "EventOperationExpenseTranslatedField?",
            categoryExpense: "EventOperationExpenseTranslatedField?",
            defaultValueLogisticExpense: "bool?",
            value: "money?",
            cardsAndBraceletsTypes: "EventOperationExpenseTranslatedField?",
            initialQty: "uint?",
            qtyExchangeByProduct: "uint?",
            finalQty: "uint?",
            categoryOthersExpense: "EventOperationExpenseTranslatedField?",
            qtyExpense: "uint?",
            equipment: "string?",
            breakdown: "EventOperationExpenseTranslatedField?",
            breakage: "EventOperationExpenseTranslatedField?",
            qtyEquipments: "uint?",
            othersUsedEquipmentsType: "EventOperationExpenseTranslatedField?",
            description: "string?",
            attachments: "AttachmentResponse[]?",
            createdBy: "string?",
            pointOfSales: "string?",
            pointOfSalesType: "EventOperationExpenseTranslatedField?",
            equipmentUse: "EventOperationExpenseTranslatedField?",
            advanceFee: "float?"
        },
        FieldsExpenseCategories: {
            id: "string",
            name: "string?",
            type: "string",
            index: "int",
            options: "ExpenseCategoriesFieldOption[]?"
        },
        ExpenseCategoriesFieldOption: {
            id: "string",
            name: "string?"
        },
        EventOperationExpenseFormFieldsResponse: {
            id: "EventOperationExpenseCategory",
            name: "string?",
            index: "int",
            fields: "FieldsExpenseCategories[]?"
        },
        EventOperation: {
            name: "string",
            placeId: "uuid",
            operationId: "uuid?",
            beginAt: "date",
            endAt: "date"
        },
        EventOperationRequest: {
            name: "string",
            placeId: "uuid",
            operationId: "uuid?",
            beginAt: "date",
            endAt: "date"
        },
        EventOperationResponse: {
            name: "string",
            placeId: "uuid",
            events: "EventOperationEvent[]",
            id: "uuid",
            status: "EventOperationStatus",
            beginAt: "datetime",
            endAt: "datetime",
            reproved: "bool",
            operationId: "uuid?"
        },
        EventOperationCompleteResponse: {
            name: "string",
            placeId: "uuid",
            events: "EventOperationEvent[]",
            id: "uuid",
            status: "EventOperationStatus",
            beginAt: "datetime",
            endAt: "datetime",
            reproved: "bool",
            operationId: "uuid?",
            placeName: "string",
            locationName: "string",
            organizationName: "string",
            organizationId: "uuid",
            isKeyAccount: "bool",
            createdBy: "string",
            createdAt: "datetime",
            contractNumber: "int?",
            customerName: "string?",
            customerDocument: "string?",
            hasExpenses: "bool",
            isHouse: "bool",
            executiveName: "string?"
        },
        EventOperationExpensesByCategory: {
            category: "EventOperationExpenseCategory",
            expenses: "EventOperationExpenseResponse[]"
        },
        EventOperationFilter: {
            key: "string",
            values: "string[]"
        },
        EventOperationEventSize: {
            id: "string",
            name: "string"
        },
        EventOperationEventSizeType: {
            id: "string",
            name: "string",
            defaultFreightValue: "money?",
            index: "int"
        },
        UpdateEventOperationEventSizeRequest: {
            eventOperationId: "uuid",
            eventOperationEventSizeId: "string"
        },
        EventOperationEventsResponse: {
            placeId: "uuid",
            events: "EventOperationEvent[]"
        },
        EventOperationEvent: {
            id: "uuid",
            name: "string",
            beginAt: "datetime"
        },
        ApproveEventOperationRequest: {
            eventOperationId: "uuid"
        },
        RejectEventOperationRequest: {
            eventOperationId: "uuid",
            description: "string"
        },
        EventOperationHistory: {
            date: "datetime",
            status: "string",
            observation: "string?",
            createdBy: "string",
            financialAnalysisDocumentUrl: "string?",
            financialClosingResponse: "RequestClosingOfEventOperationResponse?"
        },
        EventOperationFinancialDocumentUploaded: {
            eventOperationId: "uuid",
            url: "string",
            fileKey: "string"
        },
        EventOperationOperation: {
            id: "uuid",
            dealName: "string",
            dealId: "string"
        },
        RequestClosingOfEventOperationResponseSummary: {
            totalIntegratedAcquirer: "money",
            totalNonIntegratedAcquirer: "money",
            totalZigInvoice: "money",
            totalWithdrawals: "money",
            finalBalance: "money"
        },
        RequestClosingOfEventOperationResponse: {
            placeName: "string",
            eventOperationBeginAt: "date",
            eventOperationEndAt: "date",
            contractNumber: "money",
            platform: "string",
            locationOffice: "string",
            locationCountry: "string",
            placeId: "string",
            organizationId: "string",
            organizationName: "string",
            currency: "string?",
            clientCorporateName: "string?",
            clientDocument: "string?",
            zigDocument: "string",
            zigName: "string",
            zigAddress: "string",
            eventType: "string",
            finderName: "string",
            eventBillingType: "string",
            eventModel: "string",
            automaticRepayment: "bool",
            contractStartDate: "date",
            contractEndDate: "date",
            ownerId: "money?",
            clientCode: "money?",
            eventsStartAt: "date?",
            eventsEndAt: "date?",
            isHouse: "bool?",
            zigFee: "money?",
            totalProcessedValue: "money",
            futureFinancialEntries: "RequestClosingOfEventOperationFutureFinancialEntry[]?",
            zigInvoice: "EventOperationClosingGroup[]",
            zigInvoiceSummary: "EventOperationClosingGroupSummary[]",
            adjustsWithUnitValue: "RequestClosingOfEventOperationAdjustsWithUnitValue[]?",
            summary: "RequestClosingOfEventOperationResponseSummary"
        },
        RequestClosingOfEventOperationAdjustsWithUnitValue: {
            category: "string",
            obs: "string",
            value: "money",
            unitValue: "money?",
            skipped: "bool?"
        },
        RequestClosingOfEventOperationFutureFinancialEntry: {
            groupId: "string?",
            groupName: "string?",
            typeId: "string",
            typeName: "string",
            categoryId: "string?",
            categoryName: "string?",
            referenceDate: "datetime?",
            originalPayDate: "datetime?",
            value: "money?",
            obs: "string?"
        },
        EventOperationClosingGroup: {
            id: "string",
            name: "string",
            total: "money",
            types: "EventOperationClosingGroupEntry[]",
            parentGroupId: "string?",
            sortOrder: "int",
            groups: "EventOperationClosingGroup[]"
        },
        EventOperationClosingGroupSummary: {
            id: "string",
            name: "string",
            total: "money"
        },
        EventOperationClosingGroupEntry: {
            id: "string",
            name: "string",
            value: "money",
            obs: "string?"
        },
        EventOperationUsedEquipmentRequest: {
            eventOperationId: "uuid",
            eventId: "uuid?",
            eventDate: "datetime?",
            qtyEquipments: "uint",
            attachment: "Attachment?",
            equipmentType: "EquipmentType?"
        },
        EventOperationUsedEquipmentResponse: {
            id: "uuid?",
            eventOperationId: "uuid",
            eventId: "uuid?",
            eventDate: "datetime?",
            eventName: "string?",
            qtyEquipments: "int?",
            attachment: "AttachmentResponse?",
            equipmentType: "EquipmentType?",
            unitValue: "money?",
            bonusQty: "int?",
            netQty: "int?",
            periodicity: "EquipmentBillingPeriodicity?",
            total: "money?",
            createdBy: "string?",
            createdAt: "datetime?",
            updatedAt: "datetime?"
        },
        EventOperationUsedEquipmentBatch: {
            eventOperationId: "uuid",
            equipments: "EventOperationUsedEquipmentItem[]"
        },
        EventOperationUsedEquipmentItem: {
            eventId: "uuid?",
            eventDate: "datetime?",
            qtyEquipments: "uint",
            attachment: "Attachment?",
            equipmentType: "EquipmentType?"
        },
        EventOperationUsedEquipmentListResponse: {
            eventOperationId: "uuid",
            equipments: "EventOperationUsedEquipmentResponse[]"
        },
        ChargeError: {
            kind: "ChargeErrorKind",
            rawValue: "string?",
            message: "string"
        },
        OperationChargePreview: {
            section: "int",
            subcategory: "string?",
            description: "string?",
            sourceRowId: "uuid?",
            financialCategory: "string",
            type: "ChargeType",
            periodicity: "EquipmentBillingPeriodicity?",
            equipmentType: "EquipmentType?",
            unitValue: "money?",
            grossQuantity: "int?",
            bonifiedQuantity: "int?",
            netQuantity: "int?",
            total: "money?",
            status: "ChargeStatus",
            error: "ChargeError?"
        },
        OperationChargesPreviewResponse: {
            eventOperationId: "uuid",
            isHouse: "bool",
            charges: "OperationChargePreview[]",
            grandTotal: "money",
            hasBlockingErrors: "bool",
            calculatedAt: "datetime",
            contractLastUpdatedAt: "datetime?"
        },
        BaseEmployeeBars: {
            id: "string",
            isMainBar: "bool",
            shouldPrint: "bool"
        },
        BaseEmployee: {
            name: "string",
            zigReadPermissionKey: "string?",
            permissions: "Permission[]",
            role: "Role?",
            places: "string[]",
            bars: "BaseEmployeeBars[]",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?",
            password: "string?",
            isPDV: "bool?"
        },
        NewEmployee: {
            name: "string",
            zigReadPermissionKey: "string?",
            permissions: "Permission[]",
            role: "Role?",
            places: "string[]",
            bars: "BaseEmployeeBars[]",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?",
            password: "string?",
            isPDV: "bool?",
            username: "string"
        },
        EditEmployee: {
            name: "string",
            zigReadPermissionKey: "string?",
            permissions: "Permission[]",
            role: "Role?",
            places: "string[]",
            bars: "BaseEmployeeBars[]",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?",
            password: "string?",
            isPDV: "bool?"
        },
        MultipleEmployeesBars: {
            id: "string",
            isMainBar: "bool",
            shouldPrint: "bool"
        },
        MultipleEmployees: {
            username: "string",
            name: "string",
            barId: "string?",
            bars: "MultipleEmployeesBars[]",
            placeIds: "string[]",
            since: "uint?",
            until: "uint?",
            permissions: "Permission[]",
            role: "Role?",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?"
        },
        AddMultipleEmployees: {
            success: "string[]",
            errors: "string[]"
        },
        MinimalEmployee: {
            id: "string",
            name: "string",
            username: "string?",
            avatar: "ImageUrl?"
        },
        AdjustRequest: {
            value: "money",
            obs: "string?",
            payDate: "datetime",
            costCenter: "string?",
            billType: "string?",
            date: "datetime",
            category: "AdjustCategory?"
        },
        AdjustResponse: {
            id: "uuid",
            isWithdrawn: "bool",
            value: "money",
            obs: "string?",
            payDate: "datetime",
            costCenter: "string?",
            billType: "string?",
            date: "datetime",
            category: "AdjustCategory?"
        },
        ExtractAdjustPaymentLink: {
            id: "string",
            url: "string",
            status: "string"
        },
        InsertExtractAdjustResult: {
            id: "uuid",
            isWithdrawn: "bool",
            value: "money",
            obs: "string?",
            payDate: "datetime",
            costCenter: "string?",
            billType: "string?",
            date: "datetime",
            category: "AdjustCategory?",
            paymentLink: "ExtractAdjustPaymentLink?"
        },
        DayResume: {
            date: "date",
            withdrew: "money",
            in: "money",
            out: "money"
        },
        ExtractResume: {
            available: "money",
            availableInTwoDays: "money",
            toBeReleased: "money",
            availableInMoreThanOneMonth: "money",
            retainedValues: "RetainedValues",
            netValueAvailableToWithdraw: "money",
            grossValueAvailabletoAnticipate: "money",
            netValueAvailableToAnticipate: "money",
            totalRetainedWithdrawValue: "money"
        },
        Fee: {
            zigMachineCredit: "float",
            zigMachineDebit: "float",
            inHouse: "float",
            app: "float",
            rechargeRemainings: "float",
            bonus: "float",
            minimumConsumption: "float"
        },
        RechargeAvailable: {
            id: "string",
            user: "string",
            totalValue: "money",
            usedValue: "money",
            createdAt: "datetime",
            expiredAt: "datetime",
            fee: "float",
            availableValue: "money",
            withdrew: "money"
        },
        RechargeExpireResume: {
            toBeAvailable: "money",
            rechargesAvailable: "money"
        },
        ExtractDayResumeSectionValues: {
            modality: "string",
            totalValue: "money",
            tax: "float?",
            payValue: "money"
        },
        ExtractDayResumeSection: {
            title: "string",
            description: "string?",
            tooltip: "string?",
            date: "date?",
            values: "ExtractDayResumeSectionValues[]"
        },
        RechargeExpireDayResume: {
            expired: "uint",
            date: "date",
            toExpire: "uint"
        },
        BankPaymentSlipInfo: {
            beneficiary: "string?",
            barCode: "string?",
            dueDate: "datetime?"
        },
        WithdrawBankAccount: {
            id: "uuid",
            name: "string"
        },
        WithdrawEmployee: {
            id: "string",
            name: "string",
            username: "string"
        },
        WithdrawVendor: {
            id: "uuid",
            name: "string",
            username: "string"
        },
        Withdraw: {
            id: "string",
            type: "WithdrawType",
            date: "datetime",
            status: "WithdrawStatus",
            anticipationFee: "float?",
            paymentMethod: "string?",
            clientObservation: "string?",
            obs: "string?",
            proRataFee: "float?",
            withdrawValue: "money",
            anticipationValue: "money",
            attachments: "string[]?",
            bankPaymentSlipInfo: "BankPaymentSlipInfo?",
            bankAccount: "WithdrawBankAccount?",
            employee: "WithdrawEmployee?",
            vendor: "WithdrawVendor?"
        },
        ConsolidatedExtract: {
            sections: "ConsolidatedExtractSection[]",
            availableValue: "money",
            withdrewValue: "money",
            anticipatedValue: "money"
        },
        ConsolidatedExtractSectionValues: {
            title: "string",
            hideIfZero: "bool",
            totalValueUnit: "ConsolidatedExtractSectionValuesTotalValueUnit",
            totalValue: "money?",
            maxFee: "float?",
            minFee: "float?",
            payValue: "money",
            highlighted: "bool"
        },
        ConsolidatedExtractSection: {
            title: "string",
            description: "string",
            values: "ConsolidatedExtractSectionValues[]"
        },
        ExtractFlowRow: {
            id: "string",
            date: "date",
            title: "string",
            value: "money",
            balance: "money",
            competency: "date"
        },
        DebitNote: {
            id: "string",
            placeId: "string",
            status: "DebitNoteStatus",
            value: "money",
            since: "datetime",
            until: "datetime",
            generatedAs: "DebitNoteGeneratedAs",
            pdf: "string?",
            serialNumber: "uint"
        },
        DebitNoteWithPlace: {
            id: "string",
            placeId: "string",
            status: "DebitNoteStatus",
            value: "money",
            since: "datetime",
            until: "datetime",
            generatedAs: "DebitNoteGeneratedAs",
            pdf: "string?",
            serialNumber: "uint",
            placeName: "string",
            isPlaceRegistered: "bool"
        },
        RentNote: {
            id: "string",
            placeId: "string",
            status: "RentNoteStatus",
            value: "money",
            since: "datetime",
            until: "datetime",
            generatedAs: "RentNoteGeneratedAs",
            pdf: "string?",
            serialNumber: "uint"
        },
        RentNoteWithPlace: {
            id: "string",
            placeId: "string",
            status: "RentNoteStatus",
            value: "money",
            since: "datetime",
            until: "datetime",
            generatedAs: "RentNoteGeneratedAs",
            pdf: "string?",
            serialNumber: "uint",
            placeName: "string",
            isPlaceRegistered: "bool"
        },
        RetainedValuesVendor: {
            withdraw: "money",
            anticipation: "money",
            pendingWithdraw: "money",
            pendingAnticipation: "money"
        },
        RetainedValues: {
            vendor: "RetainedValuesVendor",
            twentyPercent: "money"
        },
        BaseFinancialChargeConfig: {
            placeId: "string",
            value: "uint",
            category: "AdjustCategory",
            name: "string",
            productCount: "uint",
            recurrence: "BaseFinancialChargeConfigRecurrence",
            validSince: "date",
            validUntil: "date?"
        },
        FinancialChargeConfig: {
            id: "string",
            placeId: "string",
            value: "uint",
            category: "AdjustCategory",
            name: "string",
            productCount: "uint",
            recurrence: "BaseFinancialChargeConfigRecurrence",
            validSince: "date",
            validUntil: "date?"
        },
        FinancialExtractBlockPlace: {
            id: "string",
            name: "string"
        },
        FinancialExtractBlockCreatedByAdmin: {
            id: "string",
            name: "string"
        },
        FinancialExtractBlockReleaseAdmin: {
            id: "string",
            name: "string"
        },
        FinancialExtractBlock: {
            id: "string",
            place: "FinancialExtractBlockPlace",
            createdByAdmin: "FinancialExtractBlockCreatedByAdmin?",
            type: "FinancialExtractBlockType",
            date: "date",
            value: "money",
            reason: "string",
            isReleased: "bool",
            releaseDate: "datetime?",
            releaseAdmin: "FinancialExtractBlockReleaseAdmin?",
            blockType: "string?",
            blockCategory: "string?",
            blockObservation: "string?",
            canBeReleased: "bool?",
            receivableCompetenceDate: "date?",
            receivableLiquidationDate: "date?",
            receivableType: "FinancialExtractBlockReceivableType?"
        },
        IssueResult: {
            issuedInvoices: "Invoice[]",
            errors: "string[]",
            failedInvoiceCount: "uint"
        },
        InvoiceJsonOrgAddress: {
            logradouro: "string",
            numero: "string",
            cep: "string",
            bairro: "string",
            municipio: "string"
        },
        InvoiceJsonOrg: {
            cnpj: "string",
            razaoSocial: "string",
            inscricaoEstadual: "string",
            address: "InvoiceJsonOrgAddress"
        },
        InvoiceJsonDest: {
            name: "string?",
            cpf: "string?",
            cnpj: "string?"
        },
        InvoiceJsonProducts: {
            codigo: "string",
            name: "string",
            value: "float",
            discountValue: "float",
            count: "float",
            ncm: "string?",
            cfop: "string?",
            code: "string?",
            origem: "string?",
            cst: "string?",
            csosn: "string?",
            aliquota: "string?"
        },
        InvoiceJsonPayments: {
            value: "float",
            type: "string"
        },
        InvoiceJson: {
            title: "string",
            accessKey: "string",
            number: "string",
            serial: "string",
            qrcodeUrl: "string",
            date: "datetime",
            org: "InvoiceJsonOrg",
            dest: "InvoiceJsonDest?",
            products: "InvoiceJsonProducts[]",
            tributeInfo: "string?",
            payments: "InvoiceJsonPayments[]"
        },
        Permission: {
            name: "string",
            slug: "string",
            type: "string?",
            isManagerial: "bool?",
            isPaymentMethod: "bool?"
        },
        ChildPermission: {
            name: "string",
            slug: "string",
            type: "string?",
            isManagerial: "bool?",
            isPaymentMethod: "bool?",
            parent: "string?"
        },
        Role: {
            permissions: "ChildPermission[]",
            name: "string",
            slug: "string",
            isBase: "bool"
        },
        SimplifiedRolePermissions: {
            name: "string",
            slug: "string"
        },
        SimplifiedRole: {
            permissions: "SimplifiedRolePermissions[]",
            name: "string",
            slug: "string"
        },
        BasePrechargeOperationRechargesPeriod: {
            since: "datetime",
            until: "datetime"
        },
        BasePrechargeOperationMainPageInfo: {
            title: "string",
            subTitle: "string"
        },
        BasePrechargeOperationRechargesLimit: {
            minimumValue: "uint",
            maximumValuePerUser: "uint"
        },
        BasePrechargeOperation: {
            placeId: "uuid",
            name: "string",
            email: "string",
            slug: "string",
            endsAt: "datetime",
            rechargesPeriod: "BasePrechargeOperationRechargesPeriod",
            primaryColor: "string",
            mainPageInfo: "BasePrechargeOperationMainPageInfo",
            rechargesLimit: "BasePrechargeOperationRechargesLimit",
            preSetedValues: "uint[]",
            bonus: "PrechargeOperationBonus[]",
            paymentMethods: "PrechargeOperationPaymentMethod[]",
            tips: "PrechargeOperationTip[]"
        },
        PrechargeOperationBonus: {
            value: "uint",
            bonusValue: "uint",
            type: "PrechargeOperationBonusType"
        },
        PrechargeOperationTip: {
            title: "string",
            description: "string"
        },
        PrechargeOperation: {
            placeId: "uuid",
            name: "string",
            email: "string",
            slug: "string",
            endsAt: "datetime",
            rechargesPeriod: "BasePrechargeOperationRechargesPeriod",
            primaryColor: "string",
            mainPageInfo: "BasePrechargeOperationMainPageInfo",
            rechargesLimit: "BasePrechargeOperationRechargesLimit",
            preSetedValues: "uint[]",
            bonus: "PrechargeOperationBonus[]",
            paymentMethods: "PrechargeOperationPaymentMethod[]",
            tips: "PrechargeOperationTip[]",
            id: "uuid",
            logoUrl: "string?",
            mainImageUrl: "string?"
        },
        PrechargesFilters: {
            placeIds: "string[]",
            period: "PeriodTime?",
            document: "string?",
            paymentId: "string?",
            isUsed: "bool?",
            status: "PrechargeStatus[]",
            email: "string?",
            acquirerTransactionId: "string?",
            name: "string?",
            paymentMethod: "PrechargeOperationPaymentMethod?"
        },
        Precharge: {
            pendingOnlineRechargeId: "string",
            name: "string",
            document: "string",
            date: "datetime",
            placeName: "string",
            value: "money",
            liability: "bool",
            score: "int?",
            paymentMethod: "string",
            bonusValue: "money",
            cardSummary: "string?",
            status: "PrechargeStatus",
            isUsed: "bool",
            cardBrand: "string?",
            email: "string?",
            acquirerTransactionId: "string?"
        },
        ProportionOfUnit: {
            quantity: "uint",
            basicStorageUnit: "BasicStorageUnit"
        },
        ConvertedProportionOfUnit: {
            unitQuantity: "int",
            originalUnitQuantity: "int",
            proportionOfUnit: "ProportionOfUnit"
        },
        ProductSoldMountableProducts: {
            id: "string",
            name: "string",
            count: "uint",
            section: "string",
            storageCount: "uint"
        },
        ProductSold: {
            id: "string",
            name: "string",
            category: "string",
            image: "ImageUrl?",
            count: "int",
            type: "SellableThing",
            totalValue: "money",
            totalDiscount: "money",
            fiscalCode: "string",
            mountableProducts: "ProductSoldMountableProducts[]",
            isMountable: "bool?",
            productUnitCost: "string?",
            proportionalValue: "ProportionalValue?",
            estimatedTax: "float?",
            isReturnable: "bool?"
        },
        ProductBarReportProducts: {
            transactionId: "string",
            id: "string",
            name: "string",
            image: "ImageUrl?",
            proportionalValue: "ProportionalValue?",
            count: "int",
            totalValue: "money",
            totalDiscount: "uint",
            estimatedTax: "float?",
            category: "string"
        },
        ProductBarReport: {
            id: "string",
            name: "string",
            products: "ProductBarReportProducts[]"
        },
        NewPlaceProductFiscalData: {
            ncm: "string?",
            cest: "string?",
            fiscalProfileId: "string?",
            fiscalProductGroupId: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?"
        },
        PlaceProductFiscalData: {
            ncm: "string?",
            cest: "string?",
            fiscalProfileId: "string?",
            fiscalProductGroupId: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?",
            status: "PlaceProductFiscalDataStatus"
        },
        TranslatedPlaceProductFiscalData: {
            ncm: "string?",
            cest: "string?",
            fiscalProfileId: "string?",
            fiscalProductGroupId: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?",
            status: "string"
        },
        ProductKind: {
            id: "string",
            masterKind: "string",
            name: "string",
            kindKey: "string?"
        },
        SuggestedImages: {
            tags: "string[]",
            id: "string",
            url: "string",
            weight: "float"
        },
        ProductImageSearch: {
            name: "string",
            category: "string"
        },
        ProductImageReferenceTag: {
            ptBr: "string?",
            esMx: "string?",
            enUs: "string?"
        },
        ProductImageReference: {
            imageId: "string",
            url: "string",
            tags: "ProductImageReferenceTag"
        },
        ProductRuleInputs: {
            id: "string",
            count: "uint",
            loss: "uint",
            basicStorageUnit: "string"
        },
        ProductRuleOutputs: {
            id: "string",
            count: "uint",
            basicStorageUnit: "string",
            value: "uint?"
        },
        ProductRule: {
            id: "string",
            inputs: "ProductRuleInputs[]",
            outputs: "ProductRuleOutputs[]"
        },
        ProductRuleWithResumeInputs: {
            id: "string",
            name: "string",
            count: "uint",
            loss: "uint",
            basicStorageUnit: "string",
            value: "string?",
            unitCostValue: "string?",
            totalCost: "string?",
            yieldPercentage: "float?",
            unitCostWithYield: "string?"
        },
        ProductRuleWithResumeOutputs: {
            id: "string",
            name: "string",
            count: "uint",
            basicStorageUnit: "string",
            value: "string?",
            unitCostValue: "string?"
        },
        ProductRuleWithResume: {
            id: "string",
            unitCostValue: "string?",
            value: "string?",
            cmvPercentage: "float?",
            inputs: "ProductRuleWithResumeInputs[]",
            outputs: "ProductRuleWithResumeOutputs[]"
        },
        RefundedProductRefundedBy: {
            name: "string",
            username: "string?"
        },
        RefundedProductSoldBy: {
            name: "string",
            username: "string?"
        },
        RefundedProduct: {
            id: "string",
            refundedAt: "datetime",
            name: "string",
            category: "string",
            unitValue: "money",
            count: "uint",
            refundedBy: "RefundedProductRefundedBy",
            refundObs: "string",
            buyers: "string[]",
            isCanceled: "bool",
            soldBy: "RefundedProductSoldBy?",
            operationType: "OperationType"
        },
        ResultSupplyProductionRuleInputs: {
            id: "string",
            name: "string",
            sku: "string?",
            image: "ImageUrl?",
            basicStorageUnit: "BasicStorageUnit",
            count: "money",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            loss: "money",
            lossByProportionOfUnit: "ConvertedProportionOfUnit?",
            yieldPercentage: "float?",
            unitCostValue: "string?",
            totalCost: "string?"
        },
        ResultSupplyProductionRuleOutput: {
            count: "money",
            countByProportionOfUnit: "ConvertedProportionOfUnit?"
        },
        ResultSupplyProductionRule: {
            id: "string",
            inputs: "ResultSupplyProductionRuleInputs[]",
            output: "ResultSupplyProductionRuleOutput"
        },
        SupplyWithProductionRuleAttachedTo: {
            id: "string",
            name: "string"
        },
        SupplyWithProductionRule: {
            id: "string",
            name: "string",
            sku: "string?",
            image: "ImageUrl?",
            createdAt: "datetime",
            basicStorageUnit: "BasicStorageUnit",
            yieldPercentage: "float?",
            productionRule: "ResultSupplyProductionRule",
            unitCostValue: "string?",
            attachedTo: "SupplyWithProductionRuleAttachedTo[]",
            proportionOfUnit: "ProportionOfUnit?"
        },
        BaseSystemProduct: {
            id: "string",
            productSk: "string",
            name: "string"
        },
        SystemProduct: {
            id: "string",
            productSk: "string",
            name: "string",
            imageUrl: "string?"
        },
        NewPromotionDiscountBonus: {
            bonusValue: "int"
        },
        NewPromotionDiscountDiscount: {
            cashDiscount: "int?",
            percentageDiscount: "float?",
            discountLimit: "int?",
            productsIds: "string[]"
        },
        NewPromotionDiscount: {
            bonus: "NewPromotionDiscountBonus?",
            discount: "NewPromotionDiscountDiscount?"
        },
        NewPromotionConditionsGuestList: {
            id: "string",
            cpf: "string",
            name: "string"
        },
        NewPromotionConditions: {
            guestList: "NewPromotionConditionsGuestList[]?",
            everybody: "bool?",
            checkinTime: "int?",
            birthdayPerson: "BirthdayPerson?",
            gender: "NewPromotionConditionsGender?",
            minimumValueConsumed: "int?",
            maximumValueConsumed: "int?",
            productsConsumed: "string[]?",
            productsConsumedQuantity: "int?",
            minimumPlaceFrequency: "int?",
            maximumPlaceFrequency: "int?",
            ppuUsage: "bool?",
            minimumRechargeValue: "int?"
        },
        NewPromotion: {
            isActive: "bool",
            name: "string",
            description: "string",
            placeIds: "string[]",
            maxUses: "uint?",
            secondsToExpire: "uint?",
            eventOnly: "bool?",
            weekDays: "WeekDay[]?",
            beginTime: "uint?",
            endTime: "uint?",
            frequencyOfEarning: "PromotionFrequencyOfEarning",
            typeOfDiscount: "PromotionDiscountType",
            discount: "NewPromotionDiscount",
            conditions: "NewPromotionConditions",
            automaticMessages: "bool?",
            whatsUp: "bool?"
        },
        Promotion: {
            id: "string",
            offlineId: "string?",
            isActive: "bool",
            name: "string",
            description: "string",
            placeIds: "string[]",
            maxUses: "uint?",
            secondsToExpire: "uint?",
            eventOnly: "bool?",
            weekDays: "WeekDay[]?",
            beginTime: "uint?",
            endTime: "uint?",
            frequencyOfEarning: "PromotionFrequencyOfEarning",
            typeOfDiscount: "PromotionDiscountType",
            discount: "NewPromotionDiscount",
            conditions: "NewPromotionConditions",
            automaticMessages: "bool?",
            whatsUp: "bool?"
        },
        PromotionUser: {
            id: "string",
            name: "string",
            cpf: "string",
            phone: "string",
            promotionId: "string"
        },
        BaseResponse: {
            id: "string",
            isDeleted: "bool",
            createdAt: "datetime",
            createdBy: "string"
        },
        BaseWithoutDeletedResponse: {
            id: "string",
            createdAt: "datetime",
            createdBy: "string"
        },
        BasePaginationResponse: {
            currentPage: "int",
            perPage: "int",
            total: "int",
            lastPage: "int"
        },
        PostPaymentEventEmployee: {
            name: "string",
            username: "string"
        },
        PostPaymentEventPayments: {
            method: "string",
            value: "int"
        },
        PostPaymentEventPayers: {
            cpf: "string",
            name: "string",
            email: "string?",
            phone: "string"
        },
        PostPaymentEvent: {
            acquirerTransactions: "AcquirerTransaction[]",
            createdAt: "datetime",
            createdBy: "string?",
            id: "string",
            eventId: "string?",
            event: "string?",
            beginAt: "datetime?",
            endAt: "datetime?",
            place: "string?",
            employee: "PostPaymentEventEmployee?",
            isDeleted: "bool",
            payments: "PostPaymentEventPayments[]",
            payers: "PostPaymentEventPayers[]",
            postPaymentType: "PostPaymentEventPostPaymentType"
        },
        AcquirerTransaction: {
            transactionId: "string?",
            acquirer: "string?",
            transactionUrl: "string?",
            cardBrand: "string?",
            cardHolderName: "string?",
            cardHolderNumber: "string?",
            authorizatedAmount: "int?",
            capturedAmount: "int?",
            isExpiredCreditCard: "bool?",
            expirationDate: "string?",
            paidAmount: "int?",
            transactionType: "string?",
            transactionStatus: "string?",
            type: "int?",
            amount: "int?"
        },
        NewMountableSectionItems: {
            productId: "string",
            storageCount: "uint",
            name: "string?",
            price: "uint",
            maxCount: "uint?",
            selectedCount: "uint?",
            hasAlcohol: "bool?"
        },
        NewMountableSection: {
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "NewMountableSectionPricing",
            items: "NewMountableSectionItems[]"
        },
        MountableSection: {
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "NewMountableSectionPricing",
            items: "NewMountableSectionItems[]",
            id: "string",
            order: "uint"
        },
        MountableSectionV2Items: {
            isActive: "bool",
            productId: "string",
            storageCount: "uint",
            name: "string?",
            price: "uint",
            maxCount: "uint?",
            selectedCount: "uint?",
            basicStorageUnit: "BasicStorageUnit?",
            hasAlcohol: "bool?",
            isModification: "bool?"
        },
        MountableSectionV2: {
            id: "string",
            order: "uint",
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "MountableSectionV2Pricing",
            fiscalWeight: "uint?",
            items: "MountableSectionV2Items[]"
        },
        UserAddressCep: {
            postalCode: "string",
            street: "string",
            neighborhood: "string?",
            state: "string",
            city: "string",
            stateAbbr: "string",
            municipalityCode: "string?",
            country: "string?",
            addressName: "string",
            number: "string",
            complement: "string?",
            nickname: "string?",
            createdBy: "string",
            mainAddress: "bool"
        },
        NewMountableDescription: {
            sections: "NewMountableSection[]"
        },
        MountableDescription: {
            sections: "MountableSection[]"
        },
        MountableDescriptionV2: {
            sections: "MountableSectionV2[]"
        },
        FiscalPrinter: {
            type: "PrinterType?",
            ip: "string",
            name: "string"
        },
        EditProductImage: {
            sha256: "string?",
            imageId: "string?",
            data: "bytes?"
        },
        Pagination: {
            currentPage: "int",
            perPage: "int"
        },
        PaginationResponse: {
            currentPage: "int",
            perPage: "int",
            total: "int",
            lastPage: "int"
        },
        AttachmentResponse: {
            name: "string",
            url: "string"
        },
        PeriodTime: {
            since: "datetime",
            until: "datetime"
        },
        VendorFinancialAdjustDto: {
            title: "string",
            category: "string?",
            vendorId: "string",
            eventId: "string?",
            placeId: "string",
            value: "int",
            obs: "string",
            date: "datetime",
            originalPayDate: "date"
        },
        VendorFinancialAdjustResponse: {
            id: "string",
            isDeleted: "bool",
            createdAt: "datetime",
            createdBy: "string",
            title: "string",
            category: "string?",
            vendorId: "string",
            eventId: "string?",
            placeId: "string",
            value: "int",
            obs: "string",
            date: "datetime",
            originalPayDate: "date",
            vendorClosingValueId: "string",
            vendorName: "string"
        },
        VendorFeature: {
            id: "string",
            name: "string",
            isActive: "bool",
            description: "string?"
        },
        VendorPaymentMethodFees: {
            credit: "float?",
            debit: "float?",
            pix: "float?"
        },
        VendorFees: {
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees"
        },
        VendorSettings: {
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool"
        },
        VendorPlaceRequest: {
            id: "uuid",
            barIds: "string[]"
        },
        VendorPlaceResponseBars: {
            id: "uuid",
            name: "string"
        },
        VendorPlaceResponse: {
            id: "uuid",
            name: "string",
            bars: "VendorPlaceResponseBars[]"
        },
        VendorProductRequest: {
            productId: "uuid",
            fee: "float"
        },
        VendorDocumentAddress: {
            postalCode: "string?",
            streetName: "string?",
            addressNumber: "string?",
            city: "string?",
            state: "string?",
            province: "string?",
            complement: "string?"
        },
        VendorDocument: {
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?"
        },
        BaseVendorOrg: {
            name: "string",
            login: "string",
            organizationId: "uuid",
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool",
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?"
        },
        VendorRequest: {
            name: "string",
            login: "string",
            organizationId: "uuid",
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool",
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?",
            places: "VendorPlaceRequest[]",
            productFees: "VendorProductRequest[]?"
        },
        VendorOrg: {
            name: "string",
            login: "string",
            organizationId: "uuid",
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool",
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?",
            places: "VendorPlaceResponse[]",
            productFees: "VendorProductRequest[]?",
            vendorEmployees: "VendorEmployeeResponse[]?",
            id: "uuid"
        },
        VendorEmployee: {
            name: "string",
            email: "string",
            password: "string",
            permissions: "string[]"
        },
        VendorEmployeeResponse: {
            id: "string",
            createdBy: "string",
            vendorId: "string",
            name: "string",
            email: "string",
            password: "string",
            permissions: "string[]"
        },
        MetabaseIntegrationEmbeddingParams: {
            key: "string",
            config: "MetabaseIntegrationEmbeddingParamsConfig"
        },
        MetabaseIntegrationLastEditInfo: {
            id: "int",
            email: "string",
            firstName: "string",
            lastName: "string",
            updatedAt: "datetime"
        },
        MetabaseIntegrationResource: {
            id: "int",
            name: "string",
            archived: "bool",
            createdAt: "datetime",
            embeddingParams: "MetabaseIntegrationEmbeddingParams[]?",
            lastEditInfo: "MetabaseIntegrationLastEditInfo"
        },
        ParameterNameConfiguration: {
            originalParameter: "string",
            renamedParameter: "string"
        },
        MetabaseResponse: {
            id: "string",
            code: "int",
            name: "string",
            type: "MetabaseResourceType",
            isGeneric: "bool",
            parameterNameConfiguration: "ParameterNameConfiguration[]?",
            isDeleted: "bool",
            createdBy: "string"
        },
        OrganizationMetabaseResponse: {
            id: "string",
            metabaseId: "string",
            name: "string?",
            organizationId: "string",
            placeIds: "string[]?",
            isDeleted: "bool",
            createdAt: "date",
            createdBy: "string",
            updatedAt: "date",
            metabase: "MetabaseResponse",
            contextLevel: "OrganizationMetabaseContextLevel[]"
        },
        UserConsentResponse: {
            id: "uuid",
            cpf: "string",
            hasAcceptedToShareData: "bool",
            date: "datetime",
            src: "ConsentSource"
        },
        CampaignClientInfoPlace: {
            id: "string",
            name: "string"
        },
        CampaignClientInfo: {
            phone: "string",
            place: "CampaignClientInfoPlace",
            optout: "bool"
        },
        UserPlaceInfo: {
            placeId: "string",
            phone: "string",
            userId: "string"
        },
        ConfirmOptOutParams: {
            phone: "string",
            placeId: "string",
            channel: "Channel",
            isCampaign: "bool",
            createdBy: "string",
            optOutFromZig: "bool",
            userId: "string?",
            reason: "string?"
        },
        DBOptOut: {
            date: "datetime",
            userId: "string?",
            phone: "string?",
            placeId: "string?",
            reason: "string?",
            optOutFromZig: "bool",
            isCampaign: "bool",
            channel: "Channel"
        },
        DeliveryBaseAddress: {
            streetName: "string",
            city: "string",
            country: "string",
            state: "string",
            neighborhood: "string",
            postalCode: "string",
            complement: "string?"
        },
        DeliveryAddress: {
            streetName: "string",
            city: "string",
            country: "string",
            state: "string",
            neighborhood: "string",
            postalCode: "string",
            complement: "string?",
            formattedAddress: "string",
            streetNumber: "string"
        },
        Customer: {
            name: "string",
            email: "string",
            phone: "string",
            isWhatsapp: "bool?",
            documentNumber: "string?",
            documentType: "UserDocumentType?",
            address: "Address?",
            userId: "string?"
        },
        OrderFee: {
            name: "string",
            description: "string?",
            value: "uint",
            issueInvoice: "bool",
            receivedBy: "TipReceiver?"
        },
        SimplifiedOrderIfoodScheduleSchedule: {
            deliveryDateTimeStart: "datetime",
            deliveryDateTimeEnd: "datetime"
        },
        SimplifiedOrderIfoodSchedule: {
            schedule: "SimplifiedOrderIfoodScheduleSchedule?",
            preparationStartDateTime: "datetime?"
        },
        SimplifiedOrder: {
            id: "string",
            date: "datetime",
            reference: "uint",
            status: "OrderStatus",
            vendor: "Vendor",
            value: "uint",
            deliveryFee: "uint",
            discountValueDeliveryFee: "uint?",
            tip: "uint",
            deliveryType: "DeliveryType",
            customer: "Customer",
            externalReference: "string?",
            cancellationReason: "string?",
            cancellationObs: "string?",
            ifoodSchedule: "SimplifiedOrderIfoodSchedule?",
            isPostPaid: "bool",
            discountValue: "uint",
            transactionId: "string?",
            deliverySource: "DeliverySource?",
            orderFees: "OrderFee[]?"
        },
        OrderFilter: {
            status: "OrderStatus[]",
            since: "datetime",
            until: "datetime"
        },
        DeliveryOrderStatus: {
            date: "datetime",
            status: "OrderStatus"
        },
        MountableSectionItem: {
            id: "string?",
            name: "string",
            count: "uint",
            order: "uint",
            title: "string",
            storageCount: "uint",
            maxCount: "uint?",
            price: "uint",
            isActive: "bool",
            basicStorageUnit: "string"
        },
        SectionItems: {
            id: "string?",
            name: "string?",
            count: "uint",
            eventId: "string",
            value: "uint",
            discountValue: "uint",
            transactionType: "string",
            transactionId: "string",
            promotionId: "string?",
            onlineFichaId: "string?",
            exportedAt: "datetime?",
            sections: "MountableSectionItem[]?"
        },
        GetOrdersResponsePayment: {
            method: "PaymentMethod",
            adyenCard: "AdyenCardPayment?",
            isPayOnDelivery: "bool?"
        },
        GetOrdersResponse: {
            items: "SectionItems[]?",
            statusHistory: "DeliveryOrderStatus[]",
            tip: "uint",
            value: "uint",
            transactionId: "string",
            payment: "GetOrdersResponsePayment?",
            id: "string",
            onlineFichaId: "string",
            exportedAt: "datetime?"
        },
        PlaceActivePromoters: {
            promoterId: "string",
            name: "string",
            email: "string"
        },
        CashierAdjustmentAuthor: {
            id: "string",
            name: "string",
            username: "string?"
        },
        CashierAdjustmentCashier: {
            id: "uuid",
            name: "string",
            username: "string?"
        },
        CashierAdjustment: {
            id: "uuid",
            author: "CashierAdjustmentAuthor",
            cashier: "CashierAdjustmentCashier",
            value: "uint",
            type: "CashierAdjustmentType",
            timestamp: "datetime",
            obs: "string?"
        },
        CloseMethod: {
            method: "CloseMethodEnum",
            brand: "string?"
        },
        MoneyReceived: {
            method: "AllMethods",
            value: "int"
        },
        CloseValue: {
            method: "CloseMethodEnum",
            brand: "string?",
            value: "uint"
        },
        CashierBleedings: {
            id: "string",
            author: "string",
            date: "datetime",
            value: "int"
        },
        CashierClosed: {
            author: "string",
            authorUsername: "string?",
            date: "datetime"
        },
        Cashier: {
            id: "string",
            name: "string",
            username: "string?",
            rechargeMoneyReceived: "MoneyReceived[]",
            postPaidMoneyReceived: "MoneyReceived[]",
            cashZigTagDevolutions: "uint",
            rechargeDevolutions: "uint",
            singleProductReturns: "uint",
            bleedings: "CashierBleedings[]",
            closedValues: "CloseValue[]",
            closed: "CashierClosed?",
            type: "EmployeeType?"
        },
        ZigDeviceGroup: {
            id: "string",
            name: "string",
            placeId: "string"
        },
        PixCharge: {
            id: "string",
            value: "uint",
            emv: "string"
        },
        PixChargePaidResponse: {
            status: "PixChargePaidResponseStatus",
            message: "string?"
        },
        EntranceDetail: {
            id: "uuid",
            count: "int",
            name: "string",
            userPaidValue: "int",
            totalDiscountValue: "int"
        },
        ProductReturn: {
            id: "string",
            isShared: "bool",
            name: "string",
            value: "uint",
            count: "uint",
            discountValue: "uint"
        },
        ProductRefunds: {
            id: "string",
            name: "string",
            count: "int"
        },
        ConsumptionObligation: {
            id: "uuid",
            value: "int",
            paidValue: "int",
            eventId: "uuid"
        },
        OpenBillChargeEventData: {
            id: "uuid",
            name: "string",
            date: "date",
            status: "string"
        },
        OpenBillEventInfo: {
            eventData: "OpenBillChargeEventData",
            products: "ProductReturn[]",
            value: "int",
            paidValue: "int",
            tip: "int",
            paidTip: "int"
        },
        OpenBillChargeDetails: {
            userName: "string?",
            placeData: "PlaceDetails",
            openBillChargeData: "OpenBillChargeData",
            eventsInfo: "OpenBillEventInfo[]"
        },
        PlaceDetails: {
            id: "uuid",
            placeName: "string",
            tipPercentage: "float"
        },
        OpenBillChargeData: {
            openBillTotalValue: "int",
            openBillTotalValuePaid: "int",
            openBillChargedTipValue: "int",
            consumedProducts: "ProductReturn[]"
        },
        ByPaymentMethodSummary: {
            App: "int",
            Cash: "int",
            DebitCard: "int",
            CreditCard: "int",
            Voucher: "int",
            ZigPosDebit: "int",
            ZigPosCredit: "int",
            PostEvent: "int",
            Dashboard: "int",
            Anticipated: "int",
            DeliveryOnline: "int",
            Consumption: "int",
            Ame: "int",
            Rappi: "int",
            Uber: "int",
            Ifood: "int",
            Bonus: "int",
            Pix: "int",
            Opened: "int",
            Other: "int",
            ZigPosCreditInInstallments: "int",
            IntegratedFoodVoucher: "int",
            MBWay: "int",
            Cashless: "int"
        },
        BarReport: {
            id: "string",
            name: "string",
            quantity: "uint",
            totalValue: "money",
            totalTaxAmount: "money?",
            totalDiscount: "money"
        },
        BarOrEmployeeFinance: {
            id: "string?",
            name: "string?",
            username: "string?",
            finance: "ByPaymentMethodSummary"
        },
        SellerReport: {
            id: "string",
            name: "string",
            username: "string?",
            isDeleted: "bool?",
            soldValue: "money",
            tip: "money",
            countSold: "int?"
        },
        EventResumeSectionValuesValues: {
            value: "float?",
            unit: "EventResumeSectionValuesValuesUnit"
        },
        EventResumeSectionValues: {
            name: "string",
            tooltip: "string?",
            values: "EventResumeSectionValuesValues[]",
            highlighted: "bool",
            hideIfZero: "bool"
        },
        EventResumeSection: {
            title: "string",
            description: "string?",
            columns: "string[]",
            values: "EventResumeSectionValues[]"
        },
        GetReportByScopeEvent: {
            id: "string"
        },
        GetReportByScopePlace: {
            id: "string",
            period: "PeriodTime"
        },
        GetReportByScope: {
            event: "GetReportByScopeEvent?",
            place: "GetReportByScopePlace?"
        },
        RechargeByZigDevice: {
            value: "money",
            rechargeType: "RechargeTypeEnum"
        },
        RechargeByZigCode: {
            zigCode: "string",
            reason: "string",
            value: "money"
        },
        RechargeResultsError: {
            recharge: "RechargeByZigCode",
            reason: "string"
        },
        RechargeResults: {
            success: "RechargeByZigCode[]",
            error: "RechargeResultsError[]"
        },
        PlaceContractEquipments: {
            type: "string",
            quantity: "int",
            unitValue: "int"
        },
        PublicDetail: {
            consumption: "money",
            new: "money",
            old: "money",
            zero: "money",
            consumptionPercetage: "float",
            inside: "money",
            total: "money"
        },
        NewPublic: {
            totalConsumption: "money?",
            totalPublic: "uint?",
            publicCapacity: "uint?",
            male: "PublicDetail",
            female: "PublicDetail",
            other: "PublicDetail"
        },
        NpsAnswer: {
            value: "uint",
            questionId: "QuestionType",
            comment: "string?"
        },
        BaseMenuConfig: {
            name: "string?",
            primaryColor: "string",
            secondaryColor: "string",
            contrastColor: "string",
            isOpenStatusVisible: "bool",
            isWaitingTimeVisible: "bool",
            taxType: "MenuConfigsTaxType?",
            baseRateValue: "float?",
            ratePerKm: "float?",
            waitingTime: "int?",
            additionalFieldType: "MenuConfigsAdditionalFieldType?",
            postalCode: "string?",
            state: "string?",
            city: "string?",
            neighborhood: "string?",
            address: "string?",
            number: "string?",
            complement: "string?"
        },
        GetMenuConfigResponse: {
            name: "string?",
            primaryColor: "string",
            secondaryColor: "string",
            contrastColor: "string",
            isOpenStatusVisible: "bool",
            isWaitingTimeVisible: "bool",
            taxType: "MenuConfigsTaxType?",
            baseRateValue: "float?",
            ratePerKm: "float?",
            waitingTime: "int?",
            additionalFieldType: "MenuConfigsAdditionalFieldType?",
            postalCode: "string?",
            state: "string?",
            city: "string?",
            neighborhood: "string?",
            address: "string?",
            number: "string?",
            complement: "string?",
            id: "string",
            slug: "string?",
            logoImage: "string?",
            bannerImage: "string?"
        },
        FichaSettings: {
            fontSize: "FichaFontSize?",
            imageSize: "FichaImageSize?",
            qrCodeSize: "FichaQRCodeSize?"
        },
        WalletSummary: {
            availableForWithdraw: "money",
            generalBlockedBalance: "money",
            withdrawBlockedBalance: "money",
            futureEntries: "money",
            totalBalance: "money",
            balance: "money",
            totalBlockedBalance: "money",
            futureFinancialEntriesForNext31Days: "money",
            availableForAnticipation: "money",
            futureFinancialEntriesAfter31Days: "money",
            notLiquidatedPairEntries: "money"
        },
        PairInfoRelatedVendor: {
            id: "string",
            name: "string"
        },
        PairInfo: {
            id: "string",
            name: "string",
            type: "PairInfoType",
            document: "string?",
            relatedVendor: "PairInfoRelatedVendor?"
        },
        FutureFinancialEntry: {
            typeId: "string",
            type: "string",
            categoryId: "string?",
            category: "string?",
            observation: "string?",
            competenceDate: "date",
            liquidationDate: "date",
            value: "money",
            originDestination: "PairInfo?"
        },
        FutureFinancialEntryByMonth: {
            year: "uint",
            month: "uint",
            entries: "FutureFinancialEntry[]"
        },
        FutureFinancialEntryGrouped: {
            entries: "FutureFinancialEntry[]",
            year: "uint?",
            month: "uint?",
            date: "string?",
            typeId: "string?",
            typeName: "string?",
            categoryId: "string?",
            categoryName: "string?"
        },
        WithdrawV2ItemRequestedBy: {
            id: "string",
            name: "string"
        },
        WithdrawV2ItemProRataFee: {
            value: "money",
            percentage: "float"
        },
        WithdrawV2ItemBankAccountReceiver: {
            bank: "string",
            agency: "string",
            account: "string",
            name: "string",
            documentNumber: "string",
            accountType: "string",
            documentType: "string"
        },
        WithdrawV2ItemBankAccount: {
            id: "uuid",
            name: "string",
            holder: "string",
            receiver: "WithdrawV2ItemBankAccountReceiver?",
            isDefault: "bool"
        },
        WithdrawV2Item: {
            id: "uuid",
            requestDate: "datetime",
            paymentDate: "datetime?",
            status: "WithdrawV2Status",
            statusText: "string",
            type: "WithdrawV2Type",
            typeText: "string",
            value: "money",
            requestedBy: "WithdrawV2ItemRequestedBy?",
            proRataFee: "WithdrawV2ItemProRataFee?",
            pixKey: "string?",
            reason: "string?",
            managerObs: "string?",
            attachments: "string[]?",
            bankAccount: "WithdrawV2ItemBankAccount?",
            originWithdrawRequestId: "uuid?",
            originationAnticipationWithdrawRequestId: "uuid?",
            wasDeclinedByInsufficientBalance: "bool?"
        },
        WithdrawV2Response: {
            items: "WithdrawV2Item[]",
            total: "uint"
        },
        ConsolidatedExtractV2GroupTypes: {
            id: "string",
            name: "string",
            typeId: "string?",
            categoryId: "string?",
            value: "money",
            grossValue: "money?",
            minFee: "float?",
            maxFee: "float?",
            obs: "string?",
            originDestination: "PairInfo?"
        },
        ConsolidatedExtractV2Group: {
            id: "string",
            name: "string",
            total: "money",
            types: "ConsolidatedExtractV2GroupTypes[]"
        },
        ConsolidatedExtractV2Balance: {
            initial: "money",
            period: "money",
            final: "money"
        },
        ConsolidatedExtractV2: {
            groups: "ConsolidatedExtractV2Group[]",
            balance: "ConsolidatedExtractV2Balance",
            total: "money"
        },
        ConsolidatedExtractCashFlowFutureEntries: {
            value: "money",
            groups: "ConsolidatedExtractV2Group[]"
        },
        ConsolidatedExtractCashFlow: {
            groups: "ConsolidatedExtractV2Group[]",
            balance: "ConsolidatedExtractV2Balance",
            total: "money",
            futureEntries: "ConsolidatedExtractCashFlowFutureEntries?"
        },
        AnticipatedEntryInfo: {
            id: "string",
            createdAt: "datetime",
            liquidationDate: "date",
            referenceDate: "date",
            type: "string",
            typeId: "string",
            category: "string?",
            observation: "string?",
            value: "money",
            originDestination: "PairInfo?"
        },
        DetailedEntry: {
            id: "string",
            createdAt: "datetime",
            liquidationDate: "date",
            referenceDate: "date",
            type: "string",
            typeId: "string",
            category: "string?",
            categoryId: "string?",
            groupId: "string?",
            groupName: "string?",
            observation: "string?",
            value: "money",
            originDestination: "PairInfo?"
        },
        ExtractFlowItemV2: {
            id: "string",
            createdAt: "datetime",
            liquidationDate: "date",
            referenceDate: "date",
            type: "string",
            typeId: "string",
            category: "string?",
            categoryId: "string?",
            groupId: "string?",
            groupName: "string?",
            observation: "string?",
            value: "money",
            originDestination: "PairInfo?",
            balance: "money",
            anticipated: "bool?",
            anticipatedEntries: "AnticipatedEntryInfo[]?",
            detailedEntries: "DetailedEntry[]?"
        },
        ExtractFlowResponseV2: {
            items: "ExtractFlowItemV2[]",
            total: "int",
            grandTotal: "money?"
        },
        GroupedExtractFlowItem: {
            groupKey: "string",
            totalValue: "money",
            items: "ExtractFlowItemV2[]?",
            initialBalance: "money?",
            totalIn: "money",
            totalOut: "money"
        },
        GroupedExtractFlowResponse: {
            groups: "GroupedExtractFlowItem[]",
            totalCount: "int",
            grandTotal: "money"
        },
        ClientProviderDocument: {
            id: "uuid",
            externalReference: "string?",
            documentNumber: "string?",
            documentType: "string?",
            clientType: "string?",
            provider: "string?",
            status: "string?",
            corporateName: "string?",
            fantasyName: "string?",
            contactName: "string?",
            email: "string?",
            cellPhone: "string?",
            telephone: "string?",
            postalCode: "string?",
            address: "string?",
            addressNumber: "string?",
            complement: "string?",
            neighborhood: "string?",
            city: "string?",
            state: "string?",
            operationType: "string?",
            mccCode: "string?",
            accreditationDate: "date?",
            liquidationBlocking: "bool?",
            createdAt: "datetime?",
            updatedAt: "datetime?",
            statusChangedAt: "datetime?",
            errType: "string?",
            err: "string?"
        },
        ReceivableUnit: {
            id: "uuid",
            placeId: "uuid?",
            referenceDate: "date",
            payDate: "date",
            type: "ReceivableUnitType",
            cardBrand: "string",
            grossValue: "money",
            taxValue: "money",
            netValue: "money",
            blockedValue: "money",
            anticipatedValue: "money",
            effectiveContractValue: "money",
            provider: "string",
            status: "string",
            errType: "string?",
            err: "string?",
            updatedAt: "date?",
            createdAt: "date",
            createdBy: "string",
            paymentAccountId: "string?",
            parentContractEffectPaymentAccountId: "string?",
            parentAnticipationConsolidatedId: "string?",
            isDeleted: "bool"
        },
        ReceivableUnitConsolidated: {
            id: "uuid",
            provider: "string",
            providerReference: "string",
            holderDocumentNumber: "string?",
            clientProviderDocumentId: "string",
            cardBrand: "string",
            cardType: "ReceivableUnitConsolidatedCardType",
            payDate: "date",
            creditorDocumentNumber: "string?",
            lastOperationType: "string?",
            status: "string",
            errType: "string?",
            err: "string?",
            updatedAt: "date",
            grossAmount: "money?",
            liquidAmount: "money?",
            onlineRiskAmount: "money?",
            physicalRiskAmount: "money?",
            anticipatedAmount: "money?",
            effectiveContractAmount: "money?",
            blockedAmount: "money?",
            taxAmount: "money?",
            lastProviderFileDispatchHistoryId: "string?",
            parentReceivableUnitConsolidatedId: "string?",
            isDeleted: "bool",
            createdAt: "date",
            createdBy: "string"
        },
        CentralLiquidationOperation: {
            id: "uuid",
            createdBy: "string",
            createdAt: "date",
            isDeleted: "bool",
            updatedAt: "date",
            placeId: "uuid",
            anticipationId: "uuid?",
            requestDate: "date",
            liquidationDate: "date",
            method: "string",
            provider: "string",
            status: "string",
            isZig: "bool",
            paymentAccountId: "uuid?"
        },
        CentralLiquidationOperationReceivableUnit: {
            centralLiquidationOperationId: "uuid",
            receivableUnitId: "uuid",
            nuLiquid: "string?",
            updatedAt: "date",
            err: "string?",
            externalId: "string",
            status: "string",
            lastStatus: "string",
            value: "int"
        },
        CentralLiquidationOperationReceivableUnitRelated: {
            centralLiquidationOperationId: "uuid",
            receivableUnitId: "uuid",
            nuLiquid: "string?",
            updatedAt: "date",
            err: "string?",
            externalId: "string",
            status: "string",
            lastStatus: "string",
            value: "int",
            receivableUnit: "ReceivableUnit"
        },
        CentralLiquidationOperationWithRelatedValues: {
            id: "uuid",
            createdBy: "string",
            createdAt: "date",
            isDeleted: "bool",
            updatedAt: "date",
            placeId: "uuid",
            anticipationId: "uuid?",
            requestDate: "date",
            liquidationDate: "date",
            method: "string",
            provider: "string",
            status: "string",
            isZig: "bool",
            paymentAccountId: "uuid?",
            clorus: "CentralLiquidationOperationReceivableUnitRelated[]"
        },
        ReceivableUnitByPlaceIdAndFiltersParams: {
            placeId: "string",
            id: "string?",
            paymentAccountId: "string?",
            status: "string?"
        },
        CoalaTempToken: {
            storeId: "string",
            expiresAt: "datetime",
            token: "string",
            barId: "string"
        },
        CoalaAddress: {
            streetName: "string",
            city: "string",
            country: "string",
            state: "string",
            neighborhood: "string",
            postalCode: "string",
            complement: "string",
            formattedAddress: "string",
            streetNumber: "string"
        },
        ExternalStoreIntegration: {
            externalStoreId: "string",
            name: "string",
            status: "ExternalStoreIntegrationStatus",
            createdAt: "datetime",
            isActive: "bool"
        },
        GetStoreExternalIntegrationResponse: {
            type: "ExternalStoreIntegrationType",
            status: "ExternalStoreIntegrationStatus",
            stores: "ExternalStoreIntegration[]",
            menuId: "uuid?"
        },
        GetPlaceStoreResponse: {
            id: "uuid",
            integrations: "GetStoreExternalIntegrationResponse[]"
        },
        UpdateManyStoreIntegrationsRequest: {
            externalIds: "string[]",
            type: "ExternalStoreIntegrationType"
        },
        GetExternalStoreResponse: {
            externalStoreId: "string",
            name: "string"
        },
        ExternalStoreIntegrationProductDto: {
            externalId: "string?",
            externalStoreId: "string",
            name: "string",
            description: "string?",
            price: "money",
            sku: "string?",
            isActive: "bool",
            imageUrl: "string?"
        },
        ExternalStoreIntegrationSectionProductDto: {
            externalId: "string?",
            externalStoreId: "string",
            name: "string",
            description: "string?",
            index: "uint",
            price: "money",
            sku: "string?",
            isActive: "bool"
        },
        ExternalStoreIntegrationSectionDto: {
            externalId: "string",
            name: "string",
            index: "uint",
            isActive: "bool",
            min: "uint",
            max: "uint",
            products: "ExternalStoreIntegrationSectionProductDto[]"
        },
        ExternalStoreIntegrationCategoryDto: {
            externalId: "string",
            externalStoreId: "string",
            name: "string",
            sku: "string?",
            products: "ExternalStoreIntegrationProductWithSectionsDto[]"
        },
        ExternalStoreIntegrationProductWithSectionsDto: {
            externalId: "string?",
            externalStoreId: "string",
            name: "string",
            description: "string?",
            price: "money",
            sku: "string?",
            isActive: "bool",
            imageUrl: "string?",
            sections: "ExternalStoreIntegrationSectionDto[]"
        },
        GetManyExternalStoreIntegrationCategoriesResponseDto: {
            categories: "ExternalStoreIntegrationCategoryDto[]",
            totalOfProducts: "uint"
        },
        DashboardAlert: {
            id: "string",
            date: "datetime",
            title: "string",
            description: "string",
            image: "ImageUrl",
            hasRead: "bool",
            type: "DashboardAlertType"
        },
        AuditWithRelations: {
            id: "string",
            employeeName: "string?",
            date: "datetime",
            functionName: "string",
            type: "string",
            params: "json",
            obs: "string",
            createdAt: "datetime"
        },
        AuditResponse: {
            data: "AuditWithRelations[]",
            pagination: "PaginationResponse"
        },
        AuditFilters: {
            employeeName: "string?",
            functionName: "string?",
            type: "string?"
        },
        AuditParams: {
            period: "PeriodTime",
            pagination: "Pagination",
            placeId: "string",
            filters: "AuditFilters"
        },
        BackofficeNewAccount: {
            name: "string",
            bankAccount: "BackofficeBankAccount?",
            initialBalance: "int",
            initialBalanceDate: "date",
            currentBalance: "int",
            isValidated: "bool"
        },
        BackofficeBaseAccount: {
            name: "string",
            bankAccount: "BackofficeBankAccount?"
        },
        BackofficeAccount: {
            id: "string",
            name: "string",
            bankAccount: "BackofficeBankAccount?",
            initialBalance: "int",
            initialBalanceDate: "date",
            currentBalance: "int",
            isValidated: "bool"
        },
        BackofficeBillPlanCategoryBase: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildrenChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildrenChildren[]"
        },
        BackofficeBillPlanCategoryChildren: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildrenChildren[]"
        },
        BackofficeBillPlanCategory: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            hasBills: "bool",
            position: "uint",
            children: "BackofficeBillPlanCategoryChildren[]"
        },
        BackofficeAttachment: {
            fileName: "string",
            data: "bytes"
        },
        BackofficeBaseBill: {
            description: "string?",
            performDate: "datetime",
            payDate: "datetime?",
            dueDate: "datetime",
            supplierId: "string?",
            accountId: "string",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?",
            metadata: "string?",
            value: "int",
            interest: "uint",
            fine: "uint",
            discount: "uint",
            reconciled: "bool",
            status: "BackofficeBaseBillStatus",
            duplicateId: "string?",
            issueDate: "datetime",
            numBill: "string?",
            addition: "uint"
        },
        BackofficeBillBillPlanCategory: {
            id: "string",
            value: "uint",
            referenceField: "BackofficeReferenceField?"
        },
        BackofficeSplittedBillData: {
            dueDate: "datetime?",
            performDate: "datetime",
            value: "int"
        },
        BackofficeSplittedBillDataWithId: {
            dueDate: "datetime?",
            performDate: "datetime",
            value: "int",
            id: "string"
        },
        BackofficeNewBill: {
            description: "string?",
            performDate: "datetime",
            payDate: "datetime?",
            dueDate: "datetime",
            supplierId: "string?",
            accountId: "string",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?",
            metadata: "string?",
            value: "int",
            interest: "uint",
            fine: "uint",
            discount: "uint",
            reconciled: "bool",
            status: "BackofficeBaseBillStatus",
            duplicateId: "string?",
            issueDate: "datetime",
            numBill: "string?",
            addition: "uint",
            billType: "BackofficePartialBillType?",
            costCenter: "string?",
            billPlanCategories: "BackofficeBillBillPlanCategory[]"
        },
        BackofficeNewBillWithRecurrence: {
            description: "string?",
            performDate: "datetime",
            payDate: "datetime?",
            dueDate: "datetime",
            supplierId: "string?",
            accountId: "string",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?",
            metadata: "string?",
            value: "int",
            interest: "uint",
            fine: "uint",
            discount: "uint",
            reconciled: "bool",
            status: "BackofficeBaseBillStatus",
            duplicateId: "string?",
            issueDate: "datetime",
            numBill: "string?",
            addition: "uint",
            billType: "BackofficePartialBillType?",
            costCenter: "string?",
            billPlanCategories: "BackofficeBillBillPlanCategory[]",
            recurrence: "BackofficeSplittedBillData[]"
        },
        BackofficeNewBillWithInstallments: {
            description: "string?",
            performDate: "datetime",
            payDate: "datetime?",
            dueDate: "datetime",
            supplierId: "string?",
            accountId: "string",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?",
            metadata: "string?",
            value: "int",
            interest: "uint",
            fine: "uint",
            discount: "uint",
            reconciled: "bool",
            status: "BackofficeBaseBillStatus",
            duplicateId: "string?",
            issueDate: "datetime",
            numBill: "string?",
            addition: "uint",
            billType: "BackofficePartialBillType?",
            costCenter: "string?",
            billPlanCategories: "BackofficeBillBillPlanCategory[]",
            installments: "BackofficeSplittedBillData[]"
        },
        BackofficeBillAccount: {
            name: "string",
            bankAccount: "BackofficeBankAccount?",
            id: "string"
        },
        BackofficeBillBillPlanCategories: {
            id: "string",
            name: "string",
            referenceField: "BackofficeReferenceField?",
            value: "uint"
        },
        BackofficeBill: {
            description: "string?",
            performDate: "datetime",
            payDate: "datetime?",
            dueDate: "datetime",
            supplierId: "string?",
            accountId: "string",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?",
            metadata: "string?",
            value: "int",
            interest: "uint",
            fine: "uint",
            discount: "uint",
            reconciled: "bool",
            status: "BackofficeBaseBillStatus",
            duplicateId: "string?",
            issueDate: "datetime",
            numBill: "string?",
            addition: "uint",
            id: "string",
            supplier: "BackofficeSupplier?",
            account: "BackofficeBillAccount?",
            billType: "BackofficeBillType?",
            costCenter: "BackofficeCostCenter?",
            originId: "string?",
            attachment: "string?",
            billPlanCategories: "BackofficeBillBillPlanCategories[]",
            createdBySystem: "bool"
        },
        BackofficeBaseDate: {
            since: "datetime?",
            until: "datetime?"
        },
        BackofficeRequiredBaseDate: {
            since: "date",
            until: "date"
        },
        BackofficeExportBillArgsTotalValue: {
            min: "uint",
            max: "uint"
        },
        BackofficeExportBillArgs: {
            performDate: "BackofficeRequiredBaseDate?",
            dueDate: "BackofficeRequiredBaseDate?",
            issueDate: "BackofficeRequiredBaseDate?",
            payDate: "BackofficeRequiredBaseDate?",
            type: "BackofficeBillStatusFilter",
            status: "BackofficeExportBillArgsStatus",
            bankAccountIds: "string[]",
            supplierIds: "string[]",
            costCenterIds: "string[]",
            billPlanCategoryIds: "string[]",
            numBill: "string?",
            description: "string?",
            observation: "string?",
            totalValue: "BackofficeExportBillArgsTotalValue?"
        },
        BackofficeBillsToDREAnalyticsSupplier: {
            name: "string",
            id: "string"
        },
        BackofficeBillsToDREAnalyticsBillPlanCategory: {
            name: "string",
            id: "string",
            value: "int",
            referenceField: "BackofficeReferenceField?"
        },
        BackofficeBillsToDREAnalytics: {
            id: "string",
            addition: "uint",
            discount: "uint",
            dueDate: "date",
            performDate: "date",
            payDate: "date?",
            description: "string?",
            numBill: "string?",
            value: "int",
            supplier: "BackofficeBillsToDREAnalyticsSupplier?",
            billPlanCategory: "BackofficeBillsToDREAnalyticsBillPlanCategory",
            createdBySystem: "bool",
            status: "BackofficeBillsToDREAnalyticsStatus",
            accountId: "string"
        },
        BackofficeEditBillDREAnalyticsBillPlanCategory: {
            value: "uint",
            oldBillPlanCategoryId: "string",
            newBillPlanCategoryId: "string?"
        },
        BackofficeEditBillDREAnalyticsArgBillInfo: {
            id: "string",
            performDate: "date",
            dueDate: "date?",
            description: "string",
            supplierId: "string"
        },
        BackofficeEditBillDREAnalyticsArg: {
            employeeId: "string",
            billInfo: "BackofficeEditBillDREAnalyticsArgBillInfo",
            billPlanCategoryInfo: "BackofficeEditBillDREAnalyticsBillPlanCategory?",
            additionInfo: "BackofficeEditBillDREAnalyticsBillPlanCategory?",
            discountInfo: "BackofficeEditBillDREAnalyticsBillPlanCategory?"
        },
        BackofficeNewBillType: {
            name: "string",
            categoryId: "string"
        },
        BackofficeBillType: {
            id: "string",
            category: "BackofficeCategory",
            name: "string",
            categoryId: "string"
        },
        BackofficePartialBillType: {
            idOrName: "string",
            category: "string?"
        },
        BackofficeBillDataBillPlanCategories: {
            id: "string",
            value: "uint",
            referenceField: "BackofficeReferenceField?",
            name: "string"
        },
        BackofficeCashFlowBillDateWithStatus: {
            date: "datetime",
            description: "string",
            categoryName: "string",
            billPlanCategories: "BackofficeBillDataBillPlanCategories[]",
            account: "BackofficeBillAccount?",
            value: "int",
            balance: "int",
            payDate: "datetime?",
            performDate: "datetime",
            dueDate: "datetime",
            status: "BackofficeCashFlowBillDateWithStatusStatus"
        },
        BackofficeCashFlowBillDate: {
            date: "datetime",
            description: "string",
            categoryName: "string",
            billPlanCategories: "BackofficeBillDataBillPlanCategories[]",
            account: "BackofficeBillAccount?",
            value: "int",
            balance: "int",
            payDate: "datetime?",
            performDate: "datetime",
            dueDate: "datetime"
        },
        BackofficeBaseCashFlow: {
            previousBalance: "int",
            finalBalance: "int",
            periodBalance: "int",
            totalReceipts: "int",
            totalExpenses: "int",
            since: "datetime",
            until: "datetime"
        },
        BackofficeCashFlow: {
            previousBalance: "int",
            finalBalance: "int",
            periodBalance: "int",
            totalReceipts: "int",
            totalExpenses: "int",
            since: "datetime",
            until: "datetime",
            receipts: "BackofficeCashFlowBillDate[]",
            expenses: "BackofficeCashFlowBillDate[]"
        },
        BackofficeFullCashFlow: {
            previousBalance: "int",
            finalBalance: "int",
            periodBalance: "int",
            totalReceipts: "int",
            totalExpenses: "int",
            since: "datetime",
            until: "datetime",
            receipts: "BackofficeCashFlowBillDateWithStatus[]",
            expenses: "BackofficeCashFlowBillDateWithStatus[]"
        },
        BackofficeNeoCashFlowArgs: {
            since: "date",
            until: "date",
            accountId: "string",
            billPlanContextId: "string",
            billPlanLevel: "uint",
            viewMode: "BackofficeNeoCashFlowArgsViewMode"
        },
        BackofficeNeoCashFlowBill: {
            date: "string",
            expectedTotalValue: "int",
            fulfilledTotalValue: "int"
        },
        BackofficeNeoCashFlow: {
            id: "string",
            name: "string",
            path: "string",
            parentId: "string?",
            level: "uint",
            bills: "BackofficeNeoCashFlowBill[]"
        },
        BackofficeNewCategory: {
            name: "string"
        },
        BackofficeCategory: {
            id: "string",
            name: "string"
        },
        BackofficeNewCostCenter: {
            name: "string"
        },
        BackofficeCostCenter: {
            id: "string",
            name: "string"
        },
        BackofficeNewDre: {
            name: "string",
            isCostCenterOriented: "bool"
        },
        BackofficeDre: {
            name: "string",
            isCostCenterOriented: "bool",
            id: "string"
        },
        BackofficeNewDreLineRule: {
            costCenterId: "string?",
            billPlanId: "string?"
        },
        BackofficeNewDreLine: {
            name: "string",
            parentId: "string?",
            previousLineId: "string?",
            rules: "BackofficeNewDreLineRule[]"
        },
        BackofficeDreLine: {
            name: "string",
            parentId: "string?",
            previousLineId: "string?",
            rules: "BackofficeNewDreLineRule[]",
            id: "string"
        },
        BackofficeDreLineResult: {
            id: "string",
            name: "string",
            parentId: "string",
            previousLineId: "string",
            value: "int"
        },
        BackofficeDreBillBase: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategoriesBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBillBillPlanCategories: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategoriesBillPlanCategories[]"
        },
        BackofficeDreBill: {
            costCenterId: "string?",
            bankAccountId: "string?",
            dueDate: "date?",
            peformDate: "date?",
            payDate: "date?",
            value: "int",
            billId: "string?",
            billPlanCategoryId: "string",
            billPlanCategoryName: "string",
            billPlanCategoryPath: "string",
            billPlanCategories: "BackofficeDreBillBillPlanCategories[]"
        },
        BackofficeDreReportLine: {
            dreLineId: "string",
            dreLineName: "string",
            dreParentLine: "string?",
            drePreviousLine: "string?",
            dreLineLegendType: "string",
            billPlanCategories: "BackofficeDreBill[]"
        },
        BackofficeDreFullReport: {
            dreId: "string",
            dreName: "string",
            dreReportLines: "BackofficeDreReportLine[]"
        },
        BackofficeDreReport: {
            name: "string",
            isCostCenterOriented: "bool",
            id: "string",
            lines: "BackofficeDreLineResult[]",
            notCategorizedBills: "int",
            result: "int"
        },
        BackofficeSimplyBillPlan: {
            id: "string",
            name: "string"
        },
        BackofficeExportDreArg: {
            dreId: "string",
            billPlanContextId: "string",
            since: "date",
            until: "date",
            costCenterIds: "string[]",
            bankAccountIds: "string[]",
            dateFilter: "BackofficeExportDreArgDateFilter",
            billPlanLevel: "uint"
        },
        BackofficeFocusCompany: {
            id: "string",
            cnpj: "string",
            token: "string",
            lastInvoiceVersion: "uint?"
        },
        BackofficeFocusInvoice: {
            id: "string",
            focusCompanyId: "string",
            supplierName: "string",
            supplierDocument: "string",
            accessKey: "string",
            totalValue: "uint",
            issueDate: "datetime",
            situation: "string",
            completed: "bool",
            type: "uint",
            version: "uint",
            digestValue: "string?",
            targetManifestion: "BackofficeManifestType?"
        },
        BackofficeBaseInventory: {
            date: "datetime",
            isTotal: "bool",
            createdBy: "string"
        },
        BackofficeNewInventory: {
            date: "datetime",
            isTotal: "bool",
            createdBy: "string",
            storageIds: "string[]"
        },
        BackofficeInventoryStorages: {
            id: "string",
            name: "string"
        },
        BackofficeInventory: {
            date: "datetime",
            isTotal: "bool",
            createdBy: "string",
            id: "string",
            status: "BackofficeInventoryStatus",
            storages: "BackofficeInventoryStorages[]"
        },
        BackofficeInventoryProduct: {
            productId: "string",
            storageId: "string",
            inventoryCount: "uint?",
            inventoryUnitValue: "uint?",
            realCount: "int?",
            realUnitValue: "float?"
        },
        BackofficeNewManualInvoiceBill: {
            accountId: "string?",
            createBill: "bool",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?"
        },
        BackofficeNewManualInvoiceDetailsTaxs: {
            icmsBase: "uint",
            icmsValue: "uint",
            icmsstBase: "uint",
            icmsstValue: "uint",
            ipiValue: "uint"
        },
        BackofficeNewManualInvoiceDetails: {
            num: "uint",
            serie: "uint",
            operationType: "string?",
            date: "datetime",
            taxs: "BackofficeNewManualInvoiceDetailsTaxs",
            insuranceValue: "uint",
            discountValue: "uint",
            otherExpensesValue: "uint",
            shippingValue: "uint",
            cfop: "uint?"
        },
        BackofficeNewManualInvoice: {
            storageId: "string?",
            bill: "BackofficeNewManualInvoiceBill",
            details: "BackofficeNewManualInvoiceDetails",
            supplierId: "string?",
            products: "BackofficeManualInvoiceProduct[]",
            duplicates: "BackofficeInvoiceDuplicate[]"
        },
        BackofficeManualInvoiceProduct: {
            associatedProductId: "string",
            count: "uint",
            unitValue: "uint",
            entryTotalValue: "uint",
            entryUnitValue: "uint",
            chartAccountId: "uuid?"
        },
        BackofficeUpsertManualProduct: {
            associatedProductId: "string",
            count: "uint",
            unitValue: "uint",
            entryTotalValue: "uint",
            entryUnitValue: "uint",
            chartAccountId: "uuid?",
            id: "string?",
            code: "string"
        },
        BackofficeImportedInvoiceDetailsObjBillPlanCategory: {
            billPlanCategoryId: "string",
            value: "uint"
        },
        BackofficeImportedInvoiceDetailsBillPlanCategory: {
            invoiceId: "string",
            billPlanCategoryId: "string",
            value: "uint",
            invoiceDetailsField: "BackofficeImportedInvoiceDetailsField"
        },
        BackofficeProductLastInvoiceDetails: {
            entryId: "string",
            pending: "bool",
            skipped: "bool",
            associatedProduct: "Product?",
            chartAccountId: "uuid?",
            unitValue: "string",
            unitMultiplier: "uint",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            commercialQuantity: "float",
            hasChangedCommercialQuantity: "bool",
            invoiceEntry: "BackofficeImportedInvoiceProductInvoiceEntry",
            isImported: "bool",
            totalProductValue: "uint",
            invoiceDate: "datetime"
        },
        BackofficeBaseInvoiceProduct: {
            id: "string",
            amount: "uint",
            unitValue: "uint",
            totalValue: "uint"
        },
        BackofficeLatestInvoiceProduct: {
            invoiceId: "string",
            products: "BackofficeBaseInvoiceProduct[]"
        },
        BackofficeLastInvoiceProducArg: {
            id: "string",
            amount: "uint"
        },
        BackofficeMultipleImportedInvoice: {
            success: "BackofficeImportedInvoice[]",
            errors: "string[]"
        },
        BackofficeXmlInput: {
            xml: "bytes",
            fileName: "string"
        },
        BackofficeEditInvoiceBillArg: {
            invoiceId: "string",
            createBill: "bool",
            accountId: "string?",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?"
        },
        BackofficeUpsertInvoiceDuplicateArg: {
            employeeId: "string",
            invoiceId: "string",
            accountId: "string",
            duplicates: "BackofficeInvoiceDuplicate[]",
            paymentMethod: "BackofficeBillPaymentMethod?",
            observation: "string?"
        },
        SimpleInvoiceInfoIssuer: {
            name: "string",
            cpfOrCnpj: "string"
        },
        SimpleInvoiceInfo: {
            key: "string",
            issuer: "SimpleInvoiceInfoIssuer",
            totalValue: "uint",
            issueDate: "datetime",
            status: "SimpleInvoiceInfoStatus",
            importedId: "string?",
            cannotImportReason: "string?"
        },
        NewBackofficeManualInvoiceProduct: {
            associatedProductId: "uuid",
            chartAccountId: "uuid?",
            quantity: "uint",
            unitCostValue: "string",
            discountValue: "money",
            ipiValue: "money?",
            unitMultiplier: "uint"
        },
        NewManualBackofficeInvoiceV2DetailsTaxs: {
            icmsBase: "money?",
            icmsValue: "money?",
            icmsstBase: "money?",
            icmsstValue: "money?",
            ipiValue: "money?"
        },
        NewManualBackofficeInvoiceV2Details: {
            num: "uint",
            serie: "uint",
            operationType: "string?",
            accessKey: "string?",
            date: "datetime",
            totalValue: "money",
            taxs: "NewManualBackofficeInvoiceV2DetailsTaxs",
            insuranceValue: "money",
            discountValue: "money",
            otherExpensesValue: "money",
            shippingValue: "money?",
            cfop: "uint?"
        },
        NewManualBackofficeInvoiceV2Duplicates: {
            amount: "uint",
            firstDueDate: "date",
            intervalType: "ManualBackofficeInvoiceDuplcatesInterval"
        },
        NewManualBackofficeInvoiceV2: {
            supplierId: "uuid",
            fisicalInputDate: "date?",
            details: "NewManualBackofficeInvoiceV2Details",
            products: "NewBackofficeManualInvoiceProduct[]",
            duplicates: "NewManualBackofficeInvoiceV2Duplicates"
        },
        FiscalInvoiceBackup: {
            fiscalProfileId: "string",
            fiscalProfile: "string",
            month: "uint",
            year: "uint",
            danfes: "string?",
            xmls: "string"
        },
        BackofficeImportedInvoiceUpdate: {
            storageId: "string?",
            inputDate: "datetime?"
        },
        BackofficeInvoiceXLSXArgsIssueDate: {
            since: "datetime",
            until: "datetime"
        },
        BackofficeInvoiceXLSXArgsDueDate: {
            since: "datetime",
            until: "datetime"
        },
        BackofficeInvoiceXLSXArgsPerformDate: {
            since: "datetime",
            until: "datetime"
        },
        BackofficeInvoiceXLSXArgs: {
            status: "BackofficeInvoiceXLSXArgsStatus",
            origin: "BackofficeInvoiceXLSXArgsOrigin",
            supplierIds: "string[]",
            issueDate: "BackofficeInvoiceXLSXArgsIssueDate?",
            dueDate: "BackofficeInvoiceXLSXArgsDueDate?",
            performDate: "BackofficeInvoiceXLSXArgsPerformDate?"
        },
        BackofficeBillInvoiceDuplicate: {
            id: "string?",
            code: "string?",
            dueDate: "datetime?",
            performDate: "datetime",
            value: "uint",
            accountId: "string?"
        },
        BackofficeReceivedInvoiceHeader: {
            id: "string",
            supplierName: "string",
            supplierDocument: "string",
            accessKey: "string",
            totalValue: "uint",
            issueDate: "datetime",
            state: "string",
            targetManifestion: "string?",
            completeNfe: "bool",
            kindNfe: "string",
            version: "uint",
            digestValue: "string?",
            numCorrection: "string?",
            cancelDate: "datetime?",
            cancelJustification: "string?",
            isImported: "bool",
            hasPendingManifestion: "bool",
            downloadCounter: "uint"
        },
        BackofficeResponseInvoiceManifest: {
            statusSefaz: "string",
            messageSefaz: "string",
            status: "string",
            protocol: "string",
            typeManifest: "string",
            reason: "string?"
        },
        BackofficeGetReceivedInvoicesArgsIssueDate: {
            since: "date",
            until: "date"
        },
        BackofficeGetReceivedInvoicesArgs: {
            focusCompanyId: "string",
            isComplete: "bool?",
            supplierDocument: "string?",
            supplierName: "string?",
            status: "BackofficeReceivedInvoiceStatus[]",
            issueDate: "BackofficeGetReceivedInvoicesArgsIssueDate?",
            limit: "uint"
        },
        BackofficeIncomeStatement: {
            grossRevenue: "int",
            grossProfit: "int",
            netTotal: "int",
            taxTotal: "int",
            categories: "BackofficeCategoryTotal[]",
            since: "datetime",
            until: "datetime"
        },
        BackofficeCategoryTotal: {
            name: "string",
            categoryId: "string?",
            parcialProfit: "int",
            total: "int"
        },
        BackofficeBillHistory: {
            historicByDay: "BackofficeBillHistoryByDay[]",
            since: "datetime",
            until: "datetime"
        },
        BackofficeBillHistoryByDay: {
            billDataHistory: "BackofficeBillDataHistory[]",
            date: "datetime"
        },
        BackofficeBillDataHistory: {
            billId: "string",
            value: "int"
        },
        BackofficeCategoryHistory: {
            historicByDay: "BackofficeCategoryHistoryByDay[]",
            since: "datetime",
            until: "datetime"
        },
        BackofficeCategoryHistoryByDay: {
            categoryDataHistory: "BackofficeCategoryDataHistory[]",
            date: "datetime"
        },
        BackofficeCategoryDataHistory: {
            categoryName: "string",
            value: "int"
        },
        BackofficeExtract: {
            previousBalance: "int",
            finalBalance: "int",
            periodBalance: "int",
            totalReceipts: "int",
            totalExpenses: "int",
            billExtractData: "BackofficeBillData[]",
            since: "datetime",
            until: "datetime"
        },
        BackofficeBillData: {
            date: "datetime",
            description: "string",
            categoryName: "string",
            billPlanCategories: "BackofficeBillDataBillPlanCategories[]",
            account: "BackofficeBillAccount?",
            value: "int",
            balance: "int"
        },
        BackofficeDescriptionReport: {
            bills: "BackofficeBillDescriptionData[]",
            total: "int",
            since: "datetime",
            until: "datetime"
        },
        BackofficeBillDescriptionData: {
            description: "string",
            value: "int"
        },
        BackofficeDayReport: {
            bills: "BackofficeBillDayData[]",
            total: "int",
            since: "datetime",
            until: "datetime"
        },
        BackofficeBillDayData: {
            date: "datetime",
            value: "int"
        },
        BackofficeIncomeByCategory: {
            categoryName: "string",
            value: "int"
        },
        BackofficeCostCenterReport: {
            costCenterBills: "BackofficeCostCenterBills[]",
            total: "int",
            since: "datetime",
            until: "datetime"
        },
        BackofficeCostCenterBills: {
            name: "string",
            value: "int"
        },
        BackofficeBillSupplierTrackerReport: {
            billSupplierTrackerData: "BackofficeBillSupplierTrackerData[]",
            since: "datetime",
            until: "datetime"
        },
        BackofficeBillSupplierTrackerData: {
            supplierId: "string?",
            supplierName: "string",
            billDescription: "string",
            value: "int"
        },
        BackofficeResumeBillsDueToTodayAccount: {
            id: "string",
            name: "string"
        },
        BackofficeResumeBillsDueToToday: {
            id: "string",
            value: "int",
            status: "BackofficeResumeBillsDueToTodayStatus",
            description: "string",
            account: "BackofficeResumeBillsDueToTodayAccount"
        },
        BackofficeResumeAccountBalances: {
            id: "string",
            name: "string",
            balanceValue: "int"
        },
        BackofficeResume: {
            billsDueToToday: "BackofficeResumeBillsDueToToday[]",
            accountBalances: "BackofficeResumeAccountBalances[]"
        },
        BackofficePeriodResumeToReceive: {
            paid: "uint",
            pending: "uint",
            total: "uint"
        },
        BackofficePeriodResumeToPay: {
            paid: "uint",
            pending: "uint",
            total: "uint"
        },
        BackofficePeriodResume: {
            toReceive: "BackofficePeriodResumeToReceive",
            toPay: "BackofficePeriodResumeToPay",
            balance: "int",
            growth: "float?"
        },
        BackofficeBillPlanCategoriesReportBills: {
            description: "string",
            performDate: "datetime",
            dueDate: "datetime",
            payDate: "datetime?",
            value: "int",
            account: "string?",
            supplier: "string?"
        },
        BackofficeBillPlanCategoriesReport: {
            id: "string",
            name: "string",
            total: "int",
            bills: "BackofficeBillPlanCategoriesReportBills[]"
        },
        StoragePositionReportProduct: {
            productId: "string",
            productName: "string",
            fiscalCode: "string?",
            categoryId: "string",
            categoryName: "string",
            currentCount: "float",
            currentCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            count: "float",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            unitCostValue: "string?",
            totalCost: "string?",
            basicStorageUnit: "BasicStorageUnit"
        },
        StoragePositionReport: {
            products: "StoragePositionReportProduct[]",
            totalCost: "string"
        },
        BackofficeStoragesWithResume: {
            storages: "BackofficeStorageWithResume[]",
            totalCost: "string",
            productsCount: "uint"
        },
        BackofficeStorageProductUnitCost: {
            avgUnitCost: "string?",
            id: "string",
            count: "float"
        },
        BackofficeMultipleStorageProduct: {
            storageId: "string",
            listProducts: "BackofficeStorageProduct[]"
        },
        BackofficeStorageProductTransfersResumeTransfers: {
            type: "BackofficeStorageTransferType",
            count: "float"
        },
        BackofficeStorageProductTransfersResume: {
            id: "string",
            initial: "float",
            transfers: "BackofficeStorageProductTransfersResumeTransfers[]"
        },
        BackofficePaginationStorageProductTransfersResume: {
            page: "uint?",
            itemsPerPage: "uint?",
            totalItems: "uint?",
            products: "BackofficeStorageProductTransfersResume[]"
        },
        BackofficeMultipleStorageTransferProduct: {
            productId: "string",
            count: "float"
        },
        BackofficeMultipleStorageTransferProductV2: {
            productId: "string",
            count: "float",
            basicStorageUnit: "BasicStorageUnit"
        },
        BackofficeInputV3: {
            productId: "string",
            storageId: "string",
            unitCostValue: "string?",
            obs: "string?",
            count: "float",
            basicStorageUnit: "BasicStorageUnit",
            date: "datetime"
        },
        BackofficeNewProductionRuleOutputs: {
            productId: "string",
            count: "float"
        },
        BackofficeNewProductionRule: {
            inputs: "BackofficeProductionRuleInput[]",
            outputs: "BackofficeNewProductionRuleOutputs[]"
        },
        BackofficeProductionRuleInput: {
            productId: "string",
            count: "float",
            loss: "float"
        },
        BackofficeProductionOutput: {
            productId: "string",
            count: "uint"
        },
        BackofficeProductionRuleInputs: {
            productId: "string",
            count: "uint",
            loss: "uint"
        },
        BackofficeProductionRuleOutputs: {
            productId: "string",
            count: "uint"
        },
        BackofficeProductionRule: {
            id: "string",
            inputs: "BackofficeProductionRuleInputs[]",
            outputs: "BackofficeProductionRuleOutputs[]"
        },
        BackofficeProductStatusAtStorage: {
            productId: "string",
            storageId: "string",
            count: "int",
            unitCostValue: "uint?"
        },
        BackofficeProductAlert: {
            productId: "string",
            type: "BackofficeNewProductRuleType",
            ruleQuantity: "uint",
            actualCount: "int"
        },
        BackofficeProductRule: {
            id: "string",
            productId: "string",
            type: "BackofficeNewProductRuleType",
            ruleQuantity: "uint"
        },
        BackofficeNewProductRule: {
            productId: "string",
            type: "BackofficeNewProductRuleType",
            ruleQuantity: "uint"
        },
        BackofficeEditProductRule: {
            id: "string",
            type: "BackofficeEditProductRuleType?",
            ruleQuantity: "uint?"
        },
        BackofficeResultCreateProductRuleError: {
            rule: "BackofficeNewProductRule",
            reason: "string"
        },
        BackofficeResultCreateProductRule: {
            error: "BackofficeResultCreateProductRuleError[]",
            success: "BackofficeProductRule[]"
        },
        BackofficeResultEditProductRuleError: {
            rule: "BackofficeEditProductRule",
            reason: "string"
        },
        BackofficeResultEditProductRule: {
            error: "BackofficeResultEditProductRuleError[]",
            success: "BackofficeProductRule[]"
        },
        BackofficeCurrentReportStorageStoragesProducts: {
            id: "string",
            count: "uint",
            price: "uint?"
        },
        BackofficeCurrentReportStorageStorages: {
            id: "string",
            products: "BackofficeCurrentReportStorageStoragesProducts[]"
        },
        BackofficeCurrentReportStorage: {
            value: "uint",
            storages: "BackofficeCurrentReportStorageStorages[]"
        },
        BackofficeStorageHistoryV4: {
            currentPage: "uint?",
            initial: "float",
            totalTransfersItems: "uint",
            transfers: "BackofficeStorageHistoryV3Transfers[]",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit",
            proportionOfUnit: "ProportionOfUnit?"
        },
        BackofficeNewSupplier: {
            name: "string",
            legalName: "string?",
            inscricaoEstadual: "string?",
            cpfOrCnpj: "string?",
            address: "BackofficeAddress?",
            bankAccount: "BackofficeBankAccount?",
            billPlanCategoryId: "string?",
            registerType: "BackofficeSupplierRegisterType?",
            chartAccountId: "string?",
            organizationId: "string?",
            pixKeyType: "PixKeyTypeDto?",
            pixKey: "string?",
            email: "email?",
            cellPhone: "string?",
            phone: "string?",
            contact: "string?"
        },
        BackofficeSupplier: {
            id: "string",
            isZigSupplier: "bool",
            name: "string",
            legalName: "string?",
            inscricaoEstadual: "string?",
            cpfOrCnpj: "string?",
            address: "BackofficeAddress?",
            bankAccount: "BackofficeBankAccount?",
            billPlanCategoryId: "string?",
            registerType: "BackofficeSupplierRegisterType?",
            chartAccountId: "string?",
            organizationId: "string?",
            pixKeyType: "PixKeyTypeDto?",
            pixKey: "string?",
            email: "email?",
            cellPhone: "string?",
            phone: "string?",
            contact: "string?"
        },
        BackofficeGetSuppliersParams: {
            textSearch: "string?",
            registerType: "BackofficeSupplierRegisterType?",
            pagination: "Pagination?"
        },
        BackofficeGetSuppliersResponse: {
            data: "BackofficeSupplier[]",
            pagination: "PaginationResponse"
        },
        BackofficeNewTransfer: {
            date: "datetime",
            description: "string",
            value: "uint",
            paid: "bool",
            sourceAccountId: "string",
            destinationAccountId: "string"
        },
        BackofficeTransfer: {
            id: "string",
            date: "datetime",
            description: "string",
            value: "uint",
            paid: "bool",
            sourceAccount: "BackofficeBillAccount",
            destinationAccount: "BackofficeBillAccount",
            sourceBill: "BackofficeBill",
            destinationBill: "BackofficeBill"
        },
        BackofficeProductImporting: {
            id: "string",
            unitCostValue: "string?",
            count: "uint",
            obs: "string?"
        },
        BackofficeProductImportingResultError: {
            input: "BackofficeProductImporting",
            reason: "string"
        },
        BackofficeProductImportingResult: {
            success: "BackofficeProductImporting[]",
            error: "BackofficeProductImportingResultError[]"
        },
        SupplierAbcCurveBase: {
            name: "string",
            total: "money",
            cumulativeTotal: "money",
            percentage: "float",
            cumulativePercentage: "float",
            tier: "string"
        },
        SupplierAbcCurve: {
            total: "money",
            valueCurveA: "money",
            valueCurveB: "money",
            valueCurveC: "money",
            curve: "SupplierAbcCurveBase[]",
            pagination: "PaginationResponse"
        },
        ProductAbcCurveBase: {
            name: "string",
            fiscalCode: "string?",
            count: "uint",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            unitMeasurement: "string",
            avgUnitCost: "float",
            total: "float",
            cumulativeTotal: "float",
            percentage: "float",
            cumulativePercentage: "float",
            tier: "string"
        },
        ProductAbcCurve: {
            total: "float",
            valueCurveA: "float",
            valueCurveB: "float",
            valueCurveC: "float",
            curve: "ProductAbcCurveBase[]"
        },
        BackofficeUpdateStorageUnitCostProduct: {
            productId: "string",
            storageId: "string",
            unitCostValue: "string"
        },
        PlaceBankAccountResponse: {
            id: "string",
            createdAt: "date",
            updatedAt: "date",
            isDefault: "bool",
            holder: "string",
            name: "string",
            pixKey: "PixKeyDto?",
            receiver: "BankAccountReceiverDto?"
        },
        PlaceBankAccountPaginationResponse: {
            data: "PlaceBankAccountResponse[]",
            pagination: "BasePaginationResponse"
        },
        BaseBar: {
            id: "string?",
            name: "string",
            image: "ImageUrl?",
            storageId: "string",
            storageName: "string?",
            internalIp: "string?",
            internalIps: "string[]?",
            fichaLogoSha256: "string?"
        },
        BarRequest: {
            id: "string?",
            name: "string",
            image: "ImageUrl?",
            storageId: "string",
            storageName: "string?",
            internalIp: "string?",
            internalIps: "string[]?",
            fichaLogoSha256: "string?",
            fichaLogo: "bytes?",
            menuIds: "string[]"
        },
        Bar: {
            id: "string?",
            name: "string",
            image: "ImageUrl?",
            storageId: "string",
            storageName: "string?",
            internalIp: "string?",
            internalIps: "string[]?",
            fichaLogoSha256: "string?",
            fichaLogoUrl: "string?",
            isDeleted: "bool?"
        },
        BarWithMenus: {
            id: "string?",
            name: "string",
            image: "ImageUrl?",
            storageId: "string",
            storageName: "string?",
            internalIp: "string?",
            internalIps: "string[]?",
            fichaLogoSha256: "string?",
            fichaLogoUrl: "string?",
            isDeleted: "bool?",
            menus: "MenuInfo[]",
            kds: "KdsInfo?",
            pagseguroEcActivationCode: "string?",
            pagseguroEcCnpj: "string?",
            getnetEcCnpj: "string?",
            productsCount: "int?"
        },
        MenuInfo: {
            id: "string",
            name: "string",
            isActive: "bool",
            isDefault: "bool"
        },
        KdsInfo: {
            id: "string",
            name: "string"
        },
        BarsDevices: {
            id: "string?",
            name: "string",
            deviceQuantity: "int"
        },
        EditableBarFields: {
            name: "string",
            storageId: "string",
            internalIps: "string[]",
            fichaLogoImageId: "string?",
            pagseguroEcActivationCode: "string?",
            pagseguroEcCnpj: "string?",
            getnetEcCnpj: "string?"
        },
        PlacesProductsWereSoldBodyProportionalValue: {
            value: "uint",
            quantity: "uint",
            unit: "string"
        },
        PlacesProductsWereSoldBody: {
            placeName: "string",
            placeId: "string",
            count: "int",
            proportionalValue: "PlacesProductsWereSoldBodyProportionalValue?",
            totalValue: "uint"
        },
        ProductsByBarsAtPlace: {
            barId: "string?",
            barName: "string?",
            products: "ProductsSoldReportResponse[]"
        },
        SellerTransactionClients: {
            id: "string",
            cpf: "string",
            name: "string",
            zigCode: "string?"
        },
        SellerTransactionProducts: {
            name: "string",
            count: "uint",
            isIssued: "bool"
        },
        SellerTransactionInvoiceInfo: {
            id: "string",
            pdfUrl: "string?",
            imgUrl: "string?"
        },
        SellerTransaction: {
            id: "string",
            date: "datetime",
            clients: "SellerTransactionClients[]",
            value: "money",
            tip: "money",
            refunded: "bool",
            products: "SellerTransactionProducts[]",
            invoiceInfo: "SellerTransactionInvoiceInfo?",
            serialNumber: "string?"
        },
        ProductSoldMountables: {
            id: "string",
            name: "string",
            count: "uint",
            section: "string"
        },
        ProductsSoldReportResponse: {
            productId: "string",
            fiscalCode: "string",
            productName: "string",
            categoryId: "string",
            categoryName: "string",
            image: "ImageUrl?",
            productValues: "ProductValuesHistory[]?",
            mountableProducts: "ProductSoldMountables[]?",
            count: "uint",
            unitValue: "uint[]",
            subtotal: "uint",
            discount: "uint",
            totalValue: "uint",
            proportionalValue: "ProportionalValue[]?"
        },
        ProductsSoldOrderBy: {
            column: "ProductsSoldOrderByColumn",
            order: "ProductsSoldOrderByOrder"
        },
        ProductSoldFilters: {
            categoryIds: "string[]?",
            productIds: "string[]?",
            sources: "TransactionSource[]?",
            sectorIds: "string[]?"
        },
        ProductsSoldOverviewResponse: {
            count: "uint",
            subtotal: "uint",
            discount: "uint",
            totalValue: "uint"
        },
        ProductByBarFilters: {
            barIds: "string[]?",
            productIds: "string[]?",
            sources: "TransactionSource[]?",
            sectorIds: "string[]?"
        },
        ProductValuesHistory: {
            count: "uint",
            unitValue: "uint",
            subtotal: "uint",
            discount: "uint",
            totalValue: "uint",
            proportionalValue: "ProportionalValue?"
        },
        BaseProduct: {
            id: "string",
            name: "string",
            count: "uint",
            fiscalCode: "string"
        },
        SimplifiedSeller: {
            role: "string?",
            roleId: "string?",
            username: "string?",
            name: "string",
            id: "string"
        },
        BurnedPaperTicket: {
            productId: "string",
            productName: "string",
            count: "uint"
        },
        ProductBurnedTicketSold: {
            id: "string",
            name: "string",
            category: "string",
            image: "ImageUrl?",
            count: "int",
            type: "SellableThing",
            totalValue: "money",
            totalDiscount: "money",
            fiscalCode: "string",
            mountableProducts: "ProductSoldMountableProducts[]",
            isMountable: "bool?",
            productUnitCost: "string?",
            proportionalValue: "ProportionalValue?",
            estimatedTax: "float?",
            isReturnable: "bool?",
            employee: "string",
            employeeUsername: "string?",
            transactionSource: "TransactionSource"
        },
        RechargeDetails: {
            id: "string",
            totalValue: "uint",
            usedValue: "uint",
            isRefunded: "bool",
            date: "datetime",
            user: "string",
            method: "string",
            zigCode: "string?",
            serialNumber: "string?"
        },
        Payment: {
            method: "string",
            value: "uint"
        },
        PostDetails: {
            id: "string",
            payments: "Payment[]",
            payers: "string[]",
            date: "datetime",
            zigCode: "string?",
            serialNumber: "string?",
            isRefunded: "bool?"
        },
        CashierClosingObs: {
            author: "string",
            authorUsername: "string?",
            obs: "string",
            cashierId: "string",
            date: "datetime"
        },
        CateringProductComboChild: {
            productId: "string",
            name: "string",
            count: "uint",
            value: "uint",
            image: "ImageUrl?"
        },
        CateringProductMountableSectionItem: {
            productId: "string",
            name: "string",
            price: "uint",
            maxCount: "uint?",
            image: "ImageUrl?"
        },
        CateringProductMountableSection: {
            id: "string",
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "CateringMountableSectionPricing",
            items: "CateringProductMountableSectionItem[]"
        },
        CateringProductListItem: {
            id: "string",
            name: "string",
            category: "string",
            categoryId: "string",
            type: "CateringProductSubType",
            value: "uint",
            image: "ImageUrl?",
            comboProducts: "CateringProductComboChild[]?",
            mountableSections: "CateringProductMountableSection[]?"
        },
        CateringProductCounters: {
            total: "uint",
            product: "uint",
            combo: "uint",
            mountable: "uint"
        },
        CateringProductListResponse: {
            data: "CateringProductListItem[]",
            pagination: "PaginationResponse",
            counters: "CateringProductCounters"
        },
        NewCateringComboPayloadProducts: {
            productId: "string",
            count: "uint"
        },
        NewCateringComboPayload: {
            products: "NewCateringComboPayloadProducts[]",
            description: "string?"
        },
        NewCateringProduct: {
            name: "string",
            categoryId: "string",
            value: "uint",
            type: "CateringProductSubType",
            mountableDescription: "NewMountableDescriptionWithStatus?",
            combo: "NewCateringComboPayload?"
        },
        DeleteCateringProductsFailure: {
            productId: "string",
            reason: "string"
        },
        DeleteCateringProductsResponse: {
            deleted: "string[]",
            failed: "DeleteCateringProductsFailure[]"
        },
        NewCateringProductBulkItem: {
            name: "string",
            categoryId: "string",
            value: "uint",
            image: "EditProductImage?"
        },
        BulkImportCateringProductsCreated: {
            index: "uint",
            productId: "string",
            name: "string"
        },
        BulkImportCateringProductsFailure: {
            index: "uint",
            name: "string",
            reason: "string"
        },
        BulkImportCateringProductsResponse: {
            created: "BulkImportCateringProductsCreated[]",
            failed: "BulkImportCateringProductsFailure[]"
        },
        BaseCategory: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?"
        },
        CategorySubCategoriesSubCategories: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?"
        },
        CategorySubCategories: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?",
            subCategories: "CategorySubCategoriesSubCategories[]"
        },
        Category: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?",
            subCategories: "CategorySubCategories[]",
            chartAccount: "BackOfficeChartAccountResponse?"
        },
        NewCategory: {
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            parentId: "string?",
            chartAccountId: "uuid?"
        },
        SellableListProducts: {
            id: "string",
            name: "string",
            category: "string",
            type: "string",
            image: "ImageUrl?",
            hasAlcohol: "bool?",
            fiscalCode: "string?",
            systemProductId: "string?"
        },
        SellableListCombos: {
            id: "string",
            name: "string",
            description: "string",
            category: "string",
            image: "ImageUrl?"
        },
        SellableList: {
            products: "SellableListProducts[]",
            combos: "SellableListCombos[]"
        },
        CategoryWithTotalProducts: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?",
            totalProducts: "uint",
            chartAccount: "BackOfficeChartAccountResponse?",
            subCategories: "CategoryWithTotalProducts[]"
        },
        SummarizedCategory: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?",
            totalProducts: "uint",
            subCategories: "SummarizedCategory[]"
        },
        CmvReportOverrite: {
            productUnitCost: "string?"
        },
        NewCmvReport: {
            id: "string",
            productName: "string",
            productCategory: "string",
            fiscalCode: "string",
            ncm: "string?",
            count: "float",
            totalValue: "string",
            totalDiscount: "string",
            productUnitCost: "string?",
            mountables: "CmvReportMountables[]",
            totalCost: "string",
            totalProfit: "string",
            profitMargin: "float",
            countByProportionOfUnit: "ConvertedProportionOfUnit?",
            cmv: "float",
            value: "string",
            lostCount: "float",
            lostCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            basicStorageUnit: "BasicStorageUnit?"
        },
        CmvReportResult: {
            items: "NewCmvReport[]",
            totalCount: "float",
            totalValue: "string",
            totalCost: "string",
            totalProfit: "string",
            profitMargin: "float"
        },
        ProductStoragePosition: {
            id: "string",
            fiscalCode: "string?",
            category: "string",
            name: "string",
            count: "int",
            averageUnitValue: "string?"
        },
        CmvMonthlyClosing: {
            productsSold: "uint",
            productsDiscount: "uint",
            cmv: "string?",
            cmvProductionLost: "string?",
            cmvLost: "string?"
        },
        ProductLostReport: {
            id: "string",
            fiscalCode: "string?",
            category: "string",
            name: "string",
            lost: "uint",
            lostByProportionOfUnit: "ConvertedProportionOfUnit?",
            inventory: "uint",
            inventoryByProportionOfUnit: "ConvertedProportionOfUnit?",
            refund: "uint",
            refundByProportionOfUnit: "ConvertedProportionOfUnit?",
            productionLost: "uint",
            productionLostByProportionOfUnit: "ConvertedProportionOfUnit?",
            totalLost: "uint",
            totalLostByProportionOfUnit: "ConvertedProportionOfUnit?",
            averageUnitValue: "string?",
            totalCost: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            proportionOfUnit: "ProportionOfUnit?"
        },
        BackofficeLostReportPagination: {
            page: "uint",
            itemsPerPage: "uint?"
        },
        BackofficeLostReportTotals: {
            cost: "string"
        },
        BackofficeLostReport: {
            items: "ProductLostReport[]",
            totals: "BackofficeLostReportTotals",
            page: "uint",
            itemsPerPage: "uint",
            totalItems: "uint"
        },
        NewPlaceComboProducts: {
            id: "string",
            count: "int"
        },
        NewPlaceCombo: {
            name: "string",
            value: "int",
            description: "string?",
            category: "string",
            active: "bool",
            fiscalData: "ProductFiscalData?",
            products: "NewPlaceComboProducts[]",
            printComboProductsIndividually: "bool?"
        },
        PlaceComboProducts: {
            id: "string",
            count: "int",
            name: "string",
            image: "ImageUrl?",
            category: "string"
        },
        PlaceCombo: {
            id: "string",
            name: "string",
            value: "int",
            description: "string?",
            category: "string",
            active: "bool",
            fiscalData: "ProductFiscalData?",
            products: "PlaceComboProducts[]",
            image: "ImageUrl?",
            printComboProductsIndividually: "bool?"
        },
        DataCombo: {
            id: "string",
            updatedAt: "date",
            value: "int",
            placeId: "string",
            isActive: "bool",
            name: "string",
            categoryId: "string",
            organizationId: "string",
            imageId: "string?",
            description: "string?",
            fiscalCode: "string?",
            fiscalNcm: "string?",
            fiscalCest: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?",
            fiscalProductGroupId: "string?",
            fiscalProfileId: "string?",
            isActiveForGrabAndGo: "bool",
            isDeleted: "bool"
        },
        ComodatoContractListItem: {
            id: "uuid",
            contractNumber: "string",
            requestType: "ComodatoContractRequestType",
            requestModel: "ComodatoContractRequestModel",
            signatoryName: "string",
            requestedAt: "datetime",
            signedAt: "datetime?",
            expiresAt: "datetime",
            status: "ComodatoContractStatus",
            canResendSignature: "bool"
        },
        ComodatoContractListFilters: {
            status: "ComodatoContractStatus[]?",
            contractNumber: "string?",
            dateFrom: "datetime?",
            dateTo: "datetime?"
        },
        ComodatoContractListPagination: {
            page: "int?",
            limit: "int?",
            sortBy: "ComodatoContractSortBy?",
            sortOrder: "SortOrder?"
        },
        ComodatoContractListResponsePagination: {
            currentPage: "int",
            perPage: "int",
            total: "int",
            lastPage: "int"
        },
        ComodatoContractListResponse: {
            data: "ComodatoContractListItem[]",
            pagination: "ComodatoContractListResponsePagination"
        },
        ComodatoContractListRequest: {
            placeId: "uuid",
            filters: "ComodatoContractListFilters?",
            pagination: "ComodatoContractListPagination?"
        },
        ExportComodatoContractsRequest: {
            placeId: "uuid",
            filters: "ComodatoContractListFilters?"
        },
        ResendComodatoContractSignatureRequest: {
            contractId: "uuid"
        },
        UpsertProductsWebRequest: {
            slug: "string?",
            bar: "string?"
        },
        UpsertProductsWebResponse: {
            slug: "string?",
            bar: "string?"
        },
        DeliveryFeeFiscalProductGroupDeliveryFee: {
            id: "uuid",
            name: "string",
            description: "string?",
            issueInvoice: "bool"
        },
        DeliveryFeeFiscalProductGroupBinding: {
            deliveryFee: "DeliveryFeeFiscalProductGroupDeliveryFee",
            fiscalProductGroupId: "uuid?"
        },
        Device: {
            code: "string",
            id: "string"
        },
        DeviceEventStatusCleanedDataEmployee: {
            name: "string",
            username: "string"
        },
        DeviceEventStatusCleanedData: {
            employee: "DeviceEventStatusCleanedDataEmployee",
            date: "datetime"
        },
        DeviceEventStatusDeviceConfig: {
            wifi: "bool?",
            bluetooth: "bool?",
            offlineMode: "bool?",
            nfc: "bool?",
            isMobileDataEnabled: "bool?",
            mobileDataCarrier: "string?",
            mobileDataType: "string?",
            airplaneMode: "bool?",
            mposConnected: "bool?",
            mposConnectedMac: "string?",
            remainingBattery: "int?"
        },
        DeviceEventStatusDevicePreferences: {
            isSearchByCodeEnabled: "bool?",
            dettachOnCheckout: "bool?",
            hideDettachOption: "bool?",
            hidePaymentModeVoucher: "bool?",
            isNormalSellEnabled: "bool?",
            isGroupedSellEnabled: "bool?",
            isSellWithoutCardEnabled: "bool?",
            printTwoTickets: "bool?",
            isStorageTransferPrinterLanActive: "bool?",
            printViaBtForWaiter: "bool?",
            isNumericKeyboardInObsEnabled: "bool?",
            registerWithoutCard: "bool?",
            removeCreditDebitPaymentOption: "bool?",
            isKeyboardOpenEnabled: "bool?",
            isStockTransfEnabled: "bool?"
        },
        DeviceEventStatusDevicePlatformScreen: {
            width: "int?",
            height: "int?"
        },
        DeviceEventStatusDevicePlatform: {
            brand: "string?",
            model: "string?",
            screen: "DeviceEventStatusDevicePlatformScreen?",
            version: "string?",
            sdkVersion: "int?"
        },
        DeviceEventStatus: {
            id: "string",
            fingerprint: "string",
            employeeId: "string?",
            employeeName: "string?",
            employeeUsername: "string?",
            shouldEmployeeConnectToMpos: "bool?",
            firstActivity: "datetime",
            lastOfflineSync: "datetime",
            pdvVersion: "string",
            hasFinishedActivity: "bool?",
            hasCleanedData: "bool",
            deviceType: "string?",
            cleanedData: "DeviceEventStatusCleanedData[]",
            deviceConfig: "DeviceEventStatusDeviceConfig",
            devicePreferences: "DeviceEventStatusDevicePreferences",
            devicePlatform: "DeviceEventStatusDevicePlatform?"
        },
        DeviceConfig: {
            id: "string",
            fingerprint: "string",
            employeeId: "string?",
            employeeName: "string?",
            updatedAt: "datetime?",
            createdAt: "datetime?",
            version: "string?",
            status: "string?"
        },
        DiscountPercentageRange: {
            minDiscountPercentage: "float",
            maxDiscountPercentage: "float"
        },
        DiscountValueRange: {
            minValue: "uint",
            maxValue: "uint"
        },
        BaseDiscountCategory: {
            name: "string",
            discountPercentageRange: "DiscountPercentageRange?",
            discountValueRange: "DiscountValueRange?",
            type: "DiscountCategoryType",
            hasObservation: "bool?"
        },
        CreateDiscountCategoryRequest: {
            name: "string",
            discountPercentageRange: "DiscountPercentageRange?",
            discountValueRange: "DiscountValueRange?",
            type: "DiscountCategoryType",
            hasObservation: "bool?"
        },
        UpdateDiscountCategoryRequest: {
            name: "string",
            discountPercentageRange: "DiscountPercentageRange?",
            discountValueRange: "DiscountValueRange?",
            type: "DiscountCategoryType",
            hasObservation: "bool?"
        },
        DiscountCategoryResponse: {
            name: "string",
            discountPercentageRange: "DiscountPercentageRange?",
            discountValueRange: "DiscountValueRange?",
            type: "DiscountCategoryType",
            hasObservation: "bool?",
            id: "string",
            createdAt: "datetime",
            updatedAt: "datetime",
            isDeleted: "bool"
        },
        DiscountCategoryResponseWithPlaces: {
            name: "string",
            discountPercentageRange: "DiscountPercentageRange?",
            discountValueRange: "DiscountValueRange?",
            type: "DiscountCategoryType",
            hasObservation: "bool?",
            id: "string",
            createdAt: "datetime",
            updatedAt: "datetime",
            isDeleted: "bool",
            isActive: "bool"
        },
        DiscountCategoriesResponse: {
            data: "DiscountCategoryResponseWithPlaces[]",
            pagination: "PaginationResponse"
        },
        EmployeesByDiscountCategory: {
            id: "string?",
            name: "string",
            username: "string",
            br: "string?"
        },
        DiscountCategoryFilters: {
            isActive: "bool?",
            name: "string?"
        },
        OperationResult: {
            message: "string",
            employeeId: "string"
        },
        MultipleEmployeeResult: {
            error: "OperationResult[]",
            success: "OperationResult[]"
        },
        Employee: {
            id: "string",
            name: "string",
            username: "string",
            zigReadPermissionKey: "string?",
            avatar: "ImageUrl?",
            permissions: "Permission[]",
            role: "Role?",
            organization: "Organization",
            places: "Place[]",
            zigTag: "string?",
            deviceIds: "string[]?",
            blockedBarIds: "string[]?",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            type: "EmployeeType?",
            isDeleted: "bool?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            bars: "string[]?",
            email: "email?"
        },
        EmployeeV2Places: {
            id: "string",
            name: "string"
        },
        EmployeeV2Bars: {
            id: "string?",
            name: "string",
            image: "ImageUrl?",
            storageId: "string",
            storageName: "string?",
            internalIp: "string?",
            internalIps: "string[]?",
            fichaLogoSha256: "string?",
            fichaLogoUrl: "string?",
            isDeleted: "bool?",
            isMainBar: "bool",
            shouldPrint: "bool"
        },
        EmployeeV2: {
            id: "string",
            name: "string",
            username: "string",
            avatar: "ImageUrl?",
            permissions: "Permission[]",
            role: "Role?",
            places: "EmployeeV2Places[]",
            bars: "EmployeeV2Bars[]",
            zigTag: "string?",
            deviceIds: "string[]?",
            blockedBarIds: "string[]?",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?"
        },
        GetEmployeesV2Filters: {
            placeIds: "uuid[]?"
        },
        EditMultipleEmployeesBars: {
            id: "string",
            isMainBar: "bool",
            shouldPrint: "bool",
            operation: "EditMultipleEmployeesBarsOperation"
        },
        EditMultipleEmployees: {
            username: "string?",
            initialUsernameNumber: "uint?",
            name: "string?",
            initialNameNumber: "uint?",
            permissions: "Permission[]?",
            role: "Role?",
            bars: "EditMultipleEmployeesBars[]?",
            placeIds: "string[]?",
            blockedBarIds: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?"
        },
        AddMultipleEmployeesV2Employee: {
            name: "string",
            zigReadPermissionKey: "string?",
            permissions: "Permission[]",
            role: "Role?",
            places: "string[]",
            bars: "BaseEmployeeBars[]",
            blacklistEntrances: "string[]?",
            fichasAmount: "uint?",
            menuVisualizationType: "EmployeeMenuVisualizationType?",
            shouldBeBoundToAllPlaces: "bool?",
            type: "EmployeeType?",
            assignableRoleIds: "string[]?",
            assignableBarIds: "string[]?",
            sectors: "string[]?",
            vendors: "string[]?",
            email: "email?",
            password: "string?",
            isPDV: "bool?",
            username: "string",
            barId: "string?",
            since: "uint?",
            until: "uint?",
            image: "bytes?"
        },
        EmployeeDeviceConfigsUpdatePreferences: {
            isSearchByCodeEnabled: "bool",
            dettachOnCheckout: "bool",
            hideDettachOption: "bool",
            hidePaymentModeVoucher: "bool",
            isNormalSellEnabled: "bool",
            isGroupedSellEnabled: "bool",
            isSellWithoutCardEnabled: "bool",
            printTwoTickets: "bool",
            isStorageTransferPrinterLanActive: "bool",
            printViaBtForWaiter: "bool",
            isNumericKeyboardInObsEnabled: "bool",
            registerWithoutCard: "bool",
            removeCreditDebitPaymentOption: "bool",
            isKeyboardOpenEnabled: "bool",
            isStockTransfEnabled: "bool"
        },
        EmployeeDeviceConfigsUpdate: {
            version: "string?",
            wifi: "bool?",
            bluetooth: "bool?",
            offlineMode: "bool?",
            connectToMpos: "bool?",
            preferences: "EmployeeDeviceConfigsUpdatePreferences?"
        },
        Entrance: {
            id: "string?",
            name: "string",
            category: "string",
            value: "int",
            image: "ImageUrl?",
            minimumConsumptionValue: "int",
            active: "bool",
            consumptionObligation: "uint",
            fiscalData: "PlaceProductFiscalData?",
            fiscalCode: "string?",
            menuCategoryId: "string?",
            proportionalValue: "ProportionalValue?",
            bonus: "uint?"
        },
        EntranceSold: {
            id: "string",
            name: "string",
            image: "ImageUrl?",
            count: "uint",
            totalValue: "uint",
            discountValue: "uint",
            unitValue: "uint",
            proportionalValue: "ProportionalValue?"
        },
        RelationTicket: {
            names: "string?",
            count: "uint"
        },
        TicketSold: {
            id: "string",
            name: "string",
            averageValue: "uint",
            perRelation: "RelationTicket[]"
        },
        Bilheteiro: {
            id: "string",
            name: "string",
            tickets: "TicketSold[]"
        },
        EntranceUser: {
            id: "uuid",
            name: "string",
            cpf: "string",
            date: "datetime",
            productName: "string",
            category: "string",
            count: "uint",
            unitValue: "uint",
            employeeName: "string",
            totalValue: "uint",
            totalDiscountValue: "uint"
        },
        UsersEntrancesConsumedEntrances: {
            id: "string",
            name: "string"
        },
        UsersEntrancesConsumed: {
            id: "string",
            name: "string?",
            document: "string",
            phone: "string",
            birthDate: "date?",
            entrances: "UsersEntrancesConsumedEntrances[]",
            entranceValue: "uint",
            consumption: "uint",
            total: "uint",
            checkinTime: "datetime",
            checkoutTime: "datetime?"
        },
        UsersEntrancesConsumedReportResponse: {
            data: "UsersEntrancesConsumed[]",
            pagination: "PaginationResponse"
        },
        UsersEntrancesConsumedReportFilters: {
            entranceIds: "string[]?",
            period: "PeriodTime?"
        },
        UsersEntrancesConsumedOverview: {
            totalUsers: "uint",
            entranceTotal: "uint",
            consumptionTotal: "uint",
            total: "uint"
        },
        SummaryEvent: {
            id: "string",
            name: "string",
            status: "EventState",
            begin: "datetime",
            end: "datetime?",
            image: "ImageUrl?",
            tags: "string[]",
            unfinishedPdvs: "uint?",
            hasOpenedTables: "bool?",
            lastSyncAfterClosed: "datetime?",
            income: "money?",
            totalPublic: "uint?",
            averageTicket: "money?",
            sales: "EventsSummarySales?",
            closingConferenceStatus: "ClosingEventConferenceStatus?",
            openedBy: "string?",
            openedAt: "datetime?",
            checkedAt: "datetime?",
            checkedBy: "CheckedBy?"
        },
        EventsSummarySales: {
            productsSold: "money?",
            entrance: "money?",
            service: "money?",
            remainingConsumptionObligation: "money?",
            manualInvoices: "money?"
        },
        EventListIncomeSummary: {
            cash: "money",
            credit: "money",
            debit: "money",
            app: "money",
            pix: "money",
            rappi: "money",
            uber: "money",
            ifood: "money",
            ame: "money",
            deliveryOnline: "money",
            voucher: "money",
            mbway: "money",
            anticipated: "money",
            dashboard: "money",
            online: "money",
            postEvent: "money",
            singleProductReturns: "money",
            rechargesReturned: "money",
            consummationGiven: "money",
            totalRefundedPostPayments: "money?"
        },
        EventList: {
            totalClients: "uint",
            averageTicket: "money",
            totalIncome: "money",
            futureEvents: "money",
            totalSales: "EventsSummarySales",
            incomeSummary: "EventListIncomeSummary?",
            events: "SummaryEvent[]"
        },
        EventBaseInfo: {
            sales: "money",
            public: "uint",
            id: "string",
            placeId: "string"
        },
        BankslipInfo: {
            exists: "bool",
            value: "money?",
            expirationDate: "datetime?",
            attachments: "string[]?"
        },
        MaximumPossibleAnticipationValuesResult: {
            anticipationLiquidValue: "money",
            anticipationBruteValue: "money",
            proRataFee: "float"
        },
        WithdrawRequestIdsWithDate: {
            id: "string",
            createdAt: "datetime",
            attachments: "string[]?"
        },
        AuthKeyValueData: {
            keyType: "AuthKeyType",
            keyValue: "string"
        },
        CreateWithdrawAuthKeyRequest: {
            placeId: "uuid?",
            vendorId: "uuid?",
            values: "AuthKeyValueData[]"
        },
        GetWithdrawAuthKeysRequest: {
            placeId: "uuid?",
            vendorId: "uuid?"
        },
        WithdrawAuthKeyResponse: {
            id: "uuid",
            keyType: "AuthKeyType",
            keyValue: "string",
            status: "AuthKeyStatus",
            attempts: "int",
            lastSentAt: "datetime?",
            createdAt: "datetime"
        },
        CreateWithdrawAuthKeysResponse: {
            success: "WithdrawAuthKeyResponse[]",
            errors: "CreateWithdrawAuthKeyError[]"
        },
        CreateWithdrawAuthKeyError: {
            keyValue: "string",
            error: "string"
        },
        UnlockWithdrawAuthKeyRequest: {
            authKeyId: "uuid"
        },
        DeleteWithdrawAuthKeyRequest: {
            authKeyIds: "uuid[]"
        },
        DeleteWithdrawAuthKeyResponse: {
            success: "uuid[]",
            errors: "DeleteWithdrawAuthKeyError[]"
        },
        DeleteWithdrawAuthKeyError: {
            authKeyId: "uuid",
            error: "string"
        },
        RequestAuthKeyCodeRequest: {
            authKeyId: "uuid"
        },
        RequestAuthKeyCodeResponse: {
            expiresAt: "datetime"
        },
        ValidateAuthKeyCodeRequest: {
            authKeyId: "uuid",
            code: "string"
        },
        ValidateAuthKeyCodeResponse: {
            valid: "bool"
        },
        BillPayment: {
            method: "PaymentMethod",
            value: "money"
        },
        MultipleUserIdsResultError: {
            userId: "string",
            reason: "string"
        },
        MultipleUserIdsResult: {
            success: "string[]",
            error: "MultipleUserIdsResultError[]"
        },
        ZigMachineResume: {
            debit: "money",
            credit: "money"
        },
        IncomeResume: {
            products: "uint",
            entrances: "uint"
        },
        Client: {
            id: "string",
            cpf: "string",
            birthDate: "date?",
            hasApp: "bool",
            name: "string",
            phone: "string",
            zigCode: "string?",
            appTransactionsValue: "money",
            housePostPaidTransactionsValue: "money",
            housePrePaidTransactionsValue: "money",
            bonusTransactionsValue: "money",
            remaningValueOnPlace: "money"
        },
        ClientAtPlace: {
            id: "string",
            cpf: "string",
            birthDate: "date?",
            hasApp: "bool",
            name: "string",
            phone: "string",
            zigCode: "string?",
            appTransactionsValue: "money",
            housePostPaidTransactionsValue: "money",
            housePrePaidTransactionsValue: "money",
            bonusTransactionsValue: "money",
            remaningValueOnPlace: "money",
            hasBiometry: "bool?",
            avatarUrl: "string?"
        },
        OptionsClientsEvent: {
            invoicesNotIssued: "bool?",
            includeTable: "bool?"
        },
        MountableSectionProduct: {
            id: "string",
            name: "string",
            count: "int",
            title: "string",
            storageCount: "uint",
            maxCount: "uint?",
            price: "money",
            isActive: "bool",
            basicStorageUnit: "string"
        },
        UserTransactionProduct: {
            id: "string",
            type: "SellableThing",
            name: "string",
            count: "int",
            value: "money?",
            discountValue: "money?",
            sections: "MountableSectionProduct[]?"
        },
        Payments: {
            bonus: "money",
            prePaid: "money",
            ppu: "money",
            postPaid: "money"
        },
        TransactionBuyers: {
            id: "string",
            name: "string"
        },
        UserTransaction: {
            id: "string",
            products: "UserTransactionProduct[]",
            seller: "Seller",
            buyers: "TransactionBuyers[]",
            date: "datetime",
            refunded: "bool",
            tip: "money"
        },
        Debtor: {
            userId: "string",
            userName: "string",
            userDocument: "string",
            value: "money",
            tipValue: "money",
            paidValue: "money",
            paidTipValue: "money",
            phone: "string",
            email: "string?",
            status: "DebtorStatus",
            openBillChargeId: "string?"
        },
        DebtorsFilters: {
            status: "DebtorStatus?",
            userName: "string?",
            userDocument: "string?"
        },
        OpenedBillsOverview: {
            value: "money",
            tipValue: "money",
            paidValue: "money",
            paidTipValue: "money",
            valueExemptFromTip: "money",
            paidInOtherEvents: "money",
            openBillsTotal: "money"
        },
        PaginatedDebtorsResponse: {
            data: "Debtor[]",
            pagination: "PaginationResponse",
            totalizers: "OpenedBillsOverview"
        },
        DebtorsXlsInput: {
            scope: "GetReportByScope",
            filters: "DebtorsFilters"
        },
        UserBonusReportGivenBy: {
            name: "string",
            username: "string?"
        },
        UserBonusReport: {
            id: "string",
            name: "string",
            receivedValue: "money",
            spentValue: "money",
            givenBy: "UserBonusReportGivenBy",
            reason: "string?",
            date: "datetime?",
            spentInOtherEvent: "uint",
            bonusCategoryId: "string?",
            bonusCategoryName: "string?"
        },
        BonusReportFilters: {
            bonusCategoryIds: "string[]?",
            employeesIds: "string[]?"
        },
        BonusReportInput: {
            eventId: "string",
            filters: "BonusReportFilters",
            pagination: "Pagination"
        },
        BonusReportForPlaceInputFilters: {
            bonusCategoryIds: "string[]?",
            employeesIds: "string[]?",
            since: "datetime",
            until: "datetime"
        },
        BonusReportForPlaceInput: {
            placeId: "string",
            filters: "BonusReportForPlaceInputFilters",
            pagination: "Pagination"
        },
        BonusReportResponse: {
            data: "UserBonusReport[]",
            pagination: "PaginationResponse"
        },
        BonusReportXlsInput: {
            scope: "GetReportByScope",
            filters: "BonusReportFilters"
        },
        BonusReportSummary: {
            receivedValue: "money",
            spentValue: "money",
            tipValue: "money",
            spentTipValueInOtherEvent: "money",
            spentInOtherEvent: "money",
            unusedValue: "money"
        },
        BonusReportOverview: {
            receivedValue: "money",
            spentValue: "money",
            spentInOtherEvent: "money"
        },
        BonusReportForPlaceOverviewInputFilters: {
            bonusCategoryIds: "string[]?",
            employeesIds: "string[]?",
            since: "datetime",
            until: "datetime"
        },
        BonusReportForPlaceOverviewInput: {
            placeId: "string",
            filters: "BonusReportForPlaceOverviewInputFilters"
        },
        BonusReportOverviewInput: {
            eventId: "string",
            filters: "BonusReportFilters"
        },
        UsedBonusReportUser: {
            id: "string",
            name: "string"
        },
        UsedBonusReportGivenBy: {
            name: "string",
            username: "string"
        },
        UsedBonusReport: {
            id: "string",
            user: "UsedBonusReportUser",
            spentValue: "money",
            givenAt: "datetime?",
            givenBy: "UsedBonusReportGivenBy?",
            reason: "string?",
            consumedAt: "datetime?"
        },
        ClientDetails: {
            id: "string",
            name: "string",
            email: "string?",
            hasApp: "bool",
            hasBiometry: "bool?",
            zigCode: "string?",
            phone: "string",
            cpf: "string",
            avatar: "ImageUrl?"
        },
        OpenedProduct: {
            openedValue: "uint",
            estimatedCount: "float",
            name: "string",
            id: "string",
            category: "string"
        },
        RechargeConsumption: {
            value: "money",
            user: "string",
            method: "RechargeConsumptionMethod",
            author: "string"
        },
        RefundedRechargeAuthor: {
            name: "string",
            username: "string?"
        },
        RefundedRechargeRefundedBy: {
            name: "string",
            username: "string?"
        },
        RefundedRecharge: {
            id: "string",
            totalValue: "money",
            usedValue: "money",
            date: "datetime",
            userName: "string?",
            author: "RefundedRechargeAuthor",
            refundedBy: "RefundedRechargeRefundedBy"
        },
        ActivationReturnReportProducts: {
            id: "string",
            count: "uint",
            name: "string"
        },
        ActivationReturnReport: {
            cashValue: "money",
            cashQuantity: "money",
            products: "ActivationReturnReportProducts[]"
        },
        UsedPromotion: {
            promotionId: "string",
            promotionName: "string",
            productId: "string",
            productName: "string",
            productCategory: "string",
            totalDiscount: "money",
            uses: "uint"
        },
        UserUsedPromotion: {
            userId: "string",
            userName: "string",
            userDocument: "string",
            promotion: "UsedPromotion"
        },
        TableUsedPromotion: {
            tableId: "string",
            tableName: "string",
            openedAt: "datetime",
            closedAt: "datetime?",
            promotionId: "string",
            promotionName: "string",
            productName: "string",
            productCategory: "string",
            uses: "uint",
            discountValue: "uint"
        },
        TotalsTablePromotion: {
            totalCount: "uint",
            totalDiscount: "uint"
        },
        TotalTablePromotionReport: {
            totals: "TotalsTablePromotion",
            promotions: "TableUsedPromotion[]",
            pagination: "PaginationResponse"
        },
        TablePromotionsUsedFilters: {
            tableNumbers: "string[]?",
            promotionId: "string[]?"
        },
        UsedPromotionsInScope: {
            promotionId: "string",
            promotionName: "string"
        },
        SoldEntranceWithEmployee: {
            employeeId: "string",
            employeeName: "string",
            employeeUsername: "string?",
            entranceId: "string",
            entranceName: "string",
            totalValue: "money",
            count: "uint"
        },
        TipRemovedListRemovals: {
            id: "string",
            name: "string",
            value: "money",
            reason: "string",
            date: "datetime"
        },
        TipRemovedList: {
            employee: "MinimalEmployee",
            totalRemoved: "money",
            removals: "TipRemovedListRemovals[]"
        },
        CardReturnEmployeeCashReturn: {
            count: "uint",
            value: "money"
        },
        CardReturnEmployeeProductReturn: {
            id: "string",
            count: "uint",
            name: "string"
        },
        CardReturnEmployeePixReturn: {
            count: "uint",
            value: "money"
        },
        CardReturnEmployee: {
            id: "string",
            name: "string",
            username: "string?",
            cashReturn: "CardReturnEmployeeCashReturn",
            productReturn: "CardReturnEmployeeProductReturn[]",
            pixReturn: "CardReturnEmployeePixReturn"
        },
        DiscountEmployeeDiscountsUsers: {
            id: "string",
            name: "string"
        },
        DiscountEmployeeDiscountsDiscountCategory: {
            id: "string",
            name: "string"
        },
        DiscountEmployeeDiscounts: {
            date: "datetime",
            value: "money",
            users: "DiscountEmployeeDiscountsUsers[]",
            products: "string[]",
            reason: "string?",
            percentual: "float?",
            discountCategory: "DiscountEmployeeDiscountsDiscountCategory?"
        },
        DiscountEmployee: {
            id: "string",
            name: "string",
            username: "string?",
            discounts: "DiscountEmployeeDiscounts[]"
        },
        ManualInvoice: {
            eventId: "string",
            invoiceId: "string",
            value: "money",
            paymentMethod: "string"
        },
        PostLimitChange: {
            userName: "string?",
            employeeId: "string",
            employeeName: "string",
            employeeUsername: "string?",
            date: "datetime",
            limit: "uint"
        },
        OpenedBillPaymentUser: {
            id: "string",
            name: "string"
        },
        OpenedBillPaymentEmployee: {
            id: "string",
            name: "string"
        },
        OpenedBillPayment: {
            user: "OpenedBillPaymentUser",
            employee: "OpenedBillPaymentEmployee",
            openedEventsDates: "date[]",
            paymentId: "string",
            method: "OpenedBillPaymentMethod",
            value: "money"
        },
        OpenedBillPaymentV2User: {
            id: "string",
            name: "string?",
            document: "string"
        },
        OpenedBillPaymentV2Employee: {
            id: "string",
            name: "string",
            username: "string?"
        },
        OpenedBillPaymentV2: {
            user: "OpenedBillPaymentV2User",
            employee: "OpenedBillPaymentV2Employee",
            value: "money",
            tipValue: "money?",
            methods: "PaymentMethod[]",
            openedEventId: "string",
            openedEventDate: "date",
            date: "datetime",
            reason: "string?"
        },
        OpenedBillPaymentsFilters: {
            userName: "string?",
            userDocument: "string?"
        },
        OpenedBillPaymentsOverview: {
            value: "money",
            tipValue: "money",
            openBillsTotal: "money"
        },
        PaginatedOpenedBillPaymentsResponse: {
            data: "OpenedBillPaymentV2[]",
            pagination: "PaginationResponse",
            totalizers: "OpenedBillPaymentsOverview"
        },
        OpenedBillReportOverview: {
            openBillsTotal: "money",
            linksGenerated: "uint",
            paidValueTotal: "money"
        },
        OpenedBillPaymentsXlsInput: {
            scope: "GetReportByScope",
            filters: "OpenedBillPaymentsFilters"
        },
        RappiDiscountEmployee: {
            name: "string",
            username: "string?"
        },
        RappiDiscount: {
            id: "string",
            products: "string[]",
            value: "money",
            date: "datetime",
            employee: "RappiDiscountEmployee"
        },
        ConsumptionObligationReportUser: {
            id: "string",
            name: "string"
        },
        ConsumptionObligationReportEmployee: {
            id: "string",
            name: "string",
            username: "string?"
        },
        ConsumptionObligationReport: {
            user: "ConsumptionObligationReportUser",
            employee: "ConsumptionObligationReportEmployee",
            value: "money",
            paidValue: "money",
            userProductsValueAtEvent: "money",
            date: "datetime",
            id: "string"
        },
        MoneyOperation: {
            id: "string",
            value: "money",
            date: "datetime",
            client: "string",
            author: "string",
            method: "string"
        },
        MinimumConsumptionReportGivenBy: {
            name: "string",
            username: "string?"
        },
        MinimumConsumptionReport: {
            id: "string",
            name: "string",
            receivedValue: "money",
            spentValue: "money",
            givenBy: "MinimumConsumptionReportGivenBy",
            reason: "string?",
            date: "datetime"
        },
        ReportAfterEventClosingEmployee: {
            id: "string",
            name: "string",
            username: "string?"
        },
        ReportAfterEventClosingUser: {
            cpf: "string?",
            name: "string?"
        },
        ReportAfterEventClosingTransactionType: {
            id: "string",
            name: "string"
        },
        ReportAfterEventClosing: {
            id: "string",
            createdAt: "datetime",
            employee: "ReportAfterEventClosingEmployee",
            user: "ReportAfterEventClosingUser[]",
            value: "uint",
            transactionType: "ReportAfterEventClosingTransactionType?",
            origin: "ReportAfterEventClosingOrigin"
        },
        FilterReportAfterEventClosing: {
            key: "string",
            values: "string[]"
        },
        ZigDeviceSyncForceAtEventEmployee: {
            id: "uuid",
            name: "string",
            username: "string?"
        },
        ZigDeviceSyncForceAtEventUser: {
            id: "uuid",
            name: "string"
        },
        ZigDeviceSyncForceAtEvent: {
            id: "uuid",
            balance: "money",
            reason: "string",
            date: "datetime",
            employee: "ZigDeviceSyncForceAtEventEmployee",
            user: "ZigDeviceSyncForceAtEventUser"
        },
        RechargeConsumptionData: {
            Ame: "money",
            Anticipated: "money",
            Cash: "money",
            CreditCard: "money",
            Dashboard: "money",
            DebitCard: "money",
            DeliveryOnline: "money",
            Ifood: "money",
            Pix: "money",
            Rappi: "money",
            Uber: "money",
            Voucher: "money",
            ZigPosCredit: "money",
            ZigPosDebit: "money",
            IntegratedFoodVoucher: "money",
            MBWay: "money",
            ZigPosCreditInInstallments: "money"
        },
        RechargeConsumptionByAuthorAuthor: {
            id: "string",
            name: "string"
        },
        RechargeConsumptionByAuthor: {
            author: "RechargeConsumptionByAuthorAuthor",
            consumptions: "RechargeConsumptionData"
        },
        RechargeConsumptionByAuthorPaginated: {
            pagination: "PaginationResponse?",
            data: "RechargeConsumptionByAuthor[]"
        },
        RechargeConsumptionFromAuthorUser: {
            id: "uuid",
            name: "string"
        },
        RechargeConsumptionFromAuthor: {
            user: "RechargeConsumptionFromAuthorUser",
            paymentMethod: "RechargePaymentMethod",
            value: "money"
        },
        TotemTransactionResponse: {
            data: "TotemTransaction[]",
            pagination: "PaginationResponse"
        },
        TotemTransaction: {
            date: "datetime?",
            name: "string?",
            employeeName: "string?",
            employeeUsername: "string?",
            isRefunded: "bool?",
            methods: "PaymentMethod[]?",
            products: "ProductDetails[]?",
            transactionId: "string",
            paymentValue: "uint",
            paymentTipValue: "uint",
            acquirerTransactionsId: "string?"
        },
        TotemTransactionFilters: {
            idOrCpf: "string?",
            paymentMethod: "PaymentMethod?",
            employee: "string?"
        },
        TotemTransactionTotalizerResponse: {
            totalCustomers: "uint?",
            averageTicket: "uint?",
            salesTotal: "uint?"
        },
        AppTransactionDetails: {
            transactionId: "string",
            name: "string?",
            cpf: "string",
            userId: "string",
            appPaymentType: "AppTransactionDetailsAppPaymentType",
            employee: "MinimalEmployee",
            isRefunded: "bool",
            createdAt: "datetime",
            appPaymentValue: "uint",
            appPaymentTipValue: "uint",
            products: "ProductDetails[]",
            acquirerTransactionId: "string?",
            transactionType: "AppTransactionDetailsTransactionType",
            isSellingByZigTag: "bool"
        },
        AppTransactionDetailsPaginationResponse: {
            data: "AppTransactionDetails[]",
            pagination: "PaginationResponse"
        },
        ProductDetails: {
            name: "string",
            id: "string",
            count: "uint",
            value: "uint",
            discount: "uint"
        },
        AppTransactionsTotalizer: {
            clientCount: "uint",
            totalSold: "uint",
            totalByBalance: "uint",
            totalByCreditCard: "uint",
            totalRefunded: "uint"
        },
        AppTransactionsFilters: {
            appPaymentType: "AppTransactionDetailsAppPaymentType?",
            customerName: "string?"
        },
        OpenBillCharge: {
            id: "uuid",
            expiredAt: "datetime?",
            openBillChargeDetails: "OpenBillChargeDetails"
        },
        TransactionTransfer: {
            id: "uuid",
            transactionTransferId: "string",
            transactionId: "string",
            originId: "string",
            receiverId: "string",
            date: "datetime",
            tipValue: "uint",
            newTransactionId: "string?",
            employeeName: "string",
            employeeUserName: "string",
            originDocument: "string",
            originName: "string",
            receiverDocument: "string",
            receiverName: "string",
            productName: "string",
            productId: "string",
            productDiscountValue: "uint",
            productValue: "uint",
            count: "uint"
        },
        AllSalesPaginationResponse: {
            data: "SalesDetails[]",
            pagination: "PaginationResponse"
        },
        AllSalesSummaryResponse: {
            totalInSales: "uint",
            discount: "uint",
            productSales: "uint",
            productsSold: "uint"
        },
        SalesDetailsOrderBy: {
            column: "SalesDetailsOrderByColumn",
            order: "SalesDetailsOrderByOrder"
        },
        SalesFilters: {
            customerName: "string?",
            employeeIds: "string[]?",
            paymentMethods: "PaymentMethod[]?",
            sectorIds: "string[]?",
            barIds: "string[]?"
        },
        SalesDetailsFilters: {
            customerName: "string?",
            employeeIds: "string[]?",
            paymentMethods: "PaymentMethod[]?",
            sectorIds: "string[]?",
            barIds: "string[]?",
            orderBy: "SalesDetailsOrderBy[]?"
        },
        SalesDetailsProducts: {
            name: "string",
            fiscalCode: "string?",
            category: "string?",
            count: "uint",
            value: "uint",
            discount: "uint",
            total: "uint"
        },
        SalesDetails: {
            date: "datetime?",
            transactionId: "string?",
            userId: "string?",
            name: "string?",
            document: "string?",
            sellerId: "string?",
            sellerName: "string?",
            value: "money?",
            discount: "money?",
            paymentMethods: "PaymentMethod[]?",
            isRefunded: "bool?",
            products: "SalesDetailsProducts[]?"
        },
        PlaceReportResumeRevenue: {
            totalIncome: "int",
            anticipated: "money",
            app: "money",
            cash: "money",
            dashboard: "money",
            credit: "money",
            debit: "money",
            postEvent: "money",
            rappi: "money",
            voucher: "money",
            zigCredit: "money",
            zigDebit: "money",
            pix: "money",
            rechargeDevolutions: "money",
            barTip: "money",
            entranceTip: "money",
            consumptionFromBar: "money"
        },
        PlaceReportResumePublic: {
            averageTicket: "int",
            totalPublic: "uint",
            malePublic: "uint",
            femalePublic: "uint",
            otherPublic: "uint"
        },
        PlaceReportResume: {
            date: "date",
            revenue: "PlaceReportResumeRevenue",
            public: "PlaceReportResumePublic"
        },
        PlaceReport: {
            id: "string",
            name: "string",
            resume: "PlaceReportResume[]"
        },
        FinancialClosingReportMapItem: {
            id: "uuid",
            division: "string",
            name: "string",
            fee: "string?",
            payDate: "string",
            type: "string",
            isActive: "bool"
        },
        CreateFinancialClosingReportMapInput: {
            division: "string",
            name: "string",
            fee: "string?",
            payDate: "string",
            type: "string",
            isActive: "bool?"
        },
        UpdateFinancialClosingReportMapInput: {
            division: "string?",
            name: "string?",
            fee: "string?",
            payDate: "string?",
            type: "string?",
            isActive: "bool?"
        },
        CouvertFiscalDataForPlaceFiscalProfile: {
            id: "string",
            name: "string"
        },
        CouvertFiscalDataForPlaceFiscalProductGroup: {
            id: "string",
            name: "string"
        },
        CouvertFiscalDataForPlace: {
            placeId: "uuid",
            placeName: "string",
            codigo: "string?",
            ncm: "string?",
            cest: "string?",
            fiscalProfile: "CouvertFiscalDataForPlaceFiscalProfile?",
            fiscalProductGroup: "CouvertFiscalDataForPlaceFiscalProductGroup?"
        },
        FiscalProductNcms: {
            name: "string",
            ncm: "string"
        },
        FiscalProduct: {
            id: "string",
            image: "string?",
            name: "string",
            ncm: "string",
            ncms: "FiscalProductNcms[]",
            slug: "string"
        },
        ProductFiscalDataWithPlaceInfo: {
            placeId: "string",
            placeName: "string",
            codigo: "string?",
            ncm: "string?",
            cest: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?",
            fiscalProfileId: "string?",
            fiscalProductGroupId: "string?"
        },
        ProductFiscalData: {
            codigo: "string?",
            ncm: "string?",
            cest: "string?",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?",
            fiscalProfileId: "string?",
            fiscalProductGroupId: "string?"
        },
        Invoice: {
            id: "string",
            mode: "InvoiceMode",
            issuedAt: "datetime",
            canBeCanceled: "bool?",
            isCanceled: "bool",
            isIssued: "bool",
            isIssuing: "bool",
            error: "string?",
            users: "User[]",
            pdfUrl: "string?",
            imgUrl: "string?"
        },
        InvoiceWithEvent: {
            id: "string",
            mode: "InvoiceMode",
            issuedAt: "datetime",
            canBeCanceled: "bool?",
            isCanceled: "bool",
            isIssued: "bool",
            isIssuing: "bool",
            error: "string?",
            users: "User[]",
            pdfUrl: "string?",
            imgUrl: "string?",
            event: "MinimalEvent"
        },
        MinimalInvoiceWithEventEvent: {
            id: "string",
            name: "string",
            date: "datetime"
        },
        MinimalInvoiceWithEvent: {
            id: "string",
            invoiceNumber: "string?",
            parentInvoice: "string?",
            createdAt: "date?",
            pdfUrl: "string?",
            userActionUrl: "string?",
            expirationDate: "date?",
            event: "MinimalInvoiceWithEventEvent"
        },
        SimpleIssueResult: {
            errors: "string[]",
            failedInvoiceCount: "uint",
            success: "uint"
        },
        ObligationPaymentsForInvoice: {
            userId: "string",
            value: "uint"
        },
        RecipientExtraInfoAddress: {
            logradouro: "string",
            numero: "string",
            complemento: "string?",
            bairro: "string",
            cep: "string",
            municipio: "string",
            uf: "string"
        },
        RecipientExtraInfo: {
            address: "RecipientExtraInfoAddress?",
            inscricaoEstadual: "string?",
            indicadorInscricaoEstadual: "RecipientExtraInfoIndicadorInscricaoEstadual?",
            razaoSocial: "string?"
        },
        FiscalDraftActor: {
            id: "string",
            name: "string",
            type: "FiscalDraftActorType"
        },
        FiscalDraftWorkflow: {
            draftId: "string",
            parentId: "string?",
            createdAt: "datetime",
            createdBy: "FiscalDraftActor",
            approvedAt: "datetime?",
            approvedBy: "FiscalDraftActor?",
            rejectedAt: "datetime?",
            rejectedBy: "FiscalDraftActor?"
        },
        FiscalProfileOrg: {
            cnpj: "string",
            razaoSocial: "string",
            nomeFantasia: "string",
            regimeTributario: "RegimeTributario",
            regimeTributarioEspecial: "RegimeTributarioEspecial?",
            inscricaoEstadual: "string",
            inscricaoMunicipal: "string?",
            codigoMunicipio: "string?",
            hasCadastroNacionalContribuinte: "bool"
        },
        FiscalProfileContact: {
            email: "string",
            telefone: "string"
        },
        FiscalProfileAddress: {
            logradouro: "string",
            numero: "string",
            complemento: "string?",
            bairro: "string",
            cep: "string",
            municipio: "string",
            uf: "string"
        },
        FiscalProfileNfce: {
            cscNfceProducao: "string",
            idNfceProducao: "string",
            cscNfceHomologacao: "string?",
            idNfceHomologacao: "string?",
            certificado: "bytes?",
            senhaCertificado: "string",
            certificadoValidoAte: "datetime?"
        },
        FiscalProfileSat: {
            numeroSerieSat: "string"
        },
        FiscalProfileIvaVendusPaymentIds: {
            cash: "uint",
            credit: "uint",
            debit: "uint",
            mbWay: "uint",
            other: "uint"
        },
        FiscalProfileIvaVendus: {
            apiKey: "string",
            registerIds: "string[]",
            paymentIds: "FiscalProfileIvaVendusPaymentIds",
            country: "FiscalProfileIvaVendusCountry"
        },
        FiscalProfileIvaFactura: {
            apiKey: "string",
            secretKey: "string",
            fiscalProductGroupId: "string",
            autoInvoicingURL: "string",
            issuerDocument: "string",
            expirationDays: "uint?",
            expirationOpt: "FiscalProfileIvaFacturaExpirationOpt"
        },
        FiscalProfile: {
            id: "string",
            name: "string",
            hasPendingDraft: "bool?",
            validatedAt: "datetime?",
            org: "FiscalProfileOrg?",
            contact: "FiscalProfileContact",
            address: "FiscalProfileAddress?",
            nfce: "FiscalProfileNfce?",
            sat: "FiscalProfileSat?",
            ivaVendus: "FiscalProfileIvaVendus?",
            ivaFactura: "FiscalProfileIvaFactura?",
            fiscalMode: "FiscalMode?",
            tipFiscalData: "TipFiscalData?",
            enableFocusManifestation: "bool?",
            enableNationalService: "bool?"
        },
        TipFiscalData: {
            name: "string?",
            cest: "string?",
            code: "string?",
            ncm: "string?",
            fiscalProductGroupId: "string?",
            cnae: "string?"
        },
        FiscalProductGroupIcms: {
            origem: "string?",
            csosn: "string?",
            cst: "string?",
            aliquota: "float?",
            baseCalculo: "string?",
            reducaoBaseCalculo: "float?",
            benefCode: "string?",
            creditoPresumidoCode: "string?",
            creditoPresumidoAliquota: "float?",
            pFCP: "float?"
        },
        FiscalProductGroupPis: {
            cst: "string?",
            baseCalculo: "string?",
            aliquotaPerc: "float?",
            quantidadeVendida: "uint?",
            aliquotaReais: "uint?"
        },
        FiscalProductGroupCofins: {
            cst: "string?",
            baseCalculo: "string?",
            aliquotaPerc: "float?",
            quantidadeVendida: "uint?",
            aliquotaReais: "uint?"
        },
        FiscalProductGroupIvaDual: {
            codigoSituacaoTributaria: "string?",
            codigoClassificacaoTributaria: "string?",
            aliquotaEstadualIBS: "float?",
            aliquotaMunicipalIBS: "float?",
            aliquotaCBS: "float?",
            pRedAliqCBS: "float?",
            pRedAliqIBSUf: "float?",
            pRedAliqIBSMun: "float?"
        },
        FiscalProductGroupService: {
            aliquota: "float?",
            tipoServico: "string?",
            codigoTributacaoMunicipio: "string?",
            codigoNbs: "string?",
            codigoIndicadorOperacao: "string?"
        },
        FiscalProductGroupServiceNational: {
            codigoTributacaoNacionalIss: "string?",
            codigoTributacaoMunicipalIss: "string?",
            codigoNbs: "string?",
            aliquota: "float?",
            percentualTotalTributosSN: "float?",
            percentualTotalTributosFederais: "float?",
            percentualTotalTributosEstaduais: "float?",
            percentualTotalTributosMunicipais: "float?"
        },
        FiscalProductGroupVatVendusDetails: {
            code: "FiscalProductGroupVatVendusDetailsCode",
            productType: "FiscalProductGroupVatVendusDetailsProductType",
            taxExemption: "FiscalProductGroupVatVendusDetailsTaxExemption?",
            region: "FiscalProductGroupVatVendusDetailsRegion?"
        },
        FiscalProductGroup: {
            id: "string",
            name: "string",
            hasPendingDraft: "bool?",
            validatedAt: "datetime?",
            cfop: "string?",
            cfopInterestadual: "string?",
            icms: "FiscalProductGroupIcms?",
            pis: "FiscalProductGroupPis?",
            cofins: "FiscalProductGroupCofins?",
            ivaDual: "FiscalProductGroupIvaDual?",
            service: "FiscalProductGroupService?",
            serviceNational: "FiscalProductGroupServiceNational?",
            type: "FiscalProductGroupType",
            vatVendusDetails: "FiscalProductGroupVatVendusDetails?",
            vat: "float?"
        },
        FiscalProfileDraft: {
            id: "string",
            name: "string",
            hasPendingDraft: "bool?",
            validatedAt: "datetime?",
            org: "FiscalProfileOrg?",
            contact: "FiscalProfileContact",
            address: "FiscalProfileAddress?",
            nfce: "FiscalProfileNfce?",
            sat: "FiscalProfileSat?",
            ivaVendus: "FiscalProfileIvaVendus?",
            ivaFactura: "FiscalProfileIvaFactura?",
            fiscalMode: "FiscalMode?",
            tipFiscalData: "TipFiscalData?",
            enableFocusManifestation: "bool?",
            enableNationalService: "bool?",
            parentId: "string?",
            createdAt: "datetime",
            createdBy: "FiscalDraftActor",
            approvedAt: "datetime?",
            approvedBy: "FiscalDraftActor?",
            rejectedAt: "datetime?",
            rejectedBy: "FiscalDraftActor?"
        },
        FiscalProductGroupDraft: {
            id: "string",
            name: "string",
            hasPendingDraft: "bool?",
            validatedAt: "datetime?",
            cfop: "string?",
            cfopInterestadual: "string?",
            icms: "FiscalProductGroupIcms?",
            pis: "FiscalProductGroupPis?",
            cofins: "FiscalProductGroupCofins?",
            ivaDual: "FiscalProductGroupIvaDual?",
            service: "FiscalProductGroupService?",
            serviceNational: "FiscalProductGroupServiceNational?",
            type: "FiscalProductGroupType",
            vatVendusDetails: "FiscalProductGroupVatVendusDetails?",
            vat: "float?",
            parentId: "string?",
            createdAt: "datetime",
            createdBy: "FiscalDraftActor",
            approvedAt: "datetime?",
            approvedBy: "FiscalDraftActor?",
            rejectedAt: "datetime?",
            rejectedBy: "FiscalDraftActor?"
        },
        FiscalProfileWithPendingDraft: {
            principal: "FiscalProfile",
            pendingDraft: "FiscalProfileDraft?"
        },
        FiscalProductGroupWithPendingDraft: {
            principal: "FiscalProductGroup",
            pendingDraft: "FiscalProductGroupDraft?"
        },
        InvoiceV2: {
            id: "string",
            mode: "InvoiceV2Mode",
            issuedAt: "datetime",
            isCanceled: "bool",
            pdfUrl: "string?",
            imgUrl: "string?",
            type: "string?",
            num: "string?",
            serie: "string?",
            rawSource: "string?",
            canceledRawSource: "string?",
            fiscalProfile: "string",
            value: "uint?",
            eventDate: "datetime",
            creditInvoices: "InvoiceV2[]?",
            createdBy: "string",
            transactionId: "string?",
            rechargeId: "string?",
            transactionDate: "datetime?",
            rechargeDate: "datetime?"
        },
        InvoicesV2PaginationResponse: {
            data: "InvoiceV2[]",
            pagination: "PaginationResponse"
        },
        InvoicesV2Filter: {
            employeeIds: "string[]?",
            createdBySystem: "bool?",
            fiscalProfileIds: "string[]?",
            invoiceType: "InvoiceTypeEnum?",
            emissionItemType: "InvoicesV2FilterEmissionItemType?"
        },
        NationalFiscalInvoiceFilter: {
            since: "date",
            until: "date",
            invoiceNumber: "string?",
            fiscalProfile: "string?",
            isCanceled: "bool?"
        },
        NationalFiscalInvoiceResponse: {
            data: "NationalFiscalInvoiceData[]",
            pagination: "PaginationResponse"
        },
        NationalFiscalInvoiceData: {
            id: "string",
            mode: "NationalFiscalInvoiceDataMode",
            issuedAt: "datetime",
            canBeCanceled: "bool?",
            isCanceled: "bool",
            pdfUrl: "string?",
            imgUrl: "string?",
            num: "string?",
            serie: "string?",
            rawSource: "string?",
            canceledRawSource: "string?",
            fiscalProfile: "string",
            value: "uint?",
            eventDate: "datetime",
            createdBy: "string?",
            status: "InvoiceStatus"
        },
        NotEmmitedTransactionProducts: {
            id: "string",
            name: "string",
            unitValue: "uint",
            count: "uint",
            discountValue: "uint",
            transactionProductId: "string?"
        },
        NotEmmitedTransaction: {
            id: "string",
            products: "NotEmmitedTransactionProducts[]",
            date: "datetime"
        },
        ManualRequestPayments: {
            paymentMethod: "ManualRequestPaymentMethod",
            value: "uint"
        },
        ManualRequestProducts: {
            ncm: "string",
            cest: "string?",
            fiscalProductGroupId: "string",
            value: "uint",
            fiscalIcmsBaseCalculoRetSt: "uint?",
            fiscalIcmsAliquotaFinal: "float?",
            fiscalIcmsValorSubistituto: "uint?"
        },
        ManualRequestConsumptionObligationPayments: {
            userCpf: "string",
            value: "uint"
        },
        ManualRequest: {
            fiscalProfileId: "string",
            payments: "ManualRequestPayments[]",
            products: "ManualRequestProducts[]",
            consumptionObligationPayments: "ManualRequestConsumptionObligationPayments[]?",
            tipValue: "uint",
            recipientExtraInfo: "RecipientExtraInfo?"
        },
        NotEmittedProductOrCombo: {
            id: "string",
            name: "string",
            type: "NotEmittedProductOrComboType",
            count: "uint"
        },
        InvoicePrintData: {
            printData: "bytes[]?",
            epsonPrintData: "bytes[]?",
            printMarkup: "string"
        },
        MonthInvoices: {
            emitted: "uint",
            totalReceipt: "uint",
            countEmitted: "uint",
            countTotalReceipt: "uint"
        },
        FiscalSumupEmissible: {
            totalReceipt: "uint",
            totalConsumption: "uint",
            bonus: "uint",
            preConsumptionFromOtherEvents: "uint",
            openedBillsPayments: "uint",
            rechargeBalance: "uint",
            paidNotSyncTransactions: "uint",
            otherEventsConsumption: "uint",
            openedBills: "uint",
            rappiDiscounts: "uint",
            activationFee: "uint",
            refundedPostPaidTransactions: "uint",
            otherValues: "uint"
        },
        FiscalSumupFiscal: {
            emitted: "uint",
            laterMonthInvoices: "uint",
            notEmitted: "uint",
            previousMonthInvoices: "uint"
        },
        FiscalSumup: {
            emissible: "FiscalSumupEmissible",
            fiscal: "FiscalSumupFiscal"
        },
        LogInvoiceErrorResponseBuyers: {
            id: "string?",
            name: "string?",
            cpf: "string"
        },
        LogInvoiceErrorResponseProducts: {
            id: "string?",
            name: "string?"
        },
        LogInvoiceErrorResponse: {
            id: "string",
            invoiceId: "string",
            error: "string",
            errorMessage: "string",
            errorType: "string",
            errorCorrection: "string?",
            date: "datetime",
            buyers: "LogInvoiceErrorResponseBuyers[]",
            products: "LogInvoiceErrorResponseProducts[]",
            count: "uint",
            status: "LogInvoiceErrorResponseStatus",
            mode: "InvoiceMode",
            eventId: "string",
            placeId: "string",
            fiscalProfileName: "string?",
            updatedAt: "datetime"
        },
        NotIssuedWithErrorResponse: {
            data: "LogInvoiceErrorResponse[]",
            currentPage: "int",
            perPage: "int",
            total: "int",
            lastPage: "int"
        },
        InvoiceIssuedByPerfilFiscal: {
            name: "string",
            count: "uint",
            value: "uint"
        },
        InvoiceByMode: {
            emitted: "uint",
            notEmitted: "uint",
            totalReceipt: "uint"
        },
        InvoiceIssuedByModeInvoices: {
            date: "date",
            mode: "string",
            emitted: "uint"
        },
        InvoiceIssuedByMode: {
            invoices: "InvoiceIssuedByModeInvoices[]",
            nfce: "uint",
            nfse: "uint"
        },
        ReportFiscal: {
            eventId: "string",
            eventName: "string",
            date: "datetime",
            lastInvoiceIssued: "datetime?",
            totalReceipt: "uint",
            emitted: "uint",
            notEmitted: "uint",
            emittedNfce: "uint",
            emittedNfse: "uint"
        },
        UnusedInvoice: {
            id: "string",
            date: "datetime",
            xml: "string",
            serie: "string",
            number: "string"
        },
        PendingInvoices: {
            id: "string",
            date: "datetime",
            eventDate: "datetime",
            fiscalProfileId: "string?",
            employee: "string",
            invoiceType: "string",
            value: "uint",
            fiscalMode: "string",
            error: "string?",
            rechargeId: "string?",
            transactionId: "string?",
            expirationDate: "datetime?"
        },
        PendingInvoicesFilter: {
            employeeIds: "string[]?",
            createdBySystem: "bool?",
            fiscalProfileIds: "string[]?",
            invoiceType: "PendingInvoicesFilterInvoiceType?",
            invoiceEmissionType: "PendingInvoicesFilterInvoiceEmissionType?"
        },
        PendingInvoicesPaginatedResponse: {
            data: "PendingInvoices[]",
            pagination: "PaginationResponse"
        },
        TransactionProductWithInvoiceEvent: {
            id: "string",
            name: "string",
            date: "datetime"
        },
        TransactionProductWithInvoiceInvoice: {
            id: "string",
            number: "string",
            serie: "string",
            date: "datetime",
            issuerDocument: "string",
            recipientDocument: "string?",
            value: "string",
            netValue: "string?"
        },
        TransactionProductWithInvoice: {
            transactionProductId: "string",
            transactionId: "string",
            isCombo: "bool",
            value: "uint",
            totalNetValue: "uint?",
            count: "uint",
            discountValue: "uint",
            date: "datetime",
            productName: "string",
            tipValue: "uint",
            event: "TransactionProductWithInvoiceEvent",
            invoice: "TransactionProductWithInvoiceInvoice?"
        },
        RechargeWithInvoiceEvent: {
            id: "string",
            name: "string",
            date: "datetime"
        },
        RechargeWithInvoiceInvoice: {
            id: "string",
            number: "string",
            serie: "string",
            date: "datetime",
            issuerDocument: "string",
            recipientDocument: "string?",
            value: "string",
            netValue: "string"
        },
        RechargeWithInvoice: {
            id: "string",
            totalValue: "uint",
            usedValue: "uint",
            date: "datetime",
            event: "RechargeWithInvoiceEvent",
            invoice: "RechargeWithInvoiceInvoice?"
        },
        RechargeWithInvoicePaginatedResponse: {
            data: "RechargeWithInvoice[]",
            pagination: "PaginationResponse"
        },
        RechargeWithInvoiceFilter: {
            isIssued: "bool?"
        },
        BarEmittedValue: {
            id: "string",
            name: "string",
            grossValue: "uint",
            netValue: "uint"
        },
        FiscalProfileEmittedValue: {
            id: "string",
            name: "string",
            value: "uint",
            netValue: "uint?"
        },
        EmittedValueByPaymentType: {
            netValue: "uint",
            grossValue: "uint",
            paymentMethod: "EmittedValueByPaymentTypeEnum"
        },
        EmployeeEmittedValueEmployee: {
            id: "string",
            name: "string"
        },
        EmployeeEmittedValue: {
            employee: "EmployeeEmittedValueEmployee",
            grossValue: "uint",
            netValue: "uint"
        },
        GenericValueForReport: {
            title: "string",
            description: "string?",
            motherReportPath: "string?",
            value: "int",
            emittedNetValue: "int?",
            unit: "GenericValueForReportUnit",
            highlighted: "bool",
            hideIfZero: "bool"
        },
        SearchInvoice: {
            id: "string",
            emitted: "date",
            rawSource: "string",
            canceledRawSource: "string?",
            pdfUrl: "string?",
            isCanceled: "bool",
            everestUploadTime: "datetime?",
            type: "string?"
        },
        NotEmittedProduct: {
            id: "string",
            type: "NotEmittedProductType",
            name: "string",
            count: "uint",
            lastNotEmittedSellDate: "datetime",
            firstNotEmittedSellDate: "datetime"
        },
        LastEmissionAttempt: {
            id: "string",
            invoiceId: "string",
            errorMessage: "string",
            error: "string",
            errorType: "string",
            date: "datetime",
            updatedAt: "datetime",
            eventId: "string",
            userId: "string",
            userName: "string",
            transactionId: "string"
        },
        NotEmittedProductByError: {
            productId: "string",
            productName: "string",
            count: "uint"
        },
        LastEmissionDetails: {
            attempts: "LastEmissionAttempt[]",
            products: "NotEmittedProductByError[]"
        },
        InvoiceFiscalProductGroupIcms: {
            origem: "string?",
            csosn: "string?",
            cst: "string?",
            aliquota: "float?",
            baseCalculo: "string?",
            reducaoBaseCalculo: "string?",
            benefCode: "string?"
        },
        InvoiceFiscalProductGroupPis: {
            cst: "string?",
            baseCalculo: "string?",
            aliquotaPerc: "float?",
            quantidadeVendida: "string?",
            aliquotaReais: "float?"
        },
        InvoiceFiscalProductGroupCofins: {
            cst: "string?",
            baseCalculo: "string?",
            aliquotaPerc: "float?",
            quantidadeVendida: "string?",
            aliquotaReais: "float?"
        },
        InvoiceFiscalProductGroupService: {
            aliquota: "float",
            tipoServico: "string?",
            codigoTributacaoMunicipio: "string?",
            codigoNbs: "string?",
            codigoIndicadorOperacao: "string?"
        },
        InvoiceFiscalProductGroupServiceNational: {
            codigoTributacaoNacionalIss: "string",
            codigoTributacaoMunicipalIss: "string?",
            codigoNbs: "string?",
            aliquota: "float?",
            percentualTotalTributosSN: "float?",
            percentualTotalTributosFederais: "float?",
            percentualTotalTributosEstaduais: "float?",
            percentualTotalTributosMunicipais: "float?"
        },
        InvoiceFiscalProductGroup: {
            value: "int",
            netValue: "int?",
            name: "string",
            cfop: "string?",
            icms: "InvoiceFiscalProductGroupIcms?",
            pis: "InvoiceFiscalProductGroupPis?",
            cofins: "InvoiceFiscalProductGroupCofins?",
            service: "InvoiceFiscalProductGroupService?",
            serviceNational: "InvoiceFiscalProductGroupServiceNational?",
            type: "InvoiceFiscalProductGroupType"
        },
        NCM: {
            code: "string"
        },
        CEST: {
            code: "string",
            name: "string",
            description: "string",
            productNcmId: "string"
        },
        ListCEST: {
            listCEST: "CEST[]"
        },
        ResumeImportCest: {
            imported: "uint",
            errors: "uint"
        },
        ImportCESTNCMConfig: {
            startLine: "uint",
            cestCodeColumn: "string",
            ncmCodeColumn: "string",
            cestNameColumn: "string",
            cestDescColumn: "string"
        },
        NifData: {
            nif: "string",
            name: "string?",
            address: "string?",
            postalcode: "string?",
            city: "string?",
            country: "string?"
        },
        ConsumptionObligationConfig: {
            fiscalProductGroupId: "string?",
            fiscalProfileId: "string?",
            fiscalNcm: "string?"
        },
        PlaceConsumptionObligationConfig: {
            placeId: "string",
            placeName: "string",
            fiscalProductGroupId: "string?",
            fiscalProfileId: "string?",
            fiscalNcm: "string?"
        },
        RechargeFiscalConfigPayload: {
            fiscalProductGroupId: "string?",
            fiscalProfileId: "string?",
            fiscalNcm: "string?"
        },
        PlaceRechargeFiscalConfig: {
            placeId: "string",
            placeName: "string",
            fiscalType: "string?",
            fiscalProductGroupId: "string?",
            fiscalProfileId: "string?",
            fiscalNcm: "string?"
        },
        EmployeeWithIssuedInvoices: {
            id: "string",
            name: "string"
        },
        SelectableInvoiceUserInformation: {
            document: "string",
            type: "InvoiceUserInformationType"
        },
        SelectableInvoiceRequestSelectedProducts: {
            id: "string",
            value: "uint",
            discountValue: "uint",
            quantity: "uint",
            transactionId: "string",
            transactionProductId: "string"
        },
        SelectableInvoiceRequest: {
            obligations: "ObligationPaymentsForInvoice[]",
            userInformation: "SelectableInvoiceUserInformation?",
            userId: "string",
            withTipValue: "bool?",
            selectedProducts: "SelectableInvoiceRequestSelectedProducts[]",
            tipValue: "uint?",
            recipientExtraInfo: "RecipientExtraInfo?"
        },
        InsightText: {
            type: "string",
            text: "string"
        },
        InsightCategory: {
            id: "string",
            name: "string"
        },
        Insight: {
            id: "string",
            placeId: "string",
            category: "InsightCategory",
            expirationDate: "datetime",
            updatedAt: "datetime",
            texts: "InsightText[]",
            reaction: "InsightReaction?",
            priority: "int?"
        },
        NewInventory: {
            date: "datetime",
            isTotal: "bool",
            createdBy: "string"
        },
        InventoryStorages: {
            id: "string",
            name: "string"
        },
        Inventory: {
            id: "string",
            status: "InventoryStatus",
            storages: "InventoryStorages[]",
            date: "datetime",
            isTotal: "bool",
            createdBy: "string"
        },
        NewInventoryProduct: {
            productId: "string",
            storageId: "string",
            inventoryCount: "uint?",
            inventoryUnitValue: "uint?",
            realCount: "int?",
            realUnitValue: "uint?"
        },
        InventoryProduct: {
            productId: "string",
            storageId: "string",
            inventoryCount: "uint?",
            inventoryUnitValue: "uint?",
            realCount: "int?",
            realUnitValue: "uint?",
            productName: "string",
            productCategory: "string",
            productCategoryId: "string"
        },
        TopSelling: {
            name: "string",
            count: "int"
        },
        TopSellingClient: {
            name: "string",
            count: "int",
            id: "string"
        },
        TopSellingCashier: {
            id: "string",
            name: "string",
            rechargeMoneyReceived: "money",
            postPaidMoneyReceived: "money"
        },
        Public: {
            womenInside: "int",
            menInside: "int",
            otherInside: "int",
            menOutside: "int",
            womenOutside: "int",
            otherOutside: "int",
            ticketZero: "int"
        },
        TopSellingProducts: {
            top5SellingProductsByQuantity: "TopSelling[]",
            top5SellingProductsByPrice: "TopSelling[]"
        },
        TotalReceipt: {
            bar: "Receipt",
            entrances: "Receipt",
            rechargeConsumptions: "money",
            entranceConsumptions: "money",
            barConsumptions: "money",
            averageTicket: "money",
            totalRefundedPostPayments: "money?"
        },
        Receipt: {
            cash: "money",
            credit: "money",
            debit: "money",
            postEvent: "money",
            voucher: "money",
            app: "money",
            pix: "money",
            opened: "money",
            dashboard: "money",
            anticipated: "money",
            rappi: "money",
            uber: "money",
            ifood: "money",
            ame: "money",
            deliveryOnline: "money",
            integratedFoodVoucher: "money",
            mbway: "money",
            online: "money"
        },
        ConsumptionTimeline: {
            start: "datetime",
            intervalInMinutes: "uint",
            value: "money"
        },
        OpenTableTimeline: {
            start: "datetime",
            intervalInMinutes: "uint",
            openTables: "uint"
        },
        ClientsInTagTimeline: {
            start: "datetime",
            intervalInMinutes: "uint",
            clientsInTag: "uint"
        },
        ConsumptionResume: {
            minimumConsumption: "money",
            bonus: "money",
            normal: "money",
            openedBils: "money",
            creditFromPreviousEvents: "money",
            paidInFutureEvents: "money",
            app: "money",
            productsSold: "money"
        },
        SelledProduct: {
            name: "string",
            count: "uint",
            totalValue: "money"
        },
        DeliveryReceiptItem: {
            source: "DeliverySource",
            value: "money"
        },
        DeliveryReceipt: {
            total: "money",
            items: "DeliveryReceiptItem[]"
        },
        VendorResume: {
            id: "string",
            name: "string",
            totalSold: "money"
        },
        AdminResponsePermissions: {
            id: "string",
            name: "string"
        },
        AdminResponse: {
            id: "uuid",
            email: "string",
            name: "string",
            permissions: "AdminResponsePermissions[]",
            role: "string?"
        },
        RegisterEmployeeEmailInput: {
            username: "string",
            password: "string",
            organizationUsername: "string",
            email: "string"
        },
        BaseLoyaltyProgramPlaces: {
            id: "string",
            name: "string"
        },
        BaseLoyaltyProgramPointRulesPlaceAttendPointRules: {
            placeId: "string",
            placeName: "string",
            points: "uint"
        },
        BaseLoyaltyProgramPointRulesSpentValuePointRule: {
            spentValue: "uint",
            points: "uint"
        },
        BaseLoyaltyProgramPointRulesProductPointRules: {
            productId: "string?",
            productName: "string?",
            categoryId: "string?",
            categoryName: "string?",
            points: "uint"
        },
        BaseLoyaltyProgramPointRulesNpsPointRule: {
            points: "uint"
        },
        BaseLoyaltyProgramPointRulesAppPaymentPointRule: {
            points: "uint"
        },
        BaseLoyaltyProgramPointRulesGenderPointRules: {
            gender: "Gender",
            points: "uint"
        },
        BaseLoyaltyProgramPointRules: {
            placeAttendPointRules: "BaseLoyaltyProgramPointRulesPlaceAttendPointRules[]",
            spentValuePointRule: "BaseLoyaltyProgramPointRulesSpentValuePointRule?",
            productPointRules: "BaseLoyaltyProgramPointRulesProductPointRules[]",
            npsPointRule: "BaseLoyaltyProgramPointRulesNpsPointRule?",
            appPaymentPointRule: "BaseLoyaltyProgramPointRulesAppPaymentPointRule?",
            genderPointRules: "BaseLoyaltyProgramPointRulesGenderPointRules[]?"
        },
        BaseLoyaltyProgramPrizeRulesProductPrizeRules: {
            productId: "string?",
            productName: "string?",
            categoryId: "string?",
            categoryName: "string?",
            pointsRequired: "uint",
            discount: "float"
        },
        BaseLoyaltyProgramPrizeRulesBonusPrizeRules: {
            pointsRequired: "uint",
            bonus: "uint"
        },
        BaseLoyaltyProgramPrizeRules: {
            productPrizeRules: "BaseLoyaltyProgramPrizeRulesProductPrizeRules[]",
            bonusPrizeRules: "BaseLoyaltyProgramPrizeRulesBonusPrizeRules[]"
        },
        BaseLoyaltyProgram: {
            name: "string",
            description: "string",
            pointsExpiresInDays: "uint?",
            sendMessagesAboutProgramAfterCheckout: "BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout[]",
            smsSentAt: "date?",
            isActive: "bool",
            places: "BaseLoyaltyProgramPlaces[]",
            pointRules: "BaseLoyaltyProgramPointRules",
            prizeRules: "BaseLoyaltyProgramPrizeRules"
        },
        LoyaltyProgram: {
            name: "string",
            description: "string",
            pointsExpiresInDays: "uint?",
            sendMessagesAboutProgramAfterCheckout: "BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout[]",
            smsSentAt: "date?",
            isActive: "bool",
            places: "BaseLoyaltyProgramPlaces[]",
            pointRules: "BaseLoyaltyProgramPointRules",
            prizeRules: "BaseLoyaltyProgramPrizeRules",
            id: "string"
        },
        LoyaltySummarizedReport: {
            totalActive: "uint",
            totalGeneratedPoints: "uint",
            totalUsedPoints: "uint",
            totalRedeemedVouchers: "uint"
        },
        LoyaltyProgramReport: {
            id: "string",
            name: "string",
            totalGeneratedPoints: "uint",
            totalUsedPoints: "uint",
            totalRedeemedVouchers: "uint",
            isActive: "bool"
        },
        LoyaltyCompleteReport: {
            summarizedReport: "LoyaltySummarizedReport",
            loyaltyProgramsReport: "LoyaltyProgramReport[]"
        },
        LoyaltyProgramExtract: {
            id: "uuid",
            date: "date",
            placeName: "string?",
            type: "LoyaltyProgramExtractType",
            productName: "string?",
            points: "int",
            usedPoints: "int?",
            expiresAt: "datetime?",
            isExpired: "bool"
        },
        ProgramParticipantReport: {
            name: "string",
            pointsToExpire: "uint",
            expiredPoints: "uint",
            totalPaidAmount: "uint?",
            totalEarnedPoints: "uint",
            totalUsedPoints: "uint",
            remainingTotalPoints: "uint",
            frequencyAfterJoiningAProgram: "uint",
            lastCheckIn: "datetime?",
            pointsToExpireDate: "datetime?",
            expiredPointsDate: "datetime?",
            lastPointsAcquiredDate: "datetime?",
            lastRedeemedCouponDate: "datetime?"
        },
        LoyaltyProgramFilters: {
            placeId: "string?",
            programName: "string?",
            since: "date?",
            until: "date?"
        },
        PaginationAndFilters: {
            pagination: "Pagination",
            filters: "LoyaltyProgramFilters?"
        },
        SmsCostInfo: {
            smsCost: "uint",
            usersReached: "uint"
        },
        ProgramParticipantReportResponse: {
            data: "ProgramParticipantReport[]",
            pagination: "PaginationResponse"
        },
        BaseCoupon: {
            placeIds: "string[]",
            expiresAt: "datetime?",
            discount: "float?",
            bonus: "uint?",
            categoryId: "string?",
            productId: "string?"
        },
        Coupon: {
            placeIds: "string[]",
            expiresAt: "datetime?",
            discount: "float?",
            bonus: "uint?",
            categoryId: "string?",
            productId: "string?",
            code: "string",
            campaignId: "string",
            isUsed: "bool"
        },
        GiftCardCampaign: {
            id: "string",
            name: "string",
            coupons: "Coupon[]",
            createdAt: "datetime",
            expiresAt: "datetime",
            status: "GiftCardCampaignStatus",
            createdBy: "string",
            isCanceled: "bool",
            organizationId: "string"
        },
        NpsFormPlace: {
            id: "string",
            name: "string"
        },
        NpsForm: {
            id: "string",
            place: "NpsFormPlace",
            isActive: "bool",
            enabledQuestions: "QuestionType[]",
            dailySmsLimit: "uint?"
        },
        SimpleNpsForm: {
            placeId: "string",
            isActive: "bool",
            enabledQuestions: "QuestionType[]",
            shouldSendSmsOnCheckout: "bool",
            dailySmsLimit: "uint?"
        },
        NpsPlace: {
            questionId: "QuestionType",
            score: "string"
        },
        QuestionsScore: {
            npsScore: "string",
            questionsScore: "NpsPlace[]"
        },
        NpsResultCustomer: {
            name: "string",
            userId: "string",
            document: "string",
            phone: "string?",
            birthDate: "date?"
        },
        NpsResult: {
            customer: "NpsResultCustomer",
            npsFormId: "string",
            date: "date",
            answers: "NpsAnswer[]",
            eventId: "string",
            averageTicket: "uint",
            origin: "Origin?"
        },
        NpsPlaceInfoPlace: {
            id: "string",
            name: "string"
        },
        NpsPlaceInfoConfig: {
            questionId: "QuestionType",
            name: "string",
            description: "string?",
            isActive: "bool"
        },
        NpsPlaceInfo: {
            place: "NpsPlaceInfoPlace",
            config: "NpsPlaceInfoConfig[]",
            shouldSendSmsOnCheckout: "bool",
            dailySmsLimit: "uint?"
        },
        PageArgs: {
            page: "uint",
            limitPerPage: "uint"
        },
        CustomerResult: {
            totalItems: "uint",
            data: "NpsResult[]"
        },
        NpsSmsSents: {
            checkins: "uint",
            smsSents: "uint",
            npsFormAnswers: "uint"
        },
        NpsSmsSentDates: {
            date: "date",
            smsSentCount: "uint",
            npsAnswersCount: "uint",
            conversion: "float"
        },
        NpsSmsSent: {
            totalSmsSentCount: "uint",
            totalNpsAnswerCount: "uint",
            totalConversion: "float",
            dates: "NpsSmsSentDates[]?"
        },
        NpsCustomerInfo: {
            userId: "string",
            name: "string",
            cpf: "string",
            phone: "string",
            birthDate: "date?"
        },
        AnswerDetailsEvent: {
            id: "string",
            name: "string"
        },
        AnswerDetailsAnswers: {
            questionId: "QuestionType",
            value: "uint",
            comment: "string?",
            options: "string[]?"
        },
        AnswerDetailsMostConsumedProducts: {
            name: "string",
            productId: "string",
            eventId: "string",
            date: "date"
        },
        AnswerDetails: {
            event: "AnswerDetailsEvent",
            customer: "NpsCustomerInfo?",
            answers: "AnswerDetailsAnswers[]",
            mostConsumedProducts: "AnswerDetailsMostConsumedProducts[]",
            npsFormId: "string",
            date: "date"
        },
        NpsQuestionDetailsAnswers: {
            answer: "uint",
            count: "uint"
        },
        NpsQuestionDetailsOptions: {
            questionId: "QuestionType",
            option: "string",
            count: "uint"
        },
        NpsQuestionDetails: {
            questionId: "string",
            totalAnswers: "uint",
            answers: "NpsQuestionDetailsAnswers[]",
            options: "NpsQuestionDetailsOptions[]"
        },
        OpenSaleData: {
            value: "uint",
            method: "OpenSaleMethod"
        },
        OpenSaleEmployeeEmployee: {
            id: "string",
            name: "string",
            username: "string?"
        },
        OpenSaleEmployee: {
            employee: "OpenSaleEmployeeEmployee"
        },
        OpenSaleReport: {
            employee: "OpenSaleEmployeeEmployee",
            sales: "OpenSaleData[]"
        },
        OpenSaleRefundedBy: {
            name: "string",
            username: "string"
        },
        OpenSale: {
            id: "string",
            date: "datetime",
            isRefunded: "bool",
            refundedBy: "OpenSaleRefundedBy?",
            refundedAt: "datetime?",
            employee: "OpenSaleEmployeeEmployee",
            value: "uint",
            method: "OpenSaleMethod"
        },
        Organization: {
            id: "string",
            name: "string",
            description: "string?",
            username: "string",
            icon: "ImageUrl?",
            reportMails: "string[]",
            currency: "string?",
            currencySymbol: "string?",
            isTest: "bool?",
            features: "string[]"
        },
        OrganizationFeatures: {
            id: "string",
            name: "string",
            description: "string",
            isEditableByOrganization: "bool"
        },
        OrganizationWithFeatures: {
            id: "string",
            name: "string",
            description: "string?",
            username: "string",
            icon: "ImageUrl?",
            reportMails: "string[]",
            currency: "string?",
            currencySymbol: "string?",
            countryISO3: "string?",
            isKeyAccount: "bool",
            isTest: "bool",
            features: "OrganizationFeatures[]"
        },
        PaymentLink: {
            id: "string",
            url: "string",
            status: "PaymentLinkStatus",
            amount: "uint",
            installments: "uint",
            paymentOrigin: "PaymentOrigin",
            description: "string?",
            createdAt: "datetime",
            paidAt: "datetime?"
        },
        CreatePaymentLinkResult: {
            id: "string",
            url: "string",
            status: "PaymentLinkStatus"
        },
        PaymentLinkPage: {
            rows: "PaymentLink[]",
            total: "uint"
        },
        PaymentLinkFilter: {
            search: "string?",
            statuses: "PaymentLinkStatus[]?",
            startDate: "datetime?",
            endDate: "datetime?",
            dateField: "PaymentLinkDateField?"
        },
        BankAccountContractDetails: {
            holder: "string?",
            name: "string?",
            pixKey: "string?",
            pixKeyType: "string?",
            accountType: "string?",
            account: "string?",
            digit: "string?",
            agency: "string?",
            bank: "string?",
            documentNumber: "string?",
            documentType: "string?",
            bankAccountType: "string?"
        },
        BankAccount: {
            bank: "string",
            accountName: "string",
            cnpj: "string",
            type: "string",
            agency: "string",
            account: "string"
        },
        Couvert: {
            value: "uint",
            name: "string",
            category: "string"
        },
        Place: {
            id: "string",
            name: "string",
            isApproved: "bool",
            image: "ImageUrl?",
            postPaidLimit: "int?",
            maleCouvert: "Couvert?",
            femaleCouvert: "Couvert?",
            mesasCouvert: "Couvert?",
            bars: "Bar[]",
            tip: "float",
            zigTagProduct: "PlaceProduct?",
            sellVisualizationFormat: "PlaceSellVisualizationFormat",
            fiscalPrinters: "FiscalPrinter[]",
            localServerIp: "string?",
            rechargeNotIntegratedLimit: "uint?",
            reportMails: "string[]?",
            currency: "string?",
            currencySymbol: "string?",
            isBlocked: "bool?",
            status: "PlaceStatus",
            withdrawRequestConfirmationContactEmail: "string?",
            documentType: "UserDocumentType?",
            countryISO3: "string?",
            peopleCapacity: "uint?",
            defaultReportSinceDate: "date?",
            defaultReportUntilDate: "date?",
            isExpired: "bool?"
        },
        NewPlace: {
            id: "string?",
            name: "string",
            postPaidLimit: "int?",
            maleCouvert: "Couvert?",
            femaleCouvert: "Couvert?",
            mesasCouvert: "Couvert?",
            bars: "Bar[]",
            tip: "float",
            zigTagProductId: "string?",
            sellVisualizationFormat: "NewPlaceSellVisualizationFormat",
            localServerIp: "string?",
            rechargeNotIntegratedLimit: "uint?",
            reportMails: "string[]?"
        },
        PlaceData: {
            place: "Place",
            products: "PlaceProduct[]",
            combos: "PlaceCombo[]"
        },
        PlaceContractDetailsGeneral: {
            contractNumber: "int?",
            managerZig: "string?",
            managers: "string[]",
            profile: "string?",
            status: "string",
            majorVersion: "string",
            minVersion: "string?",
            locationName: "string",
            size: "PlaceSize?",
            monthlyZigFeeFloor: "uint?",
            monthlyZigFeeCap: "uint?",
            contactPhones: "string[]?",
            isOnline: "bool",
            isHouse: "bool",
            zigFeeShouldBeChargedInDebit: "bool",
            hasCustomizedCard: "bool",
            rechargeNotIntegratedLimit: "uint?",
            nonIntegratedPaymentLimit: "uint?",
            parentPlaceName: "string?",
            type: "PlaceType?",
            ppuAuthorizationValue: "uint"
        },
        PlaceContractDetailsRecharges: {
            rechargesAction: "PlaceContractDetailsRechargesRechargesAction?",
            rechargeExpiresIn: "string?"
        },
        PlaceContractDetailsCommunicationSms: {
            cost: "uint"
        },
        PlaceContractDetailsCommunicationWhatsapp: {
            phoneNumber: "string?",
            serviceId: "string?",
            cost: "uint?"
        },
        PlaceContractDetailsCommunication: {
            sms: "PlaceContractDetailsCommunicationSms",
            whatsapp: "PlaceContractDetailsCommunicationWhatsapp"
        },
        PlaceContractDetailsTaxes: {
            feeType: "FeeType?",
            barIncomeComission: "float",
            inHouseComission: "float",
            entranceIncomeComission: "float",
            rechargeRemainingsComission: "float",
            bonusComission: "float",
            fixedFee: "uint?",
            appComission: "float",
            onlinePaymentComission: "float?",
            fixedFeeDay: "uint?",
            anticipationFee: "float?",
            thirdPartyPaymentsFee: "uint?",
            bankslipServiceFee: "uint?",
            zigMachineDebitComission: "float",
            zigMachineCreditComission: "float",
            pixComission: "float?",
            integratedFoodVoucherComission: "float?",
            zigMachineCreditForNotDefaultBrandsComission: "float?",
            zigMachineDebitForNotDefaultBrandsComission: "float?",
            replicateTaxesAllBrands: "bool",
            clientIntegratedMachineComission: "float?",
            barMinimumConsumptionComission: "float",
            entranceMinimumConsumptionComission: "float",
            creditDays: "uint",
            debitDays: "uint",
            zigMachineCreditInInstallmentsComission: "float",
            maxInstallments: "uint?"
        },
        PlaceContractDetailsIfood: {
            days: "uint?",
            comission: "float?"
        },
        PlaceContractDetailsDelivery: {
            onlineComission: "float?",
            reservationComission: "float?"
        },
        PlaceContractDetailsPlaceCurrencyToken: {
            proportion: "float",
            name: "string",
            symbol: "string"
        },
        PlaceContractDetails: {
            general: "PlaceContractDetailsGeneral",
            recharges: "PlaceContractDetailsRecharges",
            communication: "PlaceContractDetailsCommunication",
            taxes: "PlaceContractDetailsTaxes?",
            ifood: "PlaceContractDetailsIfood",
            delivery: "PlaceContractDetailsDelivery",
            charges: "FinancialChargeConfig[]?",
            placeCurrencyToken: "PlaceContractDetailsPlaceCurrencyToken?",
            bankAccount: "BankAccountContractDetails?"
        },
        PlaceFeature: {
            id: "string",
            name: "string",
            isEditableByPlace: "bool",
            isActive: "bool",
            description: "string"
        },
        EverestConfig: {
            host: "string",
            user: "string",
            password: "string",
            cnpj: "string"
        },
        PlaceWithFeatures: {
            id: "string",
            name: "string",
            placeFeaturesActive: "string[]?"
        },
        SimplifiedPlace: {
            id: "string",
            name: "string",
            isApproved: "bool",
            postPaidLimit: "uint",
            hasOpenedEvent: "bool",
            lastEventBeginDate: "date?",
            timezone: "string?",
            timezoneGmt: "int?",
            currency: "string?",
            currencySymbol: "string?",
            thirdPartyPaymentsFee: "uint?",
            bankslipServiceFee: "uint?",
            lastEventDateWithTransaction: "date?",
            placeFeatures: "string[]?",
            size: "PlaceSize?",
            isHouse: "bool?",
            defaultReportSinceDate: "date?",
            defaultReportUntilDate: "date?",
            isExpired: "bool"
        },
        BaseBeerTap: {
            name: "string",
            ip: "string",
            num: "uint",
            productId: "string",
            isActive: "bool"
        },
        BeerTap: {
            id: "string",
            name: "string",
            ip: "string",
            num: "uint",
            productId: "string",
            isActive: "bool"
        },
        PlacesResume: {
            totalAmount: "float?",
            uniqueUsersCount: "uint",
            usersCount: "uint"
        },
        UsersWithAverageTicket: {
            name: "string",
            cpf: "string",
            phone: "string",
            gender: "UsersWithAverageTicketGender",
            userId: "string",
            averageTicket: "float",
            presences: "uint"
        },
        AverageTicketFilterTicketRange: {
            min: "uint",
            max: "uint"
        },
        AverageTicketFilter: {
            cpf: "string?",
            ticketRange: "AverageTicketFilterTicketRange?",
            gender: "AverageTicketFilterGender?"
        },
        FichaExtraConfig: {
            fichaLogo: "string?",
            fichaText: "string?"
        },
        ZigLocation: {
            id: "string",
            name: "string"
        },
        SimplifiedPlaceWhatsapp: {
            id: "string",
            name: "string",
            whatsappNumber: "string?"
        },
        PlaceConfigAddress: {
            postalCode: "string",
            state: "string?",
            city: "string",
            province: "string",
            address: "string",
            addressNumber: "string?",
            complement: "string?"
        },
        PlaceSettingsGeneralSectionRequest: {
            image: "bytes?",
            name: "string",
            reportMails: "email[]?",
            postPaidLimit: "uint?",
            tipPercentage: "float",
            tipOptions: "uint[]?",
            nonIntegratedRechargeLimit: "uint?",
            zigTagProductId: "string?",
            nonIntegratedPaymentLimit: "uint?",
            peopleCapacity: "uint?",
            invoiceMoment: "InvoiceMoment?",
            defaultReportSinceDate: "date?",
            defaultReportUntilDate: "date?",
            passTemplateId: "string?",
            address: "PlaceConfigAddress?",
            slug: "string?"
        },
        PlaceSettingsGeneralSectionResponseZigTagProduct: {
            id: "string",
            name: "string"
        },
        PlaceSettingsGeneralSectionResponse: {
            image: "ImageUrl?",
            name: "string",
            reportMails: "email[]?",
            postPaidLimit: "uint?",
            tipPercentage: "float",
            tipOptions: "uint[]?",
            nonIntegratedRechargeLimit: "uint?",
            zigTagProduct: "PlaceSettingsGeneralSectionResponseZigTagProduct?",
            nonIntegratedPaymentLimit: "uint?",
            peopleCapacity: "uint?",
            invoiceMoment: "InvoiceMoment?",
            defaultReportSinceDate: "date?",
            defaultReportUntilDate: "date?",
            passTemplateId: "string?",
            address: "PlaceConfigAddress?",
            slug: "string?"
        },
        ProductToZigTag: {
            id: "string",
            name: "string"
        },
        CouvertRequest: {
            name: "string",
            value: "uint",
            category: "string"
        },
        CouvertResponse: {
            name: "string",
            value: "uint",
            category: "string",
            id: "uuid",
            isActive: "bool"
        },
        PlaceSettingsCouvertSectionRequest: {
            male: "Couvert?",
            female: "Couvert?",
            mesas: "Couvert?"
        },
        PlaceSettingsCouvertSectionResponse: {
            male: "CouvertResponse?",
            female: "CouvertResponse?",
            mesas: "CouvertResponse?"
        },
        PlaceSettingsPlaceFeatureSectionRequest: {
            placeFeatures: "string[]"
        },
        PlaceSettingsPlaceFeatureSectionResponse: {
            placeFeatures: "PlaceFeature[]"
        },
        PlaceSettingsFichaSectionRequest: {
            logo: "bytes?",
            text: "string?",
            hasRemovedImage: "bool?",
            fontSize: "FichaFontSize?",
            imageSize: "FichaImageSize?",
            qrCodeSize: "FichaQRCodeSize?"
        },
        PlaceSettingsFichaSectionResponse: {
            logo: "ImageUrl?",
            text: "string?",
            fontSize: "FichaFontSize?",
            imageSize: "FichaImageSize?",
            qrCodeSize: "FichaQRCodeSize?"
        },
        TotemPlaceConfigImage: {
            url: "string",
            sha256: "string"
        },
        PlaceSettingsPdvSectionRequest: {
            generalPassword: "string?",
            sellVisualizationFormat: "SellVisualizationFormat",
            devicesToAdd: "string[]?",
            totemConfigs: "TotemConfigsRequest",
            kdsServerIp: "string?"
        },
        PlaceSettingsPdvSectionResponse: {
            sellVisualizationFormat: "SellVisualizationFormat",
            devicesCount: "uint",
            totemConfigs: "TotemPlaceConfigResponse",
            kdsServerIp: "string?"
        },
        PlaceSettingsPdvSectionReturnError: {
            deviceIds: "string[]",
            message: "string"
        },
        PlaceSettingsPdvSectionReturn: {
            success: "string[]",
            error: "PlaceSettingsPdvSectionReturnError"
        },
        MainImageRequest: {
            bytes: "bytes?",
            shouldUpdate: "bool"
        },
        TotemPlaceConfigResponse: {
            mainImage: "TotemPlaceConfigImage?",
            primaryColor: "string?",
            secondaryColor: "string?",
            typeLogo: "string?"
        },
        TotemConfigsRequest: {
            mainImage: "MainImageRequest",
            primaryColor: "string?",
            secondaryColor: "string?",
            typeLogo: "string?"
        },
        FiscalPrintersResultError: {
            fiscalPrinter: "FiscalPrinter",
            reason: "string"
        },
        FiscalPrintersResult: {
            success: "FiscalPrinter[]",
            error: "FiscalPrintersResultError[]"
        },
        PlaceDetailAddress: {
            city: "string",
            complement: "string?",
            country: "string",
            formattedAddress: "string",
            neighborhood: "string?",
            postalCode: "string?",
            state: "string",
            streetName: "string?",
            streetNumber: "string?"
        },
        WorkingPeriod: {
            dayOfWeek: "DayOfWeek",
            startTime: "string",
            endTime: "string"
        },
        EventDay: {
            date: "datetime",
            startTime: "string"
        },
        DashPlaceBaseDetail: {
            id: "string",
            address: "PlaceDetailAddress?",
            instagram: "string?",
            facebook: "string?",
            twitter: "string?",
            description: "string?",
            ticketLink: "string?",
            phone: "string?",
            email: "string?",
            obs: "string?",
            linkHighlightType: "LinkHighlightType?",
            site: "string?",
            locationCategory: "NewLocationCategory?"
        },
        PlaceBaseDetail: {
            id: "string",
            address: "PlaceDetailAddress?",
            instagram: "string?",
            facebook: "string?",
            twitter: "string?",
            description: "string?",
            ticketLink: "string?",
            phone: "string?",
            email: "string?",
            obs: "string?",
            linkHighlightType: "LinkHighlightType?",
            site: "string?",
            locationCategory: "LocationCategory?"
        },
        BaseTag: {
            id: "string",
            tag: "string"
        },
        BaseMusicTag: {
            id: "string",
            musicTag: "string"
        },
        PlaceDetailZigLocation: {
            id: "uuid",
            name: "string"
        },
        PlaceDetail: {
            appearsInApp: "bool",
            zigLocation: "PlaceDetailZigLocation",
            placeName: "string",
            images: "PlaceDetailImage[]",
            localType: "LocalType",
            isPlaceActive: "bool",
            id: "string",
            address: "PlaceDetailAddress?",
            instagram: "string?",
            facebook: "string?",
            twitter: "string?",
            description: "string?",
            ticketLink: "string?",
            phone: "string?",
            email: "string?",
            obs: "string?",
            linkHighlightType: "LinkHighlightType?",
            site: "string?",
            locationCategory: "NewLocationCategory?"
        },
        EditPlaceDetail: {
            images: "ImageUrl[]",
            name: "string",
            id: "string",
            address: "PlaceDetailAddress?",
            instagram: "string?",
            facebook: "string?",
            twitter: "string?",
            description: "string?",
            ticketLink: "string?",
            phone: "string?",
            email: "string?",
            obs: "string?",
            linkHighlightType: "LinkHighlightType?",
            site: "string?",
            locationCategory: "NewLocationCategory?"
        },
        PlaceDetailImage: {
            url: "string",
            sha256: "string",
            height: "float",
            width: "float"
        },
        PlaceDetailTag: {
            id: "string",
            tag: "string",
            isChecked: "bool"
        },
        WorkingDays: {
            workingPeriods: "WorkingPeriod[]",
            eventDays: "EventDay[]"
        },
        PlaceDetailMusicTag: {
            id: "string",
            musicTag: "string",
            isChecked: "bool"
        },
        PosTransaction: {
            brand: "string?",
            value: "uint",
            lastDigits: "string?",
            date: "datetime",
            acquirerUid: "string",
            method: "PosTransactionMethodMethod"
        },
        PaginationPosTransaction: {
            currentPage: "uint",
            itemsPerPage: "uint",
            totalItems: "uint",
            data: "PosTransaction[]"
        },
        PosMachineDayResume: {
            soldValue: "uint",
            date: "date",
            method: "PosTransactionMethodMethod",
            brand: "string?"
        },
        PosTransactionMethod: {
            method: "PosTransactionMethodMethod"
        },
        PrechargeAccumulatedValueByGender: {
            accumulatedValue: "money",
            peopleTotalizer: "uint",
            gender: "Gender"
        },
        PrechargeAccumulatedValueByPaymentMethod: {
            accumulatedValue: "money",
            rescuedValue: "money",
            paymentMethod: "PrechargeOperationPaymentMethod"
        },
        PrechargeOperationCards: {
            peopleTotalizer: "uint",
            averageTicket: "money",
            accumulatedValue: "money",
            redeemedValue: "money",
            bonusValue: "money",
            valueByGender: "PrechargeAccumulatedValueByGender[]",
            valueByPaymentMethod: "PrechargeAccumulatedValueByPaymentMethod[]"
        },
        PrechargeOperationGraph: {
            createdAt: "date",
            totalValue: "money",
            bonusValue: "money"
        },
        PrechargeOperationReport: {
            cards: "PrechargeOperationCards",
            graph: "PrechargeOperationGraph[]"
        },
        PrechargeResponse: {
            data: "Precharge[]",
            pagination: "PaginationResponse"
        },
        CreatePrinter: {
            ip: "string",
            type: "KitchenPrinterTypes",
            barId: "string",
            offline: "bool",
            pagesToPrint: "uint?"
        },
        Printer: {
            id: "string",
            ip: "string",
            type: "KitchenPrinterTypes",
            barId: "string",
            offline: "bool",
            pagesToPrint: "uint?"
        },
        ListPrinters: {
            barId: "string",
            printers: "Printer[]"
        },
        PrintersResultError: {
            printer: "CreatePrinter",
            reason: "string"
        },
        PrintersResult: {
            success: "Printer[]",
            error: "PrintersResultError[]"
        },
        ProductBarEntry: {
            id: "string",
            name: "string"
        },
        PlaceProductMenuCategory: {
            id: "string",
            name: "string"
        },
        PlaceProduct: {
            id: "string?",
            name: "string",
            description: "string?",
            category: "string",
            categoryId: "string",
            value: "int",
            image: "ImageUrl?",
            bars: "ProductBarEntry[]",
            menuCategory: "PlaceProductMenuCategory?",
            active: "bool",
            hasAlcohol: "bool?",
            fiscalData: "TranslatedPlaceProductFiscalData",
            type: "string",
            minimumConsumptionValue: "uint?",
            hasProductionRule: "bool",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "MountableDescriptionV2?",
            mountableFiscalSplit: "bool?",
            fiscalCode: "string?",
            kind: "ProductKind",
            basicStorageUnit: "BasicStorageUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            proportionOfUnit: "ProportionOfUnit?",
            preparationTime: "uint?",
            systemProduct: "BaseSystemProduct?",
            printComboProductsIndividually: "bool?"
        },
        PlaceProductByTypeProductLinks: {
            products: "SupplyWithProductionRuleAttachedTo[]",
            count: "uint"
        },
        PlaceProductByTypeStorageLinksStorages: {
            id: "string",
            name: "string"
        },
        PlaceProductByTypeStorageLinks: {
            storages: "PlaceProductByTypeStorageLinksStorages[]",
            count: "uint"
        },
        PlaceProductByType: {
            id: "string?",
            name: "string",
            description: "string?",
            category: "string",
            categoryId: "string",
            value: "int",
            image: "ImageUrl?",
            bars: "ProductBarEntry[]",
            menuCategory: "PlaceProductMenuCategory?",
            active: "bool",
            hasAlcohol: "bool?",
            fiscalData: "TranslatedPlaceProductFiscalData",
            type: "string",
            minimumConsumptionValue: "uint?",
            hasProductionRule: "bool",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "MountableDescriptionV2?",
            mountableFiscalSplit: "bool?",
            fiscalCode: "string?",
            kind: "ProductKind",
            basicStorageUnit: "BasicStorageUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            proportionOfUnit: "ProportionOfUnit?",
            preparationTime: "uint?",
            systemProduct: "BaseSystemProduct?",
            printComboProductsIndividually: "bool?",
            productLinks: "PlaceProductByTypeProductLinks",
            storageLinks: "PlaceProductByTypeStorageLinks"
        },
        Product: {
            id: "string?",
            name: "string",
            category: "string",
            value: "int?",
            image: "ImageUrl?",
            hasAlcohol: "bool?",
            type: "string",
            fiscalCode: "string?",
            kind: "ProductKind",
            fiscalNcm: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?"
        },
        NewProduct: {
            name: "string",
            description: "string?",
            category: "string",
            hasAlcohol: "bool",
            fiscalCode: "string?",
            kindId: "string?",
            fiscalNcm: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            value: "uint?",
            releaseValue: "money?",
            proportionOfUnit: "ProportionOfUnit?",
            preparationTime: "uint?",
            systemProductId: "uuid?"
        },
        EditedProductThroughImport: {
            name: "string",
            description: "string?",
            category: "string",
            hasAlcohol: "bool",
            fiscalCode: "string?",
            kindId: "string?",
            fiscalNcm: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            value: "uint?",
            releaseValue: "money?",
            proportionOfUnit: "ProportionOfUnit?",
            preparationTime: "uint?",
            systemProductId: "uuid?",
            id: "string"
        },
        EditedProduct: {
            id: "string",
            name: "string",
            categoryId: "string",
            hasAlcohol: "bool",
            fiscalCode: "string?",
            kindId: "string?",
            description: "string?",
            value: "uint?",
            ncm: "string?",
            systemProductId: "uuid?"
        },
        EditedResultsError: {
            product: "EditedProduct",
            reason: "string"
        },
        EditedResults: {
            success: "EditedProduct[]",
            error: "EditedResultsError[]"
        },
        CreatedResultsError: {
            product: "NewProduct",
            reason: "string"
        },
        CreatedResults: {
            success: "PlaceProduct[]",
            error: "CreatedResultsError[]"
        },
        ProportionalValue: {
            quantity: "uint",
            value: "uint",
            unit: "ProportionalValueUnit"
        },
        NewMountableSectionWithStatusItems: {
            isActive: "bool",
            productId: "string",
            storageCount: "uint",
            name: "string?",
            price: "uint",
            maxCount: "uint?",
            selectedCount: "uint?"
        },
        NewMountableSectionWithStatus: {
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "NewMountableSectionWithStatusPricing",
            fiscalWeight: "uint?",
            items: "NewMountableSectionWithStatusItems[]"
        },
        NewMountableDescriptionWithStatus: {
            sections: "NewMountableSectionWithStatus[]"
        },
        NewPlaceProduct: {
            name: "string",
            category: "string",
            hasAlcohol: "bool",
            description: "string?",
            fiscalData: "NewPlaceProductFiscalData?",
            value: "uint?",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "NewMountableDescriptionWithStatus?",
            fiscalCode: "string?",
            kindId: "string?",
            menuCategory: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            preparationTime: "uint?",
            systemProductId: "uuid?"
        },
        MountableDescriptionWithDetailsSectionsItems: {
            isActive: "bool",
            productId: "string",
            storageCount: "uint",
            name: "string?",
            price: "uint",
            maxCount: "uint?",
            selectedCount: "uint?",
            isModification: "bool?"
        },
        MountableDescriptionWithDetailsSections: {
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "NewMountableSectionWithStatusPricing",
            fiscalWeight: "uint?",
            items: "MountableDescriptionWithDetailsSectionsItems[]"
        },
        MountableDescriptionWithDetails: {
            sections: "MountableDescriptionWithDetailsSections[]"
        },
        NewPlaceProductWithMountableDetails: {
            name: "string",
            category: "string",
            hasAlcohol: "bool",
            description: "string?",
            fiscalData: "NewPlaceProductFiscalData?",
            value: "uint?",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "MountableDescriptionWithDetails?",
            fiscalCode: "string?",
            kindId: "string?",
            menuCategory: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            preparationTime: "uint?",
            systemProductId: "uuid?",
            mountableFiscalSplit: "bool?"
        },
        BeerProduct: {
            beerBrand: "string?",
            beerStyle: "string?",
            beerAbv: "uint?",
            beerIbu: "uint?"
        },
        DeleteProductResultErrorPlace: {
            id: "string",
            name: "string"
        },
        DeleteProductResultErrorProducts: {
            id: "string",
            name: "string"
        },
        DeleteProductResultError: {
            place: "DeleteProductResultErrorPlace",
            products: "DeleteProductResultErrorProducts[]"
        },
        DeleteProductResult: {
            success: "bool",
            error: "DeleteProductResultError[]"
        },
        DeleteMultipleProductsResult: {
            status: "DeleteMultipleProductsStatus",
            jobId: "string?"
        },
        CreateSupply: {
            name: "string",
            placeId: "string",
            image: "bytes?",
            basicStorageUnit: "BasicStorageUnit",
            fiscalCode: "string?",
            yieldPercentage: "float?",
            proportionOfUnit: "ProportionOfUnit?"
        },
        CreateSupplyResponseErrors: {
            name: "string[]",
            error: "string"
        },
        CreateSupplyResponse: {
            resolved: "string[]",
            errors: "CreateSupplyResponseErrors[]"
        },
        BarProductMenuCategory: {
            id: "string",
            name: "string"
        },
        BarProductMenus: {
            id: "string",
            name: "string",
            productValue: "uint"
        },
        BarProduct: {
            id: "string?",
            name: "string",
            category: "string",
            categoryId: "string",
            image: "ImageUrl?",
            isActiveAtBar: "bool",
            menuCategory: "BarProductMenuCategory?",
            menus: "BarProductMenus[]",
            active: "bool",
            type: "string",
            hasProductionRule: "bool",
            fiscalCode: "string?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?"
        },
        SupplyProductionRuleOutput: {
            count: "uint"
        },
        SupplyProductionRule: {
            inputs: "BackofficeProductionRuleInput[]",
            output: "SupplyProductionRuleOutput"
        },
        OrganizationProductPlaces: {
            id: "string",
            name: "string"
        },
        OrganizationProduct: {
            id: "string",
            places: "OrganizationProductPlaces[]",
            name: "string",
            category: "string",
            categoryId: "string",
            hasAlcohol: "bool?",
            description: "string?",
            type: "string",
            image: "ImageUrl?",
            fiscalCode: "string?",
            kind: "ProductKind?",
            fiscalNcm: "string?",
            systemProductId: "string?",
            isPendingDeletion: "bool?",
            deletionFailedReason: "string?"
        },
        OrganizationProductToPlaceProduct: {
            id: "string",
            places: "OrganizationProductPlaces[]",
            name: "string",
            category: "string",
            categoryId: "string",
            hasAlcohol: "bool?",
            description: "string?",
            type: "string",
            image: "ImageUrl?",
            fiscalCode: "string?",
            kind: "ProductKind?",
            fiscalNcm: "string?",
            systemProductId: "string?",
            isPendingDeletion: "bool?",
            deletionFailedReason: "string?",
            value: "uint"
        },
        GroupedByCategoryOrganizationProductCategory: {
            id: "string",
            name: "string"
        },
        GroupedByCategoryOrganizationProduct: {
            category: "GroupedByCategoryOrganizationProductCategory",
            products: "OrganizationProduct[]"
        },
        InputProduct: {
            productId: "string",
            storageId: "string",
            unitCostValue: "uint?",
            obs: "string?",
            count: "uint",
            date: "datetime"
        },
        PlaceProductsByTypeResponse: {
            data: "PlaceProductByType[]",
            pagination: "PaginationResponse"
        },
        GrabAndGoProduct: {
            id: "string",
            name: "string",
            imageUrl: "string?",
            category: "string",
            isActiveForGrabAndGo: "bool"
        },
        PatchProduct: {
            name: "string",
            category: "string",
            hasAlcohol: "bool",
            description: "string?",
            fiscalData: "NewPlaceProductFiscalData?",
            value: "uint?",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "NewMountableDescriptionWithStatus?",
            fiscalCode: "string?",
            kindId: "string?",
            menuCategory: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            preparationTime: "uint?",
            systemProductId: "uuid?",
            id: "string?",
            bars: "string[]",
            image: "EditProductImage?"
        },
        PatchProductError: {
            name: "PatchProductErrorName",
            message: "string",
            product: "PatchProduct"
        },
        VerifyPatchProductsResult: {
            success: "PatchProduct[]",
            errors: "PatchProductError[]"
        },
        GetProductsWithSectionsRequest: {
            keywords: "string?",
            name: "string?",
            sku: "string?",
            menuId: "uuid?",
            categoryId: "uuid?"
        },
        BaseProductSectionResponseProducts: {
            id: "string",
            name: "string",
            description: "string?",
            fiscalCode: "string",
            value: "uint",
            order: "uint",
            isActive: "bool",
            syncedProduct: "ProductWithSectionResponse?"
        },
        BaseProductSectionResponse: {
            id: "uuid",
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "BaseProductSectionResponsePricing",
            order: "uint",
            products: "BaseProductSectionResponseProducts[]"
        },
        ProductWithSectionResponse: {
            id: "string",
            name: "string",
            description: "string?",
            type: "string",
            fiscalCode: "string",
            categoryId: "uuid",
            categoryName: "string",
            imageUrl: "string?",
            value: "uint",
            isActive: "bool",
            sections: "BaseProductSectionResponse[]"
        },
        GetProductsWithSectionsWithProductsResponse: {
            items: "ProductWithSectionResponse[]",
            pagination: "PaginationResponse"
        },
        ExternalStoreIntegrationSectionProduct: {
            externalId: "string?",
            externalStoreId: "string",
            name: "string",
            description: "string?",
            index: "uint",
            price: "uint",
            sku: "string?",
            isActive: "bool",
            isSynced: "bool",
            syncedProduct: "ProductWithSectionResponse?"
        },
        ExternalStoreIntegrationSection: {
            externalId: "string",
            name: "string",
            index: "uint",
            isActive: "bool",
            min: "uint",
            max: "uint",
            products: "ExternalStoreIntegrationSectionProduct[]",
            isSynced: "bool"
        },
        ExternalStoreIntegrationProductWithSections: {
            externalId: "string?",
            externalStoreId: "string",
            name: "string",
            description: "string?",
            price: "uint",
            sku: "string?",
            isActive: "bool",
            imageUrl: "string?",
            syncedProduct: "ProductWithSectionResponse?",
            sections: "ExternalStoreIntegrationSection[]",
            isSectionProductsSynced: "bool",
            allSyncedProducts: "ProductWithSectionResponse[]"
        },
        ExternalStoreIntegrationCategory: {
            externalId: "string",
            externalStoreId: "string",
            name: "string",
            sku: "string?",
            products: "ExternalStoreIntegrationProductWithSections[]",
            isSynced: "bool"
        },
        GetManyExternalStoreIntegrationCategoriesResponse: {
            categories: "ExternalStoreIntegrationCategory[]",
            totalOfProducts: "uint"
        },
        TinyProduct: {
            id: "string",
            name: "string",
            category: "string",
            categoryId: "string"
        },
        CategoryProduct: {
            id: "string?",
            name: "string",
            description: "string?",
            category: "string",
            categoryId: "string",
            value: "int",
            image: "ImageUrl?",
            bars: "ProductBarEntry[]",
            menuCategory: "PlaceProductMenuCategory?",
            active: "bool",
            hasAlcohol: "bool?",
            fiscalData: "TranslatedPlaceProductFiscalData",
            type: "string",
            minimumConsumptionValue: "uint?",
            hasProductionRule: "bool",
            proportionalValue: "ProportionalValue?",
            mountableDescription: "MountableDescriptionV2?",
            mountableFiscalSplit: "bool?",
            fiscalCode: "string?",
            kind: "ProductKind",
            basicStorageUnit: "BasicStorageUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            proportionOfUnit: "ProportionOfUnit?",
            preparationTime: "uint?",
            systemProduct: "BaseSystemProduct?",
            printComboProductsIndividually: "bool?",
            isPartOfMountableDescription: "bool",
            isMountable: "bool?"
        },
        ProductFeatureProperty: {
            name: "string",
            value: "json?"
        },
        BaseProductFeature: {
            productId: "string",
            productFeatureTemplateId: "string",
            properties: "ProductFeatureProperty[]",
            isActive: "bool",
            type: "string?"
        },
        ProductFeature: {
            productId: "string",
            productFeatureTemplateId: "string",
            properties: "ProductFeatureProperty[]",
            isActive: "bool",
            type: "string?",
            id: "string"
        },
        ProductFeatureTemplateField: {
            values: "string[]",
            name: "string",
            type: "ProductFeatureTemplateFieldType",
            isRequired: "bool"
        },
        BaseProductFeatureTemplate: {
            organizationId: "string?",
            observation: "string?",
            fields: "ProductFeatureTemplateField[]",
            name: "string",
            isActive: "bool",
            type: "string?"
        },
        ProductFeatureTemplate: {
            organizationId: "string?",
            observation: "string?",
            fields: "ProductFeatureTemplateField[]",
            name: "string",
            isActive: "bool",
            type: "string?",
            id: "string"
        },
        PlacePromoter: {
            id: "string",
            name: "string?",
            email: "string",
            phone: "string?",
            status: "PlacePromoterStatus",
            roleName: "string?",
            roleId: "string?"
        },
        PromoterRoles: {
            id: "string",
            name: "string"
        },
        EditPromoterPlace: {
            status: "bool",
            promoterRoleId: "string"
        },
        MultipleUserPromotionResultError: {
            cpfOrPhone: "string",
            reason: "string"
        },
        MultipleUserPromotionResult: {
            success: "string[]",
            error: "MultipleUserPromotionResultError[]"
        },
        CreateRefundReason: {
            reason: "string",
            type: "string[]",
            shouldAllowOpenText: "bool"
        },
        EditRefundReason: {
            id: "string",
            reason: "string",
            type: "string[]",
            isActive: "bool",
            shouldAllowOpenText: "bool"
        },
        RefundReason: {
            id: "string",
            placeId: "string",
            isActive: "bool",
            shouldAllowOpenText: "bool",
            reason: "string",
            type: "string[]"
        },
        RefundReasonResultError: {
            message: "string"
        },
        RefundReasonResult: {
            success: "RefundReason[]",
            error: "RefundReasonResultError[]"
        },
        NewRelation: {
            placeId: "string",
            eventId: "string?",
            name: "string",
            description: "string",
            couvertPercentage: "float?",
            entranceIds: "string[]",
            color: "string?",
            expiresAt: "datetime?",
            promoterIds: "string[]?",
            canBeInvitedByLink: "bool?",
            guestsLimitByPromoter: "uint?",
            guestsLimit: "uint?",
            hasAutomaticEntranceCharge: "bool?",
            isDocumentRequired: "bool?",
            addGuestTimeLimit: "datetime?"
        },
        RelationEntrances: {
            id: "string",
            name: "string"
        },
        Relation: {
            placeId: "string",
            eventId: "string?",
            name: "string",
            description: "string",
            couvertPercentage: "float?",
            entranceIds: "string[]",
            color: "string?",
            expiresAt: "datetime?",
            promoterIds: "string[]?",
            canBeInvitedByLink: "bool?",
            guestsLimitByPromoter: "uint?",
            guestsLimit: "uint?",
            hasAutomaticEntranceCharge: "bool?",
            isDocumentRequired: "bool?",
            addGuestTimeLimit: "datetime?",
            id: "string",
            entrances: "RelationEntrances[]",
            createdAt: "datetime",
            isExpired: "bool",
            isActive: "bool",
            userCount: "uint"
        },
        ImportRelationResponse: {
            success: "Relation[]?",
            errors: "ImportRelationError[]?"
        },
        ImportRelationErrorRelation: {
            id: "string",
            name: "string"
        },
        ImportRelationError: {
            type: "ImportRelationErrorTypes",
            message: "string",
            relation: "ImportRelationErrorRelation"
        },
        NewRelationUser: {
            cpf: "string?",
            name: "string",
            phone: "string?",
            promoter: "string?",
            promoterId: "uuid?"
        },
        RelationUserUser: {
            id: "string",
            name: "string",
            phone: "string?",
            cpf: "string?"
        },
        RelationUser: {
            cpf: "string?",
            name: "string",
            phone: "string?",
            promoter: "string?",
            promoterId: "uuid?",
            id: "string",
            user: "RelationUserUser?"
        },
        MultipleRelationUserErrorsUser: {
            document: "string?",
            name: "string?"
        },
        MultipleRelationUserErrors: {
            type: "MultipleRelationUserErrorsType",
            message: "string",
            user: "MultipleRelationUserErrorsUser"
        },
        MultipleRelationUser: {
            success: "RelationUser[]",
            errors: "MultipleRelationUserErrors[]"
        },
        GuestReportRelation: {
            id: "string",
            name: "string"
        },
        GuestReportUser: {
            id: "string?",
            cpf: "string?",
            phone: "string?",
            name: "string",
            birthDate: "date?"
        },
        GuestReportEntrances: {
            id: "string",
            name: "string",
            value: "uint"
        },
        GuestReport: {
            id: "string",
            relation: "GuestReportRelation",
            user: "GuestReportUser",
            promoter: "string?",
            consumption: "uint?",
            checkinDetails: "datetime?",
            checkinEmployee: "string?",
            entrances: "GuestReportEntrances[]"
        },
        RelationDataOverview: {
            numberOfGuests: "uint",
            numberOfActiveGuests: "uint",
            entranceTotal: "uint",
            consumptionTotal: "uint",
            relationLists: "uint",
            promoters: "uint"
        },
        RelationPromotersRelations: {
            numberOfGuests: "uint",
            numberOfActiveGuests: "uint",
            entranceTotal: "uint",
            consumptionTotal: "uint",
            relationLists: "uint",
            promoters: "uint",
            id: "string",
            name: "string"
        },
        RelationPromoters: {
            numberOfGuests: "uint",
            numberOfActiveGuests: "uint",
            entranceTotal: "uint",
            consumptionTotal: "uint",
            relationLists: "uint",
            promoters: "uint",
            promoter: "string",
            relationCount: "int",
            relations: "RelationPromotersRelations[]"
        },
        RelationReport: {
            numberOfGuests: "uint",
            numberOfActiveGuests: "uint",
            entranceTotal: "uint",
            consumptionTotal: "uint",
            relationLists: "uint",
            promoters: "uint",
            relationId: "string",
            eventId: "string?",
            name: "string",
            promotersName: "string[]"
        },
        GuestReportResponse: {
            data: "GuestReport[]",
            pagination: "PaginationResponse"
        },
        EmployeeReportItem: {
            count: "uint"
        },
        EmployeeReportItemWithTotal: {
            count: "uint",
            total: "uint"
        },
        EmployeeReportTotals: {
            sells: "uint",
            financialOperations: "uint",
            tip: "uint",
            refunds: "uint",
            checkIns: "uint"
        },
        EmployeeReportEmployees: {
            id: "string",
            name: "string",
            username: "string?",
            eventNames: "string[]",
            role: "string?",
            eventRoles: "string[]",
            avatar: "ImageUrl?",
            sells: "EmployeeReportItemWithTotal",
            financialOperations: "EmployeeReportItemWithTotal",
            financialOperationsClosedValue: "int",
            tipValue: "uint",
            refunds: "EmployeeReportItemWithTotal",
            sellRefunds: "EmployeeReportItemWithTotal",
            checkIns: "uint"
        },
        EmployeeReport: {
            totals: "EmployeeReportTotals",
            employees: "EmployeeReportEmployees[]"
        },
        FinanceBiReportEventsIncomes: {
            value: "uint",
            method: "FinanceBiMethod"
        },
        FinanceBiReportEvents: {
            id: "string",
            date: "date",
            incomes: "FinanceBiReportEventsIncomes[]",
            bonus: "uint",
            ticketZero: "uint",
            female: "uint",
            male: "uint",
            other: "uint"
        },
        FinanceBiReport: {
            events: "FinanceBiReportEvents[]"
        },
        BiConsumptionTimeline: {
            hourMinute: "string",
            avgValue: "uint",
            day: "uint?"
        },
        OrgConsumptionTimeline: {
            hourMinute: "string",
            avgValue: "uint",
            day: "uint?",
            placeId: "string"
        },
        ClientByReportEvents: {
            id: "string",
            date: "date",
            male: "uint",
            female: "uint",
            other: "uint"
        },
        ClientByReportTopIncomeClients: {
            id: "string",
            name: "string",
            phone: "string",
            cpf: "string",
            income: "uint"
        },
        ClientByReport: {
            events: "ClientByReportEvents[]",
            topIncomeClients: "ClientByReportTopIncomeClients[]"
        },
        ProductBiReport: {
            id: "string",
            name: "string",
            categoryId: "string",
            categoryName: "string",
            image: "ImageUrl?",
            sellCount: "uint",
            profit: "uint",
            consumption: "uint"
        },
        ReportPdvZigCardErrorCustomer: {
            id: "string",
            document: "string",
            name: "string?"
        },
        ReportPdvZigCardError: {
            id: "string",
            customer: "ReportPdvZigCardErrorCustomer?",
            employee: "MinimalEmployee",
            date: "datetime",
            deviceFingerprint: "string?",
            zigDeviceUid: "string?",
            additionalInfo: "string?"
        },
        ReportPdvZigCardReport: {
            data: "ReportPdvZigCardError[]",
            pagination: "PaginationResponse"
        },
        ReportPdvZigCardFilters: {
            employeeIds: "string[]?",
            deviceFingerprint: "string?"
        },
        ProductsSoldReportV2PriceVariationProportionalValue: {
            value: "uint",
            quantity: "uint",
            unit: "string"
        },
        ProductsSoldReportV2PriceVariation: {
            count: "int",
            unitValue: "int",
            subtotal: "int",
            discount: "int",
            totalValue: "int",
            proportionalValue: "ProductsSoldReportV2PriceVariationProportionalValue?"
        },
        ProductsSoldReportV2MountableComponent: {
            id: "string",
            name: "string",
            count: "int",
            section: "string"
        },
        ProductsSoldReportV2RowImage: {
            sha256: "string",
            url: "string"
        },
        ProductsSoldReportV2Row: {
            productId: "string",
            fiscalCode: "string?",
            productName: "string",
            categoryId: "string?",
            categoryName: "string?",
            image: "ProductsSoldReportV2RowImage?",
            count: "int",
            subtotal: "int",
            discount: "int",
            totalValue: "int",
            priceVariations: "ProductsSoldReportV2PriceVariation[]",
            mountableComponents: "ProductsSoldReportV2MountableComponent[]?",
            barId: "string?",
            barName: "string?",
            sectorId: "string?",
            sectorName: "string?",
            source: "ProductsSoldReportV2TransactionSource",
            productStatus: "ProductsSoldReportV2ProductStatus",
            masterKind: "string?",
            isReturnable: "bool"
        },
        ProductsSoldReportV2Filters: {
            placeId: "string",
            since: "datetime?",
            until: "datetime?",
            eventIds: "string[]?",
            categoryIds: "string[]?",
            productIds: "string[]?",
            barIds: "string[]?",
            sectorIds: "string[]?",
            sources: "string[]?",
            statuses: "string[]?",
            masterKinds: "string[]?",
            operationTypes: "ProductsSoldReportV2OperationType[]?"
        },
        KdsProductsReportRow: {
            productId: "string",
            productName: "string",
            productImageUrl: "string?",
            categoryName: "string?",
            source: "string",
            quantity: "int",
            expectedTime: "float?",
            actualTime: "float",
            variation: "float?"
        },
        KdsProductsReportFilters: {
            placeId: "string",
            since: "datetime",
            until: "datetime",
            kdsIds: "string[]?",
            screenIds: "string[]?",
            sources: "string[]?",
            categoryIds: "string[]?",
            productIds: "string[]?"
        },
        DetailedTransactionsReportOrderBy: {
            column: "DetailedTransactionsReportOrderByColumn",
            order: "DetailedTransactionsReportOrderByOrder"
        },
        DetailedTransactionsReportProduct: {
            name: "string",
            fiscalCode: "string?",
            category: "string?",
            count: "uint",
            value: "uint",
            discount: "uint",
            total: "uint"
        },
        DetailedTransactionsReportRow: {
            date: "datetime?",
            transactionId: "string",
            userId: "string?",
            name: "string?",
            document: "string?",
            sellerId: "string?",
            sellerName: "string?",
            value: "int",
            grossValue: "int",
            discount: "int",
            paymentMethods: "PaymentMethod[]?",
            isRefunded: "bool",
            products: "DetailedTransactionsReportProduct[]"
        },
        DetailedTransactionsReportFilters: {
            placeId: "string",
            since: "datetime?",
            until: "datetime?",
            eventIds: "string[]?",
            customerName: "string?",
            employeeIds: "string[]?",
            paymentMethods: "PaymentMethod[]?",
            sectorIds: "string[]?",
            orderBy: "DetailedTransactionsReportOrderBy[]?"
        },
        DetailedTransactionsReportResponse: {
            data: "DetailedTransactionsReportRow[]",
            pagination: "PaginationResponse"
        },
        DetailedTransactionsReportTotals: {
            totalTransactions: "int",
            refundedCount: "int",
            uniqueCustomers: "int",
            grossValue: "int",
            discount: "int",
            value: "int"
        },
        KdsOrdersReportRow: {
            orderId: "string",
            orderPassword: "string",
            date: "datetime",
            source: "string",
            kdsName: "string?",
            totalTimeMin: "float",
            finalStatus: "KdsOrderFinalStatus"
        },
        KdsOrdersReportResponse: {
            data: "KdsOrdersReportRow[]",
            pagination: "PaginationResponse"
        },
        KdsOrdersReportFilters: {
            placeId: "string",
            since: "datetime",
            until: "datetime",
            kdsIds: "string[]?",
            screenIds: "string[]?",
            sources: "string[]?",
            orderPassword: "string?",
            finalStatus: "KdsOrderFinalStatus?",
            sortBy: "KdsOrdersSortColumn?",
            sortDir: "KdsOrdersSortDirection?"
        },
        ReserveCommon: {
            name: "string",
            estimatedPeopleCount: "uint",
            reserveValue: "uint?",
            minimumConsumptionValue: "uint"
        },
        NewReserve: {
            name: "string",
            estimatedPeopleCount: "uint",
            reserveValue: "uint?",
            minimumConsumptionValue: "uint",
            obs: "string",
            reserveTemplateId: "string?",
            date: "datetime",
            expiresAt: "datetime?",
            promotionIds: "string[]"
        },
        ReservePromotions: {
            id: "string",
            name: "string",
            description: "string?",
            discount: "float"
        },
        Reserve: {
            id: "string",
            realPeopleCount: "uint",
            obs: "string",
            date: "datetime",
            reserveTemplateId: "string?",
            expiresAt: "datetime?",
            name: "string",
            estimatedPeopleCount: "uint",
            reserveValue: "uint?",
            minimumConsumptionValue: "uint",
            promotions: "ReservePromotions[]"
        },
        ReserveDiscountDetail: {
            fiscalProductGroupId: "string?",
            fiscalProductGroup: "string?",
            value: "uint",
            ncm: "string?",
            cest: "string?"
        },
        ReserveDetailUsers: {
            id: "string",
            name: "string",
            addedAt: "datetime",
            isInside: "bool"
        },
        ReserveDetailInvoices: {
            id: "string",
            mode: "InvoiceMode",
            date: "datetime",
            isCanceled: "bool",
            isIssued: "bool",
            isIssuing: "bool",
            error: "string?",
            pdfUrl: "string?",
            imgUrl: "string?"
        },
        ReserveDetail: {
            discounts: "ReserveDiscountDetail[]",
            users: "ReserveDetailUsers[]",
            invoices: "ReserveDetailInvoices[]"
        },
        ReserveReportRowReserves: {
            id: "string",
            name: "string",
            date: "date",
            products: "int",
            invitedPeople: "int",
            confirmedPeople: "int",
            value: "int",
            revenue: "int",
            issued: "int"
        },
        ReserveReportRow: {
            date: "date",
            reserves: "ReserveReportRowReserves[]"
        },
        ReserveReportDetailsIssuedInvoices: {
            id: "string",
            value: "uint",
            tipValue: "uint"
        },
        ReserveReportDetailsProductsByPromotion: {
            productId: "string",
            productName: "string",
            promotionId: "string?",
            promotionName: "string?",
            selledCount: "uint",
            originalPrice: "uint",
            totalPaidValue: "uint",
            totalDiscount: "uint"
        },
        ReserveReportDetails: {
            id: "string",
            name: "string",
            date: "date",
            confirmedPeople: "int",
            issuedInvoices: "ReserveReportDetailsIssuedInvoices[]",
            reserveValue: "uint?",
            tipValueOutsideInvoices: "uint",
            totalProductsValue: "uint",
            productsByPromotion: "ReserveReportDetailsProductsByPromotion[]"
        },
        NewReserveTemplate: {
            name: "string",
            estimatedPeopleCount: "uint",
            reserveValue: "uint?",
            minimumConsumptionValue: "uint",
            placeId: "string",
            promotionIds: "string[]"
        },
        ReserveTemplatePromotions: {
            id: "string",
            name: "string",
            description: "string?",
            discount: "float"
        },
        ReserveTemplate: {
            id: "string",
            name: "string",
            estimatedPeopleCount: "uint",
            reserveValue: "uint?",
            minimumConsumptionValue: "uint",
            promotions: "ReserveTemplatePromotions[]"
        },
        StorageProduct: {
            id: "string",
            name: "string",
            fiscalCode: "string?",
            quantity: "float",
            category: "string",
            categoryId: "string",
            image: "ImageUrl?",
            basicStorageUnit: "BasicStorageUnit??",
            avgUnitCost: "string?",
            lastUnitCost: "string?",
            hasProductionRule: "bool",
            isStockable: "bool",
            countConvertedProportionOfUnit: "ConvertedProportionOfUnit?",
            totalAvgCost: "string?"
        },
        IrregularStorageProduct: {
            id: "string",
            name: "string",
            fiscalCode: "string?",
            count: "float",
            basicStorageUnit: "BasicStorageUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            lastUnitCostValue: "string?",
            image: "ImageUrl?"
        },
        StorageWithIrregularProducts: {
            id: "string",
            name: "string",
            isCentral: "bool",
            products: "IrregularStorageProduct[]"
        },
        StorageProductOutput: {
            id: "string",
            name: "string",
            count: "float",
            basicStorageUnit: "BasicStorageUnit?"
        },
        StorageWithProductsWithoutUnitCost: {
            id: "string",
            name: "string",
            isCentral: "bool",
            products: "IrregularStorageProduct[]"
        },
        StorageWithProductsWithZeroQuantity: {
            id: "string",
            name: "string",
            isCentral: "bool",
            products: "IrregularStorageProduct[]"
        },
        BackofficeStorageInsights: {
            lowTurnoverProducts: "StorageProductOutput[]",
            highTurnoverProducts: "StorageProductOutput[]",
            zeroQuantityProducts: "StorageWithProductsWithZeroQuantity[]",
            productsWithoutUnitCostValue: "StorageWithProductsWithoutUnitCost[]"
        },
        BackofficeSingleStorageInsights: {
            lowTurnoverProducts: "StorageProductOutput[]",
            highTurnoverProducts: "StorageProductOutput[]",
            zeroQuantityProducts: "IrregularStorageProduct[]",
            productsWithoutUnitCostValue: "IrregularStorageProduct[]"
        },
        StorageTransferResult: {
            productId: "string",
            count: "float"
        },
        BackofficeMultipleStorageTransferProductResult: {
            success: "StorageTransferResult[]",
            error: "StorageTransferResult[]"
        },
        StorageTransferResultV2: {
            productId: "string",
            count: "float",
            basicStorageUnit: "BasicStorageUnit"
        },
        BackofficeMultipleStorageTransferProductResultV2: {
            transferedProducts: "StorageTransferResultV2[]",
            notActiveOnPlace: "StorageTransferResultV2[]"
        },
        GetProductsAtStorageFilters: {
            onlyStockableProducts: "bool?"
        },
        NewProductAlert: {
            productId: "string",
            type: "NewProductAlertType",
            ruleQuantity: "uint"
        },
        EditProductAlert: {
            id: "string",
            type: "EditProductAlertType?",
            ruleQuantity: "uint?"
        },
        ResultEditProductRuleError: {
            rule: "EditProductAlert",
            reason: "string"
        },
        ResultEditProductRule: {
            error: "ResultEditProductRuleError[]",
            success: "ProductAlert[]"
        },
        ResultCreateProductRuleError: {
            rule: "NewProductAlert",
            reason: "string"
        },
        ResultCreateProductRule: {
            error: "ResultCreateProductRuleError[]",
            success: "ProductAlert[]"
        },
        ProductStorageRule: {
            id: "string",
            placeId: "string",
            productId: "string",
            type: "ProductStorageRuleType",
            ruleQuantity: "uint"
        },
        ProductAlert: {
            productId: "string",
            name: "string",
            minimumAlert: "StorageAlert?",
            criticalAlert: "StorageAlert?",
            storageQuantity: "float",
            storageQuantityByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            basicStorageUnit: "BasicStorageUnit?"
        },
        StorageAlert: {
            id: "string",
            value: "float",
            valueByProportionOfUnit: "ConvertedProportionOfUnit?"
        },
        UserAlert: {
            name: "string",
            email: "string",
            phone: "string?"
        },
        ProductWithoutCostAtStorageStorage: {
            id: "string",
            name: "string"
        },
        ProductWithoutCostAtStorage: {
            productId: "string",
            storage: "ProductWithoutCostAtStorageStorage",
            lastUnitCostValue: "uint?"
        },
        UpdatedProductWithoutCostAtStorage: {
            productId: "string",
            storageId: "string",
            unitCostValue: "string?"
        },
        BaseProductionHistoryProduct: {
            productId: "string",
            name: "string",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit??",
            unitCostValue: "uint?"
        },
        BackofficeProductionHistoryItemStorage: {
            id: "string",
            name: "string"
        },
        BackofficeProductionHistoryItemAuthor: {
            id: "string",
            name: "string"
        },
        BackofficeProductionHistoryItemInputs: {
            productId: "string",
            name: "string",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit??",
            unitCostValue: "uint?",
            count: "int",
            lost: "uint"
        },
        BackofficeProductionHistoryItemOutput: {
            productId: "string",
            name: "string",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit??",
            unitCostValue: "uint?",
            count: "int"
        },
        BackofficeProductionHistoryItem: {
            id: "string",
            productionRuleId: "string",
            storage: "BackofficeProductionHistoryItemStorage?",
            author: "BackofficeProductionHistoryItemAuthor?",
            createdAt: "datetime",
            inputs: "BackofficeProductionHistoryItemInputs[]",
            output: "BackofficeProductionHistoryItemOutput"
        },
        BackofficeProductionHistoryResult: {
            items: "BackofficeProductionHistoryItem[]",
            page: "uint",
            itemsPerPage: "uint",
            totalItems: "uint"
        },
        Production: {
            id: "string",
            productionRuleId: "string",
            storage: "BackofficeProductionHistoryItemStorage?",
            author: "BackofficeProductionHistoryItemAuthor?",
            createdAt: "datetime",
            inputs: "BackofficeProductionHistoryItemInputs[]",
            output: "BackofficeProductionHistoryItemOutput",
            recipe: "SupplyWithProductionRule"
        },
        ProfitMarginReportItem: {
            id: "string",
            key: "string",
            name: "string",
            fiscalCode: "string?",
            category: "string?",
            quantity: "float",
            quantityByProportionOfUnit: "ConvertedProportionOfUnit?",
            proportionOfUnit: "ProportionOfUnit?",
            basicStorageUnit: "BasicStorageUnit?",
            value: "string",
            soldAmount: "string",
            invoicing: "float",
            averageSellingPrice: "string?",
            totalCost: "string",
            costPercentage: "float?",
            profitMarginValue: "string",
            profitMarginPercentage: "float?"
        },
        ProfitMarginReportResultInsights: {
            highProfitMarginProducts: "ProfitMarginReportItem[]",
            topHighTurnoverProduct: "ProfitMarginReportItem?",
            lowProfitMarginProducts: "ProfitMarginReportItem[]",
            topLowTurnoverProduct: "ProfitMarginReportItem?"
        },
        ProfitMarginReportResult: {
            items: "ProfitMarginReportItem[]",
            totalValue: "string",
            totalCost: "string",
            totalProfit: "string",
            profitMargin: "float",
            insights: "ProfitMarginReportResultInsights"
        },
        TransferTypeFromStorage: {
            id: "string",
            name: "string"
        },
        TransferTypeToStorage: {
            id: "string?",
            name: "string?"
        },
        TransferTypeEmployee: {
            id: "string",
            name: "string?"
        },
        TransferTypeProduct: {
            id: "string",
            name: "string?",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            count: "int",
            unitCostValue: "string?"
        },
        TransferType: {
            id: "string",
            contextId: "string",
            type: "StorageTransferType",
            date: "datetime",
            obs: "string?",
            fromStorage: "TransferTypeFromStorage",
            toStorage: "TransferTypeToStorage",
            employee: "TransferTypeEmployee",
            product: "TransferTypeProduct"
        },
        StorageTransferHistoryResult: {
            pagination: "PaginationResponse",
            transfers: "TransferType[]"
        },
        BaseGetStoragesTransfersHistoryByContextFilters: {
            productName: "string?",
            storageName: "string?",
            employeeName: "string?",
            types: "string[]?",
            since: "datetime",
            until: "datetime"
        },
        GetStoragesTransfersHistoryByContextFilters: {
            productName: "string?",
            storageName: "string?",
            employeeName: "string?",
            types: "string[]?",
            since: "datetime",
            until: "datetime",
            pagination: "Pagination?"
        },
        BackofficeTransferBetweenStoragesFromStorage: {
            id: "string",
            name: "string"
        },
        BackofficeTransferBetweenStoragesToStorage: {
            id: "string?",
            name: "string?"
        },
        BackofficeTransferBetweenStoragesEmployee: {
            id: "string",
            name: "string"
        },
        BackofficeTransferBetweenStoragesProducts: {
            id: "string",
            name: "string",
            fiscalCode: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            count: "int",
            unitCostValue: "string?",
            countByProportionOfUnit: "ConvertedProportionOfUnit?"
        },
        BackofficeTransferBetweenStorages: {
            id: "string",
            contextId: "string",
            date: "datetime",
            fromStorage: "BackofficeTransferBetweenStoragesFromStorage",
            toStorage: "BackofficeTransferBetweenStoragesToStorage",
            employee: "BackofficeTransferBetweenStoragesEmployee?",
            products: "BackofficeTransferBetweenStoragesProducts[]"
        },
        BackofficeTransfersBetweenStoragesResult: {
            pagination: "PaginationResponse",
            transfers: "BackofficeTransferBetweenStorages[]"
        },
        BaseGetBackofficeTransfersBetweenStoragesFilters: {
            employeeNameSearch: "string?",
            sourceStorageIds: "string[]?",
            since: "datetime?",
            until: "datetime?"
        },
        GetBackofficeTransfersBetweenStoragesFilters: {
            employeeNameSearch: "string?",
            sourceStorageIds: "string[]?",
            since: "datetime?",
            until: "datetime?",
            pagination: "Pagination"
        },
        BaseTableBarRangeWithBarNamesBars: {
            id: "string",
            name: "string"
        },
        BaseTableBarRangeWithBarNames: {
            fromTable: "uint",
            toTable: "uint",
            environmentName: "string?",
            bars: "BaseTableBarRangeWithBarNamesBars[]"
        },
        BaseTableBarRange: {
            fromTable: "uint",
            toTable: "uint",
            environmentName: "string?",
            bars: "string[]"
        },
        TableBarRangeResponse: {
            id: "string",
            fromTable: "uint",
            toTable: "uint",
            environmentName: "string?",
            bars: "BaseTableBarRangeWithBarNamesBars[]"
        },
        TableColor: {
            backgroundColor: "string",
            detailColor: "string",
            textColor: "string"
        },
        TableMapFilters: {
            environmentIds: "string[]?",
            status: "TableMapStatus[]?"
        },
        TableMapItem: {
            id: "string",
            number: "string[]",
            name: "string",
            status: "TableMapStatus",
            statusTranslated: "string",
            color: "TableColor",
            numberOfSeats: "uint?",
            openedAt: "datetime?",
            closedAt: "datetime?",
            totalValue: "money",
            paidValue: "money",
            employeeName: "string?",
            employeeUsername: "string?",
            lastInteractionAt: "datetime?"
        },
        GetTablesByEnvironmentAndStatusResponse: {
            tables: "TableMapItem[]",
            pagination: "PaginationResponse"
        },
        TableMapOverview: {
            tablesInService: "uint",
            tablesNeedingAttention: "uint",
            availableTables: "uint",
            hasActiveEvent: "bool"
        },
        ProductSoldV2MountableProducts: {
            id: "string",
            name: "string",
            count: "uint",
            section: "string",
            storageCount: "uint"
        },
        ProductSoldV2: {
            id: "string",
            name: "string",
            category: "string",
            categoryId: "string",
            image: "ImageUrl?",
            count: "int",
            type: "SellableThing",
            unitValue: "money",
            totalValue: "money",
            totalDiscount: "money",
            fiscalCode: "string",
            mountableProducts: "ProductSoldV2MountableProducts[]",
            isMountable: "bool?",
            productUnitCost: "string?",
            proportionalValue: "ProportionalValue?",
            estimatedTax: "float?",
            isReturnable: "bool?",
            operationType: "ProductSoldV2OperationType",
            kind: "ProductKind"
        },
        User: {
            id: "string",
            cpf: "string",
            name: "string",
            avatar: "ImageUrl?"
        },
        UserFilter: {
            type: "UserFilterType",
            filter: "string"
        },
        MinimalEvent: {
            id: "string",
            name: "string"
        },
        MinimalEventDetails: {
            id: "string",
            name: "string",
            beginAt: "datetime?",
            endAt: "datetime?"
        },
        PostPaymentWithPastBill: {
            acquirerTransactions: "AcquirerTransaction[]",
            createdAt: "datetime",
            createdBy: "string?",
            id: "string",
            eventId: "string?",
            event: "string?",
            beginAt: "datetime?",
            endAt: "datetime?",
            place: "string?",
            employee: "PostPaymentEventEmployee?",
            isDeleted: "bool",
            payments: "PostPaymentEventPayments[]",
            payers: "PostPaymentEventPayers[]",
            postPaymentType: "PostPaymentEventPostPaymentType",
            paidPastBill: "uint"
        },
        UserDetailsTransactionsRefundedBy: {
            name: "string",
            username: "string"
        },
        UserDetailsTransactionsProducts: {
            name: "string",
            count: "uint",
            value: "uint",
            discountValue: "uint"
        },
        UserDetailsTransactions: {
            id: "string",
            userValue: "uint",
            date: "datetime",
            isShared: "bool",
            isRefunded: "bool",
            refundedBy: "UserDetailsTransactionsRefundedBy?",
            sellerName: "string",
            sellerUsername: "string?",
            event: "MinimalEventDetails",
            tipValue: "uint",
            consumptionWithCreditFromOtherEvents: "uint",
            paidByApp: "bool",
            products: "UserDetailsTransactionsProducts[]",
            paidAfterEvent: "uint"
        },
        UserDetails: {
            recharges: "UserRechargeWithEvent[]",
            transactions: "UserDetailsTransactions[]",
            postPayments: "PostPaymentWithPastBill[]",
            cpf: "string",
            phone: "string",
            email: "string?",
            birthDate: "date?",
            checkInTime: "datetime?",
            checkOutTime: "datetime?",
            checkinMethod: "CheckinMethod?",
            checkoutMethod: "CheckinMethod?",
            clientsAtTag: "uint"
        },
        EditUser: {
            name: "string",
            phone: "string",
            email: "string?",
            birthDate: "date?"
        },
        UserRecharge: {
            totalValue: "uint",
            usedValue: "uint",
            authorName: "string",
            authorUsername: "string?",
            date: "datetime",
            isBonus: "bool",
            method: "UserRechargeMethod?",
            refunded: "bool",
            expired: "bool"
        },
        UserRechargeWithEvent: {
            totalValue: "uint",
            usedValue: "uint",
            authorName: "string",
            authorUsername: "string?",
            date: "datetime",
            isBonus: "bool",
            method: "UserRechargeMethod?",
            refunded: "bool",
            expired: "bool",
            event: "MinimalEventDetails"
        },
        NewUserRecharge: {
            type: "RechargeTypeEnum",
            reason: "string?",
            value: "uint",
            cpf: "string",
            name: "string?",
            email: "string?",
            phone: "string?",
            isForeign: "bool?",
            gender: "NewUserRechargeGender",
            paymentMethod: "RechargePaymentMethod?"
        },
        GiveRechargeError: {
            cpf: "string",
            err: "string"
        },
        InternationalUserRecharge: {
            type: "RechargeTypeEnum",
            value: "uint",
            cpf: "string",
            name: "string?",
            email: "email?",
            paymentMethod: "RechargePaymentMethod?"
        },
        EventUser: {
            id: "string",
            hasApp: "bool",
            checkInTime: "datetime",
            name: "string",
            email: "string?",
            gender: "string?",
            phone: "string",
            cpf: "string",
            zigCode: "string?",
            checkOutTime: "datetime?"
        },
        SearchFiltersProductConsumption: {
            id: "string",
            amount: "uint"
        },
        SearchFiltersBirthdateSince: {
            day: "uint",
            month: "uint"
        },
        SearchFiltersBirthdateUntil: {
            day: "uint",
            month: "uint"
        },
        SearchFiltersBirthdate: {
            since: "SearchFiltersBirthdateSince?",
            until: "SearchFiltersBirthdateUntil?",
            years: "uint[]?"
        },
        SearchFilters: {
            placeId: "string",
            gender: "string[]",
            consumptionVolume: "uint",
            presences: "uint?",
            firstTimeAtPlace: "bool?",
            presenceDays: "uint[]",
            productConsumption: "SearchFiltersProductConsumption[]",
            notUsedRecharges: "uint?",
            since: "datetime",
            until: "datetime",
            name: "string?",
            birthdate: "SearchFiltersBirthdate?"
        },
        SearchResult: {
            id: "string",
            name: "string",
            email: "string?",
            birthdate: "string?",
            cpf: "string",
            phone: "string",
            hasApp: "bool",
            consumption: "uint",
            presences: "uint",
            remaningValueOnPlace: "uint",
            firstTimeAtPlace: "datetime?",
            lastTimeAtPlace: "datetime?"
        },
        ClientsAtPlaceResponse: {
            data: "SearchResult[]?",
            pagination: "PaginationResponse?",
            averageTicket: "uint?"
        },
        UserDetailsByEventsTransactionsRefundedBy: {
            name: "string",
            username: "string"
        },
        UserDetailsByEventsTransactionsProducts: {
            name: "string",
            count: "uint",
            value: "uint",
            discountValue: "uint"
        },
        UserDetailsByEventsTransactions: {
            id: "string",
            userValue: "uint",
            date: "datetime",
            isShared: "bool",
            isRefunded: "bool",
            refundedBy: "UserDetailsByEventsTransactionsRefundedBy?",
            sellerName: "string",
            sellerUsername: "string?",
            tipValue: "uint",
            consumptionWithCreditFromOtherEvents: "uint",
            paidByApp: "bool",
            products: "UserDetailsByEventsTransactionsProducts[]",
            event: "MinimalEventDetails",
            paidAfterEvent: "uint"
        },
        UserDetailsByEvents: {
            event: "MinimalEventDetails",
            recharges: "UserRechargeWithEvent[]",
            transactions: "UserDetailsByEventsTransactions[]",
            postPayments: "PostPaymentWithPastBill[]",
            cpf: "string",
            phone: "string",
            email: "string?",
            checkInTime: "datetime?",
            checkOutTime: "datetime?"
        },
        ClientSearchFilters: {
            since: "datetime",
            until: "datetime"
        },
        ClientSearchResult: {
            id: "string",
            name: "string",
            email: "string?",
            cpf: "string",
            phone: "string",
            averageTicket: "uint"
        },
        ConsolidatedHistoryEventData: {
            id: "string",
            name: "string",
            date: "date",
            status: "string"
        },
        ConsolidatedHistoryConsumptionRechargesInEvent: {
            method: "string?",
            value: "uint"
        },
        ConsolidatedHistoryConsumptionEntrances: {
            id: "string",
            name: "string",
            count: "uint",
            userPaidValue: "uint",
            totalDiscountValue: "uint"
        },
        ConsolidatedHistoryConsumptionProductsSections: {
            id: "string",
            name: "string",
            count: "uint",
            title: "string",
            storageCount: "uint",
            maxCount: "uint?",
            price: "money",
            isActive: "bool",
            basicStorageUnit: "string"
        },
        ConsolidatedHistoryConsumptionProducts: {
            id: "string",
            name: "string",
            count: "uint",
            userPaidValue: "uint",
            isShared: "bool",
            totalDiscountValue: "uint",
            sections: "ConsolidatedHistoryConsumptionProductsSections[]?"
        },
        ConsolidatedHistoryConsumptionPaymentsInEvent: {
            method: "string",
            totalValue: "uint"
        },
        ConsolidatedHistoryConsumptionRefundedPaymentsInEvent: {
            method: "string",
            totalValue: "uint"
        },
        ConsolidatedHistoryConsumptionConsumptionObligations: {
            id: "string",
            value: "uint",
            paidValue: "uint"
        },
        ConsolidatedHistoryConsumption: {
            rechargesFromOtherEvents: "uint",
            notSyncRecharges: "uint",
            rechargesInEvent: "ConsolidatedHistoryConsumptionRechargesInEvent[]",
            bonusReceived: "uint",
            minimumConsumptionUsed: "uint",
            notUsedMinimumConsumption: "uint",
            entrances: "ConsolidatedHistoryConsumptionEntrances[]",
            products: "ConsolidatedHistoryConsumptionProducts[]",
            tip: "uint",
            paymentsInEvent: "ConsolidatedHistoryConsumptionPaymentsInEvent[]",
            refundedPaymentsInEvent: "ConsolidatedHistoryConsumptionRefundedPaymentsInEvent[]",
            bonusPayments: "uint?",
            openedBillPayments: "uint",
            paymentsInOtherEvents: "uint",
            consumptionObligations: "ConsolidatedHistoryConsumptionConsumptionObligations[]",
            openedBill: "uint",
            notUsedRecharges: "uint",
            rechargeDevolutions: "uint",
            rechargeDevolutionsFromOtherEvents: "uint",
            marketPlaceDiscount: "uint"
        },
        ConsolidatedHistoryGeneralActionsProductRefunds: {
            id: "string",
            name: "string",
            count: "uint"
        },
        ConsolidatedHistoryGeneralActionsPackages: {
            id: "string",
            name: "string"
        },
        ConsolidatedHistoryGeneralActionsPromotionsUsed: {
            id: "string",
            name: "string"
        },
        ConsolidatedHistoryGeneralActionsSingleProductReturns: {
            id: "string",
            returnedCount: "uint",
            eventId: "string",
            productId: "string",
            name: "string",
            unitValue: "money"
        },
        ConsolidatedHistoryGeneralActions: {
            productRefunds: "ConsolidatedHistoryGeneralActionsProductRefunds[]",
            packages: "ConsolidatedHistoryGeneralActionsPackages[]",
            promotionsUsed: "ConsolidatedHistoryGeneralActionsPromotionsUsed[]",
            removedTip: "uint",
            postPaidLimitChanged: "uint?",
            attachCount: "uint",
            singleProductReturns: "ConsolidatedHistoryGeneralActionsSingleProductReturns[]?"
        },
        ConsolidatedHistory: {
            eventData: "ConsolidatedHistoryEventData",
            checkInTime: "datetime",
            checkOutTime: "datetime?",
            consumption: "ConsolidatedHistoryConsumption",
            generalActions: "ConsolidatedHistoryGeneralActions"
        },
        HistoryActionDoneBy: {
            name: "string",
            username: "string?"
        },
        HistoryAction: {
            id: "string",
            type: "UserEventHistoryType",
            title: "string",
            subTitle: "string?",
            doneBy: "HistoryActionDoneBy?",
            value: "int?",
            tip: "int?",
            obs: "string?",
            date: "datetime?",
            eventId: "string",
            zigCode: "string?",
            syncTime: "datetime?",
            bonusCategoryName: "string?",
            isRefunded: "bool?"
        },
        UserEventHistoryEventData: {
            id: "string",
            name: "string",
            date: "date"
        },
        UserEventHistoryFirstInteractionBy: {
            name: "string",
            username: "string?"
        },
        UserEventHistoryCheckoutBy: {
            name: "string?",
            username: "string?"
        },
        UserEventHistory: {
            eventData: "UserEventHistoryEventData",
            checkInTime: "datetime",
            firstInteractionBy: "UserEventHistoryFirstInteractionBy?",
            checkOutTime: "datetime?",
            checkoutBy: "UserEventHistoryCheckoutBy?",
            oldEventsPaid: "uint",
            oldEventsRecharges: "uint",
            history: "HistoryAction[]"
        },
        UserTransactionOrderFee: {
            name: "string",
            description: "string?",
            value: "money",
            issueInvoice: "bool",
            deliverySource: "string?",
            receivedBy: "UserTransactionTipReceiver?"
        },
        UserTransactionResponse: {
            id: "string",
            products: "UserTransactionProduct[]",
            seller: "Seller",
            buyers: "TransactionBuyers[]",
            date: "datetime",
            refunded: "bool",
            tip: "money",
            marketPlaceDiscount: "money",
            orderFees: "UserTransactionOrderFee[]",
            total: "money?"
        },
        UserRefundTransactionProducts: {
            id: "string",
            name: "string",
            count: "uint"
        },
        UserRefundTransaction: {
            id: "string",
            sellerName: "string",
            refundedBy: "string",
            products: "UserRefundTransactionProducts[]"
        },
        ClientOpenedBill: {
            date: "date",
            eventId: "string",
            eventName: "string",
            value: "uint",
            tipValue: "uint",
            paidValue: "uint",
            paidInOtherEvents: "uint",
            paidTipValue: "uint"
        },
        ClientBonus: {
            date: "datetime",
            eventId: "string",
            eventName: "string",
            eventDate: "date",
            totalValue: "uint",
            usedValue: "uint",
            reason: "string?",
            givenBy: "string"
        },
        ClientDiscount: {
            date: "datetime",
            eventId: "string",
            eventName: "string",
            eventDate: "date",
            value: "uint",
            percentual: "float?",
            reason: "string?",
            givenBy: "string"
        },
        ClientTransferTransactionDetailsUserRef: {
            id: "string",
            name: "string",
            hasReceivedTransaction: "bool"
        },
        ClientTransferTransactionDetails: {
            id: "string",
            type: "SellableThing",
            name: "string",
            count: "int",
            value: "money?",
            discountValue: "money?",
            sections: "MountableSectionProduct[]?",
            userRef: "ClientTransferTransactionDetailsUserRef"
        },
        ClientOnlineFichaHistory: {
            name: "string",
            productId: "string",
            fichasBought: "uint",
            fichasBurnt: "uint",
            fichasRefunded: "uint"
        },
        AllOfflineActionTypes: {
            id: "string",
            name: "string"
        },
        VendorProductFee: {
            productId: "string",
            productName: "string",
            percentageFee: "float"
        },
        VendorClosing: {
            eventId: "string",
            vendorId: "string",
            vendorName: "string",
            totalSoldValue: "uint",
            fixedFee: "uint",
            generalPercentageFee: "float",
            payDate: "date",
            eventDate: "date",
            generalFeeValue: "uint",
            otherProductsFeeValue: "uint",
            vendorValueToReceive: "int",
            tipPercentageFee: "float",
            tipFeeValue: "int"
        },
        VendorRevenueAdjustValuesByCategory: {
            electrical: "money",
            hydraulics: "money",
            cleaning: "money",
            supply: "money",
            other: "money"
        },
        VendorRevenue: {
            id: "string",
            name: "string",
            totalSoldValue: "money",
            totalSoldValueInCredit: "money",
            totalSoldValueInCreditFeeValue: "money",
            totalSoldValueInDebit: "money",
            totalSoldValueInDebitFeeValue: "money",
            totalSoldValueInPix: "money",
            totalSoldValueInPixFeeValue: "money",
            totalSoldValueInOtherPaymentMethods: "money",
            totalTipValue: "money",
            fixedDailyFee: "uint",
            totalDailyFee: "uint?",
            percentageFee: "float",
            tipPercentageFee: "float?",
            valueFromFee: "money",
            tipFeeValue: "money?",
            totalReceipt: "money",
            totalBilling: "money",
            adjustTotalValue: "money",
            adjustValues: "VendorRevenueAdjustValuesByCategory",
            cashRetention: "money",
            cashPayment: "money?",
            voucherPayment: "money?",
            creditPayment: "money?",
            debitPayment: "money?",
            creditFee: "float?",
            debitFee: "float?",
            pixFee: "float?",
            voucherRetention: "money",
            singleProductReturns: "money?",
            otherProductsFeeValue: "money?",
            tipsInCredit: "money?",
            tipsInDebit: "money?",
            tipsInPix: "money?",
            tipsInOthers: "money?",
            floorComplement: "money?",
            rechargeLeftovers: "money?",
            rechargeLeftoversFeeValue: "money?"
        },
        VendorWithdrawalRequestResponseProRataFee: {
            percentage: "float",
            value: "money"
        },
        VendorWithdrawalRequestResponse: {
            withdrawId: "string",
            withdrawValue: "int",
            availableValue: "int",
            vendorName: "string",
            createdBy: "string",
            requestDate: "datetime",
            anticipationValue: "money",
            proRataFee: "VendorWithdrawalRequestResponseProRataFee?",
            type: "VendorWithdrawRequestType"
        },
        VendorWithdrawRequestHistoryResponseHistoryProRataFee: {
            percentage: "float",
            value: "money"
        },
        VendorWithdrawRequestHistoryResponseHistory: {
            withdrawId: "string",
            vendorId: "string",
            requestDate: "datetime",
            vendorName: "string",
            status: "string",
            paymentMethod: "string?",
            withdrawValue: "money",
            attachments: "string[]?",
            anticipationValue: "money",
            proRataFee: "VendorWithdrawRequestHistoryResponseHistoryProRataFee?",
            type: "VendorWithdrawRequestType",
            typeText: "string"
        },
        VendorWithdrawRequestHistoryResponse: {
            month: "string",
            total: "money",
            history: "VendorWithdrawRequestHistoryResponseHistory[]"
        },
        VendorDebtor: {
            userId: "string",
            userName: "string",
            value: "uint",
            paidValue: "uint",
            phone: "string",
            email: "string?",
            userDocument: "string"
        },
        ZigTagBlockConfirmRecharges: {
            id: "string",
            value: "uint",
            date: "datetime",
            expirationDate: "datetime?",
            paymentPrePaidType: "PaymentPrePaidType?"
        },
        ZigTagBlockConfirm: {
            id: "string",
            employee: "MinimalEmployee",
            event: "MinimalEvent",
            date: "datetime",
            user: "User",
            zigTagCode: "string",
            recharges: "ZigTagBlockConfirmRecharges[]"
        },
        ZigTagSyncForce: {
            id: "string",
            employee: "MinimalEmployee",
            event: "MinimalEvent",
            date: "datetime",
            user: "User",
            reason: "string",
            balance: "uint",
            zigTagCode: "string"
        },
        ZigTagUser: {
            id: "string",
            name: "string?",
            cpf: "string"
        },
        ZigTag: {
            id: "string",
            zigCode: "string",
            user: "ZigTagUser?",
            isBlocked: "bool"
        },
        ZigDeviceGroupInfo: {
            id: "string",
            name: "string"
        },
        ZigDeviceWithGroupAndBalance: {
            uid: "string",
            zigCode: "string",
            serialNumber: "uint?",
            status: "ZigDeviceWithGroupAndBalanceStatus",
            zigDeviceGroup: "ZigDeviceGroupInfo?",
            isAnonymous: "bool",
            userId: "string?",
            username: "string?",
            placeId: "string",
            totalValue: "money"
        },
        MessagePlace: {
            id: "string",
            name: "string"
        },
        Message: {
            id: "string",
            message: "string",
            place: "MessagePlace",
            date: "datetime",
            status: "MessageStatus",
            clientsCount: "uint",
            totalSent: "uint",
            createdAt: "datetime",
            value: "uint?",
            templateId: "string?",
            channel: "Channel",
            campaign: "MessageCampaign?",
            totalLines: "uint?",
            variables: "json?"
        },
        MessageClient: {
            phone: "string",
            name: "string?",
            userId: "string?",
            cpf: "string?",
            gender: "MessageClientGender?",
            totalLines: "uint?",
            observation: "string?"
        },
        MessageClientInsertResponse: {
            phone: "string",
            id: "string"
        },
        MessageClientDataForPlace: {
            frequency: "uint?",
            avgTicket: "uint?"
        },
        NewMessage: {
            placeId: "string",
            clients: "MessageClient[]",
            sendAt: "datetime?",
            message: "string?",
            channel: "Channel",
            campaignId: "string?",
            templateId: "string?",
            variables: "json?"
        },
        SentMessageClient: {
            phone: "string",
            name: "string?",
            userId: "string?",
            cpf: "string?",
            gender: "MessageClientGender?",
            totalLines: "uint?",
            observation: "string?",
            status: "SentMessageClientStatus",
            errorReason: "string?"
        },
        EditMessage: {
            placeId: "string?",
            message: "string?",
            date: "datetime?",
            templateId: "string?",
            channel: "Channel",
            campaignId: "string?",
            variables: "json?"
        },
        SentResume: {
            messageId: "string",
            mappedStatus: "string[]",
            placeId: "string"
        },
        MessageSentResume: {
            messageId: "string",
            optout: "uint",
            sending: "uint",
            sent: "uint",
            delivered: "uint",
            error: "uint",
            totalMessages: "uint",
            totalCost: "uint",
            totalCostError: "uint",
            totalCostDelivered: "uint",
            totalCostOptout: "uint"
        },
        MessageCampaign: {
            id: "string?",
            name: "string?"
        },
        ButtonsTemplate: {
            type: "ButtonType",
            title: "string",
            index: "uint?",
            phoneNumber: "string?",
            url: "string?"
        },
        MessageTemplate: {
            title: "string",
            variables: "GlossaryVariables[]?",
            message: "string",
            status: "MessageTemplateStatus",
            buttons: "ButtonsTemplate[]?",
            actionType: "ActionTypes?",
            image: "bytes?",
            rejectedReason: "string?",
            placeId: "string"
        },
        MessageTemplateResponse: {
            title: "string",
            variables: "GlossaryVariables[]?",
            message: "string",
            status: "MessageTemplateStatus",
            buttons: "ButtonsTemplate[]?",
            image: "string?",
            id: "string",
            placeId: "string",
            isUsed: "bool"
        },
        CampaignsInvestment: {
            smsCampaignId: "string",
            message: "string",
            date: "datetime",
            sentMessages: "uint",
            campaignCost: "uint",
            spentByClients: "uint",
            investmentMetric: "uint",
            placeName: "string",
            checkinsAfterMessage: "uint"
        },
        CampaignsInvestmentResult: {
            total: "uint",
            campaigns: "CampaignsInvestment[]"
        },
        MessagesSentAnalyticsFilters: {
            placeIds: "string[]?",
            eventIds: "string[]?",
            origins: "MessageSentOrigin[]?",
            since: "datetime",
            until: "datetime"
        },
        MessagesSentByOrigin: {
            origin: "string",
            count: "uint",
            percentage: "float"
        },
        MessagesSentByPlace: {
            placeId: "string",
            placeName: "string",
            count: "uint"
        },
        MessagesSentByEvent: {
            eventId: "string",
            eventName: "string",
            count: "uint"
        },
        MessagesSentDailyVolume: {
            date: "date",
            count: "uint"
        },
        MessagesSentAnalytics: {
            totalSent: "uint",
            deliveredCount: "uint",
            failedCount: "uint",
            successRate: "float",
            activePlaces: "uint",
            placesWithMessages: "uint",
            eventsWithMessages: "uint",
            distinctOrigins: "uint",
            byOrigin: "MessagesSentByOrigin[]",
            byPlace: "MessagesSentByPlace[]",
            byEvent: "MessagesSentByEvent[]",
            dailyVolume: "MessagesSentDailyVolume[]"
        },
        MessagesSentListItem: {
            placeName: "string",
            eventName: "string?",
            date: "date",
            origin: "string",
            smsCount: "uint",
            deliveredCount: "uint",
            failedCount: "uint",
            successRate: "float"
        },
        MessagesSentListResult: {
            data: "MessagesSentListItem[]",
            pagination: "PaginationResponse"
        },
        BackofficeBaseChartAccount: {
            name: "string",
            description: "string?",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            isCashflow: "bool",
            isDRE: "bool"
        },
        BackOfficeChartAccountCreate: {
            name: "string",
            description: "string?",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            isCashflow: "bool",
            isDRE: "bool",
            chartAccountParentId: "string?"
        },
        BackOfficeChartAccountUpdate: {
            name: "string",
            description: "string?",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            isCashflow: "bool",
            isDRE: "bool"
        },
        BackOfficeChartAccountResponseMetadata: {
            canCreateChildren: "bool",
            canUpdate: "bool",
            canDelete: "bool",
            isFixed: "bool"
        },
        BackOfficeChartAccountResponse: {
            id: "string",
            code: "string",
            name: "string",
            description: "string?",
            level: "uint",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            chartAccountParentId: "string?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            metadata: "BackOfficeChartAccountResponseMetadata?",
            isCashflow: "bool",
            isDRE: "bool"
        },
        BackOfficeChartAccountResponseTree: {
            id: "string",
            code: "string",
            name: "string",
            description: "string?",
            level: "uint",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            chartAccountParentId: "string?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            metadata: "BackOfficeChartAccountResponseMetadata?",
            isCashflow: "bool",
            isDRE: "bool",
            children: "BackOfficeChartAccountResponseTree[]"
        },
        BackOfficeImportChartAccountPayload: {
            startRow: "uint",
            code: "string",
            name: "string",
            level: "string",
            operation: "string",
            type: "string",
            file: "bytes"
        },
        BackOfficeChartAccountTreeMetadata: {
            canCreateChildren: "bool",
            canUpdate: "bool",
            canDelete: "bool",
            isFixed: "bool"
        },
        BackOfficeChartAccountTree: {
            id: "string",
            code: "string",
            name: "string",
            description: "string?",
            level: "uint",
            operationChartAccount: "BackOfficeOperationChartAccount?",
            chartAccountParentId: "string?",
            typeChartAccount: "BackOfficeTypeChartAccount?",
            metadata: "BackOfficeChartAccountTreeMetadata?",
            isCashflow: "bool",
            isDRE: "bool",
            children: "BackOfficeChartAccountTree[]"
        },
        BackofficeBaseAccountV2BankAccount: {
            holder: "string",
            documentNumber: "string",
            purpose: "BackofficePurposeTypes?",
            agency: "string",
            account: "string",
            bank: "string"
        },
        BackofficeBaseAccountV2: {
            accountName: "string",
            purpose: "BackofficePurposeTypes?",
            bankAccount: "BackofficeBaseAccountV2BankAccount?",
            isMainAccount: "bool",
            initialBalance: "int",
            initialBalanceDate: "datetime",
            currentBalance: "int",
            isValidated: "bool"
        },
        BackofficeAccountV2: {
            accountId: "uuid",
            isDeleted: "bool?",
            needsBalanceUpdate: "bool?",
            accountName: "string",
            purpose: "BackofficePurposeTypes?",
            bankAccount: "BackofficeBaseAccountV2BankAccount?",
            isMainAccount: "bool",
            initialBalance: "int",
            initialBalanceDate: "datetime",
            currentBalance: "int",
            isValidated: "bool"
        },
        BackofficeParamDates: {
            initial: "datetime",
            final: "datetime"
        },
        BackofficeAccountBillsReportChildrenPeriods: {
            value: "int",
            date: "string"
        },
        BackofficeAccountBillsReportChildren: {
            id: "string",
            code: "string",
            name: "string",
            children: "BackofficeAccountBillsReportChildren[]",
            total: "int?",
            chartAccountParentId: "string?",
            periods: "BackofficeAccountBillsReportChildrenPeriods[]",
            level: "int"
        },
        BackofficeAccountBillsReportSummaryPeriods: {
            value: "int",
            date: "string"
        },
        BackofficeAccountBillsReportSummary: {
            periods: "BackofficeAccountBillsReportSummaryPeriods[]",
            total: "int"
        },
        BackofficeAccountBillsReportField: {
            dre: "BackofficeAccountBillsReportChildren[]",
            summary: "BackofficeAccountBillsReportSummary"
        },
        BackofficeAccountBillsReportResponse: {
            incomeList: "BackofficeAccountBillsReportField",
            costsList: "BackofficeAccountBillsReportField",
            expensesList: "BackofficeAccountBillsReportField",
            summary: "BackofficeAccountBillsReportSummary"
        },
        GetBackofficeAccountBillsReportParams: {
            contextId: "string",
            organizationId: "string",
            interval: "BackofficeParamDates"
        },
        FinancialClosingReportMapFields: {
            name: "string",
            fee: "string?",
            payDate: "string",
            type: "string",
            isActive: "bool"
        },
        FinancialClosingReportMap: {
            division: "string",
            name: "string",
            fee: "string?",
            payDate: "string",
            type: "string"
        },
        FinancialClosingReportMapResponse: {
            integratedIncome: "FinancialClosingReportMapFields[]",
            notIntegratedIncome: "FinancialClosingReportMapFields[]",
            zigFees: "FinancialClosingReportMapFields[]",
            securityDeposit: "FinancialClosingReportMapFields[]",
            otherCharges: "FinancialClosingReportMapFields[]",
            rechargeRefund: "FinancialClosingReportMapFields[]"
        },
        BackofficeAccountBillsChartAccount: {
            chartAccountId: "string",
            type: "BackofficeTypeAccountBillsChartAccount",
            name: "string?",
            code: "string?",
            deletedAt: "datetime?",
            updatedAt: "datetime?",
            updatedBy: "string?",
            isDeleted: "bool?",
            value: "uint?"
        },
        BackofficeAccountBillsChartAccountResponse: {
            id: "string?",
            chartAccountId: "string",
            type: "BackofficeTypeAccountBillsChartAccount",
            name: "string?",
            code: "string?",
            deletedAt: "datetime?",
            updatedAt: "datetime?",
            updatedBy: "string?",
            isDeleted: "bool?",
            value: "uint?"
        },
        BackofficeRecurringPayment: {
            typeInterval: "TypeInterval",
            interval: "uint",
            times: "uint"
        },
        BackofficeRecurringGroupSummary: {
            totalCount: "uint",
            generatedCount: "uint",
            paidCount: "uint",
            pendingCount: "uint",
            overdueCount: "uint",
            paidAmount: "uint",
            pendingAmount: "uint",
            overdueAmount: "uint",
            firstDueDate: "datetime",
            lastDueDate: "datetime",
            nextDueDate: "datetime?"
        },
        BackofficeRecurringInfo: {
            recurringGroupId: "string",
            recurringSequence: "uint?",
            recurringTotalCount: "uint?",
            recurringStatus: "BackofficeRecurringStatus?",
            isFirstInGroup: "bool?",
            isLastInGroup: "bool?",
            groupSummary: "BackofficeRecurringGroupSummary?"
        },
        BackofficeBaseAccountBills: {
            supplierId: "string?",
            docNumber: "string?",
            dueDate: "datetime",
            paymentDate: "datetime?",
            invoiceDate: "datetime?",
            description: "string?",
            value: "uint?",
            paymentMethod: "BackofficePaymentMethod?",
            accountId: "string?",
            costCenterId: "string?",
            interest: "uint?",
            fine: "uint?",
            discount: "uint?",
            paidValue: "uint?",
            isPaid: "bool",
            isReconciled: "bool",
            type: "BackofficeTypeAccountBills",
            placeId: "string?",
            updatedBy: "string?",
            isDeleted: "bool?",
            createdBy: "string?",
            chartAccounts: "BackofficeAccountBillsChartAccountResponse[]",
            observation: "string?",
            recurringPayment: "BackofficeRecurringPayment?",
            financialFees: "uint?",
            attachments: "BackofficeAttachment[]?",
            eventId: "string?",
            recurringGroupId: "string?",
            recurringSequence: "uint?",
            recurringTotalCount: "uint?",
            recurringStatus: "BackofficeRecurringStatus?"
        },
        BackofficeAccountBills: {
            id: "string",
            supplierId: "string?",
            docNumber: "string?",
            dueDate: "datetime",
            paymentDate: "datetime?",
            invoiceDate: "datetime?",
            description: "string?",
            value: "uint?",
            paymentMethod: "BackofficePaymentMethod?",
            accountId: "string?",
            costCenterId: "string?",
            interest: "uint?",
            fine: "uint?",
            discount: "uint?",
            paidValue: "uint?",
            isPaid: "bool",
            isReconciled: "bool",
            type: "BackofficeTypeAccountBills",
            placeId: "string?",
            updatedBy: "string?",
            isDeleted: "bool?",
            createdBy: "string?",
            chartAccounts: "BackofficeAccountBillsChartAccountResponse[]",
            observation: "string?",
            recurringPayment: "BackofficeRecurringPayment?",
            financialFees: "uint?",
            attachments: "BackofficeAttachment[]?",
            eventId: "string?",
            recurringGroupId: "string?",
            recurringSequence: "uint?",
            recurringTotalCount: "uint?",
            recurringStatus: "BackofficeRecurringStatus?"
        },
        BackofficeGetParamsAccountsBills: {
            docNumber: "string?",
            dueDate: "BackofficeParamDates?",
            invoiceDate: "BackofficeParamDates?",
            placeId: "string",
            paymentDate: "BackofficeParamDates?",
            organizationId: "string",
            type: "BackofficeTypeAccountBills",
            isPaid: "bool?",
            supplierName: "string?",
            value: "uint?",
            status: "BackofficeAccountBillsStatus?",
            chartAccountId: "string?",
            pagination: "Pagination?",
            recurringGroupId: "string?",
            installmentGroupId: "string?",
            orderBy: "BackofficeGetParamsAccountsBillsOrderBy?",
            order: "BackofficeGetParamsAccountsBillsOrder?"
        },
        BackofficeChartAccount: {
            id: "string",
            chartAccountId: "string",
            accountBillsId: "string",
            code: "string",
            name: "string",
            level: "uint",
            type: "string"
        },
        BackofficeAccountBillsAttachmentResponse: {
            id: "string",
            url: "string",
            fileName: "string"
        },
        BackofficeGetAccountBillsResponse: {
            id: "string",
            supplier: "BackofficeSupplier?",
            costCenter: "BackofficeCostCenter?",
            account: "BackofficeAccountV2?",
            docNumber: "string?",
            interest: "uint?",
            fine: "uint?",
            discount: "uint?",
            paidValue: "uint?",
            isPaid: "bool",
            isReconciled: "bool",
            type: "BackofficeTypeAccountBills",
            placeId: "string",
            deletedAt: "datetime?",
            updatedAt: "datetime?",
            updatedBy: "string?",
            createdAt: "datetime?",
            createdBy: "string?",
            isDeleted: "bool",
            chartAccounts: "BackofficeAccountBillsChartAccountResponse[]",
            description: "string?",
            invoiceDate: "datetime?",
            dueDate: "datetime",
            paymentDate: "datetime?",
            value: "uint?",
            paymentMethod: "BackofficePaymentMethod?",
            observation: "string?",
            attachments: "BackofficeAccountBillsAttachmentResponse[]?",
            recurringPayment: "BackofficeRecurringPayment?",
            financialFees: "uint?",
            status: "BackofficeAccountBillsStatus",
            recurringGroupId: "string?",
            recurringInfo: "BackofficeRecurringInfo?"
        },
        BackofficeGetResumeAccountBillsResponse: {
            overdue: "uint",
            maturing: "uint",
            due: "uint",
            paid: "uint",
            total: "uint"
        },
        BackofficeGetDREParams: {
            placeId: "string",
            interval: "BackofficeParamDates"
        },
        BackofficeFinancialFeeType: {
            app: "float?",
            inHouse: "float?",
            expiredRecharge: "float?",
            card: "float?",
            rechargeRemainings: "float?",
            zigMachineCredit: "float?",
            zigMachineDebit: "float?",
            debitAcquirer: "float?",
            creditAcquirer: "float?",
            bonus: "float?",
            smsCost: "int?",
            cpfConsultCost: "int?",
            hasCustomizedCard: "bool?",
            barIncome: "float?",
            entranceIncome: "float?",
            barMinimumConsumption: "float?",
            entranceMinimumConsumption: "float?",
            debitDays: "float?",
            creditDays: "float?",
            rappi: "float?",
            ame: "float?",
            deliveryOnline: "float?",
            ifood: "float?",
            uber: "float?",
            pix: "float?",
            reserveOnline: "float?",
            clientfloategratedMachine: "float?",
            creditOpenSale: "float?",
            debitOpenSale: "float?",
            pixOpenSale: "float?",
            relatedStakeholderRetention: "int?",
            terminalRentValue: "int?",
            integratedFoodVoucher: "float?",
            zigMachineCreditInInstallments: "float?"
        },
        BackofficeFinancialPayDatesType: {
            debit: "datetime?",
            credit: "datetime?",
            expiredRecharge: "datetime?",
            fee: "datetime?",
            rappiDate: "datetime?",
            ameDate: "datetime?",
            ifoodDate: "datetime?",
            uberDate: "datetime?"
        },
        BackofficeFinancialClosing: {
            date: "datetime",
            fee: "BackofficeFinancialFeeType",
            payDates: "BackofficeFinancialPayDatesType",
            appTransactions: "int?",
            appCreditTransactions: "int?",
            inHouseTransactions: "int?",
            inHouseFromOtherEvents: "int?",
            bonusTransactions: "int?",
            minimumConsumptionTransactions: "int?",
            generalZigMachineCredit: "int?",
            generalZigMachineDebit: "int?",
            notUsedRecharges: "int?",
            consumedRecharges: "int?",
            totalRecharges: "int?",
            expiredRecharge: "int?",
            smsCharges: "int?",
            cpfConsultCharges: "int?",
            eventId: "uuid",
            placeId: "uuid",
            organizationId: "uuid",
            cardActivationsValue: "int?",
            barIncomeCash: "int?",
            barIncomeCredit: "int?",
            barIncomeDebit: "int?",
            barIncomeZigCredit: "int?",
            barIncomeZigDebit: "int?",
            barIncomeVoucher: "int?",
            barIncomeDashboard: "int?",
            barIncomeAnticipated: "int?",
            barIncomeApp: "int?",
            entranceIncomeApp: "int?",
            entranceIncomeCash: "int?",
            entranceIncomeCredit: "int?",
            entranceIncomeDebit: "int?",
            entranceIncomeZigCredit: "int?",
            entranceIncomeZigDebit: "int?",
            entranceIncomeVoucher: "int?",
            entranceIncomeDashboard: "int?",
            entranceIncomeAnticipated: "int?",
            barIncomePostEvent: "int?",
            entranceIncomePostEvent: "int?",
            barMinimumConsumption: "int?",
            entranceMinimumConsumption: "int?",
            barIncome: "int?",
            entranceIncome: "int?",
            cardActivationCashDevolutions: "int?",
            cardActivationProductDevolutions: "int?",
            barIncomeRappi: "int?",
            entranceIncomeRappi: "int?",
            barTip: "int?",
            entranceTip: "int?",
            barIncomeAme: "int?",
            entranceIncomeAme: "int?",
            barIncomeDeliveryOnline: "int?",
            barIncomeIfood: "int?",
            entranceIncomeIfood: "int?",
            barIncomeUber: "int?",
            entranceIncomeUber: "int?",
            barIncomePix: "int?",
            entranceIncomePix: "int?",
            paidConsumptionObligation: "int?",
            givenAndUsedBonus: "int?",
            entranceIncomeReserveOnline: "int?",
            grossProductSold: "int?",
            discountProductSold: "int?",
            grossEntranceSold: "int?",
            discountEntranceSold: "int?",
            grossZigCardSold: "int?",
            discountZigCardSold: "int?",
            grossCouvertSold: "int?",
            discountCouvertSold: "int?",
            manualInvoiceProductsValue: "int?",
            manualInvoiceTipsValue: "int?",
            eventEntranceConsumptionUsed: "int?",
            paidNotSyncTransactions: "int?",
            rechargeBalance: "int?",
            remainingConsumptionObligation: "int?",
            openSaleCredit: "int?",
            openSaleDebit: "int?",
            openSalePix: "int?",
            generalClientIntegratedMachineCredit: "int?",
            generalClientIntegratedMachineDebit: "int?",
            openSaleCreditClientIntegrated: "int?",
            openSaleDebitClientIntegrated: "int?",
            terminals: "int?",
            whatsappCharges: "int?",
            barIncomeIntegratedFoodVoucher: "int?",
            entranceIncomeIntegratedFoodVoucher: "int?",
            generalZigMachineFoodVoucher: "int?",
            generalClientIntegratedMachineFoodVoucher: "int?",
            openSaleFoodVoucher: "int?",
            openSaleFoodVoucherClientIntegrated: "int?",
            barIncomeZigCreditInInstallments: "int?",
            entranceIncomeZigCreditInInstallments: "int?",
            generalZigMachineCreditIn2Installments: "int?",
            generalZigMachineCreditIn3Installments: "int?",
            generalZigMachineCreditIn4Installments: "int?",
            generalZigMachineCreditIn5Installments: "int?",
            generalZigMachineCreditIn6Installments: "int?",
            generalZigMachineCreditIn7Installments: "int?",
            generalZigMachineCreditIn8Installments: "int?",
            generalZigMachineCreditIn9Installments: "int?",
            generalZigMachineCreditIn10Installments: "int?",
            generalZigMachineCreditIn11Installments: "int?",
            generalZigMachineCreditIn12Installments: "int?",
            openSaleCreditIn2Installments: "int?",
            openSaleCreditIn3Installments: "int?",
            openSaleCreditIn4Installments: "int?",
            openSaleCreditIn5Installments: "int?",
            openSaleCreditIn6Installments: "int?",
            openSaleCreditIn7Installments: "int?",
            openSaleCreditIn8Installments: "int?",
            openSaleCreditIn9Installments: "int?",
            openSaleCreditIn10Installments: "int?",
            openSaleCreditIn11Installments: "int?",
            openSaleCreditIn12Installments: "int?",
            notCharged: "int?",
            openedBillPayments: "int?",
            barIncomeTax: "int?",
            entranceIncomeTax: "int?"
        },
        FinancialEventClosingConferenceFee: {
            name: "string",
            value: "float",
            translate: "string?"
        },
        FinancialEventClosingConferenceAccount: {
            name: "string",
            value: "uint",
            payDate: "datetime",
            type: "TypeClosingAccount",
            translate: "string?",
            invoiceDate: "datetime"
        },
        FinancialConferenceParams: {
            name: "string",
            account: "FinancialEventClosingConferenceAccount",
            fee: "FinancialEventClosingConferenceFee?",
            total: "float"
        },
        FinancialConferenceResponse: {
            account: "FinancialEventClosingConferenceAccount",
            fee: "FinancialEventClosingConferenceFee?",
            total: "float"
        },
        FinancialEventClosingConference: {
            resumed: "FinancialConferenceResponse[]",
            integratedIncome: "FinancialConferenceResponse[]?",
            notIntegratedIncome: "FinancialConferenceResponse[]?",
            zigFees: "FinancialConferenceResponse[]?",
            securityDeposit: "FinancialConferenceResponse[]?",
            otherCharges: "FinancialConferenceResponse[]?",
            rechargeRefund: "FinancialConferenceResponse[]?"
        },
        BackofficeGetAccountBillsResponseWithPagination: {
            data: "BackofficeGetAccountBillsResponse[]",
            pagination: "PaginationResponse"
        },
        BackofficeInstallmentPreviewResponse: {
            installmentNumber: "uint",
            dueDate: "datetime",
            valueInCents: "uint",
            description: "string"
        },
        BackofficePreviewInstallmentsRequest: {
            totalAmountInCents: "uint",
            installmentCount: "uint",
            firstDueDate: "datetime",
            intervalType: "TypeInterval",
            intervalValue: "uint"
        },
        BackofficeUpdatePreviewInstallmentsRequest: {
            originalRequest: "BackofficePreviewInstallmentsRequest",
            modifiedInstallment: "BackofficeInstallmentPreviewResponse"
        },
        BackofficeCreateInstallmentResponse: {
            installmentGroupId: "string",
            totalInstallments: "uint",
            createdAccountBills: "string[]"
        },
        BackofficeAccountBillDetailValue: {
            value: "uint",
            chartAccountId: "uuid"
        },
        BackofficeAccountBillValues: {
            interest: "BackofficeAccountBillDetailValue?",
            fine: "BackofficeAccountBillDetailValue?",
            discount: "BackofficeAccountBillDetailValue?",
            financialFees: "BackofficeAccountBillDetailValue?"
        },
        MissingAccountBillsOnEventClosingParams: {
            closingType: "string",
            closingTypeTax: "string?",
            paymentDate: "string",
            chartAccountId: "string",
            typeAccountBills: "BackofficeTypeAccountBills"
        },
        MissingAccountBillsOnEventClosingQuery: {
            eventId: "string",
            closingConferenceStatus: "string",
            placeId: "string",
            organizationId: "string",
            date: "datetime",
            closingType: "uint",
            closingTypeTax: "uint?",
            paymentDate: "datetime"
        },
        BackofficeMissingAccountBillsOnEventClosing: {
            eventId: "string",
            closingConferenceStatus: "string",
            placeId: "string",
            organizationId: "string",
            date: "datetime",
            closingType: "uint",
            closingTypeTax: "uint?",
            paymentDate: "datetime",
            chartAccountId: "string",
            typeAccountBills: "BackofficeTypeAccountBills"
        },
        BackofficeAccountBillHistoryUserRef: {
            id: "string",
            name: "string?"
        },
        BackofficeAccountBillHistoryFieldChange: {
            field: "string",
            fromValue: "string?",
            toValue: "string"
        },
        BackofficeAccountBillHistoryEntry: {
            id: "string",
            eventType: "BackofficeAccountBillHistoryEventType",
            performedAt: "datetime",
            performedBy: "BackofficeAccountBillHistoryUserRef",
            changes: "BackofficeAccountBillHistoryFieldChange[]?"
        },
        BackofficeStorageInventoryStorage: {
            id: "string",
            name: "string"
        },
        BackofficeStorageInventoryCategory: {
            id: "string",
            name: "string",
            image: "ImageUrl?"
        },
        BackofficeStorageInventoryUser: {
            id: "string",
            name: "string"
        },
        BackofficeStorageInventoryWithStorage: {
            id: "string",
            name: "string",
            storageId: "string",
            storage: "BackofficeStorageInventoryStorage",
            categories: "BackofficeStorageInventoryCategory[]",
            status: "BackofficeStorageInventoryStatus",
            createdBy: "BackofficeStorageInventoryUser",
            updatedBy: "BackofficeStorageInventoryUser",
            createdAt: "datetime",
            updatedAt: "datetime",
            lastReopenReason: "string?"
        },
        BackofficeStorageInventoryProduct: {
            productId: "string",
            name: "string",
            category: "BackofficeStorageInventoryCategory",
            fiscalCode: "string",
            basicStorageUnit: "BasicStorageUnit",
            count: "float?"
        },
        CompleteBackofficeStorageInventory: {
            id: "string",
            name: "string",
            storageId: "string",
            storage: "BackofficeStorageInventoryStorage",
            categories: "BackofficeStorageInventoryCategory[]",
            status: "BackofficeStorageInventoryStatus",
            createdBy: "BackofficeStorageInventoryUser",
            updatedBy: "BackofficeStorageInventoryUser",
            createdAt: "datetime",
            updatedAt: "datetime",
            lastReopenReason: "string?",
            products: "BackofficeStorageInventoryProduct[]"
        },
        BackofficeStorageInventoriesResult: {
            items: "BackofficeStorageInventoryWithStorage[]",
            page: "uint",
            itemsPerPage: "uint",
            totalItems: "uint"
        },
        BackofficeStorageInventoryProductComparison: {
            productId: "string",
            name: "string",
            category: "BackofficeStorageInventoryCategory",
            fiscalCode: "string",
            basicStorageUnit: "BasicStorageUnit",
            proportionOfUnit: "ProportionOfUnit?",
            storageInventoryCount: "float?",
            storageInventoryCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            storageCount: "float",
            storageCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            averageUnitCostValue: "string?",
            difference: "float?",
            image: "ImageUrl?",
            storageTransferType: "BackofficeStorageInventoryProductTransferType?"
        },
        BackofficeStorageInventoryAndStorageComparison: {
            storageInventory: "BackofficeStorageInventoryWithStorage",
            products: "BackofficeStorageInventoryProductComparison[]",
            pagination: "PaginationResponse?",
            totalItemsCount: "uint?"
        },
        GetBackofficeStorageInventoryAndStorageComparisonFilters: {
            categoryName: "string?",
            productName: "string?",
            filterType: "GetBackofficeStorageInventoryAndStorageComparisonFiltersFilterType?"
        },
        BackofficeUpdateStorageInventoryProductsTransferType: {
            productId: "string",
            storageTransferType: "BackofficeStorageInventoryProductTransferType"
        },
        BackofficeStorageInventoryProductInconsistency: {
            productId: "string",
            name: "string",
            category: "BackofficeStorageInventoryCategory",
            fiscalCode: "string",
            basicStorageUnit: "BasicStorageUnit",
            storageInventoryCount: "float?",
            storageInventoryCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            storageCount: "float",
            storageCountByProportionOfUnit: "ConvertedProportionOfUnit?",
            averageUnitCostValue: "string?",
            quantityDifference: "float?",
            unitCostDifference: "string?",
            image: "ImageUrl?",
            storageTransferType: "BackofficeStorageInventoryProductTransferType?",
            proportionOfUnit: "ProportionOfUnit?"
        },
        BackofficeStorageInventoriesTotalizers: {
            total: "uint",
            open: "uint",
            inReview: "uint",
            approved: "uint",
            reopened: "uint"
        },
        Summary: {
            addedProducts: "int",
            returnedProducts: "int",
            totalSalesCommission: "money",
            totalSales: "money"
        },
        HawkerReportFilters: {
            hawkerNames: "string[]?",
            hawkerDocuments: "string[]?",
            hawkerCashierNames: "string[]?",
            hawkerCashierDocuments: "string[]?",
            employeeNames: "string[]?",
            hawkerIds: "uuid[]?",
            hawkerCycleId: "uuid?"
        },
        HawkerReportRelease: {
            hawkerProductReleaseId: "string",
            cycleId: "string",
            dateTime: "datetime",
            quantity: "int",
            unitValue: "money",
            total: "money"
        },
        Sales: {
            productId: "string",
            productName: "string",
            type: "HawkerSaleType",
            quantity: "int",
            value: "money",
            total: "money",
            commission: "money?",
            releases: "HawkerReportRelease[]?"
        },
        HawkerPaymentMethod: {
            type: "AllPaymentMethods",
            value: "money"
        },
        SessionsOpenedBar: {
            id: "uuid",
            name: "string"
        },
        SessionsClosedBar: {
            id: "uuid",
            name: "string"
        },
        Sessions: {
            id: "string",
            eventId: "string",
            hawkerId: "string",
            hawkerName: "string",
            hawkerDocument: "string",
            cycleCount: "int",
            change: "money",
            receivedValue: "money",
            valueToReceive: "money",
            balance: "money",
            openedAt: "datetime",
            closedAt: "datetime?",
            usernames: "string[]",
            openedBar: "SessionsOpenedBar?",
            closedBar: "SessionsClosedBar?",
            hasCyclesClosedByDifferentCashier: "bool?",
            isClosedByDifferentCashier: "bool?"
        },
        CycleOpenedBar: {
            id: "uuid",
            name: "string"
        },
        CycleClosedBar: {
            id: "uuid",
            name: "string"
        },
        Cycle: {
            id: "string",
            sessionId: "string",
            eventId: "string",
            openedAt: "datetime",
            closedAt: "datetime?",
            closingValue: "money",
            receivedValue: "money",
            balance: "money",
            cashierIdOpener: "string",
            cashierNameOpener: "string",
            cashierUsernameOpener: "string",
            cashierIdCloser: "string?",
            cashierNameCloser: "string?",
            cashierUsernameCloser: "string?",
            openedBar: "CycleOpenedBar?",
            closedBar: "CycleClosedBar?"
        },
        CycleSummary: {
            canceled: "Sales[]",
            devolved: "Sales[]",
            released: "Sales[]",
            remained: "Sales[]",
            transacted: "Sales[]",
            paymentMethods: "HawkerPaymentMethod[]",
            total: "Sales[]"
        },
        HawkersSummary: {
            hawkerId: "string",
            hawkerName: "string",
            hawkerDocument: "string",
            total: "money",
            commission: "money?",
            usernames: "string[]"
        },
        EventSummary: {
            hawkerSummary: "HawkersSummary[]",
            quantityReleased: "int",
            totalReleased: "money"
        },
        HawkerReport: {
            sales: "Sales[]",
            total: "money"
        },
        Buyer: {
            name: "string",
            document: "string",
            paymentType: "PaymentType",
            total: "money"
        },
        TableReportBase: {
            tableId: "string",
            tableName: "string",
            employeeName: "string",
            numberOfSeats: "int",
            openedAt: "datetime",
            closedAt: "datetime?",
            discount: "money",
            refundValue: "money",
            totalValue: "money"
        },
        TableProduct: {
            imageUrl: "ImageUrl?",
            sku: "string",
            name: "string",
            quantity: "int",
            unitPrice: "money",
            subTotal: "money",
            discount: "money",
            total: "money"
        },
        TableReport: {
            tableId: "string",
            tableName: "string",
            employeeName: "string",
            numberOfSeats: "int",
            openedAt: "datetime",
            closedAt: "datetime?",
            discount: "money",
            refundValue: "money",
            totalValue: "money",
            userId: "uuid",
            eventId: "uuid",
            productsValue: "money?",
            tip: "money?",
            duration: "int?",
            buyers: "Buyer[]"
        },
        TableProductReport: {
            tableId: "string",
            tableName: "string",
            employeeName: "string",
            numberOfSeats: "int",
            openedAt: "datetime",
            closedAt: "datetime?",
            discount: "money",
            refundValue: "money",
            totalValue: "money",
            products: "TableProduct[]"
        },
        TableReportTotals: {
            totalSeats: "uint",
            totalTables: "uint",
            totalRevenue: "money",
            totalRefund: "money",
            averageDurationInMinutes: "uint"
        },
        GetTableReportResponse: {
            tables: "TableReport[]",
            totals: "TableReportTotals"
        },
        TablesReportTotals: {
            totalSeats: "uint",
            totalTables: "uint",
            totalRevenue: "money",
            totalRefund: "money",
            averageDurationInMinutes: "uint",
            openTables: "uint",
            peopleAverageTicket: "uint",
            tableAverageTicket: "uint",
            openTablesAverageTicket: "uint"
        },
        Filters: {
            status: "TableFilterStatusEnum?",
            tableNumbers: "string[]?",
            employeeIds: "string[]?"
        },
        TableReportV2: {
            tableId: "string",
            tableName: "string",
            employeeName: "string",
            numberOfSeats: "int",
            openedAt: "datetime",
            closedAt: "datetime?",
            discount: "money",
            refundValue: "money",
            totalValue: "money",
            userId: "uuid",
            eventId: "uuid",
            productsValue: "money?",
            tip: "money?",
            duration: "int?",
            checkoutBy: "MinimalEmployee?"
        },
        GetTablesReportV2Response: {
            tables: "TableReportV2[]",
            pagination: "PaginationResponse"
        },
        GetTablesMinimun: {
            id: "string",
            name: "string?",
            numbers: "string[]"
        },
        GetTablesReportPropsPlace: {
            id: "string",
            period: "PeriodTime"
        },
        GetTablesReportProps: {
            eventId: "string?",
            place: "GetTablesReportPropsPlace?"
        },
        GetPlaceZendeskTicketsFilters: {
            period: "PeriodTime?",
            status: "ZendeskTicketStatus[]?"
        },
        TicketStatus: {
            id: "string",
            name: "string"
        },
        ZendeskTicket: {
            id: "string",
            createdAt: "date?",
            updatedAt: "date?",
            requesterId: "string",
            type: "string",
            status: "TicketStatus",
            subject: "string",
            userName: "string",
            email: "string",
            phone: "string"
        },
        ZendeskTicketsPaginationResponse: {
            data: "ZendeskTicket[]",
            pagination: "BasePaginationResponse"
        },
        ListEmployeeZendeskTicketsFilters: {
            period: "PeriodTime?",
            status: "ZigTicketStatus[]?",
            search: "string?",
            placeIds: "string[]"
        },
        EmployeeZendeskTicket: {
            id: "string",
            createdAt: "datetime?",
            updatedAt: "datetime?",
            requesterId: "string",
            type: "string?",
            status: "ZigTicketStatus",
            subject: "string",
            userName: "string",
            placeName: "string?"
        },
        EmployeeZendeskTicketsPaginationResponse: {
            data: "EmployeeZendeskTicket[]",
            pagination: "BasePaginationResponse"
        },
        ZendeskAttachment: {
            id: "string",
            fileName: "string",
            contentUrl: "string",
            contentType: "string",
            size: "uint"
        },
        ZendeskMessage: {
            id: "string",
            body: "string?",
            authorName: "string",
            authorAvatarUrl: "string?",
            isRequester: "bool",
            createdAt: "datetime",
            attachments: "ZendeskAttachment[]"
        },
        ZendeskTicketDetails: {
            id: "string",
            subject: "string",
            status: "ZigTicketStatus",
            createdAt: "datetime",
            updatedAt: "datetime",
            closedAt: "datetime?",
            messages: "ZendeskMessage[]"
        },
        DeliveryRatePerRadius: {
            radius: "float",
            value: "float"
        },
        UpsertMenuConfigRequest: {
            name: "string?",
            primaryColor: "string",
            secondaryColor: "string",
            contrastColor: "string",
            isOpenStatusVisible: "bool",
            isWaitingTimeVisible: "bool",
            taxType: "MenuConfigsTaxType?",
            baseRateValue: "float?",
            ratePerKm: "float?",
            waitingTime: "int?",
            additionalFieldType: "MenuConfigsAdditionalFieldType?",
            postalCode: "string?",
            state: "string?",
            city: "string?",
            neighborhood: "string?",
            address: "string?",
            number: "string?",
            complement: "string?",
            logoImage: "bytes?",
            bannerImage: "bytes?"
        },
        UpsertMenuConfigResponse: {
            name: "string?",
            primaryColor: "string",
            secondaryColor: "string",
            contrastColor: "string",
            isOpenStatusVisible: "bool",
            isWaitingTimeVisible: "bool",
            taxType: "MenuConfigsTaxType?",
            baseRateValue: "float?",
            ratePerKm: "float?",
            waitingTime: "int?",
            additionalFieldType: "MenuConfigsAdditionalFieldType?",
            postalCode: "string?",
            state: "string?",
            city: "string?",
            neighborhood: "string?",
            address: "string?",
            number: "string?",
            complement: "string?",
            id: "uuid",
            logoImage: "string?",
            bannerImage: "string?"
        },
        GetActiveMenusResponse: {
            dineIn: "bool",
            delivery: "bool",
            onlineTab: "bool",
            onlinePostPayment: "bool",
            viewMenu: "bool"
        },
        GetRatePerRadiusResponse: {
            isOpenStatusVisible: "bool?",
            isWaitingTimeVisible: "bool?",
            waitingTime: "int?",
            taxType: "MenuConfigsTaxType?",
            baseRateValue: "float?",
            ratePerKm: "float?",
            deliveryRatePerRadius: "DeliveryRatePerRadius[]?"
        },
        WorkingPeriods: {
            dayOfWeek: "WeekDay",
            startTime: "string",
            endTime: "string"
        },
        GetWorkingPeriodsResponse: {
            days: "WeekDay[]",
            startTime: "string",
            endTime: "string"
        },
        PlaceSectorBars: {
            id: "string",
            name: "string"
        },
        PlaceSectorAccessPolicies: {
            id: "string",
            name: "string"
        },
        PlaceSector: {
            id: "string",
            name: "string",
            description: "string?",
            placeId: "string",
            createdAt: "datetime",
            createdBy: "string",
            updatedAt: "datetime",
            isDeleted: "bool",
            bars: "PlaceSectorBars[]",
            accessPolicies: "PlaceSectorAccessPolicies[]"
        },
        NewPlaceSector: {
            placeId: "string",
            name: "string",
            description: "string?",
            bars: "string[]"
        },
        EditPlaceSector: {
            name: "string?",
            description: "string?",
            bars: "string[]?",
            accessPolicies: "string[]?"
        },
        AccessPolicySector: {
            id: "string",
            name: "string"
        },
        AccessPolicy: {
            id: "string",
            placeId: "string",
            name: "string",
            sectors: "AccessPolicySector[]",
            startDate: "datetime",
            endDate: "datetime",
            allowMultipleAccess: "bool",
            createdAt: "datetime",
            createdBy: "string",
            updatedAt: "datetime",
            isDeleted: "bool"
        },
        NewAccessPolicy: {
            placeId: "string",
            name: "string",
            sectors: "string[]",
            startDate: "datetime",
            endDate: "datetime",
            allowMultipleAccess: "bool",
            tagIds: "string[]"
        },
        EditAccessPolicy: {
            name: "string?",
            sectors: "string[]?",
            startDate: "datetime?",
            endDate: "datetime?",
            allowMultipleAccess: "bool?"
        },
        AccessTag: {
            tagId: "string",
            accessPolicyId: "string",
            createdAt: "datetime"
        },
        FinancialEntryTypeGroupTypes: {
            id: "string",
            name: "string"
        },
        FinancialEntryTypeGroup: {
            id: "string",
            name: "string",
            types: "FinancialEntryTypeGroupTypes[]",
            total: "uint"
        },
        IfoodWebhookEventInputMetadata: {
            string: "string?"
        },
        IfoodWebhookEventInput: {
            id: "string",
            code: "IfoodEventCode",
            fullCode: "IfoodEventFullCode",
            orderId: "string?",
            merchantId: "string?",
            createdAt: "datetime?",
            merchantIds: "string[]?",
            metadata: "IfoodWebhookEventInputMetadata?"
        },
        IfoodWebhookEventOutput: {
            success: "bool",
            eventId: "string?",
            action: "string?",
            error: "string?",
            merchantIds: "string[]?"
        },
        IntegrationTokenCreatedBy: {
            id: "string",
            name: "string"
        },
        IntegrationToken: {
            id: "string",
            token: "string",
            createdBy: "IntegrationTokenCreatedBy",
            createdAt: "datetime",
            places: "Place[]",
            isDeleted: "bool"
        },
        EquipmentDetailByPlace: {
            equipmentId: "string",
            contractId: "string",
            contractNumber: "string",
            contractStatus: "string",
            serialNumber: "string?",
            equipmentType: "string",
            equipmentModel: "string?",
            quantity: "int",
            unitValue: "money"
        },
        EquipmentsByPlaceFilters: {
            organizationId: "string",
            placeId: "string",
            contractId: "string?",
            serialNumber: "string?",
            model: "string?",
            status: "string[]?"
        },
        EquipmentsByPlacePaginationParams: {
            page: "int?",
            limit: "int?"
        },
        ListEquipmentsByPlaceRequest: {
            filters: "EquipmentsByPlaceFilters",
            pagination: "EquipmentsByPlacePaginationParams?"
        },
        GetEquipmentsByPlaceToExcelRequest: {
            filters: "EquipmentsByPlaceFilters"
        },
        ListEquipmentsByPlaceResponsePagination: {
            currentPage: "int",
            perPage: "int",
            total: "int",
            lastPage: "int"
        },
        ListEquipmentsByPlaceResponse: {
            data: "EquipmentDetailByPlace[]",
            pagination: "ListEquipmentsByPlaceResponsePagination"
        },
        DeliverySimplifiedOrderIfoodScheduleSchedule: {
            deliveryDateTimeStart: "datetime",
            deliveryDateTimeEnd: "datetime"
        },
        DeliverySimplifiedOrderIfoodSchedule: {
            schedule: "DeliverySimplifiedOrderIfoodScheduleSchedule?",
            preparationStartDateTime: "datetime?"
        },
        DeliverySimplifiedOrder: {
            id: "string",
            reference: "uint",
            date: "datetime",
            status: "DeliveryOrderEventStatus",
            deliverySource: "DeliverySource",
            value: "uint",
            deliveryFee: "uint",
            discountValueDeliveryFee: "uint?",
            tip: "uint",
            deliveryType: "DeliveryType",
            customerName: "string",
            externalReference: "string?",
            cancellationReason: "string?",
            cancellationObs: "string?",
            ifoodSchedule: "DeliverySimplifiedOrderIfoodSchedule?",
            isPostPaid: "bool",
            discountValue: "uint?",
            orderFees: "OrderFee[]?",
            discountValueMarketplace: "uint?",
            subTotal: "uint",
            additionalFee: "uint?"
        },
        DeliverySimplifiedOrderPayload: {
            placeId: "string",
            status: "DeliveryOrderEventStatus[]?",
            paymentMethods: "DeliveryOrderPaymentMethod[]?",
            deliverySource: "DeliverySource[]?",
            deliveryType: "DeliveryType[]?"
        },
        DeliveryCustomerAddress: {
            city: "string",
            state: "string",
            number: "string",
            street: "string",
            country: "string",
            nickname: "string?",
            createdBy: "string?",
            stateAbbr: "string",
            complement: "string?",
            postalCode: "string",
            addressName: "string",
            mainAddress: "bool",
            neighborhood: "string",
            municipalityCode: "string?"
        },
        StoreAdditionalFieldAnswerValues: {
            id: "string",
            label: "string",
            value: "string"
        },
        PlaceAddress: {
            city: "string",
            state: "string",
            postalCode: "string",
            streetName: "string",
            addressNumber: "string",
            province: "string",
            complement: "string",
            uf: "string"
        },
        OrderDataCustomerAddress: {
            city: "string",
            state: "string",
            country: "string",
            complement: "string?",
            postalCode: "string",
            streetName: "string",
            neighborhood: "string",
            streetNumber: "string",
            formattedAddress: "string"
        },
        ManagerDeliveryOrderCustomer: {
            name: "string?",
            email: "string?",
            phone: "string?",
            isWhatsapp: "bool?",
            documentNumber: "string?",
            documentType: "ManagerDeliveryOrderCustomerDocumentType?",
            address: "OrderDataCustomerAddress?"
        },
        ManagerDeliveryOrderPlace: {
            id: "string",
            name: "string",
            address: "PlaceAddress"
        },
        ManagerDeliveryOrderMenu: {
            id: "string",
            name: "string"
        },
        ManagerDeliveryOrderPayment: {
            value: "uint",
            method: "PaymentMethod",
            brand: "string?",
            change: "uint?",
            partnerPaymentId: "string?"
        },
        ManagerDeliveryOrderItemsSubItems: {
            id: "string",
            sku: "string",
            name: "string",
            sectionId: "string?",
            sectionName: "string?",
            pricing: "ManagerDeliveryOrderItemsSubItemsPricing",
            price: "uint",
            count: "uint"
        },
        ManagerDeliveryOrderItems: {
            id: "string",
            sku: "string",
            name: "string",
            count: "uint",
            baseUnitPrice: "uint",
            totalUnitPrice: "uint",
            obs: "string?",
            subItems: "ManagerDeliveryOrderItemsSubItems[]"
        },
        ManagerDeliveryOrder: {
            id: "string",
            reference: "uint",
            obs: "string?",
            date: "datetime",
            customer: "ManagerDeliveryOrderCustomer",
            customerAddress: "DeliveryCustomerAddress?",
            value: "uint",
            discountValue: "uint",
            discountValueMarketplace: "uint?",
            discountValueDeliveryFee: "uint?",
            discountValueDeliveryFeeMarketplace: "uint?",
            subTotal: "uint",
            deliveryFee: "uint",
            tip: "uint",
            tipReceivedBy: "TipReceiver?",
            channel: "DeliveryChannel?",
            status: "DeliveryOrderEventStatus",
            deliverySource: "DeliverySource?",
            deliveryType: "DeliveryType",
            place: "ManagerDeliveryOrderPlace",
            menu: "ManagerDeliveryOrderMenu?",
            payment: "ManagerDeliveryOrderPayment?",
            items: "ManagerDeliveryOrderItems[]",
            additionalFields: "StoreAdditionalFieldAnswerValues[]?",
            externalReference: "string?",
            cancellationReason: "string?",
            cancellationObs: "string?",
            isPostPaid: "bool",
            additionalFee: "uint?",
            orderFees: "OrderFee[]?",
            needCutlery: "bool?",
            locator: "string?"
        },
        CreateManualOrderSubItem: {
            productId: "string",
            count: "uint"
        },
        CreateManualOrderSection: {
            sectionId: "string",
            products: "CreateManualOrderSubItem[]"
        },
        CreateManualOrderItem: {
            productId: "string",
            count: "uint",
            obs: "string?",
            sections: "CreateManualOrderSection[]"
        },
        CreateManualOrderAddress: {
            street: "string",
            number: "string",
            complement: "string?",
            neighborhood: "string",
            city: "string",
            state: "string",
            postalCode: "string",
            country: "string?"
        },
        CreateManualOrderCustomer: {
            name: "string",
            phone: "string?",
            email: "string?",
            isWhatsapp: "bool?",
            documentNumber: "string?",
            documentType: "CreateManualOrderCustomerDocumentType?",
            address: "CreateManualOrderAddress?"
        },
        CreateManualOrderPayload: {
            menuId: "string",
            deliveryType: "CreateManualOrderPayloadDeliveryType",
            customer: "CreateManualOrderCustomer",
            items: "CreateManualOrderItem[]",
            tip: "uint?",
            obs: "string?"
        },
        CreateManualOrderPixCharge: {
            chargeId: "string",
            emv: "string",
            qrCode: "string",
            value: "int",
            expiresIn: "int?"
        },
        CreateManualOrderResponse: {
            deliveryOrderId: "string",
            reference: "uint",
            pixCharge: "CreateManualOrderPixCharge"
        },
        CalculateDeliveryFeeResponse: {
            deliveryFee: "uint",
            distanceKm: "float",
            formattedAddress: "string"
        },
        UpsertDeliveryFeeConfigPayload: {
            taxType: "UpsertDeliveryFeeConfigPayloadTaxType",
            baseRateValue: "uint",
            ratePerKm: "uint",
            attendanceRadius: "uint"
        },
        DeliveryFeeConfigResponse: {
            taxType: "string",
            baseRateValue: "uint",
            ratePerKm: "uint",
            attendanceRadius: "uint"
        },
        GetURLAuthorizationResponse: {
            merchantAuthorizationUrl: "string"
        },
        MarketplaceOperationResponse: {
            success: "bool",
            message: "string?"
        },
        MarketplaceStore: {
            id: "string",
            placeId: "string",
            merchantId: "string?",
            name: "string?",
            isAuthorized: "bool",
            isActive: "bool",
            provider: "MarketplaceProvider",
            createdAt: "datetime"
        },
        GetAllMarketplaceIntegrationsGroupedByTypeResponse: {
            keeta: "MarketplaceStore[]",
            food99: "MarketplaceStore[]"
        },
        OpenDeliveryNewEventPayload: {
            eventId: "string",
            eventType: "string",
            orderId: "string",
            orderURL: "string",
            createdAt: "datetime",
            sourceAppId: "string?",
            virtualBrand: "string?"
        },
        OpenDeliveryWebhookResponse: {
            code: "int",
            message: "string",
            data: "json?"
        },
        PendingTransactionsFilters: {
            placeId: "uuid",
            transactionDateStart: "datetime?",
            transactionDateEnd: "datetime?",
            searchText: "string?",
            status: "PendingTransactionStatus[]?",
            vendorIds: "string[]?",
            paymentMethods: "AcquirerPaymentMethod[]?",
            pagination: "Pagination"
        },
        PendingTransactionPlace: {
            id: "uuid",
            name: "string"
        },
        PendingTransactionVendor: {
            id: "uuid",
            name: "string"
        },
        PendingTransaction: {
            id: "uuid",
            createdAt: "datetime",
            updatedAt: "datetime",
            isDeleted: "bool",
            transactionDate: "datetime",
            paymentMethod: "AcquirerPaymentMethod?",
            nsu: "string",
            deviceId: "string?",
            status: "PendingTransactionStatus",
            value: "int",
            barId: "uuid?",
            placeId: "uuid",
            vendorId: "uuid?",
            acquirer: "string?",
            cardBrand: "string?",
            eventId: "uuid",
            createdBy: "string",
            place: "PendingTransactionPlace",
            vendor: "PendingTransactionVendor?"
        },
        PaginatedPendingsTransactions: {
            data: "PendingTransaction[]",
            pagination: "PaginationResponse"
        },
        FilterOptionValue: {
            key: "string",
            value: "string"
        },
        FilterOption: {
            name: "string",
            values: "FilterOptionValue[]?",
            rawValue: "string?"
        },
        AcquirerPendingTransactionFilterOptionsResponse: {
            options: "FilterOption[]"
        },
        PlaceWizardStatus: {
            shouldShowOnboarding: "bool",
            step: "PlaceWizardStep?",
            isFinished: "bool?"
        },
        PlaceWizardBar: {
            id: "uuid",
            name: "string"
        },
        PlaceWizardSector: {
            id: "uuid",
            name: "string",
            bars: "PlaceWizardBar[]"
        },
        SavePlaceWizardBarsAndSectorsStepInput: {
            placeId: "uuid",
            bars: "PlaceWizardBar[]",
            sectors: "PlaceWizardSector[]"
        },
        PlaceWizardFeature: {
            id: "string",
            name: "string",
            isEditableByPlace: "bool",
            isActive: "bool",
            description: "string",
            warning: "string?",
            dependsOn: "string?",
            category: "string"
        },
        PlaceWizardFeatureWithChildren: {
            id: "string",
            name: "string",
            isEditableByPlace: "bool",
            isActive: "bool",
            description: "string",
            warning: "string?",
            dependsOn: "string?",
            category: "string",
            children: "PlaceWizardFeatureWithChildren[]"
        },
        PlaceWizardFeatureByCategory: {
            category: "string",
            features: "PlaceWizardFeatureWithChildren[]"
        },
        GetPlaceWizardBasicInformationStepResponse: {
            features: "PlaceWizardFeatureByCategory[]",
            operationalTypes: "OperationalType[]?"
        },
        SavePlaceWizardBasicInformationStepInput: {
            placeId: "uuid",
            operationalTypes: "OperationalType[]",
            placeFeaturesIds: "string[]"
        },
        GetPlaceWizardBarsAndSectorsStepResponse: {
            bars: "PlaceWizardBar[]",
            sectors: "PlaceWizardSector[]"
        },
        WizardProduct: {
            id: "string",
            name: "string",
            value: "money",
            imageUrl: "string?"
        },
        WizardCategory: {
            id: "string",
            name: "string",
            products: "WizardProduct[]"
        },
        WizardMenu: {
            id: "string",
            name: "string",
            categories: "WizardCategory[]",
            isDefault: "bool"
        },
        WizardBar: {
            id: "string",
            name: "string",
            productIds: "string[]",
            menuIds: "string[]"
        },
        GetPlaceWizardProductsAndMenusStepResponse: {
            bars: "WizardBar[]",
            menus: "WizardMenu[]"
        },
        SaveWizardProductInput: {
            id: "uuid",
            name: "string",
            value: "money",
            image: "EditProductImage?"
        },
        SaveWizardCategoryInput: {
            id: "uuid",
            name: "string",
            products: "SaveWizardProductInput[]"
        },
        SaveWizardMenuInput: {
            id: "uuid",
            name: "string",
            categories: "SaveWizardCategoryInput[]"
        },
        SaveWizardBarInput: {
            id: "uuid",
            name: "string",
            productIds: "uuid[]",
            menuIds: "uuid[]"
        },
        SavePlaceWizardProductsAndMenusStepInput: {
            placeId: "uuid",
            menus: "SaveWizardMenuInput[]",
            bars: "SaveWizardBarInput[]"
        },
        FeatureFlag: {
            id: "string",
            key: "string",
            description: "string?",
            defaultOn: "bool",
            enabled: "bool",
            createdAt: "datetime",
            updatedAt: "datetime"
        },
        OFXFile: {
            TRNTYPE: "OFXTypeTransaction",
            DTPOSTED: "string",
            TRNAMT: "int",
            FITID: "string",
            MEMO: "string"
        },
        OFXFileTransactionResponse: {
            value: "int",
            dateTransaction: "datetime?",
            description: "string",
            accountBillId: "string?",
            paymentType: "string?",
            status: "string?",
            typeTransaction: "OFXTypeTransaction",
            fitid: "string"
        },
        OFXFileHeaderResponse: {
            dateStart: "datetime",
            dateEnd: "datetime",
            status: "OFXFileHeaderResponseStatus",
            conciliationDate: "datetime?",
            currentValue: "int"
        },
        OFXFileBankInfo: {
            bankId: "string?",
            bankName: "string?",
            bankCode: "string?",
            branchCode: "string?",
            accountCode: "string?"
        },
        OFXFileResponse: {
            accountName: "string?",
            accountId: "string?",
            transactions: "OFXFileTransactionResponse[]",
            dateStart: "datetime",
            dateEnd: "datetime",
            status: "OFXFileHeaderResponseStatus",
            conciliationDate: "datetime?",
            currentValue: "int",
            bankId: "string?",
            bankName: "string?",
            bankCode: "string?",
            branchCode: "string?",
            accountCode: "string?"
        },
        BankInfo: {
            bank: "string?",
            agency: "string?",
            account: "string?",
            holder: "string?",
            purpose: "string?"
        },
        BackofficeBankConciliation: {
            bankAccountId: "string",
            initialPeriod: "datetime",
            finalPeriod: "datetime",
            status: "BackofficeBankConciliationStatus",
            conciliationDate: "datetime?",
            placeId: "string",
            currentBalance: "int",
            transactions: "BackofficeBankConciliationTransactions[]"
        },
        BackofficeBankConciliationResponse: {
            id: "string",
            bankAccountId: "string",
            initialPeriod: "datetime",
            finalPeriod: "datetime",
            status: "BackofficeBankConciliationStatus",
            conciliationDate: "datetime?",
            placeId: "string",
            transactions: "BackofficeBankConciliationTransactionsResponse[]"
        },
        BackofficeBankConciliationBankInfo: {
            id: "string",
            bankAccountId: "string",
            initialPeriod: "datetime",
            finalPeriod: "datetime",
            status: "BackofficeBankConciliationStatus",
            conciliationDate: "datetime?",
            placeId: "string",
            transactions: "BackofficeBankConciliationTransactionsResponse[]",
            bankInfo: "BankInfo?"
        },
        BackofficeBankConciliationResponseWithPagination: {
            data: "BackofficeBankConciliationBankInfo[]",
            pagination: "PaginationResponse"
        },
        BackofficeBankConciliationTransactions: {
            value: "int",
            date: "datetime",
            description: "string",
            accountBillId: "string?",
            paymentType: "string",
            status: "BackofficeBankConciliationTransactionsType",
            bankConciliationId: "string?",
            fitid: "string"
        },
        BackofficeBankConciliationTransactionsResponse: {
            id: "string?",
            value: "int",
            date: "datetime",
            description: "string",
            accountBillId: "string?",
            paymentType: "string",
            status: "BackofficeBankConciliationTransactionsType",
            bankConciliationId: "string?",
            fitid: "string",
            chartAccountName: "string?"
        },
        ReprintAuthorizedBy: {
            id: "string",
            name: "string"
        },
        ReprintProduct: {
            id: "string",
            name: "string",
            unitValue: "money"
        },
        ReprintEmployee: {
            id: "string",
            name: "string"
        },
        Reprint: {
            authorizedBy: "ReprintAuthorizedBy?",
            product: "ReprintProduct",
            transactionId: "string",
            date: "datetime",
            employee: "ReprintEmployee",
            deviceId: "string"
        },
        ReprintResumeAuthorizedBy: {
            id: "string",
            name: "string"
        },
        ReprintResume: {
            authorizedBy: "ReprintResumeAuthorizedBy?",
            qnt: "uint",
            totalValue: "money"
        },
        ProductRankingReportImage: {
            url: "string",
            sha256: "string"
        },
        ProductRankingReport: {
            id: "string",
            name: "string",
            image: "ProductRankingReportImage?",
            category: "string",
            categoryId: "string",
            unitValue: "uint",
            quantity: "uint",
            discount: "money",
            totalValue: "money"
        },
        EmployeeProductRankingReport: {
            id: "string",
            name: "string",
            username: "string?",
            avatar: "ImageUrl?",
            quantity: "uint",
            totalValue: "money"
        },
        SingleProductReturn: {
            productId: "string",
            employeeId: "string",
            authorizedBy: "string?",
            unitValue: "money",
            eventId: "uuid",
            placeId: "uuid",
            date: "datetime",
            barId: "string?",
            reason: "string?",
            sku: "string",
            productName: "string",
            categoryName: "string",
            categoryId: "uuid",
            employeeName: "string",
            employeeUsername: "string"
        },
        SingleProductReturnResponseProduct: {
            id: "uuid",
            name: "string",
            sku: "string",
            unitValue: "money"
        },
        SingleProductReturnResponseCategory: {
            id: "uuid",
            name: "string"
        },
        SingleProductReturnResponseEmployee: {
            id: "uuid",
            name: "string",
            username: "string"
        },
        SingleProductReturnResponse: {
            authorizedBy: "string?",
            eventId: "uuid",
            placeId: "uuid",
            date: "datetime",
            barId: "string?",
            reason: "string?",
            product: "SingleProductReturnResponseProduct",
            category: "SingleProductReturnResponseCategory",
            employee: "SingleProductReturnResponseEmployee"
        },
        BiPanel: {
            panelId: "string",
            organizationId: "string",
            placeIds: "string[]?",
            name: "string",
            chatEnabled: "bool"
        },
        BIWorkspace: {
            id: "string",
            name: "string",
            panels: "BiPanel[]"
        },
        BonusCategory: {
            id: "uuid",
            name: "string",
            daysToExpire: "uint",
            status: "bool",
            lockZigTag: "bool"
        },
        BonusCategoryCreateRequest: {
            placeId: "string",
            name: "string",
            daysToExpire: "uint",
            status: "bool",
            employeeIds: "uuid[]",
            categoryIds: "uuid[]?",
            productIds: "string[]?",
            lockZigTag: "bool?"
        },
        BonusCategoryUpdateRequest: {
            id: "string",
            name: "string",
            daysToExpire: "uint",
            status: "bool",
            employeeIds: "uuid[]",
            categoryIds: "uuid[]?",
            productIds: "string[]?",
            lockZigTag: "bool?"
        },
        BonusCategoryGetFilters: {
            name: "string"
        },
        CompleteBonusCategoryEmployees: {
            id: "uuid",
            name: "string"
        },
        CompleteBonusCategoryProducts: {
            id: "string",
            name: "string"
        },
        CompleteBonusCategoryCategories: {
            id: "uuid",
            name: "string"
        },
        CompleteBonusCategory: {
            id: "uuid",
            name: "string",
            daysToExpire: "uint",
            status: "bool",
            lockZigTag: "bool",
            employees: "CompleteBonusCategoryEmployees[]",
            products: "CompleteBonusCategoryProducts[]",
            categories: "CompleteBonusCategoryCategories[]"
        },
        BonusCategoryGetRequest: {
            placeId: "string",
            pagination: "Pagination",
            filters: "BonusCategoryGetFilters?"
        },
        BonusCategoryGetResponse: {
            data: "CompleteBonusCategory[]",
            pagination: "PaginationResponse"
        },
        BonusCategoryDeleteRequest: {
            bonusCategoryIds: "uuid[]"
        },
        BaseCashbackConfig: {
            name: "string?",
            isActive: "bool",
            percentage: "float",
            expiresIn: "uint?",
            expiresAt: "date?",
            placeIds: "string[]",
            minimumConsumption: "uint",
            shouldConsiderEntrance: "bool"
        },
        CashbackConfig: {
            id: "string",
            name: "string?",
            isActive: "bool",
            percentage: "float",
            expiresIn: "uint?",
            expiresAt: "date?",
            placeIds: "string[]",
            minimumConsumption: "uint",
            shouldConsiderEntrance: "bool"
        },
        CashbackConfigDataStatus: {
            key: "CashbackConfigDataStatusKey",
            translation: "string"
        },
        CashbackConfigData: {
            id: "string",
            name: "string?",
            createdAt: "datetime",
            expiresIn: "uint?",
            expiresAt: "date?",
            places: "MinimalEvent[]",
            messagesSent: "uint",
            isActive: "bool",
            status: "CashbackConfigDataStatus"
        },
        ListCashbackConfigs: {
            data: "CashbackConfigData[]",
            pagination: "PaginationResponse"
        },
        CashbackRescue: {
            id: "string",
            name: "string?",
            createdAt: "datetime",
            places: "MinimalEvent[]",
            messagesSent: "uint",
            rescues: "uint",
            totalValue: "uint",
            giftbackSent: "uint",
            giftbackValue: "uint",
            conversionRate: "uint"
        },
        ListCashbackRescues: {
            data: "CashbackRescue[]",
            pagination: "PaginationResponse"
        },
        ListCashbackRescuesOverview: {
            giftbacks: "uint",
            messagesSent: "uint",
            rescues: "uint",
            totalValue: "uint"
        },
        CdpUserSegment: {
            id: "string",
            name: "string"
        },
        CdpUserPlace: {
            id: "uuid",
            name: "string"
        },
        CdpUserRfmClassification: {
            classification: "RfmClassification",
            placeId: "uuid"
        },
        CdpUser: {
            userId: "uuid",
            document: "string",
            documentType: "UserDocumentType?",
            name: "string",
            phone: "string",
            phoneCity: "string?",
            email: "string?",
            gender: "Gender?",
            birthDate: "date?",
            country: "string?",
            remainingBalance: "money",
            totalPaidValue: "money",
            averageTicket: "money",
            presences: "uint",
            lastInteraction: "datetime",
            firstInteraction: "datetime",
            rfmClassifications: "CdpUserRfmClassification[]",
            allowCommunication: "bool",
            places: "CdpUserPlace[]",
            segments: "CdpUserSegment[]"
        },
        BaseCdpFilters: {
            userIds: "uuid[]?",
            eventIds: "uuid[]?",
            dateFrom: "date?",
            dateTo: "date?"
        },
        CdpUserFilters: {
            userIds: "uuid[]?",
            eventIds: "uuid[]?",
            dateFrom: "date?",
            dateTo: "date?",
            rfmClassifications: "RfmClassification[]?",
            segments: "string[]?",
            userDocument: "string?",
            remainingBalance: "money?",
            lastInteraction: "date?",
            allowCommunication: "bool?",
            sortBy: "CdpUserSortField?",
            sortDirection: "CdpSortDirection?"
        },
        CdpInteractionFilters: {
            userIds: "uuid[]?",
            eventIds: "uuid[]?",
            dateFrom: "date?",
            dateTo: "date?",
            types: "InteractionType[]?",
            minTotalPaidValue: "money?",
            maxTotalPaidValue: "money?",
            minAvaliation: "uint?",
            maxAvaliation: "uint?",
            productIds: "string[]?",
            categoryIds: "uuid[]?",
            categoryNames: "string[]?",
            productTypes: "ProductPurchaseType[]?"
        },
        CdpInteractionListFilters: {
            eventIds: "uuid[]?",
            dateFrom: "date?",
            dateTo: "date?",
            types: "InteractionType[]?",
            minAvaliation: "uint?",
            maxAvaliation: "uint?"
        },
        CdpProductPurchaseListFilters: {
            eventIds: "uuid[]?",
            dateFrom: "date?",
            dateTo: "date?",
            productIds: "string[]?",
            categoryIds: "uuid[]?",
            categoryNames: "string[]?",
            productTypes: "ProductPurchaseType[]?"
        },
        CdpInteraction: {
            id: "string",
            userId: "uuid",
            type: "InteractionType",
            date: "datetime",
            provider: "CdpInteractionProvider",
            eventId: "string?",
            placeId: "uuid?",
            organizationId: "string?",
            beginAt: "datetime?",
            totalPaidValue: "money",
            totalDiscountValue: "money",
            totalBonusValue: "money",
            hadDiscount: "bool",
            hadPromotion: "bool",
            npsSurveyAnswerId: "string?",
            npsSurveyGeneralAvaliation: "uint?",
            ticketOrderPaidValue: "money",
            ticketQuantity: "uint",
            channel: "CdpInteractionChannel?",
            communicationId: "string?",
            communicationChannel: "CdpInteractionCommunicationChannel?",
            communicationSubject: "CdpInteractionCommunicationSubject?",
            communicationContent: "string?",
            toSegmentId: "string?",
            toRfmClassification: "RfmClassification?"
        },
        CdpProductPurchase: {
            id: "string",
            interactionId: "string",
            productId: "string",
            systemProductId: "string",
            categoryId: "uuid",
            categoryName: "string",
            productName: "string",
            unitPrice: "money",
            quantity: "uint",
            totalValue: "money",
            totalDiscountValue: "money",
            wasSplitted: "bool",
            type: "ProductPurchaseType"
        },
        RfmDistribution: {
            classification: "RfmClassification",
            count: "uint"
        },
        SegmentDistribution: {
            segmentId: "string",
            count: "uint"
        },
        ProductCategoryDistribution: {
            categoryId: "string",
            categoryName: "string",
            totalQuantity: "uint",
            totalValue: "money",
            uniqueUsers: "uint",
            uniqueProducts: "uint"
        },
        FavoriteProduct: {
            userId: "uuid",
            productId: "string",
            productName: "string",
            categoryId: "string",
            categoryName: "string",
            totalQuantity: "uint",
            totalValue: "money",
            lastPurchaseDate: "datetime"
        },
        CdpMetrics: {
            averageLTV: "money",
            churnRate: "float",
            averageTicket: "money"
        },
        CdpUsersPage: {
            data: "CdpUser[]",
            pagination: "PaginationResponse"
        },
        CreateCdpPlaceRfmRuleInput: {
            placeId: "uuid",
            recencyScore5MaxInDays: "uint",
            recencyScore4MaxInDays: "uint",
            recencyScore3MaxInDays: "uint",
            recencyScore2MaxInDays: "uint",
            frequencyScore5MinByMonth: "float",
            frequencyScore4MinByMonth: "float",
            frequencyScore3MinByMonth: "float",
            frequencyScore2MinByMonth: "float",
            averageTicketScore5Min: "money",
            averageTicketScore4Min: "money",
            averageTicketScore3Min: "money",
            averageTicketScore2Min: "money",
            analysisPeriodDays: "uint"
        },
        CdpPlaceRfmRule: {
            placeId: "uuid",
            recencyScore5MaxInDays: "uint",
            recencyScore4MaxInDays: "uint",
            recencyScore3MaxInDays: "uint",
            recencyScore2MaxInDays: "uint",
            frequencyScore5MinByMonth: "float",
            frequencyScore4MinByMonth: "float",
            frequencyScore3MinByMonth: "float",
            frequencyScore2MinByMonth: "float",
            averageTicketScore5Min: "money",
            averageTicketScore4Min: "money",
            averageTicketScore3Min: "money",
            averageTicketScore2Min: "money",
            analysisPeriodDays: "uint",
            id: "uuid",
            syncedAt: "datetime?",
            updatedAt: "datetime"
        },
        UpdateCdpPlaceRfmRuleInput: {
            placeId: "uuid",
            recencyScore5MaxInDays: "uint",
            recencyScore4MaxInDays: "uint",
            recencyScore3MaxInDays: "uint",
            recencyScore2MaxInDays: "uint",
            frequencyScore5MinByMonth: "float",
            frequencyScore4MinByMonth: "float",
            frequencyScore3MinByMonth: "float",
            frequencyScore2MinByMonth: "float",
            averageTicketScore5Min: "money",
            averageTicketScore4Min: "money",
            averageTicketScore3Min: "money",
            averageTicketScore2Min: "money",
            analysisPeriodDays: "uint",
            id: "uuid"
        },
        CdpSegmentRules: {
            birthday: "CdpSegmentRulesBirthday?",
            gender: "Gender[]",
            minFrequencyInDays: "uint",
            minAvgTicket: "money",
            minTotalPaidValue: "money",
            minRemainingBalance: "money",
            rfmClassification: "RfmClassification?",
            minPresences: "uint",
            maxLastInteractionDays: "uint?"
        },
        CreateCdpOrganizationCustomSegmentInput: {
            name: "string",
            description: "string",
            rules: "CdpSegmentRules",
            analysisPeriodDays: "uint"
        },
        CdpOrganizationCustomSegment: {
            name: "string",
            description: "string",
            rules: "CdpSegmentRules",
            analysisPeriodDays: "uint",
            id: "uuid",
            syncedAt: "datetime?",
            updatedAt: "datetime"
        },
        UpdateCdpOrganizationCustomSegmentInput: {
            name: "string",
            description: "string",
            rules: "CdpSegmentRules",
            analysisPeriodDays: "uint",
            id: "uuid"
        },
        AgeGroup: {
            minAge: "uint",
            maxAge: "uint?",
            count: "uint"
        },
        AudienceMetricsByPeriod: {
            period: "string",
            date: "date",
            totalVisitors: "uint",
            previousPeriodVisitors: "uint",
            growthPercentage: "float",
            newClientsCount: "uint",
            recurringClientsCount: "uint",
            newClientsPercentage: "float",
            recurringClientsPercentage: "float",
            previousPeriodNewClientsCount: "uint",
            previousPeriodRecurringClientsCount: "uint"
        },
        AverageTicketMetricsByPeriod: {
            period: "string",
            date: "date",
            averageTicket: "money",
            previousPeriodAverageTicket: "money",
            variationPercentage: "float"
        },
        TpvMetricsByPeriod: {
            period: "string",
            date: "date",
            totalValue: "money",
            previousPeriodTotalValue: "money",
            variationPercentage: "float"
        },
        DashboardKpis: {
            totalVisitors: "uint",
            visitorsVariationPercentage: "float",
            averageTicket: "money",
            ticketVariationPercentage: "float",
            totalTpv: "money",
            tpvVariationPercentage: "float",
            activationRate: "float",
            previousActivationRate: "float",
            activationRateVariation: "float",
            newClientsInPeriod: "uint",
            activatedClients: "uint",
            reactivatedClients: "uint",
            previousReactivatedClients: "uint",
            reactivatedClientsVariation: "float",
            reactivationRate: "float",
            averageTimeBetweenVisits: "float",
            newClientsPercentage: "float",
            recurringClientsPercentage: "float"
        },
        DashboardKpisByPeriod: {
            period: "string",
            date: "date",
            totalVisitors: "uint",
            visitorsVariationPercentage: "float",
            averageTicket: "money",
            ticketVariationPercentage: "float",
            totalTpv: "money",
            tpvVariationPercentage: "float"
        },
        RfmDistributionByPeriod: {
            period: "string",
            date: "date",
            distributions: "RfmDistributionEnhanced[]"
        },
        InactiveClientsKpi: {
            inactiveDays: "uint",
            count: "uint"
        },
        ChurnRiskKpi: {
            classification: "RfmClassification",
            count: "uint"
        },
        TopRfmMetrics: {
            classification: "RfmClassification",
            count: "uint",
            averageTicket: "money",
            totalTpv: "money",
            percentageOfTotalTpv: "float"
        },
        DemographicDistributionGenderDistribution: {
            gender: "DemographicGender",
            count: "uint",
            percentage: "float"
        },
        DemographicDistribution: {
            genderDistribution: "DemographicDistributionGenderDistribution[]",
            ageDistribution: "AgeGroup[]"
        },
        RfmFrequencyDistribution: {
            classification: "RfmClassification",
            averageVisitsPerMonth: "float",
            totalClients: "uint"
        },
        ActivationRateMetrics: {
            activationRate: "float",
            previousActivationRate: "float",
            activationRateVariation: "float",
            newClientsInPeriod: "uint",
            activatedClients: "uint"
        },
        ActivationRateByPeriod: {
            period: "string",
            date: "datetime",
            activationRate: "float",
            newClientsInPeriod: "uint",
            activatedClients: "uint"
        },
        ReactivationMetrics: {
            reactivatedClients: "uint",
            previousReactivatedClients: "uint",
            reactivatedClientsVariation: "float",
            reactivationRate: "float"
        },
        AverageTimeBetweenVisitsMetricsByRfmClassification: {
            classification: "RfmClassification",
            averageTimeBetweenVisits: "float",
            totalClients: "uint"
        },
        AverageTimeBetweenVisitsMetrics: {
            averageTimeBetweenVisits: "float",
            byRfmClassification: "AverageTimeBetweenVisitsMetricsByRfmClassification[]"
        },
        RfmDistributionEnhanced: {
            classification: "RfmClassification",
            count: "uint",
            percentage: "float",
            averageTicket: "money",
            totalTpv: "money",
            percentageOfTotalTpv: "float"
        },
        SegmentDistributionEnhanced: {
            segmentId: "string",
            segmentName: "string",
            count: "uint",
            percentage: "float",
            averageTicket: "money",
            totalTpv: "money",
            percentageOfTotalTpv: "float"
        },
        RetentionRateByMonth: {
            month: "string",
            year: "uint",
            retentionRate: "float",
            clientsRetained: "uint",
            totalClientsPreviousMonth: "uint"
        },
        OccupancyRate: {
            period: "string",
            date: "date",
            averageOccupancy: "float",
            peakOccupancy: "float",
            capacity: "uint"
        },
        ValueMatrixPoint: {
            userId: "uuid",
            userName: "string",
            frequencyPerMonth: "float",
            averageTicket: "money",
            totalTpv: "money",
            rfmClassification: "RfmClassification",
            quadrant: "ValueMatrixPointQuadrant"
        },
        ValueMatrixDistributionCell: {
            frequencyBinIndex: "uint",
            ticketBinIndex: "uint",
            count: "uint"
        },
        ValueMatrixDistribution: {
            frequencyEdges: "float[]",
            ticketEdges: "money[]",
            heatmap: "ValueMatrixDistributionCell[]",
            totalClients: "uint"
        },
        RemainingBalanceKpi: {
            clientsWithBalance: "uint",
            totalBalance: "money",
            averageBalance: "money",
            percentageOfClients: "float"
        },
        CityDistribution: {
            city: "string",
            count: "uint",
            percentage: "float"
        },
        DashboardInsightData: {
            value1: "string?",
            value2: "string?",
            value3: "string?"
        },
        DashboardInsight: {
            type: "DashboardInsightType",
            message: "string",
            severity: "DashboardInsightSeverity",
            data: "DashboardInsightData?"
        },
        PeriodComparison: {
            currentPeriod: "PeriodTime",
            previousPeriod: "PeriodTime",
            totalVisitors: "uint",
            previousTotalVisitors: "uint",
            visitorsVariation: "float",
            totalTpv: "money",
            previousTotalTpv: "money",
            tpvVariation: "float",
            averageTicket: "money",
            previousAverageTicket: "money",
            ticketVariation: "float",
            newClients: "uint",
            previousNewClients: "uint",
            newClientsVariation: "float",
            recurringClients: "uint",
            previousRecurringClients: "uint",
            recurringClientsVariation: "float",
            activationRate: "float",
            previousActivationRate: "float",
            activationRateVariation: "float",
            reactivatedClients: "uint",
            previousReactivatedClients: "uint",
            reactivatedClientsVariation: "float"
        },
        RfmDistributionComparison: {
            classification: "RfmClassification",
            currentCount: "uint",
            previousCount: "uint",
            countVariation: "float",
            currentPercentage: "float",
            previousPercentage: "float",
            percentagePointsChange: "float"
        },
        SegmentDistributionComparison: {
            segmentId: "string",
            segmentName: "string",
            currentCount: "uint",
            previousCount: "uint",
            countVariation: "float",
            currentPercentage: "float",
            previousPercentage: "float",
            percentagePointsChange: "float"
        },
        DashboardNotificationList: {
            id: "uuid",
            classification: "DashboardNotificationClassificationEnum",
            title: "string",
            description: "string",
            tags: "DashboardNotificationTagsEnum[]?",
            createdAt: "datetime",
            permissions: "string[]"
        },
        DashboardNotificationPaginated: {
            data: "DashboardNotificationList[]",
            pagination: "PaginationResponse"
        },
        EmployeeTipReport: {
            id: "uuid",
            name: "string",
            username: "string",
            total: "int",
            extraTip: "int?",
            cashTotal: "int",
            debitTotal: "int",
            creditTotal: "int",
            pixTotal: "int",
            bonusTotal: "int",
            appTotal: "int"
        },
        EmployeeTipReportFilters: {
            employeeIds: "string[]?"
        },
        BaseReportActionsTransactionType: {
            id: "string",
            name: "string"
        },
        BaseReportActions: {
            id: "string",
            createdAt: "datetime",
            syncedAt: "datetime",
            employee: "MinimalEmployee",
            value: "uint",
            transactionType: "BaseReportActionsTransactionType?",
            paymentMethod: "PaymentMethodWithCashlessAndBonus[]"
        },
        ReportActionsFromEventProducts: {
            name: "string",
            count: "uint",
            value: "uint"
        },
        ReportActionsFromEventUser: {
            cpf: "string?",
            name: "string?"
        },
        ReportActionsFromEvent: {
            id: "string",
            createdAt: "datetime",
            syncedAt: "datetime",
            employee: "MinimalEmployee",
            value: "uint",
            transactionType: "BaseReportActionsTransactionType?",
            paymentMethod: "PaymentMethodWithCashlessAndBonus[]",
            products: "ReportActionsFromEventProducts[]",
            user: "ReportActionsFromEventUser[]"
        },
        FiltersActionsFromEvent: {
            employeeIds: "string[]?",
            transactionTypeIds: "string[]?",
            transactionId: "string?"
        },
        ReportActionsFromEventResponse: {
            data: "ReportActionsFromEvent[]",
            pagination: "PaginationResponse"
        },
        ReportActionsFromEventOrPlaceTransactionType: {
            id: "string",
            name: "string"
        },
        ReportActionsFromEventOrPlaceUsersAcquirerTransaction: {
            acquirer: "string?",
            id: "string?",
            brand: "string?",
            nsu: "string?",
            nsuHost: "string?",
            authorizationCode: "string?",
            bin: "string?"
        },
        ReportActionsFromEventOrPlaceUsers: {
            id: "string",
            cpf: "string",
            name: "string",
            zigCode: "string?",
            acquirerTransaction: "ReportActionsFromEventOrPlaceUsersAcquirerTransaction?"
        },
        ReportActionsFromEventOrPlaceBar: {
            id: "string",
            name: "string"
        },
        ReportActionsFromEventOrPlaceHawker: {
            id: "string",
            name: "string",
            document: "string"
        },
        ReportActionsFromEventOrPlace: {
            id: "string",
            createdAt: "datetime",
            syncedAt: "datetime",
            employee: "MinimalEmployee?",
            value: "uint",
            transactionType: "ReportActionsFromEventOrPlaceTransactionType",
            paymentMethod: "PaymentMethodWithCashlessAndBonus[]",
            users: "ReportActionsFromEventOrPlaceUsers[]",
            deviceId: "string?",
            terminal: "string?",
            bar: "ReportActionsFromEventOrPlaceBar?",
            status: "string",
            hawker: "ReportActionsFromEventOrPlaceHawker?",
            productId: "string?",
            productName: "string?",
            productCount: "uint?",
            paidInOtherEvent: "bool"
        },
        FiltersActionsFromEventOrPlace: {
            terminals: "string[]?",
            userDocuments: "string[]?",
            employeeNames: "string[]?",
            zigCodes: "string[]?",
            paymentMethods: "string[]?",
            transactionTypeIds: "string[]?",
            barIds: "string[]?",
            since: "datetime?",
            until: "datetime?"
        },
        FiltersValuesForTransactionsReportTransactionTypes: {
            id: "string",
            name: "string"
        },
        FiltersValuesForTransactionsReport: {
            paymentMethods: "string[]",
            transactionTypes: "FiltersValuesForTransactionsReportTransactionTypes[]",
            barIds: "string[]"
        },
        TransactionReportLink: {
            id: "string",
            createdAt: "datetime",
            updatedAt: "datetime",
            employee: "MinimalEmployee",
            email: "string",
            status: "TransactionReportLinkStatus",
            fileUrl: "string?",
            since: "datetime",
            until: "datetime",
            eventId: "string?"
        },
        HawkerCashierReleasedProduct: {
            id: "uuid",
            name: "string",
            count: "uint",
            value: "money",
            total: "money"
        },
        HawkerCashierPayment: {
            method: "string",
            value: "money"
        },
        HawkerCashierAdjustment: {
            id: "uuid",
            date: "datetime",
            value: "money",
            type: "HawkerCashierAdjustmentType"
        },
        HawkerCashierHawkerClosing: {
            id: "uuid",
            date: "datetime",
            value: "money",
            type: "HawkerCashierHawkerClosingType"
        },
        HawkerCashierFinancialSummary: {
            changeFundsValue: "money",
            bleedingsValue: "money",
            cyclesReceivedValue: "money",
            sessionsReceivedValue: "money",
            cashValue: "money",
            valueWithCashier: "money",
            cashierDiffValue: "money",
            commissionsValue: "money"
        },
        HawkerCashierClosing: {
            id: "uuid",
            name: "string",
            document: "string",
            openedAt: "datetime",
            closedAt: "datetime",
            diffValue: "money",
            logins: "string[]"
        },
        BaseHawkerTransactionsFilters: {
            eventTypes: "HawkerTransactionType[]?",
            hawkerName: "string[]?",
            hawkerDocument: "string[]?",
            employeeIds: "string[]?",
            employeeLogin: "string[]?",
            hawkerCashierName: "string[]?",
            hawkerCashierDocument: "string[]?",
            cashierEmployeeLogin: "string[]?",
            since: "datetime?",
            until: "datetime?",
            barName: "string[]?",
            cycleId: "uuid[]?",
            productName: "string[]?",
            hawkerSessionId: "string[]?"
        },
        HawkerTransactionsFilters: {
            eventTypes: "HawkerTransactionType[]?",
            hawkerName: "string[]?",
            hawkerDocument: "string[]?",
            employeeIds: "string[]?",
            employeeLogin: "string[]?",
            hawkerCashierName: "string[]?",
            hawkerCashierDocument: "string[]?",
            cashierEmployeeLogin: "string[]?",
            since: "datetime?",
            until: "datetime?",
            barName: "string[]?",
            cycleId: "uuid[]?",
            productName: "string[]?",
            hawkerSessionId: "string[]?"
        },
        HawkerTransactionsPlaceFilters: {
            eventTypes: "HawkerTransactionType[]?",
            hawkerName: "string[]?",
            hawkerDocument: "string[]?",
            employeeIds: "string[]?",
            employeeLogin: "string[]?",
            hawkerCashierName: "string[]?",
            hawkerCashierDocument: "string[]?",
            cashierEmployeeLogin: "string[]?",
            since: "datetime",
            until: "datetime",
            barName: "string[]?",
            cycleId: "uuid[]?",
            productName: "string[]?",
            hawkerSessionId: "string[]?"
        },
        HawkerTransaction: {
            id: "string?",
            eventType: "string?",
            hawkerName: "string?",
            hawkerDocument: "string?",
            barId: "string?",
            barName: "string?",
            employeeId: "string?",
            employeeLogin: "string?",
            cashierEmployeeLogin: "string?",
            paymentMethod: "string?",
            paymentValue: "uint?",
            date: "datetime?",
            productId: "string?",
            productName: "string?",
            isCancelled: "bool?",
            quantity: "uint?",
            amount: "money?",
            sessionId: "string?",
            cycleId: "string?",
            cashierId: "string?",
            cashierName: "string?",
            cashierDocument: "string?",
            deviceId: "string?",
            terminalSerialNumber: "string?",
            discount: "money?",
            productTotal: "money?",
            totalValue: "money?",
            commission: "money?",
            closingBalance: "money?"
        },
        HawkerTransactionPlace: {
            id: "string?",
            eventType: "string?",
            hawkerName: "string?",
            hawkerDocument: "string?",
            barId: "string?",
            barName: "string?",
            employeeId: "string?",
            employeeLogin: "string?",
            cashierEmployeeLogin: "string?",
            paymentMethod: "string?",
            paymentValue: "uint?",
            date: "datetime?",
            productId: "string?",
            productName: "string?",
            isCancelled: "bool?",
            quantity: "uint?",
            amount: "money?",
            sessionId: "string?",
            cycleId: "string?",
            cashierId: "string?",
            cashierName: "string?",
            cashierDocument: "string?",
            deviceId: "string?",
            terminalSerialNumber: "string?",
            discount: "money?",
            productTotal: "money?",
            totalValue: "money?",
            commission: "money?",
            closingBalance: "money?",
            eventId: "string",
            eventName: "string"
        },
        KdsBar: {
            id: "string",
            name: "string"
        },
        KdsProductScreen: {
            productId: "string"
        },
        KdsScreen: {
            id: "string",
            name: "string",
            type: "KdsScreenType",
            productsScreen: "KdsProductScreen[]"
        },
        ZigBar: {
            id: "string",
            name: "string"
        },
        Kds: {
            id: "string",
            ninegridKdsId: "uint?",
            name: "string",
            createdAt: "datetime",
            bar: "KdsBar?",
            link: "string?",
            type: "KdsType",
            provider: "string",
            screens: "KdsScreen[]",
            zigBars: "ZigBar[]"
        },
        KdsFilters: {
            search: "string?"
        },
        KdsCard: {
            showOrder: "bool",
            showIntegration: "bool",
            showClient: "bool"
        },
        KdsDetails: {
            id: "uint",
            name: "string",
            statusChange: "bool",
            timeManagement: "bool",
            readyTimeOrder: "uint",
            standardTimeOrder: "uint",
            bar: "KdsBar?",
            card: "KdsCard"
        },
        KdsRequest: {
            barId: "string",
            name: "string",
            statusChange: "bool",
            timeManagement: "bool",
            readyTimeOrder: "uint",
            standardTimeOrder: "uint",
            card: "KdsCard?"
        },
        ReportDateRange: {
            dateStart: "datetime",
            dateEnd: "datetime"
        },
        KdsProductionBySectorReport: {
            sectorName: "string",
            time: "string",
            timeSeconds: "uint"
        },
        KdsProductionByProductReport: {
            productName: "string",
            time: "string",
            timeSeconds: "uint"
        },
        KdsIntegration: {
            name: "string"
        },
        KdsProduct: {
            code: "string",
            product: "string",
            quantity: "string",
            productionSector: "string",
            preparationTime: "string"
        },
        KdsOrder: {
            customer: "string",
            orderId: "uint",
            notes: "string",
            datetimeOrder: "datetime",
            locationOrderName: "string",
            statusName: "string",
            integration: "KdsIntegration",
            products: "KdsProduct[]"
        },
        KdsAverageProductionTimeByHour: {
            hour: "uint",
            time: "string",
            timeSeconds: "uint"
        },
        EditKdsRequest: {
            barIds: "string[]",
            name: "string"
        },
        CreateKdsScreenResponse: {
            id: "string",
            name: "string"
        },
        KdsProductBar: {
            productId: "string",
            barId: "string"
        },
        NewMenu: {
            name: "string",
            type: "MenuType",
            productIds: "string[]",
            barsIds: "string[]?",
            allowFichaExport: "bool"
        },
        BaseEditMenuItem: {
            id: "string",
            action: "EditMenuItemAction"
        },
        EditMenu: {
            name: "string",
            type: "MenuType",
            productsToEdit: "BaseEditMenuItem[]?",
            barsToEdit: "BaseEditMenuItem[]?",
            allowFichaExport: "bool"
        },
        MenuProduct: {
            productId: "string",
            name: "string",
            isActive: "bool",
            price: "uint",
            proportionalValue: "ProportionalValue?",
            hasMountable: "bool",
            image: "ImageUrl?",
            sku: "string?"
        },
        MenuCategory: {
            id: "string",
            name: "string",
            description: "string?",
            printOrder: "uint?",
            priority: "uint",
            image: "ImageUrl?",
            parentId: "string?",
            menuCategoryId: "uuid",
            products: "MenuProduct[]"
        },
        Menu: {
            id: "uuid",
            name: "string",
            type: "MenuType",
            isDefault: "bool",
            isActive: "bool",
            categories: "MenuCategory[]",
            productsCount: "int?"
        },
        BaseBarInfo: {
            id: "string",
            name: "string"
        },
        BaseCategoryInfo: {
            id: "string",
            name: "string"
        },
        BaseMenu: {
            id: "string",
            name: "string",
            type: "MenuType",
            isDefault: "bool",
            isActive: "bool"
        },
        MenuList: {
            id: "string",
            name: "string",
            type: "MenuType",
            isDefault: "bool",
            isActive: "bool",
            productsCount: "int",
            bars: "BaseBarInfo[]?"
        },
        MenuDetails: {
            id: "string",
            name: "string",
            type: "MenuType",
            isDefault: "bool",
            isActive: "bool",
            productsCount: "int",
            categories: "BaseCategoryInfo[]?",
            bars: "BaseBarInfo[]?",
            allowFichaExport: "bool?"
        },
        MenuProductFilters: {
            isActive: "bool?",
            name: "string?"
        },
        BaseMenuProduct: {
            id: "string",
            name: "string",
            description: "string?",
            sku: "string",
            image: "ImageUrl?"
        },
        MenuProducts: {
            id: "string",
            name: "string",
            description: "string?",
            sku: "string",
            image: "ImageUrl?",
            price: "uint",
            hasMountable: "bool",
            categoryId: "string",
            categoryName: "string",
            isActive: "bool",
            proportionalValue: "ProportionalValue?"
        },
        AddableMenuProduct: {
            id: "string",
            name: "string",
            description: "string?",
            sku: "string",
            image: "ImageUrl?",
            isBeingUsed: "bool"
        },
        EditProduct: {
            isActive: "bool?",
            price: "uint?"
        },
        NewEditProduct: {
            productId: "uuid",
            isActive: "bool?",
            price: "uint?"
        },
        CreateProductRequest: {
            name: "string",
            category: "string",
            hasAlcohol: "bool",
            description: "string?",
            fiscalData: "NewPlaceProductFiscalData?",
            value: "uint?",
            proportionalValue: "ProportionalValue?",
            fiscalCode: "string?",
            kindKey: "string",
            menuCategory: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            image: "EditProductImage?",
            externalId: "string?",
            externalStoreId: "string?",
            preparationTime: "uint?",
            systemProductId: "string?"
        },
        ProductMountableSectionItem: {
            isActive: "bool",
            storageCount: "uint",
            name: "string?",
            price: "uint",
            maxCount: "uint?",
            selectedCount: "uint?",
            product: "CreateProductRequest"
        },
        ProductMountableSection: {
            title: "string",
            min: "uint",
            max: "uint",
            pricing: "ProductMountableSectionPricing",
            items: "ProductMountableSectionItem[]"
        },
        CreateProductWithSectionsRequest: {
            name: "string",
            category: "string",
            hasAlcohol: "bool",
            description: "string?",
            fiscalData: "NewPlaceProductFiscalData?",
            value: "uint?",
            proportionalValue: "ProportionalValue?",
            fiscalCode: "string?",
            kindKey: "string",
            menuCategory: "string?",
            basicStorageUnit: "BasicStorageUnit?",
            isHiddenFromApp: "bool?",
            beerProduct: "BeerProduct?",
            yieldPercentage: "float?",
            isReturnableProduct: "bool?",
            isStockable: "bool?",
            releaseValue: "money?",
            image: "EditProductImage?",
            externalId: "string?",
            externalStoreId: "string?",
            preparationTime: "uint?",
            systemProductId: "string?",
            sections: "ProductMountableSection[]"
        },
        CreateMenuWithProductsRequest: {
            name: "string",
            type: "MenuType",
            deliveryIntegratedType: "ExternalStoreIntegrationType?",
            products: "CreateProductWithSectionsRequest[]",
            allowFichaExport: "bool"
        },
        CreateMenuWithProductsResponse: {
            id: "uuid",
            name: "string",
            type: "MenuType",
            deliveryIntegratedType: "ExternalStoreIntegrationType?",
            productsCount: "int?"
        },
        UpdateMenuAndExternalProductRequest: {
            productId: "string",
            menuId: "uuid",
            price: "uint",
            externalStoreId: "string",
            externalProductId: "string",
            externalProductOptionId: "string?",
            externalProductSku: "string?",
            externalProductSections: "ProductMountableSection[]?"
        },
        ReImportIfoodProductRequest: {
            productId: "uuid",
            menuId: "uuid",
            price: "uint",
            sections: "ProductMountableSection[]"
        },
        LinkSyncedProductToDeliveryMenuRequest: {
            productId: "uuid",
            price: "uint"
        },
        ProductToRemoveFromExternalStore: {
            productId: "string",
            externalProductId: "string",
            externalProductOptionId: "string?"
        },
        GetMenusRequest: {
            name: "string?"
        },
        GetDeliveryIntegratedMenuResponse: {
            id: "uuid",
            name: "string",
            type: "MenuType",
            isDefault: "bool",
            isActive: "bool",
            deliveryIntegratedType: "ExternalStoreIntegrationType",
            createdAt: "datetime",
            numberOfProducts: "uint",
            numberOfNotSyncedProducts: "uint",
            numberOfNotImportedProducts: "uint"
        },
        GetDeliveryIntegratedMenusResponse: {
            items: "GetDeliveryIntegratedMenuResponse[]",
            pagination: "PaginationResponse"
        },
        ReportFilters: {
            tableNumbers: "string[]?"
        },
        ReportHeader: {
            currentValue: "money",
            previousValue: "money"
        },
        TableReportBaseV2: {
            number: "string[]",
            name: "string",
            ids: "string[]",
            eventId: "string",
            eventBeginAt: "datetime"
        },
        TableProfitReport: {
            number: "string[]",
            name: "string",
            ids: "string[]",
            eventId: "string",
            eventBeginAt: "datetime",
            value: "money",
            tipValue: "money",
            total: "money"
        },
        TablePeopleServedReport: {
            number: "string[]",
            name: "string",
            ids: "string[]",
            eventId: "string",
            eventBeginAt: "datetime",
            clientsAtTable: "uint"
        },
        TableValueBaseReport: {
            number: "string[]",
            name: "string",
            ids: "string[]",
            eventId: "string",
            eventBeginAt: "datetime",
            value: "money"
        },
        TableReportResponse: {
            header: "ReportHeader",
            data: "TableValueBaseReport[]"
        },
        TableEmployeeSaleRankingReport: {
            id: "string",
            name: "string",
            username: "string?",
            avatar: "ImageUrl?",
            totalSoldValue: "money",
            mediumValue: "money",
            openedTables: "uint"
        },
        TableProductSoldRankingReport: {
            id: "string",
            name: "string",
            totalSoldValue: "money",
            totalCount: "uint"
        },
        MesaStatusConfiguration: {
            id: "uuid",
            msFromLastInteraction: "uint",
            backgroundColor: "string",
            detailColor: "string",
            textColor: "string"
        },
        MesaStatusConfigurationReturn: {
            id: "uuid?",
            msFromLastInteraction: "uint",
            backgroundColor: "string",
            detailColor: "string",
            textColor: "string"
        },
        CreateStatusConfiguration: {
            msFromLastInteraction: "uint",
            backgroundColor: "string",
            detailColor: "string",
            textColor: "string"
        },
        EmployeeCardsCreatedBy: {
            id: "string",
            name: "string",
            username: "string"
        },
        EmployeeCardsPermissions: {
            id: "string",
            name: "string"
        },
        EmployeeCards: {
            createdAt: "datetime",
            createdBy: "EmployeeCardsCreatedBy",
            id: "string",
            name: "string",
            username: "string?",
            zigDeviceId: "string",
            uid: "string",
            permissions: "EmployeeCardsPermissions[]",
            status: "EmployeeCardsStatuses"
        },
        EmployeeCardsPaginationPagination: {
            currentPage: "int",
            lastPage: "int",
            perPage: "int",
            total: "int"
        },
        EmployeeCardsPagination: {
            data: "EmployeeCards[]",
            pagination: "EmployeeCardsPaginationPagination"
        },
        CardHistory: {
            createdAt: "datetime",
            deviceId: "string",
            employeeCardPasswordId: "string?",
            id: "uuid",
            name: "string",
            offlineActionId: "string?",
            type: "string?",
            uid: "string",
            price: "uint?",
            employeeName: "string?",
            employeeUsername: "string?",
            sourceIds: "string[]"
        },
        CardHistoryPaginationPagination: {
            currentPage: "int",
            lastPage: "int",
            perPage: "int",
            total: "int"
        },
        CardHistoryPagination: {
            data: "CardHistory[]",
            pagination: "CardHistoryPaginationPagination"
        },
        PendingOnlineRechargeValue: {
            date: "date",
            value: "money"
        },
        PendingOnlineRechargeResume: {
            gender: "PendingOnlineRechargeResumeGender",
            qnt: "uint",
            value: "money",
            bonus: "money",
            refundedValue: "money",
            retrievedValue: "money",
            createdAt: "datetime"
        },
        PendingOnlineRechargeByDateData: {
            date: "string",
            topUpQuantity: "uint",
            maleQuantity: "uint",
            maleValue: "money",
            femaleQuantity: "uint",
            femaleValue: "money",
            otherQuantity: "uint",
            otherValue: "money",
            redeemedQuantity: "uint",
            accumulatedValue: "money",
            redeemedValue: "money",
            usedValue: "money",
            bonusValue: "money"
        },
        PendingOnlineRechargeReportCardsGender: {
            male: "float",
            female: "float",
            other: "float"
        },
        PendingOnlineRechargeReportCards: {
            redeemedTopUp: "float",
            topUpUsed: "float",
            averageTicketOfGivenTopUps: "money",
            averageRedeemedPerDay: "money",
            gender: "PendingOnlineRechargeReportCardsGender"
        },
        PendingOnlineRechargeReportTotalizer: {
            accumulatedValueTotal: "money",
            redeemedValueTotal: "money",
            usedValueTotal: "money",
            topUpQuantityTotal: "uint",
            maleQuantityTotal: "uint",
            maleValueTotal: "money",
            femaleQuantityTotal: "uint",
            femaleValueTotal: "money",
            otherQuantityTotal: "uint",
            otherValueTotal: "money",
            redeemedQuantityTotal: "uint",
            bonusValueTotal: "money"
        },
        PendingOnlineRechargeReport: {
            cards: "PendingOnlineRechargeReportCards",
            totalizer: "PendingOnlineRechargeReportTotalizer",
            rows: "PendingOnlineRechargeByDateData[]"
        },
        PendingPlaceContractsEquipments: {
            type: "string",
            unitValue: "int",
            quantity: "int"
        },
        PendingPlaceContractsContractFiles: {
            url: "string"
        },
        PendingPlaceContracts: {
            id: "string",
            requestType: "string",
            equipments: "PendingPlaceContractsEquipments[]",
            contractFiles: "PendingPlaceContractsContractFiles[]"
        },
        ListPendingPlaceContracts: {
            contracts: "PendingPlaceContracts[]",
            contactEmails: "string[]"
        },
        PlaceContractsListRequestType: {
            id: "string",
            name: "string"
        },
        PlaceContractsListContractFiles: {
            url: "string"
        },
        PlaceContractsList: {
            id: "string",
            requestDate: "date",
            signatureDate: "date?",
            requestType: "PlaceContractsListRequestType",
            signedBy: "MinimalEmployee?",
            managerId: "string",
            managerName: "string",
            status: "string",
            contractFiles: "PlaceContractsListContractFiles[]"
        },
        PlaceContractListPaginated: {
            data: "PlaceContractsList[]",
            pagination: "PaginationResponse"
        },
        PlaceContractListFilters: {
            statuses: "string[]?",
            requestDatePeriod: "PeriodTime?"
        },
        PlaceContractContractFiles: {
            url: "string"
        },
        PlaceContractRequestType: {
            id: "string",
            name: "string"
        },
        PlaceContractRequestModel: {
            id: "string",
            name: "string"
        },
        PlaceContract: {
            contractFiles: "PlaceContractContractFiles[]",
            contractPeriod: "PeriodTime?",
            equipments: "PlaceContractEquipments[]",
            managerContact: "PlaceContractManagerContact",
            managerId: "string",
            managerName: "string",
            requestDate: "date",
            requestType: "PlaceContractRequestType",
            requestModel: "PlaceContractRequestModel",
            status: "string"
        },
        RechargeManagementUser: {
            id: "string",
            name: "string",
            cpf: "string",
            documentType: "string"
        },
        RechargeManagementAuthor: {
            id: "string",
            name: "string"
        },
        RechargeManagementValidPlaces: {
            id: "string",
            name: "string"
        },
        RechargeManagement: {
            id: "string",
            user: "RechargeManagementUser",
            method: "string?",
            type: "RechargeManagementType",
            bonusType: "RechargeManagementBonusType?",
            author: "RechargeManagementAuthor",
            status: "RechargeManagementStatus",
            date: "datetime",
            totalValue: "uint",
            usedValue: "uint",
            expiresAt: "datetime?",
            validPlaces: "RechargeManagementValidPlaces[]?",
            rechargeType: "RechargeManagementRechargeType"
        },
        EmployeesFilter: {
            id: "string",
            name: "string"
        },
        RechargeFilters: {
            employees: "EmployeesFilter[]",
            status: "RechargeStatusEnum[]"
        },
        RechargesPaginated: {
            data: "RechargeManagement[]",
            pagination: "PaginationResponse"
        },
        RechargeRequestFilters: {
            eventId: "string?",
            placeId: "string?",
            employeeId: "string?",
            cpf: "string?",
            since: "datetime?",
            until: "datetime?",
            status: "RechargeStatusEnum?",
            order: "OrderEnum?"
        },
        CampaignProductType: {
            productId: "string",
            quantity: "uint"
        },
        WinnersType: {
            position: "uint",
            value: "uint"
        },
        CampaignRequest: {
            name: "string",
            sponsors: "string?",
            beginAt: "datetime",
            endAt: "datetime",
            type: "CampaignType",
            organizationId: "uuid",
            products: "CampaignProductType[]?",
            placesIds: "uuid[]",
            winnerQuantity: "WinnersType[]?",
            paymentType: "CampaignsPaymentType",
            target: "uint",
            targetPrizeValue: "uint?"
        },
        CampaignResponse: {
            id: "string",
            name: "string",
            sponsors: "string?",
            beginAt: "datetime",
            endAt: "datetime",
            type: "CampaignType",
            status: "StatusType",
            createdAt: "datetime",
            createdBy: "MinimalEmployee",
            updatedAt: "datetime",
            updatedBy: "MinimalEmployee?",
            products: "CampaignProductType[]?",
            placesIds: "uuid[]",
            winnerQuantity: "WinnersType[]?",
            paymentType: "CampaignsPaymentType?",
            target: "uint",
            targetPrizeValue: "uint?"
        },
        CampaignResponseFilters: {
            name: "string",
            id: "string"
        },
        CampaignTotalsReponse: {
            activeCampaigns: "uint",
            scheduledCampaigns: "uint",
            completedCampaigns: "uint",
            totalOnSale: "uint"
        },
        CampaignFilters: {
            status: "StatusType[]?",
            campaigns: "string[]?"
        },
        TableCampaignResponse: {
            status: "StatusType",
            name: "string",
            beginAt: "datetime",
            endAt: "datetime",
            type: "CampaignType",
            id: "string",
            total: "uint",
            attendance: "uint",
            productCount: "uint"
        },
        ListCampaignsReponse: {
            data: "TableCampaignResponse[]",
            pagination: "PaginationResponse"
        },
        ListWinners: {
            status: "StatusType",
            campaignName: "string",
            squadCampaignId: "string",
            paymentType: "CampaignsPaymentType?",
            retrievedAt: "datetime?",
            retrievedBy: "MinimalEmployee?",
            rankingPosition: "uint",
            employee: "MinimalEmployee?",
            value: "uint?"
        },
        ListWinnersResponse: {
            data: "ListWinners[]",
            pagination: "PaginationResponse"
        },
        ListWinnersFilters: {
            status: "ListWinnersStatus?",
            employeeId: "string?",
            campaignId: "string?"
        },
        ListSquadCampaignRanking: {
            employee: "MinimalEmployee",
            totalValue: "money",
            soldProducts: "uint",
            attendance: "uint"
        },
        CreateVendorOrg: {
            name: "string",
            login: "string",
            organizationId: "uuid",
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool",
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?",
            places: "VendorPlaceRequest[]",
            productFees: "VendorProductRequest[]?",
            password: "string"
        },
        UpdateVendorOrg: {
            name: "string",
            login: "string",
            organizationId: "uuid",
            dailyRentalFeeValue: "money",
            revenuePercentageFee: "float",
            tipPercentageFee: "float",
            anticipationFee: "float?",
            paymentMethodFees: "VendorPaymentMethodFees",
            paymentDaysOffset: "uint",
            fiscalProfileId: "string?",
            floorComplement: "money?",
            activeFeatures: "string[]",
            isFinancialVendor: "bool",
            fullName: "string?",
            document: "string?",
            documentType: "VendorDocumentType?",
            phone: "string?",
            email: "string?",
            address: "VendorDocumentAddress?",
            places: "VendorPlaceRequest[]",
            productFees: "VendorProductRequest[]?",
            id: "uuid",
            password: "string?"
        },
        VendorReceiveTip: {
            id: "uuid",
            name: "string"
        },
        VendorPaymentMethods: {
            vendorId: "string",
            paymentMethod: "PlaceVendorPaymentMethodType"
        },
        VendorPaymentMethodsResponse: {
            vendorId: "string",
            paymentMethod: "PlaceVendorPaymentMethodType",
            vendorName: "string"
        },
        VendorExtractResume: {
            available: "money",
            toBeReleased: "money"
        },
        VendorConsolidatedExtractSectionValues: {
            title: "string",
            relativeTo: "string",
            hideIfZero: "bool",
            totalValueUnit: "VendorConsolidatedExtractSectionValuesTotalValueUnit",
            totalValue: "int?",
            maxFee: "float?",
            minFee: "float?",
            payValue: "int",
            highlighted: "bool"
        },
        VendorConsolidatedExtractSection: {
            title: "string",
            description: "string",
            total: "money",
            values: "VendorConsolidatedExtractSectionValues[]"
        },
        VendorConsolidatedExtract: {
            sections: "VendorConsolidatedExtractSection[]",
            availableValue: "int",
            withdrewValue: "int"
        },
        BankslipPreviewData: {
            type: "BankslipAvailableTypes",
            barcode: "string",
            line: "string",
            amount: "money",
            dueDate: "date?",
            expirationDate: "date?",
            minAmount: "money?",
            maxAmount: "money?",
            nominalAmount: "money?",
            fine: "money?",
            interest: "money?",
            discounts: "money?",
            recipientName: "string?",
            recipientTaxId: "string?",
            payerName: "string?",
            payerTaxId: "string?",
            status: "string?",
            description: "string?",
            bankslipServiceFee: "money"
        },
        CreateWithdrawDto: {
            withdrawValue: "money",
            anticipationValue: "money",
            bankAccountId: "uuid?",
            type: "WithdrawType",
            obs: "string?",
            vendorWithdrawId: "string?",
            bankPaymentSlipInfo: "BankPaymentSlipInfo?",
            originWithdrawRequestId: "uuid?",
            thirdPartyFeeFinancedByAnticipation: "bool?"
        },
        WithdrawResponse: {
            withdrawValue: "money?",
            anticipationValue: "money?",
            bankAccountId: "uuid?",
            anticipationFee: "float?",
            proRataFee: "float?",
            type: "WithdrawType",
            obs: "string?",
            id: "string"
        },
        EventOperationsByPlaceIdFilters: {
            placeId: "uuid"
        },
        GetEventOperationsByPlaceIdRequest: {
            pagination: "Pagination",
            filters: "EventOperationsByPlaceIdFilters"
        },
        GetEventOperationsByPlaceIdResponseData: {
            id: "uuid",
            name: "string",
            contractNumber: "int?",
            beginAt: "datetime",
            endAt: "datetime"
        },
        GetEventOperationsByPlaceIdResponse: {
            pagination: "PaginationResponse",
            data: "GetEventOperationsByPlaceIdResponseData[]"
        },
        GetCombinedOrdersReportRequestDtoPeriod: {
            since: "datetime",
            until: "datetime"
        },
        GetCombinedOrdersReportRequestDto: {
            reference: "string?",
            vendors: "Vendor[]?",
            statuses: "OrderStatus[]?",
            period: "GetCombinedOrdersReportRequestDtoPeriod?"
        },
        PaginationRequestDto: {
            currentPage: "uint",
            perPage: "uint"
        },
        PaginationResponseDto: {
            currentPage: "uint",
            perPage: "uint",
            total: "uint",
            lastPage: "uint"
        },
        CombinedOrderReportPaymentDto: {
            method: "PaymentMethodOrder",
            brand: "string?",
            change: "money?",
            partnerPaymentId: "string?",
            value: "money"
        },
        CombinedOrderReportItemDto: {
            id: "string",
            name: "string",
            sku: "string",
            count: "uint",
            baseUnitPrice: "money",
            totalUnitPrice: "money",
            obs: "string?",
            subItems: "CombinedOrderReportSubItemDto[]"
        },
        CombinedOrderReportSubItemDto: {
            id: "string",
            sku: "string",
            name: "string",
            sectionId: "string?",
            sectionName: "string?",
            pricing: "CombinedOrderReportSubItemDtoPricing",
            price: "money",
            count: "uint"
        },
        GetCombinedOrderReportDto: {
            id: "string",
            reference: "uint",
            externalReference: "string?",
            obs: "string?",
            date: "datetime",
            finishedAt: "datetime?",
            value: "money",
            channel: "DeliveryChannel",
            status: "OrderStatus",
            vendor: "Vendor",
            deliveryType: "DeliveryTypeOrder",
            customerName: "string",
            customerAddress: "string",
            deliveryFee: "money",
            discountValue: "money",
            discountValueMarketplace: "money?",
            discountValueDeliveryFee: "money?",
            discountValueDeliveryFeeMarketplace: "money?",
            tip: "money",
            subTotal: "money",
            payment: "CombinedOrderReportPaymentDto?",
            items: "CombinedOrderReportItemDto[]",
            orderFees: "OrderFee[]"
        },
        GetCombinedOrdersReportResponseDto: {
            items: "GetCombinedOrderReportDto[]",
            totalValue: "money",
            pagination: "PaginationResponseDto"
        },
        AdvanceBase: {
            id: "string",
            createdAt: "datetime",
            cnpj: "string",
            companyName: "string?",
            tradingName: "string?",
            ticketEventIds: "int[]?",
            mainPlaceId: "string?",
            mainPlaceName: "string?",
            totalValue: "money",
            interestValue: "money",
            totalWithInterest: "money",
            interestConfig: "AdvanceInterestConfig?",
            installmentConfig: "AdvanceInstallmentConfig?",
            status: "AdvanceStatus",
            approvedBy: "string?",
            approvedAt: "datetime?",
            obs: "string?",
            advanceRequestId: "string?"
        },
        AdvanceInterestConfig: {
            type: "AdvanceInterestType",
            rate: "float?",
            gracePeriodMonths: "int?",
            fixedInterestValue: "money?"
        },
        AdvanceInstallmentConfig: {
            numberOfInstallments: "int",
            installmentValue: "money",
            firstDueDate: "date",
            downPaymentValue: "money?"
        },
        AdvanceChargeBase: {
            id: "string",
            createdAt: "datetime",
            advanceId: "string",
            chargeValue: "money",
            dueDate: "date?",
            paidAt: "datetime?",
            status: "AdvanceChargeStatus",
            paymentDocumentUrl: "string?",
            chargeType: "AdvanceChargePaymentType",
            obs: "string?",
            ticketEventId: "int?"
        },
        AdvanceDocumentBase: {
            id: "string",
            advanceId: "string",
            documentName: "string",
            documentUrl: "string",
            documentType: "AdvanceDocumentType",
            uploadedAt: "datetime",
            uploadedBy: "string",
            obs: "string?",
            isClientVisible: "bool"
        },
        AdvancePlace: {
            placeId: "string",
            placeName: "string",
            bindingType: "AdvancePlaceBindingType",
            bindBy: "string?",
            bindByName: "string?"
        },
        AdvanceApprovalMinutes: {
            id: "uuid",
            code: "string",
            meetingDate: "date"
        },
        AdvanceListItem: {
            id: "string",
            code: "string?",
            createdAt: "datetime",
            cnpj: "string",
            companyName: "string?",
            mainPlaceName: "string",
            totalValue: "money",
            totalWithInterest: "money",
            remainingValue: "money",
            status: "AdvanceStatus",
            chargeType: "AdvanceChargeType",
            isExistingClient: "bool",
            disbursedValue: "money",
            isOnCommitteeAgenda: "bool?",
            approvalMinutes: "AdvanceApprovalMinutes?"
        },
        AdvanceGroupByCnpj: {
            cnpj: "string",
            companyName: "string?",
            totalAdvances: "int",
            totalValue: "money",
            totalWithInterest: "money",
            openValue: "money",
            advances: "AdvanceListItem[]"
        },
        ListAdvancesFilters: {
            status: "AdvanceStatus?",
            chargeType: "AdvanceChargeType?",
            cnpj: "string?",
            search: "string?",
            dateFrom: "date?",
            dateTo: "date?",
            sortBy: "string?",
            sortOrder: "string?"
        },
        Advance: {
            id: "string",
            createdAt: "datetime",
            cnpj: "string",
            companyName: "string?",
            tradingName: "string?",
            ticketEventIds: "int[]?",
            mainPlaceId: "string?",
            mainPlaceName: "string?",
            totalValue: "money",
            interestValue: "money",
            totalWithInterest: "money",
            interestConfig: "AdvanceInterestConfig?",
            installmentConfig: "AdvanceInstallmentConfig?",
            status: "AdvanceStatus",
            approvedBy: "string?",
            approvedAt: "datetime?",
            obs: "string?",
            advanceRequestId: "string?",
            isDisbursed: "bool",
            disbursedValue: "money",
            remainingValue: "int?",
            openChargesValue: "int?",
            documents: "AdvanceDocument[]",
            charges: "AdvanceCharge[]"
        },
        AdvanceCharge: {
            id: "string",
            createdAt: "datetime",
            advanceId: "string",
            chargeValue: "money",
            dueDate: "date?",
            paidAt: "datetime?",
            status: "AdvanceChargeStatus",
            paymentDocumentUrl: "string?",
            chargeType: "AdvanceChargePaymentType",
            obs: "string?",
            ticketEventId: "int?"
        },
        AdvanceDocument: {
            id: "string",
            advanceId: "string",
            documentName: "string",
            documentUrl: "string",
            documentType: "AdvanceDocumentType",
            uploadedAt: "datetime",
            uploadedBy: "string",
            obs: "string?",
            isClientVisible: "bool"
        },
        ListAdvancesResponse: {
            items: "AdvanceListItem[]",
            totalCount: "int",
            page: "int",
            pageSize: "int"
        },
        ImageUrl: {
            url: "string",
            sha256: "string"
        },
        ClosingEventConferenceDataToProcess: {
            id: "string",
            closingConferenceStatus: "ClosingEventConferenceStatus",
            checkedBy: "string",
            checkedAt: "datetime"
        },
        CheckedBy: {
            id: "string",
            name: "string"
        },
        Event: {
            id: "string",
            name: "string",
            description: "string?",
            place: "Place?",
            status: "EventState",
            begin: "datetime",
            end: "datetime?",
            cover: "ImageUrl?",
            image: "ImageUrl?",
            attractions: "string[]?",
            closingConferenceStatus: "ClosingEventConferenceStatus?",
            passTemplateId: "string?",
            openedBy: "string?",
            openedAt: "datetime?",
            openingReason: "string?",
            checkedBy: "CheckedBy?",
            checkedAt: "datetime?"
        },
        BaseCombo: {
            name: "string",
            value: "int",
            description: "string?",
            category: "string",
            active: "bool",
            fiscalData: "ProductFiscalData?"
        },
        EventDetails: {
            placeId: "string",
            begin: "datetime",
            end: "datetime?",
            name: "string",
            description: "string?",
            attractions: "string[]?",
            peopleCapacity: "uint?"
        },
        OpenedReports: {
            type: "string"
        },
        EmployeeBase: {
            id: "string?",
            name: "string",
            username: "string"
        },
        Seller: {
            id: "string",
            name: "string",
            avatar: "ImageUrl?"
        },
        TransactionProduct: {
            id: "string",
            name: "string",
            category: "string",
            value: "int",
            count: "int",
            image: "ImageUrl?"
        },
        TransactionComboProduct: {
            id: "string",
            name: "string",
            count: "int",
            originalValue: "int"
        },
        TransactionCombo: {
            id: "string",
            products: "TransactionComboProduct[]",
            value: "int",
            name: "string",
            category: "string",
            count: "int",
            description: "string?"
        },
        Transaction: {
            id: "string",
            date: "datetime",
            products: "TransactionProduct[]",
            combos: "TransactionCombo[]",
            place: "string",
            event: "string",
            seller: "Seller",
            buyers: "User[]",
            paid: "bool",
            refunded: "bool",
            refundedBy: "string?",
            refundedObs: "string?",
            value: "int"
        },
        StockProduct: {
            id: "string",
            name: "string",
            quantity: "int"
        },
        Transfer: {
            value: "int",
            date: "datetime",
            paid: "bool",
            reason: "TransferReason"
        },
        ProductTransfer: {
            employee: "EmployeeBase",
            count: "int",
            date: "datetime"
        },
        ReportProduct: {
            id: "string",
            name: "string",
            value: "int",
            image: "ImageUrl?",
            transfers: "ProductTransfer[]?",
            finalCount: "int?",
            lostCount: "int?",
            deliveredCount: "int?"
        },
        StockReportData: {
            products: "ReportProduct[]"
        },
        BarReportData: {
            products: "ReportProduct[]"
        },
        CashierTransfer: {
            value: "int",
            employee: "EmployeeBase",
            date: "datetime"
        },
        CashierReportDataInput: {
            finalInputCredit: "int",
            finalInputDebit: "int",
            finalInputCash: "int"
        },
        CashierReportData: {
            finalInputCredit: "int?",
            finalInputDebit: "int?",
            finalInputCash: "int?",
            transfers: "CashierTransfer[]",
            salesCredit: "int?",
            salesDebit: "int?",
            salesCash: "int?"
        },
        EmployeeBaseResponse: {
            data: "EmployeeBase[]",
            pagination: "PaginationResponse"
        },
        StockTransfer: {
            employeeBar: "string",
            stocker: "string",
            product: "string",
            quantity: "int",
            date: "datetime",
            bar: "string"
        },
        BillProducts: {
            category: "string",
            name: "string",
            value: "int",
            quantity: "int"
        },
        BillTransaction: {
            id: "string",
            date: "datetime",
            products: "BillProducts[]",
            seller: "string",
            refunded: "bool",
            value: "int",
            tip: "int",
            totalValue: "int",
            paid: "bool"
        },
        UserBill: {
            id: "string",
            name: "string",
            transactions: "BillTransaction[]"
        },
        CpfOrPhone: {
            type: "CpfOrPhoneType",
            value: "string"
        },
        TimelineProduct: {
            name: "string",
            id: "string",
            count: "string"
        },
        TimelineEvent: {
            id: "string",
            type: "TimelineEventType",
            value: "uint",
            products: "TimelineProduct[]?",
            shared: "bool?",
            paid: "bool?",
            refunded: "bool?",
            usedValue: "uint?",
            expired: "bool?",
            rechargeType: "string?",
            date: "datetime"
        },
        BonusByProductProduct: {
            id: "uuid",
            name: "string"
        },
        BonusByProductCategory: {
            id: "uuid",
            name: "string"
        },
        BonusByProduct: {
            product: "BonusByProductProduct",
            category: "BonusByProductCategory",
            bonusValue: "money",
            bonusTipValue: "money",
            bonusValueSpentFromOtherEvents: "money",
            bonusTipValueSpentFromOtherEvents: "money",
            bonusCategoryId: "string?",
            bonusCategoryName: "string?"
        },
        GuinnessLog: {
            employee: "string",
            name: "string?",
            cpf: "string?",
            uid: "string",
            date: "datetime",
            type: "GuinnessLogType",
            sector: "string?"
        },
        FilterScopePlace: {
            id: "string",
            period: "PeriodTime"
        },
        FilterScope: {
            eventId: "string?",
            place: "FilterScopePlace?"
        },
        GetEventOperationWithExpenses: {
            operation: "EventOperationCompleteResponse",
            sections: "EventOperationExpensesByCategory[]"
        },
        GetEmployeeTypes: {
            type: "EmployeeType",
            name: "string"
        },
        GetBackofficeConfig: {
            zigAccountId: "string",
            placeAccountId: "string",
            zigSupplierId: "string"
        },
        ProductsSoldReport: {
            productList: "ProductsSoldReportResponse[]",
            pagination: "PaginationResponse"
        },
        ProductsSoldReportForEvent: {
            productList: "ProductsSoldReportResponse[]",
            pagination: "PaginationResponse"
        },
        AddCateringProduct: {
            productId: "string"
        },
        UpdateWithdrawReceipts: {
            success: "WithdrawRequestIdsWithDate[]",
            error: "WithdrawRequestIdsWithDate[]"
        },
        GetZigDeviceSyncForcesAtEvent: {
            data: "ZigDeviceSyncForceAtEvent[]",
            pagination: "PaginationResponse?"
        },
        GetRescueRechargeConsumptionsAtEvent: {
            pagination: "PaginationResponse?",
            data: "RechargeConsumptionData"
        },
        ForgotPassword: {
            message: "string"
        },
        RegisterEmployeeEmail: {
            success: "bool"
        },
        ConfirmEmployeeEmail: {
            success: "bool"
        },
        RemoveProductionRulesFromSuppliesDeletedRulesSuccess: {
            ruleId: "string",
            productId: "string"
        },
        RemoveProductionRulesFromSuppliesDeletedRulesFailed: {
            ruleId: "string",
            productId: "string",
            error: "string"
        },
        RemoveProductionRulesFromSuppliesEditedRulesSuccess: {
            ruleId: "string"
        },
        RemoveProductionRulesFromSuppliesEditedRulesFailed: {
            ruleId: "string",
            error: "string"
        },
        RemoveProductionRulesFromSupplies: {
            removedRulesCount: "uint",
            editedRulesCount: "uint",
            affectedSupplyIds: "string[]",
            deletedRulesSuccess: "RemoveProductionRulesFromSuppliesDeletedRulesSuccess[]",
            deletedRulesFailed: "RemoveProductionRulesFromSuppliesDeletedRulesFailed[]",
            editedRulesSuccess: "RemoveProductionRulesFromSuppliesEditedRulesSuccess[]",
            editedRulesFailed: "RemoveProductionRulesFromSuppliesEditedRulesFailed[]"
        },
        PatchProductsFieldsProductFields: {
            categoryId: "uuid?",
            kindId: "uuid?",
            fiscalProfileId: "uuid?",
            fiscalProductGroupId: "uuid?"
        },
        GetExtractOfValuesOwedToTheVendors: {
            valueToBePaid: "money"
        },
        GetAccessPoliciesFilters: {
            accessPolicyName: "string?"
        },
        GetAccessPolicyTags: {
            data: "AccessTag[]",
            pagination: "PaginationResponse"
        },
        EditEmployeesPlacesAndBarsEmployeesPlacesBars: {
            id: "uuid",
            shouldPrint: "bool",
            isMainBar: "bool"
        },
        EditEmployeesPlacesAndBarsEmployeesPlaces: {
            id: "uuid",
            bars: "EditEmployeesPlacesAndBarsEmployeesPlacesBars[]?"
        },
        EditEmployeesPlacesAndBarsEmployees: {
            id: "uuid",
            places: "EditEmployeesPlacesAndBarsEmployeesPlaces[]"
        },
        EditEmployeesPlacesAndBarsErrors: {
            employeeId: "uuid",
            error: "string"
        },
        EditEmployeesPlacesAndBars: {
            errors: "EditEmployeesPlacesAndBarsErrors[]"
        },
        GetAllEventActionsV2: {
            data: "ReportActionsFromEventOrPlace[]",
            pagination: "PaginationResponse?"
        },
        GetAllPlaceActions: {
            data: "ReportActionsFromEventOrPlace[]",
            pagination: "PaginationResponse?"
        },
        GetHawkerTransactions: {
            transactions: "HawkerTransaction[]",
            pagination: "PaginationResponse"
        },
        GetHawkerTransactionsByPlace: {
            transactions: "HawkerTransactionPlace[]",
            pagination: "PaginationResponse"
        },
        GetMenuProductsByCategory: {
            data: "MenuProducts[]",
            pagination: "PaginationResponse"
        },
        GetAllMenuProducts: {
            data: "MenuProducts[]",
            pagination: "PaginationResponse"
        },
        GetTableProfitReport: {
            header: "ReportHeader",
            data: "TableProfitReport[]"
        },
        GetTablePeopleServedReport: {
            header: "ReportHeader",
            data: "TablePeopleServedReport[]"
        },
        GetPasswordCardsFromPlaceFilters: {
            employeeName: "string?",
            status: "EmployeeCardsStatuses?"
        },
        GetProductMasterKinds: {
            label: "string",
            value: "ProductMasterKind"
        },
        GetAllVendorFeatures: {
            id: "string",
            name: "string"
        },
        GetVendorsBalancesVendor: {
            id: "uuid",
            name: "string"
        },
        GetVendorsBalances: {
            vendor: "GetVendorsBalancesVendor",
            withdraw: "money",
            anticipation: "money",
            pendingWithdraw: "money",
            pendingAnticipation: "money"
        },
        GetAutomaticWithdrawHistoryDataVendor: {
            id: "uuid",
            name: "string"
        },
        GetAutomaticWithdrawHistoryDataPlace: {
            id: "uuid",
            name: "string"
        },
        GetAutomaticWithdrawHistoryData: {
            id: "int",
            type: "GetAutomaticWithdrawHistoryDataType",
            vendor: "GetAutomaticWithdrawHistoryDataVendor?",
            place: "GetAutomaticWithdrawHistoryDataPlace",
            expectedAmount: "money",
            placeBalance: "money?",
            vendorBalance: "money?",
            actualAmount: "money?",
            status: "AutomaticWithdrawStatus",
            error: "string?"
        },
        GetAutomaticWithdrawHistory: {
            date: "date",
            status: "AutomaticWithdrawStatus",
            data: "GetAutomaticWithdrawHistoryData[]"
        },
        RetryPixReceipt: {
            receiptUrl: "string"
        },
        AddressFromCepTipo: [
            "localidade",
            "logradouro",
            "unidadeOperacional",
            "grandeUsuario"
        ],
        BackofficeStorageTransferType: [
            "input",
            "transferOut",
            "transferIn",
            "lost",
            "productionLost",
            "sell",
            "refund",
            "manual",
            "productionOut",
            "productionIn",
            "invoice",
            "inventory",
            "cardExchange"
        ],
        BackofficeSupplierRegisterType: [
            "Customer",
            "Supplier",
            "CustomerAndSupplier",
            "Employee"
        ],
        BackofficeBillPaymentMethod: [
            "App",
            "Money",
            "Check",
            "Boleto",
            "CreditCard",
            "BankTransfer",
            "Promissory",
            "DebitCard",
            "AutomaticDebit"
        ],
        BankAccountReceiverTypeDto: [
            "conta_corrente",
            "conta_salario",
            "conta_poupanca",
            "conta_pagamento"
        ],
        PixKeyTypeDto: [
            "email",
            "evp",
            "phone",
            "cpf",
            "cnpj"
        ],
        BankAccountDocumentTypeDto: [
            "cpf",
            "cnpj"
        ],
        CategoryKind: [
            "product",
            "menu"
        ],
        EventOperationExpenseCategory: [
            "fieldTeam",
            "logisticsExpense",
            "cardsAndBracelets",
            "othersExpenses",
            "equipmentBreakdown",
            "replacedEquipments",
            "usedEquipments",
            "otherUsedEquipments",
            "posCreditAdvance"
        ],
        EventOperationExpenseType: [
            "listEquipment",
            "typeBreakdowns",
            "typeBreakages",
            "typeRepairs",
            "exchangeForProduct",
            "notReturned",
            "head",
            "supervisor",
            "technician",
            "providedByCustomer",
            "notProvided",
            "uber",
            "app99",
            "loggi",
            "carrier",
            "carRental",
            "airfare",
            "others"
        ],
        EventOperationExpenseResponsible: [
            "client",
            "zig",
            "rateio"
        ],
        EventOperationStatus: [
            "opened",
            "operationalApproval",
            "financialApproval",
            "financialRevision",
            "finalApproval",
            "finished"
        ],
        EquipmentType: [
            "Terminal",
            "TotemFicha",
            "TotemCashless",
            "MiniTotem"
        ],
        EquipmentBillingPeriodicity: [
            "Daily",
            "Monthly"
        ],
        ChargeType: [
            "OneTime",
            "Recurring"
        ],
        ChargeStatus: [
            "Calculated",
            "FullyBonified",
            "Error",
            "ReportedOnly",
            "NotInContract"
        ],
        ChargeErrorKind: [
            "UnknownPeriodicity",
            "ContractsApiUnavailable",
            "MissingContractValue",
            "InternationalNotSupported"
        ],
        DashboardNotificationClassificationEnum: [
            "warning",
            "soon",
            "release",
            "alert",
            "other",
            "xmlZipSuccess",
            "xmlZipError"
        ],
        DashboardNotificationTagsEnum: [
            "organization",
            "place",
            "event",
            "pdv",
            "app"
        ],
        EmployeeMenuVisualizationType: [
            "SmallGrid",
            "Grid",
            "NoPicture"
        ],
        EmployeeType: [
            "system",
            "hawker",
            "admin",
            "dashboard",
            "hawkerCashier",
            "miniTotemFicha",
            "miniTotemCashless",
            "beerTap",
            "beerTapCashless",
            "kds"
        ],
        AdjustCategory: [
            "pos",
            "posTax",
            "operatorFee",
            "systemSetup",
            "wifiSetup",
            "equipmentsPurchase",
            "equipmentsRental",
            "zigDevicePurchase",
            "equipmentsMaintenance",
            "wifiAssistance",
            "zigFee",
            "totemFee",
            "cardActivations",
            "genericOperationsFee",
            "genericServices",
            "bonifications",
            "expiredRecharges",
            "notUsedRecharges",
            "generalZigMachineTPV",
            "generalZigMachineTax",
            "paymentsTax",
            "anticipationFee",
            "payments",
            "withdraw",
            "externalResourceContribution",
            "reimbursements",
            "balanceAdjustment",
            "renegotiation",
            "advance",
            "advanceFee",
            "balanceRetention",
            "balanceTransfer",
            "residueRemain",
            "missingCards",
            "billingInvoice",
            "guaranteedMinimumSupplement",
            "commandFiscalPurchase",
            "accountsReceivableLegal",
            "cardDiscount",
            "discountGeneralOperatingExpenses",
            "discountOperatorDailyRate",
            "generalDiscount",
            "dailyCoordinatorRate",
            "dailyHeadsRate",
            "setupDailyCoordinatorRate",
            "setupDailyHeadsRate",
            "setupDailySupervisorsRate",
            "setupDailyTechnicalRate",
            "setupDailyTraineeRate",
            "dailySupervisorRate",
            "dailyTechnicianRate",
            "dailyTraineeRate",
            "damagedEquipment",
            "integratedAPPBilling",
            "apartCreditBilling",
            "integratedCreditBilling",
            "apartDebitBilling",
            "integratedDebitBilling",
            "apartBillingPIX",
            "integratedPIXBilling",
            "integratedAdvancedRechargeBilling",
            "interestandPenalties",
            "softwareLicense",
            "replacedMachines",
            "minimumGuaranteedpermachine",
            "otherEquipment",
            "rebate",
            "setupAdvancedRecharge",
            "setupRefundSite",
            "acquirementfeeforIntegratedZIGApplication",
            "acquiringfeeonapartCredit",
            "acquiringfeeforIntegratedCredit",
            "acquiringfeeforapartDebit",
            "acquiringfeeonIntegratedDebit",
            "acquiringfeeforapartPIX",
            "acquiringfeeforIntegratedPIX",
            "acquiringfeeforAdvancedRecharge",
            "refundfee",
            "relatedpartyretentionfee",
            "rappiFee",
            "SMSFee",
            "residualFee",
            "cardtoCashExchange",
            "cardtoProductExchange",
            "travelFood",
            "shipping",
            "accommodation",
            "transport",
            "pixRefundFee",
            "softwareLicenseMachine",
            "softwareLicenseTotem",
            "integratedAdvanceDebitBilling",
            "integratedAdvanceCreditBilling",
            "integratedAdvancePixBilling",
            "integratedAdvanceDebitFee",
            "integratedAdvanceCreditFee",
            "integratedAdvancePixFee",
            "zeDeliveryDiscount",
            "ticketPrinting",
            "validatorRental",
            "zeDeliveryRetention",
            "valueAddedTax",
            "moneyTPV",
            "acquiringFeeForIntegratedInstallmentCredit",
            "loanBracelet",
            "lendingCards",
            "issuedCharge",
            "anticipationValue",
            "anticipatedValue",
            "softwareLicenseGiftback",
            "integratedOnlineDeliveryIncome",
            "generalZigMachineCreditIn2Installments",
            "generalZigMachineCreditIn3Installments",
            "generalZigMachineCreditIn4Installments",
            "generalZigMachineCreditIn5Installments",
            "generalZigMachineCreditIn6Installments",
            "generalZigMachineCreditIn7Installments",
            "generalZigMachineCreditIn8Installments",
            "generalZigMachineCreditIn9Installments",
            "generalZigMachineCreditIn10Installments",
            "generalZigMachineCreditIn11Installments",
            "generalZigMachineCreditIn12Installments",
            "generalZigMachineCreditIn2InstallmentsFEE",
            "generalZigMachineCreditIn3InstallmentsFEE",
            "generalZigMachineCreditIn4InstallmentsFEE",
            "generalZigMachineCreditIn5InstallmentsFEE",
            "generalZigMachineCreditIn6InstallmentsFEE",
            "generalZigMachineCreditIn7InstallmentsFEE",
            "generalZigMachineCreditIn8InstallmentsFEE",
            "generalZigMachineCreditIn9InstallmentsFEE",
            "generalZigMachineCreditIn10InstallmentsFEE",
            "generalZigMachineCreditIn11InstallmentsFEE",
            "generalZigMachineCreditIn12InstallmentsFEE",
            "totalTpvBarIncome",
            "totalTpvEntranceIncome",
            "totalTpvEntranceIncomeConsumption",
            "totalTpvBarMinimumConsumption",
            "totalTpvBonus",
            "bankRefund",
            "acquirerRefund",
            "advanceRenegotiation",
            "zigTicketsRetention",
            "onlineDeliveryAcquisitionFee",
            "pixPreventiveBlock",
            "pixAuthorizedUnblock",
            "pixRefundByChargeback",
            "totenRental",
            "RelatedStakeholderRetentionReprocessing",
            "electrical",
            "hydraulics",
            "cleaning",
            "other",
            "supply"
        ],
        WithdrawStatus: [
            "Pending",
            "Paid",
            "Refused",
            "Processing",
            "Pix_Processing",
            "Bankslip_Processing",
            "PendingManagerApproval",
            "Cancelled",
            "PendingPlaceConfirmation",
            "CanceledPlaceConfirmation",
            "ProcessingCancellation",
            "PendingAnticipation",
            "PendingTreasuryAction"
        ],
        WithdrawType: [
            "Anticipation",
            "Withdraw",
            "WithdrawAndAnticipation",
            "Bankslip"
        ],
        ConsolidatedExtractSectionValuesTotalValueUnit: [
            "unit",
            "money"
        ],
        DebitNoteStatus: [
            "CREATED",
            "GENERATED",
            "CANCELLED"
        ],
        DebitNoteGeneratedAs: [
            "AUTOMATIC",
            "MANUALLY"
        ],
        RentNoteStatus: [
            "CREATED",
            "GENERATED",
            "CANCELLED"
        ],
        RentNoteGeneratedAs: [
            "AUTOMATIC",
            "MANUALLY"
        ],
        BaseFinancialChargeConfigRecurrence: [
            "daily",
            "event",
            "weekly",
            "monthly"
        ],
        AutomaticWithdrawStatus: [
            "success",
            "partial",
            "error"
        ],
        FinancialExtractBlockType: [
            "automatic",
            "manual",
            "contractEffect"
        ],
        FinancialExtractBlockReceivableType: [
            "credit",
            "debit"
        ],
        InvoiceMoment: [
            "recharge",
            "rechargeAndActivation",
            "consumption",
            "consumptionAndActivation"
        ],
        InvoiceStatus: [
            "issued",
            "issuing",
            "failed",
            "canceled"
        ],
        PrechargeOperationBonusType: [
            "money"
        ],
        PrechargeOperationPaymentMethod: [
            "PIX",
            "CREDIT_CARD"
        ],
        PrechargeStatus: [
            "refused",
            "success",
            "pending_review",
            "refunded"
        ],
        SellableThing: [
            "Product",
            "Combo"
        ],
        PlaceProductFiscalDataStatus: [
            "no",
            "notTested",
            "tested",
            "error"
        ],
        OperationType: [
            "table",
            "zigTag",
            "ficha"
        ],
        ProductMasterKind: [
            "Outros",
            "Bilheteria",
            "Bebidas",
            "Alimentos"
        ],
        ProductStatus: [
            "active",
            "inactive"
        ],
        WeekDay: [
            "sun",
            "mon",
            "tue",
            "wed",
            "thu",
            "fri",
            "sat"
        ],
        BirthdayPerson: [
            "day",
            "week",
            "month"
        ],
        PromotionFrequencyOfEarning: [
            "everytime",
            "eachEvent",
            "oncePerWeek",
            "oncePerMonth"
        ],
        PromotionDiscountType: [
            "bonus",
            "discount"
        ],
        NewPromotionConditionsGender: [
            "Male",
            "Female",
            "Other"
        ],
        PostPaymentEventPostPaymentType: [
            "App",
            "Place"
        ],
        BasicStorageUnit: [
            "milliliter",
            "liter",
            "kilogram",
            "gram",
            "unit"
        ],
        NewMountableSectionPricing: [
            "sum",
            "average",
            "higher"
        ],
        MountableSectionV2Pricing: [
            "sum",
            "average",
            "higher"
        ],
        PrinterType: [
            "EPSON",
            "BEMATECH"
        ],
        PaymentPrePaidType: [
            "MinimumConsumption",
            "Bonus",
            "FromEvent",
            "FromOtherEvent",
            "FromApp",
            "FakeRecharge"
        ],
        TransactionSource: [
            "ficha",
            "balcony",
            "delivery",
            "grabngo",
            "onlineBill",
            "cashless",
            "dash",
            "zigQrcode",
            "hce",
            "onlineFicha",
            "table"
        ],
        UserDocumentType: [
            "unknown",
            "cpf",
            "phone",
            "uid",
            "table",
            "email"
        ],
        RechargePaymentMethod: [
            "Rappi",
            "Ifood",
            "Uber",
            "Ame",
            "DeliveryOnline",
            "CreditCard",
            "DebitCard",
            "Cash",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "Voucher",
            "Dashboard",
            "Anticipated",
            "Pix",
            "IntegratedFoodVoucher",
            "Online",
            "MBWay"
        ],
        Gender: [
            "Male",
            "Female",
            "Other"
        ],
        RechargePaymentMethodWithCashless: [
            "Rappi",
            "Ifood",
            "Uber",
            "Ame",
            "DeliveryOnline",
            "CreditCard",
            "DebitCard",
            "Cash",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "Voucher",
            "Dashboard",
            "Anticipated",
            "Pix",
            "IntegratedFoodVoucher",
            "Online",
            "MBWay",
            "Cashless"
        ],
        AllPaymentMethods: [
            "Rappi",
            "Ifood",
            "Uber",
            "Ame",
            "DeliveryOnline",
            "CreditCard",
            "DebitCard",
            "Cash",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "Voucher",
            "Dashboard",
            "Anticipated",
            "Pix",
            "IntegratedFoodVoucher",
            "Online",
            "MBWay",
            "PostEvent",
            "Bonus",
            "Cashless",
            "Unknown",
            "DigitalCashless"
        ],
        OperationalType: [
            "ficha",
            "prePaid",
            "postPaid",
            "mesa",
            "balcony"
        ],
        VendorFinancialAdjustCategory: [
            "electrical",
            "hydraulics",
            "cleaning",
            "other",
            "supply"
        ],
        VendorClosingValueRelative: [
            "closingBilled",
            "adjust",
            "revenue",
            "dailyRent",
            "weeklyRent",
            "monthlyRent",
            "commissionPayment",
            "floorComplement"
        ],
        VendorFeatureEnum: [
            "seeExtract",
            "seeClosings",
            "chargeOpenedBillsFromVendor",
            "seeBarReports",
            "canCreateAndDeleteProducts",
            "cashRetention",
            "blockWithdraw"
        ],
        VendorDocumentType: [
            "CPF",
            "CNPJ",
            "INTERNATIONAL"
        ],
        VendorWithdrawRequestType: [
            "Withdraw",
            "Anticipation"
        ],
        VendorWithdrawRequestStatus: [
            "Processing",
            "Paid",
            "Refused",
            "Pending"
        ],
        MetabaseQuestionEnum: [
            "audits_enterprise",
            "relay_gl",
            "gift_card"
        ],
        MetabaseIntegrationEmbeddingParamsConfig: [
            "enabled",
            "locked",
            "disabled"
        ],
        MetabaseResourceType: [
            "card",
            "dashboard"
        ],
        OrganizationMetabaseContextLevel: [
            "organization",
            "place",
            "event"
        ],
        ConsentSource: [
            "delivery",
            "queue",
            "reservation",
            "pdv",
            "app",
            "precharge"
        ],
        Channel: [
            "sms",
            "whatsapp"
        ],
        MenuType: [
            "normal",
            "delivery",
            "dineIn",
            "pickUp",
            "deliveryByMarketplace",
            "hawker",
            "grabAndGo",
            "onlineFicha",
            "onlineTab",
            "viewMenu",
            "deliveryIntegrated"
        ],
        Vendor: [
            "rappi",
            "coala",
            "ifood",
            "ubereats",
            "menu",
            "food99",
            "keeta",
            "manualOrder"
        ],
        OrderStatus: [
            "placed",
            "confirmed",
            "concluded",
            "cancelled",
            "pendingPayment",
            "ready",
            "dispatched",
            "pickupAreaAssigned"
        ],
        DeliveryType: [
            "dineIn",
            "pickUp",
            "deliveryByPartner",
            "deliveryByRestaurant",
            "deliveryByMarketplace",
            "viewMenu",
            "onlineTab",
            "onlineFicha"
        ],
        DeliverySource: [
            "coala",
            "ifood",
            "ubereats",
            "rappi",
            "food99",
            "keeta",
            "other"
        ],
        TipReceiver: [
            "MERCHANT",
            "LOGISTIC_SERVICES",
            "MARKETPLACE"
        ],
        CashierAdjustmentType: [
            "bleeding",
            "pettyCash"
        ],
        CloseMethodEnum: [
            "cash",
            "debit",
            "credit",
            "voucher"
        ],
        AllMethods: [
            "cash",
            "debit",
            "credit",
            "voucher",
            "zigDebit",
            "zigCredit",
            "zigCreditInInstallments",
            "postEvent",
            "dashboard",
            "anticipated",
            "deliveryOnline",
            "ame",
            "rappi",
            "uber",
            "ifood",
            "bonus",
            "pix",
            "integratedFoodVoucher",
            "MBWay",
            "online"
        ],
        PaymentMethodWithCashless: [
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "CreditCard",
            "DebitCard",
            "Cash",
            "App",
            "Voucher",
            "Anticipated",
            "Pix",
            "Cashless",
            "DigitalCashless",
            "IntegratedFoodVoucher",
            "MBWay"
        ],
        PaymentMethodWithCashlessAndBonus: [
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "CreditCard",
            "DebitCard",
            "Cash",
            "App",
            "Voucher",
            "Anticipated",
            "Pix",
            "Cashless",
            "DigitalCashless",
            "IntegratedFoodVoucher",
            "MBWay",
            "Bonus",
            "MinimumConsumption",
            "Ifood",
            "Online"
        ],
        PixChargePaidResponseStatus: [
            "paid",
            "notPaid",
            "expired",
            "error"
        ],
        EventResumeSectionValuesValuesUnit: [
            "money",
            "un",
            "percentage"
        ],
        RechargeTypeEnum: [
            "minimumConsumption",
            "normal",
            "bonus"
        ],
        RechargeType: [
            "Bonus",
            "Refund",
            "CreditViaApp",
            "CreditViaPlace",
            "RefundForPPU"
        ],
        CheckinMethod: [
            "biometry",
            "pdv",
            "app",
            "automatic",
            "menu"
        ],
        PlaceContractManagerContact: [
            "Zendesk",
            "Comercial"
        ],
        QuestionType: [
            "music",
            "product",
            "service",
            "price",
            "cleaness",
            "mixes",
            "nps",
            "paymentExperience"
        ],
        Origin: [
            "direct_link",
            "qr_code",
            "sms"
        ],
        MenuConfigsTaxType: [
            "unique",
            "baseRateWithVariableKm",
            "ratePerRadius"
        ],
        MenuConfigsAdditionalFieldType: [
            "numberChair",
            "numberTable",
            "numberRoom",
            "referencePoint"
        ],
        PlaceMenus: [
            "delivery",
            "dineIn",
            "onlineTab",
            "onlinePostPayment",
            "viewMenu"
        ],
        FichaFontSize: [
            "Small",
            "Medium",
            "Large"
        ],
        FichaImageSize: [
            "NoImage",
            "Small",
            "Medium",
            "Large"
        ],
        FichaQRCodeSize: [
            "NoQRCode",
            "Small",
            "Medium",
            "Large"
        ],
        PairInfoType: [
            "vendor",
            "place"
        ],
        FutureFinancialEntryGroupBy: [
            "MONTH",
            "DAY",
            "TYPE",
            "CATEGORY"
        ],
        WithdrawV2Status: [
            "Paid",
            "Pending",
            "Refused",
            "Processing",
            "Pix_Processing",
            "Bankslip_Processing",
            "PendingManagerApproval",
            "Cancelled",
            "PendingPlaceConfirmation",
            "CanceledPlaceConfirmation",
            "ProcessingCancellation",
            "PendingAnticipation",
            "PendingTreasuryAction"
        ],
        WithdrawV2Type: [
            "Withdraw",
            "Anticipation"
        ],
        DateFilterType: [
            "referenceDate",
            "originalPayDate",
            "effectivePayDate"
        ],
        GroupByOption: [
            "DAY",
            "MONTH",
            "TYPE",
            "CATEGORY"
        ],
        ReceivableUnitType: [
            "credit",
            "debit",
            "anticipation",
            "contractEffect"
        ],
        ReceivableUnitConsolidatedCardType: [
            "credit",
            "debit"
        ],
        ExternalStoreIntegrationStatus: [
            "synced",
            "pendingSyncing",
            "pendingImporting",
            "noItemsToImport"
        ],
        ExternalStoreIntegrationType: [
            "iFood",
            "rappi",
            "keeta"
        ],
        DashboardAlertType: [
            "ExtractPriority",
            "Normal"
        ],
        BackofficeBaseBillStatus: [
            "Paid",
            "Pending"
        ],
        BackofficeReferenceField: [
            "addition",
            "discount"
        ],
        BackofficeDateInterval: [
            "weekly",
            "monthly",
            "yearly",
            "semiannual",
            "quarterly",
            "bimonthly"
        ],
        BackofficeBillStatusFilter: [
            "Any",
            "ToPay",
            "ToReceive"
        ],
        BackofficeBillDateFilter: [
            "ByDue",
            "ByPerform",
            "ByPay"
        ],
        BackofficeExportBillArgsStatus: [
            "Paid",
            "Pending",
            "Any"
        ],
        BackofficeBillsToDREAnalyticsStatus: [
            "Paid",
            "Pending"
        ],
        BackofficeCashFlowBillDateWithStatusStatus: [
            "Paid",
            "Overdue",
            "Pending"
        ],
        BackofficeNeoCashFlowArgsViewMode: [
            "Weekly",
            "Daily",
            "Monthly"
        ],
        BackofficeExportDreArgDateFilter: [
            "PerformDate",
            "PayDate"
        ],
        BackofficeInventoryStatus: [
            "Opened",
            "Closed",
            "Canceled"
        ],
        BackofficeImportedInvoiceDetailsField: [
            "insuranceValue",
            "discountValue",
            "otherExpensesValue",
            "shippingValue",
            "icmsstValue",
            "ipiValue"
        ],
        SimpleInvoiceInfoStatus: [
            "authorized",
            "notAllowed",
            "xmlUnavailable",
            "imported"
        ],
        ManualBackofficeInvoiceDuplcatesInterval: [
            "Week",
            "Month"
        ],
        BackofficeInvoiceXLSXArgsStatus: [
            "Processed",
            "Pending",
            "Any"
        ],
        BackofficeInvoiceXLSXArgsOrigin: [
            "ByXML",
            "Manual",
            "Focus",
            "Any"
        ],
        BackofficeManifestType: [
            "ciencia",
            "confirmacao",
            "desconhecimento",
            "naoRealizada"
        ],
        BackofficeReceivedInvoiceStatus: [
            "ciencia",
            "confirmacao",
            "desconhecimento",
            "naoRealizada",
            "respostaPendente",
            "baixada"
        ],
        BackofficeResumeBillsDueToTodayStatus: [
            "Paid",
            "Pending"
        ],
        BackofficeProductStorageHistoryFilterBy: [
            "interval",
            "events"
        ],
        BackofficeNewProductRuleType: [
            "minimunQuantity",
            "criticalQuantity"
        ],
        BackofficeEditProductRuleType: [
            "minimunQuantity",
            "criticalQuantity"
        ],
        ProductsSoldOrderByColumn: [
            "count",
            "subtotal",
            "discount",
            "totalValue",
            "productName"
        ],
        ProductsSoldOrderByOrder: [
            "desc",
            "asc"
        ],
        CateringProductSubType: [
            "Product",
            "Combo",
            "Mountable"
        ],
        CateringProductsOrderBy: [
            "name",
            "category"
        ],
        CateringProductsOrderDirection: [
            "asc",
            "desc"
        ],
        CateringMountableSectionPricing: [
            "sum",
            "average",
            "higher"
        ],
        CmvReportType: [
            "All",
            "From_Place",
            "From_Vendor"
        ],
        ComodatoContractStatus: [
            "pendingSignature",
            "signatureExpired",
            "contractExpired",
            "active",
            "closed"
        ],
        ComodatoContractRequestType: [
            "permanent",
            "temporary"
        ],
        ComodatoContractRequestModel: [
            "addition",
            "exchange"
        ],
        ComodatoContractSortBy: [
            "createdAt",
            "signedAt",
            "expiresAt",
            "status"
        ],
        SortOrder: [
            "asc",
            "desc"
        ],
        DiscountCategoryType: [
            "percentage",
            "value"
        ],
        EditMultipleEmployeesBarsOperation: [
            "add",
            "remove"
        ],
        BankAccountType: [
            "Savings",
            "Checking"
        ],
        AuthKeyType: [
            "email",
            "phone"
        ],
        AuthKeyStatus: [
            "active",
            "blocked",
            "inactive"
        ],
        DebtorStatus: [
            "notCharged",
            "created",
            "expired",
            "partiallyCreated"
        ],
        RechargeConsumptionMethod: [
            "Ame",
            "Anticipated",
            "Cash",
            "Credit",
            "CreditCard",
            "Dashboard",
            "DebitCard",
            "DeliveryOnline",
            "Ifood",
            "Pix",
            "Rappi",
            "Uber",
            "Voucher",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "MBWay",
            "IntegratedFoodVoucher"
        ],
        PaymentMethod: [
            "CreditCard",
            "DebitCard",
            "Cash",
            "PostEvent",
            "ZigPosCredit",
            "ZigPosDebit",
            "Voucher",
            "Bonus",
            "App",
            "Pix",
            "IntegratedFoodVoucher",
            "ZigPosCreditInInstallments",
            "Anticipated",
            "Ame",
            "MBWay",
            "DeliveryOnline",
            "Ifood"
        ],
        OpenedBillPaymentMethod: [
            "CreditCard",
            "DebitCard",
            "Cash",
            "PostEvent",
            "ZigPosCredit",
            "ZigPosDebit",
            "Voucher",
            "Bonus",
            "MBWay"
        ],
        ReportAfterEventClosingOrigin: [
            "OfflineAction",
            "HistoryMachine",
            "HistoryMachineAfterClosing"
        ],
        AppTransactionDetailsAppPaymentType: [
            "creditCard",
            "balance"
        ],
        AppTransactionDetailsTransactionType: [
            "ppu",
            "pre",
            "post"
        ],
        TransactionType: [
            "Couvert",
            "Entrance",
            "Normal",
            "Tip",
            "ZigCard",
            "MinimumConsumption"
        ],
        BuyerPaymentType: [
            "Post",
            "Ppu",
            "MinimumConsumption",
            "Bonus",
            "FromEvent",
            "FromOtherEvent",
            "FromApp"
        ],
        OriginalType: [
            "pre",
            "post",
            "ppu"
        ],
        SalesDetailsOrderByColumn: [
            "date",
            "isRefunded"
        ],
        SalesDetailsOrderByOrder: [
            "desc",
            "asc"
        ],
        RegimeTributario: [
            "SimplesNacional",
            "SimplesNacionalExcesso",
            "RegimeNormal"
        ],
        RegimeTributarioEspecial: [
            "MicroempresaMunicipal",
            "Estimativa",
            "SociedadeDeProfissionais",
            "Cooperativa",
            "MEISimplesNacional",
            "MEEPPSimplesNacional"
        ],
        FiscalMode: [
            "nfce",
            "sat",
            "ivaVendus",
            "ivaFactura"
        ],
        InvoiceMode: [
            "sat",
            "nfe",
            "nfse",
            "nfsen",
            "nfce",
            "ivaVendus",
            "ivaFactura"
        ],
        RecipientExtraInfoIndicadorInscricaoEstadual: [
            "ContribuinteICMS",
            "ContribuinteIsento",
            "NaoContribuinte"
        ],
        FiscalDraftActorType: [
            "adminZig",
            "employee"
        ],
        FiscalProfileIvaVendusCountry: [
            "PT",
            "ES"
        ],
        FiscalProfileIvaFacturaExpirationOpt: [
            "lastMonthDay",
            "daysAfterTransaction"
        ],
        FiscalProductGroupType: [
            "invoice",
            "service",
            "serviceNational",
            "vat",
            "vatFactura",
            "vatSpain"
        ],
        FiscalProductGroupVatVendusDetailsCode: [
            "INT",
            "RED",
            "NOR",
            "ISE",
            "RED2",
            "OUT",
            "OUT2"
        ],
        FiscalProductGroupVatVendusDetailsProductType: [
            "P",
            "S",
            "O",
            "I",
            "E"
        ],
        FiscalProductGroupVatVendusDetailsTaxExemption: [
            "M01",
            "M02",
            "M03",
            "M04",
            "M05",
            "M06",
            "M07",
            "M08",
            "M09",
            "M10",
            "M11",
            "M12",
            "M13",
            "M14",
            "M15",
            "M16",
            "M99"
        ],
        FiscalProductGroupVatVendusDetailsRegion: [
            "ptContinental",
            "ptAcores",
            "ptMadeira"
        ],
        InvoiceV2Mode: [
            "sat",
            "nfse",
            "nfsen",
            "nfce",
            "ivaVendus",
            "ivaFactura"
        ],
        InvoiceTypeEnum: [
            "FT",
            "NC"
        ],
        InvoicesV2FilterEmissionItemType: [
            "Product",
            "Recharge"
        ],
        NationalFiscalInvoiceDataMode: [
            "sat",
            "nfse",
            "nfsen",
            "nfce",
            "nfe"
        ],
        ManualRequestPaymentMethod: [
            "Cash",
            "CreditCard",
            "DebitCard",
            "Voucher",
            "PostEvent",
            "Anticipated"
        ],
        NotEmittedProductOrComboType: [
            "combo",
            "product"
        ],
        LogInvoiceErrorResponseStatus: [
            "pending",
            "resolved"
        ],
        PendingInvoicesFilterInvoiceType: [
            "FT",
            "NC"
        ],
        PendingInvoicesFilterInvoiceEmissionType: [
            "Recharge",
            "Products"
        ],
        EmittedValueByPaymentTypeEnum: [
            "cashless",
            "zigApp",
            "card",
            "cash",
            "bonus",
            "pix",
            "mbWay",
            "mealTicket",
            "voucher",
            "noPaymentAttached"
        ],
        GenericValueForReportUnit: [
            "unit",
            "money"
        ],
        NotEmittedProductType: [
            "product",
            "combo"
        ],
        InvoiceFiscalProductGroupType: [
            "invoice",
            "service",
            "serviceNational",
            "vat",
            "vatFactura",
            "vatSpain"
        ],
        InvoiceUserInformationType: [
            "CPF",
            "CNPJ",
            "NIF"
        ],
        InsightReaction: [
            "good",
            "bad"
        ],
        InventoryStatus: [
            "Opened",
            "Closed",
            "Canceled"
        ],
        BaseLoyaltyProgramSendMessagesAboutProgramAfterCheckout: [
            "sms",
            "wpp"
        ],
        LoyaltyProgramExtractType: [
            "couponRedeem",
            "productBuy",
            "placeAttend",
            "spentValue",
            "gender",
            "appPayment"
        ],
        GiftCardCampaignStatus: [
            "active",
            "canceled",
            "expired"
        ],
        OpenSaleMethod: [
            "pix",
            "credit",
            "debit",
            "integratedFoodVoucher",
            "mbway",
            "creditInInstallments"
        ],
        PaymentOrigin: [
            "zig",
            "place"
        ],
        PaymentLinkStatus: [
            "PENDING",
            "PAID",
            "EXPIRED",
            "CANCELED"
        ],
        PaymentLinkDateField: [
            "createdAt",
            "paidAt"
        ],
        PlaceSize: [
            "XS",
            "S",
            "M",
            "L",
            "XL"
        ],
        PlaceType: [
            "default",
            "delivery",
            "transfers",
            "advance",
            "billing"
        ],
        PlaceSellVisualizationFormat: [
            "Grid",
            "List"
        ],
        PlaceStatus: [
            "active",
            "inactive",
            "blocked",
            "paused"
        ],
        NewPlaceSellVisualizationFormat: [
            "Grid",
            "List"
        ],
        PlaceContractDetailsRechargesRechargesAction: [
            "ChargeBack",
            "PlaceOnly",
            "Normal"
        ],
        UsersWithAverageTicketGender: [
            "Male",
            "Female",
            "Other"
        ],
        AverageTicketFilterGender: [
            "Male",
            "Female",
            "Other"
        ],
        SellVisualizationFormat: [
            "Grid",
            "List"
        ],
        LinkHighlightType: [
            "instagram",
            "facebook",
            "twitter",
            "ticketLink",
            "site"
        ],
        LocationCategory: [
            "show",
            "event",
            "festival",
            "restaurant",
            "barAndRestaurant",
            "pub",
            "nightclub",
            "bar"
        ],
        NewLocationCategory: [
            "show",
            "event",
            "festival",
            "restaurant",
            "barAndRestaurant",
            "pub",
            "nightclub",
            "bar",
            "arena",
            "bistro",
            "beachClub"
        ],
        DayOfWeek: [
            "mon",
            "tue",
            "wed",
            "thu",
            "fri",
            "sat",
            "sun",
            "hol"
        ],
        LocalType: [
            "place",
            "event"
        ],
        FeeType: [
            "single",
            "segmented"
        ],
        PosTransactionMethodMethod: [
            "Credit",
            "Debit"
        ],
        KitchenPrinterTypes: [
            "lan",
            "smartpos",
            "kds"
        ],
        ProportionalValueUnit: [
            "gramas",
            "ml",
            "un"
        ],
        NewMountableSectionWithStatusPricing: [
            "sum",
            "average",
            "higher"
        ],
        ProductType: [
            "MinimumConsumption",
            "ZigCard",
            "Couvert",
            "Product",
            "Entrance",
            "Tip",
            "Supply",
            "Combo",
            "Catering"
        ],
        DeleteMultipleProductsStatus: [
            "completed",
            "queued"
        ],
        PatchProductErrorName: [
            "invalidTaxData",
            "ncm",
            "cest",
            "duplicatedFiscalCode",
            "productNotFound",
            "categoryWithSubcategory",
            "supercategoryNotFound",
            "invalidSystemProduct"
        ],
        BaseProductSectionResponsePricing: [
            "sum",
            "average",
            "higher"
        ],
        ProductFeatureTemplateFieldType: [
            "text",
            "number",
            "bool",
            "enum"
        ],
        PlacePromoterStatus: [
            "active",
            "inactive",
            "pending"
        ],
        RefundReasonsTypes: [
            "refund",
            "cancel"
        ],
        ImportRelationErrorTypes: [
            "limitByPromoterCannotGreaterThanLimitPerList",
            "relationNameAlreadyExists",
            "invalidInput"
        ],
        MultipleRelationUserErrorsType: [
            "userAlreadyExists",
            "relationReachesLimit",
            "userWithoutDocument"
        ],
        FinanceBiMethod: [
            "Credit",
            "Debit",
            "Cash",
            "PostEvent",
            "ZigCredit",
            "ZigDebit",
            "Voucher",
            "Anticipated",
            "Dashboard",
            "App",
            "Other"
        ],
        ReportExportFormat: [
            "Csv",
            "Xlsx"
        ],
        ProductsSoldReportV2OperationType: [
            "Table",
            "ZigTag"
        ],
        ProductsSoldReportV2TransactionSource: [
            "ficha",
            "balcony",
            "delivery",
            "grabngo",
            "onlineBill",
            "cashless",
            "dash",
            "zigQrcode",
            "hce",
            "onlineFicha",
            "table"
        ],
        ProductsSoldReportV2ProductStatus: [
            "active",
            "inactive",
            "unavailable"
        ],
        DetailedTransactionsReportOrderByColumn: [
            "date",
            "isRefunded"
        ],
        DetailedTransactionsReportOrderByOrder: [
            "desc",
            "asc"
        ],
        KdsOrderFinalStatus: [
            "ON_TIME",
            "DELAYED"
        ],
        KdsOrdersSortColumn: [
            "date",
            "totalTimeMin"
        ],
        KdsOrdersSortDirection: [
            "asc",
            "desc"
        ],
        NewProductAlertType: [
            "minimunQuantity",
            "criticalQuantity"
        ],
        EditProductAlertType: [
            "minimunQuantity",
            "criticalQuantity"
        ],
        ProductStorageRuleType: [
            "minimunQuantity",
            "criticalQuantity"
        ],
        StorageTransferType: [
            "input",
            "transferOut",
            "transferIn",
            "lost",
            "productionLost",
            "sell",
            "refund",
            "manual",
            "productionOut",
            "productionIn",
            "invoice",
            "inventory",
            "cardExchange"
        ],
        TableMapStatus: [
            "Available",
            "InService",
            "InPayment",
            "Paid",
            "Blocked"
        ],
        ProductSoldV2OperationType: [
            "table",
            "card"
        ],
        UserFilterType: [
            "cpf",
            "phone",
            "zigcode",
            "id"
        ],
        UserRechargeMethod: [
            "CreditCard",
            "DebitCard",
            "Cash",
            "App",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "Voucher",
            "Dashboard",
            "Anticipated",
            "DeliveryOnline",
            "Ame",
            "Rappi",
            "Ifood",
            "Uber",
            "Pix",
            "IntegratedFoodVoucher",
            "Online",
            "MBWay"
        ],
        NewUserRechargeGender: [
            "Male",
            "Female",
            "Other"
        ],
        UserEventHistoryType: [
            "productTransaction",
            "entranceTransaction",
            "sharedTransaction",
            "attach",
            "consumeRecharge",
            "detachAndRefundActivation",
            "postPayment",
            "appPrePayment",
            "recharge",
            "bonus",
            "minimumConsumption",
            "refundRecharge",
            "refundTransaction",
            "discount",
            "tipRemoval",
            "promotion",
            "changePostLimit",
            "attachToReserve",
            "consumptionObligation",
            "zigDeviceSyncForce",
            "transferProductTransaction",
            "zigCardPixRefund",
            "transferConsumptionObligation",
            "transferTransaction",
            "refundPostPayment",
            "singleProductReturn"
        ],
        UserTransactionTipReceiver: [
            "MERCHANT",
            "LOGISTIC_SERVICES",
            "MARKETPLACE"
        ],
        VendorWithdrawRequestMethod: [
            "accountBalance",
            "other"
        ],
        ZigDeviceWithGroupAndBalanceStatus: [
            "inactive",
            "used",
            "inUse",
            "blocked"
        ],
        MessageStatus: [
            "scheduled",
            "sent",
            "canceled"
        ],
        GlossaryVariables: [
            "date",
            "client",
            "productName",
            "productOriginalPrice",
            "productPromotionalPrice",
            "discount",
            "observation"
        ],
        ActionTypes: [
            "action",
            "text",
            "media",
            "location",
            "quick",
            "list",
            "card"
        ],
        MessageClientGender: [
            "Male",
            "Female",
            "Other"
        ],
        SentMessageClientStatus: [
            "optout",
            "sending",
            "sent",
            "delivered",
            "error"
        ],
        MessageTemplateStatus: [
            "approved",
            "rejected",
            "pending",
            "received"
        ],
        ButtonType: [
            "QUICK_REPLY",
            "URL",
            "PHONE_NUMBER"
        ],
        MessageSentOrigin: [
            "coalaIntegration",
            "npsForm",
            "campaignMessage",
            "kitchen",
            "reservation_confirmation",
            "giftback",
            "minimumStorageAlert",
            "givePromotion",
            "reservation_late",
            "reservation_day_of",
            "reservation_reminder",
            "reservation_cancellation"
        ],
        BackOfficeOperationChartAccount: [
            "credit",
            "debit"
        ],
        BackOfficeTypeChartAccount: [
            "analytic",
            "synthetic"
        ],
        BackofficePurposeTypes: [
            "Advance",
            "CardIssuer",
            "InternalCash",
            "Tip",
            "CreditCard",
            "eWallet",
            "InvestmentAccount",
            "CheckingAccount",
            "PaymentAccount",
            "ReceivingAccount",
            "LoanAccount",
            "SecuredAccount",
            "SavingsAccount"
        ],
        BackofficeTypeAccountBills: [
            "payable",
            "receivable"
        ],
        BackofficePaymentMethod: [
            "App",
            "Money",
            "Check",
            "CreditCard",
            "BankTransfer",
            "Promissory",
            "DebitCard",
            "AutomaticDebit",
            "Boleto",
            "Pix"
        ],
        BackofficeTypeAccountBillsChartAccount: [
            "Account",
            "Interest",
            "Fine",
            "Discount",
            "FinancialFees",
            "InvoiceProducts"
        ],
        TypeInterval: [
            "Day",
            "Week",
            "Month",
            "Year"
        ],
        BackofficeRecurringStatus: [
            "active",
            "paused",
            "completed",
            "cancelled"
        ],
        BackofficeGetParamsAccountsBillsOrderBy: [
            "dueDate"
        ],
        BackofficeGetParamsAccountsBillsOrder: [
            "asc",
            "desc"
        ],
        BackofficeAccountBillsStatus: [
            "due",
            "overdue",
            "paid",
            "conciliated",
            "dueToday"
        ],
        TypeClosingAccount: [
            "credit",
            "debit"
        ],
        BackofficeAccountBillHistoryEventType: [
            "created",
            "updated",
            "deleted",
            "paymentAdded",
            "reconciled",
            "chartAccountAssigned",
            "chartAccountValueChanged",
            "unknown"
        ],
        BackofficeStorageInventoryProductTransferType: [
            "manual",
            "lost"
        ],
        BackofficeStorageInventoryStatus: [
            "open",
            "reopened",
            "in_review",
            "approved"
        ],
        GetBackofficeStorageInventoryAndStorageComparisonFiltersFilterType: [
            "onlyZero",
            "negativeDifference",
            "positiveDifference",
            "withoutDifference"
        ],
        HawkerSaleType: [
            "transacted",
            "devolved",
            "released",
            "canceled",
            "remained",
            "all"
        ],
        PaymentType: [
            "CreditCard",
            "DebitCard",
            "Pix",
            "Cash"
        ],
        TableFilterStatusEnum: [
            "all",
            "open",
            "closed"
        ],
        ZendeskTicketStatus: [
            "closed",
            "solved",
            "hold",
            "pending",
            "open",
            "new"
        ],
        ZigTicketStatus: [
            "closed",
            "ongoing",
            "open"
        ],
        IfoodEventCode: [
            "POS",
            "PLC",
            "CFM",
            "SPS",
            "SPE",
            "RTP",
            "DSP",
            "CON",
            "CAN",
            "CAR",
            "CARF",
            "HSD",
            "HSS",
            "PAA",
            "RDR",
            "RDS",
            "RDF",
            "DCRA",
            "DCRR",
            "CLT",
            "ADR",
            "GTO",
            "AAO",
            "DDD",
            "AAD",
            "DRGO",
            "DRDO",
            "DCR",
            "DDCR",
            "DDCS",
            "DRCR",
            "DPCR",
            "DPCS",
            "DAR",
            "DAU",
            "DAA",
            "DAD",
            "DGA",
            "DGD",
            "DGAC",
            "DGDC",
            "DGU",
            "RTS",
            "OPA",
            "RPS",
            "PRS",
            "CPR",
            "CPT",
            "BOA",
            "RFI",
            "GTD",
            "DRH",
            "KEEPALIVE"
        ],
        IfoodEventFullCode: [
            "PLACED",
            "CONFIRMED",
            "SEPARATION_STARTED",
            "SEPARATION_ENDED",
            "READY_TO_PICKUP",
            "DISPATCHED",
            "CONCLUDED",
            "CANCELLED",
            "CANCELLATION_REQUESTED",
            "CANCELLATION_REQUEST_FAILED",
            "HANDSHAKE_DISPUTE",
            "HANDSHAKE_SETTLEMENT",
            "PICKUP_AREA_ASSIGNED",
            "ASSIGN_DRIVER",
            "GOING_TO_ORIGIN",
            "ARRIVED_AT_ORIGIN",
            "DELIVERY_DRIVER_DEALLOCATED",
            "COLLECTED",
            "ARRIVED_AT_DESTINATION",
            "DELIVERY_RETURNING_TO_ORIGIN",
            "DELIVERY_RETURNED_TO_ORIGIN",
            "DELIVERY_CANCELLATION_REQUESTED",
            "DELIVERY_DROP_CODE_REQUESTED",
            "DELIVERY_DROP_CODE_VALIDATION_SUCCESS",
            "DELIVERY_RETURN_CODE_REQUESTED",
            "DELIVERY_PICKUP_CODE_REQUESTED",
            "DELIVERY_PICKUP_CODE_VALIDATION_SUCCESS",
            "DELIVERY_ADDRESS_CHANGE_REQUESTED",
            "DELIVERY_ADDRESS_CHANGE_USER_CONFIRMED",
            "DELIVERY_ADDRESS_CHANGE_ACCEPTED",
            "DELIVERY_ADDRESS_CHANGE_DENIED",
            "DELIVERY_GROUP_ASSIGNED",
            "DELIVERY_GROUP_DISMISSED",
            "DELIVERY_GROUP_ASSOCIATED",
            "DELIVERY_GROUP_DISSOCIATED",
            "DELIVERY_GROUP_UPDATED",
            "RETURN_TO_STORE",
            "ORDER_PATCHED",
            "RECOMMENDED_PREPARATION_START",
            "PREPARATION_STARTED",
            "CONSUMER_PREPARATION_TIME_REQUESTED",
            "CHANGE_PREPARATION_TIME",
            "BOX_ASSIGNED",
            "READY_FOR_INVOICE",
            "REQUEST_DRIVER",
            "REQUEST_DRIVER_SUCCESS",
            "REQUEST_DRIVER_FAILED",
            "DELIVERY_CANCELLATION_REQUEST_ACCEPTED",
            "DELIVERY_CANCELLATION_REQUEST_REJECTED",
            "GOING_TO_DESTINATION",
            "DELIVERY_RETURNING_HANDSHAKE",
            "KEEPALIVE"
        ],
        DeliveryChannel: [
            "phone",
            "whatsapp",
            "marketplace",
            "whitelabel"
        ],
        DeliveryOrderEventStatus: [
            "pendingPayment",
            "placed",
            "integrated",
            "scheduled",
            "confirmed",
            "ready",
            "dispatched",
            "concluded",
            "cancelled",
            "pickupAreaAssigned"
        ],
        DeliveryOrderPaymentMethod: [
            "Rappi",
            "Ifood",
            "Uber",
            "Ame",
            "DeliveryOnline",
            "CreditCard",
            "DebitCard",
            "Cash",
            "ZigPosCredit",
            "ZigPosCreditInInstallments",
            "ZigPosDebit",
            "Voucher",
            "Dashboard",
            "Anticipated",
            "Pix",
            "IntegratedFoodVoucher",
            "Online",
            "MBWay"
        ],
        ManagerDeliveryOrderCustomerDocumentType: [
            "cpf",
            "phone",
            "unknown"
        ],
        ManagerDeliveryOrderItemsSubItemsPricing: [
            "sum",
            "average",
            "higher"
        ],
        DeliveryIfoodCancellationReason: [
            "SYSTEM_ERROR",
            "DUPLICATE_ORDER",
            "ITEM_UNAVAILABLE",
            "NO_DELIVERY_PERSON",
            "OUTDATED_MENU",
            "OUTSIDE_DELIVERY_AREA",
            "FRAUDULENT_CUSTOMER",
            "OUTSIDE_DELIVERY_HOURS",
            "INTERNAL_DIFFICULTIES",
            "RISK_AREA",
            "RESTAURANT_OPENING_LATER",
            "RESTAURANT_CLOSED_EARLIER"
        ],
        ZigCancelReason: [
            "itemUnavailable",
            "storeClosed",
            "storeOverloaded",
            "infrastructureOutage",
            "customerIssue",
            "outdatedMenu",
            "fraudSuspected",
            "feesOrPromoDoubt",
            "noCourier",
            "orderOutOfArea",
            "unsafeArea",
            "other"
        ],
        CreateManualOrderCustomerDocumentType: [
            "cpf",
            "phone",
            "unknown"
        ],
        CreateManualOrderPayloadDeliveryType: [
            "deliveryByRestaurant",
            "pickUp"
        ],
        UpsertDeliveryFeeConfigPayloadTaxType: [
            "unique",
            "baseRateWithVariableKm",
            "ratePerRadius"
        ],
        MarketplaceProvider: [
            "keeta",
            "food99"
        ],
        PendingTransactionStatus: [
            "pending",
            "conciliated",
            "processed",
            "cancelled"
        ],
        AcquirerPaymentMethod: [
            "Credit",
            "Debit",
            "Pix"
        ],
        PlaceWizardStep: [
            "basicInformation",
            "barsAndSectors",
            "productsAndMenus",
            "rolesAndEmployees"
        ],
        OFXTypeTransaction: [
            "CREDIT",
            "DEBIT",
            "INT",
            "DIV",
            "FEE",
            "SRVCHG",
            "DEP",
            "ATM",
            "POS",
            "XFER",
            "CHECK",
            "PAYMENT",
            "CASH",
            "DIRECTDEP",
            "DIRECTDEBIT",
            "REPEATPMT",
            "OTHER",
            "OUT",
            "IN"
        ],
        OFXFileHeaderResponseStatus: [
            "created",
            "notCreated",
            "validated"
        ],
        BackofficeBankConciliationStatus: [
            "opened",
            "conciliated"
        ],
        BackofficeBankConciliationTransactionsType: [
            "opened",
            "conciliated",
            "refused"
        ],
        BackofficeSaveBankConciliationType: [
            "conciliation",
            "undoConciliation",
            "ignore",
            "undoIgnore"
        ],
        CashbackConfigDataStatusKey: [
            "active",
            "deactivated",
            "expired"
        ],
        RfmClassification: [
            "champions",
            "loyal",
            "highPotential",
            "recent",
            "promising",
            "attention",
            "closeToHibernation",
            "risk",
            "canNotLose",
            "hibernating",
            "lost",
            "others"
        ],
        CdpSortDirection: [
            "asc",
            "desc"
        ],
        CdpUserSortField: [
            "name",
            "totalPaidValue",
            "averageTicket",
            "presences",
            "lastInteraction"
        ],
        InteractionType: [
            "Event",
            "TicketOrder",
            "NpsSurveyAnswer",
            "Communication",
            "SegmentAlteration"
        ],
        ProductPurchaseType: [
            "Product",
            "Entrance"
        ],
        CdpInteractionProvider: [
            "Zigpay",
            "ZigTickets",
            "Netpdv"
        ],
        CdpInteractionChannel: [
            "App",
            "Marketplace",
            "Phisical",
            "Promoter"
        ],
        CdpInteractionCommunicationChannel: [
            "Whatsapp",
            "Email",
            "Sms",
            "Push"
        ],
        CdpInteractionCommunicationSubject: [
            "Giftback",
            "Promotion",
            "NpsSurvey",
            "Generic"
        ],
        CdpSegmentRulesBirthday: [
            "thismonth",
            "nextmonth",
            "thisweek",
            "nextweek"
        ],
        DashboardTimeGrouping: [
            "dayOfWeek",
            "week",
            "month"
        ],
        MixMode: [
            "organization",
            "place"
        ],
        DemographicGender: [
            "Male",
            "Female",
            "Other",
            "NotInformed"
        ],
        ValueMatrixPointQuadrant: [
            "highFrequencyHighTicket",
            "highFrequencyLowTicket",
            "lowFrequencyHighTicket",
            "lowFrequencyLowTicket"
        ],
        DashboardInsightType: [
            "ticketVariation",
            "paretoRule",
            "weekdayPattern",
            "lostValuableClients",
            "growthTrend",
            "retentionAlert"
        ],
        DashboardInsightSeverity: [
            "info",
            "warning",
            "critical",
            "success"
        ],
        ExportFormat: [
            "csv",
            "excel"
        ],
        CdpReportType: [
            "clients",
            "rfmDistribution",
            "segmentDistribution",
            "interactions",
            "productPurchases",
            "demographicDistribution",
            "periodComparison",
            "topRfmMetrics",
            "valueMatrix"
        ],
        TransactionReportLinkStatus: [
            "PROCESSING",
            "SUCCESS",
            "ERROR"
        ],
        HawkerCashierAdjustmentType: [
            "changeFund",
            "bleeding"
        ],
        HawkerCashierHawkerClosingType: [
            "session",
            "cycle"
        ],
        HawkerTransactionType: [
            "sessionOpening",
            "sessionClosure",
            "cycleOpening",
            "cycleClosure",
            "productRelease",
            "sale",
            "cancellation",
            "bleeding",
            "changeFund",
            "devolution",
            "cashierOpening",
            "cashierClosure"
        ],
        KdsType: [
            "Main",
            "Basic"
        ],
        KdsScreenType: [
            "PRIMARY",
            "SECONDARY"
        ],
        EditMenuItemAction: [
            "add",
            "remove"
        ],
        ProductMountableSectionPricing: [
            "sum",
            "average",
            "higher"
        ],
        EmployeeCardsStatuses: [
            "active",
            "inactive",
            "blocked"
        ],
        PendingOnlineRechargeResumeGender: [
            "Male",
            "Female",
            "Other"
        ],
        RechargeManagementType: [
            "Bonus",
            "CreditViaApp",
            "CreditViaPlace",
            "Refund"
        ],
        RechargeManagementBonusType: [
            "MinimumConsumption"
        ],
        RechargeManagementStatus: [
            "refunded",
            "expired",
            "active"
        ],
        RechargeManagementRechargeType: [
            "MinimumConsumption",
            "Bonus",
            "Recharge"
        ],
        RechargeStatusEnum: [
            "refunded",
            "expired",
            "active"
        ],
        OrderEnum: [
            "asc",
            "desc"
        ],
        StatusType: [
            "scheduled",
            "active",
            "finished"
        ],
        CampaignType: [
            "salesTotal",
            "attendance",
            "soldProducts"
        ],
        CampaignsPaymentType: [
            "bonus",
            "money",
            "pix",
            "employeeOfTheMonth",
            "dayOff"
        ],
        ListWinnersStatus: [
            "pending",
            "done"
        ],
        PlaceVendorPaymentMethodType: [
            "cash",
            "voucher",
            "credit",
            "debit"
        ],
        VendorConsolidatedExtractSectionValuesTotalValueUnit: [
            "unit",
            "money"
        ],
        BankslipAvailableTypes: [
            "BOLETO",
            "UTILITY",
            "TAX"
        ],
        CombinedOrderReportSubItemDtoPricing: [
            "sum",
            "average",
            "higher"
        ],
        DeliveryTypeOrder: [
            "dineIn",
            "pickUp",
            "delivery",
            "deliveryByPartner",
            "deliveryByRestaurant",
            "deliveryByMarketplace",
            "onlineFicha",
            "onlineTab",
            "viewMenu"
        ],
        PaymentMethodOrder: [
            "creditCardInPlace",
            "debitCardOnline",
            "debitCardInPlace",
            "cash",
            "creditCardOnline",
            "voucherInPlace",
            "ame",
            "pix"
        ],
        GetCombinedOrdersReportOrderBy: [
            "reference",
            "date",
            "status",
            "value"
        ],
        GetCombinedOrdersReportOrderDirection: [
            "asc",
            "desc"
        ],
        AdvanceStatus: [
            "pendingApproval",
            "open",
            "closed",
            "cancelled",
            "pdd"
        ],
        AdvanceChargeType: [
            "foodAndBeverage",
            "ticket",
            "both"
        ],
        AdvancePaymentMode: [
            "manual",
            "asAvailable"
        ],
        AdvanceInterestType: [
            "simple",
            "compound",
            "manual",
            "mixed"
        ],
        AdvanceChargeStatus: [
            "pending",
            "paid",
            "cancelled"
        ],
        AdvanceChargePaymentType: [
            "automatic",
            "manual",
            "ticket"
        ],
        AdvanceDocumentType: [
            "contract",
            "addendum",
            "renegotiation",
            "other",
            "feasibility",
            "payment",
            "partnerDocuments",
            "foodAndBeverageContract",
            "ticketContract"
        ],
        AdvancePlaceBindingType: [
            "manual",
            "automatic"
        ],
        AdvanceRequestStatus: [
            "pending",
            "analyzing",
            "approved",
            "rejected"
        ],
        AdvanceRequestVenueType: [
            "event",
            "venue"
        ],
        AdvanceRequestDocumentType: [
            "borderos",
            "socialContract",
            "feasibilityStudies",
            "contracts",
            "partnerDocuments",
            "other"
        ],
        EventState: [
            "Created",
            "Finished",
            "Running",
            "Canceled"
        ],
        ClosingEventConferenceStatus: [
            "pending",
            "sent"
        ],
        TransferReason: [
            "PPUTransaction",
            "PostTransactionOnline",
            "PostTransactionInPlace",
            "RechargeInPlace",
            "RechargeInApp",
            "PreTransaction",
            "PreTransactionWithPlaceCredit",
            "PreTransactionWithPlaceCreditFromOtherEvent",
            "BonusTransaction",
            "RefundedTransaction",
            "PaidPostPaidTransactionsInPlace"
        ],
        ReportType: [
            "Waiter",
            "Stock",
            "GeneralEmployee",
            "Cashier",
            "Bar"
        ],
        CpfOrPhoneType: [
            "cpf",
            "phone"
        ],
        TimelineEventType: [
            "Recharge",
            "Transaction",
            "PostPayment"
        ],
        GuinnessLogType: [
            "checkin",
            "checkout"
        ],
        ApplySuggestedImageForProductType: [
            "product",
            "combo"
        ],
        GetBackofficeCashFlowV2GroupBy: [
            "day",
            "month"
        ],
        GetInvoicesBySearchValueCountry: [
            "mx",
            "pt",
            "es"
        ],
        GetPlaceProductsByTypeOrderBy: [
            "name",
            "fiscalCode",
            "category"
        ],
        GetPlaceProductsByTypeOrder: [
            "asc",
            "desc"
        ],
        ExportPlaceProductsByTypeOrderBy: [
            "name",
            "fiscalCode",
            "category"
        ],
        ExportPlaceProductsByTypeOrder: [
            "asc",
            "desc"
        ],
        VerifyPatchProductsType: [
            "create",
            "edit"
        ],
        GetBackofficeProductStorageHistoryXlsFilterBy: [
            "interval",
            "events"
        ],
        GetBackofficeProductionHistoryForProductsOrderBy: [
            "createdAt",
            "storage",
            "outputCount",
            "name"
        ],
        GetBackofficeProductionHistoryForProductsOrder: [
            "asc",
            "desc"
        ],
        ExportBackofficeProductionHistoryForProductsOrderBy: [
            "createdAt",
            "storage",
            "outputCount",
            "name"
        ],
        ExportBackofficeProductionHistoryForProductsOrder: [
            "asc",
            "desc"
        ],
        GetBackofficeTransfersBetweenStoragesOrderBy: [
            "date",
            "fromStorage",
            "toStorage"
        ],
        GetBackofficeTransfersBetweenStoragesOrder: [
            "asc",
            "desc"
        ],
        ExportBackofficeTransfersBetweenStoragesOrderBy: [
            "date",
            "fromStorage",
            "toStorage"
        ],
        ExportBackofficeTransfersBetweenStoragesOrder: [
            "asc",
            "desc"
        ],
        GetBackofficeStorageInventoriesOrderBy: [
            "storage",
            "name",
            "status",
            "createdAt"
        ],
        GetBackofficeStorageInventoriesOrder: [
            "asc",
            "desc"
        ],
        GetBackofficeStorageInventoryAndStorageComparisonOrder: [
            "asc",
            "desc"
        ],
        GetBackofficeStorageInventoryAndStorageComparisonOrderBy: [
            "name",
            "category",
            "fiscalCode",
            "basicStorageUnit",
            "storageInventoryCount",
            "storageCount",
            "averageUnitCostValue",
            "difference"
        ],
        ExportBackofficeStorageInventoryAndStorageComparisonOrder: [
            "asc",
            "desc"
        ],
        ExportBackofficeStorageInventoryAndStorageComparisonOrderBy: [
            "name",
            "category",
            "fiscalCode",
            "basicStorageUnit",
            "storageInventoryCount",
            "storageCount",
            "averageUnitCostValue",
            "difference"
        ],
        ExportBackofficeStorageInventoryAndStorageComparisonPdfOrder: [
            "asc",
            "desc"
        ],
        ExportBackofficeStorageInventoryAndStorageComparisonPdfOrderBy: [
            "name",
            "category",
            "fiscalCode",
            "basicStorageUnit",
            "storageInventoryCount",
            "storageCount",
            "averageUnitCostValue",
            "difference"
        ],
        GetBackofficeStorageInventoryTopInconsistenciesType: [
            "unitCost",
            "quantity"
        ],
        GetCdpDashboardKpisTimeSeriesGroupBy: [
            "week",
            "month"
        ],
        GetCdpAudienceMetricsTimeSeriesGroupBy: [
            "week",
            "month"
        ],
        GetCdpRfmDistributionTimeSeriesGroupBy: [
            "week",
            "month"
        ],
        GetAutomaticWithdrawHistoryDataType: [
            "vendor",
            "place"
        ]
    }
} as const;
